/*!
 * herajs v1.2.0
 * (c) 2022 AERGO
 * Released under MIT license.
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.herajs = {}));
}(this, (function (exports) { 'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function () {};

        return {
          s: F,
          n: function () {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function () {
        it = it.call(o);
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var runtime_1 = createCommonjsModule(function (module) {
    /**
     * Copyright (c) 2014-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var runtime = function (exports) {

      var Op = Object.prototype;
      var hasOwn = Op.hasOwnProperty;
      var undefined$1; // More compressible than void 0.

      var $Symbol = typeof Symbol === "function" ? Symbol : {};
      var iteratorSymbol = $Symbol.iterator || "@@iterator";
      var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
      var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

      function define(obj, key, value) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
        return obj[key];
      }

      try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
      } catch (err) {
        define = function define(obj, key, value) {
          return obj[key] = value;
        };
      }

      function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.

        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
      }

      exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
      // record like context.tryEntries[i].completion. This interface could
      // have been (and was previously) designed to take a closure to be
      // invoked without arguments, but in all the cases we care about we
      // already have an existing method we want to call, so there's no need
      // to create a new function object. We can even get away with assuming
      // the method takes exactly one argument, since that happens to be true
      // in every case, so we don't have to touch the arguments object. The
      // only additional allocation required is the completion record, which
      // has a stable shape and so hopefully should be cheap to allocate.

      function tryCatch(fn, obj, arg) {
        try {
          return {
            type: "normal",
            arg: fn.call(obj, arg)
          };
        } catch (err) {
          return {
            type: "throw",
            arg: err
          };
        }
      }

      var GenStateSuspendedStart = "suspendedStart";
      var GenStateSuspendedYield = "suspendedYield";
      var GenStateExecuting = "executing";
      var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
      // breaking out of the dispatch switch statement.

      var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
      // .constructor.prototype properties for functions that return Generator
      // objects. For full spec compliance, you may wish to configure your
      // minifier not to mangle the names of these two functions.

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
      // don't natively support it.


      var IteratorPrototype = {};
      define(IteratorPrototype, iteratorSymbol, function () {
        return this;
      });
      var getProto = Object.getPrototypeOf;
      var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

      if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
        // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
      }

      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
      GeneratorFunction.prototype = GeneratorFunctionPrototype;
      define(Gp, "constructor", GeneratorFunctionPrototype);
      define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
      GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
      // Iterator interface in terms of a single ._invoke method.

      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
          define(prototype, method, function (arg) {
            return this._invoke(method, arg);
          });
        });
      }

      exports.isGeneratorFunction = function (genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
      };

      exports.mark = function (genFun) {
        if (Object.setPrototypeOf) {
          Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        } else {
          genFun.__proto__ = GeneratorFunctionPrototype;
          define(genFun, toStringTagSymbol, "GeneratorFunction");
        }

        genFun.prototype = Object.create(Gp);
        return genFun;
      }; // Within the body of any async function, `await x` is transformed to
      // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
      // `hasOwn.call(value, "__await")` to determine if the yielded value is
      // meant to be awaited.


      exports.awrap = function (arg) {
        return {
          __await: arg
        };
      };

      function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);

          if (record.type === "throw") {
            reject(record.arg);
          } else {
            var result = record.arg;
            var value = result.value;

            if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
              return PromiseImpl.resolve(value.__await).then(function (value) {
                invoke("next", value, resolve, reject);
              }, function (err) {
                invoke("throw", err, resolve, reject);
              });
            }

            return PromiseImpl.resolve(value).then(function (unwrapped) {
              // When a yielded Promise is resolved, its final value becomes
              // the .value of the Promise<{value,done}> result for the
              // current iteration.
              result.value = unwrapped;
              resolve(result);
            }, function (error) {
              // If a rejected Promise was yielded, throw the rejection back
              // into the async generator function so it can be handled there.
              return invoke("throw", error, resolve, reject);
            });
          }
        }

        var previousPromise;

        function enqueue(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }

          return previousPromise = // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        } // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).


        this._invoke = enqueue;
      }

      defineIteratorMethods(AsyncIterator.prototype);
      define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
        return this;
      });
      exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
      // AsyncIterator objects; they just return a Promise for the value of
      // the final result produced by the iterator.

      exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function (result) {
          return result.done ? result.value : iter.next();
        });
      };

      function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
          if (state === GenStateExecuting) {
            throw new Error("Generator is already running");
          }

          if (state === GenStateCompleted) {
            if (method === "throw") {
              throw arg;
            } // Be forgiving, per 25.3.3.3.3 of the spec:
            // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


            return doneResult();
          }

          context.method = method;
          context.arg = arg;

          while (true) {
            var delegate = context.delegate;

            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context);

              if (delegateResult) {
                if (delegateResult === ContinueSentinel) continue;
                return delegateResult;
              }
            }

            if (context.method === "next") {
              // Setting context._sent for legacy support of Babel's
              // function.sent implementation.
              context.sent = context._sent = context.arg;
            } else if (context.method === "throw") {
              if (state === GenStateSuspendedStart) {
                state = GenStateCompleted;
                throw context.arg;
              }

              context.dispatchException(context.arg);
            } else if (context.method === "return") {
              context.abrupt("return", context.arg);
            }

            state = GenStateExecuting;
            var record = tryCatch(innerFn, self, context);

            if (record.type === "normal") {
              // If an exception is thrown from innerFn, we leave state ===
              // GenStateExecuting and loop back for another invocation.
              state = context.done ? GenStateCompleted : GenStateSuspendedYield;

              if (record.arg === ContinueSentinel) {
                continue;
              }

              return {
                value: record.arg,
                done: context.done
              };
            } else if (record.type === "throw") {
              state = GenStateCompleted; // Dispatch the exception by looping back around to the
              // context.dispatchException(context.arg) call above.

              context.method = "throw";
              context.arg = record.arg;
            }
          }
        };
      } // Call delegate.iterator[context.method](context.arg) and handle the
      // result, either by returning a { value, done } result from the
      // delegate iterator, or by modifying context.method and context.arg,
      // setting context.delegate to null, and returning the ContinueSentinel.


      function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];

        if (method === undefined$1) {
          // A .throw or .return when the delegate iterator has no .throw
          // method always terminates the yield* loop.
          context.delegate = null;

          if (context.method === "throw") {
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (delegate.iterator["return"]) {
              // If the delegate iterator has a return method, give it a
              // chance to clean up.
              context.method = "return";
              context.arg = undefined$1;
              maybeInvokeDelegate(delegate, context);

              if (context.method === "throw") {
                // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
              }
            }

            context.method = "throw";
            context.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return ContinueSentinel;
        }

        var record = tryCatch(method, delegate.iterator, context.arg);

        if (record.type === "throw") {
          context.method = "throw";
          context.arg = record.arg;
          context.delegate = null;
          return ContinueSentinel;
        }

        var info = record.arg;

        if (!info) {
          context.method = "throw";
          context.arg = new TypeError("iterator result is not an object");
          context.delegate = null;
          return ContinueSentinel;
        }

        if (info.done) {
          // Assign the result of the finished delegate to the temporary
          // variable specified by delegate.resultName (see delegateYield).
          context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

          context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
          // exception, let the outer generator proceed normally. If
          // context.method was "next", forget context.arg since it has been
          // "consumed" by the delegate iterator. If context.method was
          // "return", allow the original .return call to continue in the
          // outer generator.

          if (context.method !== "return") {
            context.method = "next";
            context.arg = undefined$1;
          }
        } else {
          // Re-yield the result returned by the delegate method.
          return info;
        } // The delegate iterator is finished, so forget it and continue with
        // the outer generator.


        context.delegate = null;
        return ContinueSentinel;
      } // Define Generator.prototype.{next,throw,return} in terms of the
      // unified ._invoke helper method.


      defineIteratorMethods(Gp);
      define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
      // @@iterator function is called on it. Some browsers' implementations of the
      // iterator prototype chain incorrectly implement this, causing the Generator
      // object to not be returned from this call. This ensures that doesn't happen.
      // See https://github.com/facebook/regenerator/issues/274 for more details.

      define(Gp, iteratorSymbol, function () {
        return this;
      });
      define(Gp, "toString", function () {
        return "[object Generator]";
      });

      function pushTryEntry(locs) {
        var entry = {
          tryLoc: locs[0]
        };

        if (1 in locs) {
          entry.catchLoc = locs[1];
        }

        if (2 in locs) {
          entry.finallyLoc = locs[2];
          entry.afterLoc = locs[3];
        }

        this.tryEntries.push(entry);
      }

      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
      }

      function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [{
          tryLoc: "root"
        }];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
      }

      exports.keys = function (object) {
        var keys = [];

        for (var key in object) {
          keys.push(key);
        }

        keys.reverse(); // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.

        return function next() {
          while (keys.length) {
            var key = keys.pop();

            if (key in object) {
              next.value = key;
              next.done = false;
              return next;
            }
          } // To avoid creating an additional object, we just hang the .value
          // and .done properties off the next function object itself. This
          // also ensures that the minifier will not anonymize the function.


          next.done = true;
          return next;
        };
      };

      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];

          if (iteratorMethod) {
            return iteratorMethod.call(iterable);
          }

          if (typeof iterable.next === "function") {
            return iterable;
          }

          if (!isNaN(iterable.length)) {
            var i = -1,
                next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }

              next.value = undefined$1;
              next.done = true;
              return next;
            };

            return next.next = next;
          }
        } // Return an iterator with no values.


        return {
          next: doneResult
        };
      }

      exports.values = values;

      function doneResult() {
        return {
          value: undefined$1,
          done: true
        };
      }

      Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
          this.prev = 0;
          this.next = 0; // Resetting context._sent for legacy support of Babel's
          // function.sent implementation.

          this.sent = this._sent = undefined$1;
          this.done = false;
          this.delegate = null;
          this.method = "next";
          this.arg = undefined$1;
          this.tryEntries.forEach(resetTryEntry);

          if (!skipTempReset) {
            for (var name in this) {
              // Not sure about the optimal order of these conditions:
              if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                this[name] = undefined$1;
              }
            }
          }
        },
        stop: function stop() {
          this.done = true;
          var rootEntry = this.tryEntries[0];
          var rootRecord = rootEntry.completion;

          if (rootRecord.type === "throw") {
            throw rootRecord.arg;
          }

          return this.rval;
        },
        dispatchException: function dispatchException(exception) {
          if (this.done) {
            throw exception;
          }

          var context = this;

          function handle(loc, caught) {
            record.type = "throw";
            record.arg = exception;
            context.next = loc;

            if (caught) {
              // If the dispatched exception was caught by a catch block,
              // then let that catch block handle the exception normally.
              context.method = "next";
              context.arg = undefined$1;
            }

            return !!caught;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            var record = entry.completion;

            if (entry.tryLoc === "root") {
              // Exception thrown outside of any try block that could handle
              // it, so set the completion value of the entire function to
              // throw the exception.
              return handle("end");
            }

            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc");
              var hasFinally = hasOwn.call(entry, "finallyLoc");

              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                } else if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                }
              } else if (hasFinally) {
                if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else {
                throw new Error("try statement without catch or finally");
              }
            }
          }
        },
        abrupt: function abrupt(type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }

          if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
            // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
          }

          var record = finallyEntry ? finallyEntry.completion : {};
          record.type = type;
          record.arg = arg;

          if (finallyEntry) {
            this.method = "next";
            this.next = finallyEntry.finallyLoc;
            return ContinueSentinel;
          }

          return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
          if (record.type === "throw") {
            throw record.arg;
          }

          if (record.type === "break" || record.type === "continue") {
            this.next = record.arg;
          } else if (record.type === "return") {
            this.rval = this.arg = record.arg;
            this.method = "return";
            this.next = "end";
          } else if (record.type === "normal" && afterLoc) {
            this.next = afterLoc;
          }

          return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.finallyLoc === finallyLoc) {
              this.complete(entry.completion, entry.afterLoc);
              resetTryEntry(entry);
              return ContinueSentinel;
            }
          }
        },
        "catch": function _catch(tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;

              if (record.type === "throw") {
                var thrown = record.arg;
                resetTryEntry(entry);
              }

              return thrown;
            }
          } // The context.catch method must only be called with a location
          // argument that corresponds to a known catch block.


          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
          this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          };

          if (this.method === "next") {
            // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined$1;
          }

          return ContinueSentinel;
        }
      }; // Regardless of whether this script is executing as a CommonJS module
      // or not, return the runtime object so that we can declare the variable
      // regeneratorRuntime in the outer scope, which allows this module to be
      // injected easily by `bin/regenerator --include-runtime script.js`.

      return exports;
    }( // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
     module.exports );

    try {
      regeneratorRuntime = runtime;
    } catch (accidentalStrictMode) {
      // This module should not be running in strict mode, so the above
      // assignment should always work unless something is misconfigured. Just
      // in case runtime.js accidentally runs in strict mode, in modern engines
      // we can explicitly access globalThis. In older engines we can escape
      // strict mode using a global Function call. This could conceivably fail
      // if a Content Security Policy forbids using Function, but in that case
      // the proper solution is to fix the accidental strict mode problem. If
      // you've misconfigured your bundler to force strict mode and applied a
      // CSP to forbid Function, and you're not willing to fix either of those
      // problems, please detail your unique predicament in a GitHub issue.
      if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
        globalThis.regeneratorRuntime = runtime;
      } else {
        Function("r", "regeneratorRuntime = r")(runtime);
      }
    }
  });

  var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};

  var lookup = [];
  var revLookup = [];
  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
  var inited = false;

  function init() {
    inited = true;
    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

    for (var i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }

    revLookup['-'.charCodeAt(0)] = 62;
    revLookup['_'.charCodeAt(0)] = 63;
  }

  function toByteArray(b64) {
    if (!inited) {
      init();
    }

    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;

    if (len % 4 > 0) {
      throw new Error('Invalid string. Length must be a multiple of 4');
    } // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice


    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0; // base64 is 4/3 + up to two characters of the original data

    arr = new Arr(len * 3 / 4 - placeHolders); // if there are placeholders, only get up to the last complete 4 chars

    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;

    for (i = 0, j = 0; i < l; i += 4, j += 3) {
      tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
      arr[L++] = tmp >> 16 & 0xFF;
      arr[L++] = tmp >> 8 & 0xFF;
      arr[L++] = tmp & 0xFF;
    }

    if (placeHolders === 2) {
      tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
      arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
      tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
      arr[L++] = tmp >> 8 & 0xFF;
      arr[L++] = tmp & 0xFF;
    }

    return arr;
  }

  function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
  }

  function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];

    for (var i = start; i < end; i += 3) {
      tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
      output.push(tripletToBase64(tmp));
    }

    return output.join('');
  }

  function fromByteArray(uint8) {
    if (!inited) {
      init();
    }

    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes

    var output = '';
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later

    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
      parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    } // pad the end with zeros, but make sure to not forget the extra bytes


    if (extraBytes === 1) {
      tmp = uint8[len - 1];
      output += lookup[tmp >> 2];
      output += lookup[tmp << 4 & 0x3F];
      output += '==';
    } else if (extraBytes === 2) {
      tmp = (uint8[len - 2] << 8) + uint8[len - 1];
      output += lookup[tmp >> 10];
      output += lookup[tmp >> 4 & 0x3F];
      output += lookup[tmp << 2 & 0x3F];
      output += '=';
    }

    parts.push(output);
    return parts.join('');
  }

  function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;

    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;

    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : (s ? -1 : 1) * Infinity;
    } else {
      m = m + Math.pow(2, mLen);
      e = e - eBias;
    }

    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
  }
  function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);

    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0;
      e = eMax;
    } else {
      e = Math.floor(Math.log(value) / Math.LN2);

      if (value * (c = Math.pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }

      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * Math.pow(2, 1 - eBias);
      }

      if (value * c >= 2) {
        e++;
        c /= 2;
      }

      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * Math.pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
        e = 0;
      }
    }

    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

    e = e << mLen | m;
    eLen += mLen;

    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

    buffer[offset + i - d] |= s * 128;
  }

  var toString = {}.toString;
  var isArray = Array.isArray || function (arr) {
    return toString.call(arr) == '[object Array]';
  };

  var INSPECT_MAX_BYTES = 50;
  /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Use Object implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * Due to various browser bugs, sometimes the Object implementation will be used even
   * when the browser supports typed arrays.
   *
   * Note:
   *
   *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
   *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
   *
   *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
   *
   *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
   *     incorrect length in some situations.

   * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
   * get the Object implementation, which is slower but behaves correctly.
   */

  Buffer$1.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined ? global$1.TYPED_ARRAY_SUPPORT : true;
  /*
   * Export kMaxLength after typed array support is determined.
   */

  var _kMaxLength = kMaxLength();

  function kMaxLength() {
    return Buffer$1.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
  }

  function createBuffer(that, length) {
    if (kMaxLength() < length) {
      throw new RangeError('Invalid typed array length');
    }

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      // Return an augmented `Uint8Array` instance, for best performance
      that = new Uint8Array(length);
      that.__proto__ = Buffer$1.prototype;
    } else {
      // Fallback: Return an object instance of the Buffer class
      if (that === null) {
        that = new Buffer$1(length);
      }

      that.length = length;
    }

    return that;
  }
  /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */


  function Buffer$1(arg, encodingOrOffset, length) {
    if (!Buffer$1.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$1)) {
      return new Buffer$1(arg, encodingOrOffset, length);
    } // Common case.


    if (typeof arg === 'number') {
      if (typeof encodingOrOffset === 'string') {
        throw new Error('If encoding is specified then the first argument must be a string');
      }

      return allocUnsafe(this, arg);
    }

    return from(this, arg, encodingOrOffset, length);
  }
  Buffer$1.poolSize = 8192; // not used by this implementation
  // TODO: Legacy, not needed anymore. Remove in next major version.

  Buffer$1._augment = function (arr) {
    arr.__proto__ = Buffer$1.prototype;
    return arr;
  };

  function from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('"value" argument must not be a number');
    }

    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
      return fromArrayBuffer(that, value, encodingOrOffset, length);
    }

    if (typeof value === 'string') {
      return fromString(that, value, encodingOrOffset);
    }

    return fromObject(that, value);
  }
  /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/


  Buffer$1.from = function (value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
  };

  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    Buffer$1.prototype.__proto__ = Uint8Array.prototype;
    Buffer$1.__proto__ = Uint8Array;
  }

  function assertSize(size) {
    if (typeof size !== 'number') {
      throw new TypeError('"size" argument must be a number');
    } else if (size < 0) {
      throw new RangeError('"size" argument must not be negative');
    }
  }

  function alloc(that, size, fill, encoding) {
    assertSize(size);

    if (size <= 0) {
      return createBuffer(that, size);
    }

    if (fill !== undefined) {
      // Only pay attention to encoding if it's a string. This
      // prevents accidentally sending in a number that would
      // be interpretted as a start offset.
      return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    }

    return createBuffer(that, size);
  }
  /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/


  Buffer$1.alloc = function (size, fill, encoding) {
    return alloc(null, size, fill, encoding);
  };

  function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);

    if (!Buffer$1.TYPED_ARRAY_SUPPORT) {
      for (var i = 0; i < size; ++i) {
        that[i] = 0;
      }
    }

    return that;
  }
  /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */


  Buffer$1.allocUnsafe = function (size) {
    return allocUnsafe(null, size);
  };
  /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */


  Buffer$1.allocUnsafeSlow = function (size) {
    return allocUnsafe(null, size);
  };

  function fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
      encoding = 'utf8';
    }

    if (!Buffer$1.isEncoding(encoding)) {
      throw new TypeError('"encoding" must be a valid string encoding');
    }

    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);

    if (actual !== length) {
      // Writing a hex string, for example, that contains invalid characters will
      // cause everything after the first invalid character to be ignored. (e.g.
      // 'abxxcd' will be treated as 'ab')
      that = that.slice(0, actual);
    }

    return that;
  }

  function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);

    for (var i = 0; i < length; i += 1) {
      that[i] = array[i] & 255;
    }

    return that;
  }

  function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer

    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('\'offset\' is out of bounds');
    }

    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('\'length\' is out of bounds');
    }

    if (byteOffset === undefined && length === undefined) {
      array = new Uint8Array(array);
    } else if (length === undefined) {
      array = new Uint8Array(array, byteOffset);
    } else {
      array = new Uint8Array(array, byteOffset, length);
    }

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      // Return an augmented `Uint8Array` instance, for best performance
      that = array;
      that.__proto__ = Buffer$1.prototype;
    } else {
      // Fallback: Return an object instance of the Buffer class
      that = fromArrayLike(that, array);
    }

    return that;
  }

  function fromObject(that, obj) {
    if (internalIsBuffer(obj)) {
      var len = checked(obj.length) | 0;
      that = createBuffer(that, len);

      if (that.length === 0) {
        return that;
      }

      obj.copy(that, 0, 0, len);
      return that;
    }

    if (obj) {
      if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
        if (typeof obj.length !== 'number' || isnan(obj.length)) {
          return createBuffer(that, 0);
        }

        return fromArrayLike(that, obj);
      }

      if (obj.type === 'Buffer' && isArray(obj.data)) {
        return fromArrayLike(that, obj.data);
      }
    }

    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
  }

  function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) {
      throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
    }

    return length | 0;
  }

  function SlowBuffer(length) {
    if (+length != length) {
      // eslint-disable-line eqeqeq
      length = 0;
    }

    return Buffer$1.alloc(+length);
  }
  Buffer$1.isBuffer = isBuffer;

  function internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
  }

  Buffer$1.compare = function compare(a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
      throw new TypeError('Arguments must be Buffers');
    }

    if (a === b) return 0;
    var x = a.length;
    var y = b.length;

    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
      }
    }

    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
  };

  Buffer$1.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'latin1':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return true;

      default:
        return false;
    }
  };

  Buffer$1.concat = function concat(list, length) {
    if (!isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }

    if (list.length === 0) {
      return Buffer$1.alloc(0);
    }

    var i;

    if (length === undefined) {
      length = 0;

      for (i = 0; i < list.length; ++i) {
        length += list[i].length;
      }
    }

    var buffer = Buffer$1.allocUnsafe(length);
    var pos = 0;

    for (i = 0; i < list.length; ++i) {
      var buf = list[i];

      if (!internalIsBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }

      buf.copy(buffer, pos);
      pos += buf.length;
    }

    return buffer;
  };

  function byteLength(string, encoding) {
    if (internalIsBuffer(string)) {
      return string.length;
    }

    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
      return string.byteLength;
    }

    if (typeof string !== 'string') {
      string = '' + string;
    }

    var len = string.length;
    if (len === 0) return 0; // Use a for loop to avoid recursion

    var loweredCase = false;

    for (;;) {
      switch (encoding) {
        case 'ascii':
        case 'latin1':
        case 'binary':
          return len;

        case 'utf8':
        case 'utf-8':
        case undefined:
          return utf8ToBytes(string).length;

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return len * 2;

        case 'hex':
          return len >>> 1;

        case 'base64':
          return base64ToBytes(string).length;

        default:
          if (loweredCase) return utf8ToBytes(string).length; // assume utf8

          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }

  Buffer$1.byteLength = byteLength;

  function slowToString(encoding, start, end) {
    var loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.

    if (start === undefined || start < 0) {
      start = 0;
    } // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.


    if (start > this.length) {
      return '';
    }

    if (end === undefined || end > this.length) {
      end = this.length;
    }

    if (end <= 0) {
      return '';
    } // Force coersion to uint32. This will also coerce falsey/NaN values to 0.


    end >>>= 0;
    start >>>= 0;

    if (end <= start) {
      return '';
    }

    if (!encoding) encoding = 'utf8';

    while (true) {
      switch (encoding) {
        case 'hex':
          return hexSlice(this, start, end);

        case 'utf8':
        case 'utf-8':
          return utf8Slice(this, start, end);

        case 'ascii':
          return asciiSlice(this, start, end);

        case 'latin1':
        case 'binary':
          return latin1Slice(this, start, end);

        case 'base64':
          return base64Slice(this, start, end);

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return utf16leSlice(this, start, end);

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
          encoding = (encoding + '').toLowerCase();
          loweredCase = true;
      }
    }
  } // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
  // Buffer instances.


  Buffer$1.prototype._isBuffer = true;

  function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
  }

  Buffer$1.prototype.swap16 = function swap16() {
    var len = this.length;

    if (len % 2 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 16-bits');
    }

    for (var i = 0; i < len; i += 2) {
      swap(this, i, i + 1);
    }

    return this;
  };

  Buffer$1.prototype.swap32 = function swap32() {
    var len = this.length;

    if (len % 4 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 32-bits');
    }

    for (var i = 0; i < len; i += 4) {
      swap(this, i, i + 3);
      swap(this, i + 1, i + 2);
    }

    return this;
  };

  Buffer$1.prototype.swap64 = function swap64() {
    var len = this.length;

    if (len % 8 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 64-bits');
    }

    for (var i = 0; i < len; i += 8) {
      swap(this, i, i + 7);
      swap(this, i + 1, i + 6);
      swap(this, i + 2, i + 5);
      swap(this, i + 3, i + 4);
    }

    return this;
  };

  Buffer$1.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
  };

  Buffer$1.prototype.equals = function equals(b) {
    if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer$1.compare(this, b) === 0;
  };

  Buffer$1.prototype.inspect = function inspect() {
    var str = '';
    var max = INSPECT_MAX_BYTES;

    if (this.length > 0) {
      str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
      if (this.length > max) str += ' ... ';
    }

    return '<Buffer ' + str + '>';
  };

  Buffer$1.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) {
      throw new TypeError('Argument must be a Buffer');
    }

    if (start === undefined) {
      start = 0;
    }

    if (end === undefined) {
      end = target ? target.length : 0;
    }

    if (thisStart === undefined) {
      thisStart = 0;
    }

    if (thisEnd === undefined) {
      thisEnd = this.length;
    }

    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError('out of range index');
    }

    if (thisStart >= thisEnd && start >= end) {
      return 0;
    }

    if (thisStart >= thisEnd) {
      return -1;
    }

    if (start >= end) {
      return 1;
    }

    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);

    for (var i = 0; i < len; ++i) {
      if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
      }
    }

    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
  }; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
  // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
  //
  // Arguments:
  // - buffer - a Buffer to search
  // - val - a string, Buffer, or number
  // - byteOffset - an index into `buffer`; will be clamped to an int32
  // - encoding - an optional encoding, relevant is val is a string
  // - dir - true for indexOf, false for lastIndexOf


  function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1; // Normalize byteOffset

    if (typeof byteOffset === 'string') {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) {
      byteOffset = 0x7fffffff;
    } else if (byteOffset < -0x80000000) {
      byteOffset = -0x80000000;
    }

    byteOffset = +byteOffset; // Coerce to Number.

    if (isNaN(byteOffset)) {
      // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
      byteOffset = dir ? 0 : buffer.length - 1;
    } // Normalize byteOffset: negative offsets start from the end of the buffer


    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;

    if (byteOffset >= buffer.length) {
      if (dir) return -1;else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
      if (dir) byteOffset = 0;else return -1;
    } // Normalize val


    if (typeof val === 'string') {
      val = Buffer$1.from(val, encoding);
    } // Finally, search either indexOf (if dir is true) or lastIndexOf


    if (internalIsBuffer(val)) {
      // Special case: looking for empty string/buffer always fails
      if (val.length === 0) {
        return -1;
      }

      return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
      val = val & 0xFF; // Search for a byte value [0-255]

      if (Buffer$1.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
      }

      return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
    }

    throw new TypeError('val must be string, number or Buffer');
  }

  function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;

    if (encoding !== undefined) {
      encoding = String(encoding).toLowerCase();

      if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
        if (arr.length < 2 || val.length < 2) {
          return -1;
        }

        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }

    function read(buf, i) {
      if (indexSize === 1) {
        return buf[i];
      } else {
        return buf.readUInt16BE(i * indexSize);
      }
    }

    var i;

    if (dir) {
      var foundIndex = -1;

      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1) foundIndex = i;
          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
          if (foundIndex !== -1) i -= i - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;

      for (i = byteOffset; i >= 0; i--) {
        var found = true;

        for (var j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val, j)) {
            found = false;
            break;
          }
        }

        if (found) return i;
      }
    }

    return -1;
  }

  Buffer$1.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
  };

  Buffer$1.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
  };

  Buffer$1.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
  };

  function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;

    if (!length) {
      length = remaining;
    } else {
      length = Number(length);

      if (length > remaining) {
        length = remaining;
      }
    } // must be an even number of digits


    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

    if (length > strLen / 2) {
      length = strLen / 2;
    }

    for (var i = 0; i < length; ++i) {
      var parsed = parseInt(string.substr(i * 2, 2), 16);
      if (isNaN(parsed)) return i;
      buf[offset + i] = parsed;
    }

    return i;
  }

  function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
  }

  function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
  }

  function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
  }

  function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
  }

  function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
  }

  Buffer$1.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
      encoding = 'utf8';
      length = this.length;
      offset = 0; // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
      encoding = offset;
      length = this.length;
      offset = 0; // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
      offset = offset | 0;

      if (isFinite(length)) {
        length = length | 0;
        if (encoding === undefined) encoding = 'utf8';
      } else {
        encoding = length;
        length = undefined;
      } // legacy write(string, encoding, offset, length) - remove in v0.13

    } else {
      throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    }

    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;

    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
      throw new RangeError('Attempt to write outside buffer bounds');
    }

    if (!encoding) encoding = 'utf8';
    var loweredCase = false;

    for (;;) {
      switch (encoding) {
        case 'hex':
          return hexWrite(this, string, offset, length);

        case 'utf8':
        case 'utf-8':
          return utf8Write(this, string, offset, length);

        case 'ascii':
          return asciiWrite(this, string, offset, length);

        case 'latin1':
        case 'binary':
          return latin1Write(this, string, offset, length);

        case 'base64':
          // Warning: maxLength not taken into account in base64Write
          return base64Write(this, string, offset, length);

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return ucs2Write(this, string, offset, length);

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };

  Buffer$1.prototype.toJSON = function toJSON() {
    return {
      type: 'Buffer',
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };

  function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
      return fromByteArray(buf);
    } else {
      return fromByteArray(buf.slice(start, end));
    }
  }

  function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;

    while (i < end) {
      var firstByte = buf[i];
      var codePoint = null;
      var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

      if (i + bytesPerSequence <= end) {
        var secondByte, thirdByte, fourthByte, tempCodePoint;

        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 0x80) {
              codePoint = firstByte;
            }

            break;

          case 2:
            secondByte = buf[i + 1];

            if ((secondByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;

              if (tempCodePoint > 0x7F) {
                codePoint = tempCodePoint;
              }
            }

            break;

          case 3:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];

            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;

              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                codePoint = tempCodePoint;
              }
            }

            break;

          case 4:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            fourthByte = buf[i + 3];

            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;

              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                codePoint = tempCodePoint;
              }
            }

        }
      }

      if (codePoint === null) {
        // we did not generate a valid codePoint so insert a
        // replacement char (U+FFFD) and advance only 1 byte
        codePoint = 0xFFFD;
        bytesPerSequence = 1;
      } else if (codePoint > 0xFFFF) {
        // encode to utf16 (surrogate pair dance)
        codePoint -= 0x10000;
        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
        codePoint = 0xDC00 | codePoint & 0x3FF;
      }

      res.push(codePoint);
      i += bytesPerSequence;
    }

    return decodeCodePointsArray(res);
  } // Based on http://stackoverflow.com/a/22747272/680742, the browser with
  // the lowest limit is Chrome, with 0x10000 args.
  // We go 1 magnitude less, for safety


  var MAX_ARGUMENTS_LENGTH = 0x1000;

  function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;

    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
    } // Decode in chunks to avoid "call stack size exceeded".


    var res = '';
    var i = 0;

    while (i < len) {
      res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }

    return res;
  }

  function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i] & 0x7F);
    }

    return ret;
  }

  function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i]);
    }

    return ret;
  }

  function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';

    for (var i = start; i < end; ++i) {
      out += toHex(buf[i]);
    }

    return out;
  }

  function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';

    for (var i = 0; i < bytes.length; i += 2) {
      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }

    return res;
  }

  Buffer$1.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;

    if (start < 0) {
      start += len;
      if (start < 0) start = 0;
    } else if (start > len) {
      start = len;
    }

    if (end < 0) {
      end += len;
      if (end < 0) end = 0;
    } else if (end > len) {
      end = len;
    }

    if (end < start) end = start;
    var newBuf;

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      newBuf = this.subarray(start, end);
      newBuf.__proto__ = Buffer$1.prototype;
    } else {
      var sliceLen = end - start;
      newBuf = new Buffer$1(sliceLen, undefined);

      for (var i = 0; i < sliceLen; ++i) {
        newBuf[i] = this[i + start];
      }
    }

    return newBuf;
  };
  /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */


  function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
  }

  Buffer$1.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;

    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }

    return val;
  };

  Buffer$1.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;

    if (!noAssert) {
      checkOffset(offset, byteLength, this.length);
    }

    var val = this[offset + --byteLength];
    var mul = 1;

    while (byteLength > 0 && (mul *= 0x100)) {
      val += this[offset + --byteLength] * mul;
    }

    return val;
  };

  Buffer$1.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
  };

  Buffer$1.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
  };

  Buffer$1.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
  };

  Buffer$1.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
  };

  Buffer$1.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
  };

  Buffer$1.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;

    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }

    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
  };

  Buffer$1.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];

    while (i > 0 && (mul *= 0x100)) {
      val += this[offset + --i] * mul;
    }

    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
  };

  Buffer$1.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
  };

  Buffer$1.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
  };

  Buffer$1.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
  };

  Buffer$1.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
  };

  Buffer$1.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
  };

  Buffer$1.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4);
  };

  Buffer$1.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4);
  };

  Buffer$1.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8);
  };

  Buffer$1.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8);
  };

  function checkInt(buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
  }

  Buffer$1.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;

    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;

    while (++i < byteLength && (mul *= 0x100)) {
      this[offset + i] = value / mul & 0xFF;
    }

    return offset + byteLength;
  };

  Buffer$1.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;

    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;

    while (--i >= 0 && (mul *= 0x100)) {
      this[offset + i] = value / mul & 0xFF;
    }

    return offset + byteLength;
  };

  Buffer$1.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
  };

  function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;

    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
      buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
    }
  }

  Buffer$1.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value & 0xff;
      this[offset + 1] = value >>> 8;
    } else {
      objectWriteUInt16(this, value, offset, true);
    }

    return offset + 2;
  };

  Buffer$1.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value >>> 8;
      this[offset + 1] = value & 0xff;
    } else {
      objectWriteUInt16(this, value, offset, false);
    }

    return offset + 2;
  };

  function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;

    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
      buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
    }
  }

  Buffer$1.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset + 3] = value >>> 24;
      this[offset + 2] = value >>> 16;
      this[offset + 1] = value >>> 8;
      this[offset] = value & 0xff;
    } else {
      objectWriteUInt32(this, value, offset, true);
    }

    return offset + 4;
  };

  Buffer$1.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 0xff;
    } else {
      objectWriteUInt32(this, value, offset, false);
    }

    return offset + 4;
  };

  Buffer$1.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;

    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);
      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;

    while (++i < byteLength && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
        sub = 1;
      }

      this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }

    return offset + byteLength;
  };

  Buffer$1.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;

    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);
      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;

    while (--i >= 0 && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
        sub = 1;
      }

      this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }

    return offset + byteLength;
  };

  Buffer$1.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
    if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
  };

  Buffer$1.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value & 0xff;
      this[offset + 1] = value >>> 8;
    } else {
      objectWriteUInt16(this, value, offset, true);
    }

    return offset + 2;
  };

  Buffer$1.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value >>> 8;
      this[offset + 1] = value & 0xff;
    } else {
      objectWriteUInt16(this, value, offset, false);
    }

    return offset + 2;
  };

  Buffer$1.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value & 0xff;
      this[offset + 1] = value >>> 8;
      this[offset + 2] = value >>> 16;
      this[offset + 3] = value >>> 24;
    } else {
      objectWriteUInt32(this, value, offset, true);
    }

    return offset + 4;
  };

  Buffer$1.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (value < 0) value = 0xffffffff + value + 1;

    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 0xff;
    } else {
      objectWriteUInt32(this, value, offset, false);
    }

    return offset + 4;
  };

  function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
  }

  function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4);
    }

    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
  }

  Buffer$1.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
  };

  Buffer$1.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
  };

  function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8);
    }

    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
  }

  Buffer$1.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
  };

  Buffer$1.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
  }; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)


  Buffer$1.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done

    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions

    if (targetStart < 0) {
      throw new RangeError('targetStart out of bounds');
    }

    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds'); // Are we oob?

    if (end > this.length) end = this.length;

    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }

    var len = end - start;
    var i;

    if (this === target && start < targetStart && targetStart < end) {
      // descending copy from end
      for (i = len - 1; i >= 0; --i) {
        target[i + targetStart] = this[i + start];
      }
    } else if (len < 1000 || !Buffer$1.TYPED_ARRAY_SUPPORT) {
      // ascending copy from start
      for (i = 0; i < len; ++i) {
        target[i + targetStart] = this[i + start];
      }
    } else {
      Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    }

    return len;
  }; // Usage:
  //    buffer.fill(number[, offset[, end]])
  //    buffer.fill(buffer[, offset[, end]])
  //    buffer.fill(string[, offset[, end]][, encoding])


  Buffer$1.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
      if (typeof start === 'string') {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === 'string') {
        encoding = end;
        end = this.length;
      }

      if (val.length === 1) {
        var code = val.charCodeAt(0);

        if (code < 256) {
          val = code;
        }
      }

      if (encoding !== undefined && typeof encoding !== 'string') {
        throw new TypeError('encoding must be a string');
      }

      if (typeof encoding === 'string' && !Buffer$1.isEncoding(encoding)) {
        throw new TypeError('Unknown encoding: ' + encoding);
      }
    } else if (typeof val === 'number') {
      val = val & 255;
    } // Invalid ranges are not set to a default, so can range check early.


    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError('Out of range index');
    }

    if (end <= start) {
      return this;
    }

    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;

    if (typeof val === 'number') {
      for (i = start; i < end; ++i) {
        this[i] = val;
      }
    } else {
      var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer$1(val, encoding).toString());
      var len = bytes.length;

      for (i = 0; i < end - start; ++i) {
        this[i + start] = bytes[i % len];
      }
    }

    return this;
  }; // HELPER FUNCTIONS
  // ================


  var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

  function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, ''); // Node converts strings with length < 2 to ''

    if (str.length < 2) return ''; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not

    while (str.length % 4 !== 0) {
      str = str + '=';
    }

    return str;
  }

  function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
  }

  function toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
  }

  function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];

    for (var i = 0; i < length; ++i) {
      codePoint = string.charCodeAt(i); // is surrogate component

      if (codePoint > 0xD7FF && codePoint < 0xE000) {
        // last char was a lead
        if (!leadSurrogate) {
          // no lead yet
          if (codePoint > 0xDBFF) {
            // unexpected trail
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue;
          } else if (i + 1 === length) {
            // unpaired lead
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue;
          } // valid lead


          leadSurrogate = codePoint;
          continue;
        } // 2 leads in a row


        if (codePoint < 0xDC00) {
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          leadSurrogate = codePoint;
          continue;
        } // valid surrogate pair


        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
      } else if (leadSurrogate) {
        // valid bmp char, but last char was a lead
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
      }

      leadSurrogate = null; // encode utf8

      if (codePoint < 0x80) {
        if ((units -= 1) < 0) break;
        bytes.push(codePoint);
      } else if (codePoint < 0x800) {
        if ((units -= 2) < 0) break;
        bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
      } else if (codePoint < 0x10000) {
        if ((units -= 3) < 0) break;
        bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
      } else if (codePoint < 0x110000) {
        if ((units -= 4) < 0) break;
        bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
      } else {
        throw new Error('Invalid code point');
      }
    }

    return bytes;
  }

  function asciiToBytes(str) {
    var byteArray = [];

    for (var i = 0; i < str.length; ++i) {
      // Node's code seems to be doing this and not & 0x7F..
      byteArray.push(str.charCodeAt(i) & 0xFF);
    }

    return byteArray;
  }

  function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];

    for (var i = 0; i < str.length; ++i) {
      if ((units -= 2) < 0) break;
      c = str.charCodeAt(i);
      hi = c >> 8;
      lo = c % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }

    return byteArray;
  }

  function base64ToBytes(str) {
    return toByteArray(base64clean(str));
  }

  function blitBuffer(src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
      if (i + offset >= dst.length || i >= src.length) break;
      dst[i + offset] = src[i];
    }

    return i;
  }

  function isnan(val) {
    return val !== val; // eslint-disable-line no-self-compare
  } // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
  // The _isBuffer check is for Safari 5-7 support, because it's missing
  // Object.prototype.constructor. Remove this eventually


  function isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
  }

  function isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
  } // For Node v0.10 support. Remove this eventually.


  function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0));
  }

  var bufferEs6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
    kMaxLength: _kMaxLength,
    Buffer: Buffer$1,
    SlowBuffer: SlowBuffer,
    isBuffer: isBuffer
  });

  var getOwnPropertyDescriptors = function getOwnPropertyDescriptors(originalObject) {
    return Object.getOwnPropertyNames(originalObject).reduce(function (descriptors, name) {
      descriptors[name] = Object.getOwnPropertyDescriptor(originalObject, name);
      return descriptors;
    }, {});
  };

  var kCustomPromisifiedSymbol = Symbol('util.promisify.custom');
  function promisify(original, context) {
    if (typeof context === 'undefined') {
      context = this;
    }

    if (typeof original !== 'function') {
      throw new Error('original is not a function', 'Function', original);
    }

    function fn() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return new Promise(function (resolve, reject) {
        original.call.apply(original, [context].concat(args, [function (err, value) {
          if (err) {
            return reject(err);
          }

          resolve(value);
        }]));
      });
    }

    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn,
      enumerable: false,
      writable: false,
      configurable: true
    });
    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
  }

  var googleProtobuf = createCommonjsModule(function (module, exports) {
    var $jscomp = $jscomp || {};
    $jscomp.scope = {};

    $jscomp.findInternal = function (a, b, c) {
      a instanceof String && (a = String(a));

      for (var d = a.length, e = 0; e < d; e++) {
        var f = a[e];
        if (b.call(c, f, e, a)) return {
          i: e,
          v: f
        };
      }

      return {
        i: -1,
        v: void 0
      };
    };

    $jscomp.ASSUME_ES5 = !1;
    $jscomp.ASSUME_NO_NATIVE_MAP = !1;
    $jscomp.ASSUME_NO_NATIVE_SET = !1;
    $jscomp.SIMPLE_FROUND_POLYFILL = !1;
    $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
      a != Array.prototype && a != Object.prototype && (a[b] = c.value);
    };

    $jscomp.getGlobal = function (a) {
      return "undefined" != typeof window && window === a ? a : "undefined" != typeof commonjsGlobal && null != commonjsGlobal ? commonjsGlobal : a;
    };

    $jscomp.global = $jscomp.getGlobal(commonjsGlobal);

    $jscomp.polyfill = function (a, b, c, d) {
      if (b) {
        c = $jscomp.global;
        a = a.split(".");

        for (d = 0; d < a.length - 1; d++) {
          var e = a[d];
          e in c || (c[e] = {});
          c = c[e];
        }

        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && $jscomp.defineProperty(c, a, {
          configurable: !0,
          writable: !0,
          value: b
        });
      }
    };

    $jscomp.polyfill("Array.prototype.findIndex", function (a) {
      return a ? a : function (a, c) {
        return $jscomp.findInternal(this, a, c).i;
      };
    }, "es6", "es3");

    $jscomp.checkStringArgs = function (a, b, c) {
      if (null == a) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
      if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
      return a + "";
    };

    $jscomp.polyfill("String.prototype.endsWith", function (a) {
      return a ? a : function (a, c) {
        var b = $jscomp.checkStringArgs(this, a, "endsWith");
        a += "";
        void 0 === c && (c = b.length);
        c = Math.max(0, Math.min(c | 0, b.length));

        for (var e = a.length; 0 < e && 0 < c;) {
          if (b[--c] != a[--e]) return !1;
        }

        return 0 >= e;
      };
    }, "es6", "es3");
    $jscomp.polyfill("Array.prototype.find", function (a) {
      return a ? a : function (a, c) {
        return $jscomp.findInternal(this, a, c).v;
      };
    }, "es6", "es3");
    $jscomp.polyfill("String.prototype.startsWith", function (a) {
      return a ? a : function (a, c) {
        var b = $jscomp.checkStringArgs(this, a, "startsWith");
        a += "";
        var e = b.length,
            f = a.length;
        c = Math.max(0, Math.min(c | 0, b.length));

        for (var g = 0; g < f && c < e;) {
          if (b[c++] != a[g++]) return !1;
        }

        return g >= f;
      };
    }, "es6", "es3");
    $jscomp.polyfill("String.prototype.repeat", function (a) {
      return a ? a : function (a) {
        var b = $jscomp.checkStringArgs(this, null, "repeat");
        if (0 > a || 1342177279 < a) throw new RangeError("Invalid count value");
        a |= 0;

        for (var d = ""; a;) {
          if (a & 1 && (d += b), a >>>= 1) b += b;
        }

        return d;
      };
    }, "es6", "es3");
    var COMPILED = !0,
        goog = goog || {};
    goog.global = commonjsGlobal || self;

    goog.isDef = function (a) {
      return void 0 !== a;
    };

    goog.isString = function (a) {
      return "string" == typeof a;
    };

    goog.isBoolean = function (a) {
      return "boolean" == typeof a;
    };

    goog.isNumber = function (a) {
      return "number" == typeof a;
    };

    goog.exportPath_ = function (a, b, c) {
      a = a.split(".");
      c = c || goog.global;
      a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);

      for (var d; a.length && (d = a.shift());) {
        !a.length && goog.isDef(b) ? c[d] = b : c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {};
      }
    };

    goog.define = function (a, b) {

      return b;
    };

    goog.FEATURESET_YEAR = 2012;
    goog.DEBUG = !0;
    goog.LOCALE = "en";
    goog.TRUSTED_SITE = !0;
    goog.STRICT_MODE_COMPATIBLE = !1;
    goog.DISALLOW_TEST_ONLY_CODE =  !goog.DEBUG;
    goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;

    goog.provide = function (a) {
      if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
      goog.constructNamespace_(a);
    };

    goog.constructNamespace_ = function (a, b) {

      goog.exportPath_(a, b);
    };

    goog.getScriptNonce = function (a) {
      if (a && a != goog.global) return goog.getScriptNonce_(a.document);
      null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
      return goog.cspNonce_;
    };

    goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
    goog.cspNonce_ = null;

    goog.getScriptNonce_ = function (a) {
      return (a = a.querySelector && a.querySelector("script[nonce]")) && (a = a.nonce || a.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a) ? a : "";
    };

    goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;

    goog.module = function (a) {
      if (!goog.isString(a) || !a || -1 == a.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
      if (!goog.isInGoogModuleLoader_()) throw Error("Module " + a + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
      if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
      goog.moduleLoaderState_.moduleName = a;
    };

    goog.module.get = function (a) {
      return goog.module.getInternal_(a);
    };

    goog.module.getInternal_ = function (a) {

      return null;
    };

    goog.ModuleType = {
      ES6: "es6",
      GOOG: "goog"
    };
    goog.moduleLoaderState_ = null;

    goog.isInModuleLoader_ = function () {
      return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
    };

    goog.isInGoogModuleLoader_ = function () {
      return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
    };

    goog.isInEs6ModuleLoader_ = function () {
      if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
      var a = goog.global.$jscomp;
      return a ? "function" != typeof a.getCurrentModulePath ? !1 : !!a.getCurrentModulePath() : !1;
    };

    goog.module.declareLegacyNamespace = function () {
      goog.moduleLoaderState_.declareLegacyNamespace = !0;
    };

    goog.declareModuleId = function (a) {

      if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = a;else {
        var b = goog.global.$jscomp;
        if (!b || "function" != typeof b.getCurrentModulePath) throw Error('Module with namespace "' + a + '" has been loaded incorrectly.');
        b = b.require(b.getCurrentModulePath());
        goog.loadedModules_[a] = {
          exports: b,
          type: goog.ModuleType.ES6,
          moduleId: a
        };
      }
    };

    goog.setTestOnly = function (a) {
      if (goog.DISALLOW_TEST_ONLY_CODE) throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
    };

    goog.forwardDeclare = function (a) {};

    goog.getObjectByName = function (a, b) {
      a = a.split(".");
      b = b || goog.global;

      for (var c = 0; c < a.length; c++) {
        if (b = b[a[c]], !goog.isDefAndNotNull(b)) return null;
      }

      return b;
    };

    goog.globalize = function (a, b) {
      b = b || goog.global;

      for (var c in a) {
        b[c] = a[c];
      }
    };

    goog.addDependency = function (a, b, c, d) {
    };

    goog.ENABLE_DEBUG_LOADER = !0;

    goog.logToConsole_ = function (a) {
      goog.global.console && goog.global.console.error(a);
    };

    goog.require = function (a) {
    };

    goog.requireType = function (a) {
      return {};
    };

    goog.basePath = "";

    goog.nullFunction = function () {};

    goog.abstractMethod = function () {
      throw Error("unimplemented abstract method");
    };

    goog.addSingletonGetter = function (a) {
      a.instance_ = void 0;

      a.getInstance = function () {
        if (a.instance_) return a.instance_;
        goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
        return a.instance_ = new a();
      };
    };

    goog.instantiatedSingletons_ = [];
    goog.LOAD_MODULE_USING_EVAL = !0;
    goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
    goog.loadedModules_ = {};
    goog.DEPENDENCIES_ENABLED = !COMPILED ;
    goog.TRANSPILE = "detect";
    goog.ASSUME_ES_MODULES_TRANSPILED = !1;
    goog.TRANSPILE_TO_LANGUAGE = "";
    goog.TRANSPILER = "transpile.js";
    goog.hasBadLetScoping = null;

    goog.useSafari10Workaround = function () {
      if (null == goog.hasBadLetScoping) {
        try {
          var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
        } catch (b) {
          a = !1;
        }

        goog.hasBadLetScoping = a;
      }

      return goog.hasBadLetScoping;
    };

    goog.workaroundSafari10EvalBug = function (a) {
      return "(function(){" + a + "\n;})();\n";
    };

    goog.loadModule = function (a) {
      var b = goog.moduleLoaderState_;

      try {
        goog.moduleLoaderState_ = {
          moduleName: "",
          declareLegacyNamespace: !1,
          type: goog.ModuleType.GOOG
        };
        if (goog.isFunction(a)) var c = a.call(void 0, {});else if (goog.isString(a)) goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), c = goog.loadModuleFromSource_.call(void 0, a);else throw Error("Invalid module definition");
        var d = goog.moduleLoaderState_.moduleName;
        if (goog.isString(d) && d) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, c) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == _typeof(c) && null != c && Object.seal(c), goog.loadedModules_[d] = {
          exports: c,
          type: goog.ModuleType.GOOG,
          moduleId: goog.moduleLoaderState_.moduleName
        };else throw Error('Invalid module name "' + d + '"');
      } finally {
        goog.moduleLoaderState_ = b;
      }
    };

    goog.loadModuleFromSource_ = function (a) {
      eval(a);
      return {};
    };

    goog.normalizePath_ = function (a) {
      a = a.split("/");

      for (var b = 0; b < a.length;) {
        "." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
      }

      return a.join("/");
    };

    goog.loadFileSync_ = function (a) {
      if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(a);

      try {
        var b = new goog.global.XMLHttpRequest();
        b.open("get", a, !1);
        b.send();
        return 0 == b.status || 200 == b.status ? b.responseText : null;
      } catch (c) {
        return null;
      }
    };

    goog.transpile_ = function (a, b, c) {
      var d = goog.global.$jscomp;
      d || (goog.global.$jscomp = d = {});
      var e = d.transpile;

      if (!e) {
        var f = goog.basePath + goog.TRANSPILER,
            g = goog.loadFileSync_(f);

        if (g) {
          (function () {
            (0, eval)(g + "\n//# sourceURL=" + f);
          }).call(goog.global);
          if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
          goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
          d = goog.global.$jscomp;
          e = d.transpile;
        }
      }

      e || (e = d.transpile = function (a, b) {
        goog.logToConsole_(b + " requires transpilation but no transpiler was found.");
        return a;
      });
      return e(a, b, c);
    };

    goog.typeOf = function (a) {
      var b = _typeof(a);

      if ("object" == b) {
        if (a) {
          if (a instanceof Array) return "array";
          if (a instanceof Object) return b;
          var c = Object.prototype.toString.call(a);
          if ("[object Window]" == c) return "object";
          if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
          if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
        } else return "null";
      } else if ("function" == b && "undefined" == typeof a.call) return "object";
      return b;
    };

    goog.isNull = function (a) {
      return null === a;
    };

    goog.isDefAndNotNull = function (a) {
      return null != a;
    };

    goog.isArray = function (a) {
      return "array" == goog.typeOf(a);
    };

    goog.isArrayLike = function (a) {
      var b = goog.typeOf(a);
      return "array" == b || "object" == b && "number" == typeof a.length;
    };

    goog.isDateLike = function (a) {
      return goog.isObject(a) && "function" == typeof a.getFullYear;
    };

    goog.isFunction = function (a) {
      return "function" == goog.typeOf(a);
    };

    goog.isObject = function (a) {
      var b = _typeof(a);

      return "object" == b && null != a || "function" == b;
    };

    goog.getUid = function (a) {
      return a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
    };

    goog.hasUid = function (a) {
      return !!a[goog.UID_PROPERTY_];
    };

    goog.removeUid = function (a) {
      null !== a && "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);

      try {
        delete a[goog.UID_PROPERTY_];
      } catch (b) {}
    };

    goog.UID_PROPERTY_ = "closure_uid_" + (1E9 * Math.random() >>> 0);
    goog.uidCounter_ = 0;
    goog.getHashCode = goog.getUid;
    goog.removeHashCode = goog.removeUid;

    goog.cloneObject = function (a) {
      var b = goog.typeOf(a);

      if ("object" == b || "array" == b) {
        if ("function" === typeof a.clone) return a.clone();
        b = "array" == b ? [] : {};

        for (var c in a) {
          b[c] = goog.cloneObject(a[c]);
        }

        return b;
      }

      return a;
    };

    goog.bindNative_ = function (a, b, c) {
      return a.call.apply(a.bind, arguments);
    };

    goog.bindJs_ = function (a, b, c) {
      if (!a) throw Error();

      if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function () {
          var c = Array.prototype.slice.call(arguments);
          Array.prototype.unshift.apply(c, d);
          return a.apply(b, c);
        };
      }

      return function () {
        return a.apply(b, arguments);
      };
    };

    goog.bind = function (a, b, c) {
      Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
      return goog.bind.apply(null, arguments);
    };

    goog.partial = function (a, b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return function () {
        var b = c.slice();
        b.push.apply(b, arguments);
        return a.apply(this, b);
      };
    };

    goog.mixin = function (a, b) {
      for (var c in b) {
        a[c] = b[c];
      }
    };

    goog.now = goog.TRUSTED_SITE && Date.now || function () {
      return +new Date();
    };

    goog.globalEval = function (a) {
      if (goog.global.execScript) goog.global.execScript(a, "JavaScript");else if (goog.global.eval) {
        if (null == goog.evalWorksForGlobals_) {
          try {
            goog.global.eval("var _evalTest_ = 1;");
          } catch (d) {}

          if ("undefined" != typeof goog.global._evalTest_) {
            try {
              delete goog.global._evalTest_;
            } catch (d) {}

            goog.evalWorksForGlobals_ = !0;
          } else goog.evalWorksForGlobals_ = !1;
        }

        if (goog.evalWorksForGlobals_) goog.global.eval(a);else {
          var b = goog.global.document,
              c = b.createElement("SCRIPT");
          c.type = "text/javascript";
          c.defer = !1;
          c.appendChild(b.createTextNode(a));
          b.head.appendChild(c);
          b.head.removeChild(c);
        }
      } else throw Error("goog.globalEval not available");
    };

    goog.evalWorksForGlobals_ = null;

    goog.getCssName = function (a, b) {
      if ("." == String(a).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);

      var c = function c(a) {
        return goog.cssNameMapping_[a] || a;
      },
          d = function d(a) {
        a = a.split("-");

        for (var b = [], d = 0; d < a.length; d++) {
          b.push(c(a[d]));
        }

        return b.join("-");
      };

      d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function (a) {
        return a;
      };
      a = b ? a + "-" + d(b) : d(a);
      return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a) : a;
    };

    goog.setCssNameMapping = function (a, b) {
      goog.cssNameMapping_ = a;
      goog.cssNameMappingStyle_ = b;
    };

    goog.getMsg = function (a, b, c) {
      c && c.html && (a = a.replace(/</g, "&lt;"));
      b && (a = a.replace(/\{\$([^}]+)}/g, function (a, c) {
        return null != b && c in b ? b[c] : a;
      }));
      return a;
    };

    goog.getMsgWithFallback = function (a, b) {
      return a;
    };

    goog.exportSymbol = function (a, b, c) {
      goog.exportPath_(a, b, c);
    };

    goog.exportProperty = function (a, b, c) {
      a[b] = c;
    };

    goog.inherits = function (a, b) {
      function c() {}

      c.prototype = b.prototype;
      a.superClass_ = b.prototype;
      a.prototype = new c();
      a.prototype.constructor = a;

      a.base = function (a, c, f) {
        for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) {
          d[e - 2] = arguments[e];
        }

        return b.prototype[c].apply(a, d);
      };
    };

    goog.base = function (a, b, c) {
      var d = arguments.callee.caller;
      if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !d) throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");

      if ("undefined" !== typeof d.superClass_) {
        for (var e = Array(arguments.length - 1), f = 1; f < arguments.length; f++) {
          e[f - 1] = arguments[f];
        }

        return d.superClass_.constructor.apply(a, e);
      }

      if ("string" != typeof b && "symbol" != _typeof(b)) throw Error("method names provided to goog.base must be a string or a symbol");
      e = Array(arguments.length - 2);

      for (f = 2; f < arguments.length; f++) {
        e[f - 2] = arguments[f];
      }

      f = !1;

      for (var g = a.constructor.prototype; g; g = Object.getPrototypeOf(g)) {
        if (g[b] === d) f = !0;else if (f) return g[b].apply(a, e);
      }

      if (a[b] === d) return a.constructor.prototype[b].apply(a, e);
      throw Error("goog.base called from a method of one name to a method of a different name");
    };

    goog.scope = function (a) {
      if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
      a.call(goog.global);
    };

    goog.defineClass = function (a, b) {
      var c = b.constructor,
          d = b.statics;
      c && c != Object.prototype.constructor || (c = function c() {
        throw Error("cannot instantiate an interface (no constructor defined).");
      });
      c = goog.defineClass.createSealingConstructor_(c, a);
      a && goog.inherits(c, a);
      delete b.constructor;
      delete b.statics;
      goog.defineClass.applyProperties_(c.prototype, b);
      null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
      return c;
    };

    goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;

    goog.defineClass.createSealingConstructor_ = function (a, b) {
      if (!goog.defineClass.SEAL_CLASS_INSTANCES) return a;

      var c = !goog.defineClass.isUnsealable_(b),
          d = function d() {
        var b = a.apply(this, arguments) || this;
        b[goog.UID_PROPERTY_] = b[goog.UID_PROPERTY_];
        this.constructor === d && c && Object.seal instanceof Function && Object.seal(b);
        return b;
      };

      return d;
    };

    goog.defineClass.isUnsealable_ = function (a) {
      return a && a.prototype && a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
    };

    goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

    goog.defineClass.applyProperties_ = function (a, b) {
      for (var c in b) {
        Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
      }

      for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++) {
        c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
      }
    };

    goog.tagUnsealableClass = function (a) {
    };

    goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable";
    goog.TRUSTED_TYPES_POLICY_NAME = "";

    goog.identity_ = function (a) {
      return a;
    };

    goog.createTrustedTypesPolicy = function (a) {
      var b = null;
      if ("undefined" === typeof TrustedTypes || !TrustedTypes.createPolicy) return b;

      try {
        b = TrustedTypes.createPolicy(a, {
          createHTML: goog.identity_,
          createScript: goog.identity_,
          createScriptURL: goog.identity_,
          createURL: goog.identity_
        });
      } catch (c) {
        goog.logToConsole_(c.message);
      }

      return b;
    };

    goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null;
    goog.object = {};

    goog.object.is = function (a, b) {
      return a === b ? 0 !== a || 1 / a === 1 / b : a !== a && b !== b;
    };

    goog.object.forEach = function (a, b, c) {
      for (var d in a) {
        b.call(c, a[d], d, a);
      }
    };

    goog.object.filter = function (a, b, c) {
      var d = {},
          e;

      for (e in a) {
        b.call(c, a[e], e, a) && (d[e] = a[e]);
      }

      return d;
    };

    goog.object.map = function (a, b, c) {
      var d = {},
          e;

      for (e in a) {
        d[e] = b.call(c, a[e], e, a);
      }

      return d;
    };

    goog.object.some = function (a, b, c) {
      for (var d in a) {
        if (b.call(c, a[d], d, a)) return !0;
      }

      return !1;
    };

    goog.object.every = function (a, b, c) {
      for (var d in a) {
        if (!b.call(c, a[d], d, a)) return !1;
      }

      return !0;
    };

    goog.object.getCount = function (a) {
      var b = 0,
          c;

      for (c in a) {
        b++;
      }

      return b;
    };

    goog.object.getAnyKey = function (a) {
      for (var b in a) {
        return b;
      }
    };

    goog.object.getAnyValue = function (a) {
      for (var b in a) {
        return a[b];
      }
    };

    goog.object.contains = function (a, b) {
      return goog.object.containsValue(a, b);
    };

    goog.object.getValues = function (a) {
      var b = [],
          c = 0,
          d;

      for (d in a) {
        b[c++] = a[d];
      }

      return b;
    };

    goog.object.getKeys = function (a) {
      var b = [],
          c = 0,
          d;

      for (d in a) {
        b[c++] = d;
      }

      return b;
    };

    goog.object.getValueByKeys = function (a, b) {
      var c = goog.isArrayLike(b),
          d = c ? b : arguments;

      for (c = c ? 0 : 1; c < d.length; c++) {
        if (null == a) return;
        a = a[d[c]];
      }

      return a;
    };

    goog.object.containsKey = function (a, b) {
      return null !== a && b in a;
    };

    goog.object.containsValue = function (a, b) {
      for (var c in a) {
        if (a[c] == b) return !0;
      }

      return !1;
    };

    goog.object.findKey = function (a, b, c) {
      for (var d in a) {
        if (b.call(c, a[d], d, a)) return d;
      }
    };

    goog.object.findValue = function (a, b, c) {
      return (b = goog.object.findKey(a, b, c)) && a[b];
    };

    goog.object.isEmpty = function (a) {
      for (var b in a) {
        return !1;
      }

      return !0;
    };

    goog.object.clear = function (a) {
      for (var b in a) {
        delete a[b];
      }
    };

    goog.object.remove = function (a, b) {
      var c;
      (c = b in a) && delete a[b];
      return c;
    };

    goog.object.add = function (a, b, c) {
      if (null !== a && b in a) throw Error('The object already contains the key "' + b + '"');
      goog.object.set(a, b, c);
    };

    goog.object.get = function (a, b, c) {
      return null !== a && b in a ? a[b] : c;
    };

    goog.object.set = function (a, b, c) {
      a[b] = c;
    };

    goog.object.setIfUndefined = function (a, b, c) {
      return b in a ? a[b] : a[b] = c;
    };

    goog.object.setWithReturnValueIfNotSet = function (a, b, c) {
      if (b in a) return a[b];
      c = c();
      return a[b] = c;
    };

    goog.object.equals = function (a, b) {
      for (var c in a) {
        if (!(c in b) || a[c] !== b[c]) return !1;
      }

      for (var d in b) {
        if (!(d in a)) return !1;
      }

      return !0;
    };

    goog.object.clone = function (a) {
      var b = {},
          c;

      for (c in a) {
        b[c] = a[c];
      }

      return b;
    };

    goog.object.unsafeClone = function (a) {
      var b = goog.typeOf(a);

      if ("object" == b || "array" == b) {
        if (goog.isFunction(a.clone)) return a.clone();
        b = "array" == b ? [] : {};

        for (var c in a) {
          b[c] = goog.object.unsafeClone(a[c]);
        }

        return b;
      }

      return a;
    };

    goog.object.transpose = function (a) {
      var b = {},
          c;

      for (c in a) {
        b[a[c]] = c;
      }

      return b;
    };

    goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

    goog.object.extend = function (a, b) {
      for (var c, d, e = 1; e < arguments.length; e++) {
        d = arguments[e];

        for (c in d) {
          a[c] = d[c];
        }

        for (var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++) {
          c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
      }
    };

    goog.object.create = function (a) {
      var b = arguments.length;
      if (1 == b && goog.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
      if (b % 2) throw Error("Uneven number of arguments");

      for (var c = {}, d = 0; d < b; d += 2) {
        c[arguments[d]] = arguments[d + 1];
      }

      return c;
    };

    goog.object.createSet = function (a) {
      var b = arguments.length;
      if (1 == b && goog.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);

      for (var c = {}, d = 0; d < b; d++) {
        c[arguments[d]] = !0;
      }

      return c;
    };

    goog.object.createImmutableView = function (a) {
      var b = a;
      Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
      return b;
    };

    goog.object.isImmutableView = function (a) {
      return !!Object.isFrozen && Object.isFrozen(a);
    };

    goog.object.getAllPropertyNames = function (a, b, c) {
      if (!a) return [];
      if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(a);

      for (var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);) {
        for (var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++) {
          d[e[f]] = !0;
        }

        a = Object.getPrototypeOf(a);
      }

      return goog.object.getKeys(d);
    };

    goog.object.getSuperClass = function (a) {
      return (a = Object.getPrototypeOf(a.prototype)) && a.constructor;
    };

    goog.debug = {};

    goog.debug.Error = function (a) {
      if (Error.captureStackTrace) Error.captureStackTrace(this, goog.debug.Error);else {
        var b = Error().stack;
        b && (this.stack = b);
      }
      a && (this.message = String(a));
      this.reportErrorToServer = !0;
    };

    goog.inherits(goog.debug.Error, Error);
    goog.debug.Error.prototype.name = "CustomError";
    goog.dom = {};
    goog.dom.NodeType = {
      ELEMENT: 1,
      ATTRIBUTE: 2,
      TEXT: 3,
      CDATA_SECTION: 4,
      ENTITY_REFERENCE: 5,
      ENTITY: 6,
      PROCESSING_INSTRUCTION: 7,
      COMMENT: 8,
      DOCUMENT: 9,
      DOCUMENT_TYPE: 10,
      DOCUMENT_FRAGMENT: 11,
      NOTATION: 12
    };
    goog.asserts = {};
    goog.asserts.ENABLE_ASSERTS = goog.DEBUG;

    goog.asserts.AssertionError = function (a, b) {
      goog.debug.Error.call(this, goog.asserts.subs_(a, b));
      this.messagePattern = a;
    };

    goog.inherits(goog.asserts.AssertionError, goog.debug.Error);
    goog.asserts.AssertionError.prototype.name = "AssertionError";

    goog.asserts.DEFAULT_ERROR_HANDLER = function (a) {
      throw a;
    };

    goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;

    goog.asserts.subs_ = function (a, b) {
      a = a.split("%s");

      for (var c = "", d = a.length - 1, e = 0; e < d; e++) {
        c += a[e] + (e < b.length ? b[e] : "%s");
      }

      return c + a[d];
    };

    goog.asserts.doAssertFailure_ = function (a, b, c, d) {
      var e = "Assertion failed";

      if (c) {
        e += ": " + c;
        var f = d;
      } else a && (e += ": " + a, f = b);

      a = new goog.asserts.AssertionError("" + e, f || []);
      goog.asserts.errorHandler_(a);
    };

    goog.asserts.setErrorHandler = function (a) {
      goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
    };

    goog.asserts.assert = function (a, b, c) {
      goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.assertExists = function (a, b, c) {
      goog.asserts.ENABLE_ASSERTS && null == a && goog.asserts.doAssertFailure_("Expected to exist: %s.", [a], b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.fail = function (a, b) {
      goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1)));
    };

    goog.asserts.assertNumber = function (a, b, c) {
      goog.asserts.ENABLE_ASSERTS && !goog.isNumber(a) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.assertString = function (a, b, c) {
      goog.asserts.ENABLE_ASSERTS && !goog.isString(a) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.assertFunction = function (a, b, c) {
      goog.asserts.ENABLE_ASSERTS && !goog.isFunction(a) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.assertObject = function (a, b, c) {
      goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.assertArray = function (a, b, c) {
      goog.asserts.ENABLE_ASSERTS && !goog.isArray(a) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.assertBoolean = function (a, b, c) {
      goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(a) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.assertElement = function (a, b, c) {
      !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.assertInstanceof = function (a, b, c, d) {
      !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(b), goog.asserts.getType_(a)], c, Array.prototype.slice.call(arguments, 3));
      return a;
    };

    goog.asserts.assertFinite = function (a, b, c) {
      !goog.asserts.ENABLE_ASSERTS || "number" == typeof a && isFinite(a) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [a], b, Array.prototype.slice.call(arguments, 2));
      return a;
    };

    goog.asserts.assertObjectPrototypeIsIntact = function () {
      for (var a in Object.prototype) {
        goog.asserts.fail(a + " should not be enumerable in Object.prototype.");
      }
    };

    goog.asserts.getType_ = function (a) {
      return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : _typeof(a);
    };

    var jspb = {
      BinaryConstants: {},
      ConstBinaryMessage: function ConstBinaryMessage() {},
      BinaryMessage: function BinaryMessage() {}
    };
    jspb.BinaryConstants.FieldType = {
      INVALID: -1,
      DOUBLE: 1,
      FLOAT: 2,
      INT64: 3,
      UINT64: 4,
      INT32: 5,
      FIXED64: 6,
      FIXED32: 7,
      BOOL: 8,
      STRING: 9,
      GROUP: 10,
      MESSAGE: 11,
      BYTES: 12,
      UINT32: 13,
      ENUM: 14,
      SFIXED32: 15,
      SFIXED64: 16,
      SINT32: 17,
      SINT64: 18,
      FHASH64: 30,
      VHASH64: 31
    };
    jspb.BinaryConstants.WireType = {
      INVALID: -1,
      VARINT: 0,
      FIXED64: 1,
      DELIMITED: 2,
      START_GROUP: 3,
      END_GROUP: 4,
      FIXED32: 5
    };

    jspb.BinaryConstants.FieldTypeToWireType = function (a) {
      var b = jspb.BinaryConstants.FieldType,
          c = jspb.BinaryConstants.WireType;

      switch (a) {
        case b.INT32:
        case b.INT64:
        case b.UINT32:
        case b.UINT64:
        case b.SINT32:
        case b.SINT64:
        case b.BOOL:
        case b.ENUM:
        case b.VHASH64:
          return c.VARINT;

        case b.DOUBLE:
        case b.FIXED64:
        case b.SFIXED64:
        case b.FHASH64:
          return c.FIXED64;

        case b.STRING:
        case b.MESSAGE:
        case b.BYTES:
          return c.DELIMITED;

        case b.FLOAT:
        case b.FIXED32:
        case b.SFIXED32:
          return c.FIXED32;

        default:
          return c.INVALID;
      }
    };

    jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1;
    jspb.BinaryConstants.FLOAT32_EPS = 1.401298464324817E-45;
    jspb.BinaryConstants.FLOAT32_MIN = 1.1754943508222875E-38;
    jspb.BinaryConstants.FLOAT32_MAX = 3.4028234663852886E38;
    jspb.BinaryConstants.FLOAT64_EPS = 4.9E-324;
    jspb.BinaryConstants.FLOAT64_MIN = 2.2250738585072014E-308;
    jspb.BinaryConstants.FLOAT64_MAX = 1.7976931348623157E308;
    jspb.BinaryConstants.TWO_TO_20 = 1048576;
    jspb.BinaryConstants.TWO_TO_23 = 8388608;
    jspb.BinaryConstants.TWO_TO_31 = 2147483648;
    jspb.BinaryConstants.TWO_TO_32 = 4294967296;
    jspb.BinaryConstants.TWO_TO_52 = 4503599627370496;
    jspb.BinaryConstants.TWO_TO_63 = 0x7fffffffffffffff;
    jspb.BinaryConstants.TWO_TO_64 = 1.8446744073709552E19;
    jspb.BinaryConstants.ZERO_HASH = "\x00\x00\x00\x00\x00\x00\x00\x00";
    goog.array = {};
    goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
    goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;

    goog.array.peek = function (a) {
      return a[a.length - 1];
    };

    goog.array.last = goog.array.peek;
    goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function (a, b, c) {
      goog.asserts.assert(null != a.length);
      return Array.prototype.indexOf.call(a, b, c);
    } : function (a, b, c) {
      c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
      if (goog.isString(a)) return goog.isString(b) && 1 == b.length ? a.indexOf(b, c) : -1;

      for (; c < a.length; c++) {
        if (c in a && a[c] === b) return c;
      }

      return -1;
    };
    goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function (a, b, c) {
      goog.asserts.assert(null != a.length);
      return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
    } : function (a, b, c) {
      c = null == c ? a.length - 1 : c;
      0 > c && (c = Math.max(0, a.length + c));
      if (goog.isString(a)) return goog.isString(b) && 1 == b.length ? a.lastIndexOf(b, c) : -1;

      for (; 0 <= c; c--) {
        if (c in a && a[c] === b) return c;
      }

      return -1;
    };
    goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function (a, b, c) {
      goog.asserts.assert(null != a.length);
      Array.prototype.forEach.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
        f in e && b.call(c, e[f], f, a);
      }
    };

    goog.array.forEachRight = function (a, b, c) {
      var d = a.length,
          e = goog.isString(a) ? a.split("") : a;

      for (--d; 0 <= d; --d) {
        d in e && b.call(c, e[d], d, a);
      }
    };

    goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function (a, b, c) {
      goog.asserts.assert(null != a.length);
      return Array.prototype.filter.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = [], f = 0, g = goog.isString(a) ? a.split("") : a, h = 0; h < d; h++) {
        if (h in g) {
          var k = g[h];
          b.call(c, k, h, a) && (e[f++] = k);
        }
      }

      return e;
    };
    goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function (a, b, c) {
      goog.asserts.assert(null != a.length);
      return Array.prototype.map.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = Array(d), f = goog.isString(a) ? a.split("") : a, g = 0; g < d; g++) {
        g in f && (e[g] = b.call(c, f[g], g, a));
      }

      return e;
    };
    goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function (a, b, c, d) {
      goog.asserts.assert(null != a.length);
      d && (b = goog.bind(b, d));
      return Array.prototype.reduce.call(a, b, c);
    } : function (a, b, c, d) {
      var e = c;
      goog.array.forEach(a, function (c, g) {
        e = b.call(d, e, c, g, a);
      });
      return e;
    };
    goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function (a, b, c, d) {
      goog.asserts.assert(null != a.length);
      goog.asserts.assert(null != b);
      d && (b = goog.bind(b, d));
      return Array.prototype.reduceRight.call(a, b, c);
    } : function (a, b, c, d) {
      var e = c;
      goog.array.forEachRight(a, function (c, g) {
        e = b.call(d, e, c, g, a);
      });
      return e;
    };
    goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function (a, b, c) {
      goog.asserts.assert(null != a.length);
      return Array.prototype.some.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
        if (f in e && b.call(c, e[f], f, a)) return !0;
      }

      return !1;
    };
    goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function (a, b, c) {
      goog.asserts.assert(null != a.length);
      return Array.prototype.every.call(a, b, c);
    } : function (a, b, c) {
      for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
        if (f in e && !b.call(c, e[f], f, a)) return !1;
      }

      return !0;
    };

    goog.array.count = function (a, b, c) {
      var d = 0;
      goog.array.forEach(a, function (a, f, g) {
        b.call(c, a, f, g) && ++d;
      }, c);
      return d;
    };

    goog.array.find = function (a, b, c) {
      b = goog.array.findIndex(a, b, c);
      return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
    };

    goog.array.findIndex = function (a, b, c) {
      for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
        if (f in e && b.call(c, e[f], f, a)) return f;
      }

      return -1;
    };

    goog.array.findRight = function (a, b, c) {
      b = goog.array.findIndexRight(a, b, c);
      return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
    };

    goog.array.findIndexRight = function (a, b, c) {
      var d = a.length,
          e = goog.isString(a) ? a.split("") : a;

      for (--d; 0 <= d; d--) {
        if (d in e && b.call(c, e[d], d, a)) return d;
      }

      return -1;
    };

    goog.array.contains = function (a, b) {
      return 0 <= goog.array.indexOf(a, b);
    };

    goog.array.isEmpty = function (a) {
      return 0 == a.length;
    };

    goog.array.clear = function (a) {
      if (!goog.isArray(a)) for (var b = a.length - 1; 0 <= b; b--) {
        delete a[b];
      }
      a.length = 0;
    };

    goog.array.insert = function (a, b) {
      goog.array.contains(a, b) || a.push(b);
    };

    goog.array.insertAt = function (a, b, c) {
      goog.array.splice(a, c, 0, b);
    };

    goog.array.insertArrayAt = function (a, b, c) {
      goog.partial(goog.array.splice, a, c, 0).apply(null, b);
    };

    goog.array.insertBefore = function (a, b, c) {
      var d;
      2 == arguments.length || 0 > (d = goog.array.indexOf(a, c)) ? a.push(b) : goog.array.insertAt(a, b, d);
    };

    goog.array.remove = function (a, b) {
      b = goog.array.indexOf(a, b);
      var c;
      (c = 0 <= b) && goog.array.removeAt(a, b);
      return c;
    };

    goog.array.removeLast = function (a, b) {
      b = goog.array.lastIndexOf(a, b);
      return 0 <= b ? (goog.array.removeAt(a, b), !0) : !1;
    };

    goog.array.removeAt = function (a, b) {
      goog.asserts.assert(null != a.length);
      return 1 == Array.prototype.splice.call(a, b, 1).length;
    };

    goog.array.removeIf = function (a, b, c) {
      b = goog.array.findIndex(a, b, c);
      return 0 <= b ? (goog.array.removeAt(a, b), !0) : !1;
    };

    goog.array.removeAllIf = function (a, b, c) {
      var d = 0;
      goog.array.forEachRight(a, function (e, f) {
        b.call(c, e, f, a) && goog.array.removeAt(a, f) && d++;
      });
      return d;
    };

    goog.array.concat = function (a) {
      return Array.prototype.concat.apply([], arguments);
    };

    goog.array.join = function (a) {
      return Array.prototype.concat.apply([], arguments);
    };

    goog.array.toArray = function (a) {
      var b = a.length;

      if (0 < b) {
        for (var c = Array(b), d = 0; d < b; d++) {
          c[d] = a[d];
        }

        return c;
      }

      return [];
    };

    goog.array.clone = goog.array.toArray;

    goog.array.extend = function (a, b) {
      for (var c = 1; c < arguments.length; c++) {
        var d = arguments[c];

        if (goog.isArrayLike(d)) {
          var e = a.length || 0,
              f = d.length || 0;
          a.length = e + f;

          for (var g = 0; g < f; g++) {
            a[e + g] = d[g];
          }
        } else a.push(d);
      }
    };

    goog.array.splice = function (a, b, c, d) {
      goog.asserts.assert(null != a.length);
      return Array.prototype.splice.apply(a, goog.array.slice(arguments, 1));
    };

    goog.array.slice = function (a, b, c) {
      goog.asserts.assert(null != a.length);
      return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
    };

    goog.array.removeDuplicates = function (a, b, c) {
      b = b || a;

      var d = function d(a) {
        return goog.isObject(a) ? "o" + goog.getUid(a) : _typeof(a).charAt(0) + a;
      };

      c = c || d;
      d = {};

      for (var e = 0, f = 0; f < a.length;) {
        var g = a[f++],
            h = c(g);
        Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
      }

      b.length = e;
    };

    goog.array.binarySearch = function (a, b, c) {
      return goog.array.binarySearch_(a, c || goog.array.defaultCompare, !1, b);
    };

    goog.array.binarySelect = function (a, b, c) {
      return goog.array.binarySearch_(a, b, !0, void 0, c);
    };

    goog.array.binarySearch_ = function (a, b, c, d, e) {
      for (var f = 0, g = a.length, h; f < g;) {
        var k = f + g >> 1;
        var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
        0 < l ? f = k + 1 : (g = k, h = !l);
      }

      return h ? f : ~f;
    };

    goog.array.sort = function (a, b) {
      a.sort(b || goog.array.defaultCompare);
    };

    goog.array.stableSort = function (a, b) {
      for (var c = Array(a.length), d = 0; d < a.length; d++) {
        c[d] = {
          index: d,
          value: a[d]
        };
      }

      var e = b || goog.array.defaultCompare;
      goog.array.sort(c, function (a, b) {
        return e(a.value, b.value) || a.index - b.index;
      });

      for (d = 0; d < a.length; d++) {
        a[d] = c[d].value;
      }
    };

    goog.array.sortByKey = function (a, b, c) {
      var d = c || goog.array.defaultCompare;
      goog.array.sort(a, function (a, c) {
        return d(b(a), b(c));
      });
    };

    goog.array.sortObjectsByKey = function (a, b, c) {
      goog.array.sortByKey(a, function (a) {
        return a[b];
      }, c);
    };

    goog.array.isSorted = function (a, b, c) {
      b = b || goog.array.defaultCompare;

      for (var d = 1; d < a.length; d++) {
        var e = b(a[d - 1], a[d]);
        if (0 < e || 0 == e && c) return !1;
      }

      return !0;
    };

    goog.array.equals = function (a, b, c) {
      if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length) return !1;
      var d = a.length;
      c = c || goog.array.defaultCompareEquality;

      for (var e = 0; e < d; e++) {
        if (!c(a[e], b[e])) return !1;
      }

      return !0;
    };

    goog.array.compare3 = function (a, b, c) {
      c = c || goog.array.defaultCompare;

      for (var d = Math.min(a.length, b.length), e = 0; e < d; e++) {
        var f = c(a[e], b[e]);
        if (0 != f) return f;
      }

      return goog.array.defaultCompare(a.length, b.length);
    };

    goog.array.defaultCompare = function (a, b) {
      return a > b ? 1 : a < b ? -1 : 0;
    };

    goog.array.inverseDefaultCompare = function (a, b) {
      return -goog.array.defaultCompare(a, b);
    };

    goog.array.defaultCompareEquality = function (a, b) {
      return a === b;
    };

    goog.array.binaryInsert = function (a, b, c) {
      c = goog.array.binarySearch(a, b, c);
      return 0 > c ? (goog.array.insertAt(a, b, -(c + 1)), !0) : !1;
    };

    goog.array.binaryRemove = function (a, b, c) {
      b = goog.array.binarySearch(a, b, c);
      return 0 <= b ? goog.array.removeAt(a, b) : !1;
    };

    goog.array.bucket = function (a, b, c) {
      for (var d = {}, e = 0; e < a.length; e++) {
        var f = a[e],
            g = b.call(c, f, e, a);
        goog.isDef(g) && (d[g] || (d[g] = [])).push(f);
      }

      return d;
    };

    goog.array.toObject = function (a, b, c) {
      var d = {};
      goog.array.forEach(a, function (e, f) {
        d[b.call(c, e, f, a)] = e;
      });
      return d;
    };

    goog.array.range = function (a, b, c) {
      var d = [],
          e = 0,
          f = a;
      c = c || 1;
      void 0 !== b && (e = a, f = b);
      if (0 > c * (f - e)) return [];
      if (0 < c) for (a = e; a < f; a += c) {
        d.push(a);
      } else for (a = e; a > f; a += c) {
        d.push(a);
      }
      return d;
    };

    goog.array.repeat = function (a, b) {
      for (var c = [], d = 0; d < b; d++) {
        c[d] = a;
      }

      return c;
    };

    goog.array.flatten = function (a) {
      for (var b = [], c = 0; c < arguments.length; c++) {
        var d = arguments[c];
        if (goog.isArray(d)) for (var e = 0; e < d.length; e += 8192) {
          var f = goog.array.slice(d, e, e + 8192);
          f = goog.array.flatten.apply(null, f);

          for (var g = 0; g < f.length; g++) {
            b.push(f[g]);
          }
        } else b.push(d);
      }

      return b;
    };

    goog.array.rotate = function (a, b) {
      goog.asserts.assert(null != a.length);
      a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
      return a;
    };

    goog.array.moveItem = function (a, b, c) {
      goog.asserts.assert(0 <= b && b < a.length);
      goog.asserts.assert(0 <= c && c < a.length);
      b = Array.prototype.splice.call(a, b, 1);
      Array.prototype.splice.call(a, c, 0, b[0]);
    };

    goog.array.zip = function (a) {
      if (!arguments.length) return [];

      for (var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++) {
        arguments[d].length < c && (c = arguments[d].length);
      }

      for (d = 0; d < c; d++) {
        for (var e = [], f = 0; f < arguments.length; f++) {
          e.push(arguments[f][d]);
        }

        b.push(e);
      }

      return b;
    };

    goog.array.shuffle = function (a, b) {
      b = b || Math.random;

      for (var c = a.length - 1; 0 < c; c--) {
        var d = Math.floor(b() * (c + 1)),
            e = a[c];
        a[c] = a[d];
        a[d] = e;
      }
    };

    goog.array.copyByIndex = function (a, b) {
      var c = [];
      goog.array.forEach(b, function (b) {
        c.push(a[b]);
      });
      return c;
    };

    goog.array.concatMap = function (a, b, c) {
      return goog.array.concat.apply([], goog.array.map(a, b, c));
    };

    goog.crypt = {};

    goog.crypt.stringToByteArray = function (a) {
      for (var b = [], c = 0, d = 0; d < a.length; d++) {
        var e = a.charCodeAt(d);
        255 < e && (b[c++] = e & 255, e >>= 8);
        b[c++] = e;
      }

      return b;
    };

    goog.crypt.byteArrayToString = function (a) {
      if (8192 >= a.length) return String.fromCharCode.apply(null, a);

      for (var b = "", c = 0; c < a.length; c += 8192) {
        var d = goog.array.slice(a, c, c + 8192);
        b += String.fromCharCode.apply(null, d);
      }

      return b;
    };

    goog.crypt.byteArrayToHex = function (a, b) {
      return goog.array.map(a, function (a) {
        a = a.toString(16);
        return 1 < a.length ? a : "0" + a;
      }).join(b || "");
    };

    goog.crypt.hexToByteArray = function (a) {
      goog.asserts.assert(0 == a.length % 2, "Key string length must be multiple of 2");

      for (var b = [], c = 0; c < a.length; c += 2) {
        b.push(parseInt(a.substring(c, c + 2), 16));
      }

      return b;
    };

    goog.crypt.stringToUtf8ByteArray = function (a) {
      for (var b = [], c = 0, d = 0; d < a.length; d++) {
        var e = a.charCodeAt(d);
        128 > e ? b[c++] = e : (2048 > e ? b[c++] = e >> 6 | 192 : (55296 == (e & 64512) && d + 1 < a.length && 56320 == (a.charCodeAt(d + 1) & 64512) ? (e = 65536 + ((e & 1023) << 10) + (a.charCodeAt(++d) & 1023), b[c++] = e >> 18 | 240, b[c++] = e >> 12 & 63 | 128) : b[c++] = e >> 12 | 224, b[c++] = e >> 6 & 63 | 128), b[c++] = e & 63 | 128);
      }

      return b;
    };

    goog.crypt.utf8ByteArrayToString = function (a) {
      for (var b = [], c = 0, d = 0; c < a.length;) {
        var e = a[c++];
        if (128 > e) b[d++] = String.fromCharCode(e);else if (191 < e && 224 > e) {
          var f = a[c++];
          b[d++] = String.fromCharCode((e & 31) << 6 | f & 63);
        } else if (239 < e && 365 > e) {
          f = a[c++];
          var g = a[c++],
              h = a[c++];
          e = ((e & 7) << 18 | (f & 63) << 12 | (g & 63) << 6 | h & 63) - 65536;
          b[d++] = String.fromCharCode(55296 + (e >> 10));
          b[d++] = String.fromCharCode(56320 + (e & 1023));
        } else f = a[c++], g = a[c++], b[d++] = String.fromCharCode((e & 15) << 12 | (f & 63) << 6 | g & 63);
      }

      return b.join("");
    };

    goog.crypt.xorByteArray = function (a, b) {
      goog.asserts.assert(a.length == b.length, "XOR array lengths must match");

      for (var c = [], d = 0; d < a.length; d++) {
        c.push(a[d] ^ b[d]);
      }

      return c;
    };

    goog.dom.asserts = {};

    goog.dom.asserts.assertIsLocation = function (a) {
      if (goog.asserts.ENABLE_ASSERTS) {
        var b = goog.dom.asserts.getWindow_(a);
        b && (!a || !(a instanceof b.Location) && a instanceof b.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(a));
      }

      return a;
    };

    goog.dom.asserts.assertIsElementType_ = function (a, b) {
      if (goog.asserts.ENABLE_ASSERTS) {
        var c = goog.dom.asserts.getWindow_(a);
        c && "undefined" != typeof c[b] && (a && (a instanceof c[b] || !(a instanceof c.Location || a instanceof c.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, goog.dom.asserts.debugStringForType_(a)));
      }

      return a;
    };

    goog.dom.asserts.assertIsHTMLAnchorElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLAnchorElement");
    };

    goog.dom.asserts.assertIsHTMLButtonElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLButtonElement");
    };

    goog.dom.asserts.assertIsHTMLLinkElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLLinkElement");
    };

    goog.dom.asserts.assertIsHTMLImageElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLImageElement");
    };

    goog.dom.asserts.assertIsHTMLAudioElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLAudioElement");
    };

    goog.dom.asserts.assertIsHTMLVideoElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLVideoElement");
    };

    goog.dom.asserts.assertIsHTMLInputElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLInputElement");
    };

    goog.dom.asserts.assertIsHTMLTextAreaElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLTextAreaElement");
    };

    goog.dom.asserts.assertIsHTMLCanvasElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLCanvasElement");
    };

    goog.dom.asserts.assertIsHTMLEmbedElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLEmbedElement");
    };

    goog.dom.asserts.assertIsHTMLFormElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLFormElement");
    };

    goog.dom.asserts.assertIsHTMLFrameElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLFrameElement");
    };

    goog.dom.asserts.assertIsHTMLIFrameElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLIFrameElement");
    };

    goog.dom.asserts.assertIsHTMLObjectElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLObjectElement");
    };

    goog.dom.asserts.assertIsHTMLScriptElement = function (a) {
      return goog.dom.asserts.assertIsElementType_(a, "HTMLScriptElement");
    };

    goog.dom.asserts.debugStringForType_ = function (a) {
      if (goog.isObject(a)) try {
        return a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
      } catch (b) {
        return "<object could not be stringified>";
      } else return void 0 === a ? "undefined" : null === a ? "null" : _typeof(a);
    };

    goog.dom.asserts.getWindow_ = function (a) {
      try {
        var b = a && a.ownerDocument,
            c = b && (b.defaultView || b.parentWindow);
        c = c || goog.global;
        if (c.Element && c.Location) return c;
      } catch (d) {}

      return null;
    };

    goog.functions = {};

    goog.functions.constant = function (a) {
      return function () {
        return a;
      };
    };

    goog.functions.FALSE = function () {
      return !1;
    };

    goog.functions.TRUE = function () {
      return !0;
    };

    goog.functions.NULL = function () {
      return null;
    };

    goog.functions.identity = function (a, b) {
      return a;
    };

    goog.functions.error = function (a) {
      return function () {
        throw Error(a);
      };
    };

    goog.functions.fail = function (a) {
      return function () {
        throw a;
      };
    };

    goog.functions.lock = function (a, b) {
      b = b || 0;
      return function () {
        return a.apply(this, Array.prototype.slice.call(arguments, 0, b));
      };
    };

    goog.functions.nth = function (a) {
      return function () {
        return arguments[a];
      };
    };

    goog.functions.partialRight = function (a, b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return function () {
        var b = Array.prototype.slice.call(arguments);
        b.push.apply(b, c);
        return a.apply(this, b);
      };
    };

    goog.functions.withReturnValue = function (a, b) {
      return goog.functions.sequence(a, goog.functions.constant(b));
    };

    goog.functions.equalTo = function (a, b) {
      return function (c) {
        return b ? a == c : a === c;
      };
    };

    goog.functions.compose = function (a, b) {
      var c = arguments,
          d = c.length;
      return function () {
        var a;
        d && (a = c[d - 1].apply(this, arguments));

        for (var b = d - 2; 0 <= b; b--) {
          a = c[b].call(this, a);
        }

        return a;
      };
    };

    goog.functions.sequence = function (a) {
      var b = arguments,
          c = b.length;
      return function () {
        for (var a, e = 0; e < c; e++) {
          a = b[e].apply(this, arguments);
        }

        return a;
      };
    };

    goog.functions.and = function (a) {
      var b = arguments,
          c = b.length;
      return function () {
        for (var a = 0; a < c; a++) {
          if (!b[a].apply(this, arguments)) return !1;
        }

        return !0;
      };
    };

    goog.functions.or = function (a) {
      var b = arguments,
          c = b.length;
      return function () {
        for (var a = 0; a < c; a++) {
          if (b[a].apply(this, arguments)) return !0;
        }

        return !1;
      };
    };

    goog.functions.not = function (a) {
      return function () {
        return !a.apply(this, arguments);
      };
    };

    goog.functions.create = function (a, b) {
      var c = function c() {};

      c.prototype = a.prototype;
      c = new c();
      a.apply(c, Array.prototype.slice.call(arguments, 1));
      return c;
    };

    goog.functions.CACHE_RETURN_VALUE = !0;

    goog.functions.cacheReturnValue = function (a) {
      var b = !1,
          c;
      return function () {
        if (!goog.functions.CACHE_RETURN_VALUE) return a();
        b || (c = a(), b = !0);
        return c;
      };
    };

    goog.functions.once = function (a) {
      var b = a;
      return function () {
        if (b) {
          var a = b;
          b = null;
          a();
        }
      };
    };

    goog.functions.debounce = function (a, b, c) {
      var d = 0;
      return function (e) {
        goog.global.clearTimeout(d);
        var f = arguments;
        d = goog.global.setTimeout(function () {
          a.apply(c, f);
        }, b);
      };
    };

    goog.functions.throttle = function (a, b, c) {
      var d = 0,
          e = !1,
          f = [],
          g = function g() {
        d = 0;
        e && (e = !1, h());
      },
          h = function h() {
        d = goog.global.setTimeout(g, b);
        a.apply(c, f);
      };

      return function (a) {
        f = arguments;
        d ? e = !0 : h();
      };
    };

    goog.functions.rateLimit = function (a, b, c) {
      var d = 0,
          e = function e() {
        d = 0;
      };

      return function (f) {
        d || (d = goog.global.setTimeout(e, b), a.apply(c, arguments));
      };
    };

    goog.dom.HtmlElement = function () {};

    goog.dom.TagName = function (a) {
      this.tagName_ = a;
    };

    goog.dom.TagName.prototype.toString = function () {
      return this.tagName_;
    };

    goog.dom.TagName.A = new goog.dom.TagName("A");
    goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR");
    goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM");
    goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS");
    goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET");
    goog.dom.TagName.AREA = new goog.dom.TagName("AREA");
    goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE");
    goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE");
    goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO");
    goog.dom.TagName.B = new goog.dom.TagName("B");
    goog.dom.TagName.BASE = new goog.dom.TagName("BASE");
    goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT");
    goog.dom.TagName.BDI = new goog.dom.TagName("BDI");
    goog.dom.TagName.BDO = new goog.dom.TagName("BDO");
    goog.dom.TagName.BIG = new goog.dom.TagName("BIG");
    goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE");
    goog.dom.TagName.BODY = new goog.dom.TagName("BODY");
    goog.dom.TagName.BR = new goog.dom.TagName("BR");
    goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON");
    goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS");
    goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION");
    goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER");
    goog.dom.TagName.CITE = new goog.dom.TagName("CITE");
    goog.dom.TagName.CODE = new goog.dom.TagName("CODE");
    goog.dom.TagName.COL = new goog.dom.TagName("COL");
    goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP");
    goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND");
    goog.dom.TagName.DATA = new goog.dom.TagName("DATA");
    goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST");
    goog.dom.TagName.DD = new goog.dom.TagName("DD");
    goog.dom.TagName.DEL = new goog.dom.TagName("DEL");
    goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS");
    goog.dom.TagName.DFN = new goog.dom.TagName("DFN");
    goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG");
    goog.dom.TagName.DIR = new goog.dom.TagName("DIR");
    goog.dom.TagName.DIV = new goog.dom.TagName("DIV");
    goog.dom.TagName.DL = new goog.dom.TagName("DL");
    goog.dom.TagName.DT = new goog.dom.TagName("DT");
    goog.dom.TagName.EM = new goog.dom.TagName("EM");
    goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED");
    goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET");
    goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION");
    goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE");
    goog.dom.TagName.FONT = new goog.dom.TagName("FONT");
    goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER");
    goog.dom.TagName.FORM = new goog.dom.TagName("FORM");
    goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME");
    goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET");
    goog.dom.TagName.H1 = new goog.dom.TagName("H1");
    goog.dom.TagName.H2 = new goog.dom.TagName("H2");
    goog.dom.TagName.H3 = new goog.dom.TagName("H3");
    goog.dom.TagName.H4 = new goog.dom.TagName("H4");
    goog.dom.TagName.H5 = new goog.dom.TagName("H5");
    goog.dom.TagName.H6 = new goog.dom.TagName("H6");
    goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD");
    goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER");
    goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP");
    goog.dom.TagName.HR = new goog.dom.TagName("HR");
    goog.dom.TagName.HTML = new goog.dom.TagName("HTML");
    goog.dom.TagName.I = new goog.dom.TagName("I");
    goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME");
    goog.dom.TagName.IMG = new goog.dom.TagName("IMG");
    goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT");
    goog.dom.TagName.INS = new goog.dom.TagName("INS");
    goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX");
    goog.dom.TagName.KBD = new goog.dom.TagName("KBD");
    goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN");
    goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL");
    goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND");
    goog.dom.TagName.LI = new goog.dom.TagName("LI");
    goog.dom.TagName.LINK = new goog.dom.TagName("LINK");
    goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN");
    goog.dom.TagName.MAP = new goog.dom.TagName("MAP");
    goog.dom.TagName.MARK = new goog.dom.TagName("MARK");
    goog.dom.TagName.MATH = new goog.dom.TagName("MATH");
    goog.dom.TagName.MENU = new goog.dom.TagName("MENU");
    goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM");
    goog.dom.TagName.META = new goog.dom.TagName("META");
    goog.dom.TagName.METER = new goog.dom.TagName("METER");
    goog.dom.TagName.NAV = new goog.dom.TagName("NAV");
    goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES");
    goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT");
    goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT");
    goog.dom.TagName.OL = new goog.dom.TagName("OL");
    goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP");
    goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION");
    goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT");
    goog.dom.TagName.P = new goog.dom.TagName("P");
    goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM");
    goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE");
    goog.dom.TagName.PRE = new goog.dom.TagName("PRE");
    goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS");
    goog.dom.TagName.Q = new goog.dom.TagName("Q");
    goog.dom.TagName.RP = new goog.dom.TagName("RP");
    goog.dom.TagName.RT = new goog.dom.TagName("RT");
    goog.dom.TagName.RTC = new goog.dom.TagName("RTC");
    goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY");
    goog.dom.TagName.S = new goog.dom.TagName("S");
    goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP");
    goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT");
    goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION");
    goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT");
    goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL");
    goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE");
    goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN");
    goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE");
    goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG");
    goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE");
    goog.dom.TagName.SUB = new goog.dom.TagName("SUB");
    goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY");
    goog.dom.TagName.SUP = new goog.dom.TagName("SUP");
    goog.dom.TagName.SVG = new goog.dom.TagName("SVG");
    goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE");
    goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY");
    goog.dom.TagName.TD = new goog.dom.TagName("TD");
    goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE");
    goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA");
    goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT");
    goog.dom.TagName.TH = new goog.dom.TagName("TH");
    goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD");
    goog.dom.TagName.TIME = new goog.dom.TagName("TIME");
    goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE");
    goog.dom.TagName.TR = new goog.dom.TagName("TR");
    goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK");
    goog.dom.TagName.TT = new goog.dom.TagName("TT");
    goog.dom.TagName.U = new goog.dom.TagName("U");
    goog.dom.TagName.UL = new goog.dom.TagName("UL");
    goog.dom.TagName.VAR = new goog.dom.TagName("VAR");
    goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO");
    goog.dom.TagName.WBR = new goog.dom.TagName("WBR");
    goog.dom.tags = {};
    goog.dom.tags.VOID_TAGS_ = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      command: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
    };

    goog.dom.tags.isVoidTag = function (a) {
      return !0 === goog.dom.tags.VOID_TAGS_[a];
    };

    goog.html = {};
    goog.html.trustedtypes = {};
    goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null;
    goog.string = {};

    goog.string.TypedString = function () {};

    goog.string.Const = function (a, b) {
      this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
      this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
    };

    goog.string.Const.prototype.implementsGoogStringTypedString = !0;

    goog.string.Const.prototype.getTypedStringValue = function () {
      return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
    };

    goog.string.Const.prototype.toString = function () {
      return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
    };

    goog.string.Const.unwrap = function (a) {
      if (a instanceof goog.string.Const && a.constructor === goog.string.Const && a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_) return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
      goog.asserts.fail("expected object of type Const, got '" + a + "'");
      return "type_error:Const";
    };

    goog.string.Const.from = function (a) {
      return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a);
    };

    goog.string.Const.TYPE_MARKER_ = {};
    goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {};
    goog.string.Const.EMPTY = goog.string.Const.from("");

    goog.html.SafeScript = function () {
      this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "";
      this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    };

    goog.html.SafeScript.prototype.implementsGoogStringTypedString = !0;
    goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};

    goog.html.SafeScript.fromConstant = function (a) {
      a = goog.string.Const.unwrap(a);
      return 0 === a.length ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeScript.fromConstantAndArgs = function (a, b) {
      for (var c = [], d = 1; d < arguments.length; d++) {
        c.push(goog.html.SafeScript.stringify_(arguments[d]));
      }

      return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(a) + ")(" + c.join(", ") + ");");
    };

    goog.html.SafeScript.fromJson = function (a) {
      return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(a));
    };

    goog.html.SafeScript.prototype.getTypedStringValue = function () {
      return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
    };

    goog.DEBUG && (goog.html.SafeScript.prototype.toString = function () {
      return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
    });

    goog.html.SafeScript.unwrap = function (a) {
      return goog.html.SafeScript.unwrapTrustedScript(a).toString();
    };

    goog.html.SafeScript.unwrapTrustedScript = function (a) {
      if (a instanceof goog.html.SafeScript && a.constructor === goog.html.SafeScript && a.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;
      goog.asserts.fail("expected object of type SafeScript, got '" + a + "' of type " + goog.typeOf(a));
      return "type_error:SafeScript";
    };

    goog.html.SafeScript.stringify_ = function (a) {
      return JSON.stringify(a).replace(/</g, "\\x3c");
    };

    goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function (a) {
      return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(a);
    };

    goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (a) {
      this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(a) : a;
      return this;
    };

    goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
    goog.fs = {};
    goog.fs.url = {};

    goog.fs.url.createObjectUrl = function (a) {
      return goog.fs.url.getUrlObject_().createObjectURL(a);
    };

    goog.fs.url.revokeObjectUrl = function (a) {
      goog.fs.url.getUrlObject_().revokeObjectURL(a);
    };

    goog.fs.url.getUrlObject_ = function () {
      var a = goog.fs.url.findUrlObject_();
      if (null != a) return a;
      throw Error("This browser doesn't seem to support blob URLs");
    };

    goog.fs.url.findUrlObject_ = function () {
      return goog.isDef(goog.global.URL) && goog.isDef(goog.global.URL.createObjectURL) ? goog.global.URL : goog.isDef(goog.global.webkitURL) && goog.isDef(goog.global.webkitURL.createObjectURL) ? goog.global.webkitURL : goog.isDef(goog.global.createObjectURL) ? goog.global : null;
    };

    goog.fs.url.browserSupportsObjectUrls = function () {
      return null != goog.fs.url.findUrlObject_();
    };

    goog.i18n = {};
    goog.i18n.bidi = {};
    goog.i18n.bidi.FORCE_RTL = !1;
    goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || "nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase());
    goog.i18n.bidi.Format = {
      LRE: "\u202A",
      RLE: "\u202B",
      PDF: "\u202C",
      LRM: "\u200E",
      RLM: "\u200F"
    };
    goog.i18n.bidi.Dir = {
      LTR: 1,
      RTL: -1,
      NEUTRAL: 0
    };
    goog.i18n.bidi.RIGHT = "right";
    goog.i18n.bidi.LEFT = "left";
    goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT;
    goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT;

    goog.i18n.bidi.toDir = function (a, b) {
      return "number" == typeof a ? 0 < a ? goog.i18n.bidi.Dir.LTR : 0 > a ? goog.i18n.bidi.Dir.RTL : b ? null : goog.i18n.bidi.Dir.NEUTRAL : null == a ? null : a ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
    };

    goog.i18n.bidi.ltrChars_ = "A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0900-\u1FFF\u200E\u2C00-\uD801\uD804-\uD839\uD83C-\uDBFF\uF900-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF";
    goog.i18n.bidi.rtlChars_ = "\u0591-\u06EF\u06FA-\u08FF\u200F\uD802-\uD803\uD83A-\uD83B\uFB1D-\uFDFF\uFE70-\uFEFC";
    goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g;

    goog.i18n.bidi.stripHtmlIfNeeded_ = function (a, b) {
      return b ? a.replace(goog.i18n.bidi.htmlSkipReg_, "") : a;
    };

    goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]");
    goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]");

    goog.i18n.bidi.hasAnyRtl = function (a, b) {
      return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
    };

    goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl;

    goog.i18n.bidi.hasAnyLtr = function (a, b) {
      return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
    };

    goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]");
    goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]");

    goog.i18n.bidi.isRtlChar = function (a) {
      return goog.i18n.bidi.rtlRe_.test(a);
    };

    goog.i18n.bidi.isLtrChar = function (a) {
      return goog.i18n.bidi.ltrRe_.test(a);
    };

    goog.i18n.bidi.isNeutralChar = function (a) {
      return !goog.i18n.bidi.isLtrChar(a) && !goog.i18n.bidi.isRtlChar(a);
    };

    goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]");
    goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]");

    goog.i18n.bidi.startsWithRtl = function (a, b) {
      return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
    };

    goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl;

    goog.i18n.bidi.startsWithLtr = function (a, b) {
      return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
    };

    goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr;
    goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/;

    goog.i18n.bidi.isNeutralText = function (a, b) {
      a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b);
      return goog.i18n.bidi.isRequiredLtrRe_.test(a) || !goog.i18n.bidi.hasAnyLtr(a) && !goog.i18n.bidi.hasAnyRtl(a);
    };

    goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$");
    goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$");

    goog.i18n.bidi.endsWithLtr = function (a, b) {
      return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
    };

    goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr;

    goog.i18n.bidi.endsWithRtl = function (a, b) {
      return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
    };

    goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl;
    goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;

    goog.i18n.bidi.isRtlLanguage = function (a) {
      return goog.i18n.bidi.rtlLocalesRe_.test(a);
    };

    goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;

    goog.i18n.bidi.guardBracketInText = function (a, b) {
      b = (void 0 === b ? goog.i18n.bidi.hasAnyRtl(a) : b) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM;
      return a.replace(goog.i18n.bidi.bracketGuardTextRe_, b + "$&" + b);
    };

    goog.i18n.bidi.enforceRtlInHtml = function (a) {
      return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + a + "</span>";
    };

    goog.i18n.bidi.enforceRtlInText = function (a) {
      return goog.i18n.bidi.Format.RLE + a + goog.i18n.bidi.Format.PDF;
    };

    goog.i18n.bidi.enforceLtrInHtml = function (a) {
      return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + a + "</span>";
    };

    goog.i18n.bidi.enforceLtrInText = function (a) {
      return goog.i18n.bidi.Format.LRE + a + goog.i18n.bidi.Format.PDF;
    };

    goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
    goog.i18n.bidi.leftRe_ = /left/gi;
    goog.i18n.bidi.rightRe_ = /right/gi;
    goog.i18n.bidi.tempRe_ = /%%%%/g;

    goog.i18n.bidi.mirrorCSS = function (a) {
      return a.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
    };

    goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g;
    goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g;

    goog.i18n.bidi.normalizeHebrewQuote = function (a) {
      return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05F3");
    };

    goog.i18n.bidi.wordSeparatorRe_ = /\s+/;
    goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/;
    goog.i18n.bidi.rtlDetectionThreshold_ = .4;

    goog.i18n.bidi.estimateDirection = function (a, b) {
      var c = 0,
          d = 0,
          e = !1;
      a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b).split(goog.i18n.bidi.wordSeparatorRe_);

      for (b = 0; b < a.length; b++) {
        var f = a[b];
        goog.i18n.bidi.startsWithRtl(f) ? (c++, d++) : goog.i18n.bidi.isRequiredLtrRe_.test(f) ? e = !0 : goog.i18n.bidi.hasAnyLtr(f) ? d++ : goog.i18n.bidi.hasNumeralsRe_.test(f) && (e = !0);
      }

      return 0 == d ? e ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c / d > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
    };

    goog.i18n.bidi.detectRtlDirectionality = function (a, b) {
      return goog.i18n.bidi.estimateDirection(a, b) == goog.i18n.bidi.Dir.RTL;
    };

    goog.i18n.bidi.setElementDirAndAlign = function (a, b) {
      a && (b = goog.i18n.bidi.toDir(b)) && (a.style.textAlign = b == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a.dir = b == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
    };

    goog.i18n.bidi.setElementDirByTextDirectionality = function (a, b) {
      switch (goog.i18n.bidi.estimateDirection(b)) {
        case goog.i18n.bidi.Dir.LTR:
          a.dir = "ltr";
          break;

        case goog.i18n.bidi.Dir.RTL:
          a.dir = "rtl";
          break;

        default:
          a.removeAttribute("dir");
      }
    };

    goog.i18n.bidi.DirectionalString = function () {};

    goog.html.TrustedResourceUrl = function () {
      this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = "";
      this.trustedURL_ = null;
      this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    };

    goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0;

    goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function () {
      return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
    };

    goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;

    goog.html.TrustedResourceUrl.prototype.getDirection = function () {
      return goog.i18n.bidi.Dir.LTR;
    };

    goog.html.TrustedResourceUrl.prototype.cloneWithParams = function (a, b) {
      var c = goog.html.TrustedResourceUrl.unwrap(this);
      c = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);
      var d = c[3] || "";
      return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", c[2] || "", a) + goog.html.TrustedResourceUrl.stringifyParams_("#", d, b));
    };

    goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function () {
      return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
    });

    goog.html.TrustedResourceUrl.unwrap = function (a) {
      return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString();
    };

    goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function (a) {
      if (a instanceof goog.html.TrustedResourceUrl && a.constructor === goog.html.TrustedResourceUrl && a.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;
      goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + a + "' of type " + goog.typeOf(a));
      return "type_error:TrustedResourceUrl";
    };

    goog.html.TrustedResourceUrl.unwrapTrustedURL = function (a) {
      return a.trustedURL_ ? a.trustedURL_ : goog.html.TrustedResourceUrl.unwrap(a);
    };

    goog.html.TrustedResourceUrl.format = function (a, b) {
      var c = goog.string.Const.unwrap(a);
      if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);
      a = c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function (a, e) {
        if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
        a = b[e];
        return a instanceof goog.string.Const ? goog.string.Const.unwrap(a) : encodeURIComponent(String(a));
      });
      return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g;
    goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;
    goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;

    goog.html.TrustedResourceUrl.formatWithParams = function (a, b, c, d) {
      return goog.html.TrustedResourceUrl.format(a, b).cloneWithParams(c, d);
    };

    goog.html.TrustedResourceUrl.fromConstant = function (a) {
      return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
    };

    goog.html.TrustedResourceUrl.fromConstants = function (a) {
      for (var b = "", c = 0; c < a.length; c++) {
        b += goog.string.Const.unwrap(a[c]);
      }

      return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
    };

    goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};

    goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function (a) {
      var b = new goog.html.TrustedResourceUrl();
      b.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(a) : a;
      goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY && (b.trustedURL_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a));
      return b;
    };

    goog.html.TrustedResourceUrl.stringifyParams_ = function (a, b, c) {
      if (null == c) return b;
      if (goog.isString(c)) return c ? a + encodeURIComponent(c) : "";

      for (var d in c) {
        var e = c[d];
        e = goog.isArray(e) ? e : [e];

        for (var f = 0; f < e.length; f++) {
          var g = e[f];
          null != g && (b || (b = a), b += (b.length > a.length ? "&" : "") + encodeURIComponent(d) + "=" + encodeURIComponent(String(g)));
        }
      }

      return b;
    };

    goog.string.internal = {};

    goog.string.internal.startsWith = function (a, b) {
      return 0 == a.lastIndexOf(b, 0);
    };

    goog.string.internal.endsWith = function (a, b) {
      var c = a.length - b.length;
      return 0 <= c && a.indexOf(b, c) == c;
    };

    goog.string.internal.caseInsensitiveStartsWith = function (a, b) {
      return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(0, b.length));
    };

    goog.string.internal.caseInsensitiveEndsWith = function (a, b) {
      return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
    };

    goog.string.internal.caseInsensitiveEquals = function (a, b) {
      return a.toLowerCase() == b.toLowerCase();
    };

    goog.string.internal.isEmptyOrWhitespace = function (a) {
      return /^[\s\xa0]*$/.test(a);
    };

    goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function (a) {
      return a.trim();
    } : function (a) {
      return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
    };

    goog.string.internal.caseInsensitiveCompare = function (a, b) {
      a = String(a).toLowerCase();
      b = String(b).toLowerCase();
      return a < b ? -1 : a == b ? 0 : 1;
    };

    goog.string.internal.newLineToBr = function (a, b) {
      return a.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
    };

    goog.string.internal.htmlEscape = function (a, b) {
      if (b) a = a.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");else {
        if (!goog.string.internal.ALL_RE_.test(a)) return a;
        -1 != a.indexOf("&") && (a = a.replace(goog.string.internal.AMP_RE_, "&amp;"));
        -1 != a.indexOf("<") && (a = a.replace(goog.string.internal.LT_RE_, "&lt;"));
        -1 != a.indexOf(">") && (a = a.replace(goog.string.internal.GT_RE_, "&gt;"));
        -1 != a.indexOf('"') && (a = a.replace(goog.string.internal.QUOT_RE_, "&quot;"));
        -1 != a.indexOf("'") && (a = a.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;"));
        -1 != a.indexOf("\x00") && (a = a.replace(goog.string.internal.NULL_RE_, "&#0;"));
      }
      return a;
    };

    goog.string.internal.AMP_RE_ = /&/g;
    goog.string.internal.LT_RE_ = /</g;
    goog.string.internal.GT_RE_ = />/g;
    goog.string.internal.QUOT_RE_ = /"/g;
    goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
    goog.string.internal.NULL_RE_ = /\x00/g;
    goog.string.internal.ALL_RE_ = /[\x00&<>"']/;

    goog.string.internal.whitespaceEscape = function (a, b) {
      return goog.string.internal.newLineToBr(a.replace(/  /g, " &#160;"), b);
    };

    goog.string.internal.contains = function (a, b) {
      return -1 != a.indexOf(b);
    };

    goog.string.internal.caseInsensitiveContains = function (a, b) {
      return goog.string.internal.contains(a.toLowerCase(), b.toLowerCase());
    };

    goog.string.internal.compareVersions = function (a, b) {
      var c = 0;
      a = goog.string.internal.trim(String(a)).split(".");
      b = goog.string.internal.trim(String(b)).split(".");

      for (var d = Math.max(a.length, b.length), e = 0; 0 == c && e < d; e++) {
        var f = a[e] || "",
            g = b[e] || "";

        do {
          f = /(\d*)(\D*)(.*)/.exec(f) || ["", "", "", ""];
          g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];
          if (0 == f[0].length && 0 == g[0].length) break;
          c = 0 == f[1].length ? 0 : parseInt(f[1], 10);
          var h = 0 == g[1].length ? 0 : parseInt(g[1], 10);
          c = goog.string.internal.compareElements_(c, h) || goog.string.internal.compareElements_(0 == f[2].length, 0 == g[2].length) || goog.string.internal.compareElements_(f[2], g[2]);
          f = f[3];
          g = g[3];
        } while (0 == c);
      }

      return c;
    };

    goog.string.internal.compareElements_ = function (a, b) {
      return a < b ? -1 : a > b ? 1 : 0;
    };

    goog.html.SafeUrl = function () {
      this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = "";
      this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    };

    goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez";
    goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0;

    goog.html.SafeUrl.prototype.getTypedStringValue = function () {
      return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
    };

    goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;

    goog.html.SafeUrl.prototype.getDirection = function () {
      return goog.i18n.bidi.Dir.LTR;
    };

    goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function () {
      return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
    });

    goog.html.SafeUrl.unwrap = function (a) {
      return goog.html.SafeUrl.unwrapTrustedURL(a).toString();
    };

    goog.html.SafeUrl.unwrapTrustedURL = function (a) {
      if (a instanceof goog.html.SafeUrl && a.constructor === goog.html.SafeUrl && a.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;
      goog.asserts.fail("expected object of type SafeUrl, got '" + a + "' of type " + goog.typeOf(a));
      return "type_error:SafeUrl";
    };

    goog.html.SafeUrl.fromConstant = function (a) {
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
    };

    goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime))(?:;\w+=(?:\w+|"[\w;=]+"))*$/i;

    goog.html.SafeUrl.isSafeMimeType = function (a) {
      return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a);
    };

    goog.html.SafeUrl.fromBlob = function (a) {
      a = goog.html.SAFE_MIME_TYPE_PATTERN_.test(a.type) ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.DATA_URL_PATTERN_ = /^data:([^,]*);base64,[a-z0-9+\/]+=*$/i;

    goog.html.SafeUrl.fromDataUrl = function (a) {
      a = a.replace(/(%0A|%0D)/g, "");
      var b = a.match(goog.html.DATA_URL_PATTERN_);
      b = b && goog.html.SAFE_MIME_TYPE_PATTERN_.test(b[1]);
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b ? a : goog.html.SafeUrl.INNOCUOUS_STRING);
    };

    goog.html.SafeUrl.fromTelUrl = function (a) {
      goog.string.internal.caseInsensitiveStartsWith(a, "tel:") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;

    goog.html.SafeUrl.fromSipUrl = function (a) {
      goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a)) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeUrl.fromFacebookMessengerUrl = function (a) {
      goog.string.internal.caseInsensitiveStartsWith(a, "fb-messenger://share") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeUrl.fromWhatsAppUrl = function (a) {
      goog.string.internal.caseInsensitiveStartsWith(a, "whatsapp://send") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeUrl.fromSmsUrl = function (a) {
      goog.string.internal.caseInsensitiveStartsWith(a, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeUrl.isSmsUrlBodyValid_ = function (a) {
      var b = a.indexOf("#");
      0 < b && (a = a.substring(0, b));
      b = a.match(/[?&]body=/gi);
      if (!b) return !0;
      if (1 < b.length) return !1;
      a = a.match(/[?&]body=([^&]*)/)[1];
      if (!a) return !0;

      try {
        decodeURIComponent(a);
      } catch (c) {
        return !1;
      }

      return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a);
    };

    goog.html.SafeUrl.fromSshUrl = function (a) {
      goog.string.internal.caseInsensitiveStartsWith(a, "ssh://") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeUrl.sanitizeChromeExtensionUrl = function (a, b) {
      return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a, b);
    };

    goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function (a, b) {
      return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a, b);
    };

    goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function (a, b) {
      return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a, b);
    };

    goog.html.SafeUrl.sanitizeExtensionUrl_ = function (a, b, c) {
      (a = a.exec(b)) ? (a = a[1], -1 == (c instanceof goog.string.Const ? [goog.string.Const.unwrap(c)] : c.map(function (a) {
        return goog.string.Const.unwrap(a);
      })).indexOf(a) && (b = goog.html.SafeUrl.INNOCUOUS_STRING)) : b = goog.html.SafeUrl.INNOCUOUS_STRING;
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
    };

    goog.html.SafeUrl.fromTrustedResourceUrl = function (a) {
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a));
    };

    goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
    goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_;

    goog.html.SafeUrl.sanitize = function (a) {
      if (a instanceof goog.html.SafeUrl) return a;
      a = "object" == _typeof(a) && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
      goog.html.SAFE_URL_PATTERN_.test(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeUrl.sanitizeAssertUnchanged = function (a, b) {
      if (a instanceof goog.html.SafeUrl) return a;
      a = "object" == _typeof(a) && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
      if (b && /^data:/i.test(a) && (b = goog.html.SafeUrl.fromDataUrl(a), b.getTypedStringValue() == a)) return b;
      goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a), "%s does not match the safe URL pattern", a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};

    goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function (a) {
      var b = new goog.html.SafeUrl();
      b.privateDoNotAccessOrElseSafeUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a) : a;
      return b;
    };

    goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");

    goog.html.SafeStyle = function () {
      this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "";
      this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    };

    goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0;
    goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};

    goog.html.SafeStyle.fromConstant = function (a) {
      a = goog.string.Const.unwrap(a);
      if (0 === a.length) return goog.html.SafeStyle.EMPTY;
      goog.asserts.assert(goog.string.internal.endsWith(a, ";"), "Last character of style string is not ';': " + a);
      goog.asserts.assert(goog.string.internal.contains(a, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + a);
      return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeStyle.prototype.getTypedStringValue = function () {
      return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
    };

    goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function () {
      return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
    });

    goog.html.SafeStyle.unwrap = function (a) {
      if (a instanceof goog.html.SafeStyle && a.constructor === goog.html.SafeStyle && a.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;
      goog.asserts.fail("expected object of type SafeStyle, got '" + a + "' of type " + goog.typeOf(a));
      return "type_error:SafeStyle";
    };

    goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function (a) {
      return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(a);
    };

    goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (a) {
      this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = a;
      return this;
    };

    goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");
    goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez";

    goog.html.SafeStyle.create = function (a) {
      var b = "",
          c;

      for (c in a) {
        if (!/^[-_a-zA-Z0-9]+$/.test(c)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + c);
        var d = a[c];
        null != d && (d = goog.isArray(d) ? goog.array.map(d, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(d), b += c + ":" + d + ";");
      }

      return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
    };

    goog.html.SafeStyle.sanitizePropertyValue_ = function (a) {
      if (a instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(a).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
      a = a instanceof goog.string.Const ? goog.string.Const.unwrap(a) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a));
      if (/[{;}]/.test(a)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [a]);
      return a;
    };

    goog.html.SafeStyle.sanitizePropertyValueString_ = function (a) {
      var b = a.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");

      if (goog.html.SafeStyle.VALUE_RE_.test(b)) {
        if (goog.html.SafeStyle.COMMENT_RE_.test(a)) return goog.asserts.fail("String value disallows comments, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
        if (!goog.html.SafeStyle.hasBalancedQuotes_(a)) return goog.asserts.fail("String value requires balanced quotes, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
        if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a)) return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
      } else return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;

      return goog.html.SafeStyle.sanitizeUrl_(a);
    };

    goog.html.SafeStyle.hasBalancedQuotes_ = function (a) {
      for (var b = !0, c = !0, d = 0; d < a.length; d++) {
        var e = a.charAt(d);
        "'" == e && c ? b = !b : '"' == e && b && (c = !c);
      }

      return b && c;
    };

    goog.html.SafeStyle.hasBalancedSquareBrackets_ = function (a) {
      for (var b = !0, c = /^[-_a-zA-Z0-9]$/, d = 0; d < a.length; d++) {
        var e = a.charAt(d);

        if ("]" == e) {
          if (b) return !1;
          b = !0;
        } else if ("[" == e) {
          if (!b) return !1;
          b = !1;
        } else if (!b && !c.test(e)) return !1;
      }

      return b;
    };

    goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
    goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$");
    goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;
    goog.html.SafeStyle.FUNCTIONS_RE_ = /\b(hsl|hsla|rgb|rgba|matrix|calc|minmax|fit-content|repeat|(rotate|scale|translate)(X|Y|Z|3d)?)\([-+*/0-9a-z.%\[\], ]+\)/g;
    goog.html.SafeStyle.COMMENT_RE_ = /\/\*/;

    goog.html.SafeStyle.sanitizeUrl_ = function (a) {
      return a.replace(goog.html.SafeStyle.URL_RE_, function (a, c, d, e) {
        var b = "";
        d = d.replace(/^(['"])(.*)\1$/, function (a, c, d) {
          b = c;
          return d;
        });
        a = goog.html.SafeUrl.sanitize(d).getTypedStringValue();
        return c + b + a + b + e;
      });
    };

    goog.html.SafeStyle.concat = function (a) {
      var b = "",
          c = function c(a) {
        goog.isArray(a) ? goog.array.forEach(a, c) : b += goog.html.SafeStyle.unwrap(a);
      };

      goog.array.forEach(arguments, c);
      return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
    };

    goog.html.SafeStyleSheet = function () {
      this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "";
      this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    };

    goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = !0;
    goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};

    goog.html.SafeStyleSheet.createRule = function (a, b) {
      if (goog.string.internal.contains(a, "<")) throw Error("Selector does not allow '<', got: " + a);
      var c = a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
      if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + a);
      if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(c)) throw Error("() and [] in selector must be balanced, got: " + a);
      b instanceof goog.html.SafeStyle || (b = goog.html.SafeStyle.create(b));
      a = a + "{" + goog.html.SafeStyle.unwrap(b).replace(/</g, "\\3C ") + "}";
      return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeStyleSheet.hasBalancedBrackets_ = function (a) {
      for (var b = {
        "(": ")",
        "[": "]"
      }, c = [], d = 0; d < a.length; d++) {
        var e = a[d];
        if (b[e]) c.push(b[e]);else if (goog.object.contains(b, e) && c.pop() != e) return !1;
      }

      return 0 == c.length;
    };

    goog.html.SafeStyleSheet.concat = function (a) {
      var b = "",
          c = function c(a) {
        goog.isArray(a) ? goog.array.forEach(a, c) : b += goog.html.SafeStyleSheet.unwrap(a);
      };

      goog.array.forEach(arguments, c);
      return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
    };

    goog.html.SafeStyleSheet.fromConstant = function (a) {
      a = goog.string.Const.unwrap(a);
      if (0 === a.length) return goog.html.SafeStyleSheet.EMPTY;
      goog.asserts.assert(!goog.string.internal.contains(a, "<"), "Forbidden '<' character in style sheet string: " + a);
      return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
    };

    goog.html.SafeStyleSheet.prototype.getTypedStringValue = function () {
      return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
    };

    goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function () {
      return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
    });

    goog.html.SafeStyleSheet.unwrap = function (a) {
      if (a instanceof goog.html.SafeStyleSheet && a.constructor === goog.html.SafeStyleSheet && a.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
      goog.asserts.fail("expected object of type SafeStyleSheet, got '" + a + "' of type " + goog.typeOf(a));
      return "type_error:SafeStyleSheet";
    };

    goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function (a) {
      return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(a);
    };

    goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (a) {
      this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = a;
      return this;
    };

    goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");
    goog.labs = {};
    goog.labs.userAgent = {};
    goog.labs.userAgent.util = {};

    goog.labs.userAgent.util.getNativeUserAgentString_ = function () {
      var a = goog.labs.userAgent.util.getNavigator_();
      return a && (a = a.userAgent) ? a : "";
    };

    goog.labs.userAgent.util.getNavigator_ = function () {
      return goog.global.navigator;
    };

    goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_();

    goog.labs.userAgent.util.setUserAgent = function (a) {
      goog.labs.userAgent.util.userAgent_ = a || goog.labs.userAgent.util.getNativeUserAgentString_();
    };

    goog.labs.userAgent.util.getUserAgent = function () {
      return goog.labs.userAgent.util.userAgent_;
    };

    goog.labs.userAgent.util.matchUserAgent = function (a) {
      var b = goog.labs.userAgent.util.getUserAgent();
      return goog.string.internal.contains(b, a);
    };

    goog.labs.userAgent.util.matchUserAgentIgnoreCase = function (a) {
      var b = goog.labs.userAgent.util.getUserAgent();
      return goog.string.internal.caseInsensitiveContains(b, a);
    };

    goog.labs.userAgent.util.extractVersionTuples = function (a) {
      for (var b = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, c = [], d; d = b.exec(a);) {
        c.push([d[1], d[2], d[3] || void 0]);
      }

      return c;
    };

    goog.labs.userAgent.browser = {};

    goog.labs.userAgent.browser.matchOpera_ = function () {
      return goog.labs.userAgent.util.matchUserAgent("Opera");
    };

    goog.labs.userAgent.browser.matchIE_ = function () {
      return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
    };

    goog.labs.userAgent.browser.matchEdgeHtml_ = function () {
      return goog.labs.userAgent.util.matchUserAgent("Edge");
    };

    goog.labs.userAgent.browser.matchEdgeChromium_ = function () {
      return goog.labs.userAgent.util.matchUserAgent("Edg/");
    };

    goog.labs.userAgent.browser.matchOperaChromium_ = function () {
      return goog.labs.userAgent.util.matchUserAgent("OPR");
    };

    goog.labs.userAgent.browser.matchFirefox_ = function () {
      return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
    };

    goog.labs.userAgent.browser.matchSafari_ = function () {
      return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
    };

    goog.labs.userAgent.browser.matchCoast_ = function () {
      return goog.labs.userAgent.util.matchUserAgent("Coast");
    };

    goog.labs.userAgent.browser.matchIosWebview_ = function () {
      return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
    };

    goog.labs.userAgent.browser.matchChrome_ = function () {
      return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
    };

    goog.labs.userAgent.browser.matchAndroidBrowser_ = function () {
      return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
    };

    goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_;
    goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_;
    goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_;
    goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_;
    goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_;
    goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_;
    goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_;
    goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_;
    goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_;
    goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_;
    goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_;

    goog.labs.userAgent.browser.isSilk = function () {
      return goog.labs.userAgent.util.matchUserAgent("Silk");
    };

    goog.labs.userAgent.browser.getVersion = function () {
      function a(a) {
        a = goog.array.find(a, d);
        return c[a] || "";
      }

      var b = goog.labs.userAgent.util.getUserAgent();
      if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(b);
      b = goog.labs.userAgent.util.extractVersionTuples(b);
      var c = {};
      goog.array.forEach(b, function (a) {
        c[a[0]] = a[1];
      });
      var d = goog.partial(goog.object.containsKey, c);
      return goog.labs.userAgent.browser.isOpera() ? a(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? a(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? a(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? a(["Chrome", "CriOS"]) : (b = b[2]) && b[1] || "";
    };

    goog.labs.userAgent.browser.isVersionOrHigher = function (a) {
      return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a);
    };

    goog.labs.userAgent.browser.getIEVersion_ = function (a) {
      var b = /rv: *([\d\.]*)/.exec(a);
      if (b && b[1]) return b[1];
      b = "";
      var c = /MSIE +([\d\.]+)/.exec(a);
      if (c && c[1]) if (a = /Trident\/(\d.\d)/.exec(a), "7.0" == c[1]) {
        if (a && a[1]) switch (a[1]) {
          case "4.0":
            b = "8.0";
            break;

          case "5.0":
            b = "9.0";
            break;

          case "6.0":
            b = "10.0";
            break;

          case "7.0":
            b = "11.0";
        } else b = "7.0";
      } else b = c[1];
      return b;
    };

    goog.html.SafeHtml = function () {
      this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "";
      this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
      this.dir_ = null;
    };

    goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0;

    goog.html.SafeHtml.prototype.getDirection = function () {
      return this.dir_;
    };

    goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0;

    goog.html.SafeHtml.prototype.getTypedStringValue = function () {
      return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
    };

    goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function () {
      return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
    });

    goog.html.SafeHtml.unwrap = function (a) {
      return goog.html.SafeHtml.unwrapTrustedHTML(a).toString();
    };

    goog.html.SafeHtml.unwrapTrustedHTML = function (a) {
      if (a instanceof goog.html.SafeHtml && a.constructor === goog.html.SafeHtml && a.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;
      goog.asserts.fail("expected object of type SafeHtml, got '" + a + "' of type " + goog.typeOf(a));
      return "type_error:SafeHtml";
    };

    goog.html.SafeHtml.htmlEscape = function (a) {
      if (a instanceof goog.html.SafeHtml) return a;

      var b = "object" == _typeof(a),
          c = null;

      b && a.implementsGoogI18nBidiDirectionalString && (c = a.getDirection());
      a = b && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
      return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a), c);
    };

    goog.html.SafeHtml.htmlEscapePreservingNewlines = function (a) {
      if (a instanceof goog.html.SafeHtml) return a;
      a = goog.html.SafeHtml.htmlEscape(a);
      return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)), a.getDirection());
    };

    goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function (a) {
      if (a instanceof goog.html.SafeHtml) return a;
      a = goog.html.SafeHtml.htmlEscape(a);
      return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)), a.getDirection());
    };

    goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape;
    goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/;
    goog.html.SafeHtml.URL_ATTRIBUTES_ = {
      action: !0,
      cite: !0,
      data: !0,
      formaction: !0,
      href: !0,
      manifest: !0,
      poster: !0,
      src: !0
    };
    goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = {
      APPLET: !0,
      BASE: !0,
      EMBED: !0,
      IFRAME: !0,
      LINK: !0,
      MATH: !0,
      META: !0,
      OBJECT: !0,
      SCRIPT: !0,
      STYLE: !0,
      SVG: !0,
      TEMPLATE: !0
    };

    goog.html.SafeHtml.create = function (a, b, c) {
      goog.html.SafeHtml.verifyTagName(String(a));
      return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a), b, c);
    };

    goog.html.SafeHtml.verifyTagName = function (a) {
      if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a)) throw Error("Invalid tag name <" + a + ">.");
      if (a.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error("Tag name <" + a + "> is not allowed for SafeHtml.");
    };

    goog.html.SafeHtml.createIframe = function (a, b, c, d) {
      a && goog.html.TrustedResourceUrl.unwrap(a);
      var e = {};
      e.src = a || null;
      e.srcdoc = b && goog.html.SafeHtml.unwrap(b);
      a = goog.html.SafeHtml.combineAttributes(e, {
        sandbox: ""
      }, c);
      return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
    };

    goog.html.SafeHtml.createSandboxIframe = function (a, b, c, d) {
      if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error("The browser does not support sandboxed iframes.");
      var e = {};
      e.src = a ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)) : null;
      e.srcdoc = b || null;
      e.sandbox = "";
      a = goog.html.SafeHtml.combineAttributes(e, {}, c);
      return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
    };

    goog.html.SafeHtml.canUseSandboxIframe = function () {
      return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
    };

    goog.html.SafeHtml.createScriptSrc = function (a, b) {
      goog.html.TrustedResourceUrl.unwrap(a);
      a = goog.html.SafeHtml.combineAttributes({
        src: a
      }, {}, b);
      return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", a);
    };

    goog.html.SafeHtml.createScript = function (a, b) {
      for (var c in b) {
        var d = c.toLowerCase();
        if ("language" == d || "src" == d || "text" == d || "type" == d) throw Error('Cannot set "' + d + '" attribute');
      }

      c = "";
      a = goog.array.concat(a);

      for (d = 0; d < a.length; d++) {
        c += goog.html.SafeScript.unwrap(a[d]);
      }

      a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
      return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", b, a);
    };

    goog.html.SafeHtml.createStyle = function (a, b) {
      b = goog.html.SafeHtml.combineAttributes({
        type: "text/css"
      }, {}, b);
      var c = "";
      a = goog.array.concat(a);

      for (var d = 0; d < a.length; d++) {
        c += goog.html.SafeStyleSheet.unwrap(a[d]);
      }

      a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
      return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", b, a);
    };

    goog.html.SafeHtml.createMetaRefresh = function (a, b) {
      a = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));
      (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'");
      return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
        "http-equiv": "refresh",
        content: (b || 0) + "; url=" + a
      });
    };

    goog.html.SafeHtml.getAttrNameAndValue_ = function (a, b, c) {
      if (c instanceof goog.string.Const) c = goog.string.Const.unwrap(c);else if ("style" == b.toLowerCase()) c = goog.html.SafeHtml.getStyleValue_(c);else {
        if (/^on/i.test(b)) throw Error('Attribute "' + b + '" requires goog.string.Const value, "' + c + '" given.');
        if (b.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) if (c instanceof goog.html.TrustedResourceUrl) c = goog.html.TrustedResourceUrl.unwrap(c);else if (c instanceof goog.html.SafeUrl) c = goog.html.SafeUrl.unwrap(c);else if (goog.isString(c)) c = goog.html.SafeUrl.sanitize(c).getTypedStringValue();else throw Error('Attribute "' + b + '" on tag "' + a + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c + '" given.');
      }
      c.implementsGoogStringTypedString && (c = c.getTypedStringValue());
      goog.asserts.assert(goog.isString(c) || goog.isNumber(c), "String or number value expected, got " + _typeof(c) + " with value: " + c);
      return b + '="' + goog.string.internal.htmlEscape(String(c)) + '"';
    };

    goog.html.SafeHtml.getStyleValue_ = function (a) {
      if (!goog.isObject(a)) throw Error('The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + _typeof(a) + " given: " + a);
      a instanceof goog.html.SafeStyle || (a = goog.html.SafeStyle.create(a));
      return goog.html.SafeStyle.unwrap(a);
    };

    goog.html.SafeHtml.createWithDir = function (a, b, c, d) {
      b = goog.html.SafeHtml.create(b, c, d);
      b.dir_ = a;
      return b;
    };

    goog.html.SafeHtml.join = function (a, b) {
      a = goog.html.SafeHtml.htmlEscape(a);

      var c = a.getDirection(),
          d = [],
          e = function e(a) {
        goog.isArray(a) ? goog.array.forEach(a, e) : (a = goog.html.SafeHtml.htmlEscape(a), d.push(goog.html.SafeHtml.unwrap(a)), a = a.getDirection(), c == goog.i18n.bidi.Dir.NEUTRAL ? c = a : a != goog.i18n.bidi.Dir.NEUTRAL && c != a && (c = null));
      };

      goog.array.forEach(b, e);
      return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)), c);
    };

    goog.html.SafeHtml.concat = function (a) {
      return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
    };

    goog.html.SafeHtml.concatWithDir = function (a, b) {
      var c = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
      c.dir_ = a;
      return c;
    };

    goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};

    goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function (a, b) {
      return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(a, b);
    };

    goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (a, b) {
      this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(a) : a;
      this.dir_ = b;
      return this;
    };

    goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function (a, b, c) {
      var d = null;
      var e = "<" + a + goog.html.SafeHtml.stringifyAttributes(a, b);
      goog.isDefAndNotNull(c) ? goog.isArray(c) || (c = [c]) : c = [];
      goog.dom.tags.isVoidTag(a.toLowerCase()) ? (goog.asserts.assert(!c.length, "Void tag <" + a + "> does not allow content."), e += ">") : (d = goog.html.SafeHtml.concat(c), e += ">" + goog.html.SafeHtml.unwrap(d) + "</" + a + ">", d = d.getDirection());
      (a = b && b.dir) && (d = /^(ltr|rtl|auto)$/i.test(a) ? goog.i18n.bidi.Dir.NEUTRAL : null);
      return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e, d);
    };

    goog.html.SafeHtml.stringifyAttributes = function (a, b) {
      var c = "";
      if (b) for (var d in b) {
        if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d)) throw Error('Invalid attribute name "' + d + '".');
        var e = b[d];
        goog.isDefAndNotNull(e) && (c += " " + goog.html.SafeHtml.getAttrNameAndValue_(a, d, e));
      }
      return c;
    };

    goog.html.SafeHtml.combineAttributes = function (a, b, c) {
      var d = {},
          e;

      for (e in a) {
        goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = a[e];
      }

      for (e in b) {
        goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = b[e];
      }

      for (e in c) {
        var f = e.toLowerCase();
        if (f in a) throw Error('Cannot override "' + f + '" attribute, got "' + e + '" with value "' + c[e] + '"');
        f in b && delete d[f];
        d[e] = c[e];
      }

      return d;
    };

    goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
    goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL);
    goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
    goog.html.uncheckedconversions = {};

    goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function (a, b, c) {
      goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
      goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
      return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b, c || null);
    };

    goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function (a, b) {
      goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
      goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
      return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b);
    };

    goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function (a, b) {
      goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
      goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
      return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b);
    };

    goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function (a, b) {
      goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
      goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
      return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
    };

    goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function (a, b) {
      goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
      goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
      return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
    };

    goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function (a, b) {
      goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
      goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
      return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
    };

    goog.dom.safe = {};
    goog.dom.safe.InsertAdjacentHtmlPosition = {
      AFTERBEGIN: "afterbegin",
      AFTEREND: "afterend",
      BEFOREBEGIN: "beforebegin",
      BEFOREEND: "beforeend"
    };

    goog.dom.safe.insertAdjacentHtml = function (a, b, c) {
      a.insertAdjacentHTML(b, goog.html.SafeHtml.unwrapTrustedHTML(c));
    };

    goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
      MATH: !0,
      SCRIPT: !0,
      STYLE: !0,
      SVG: !0,
      TEMPLATE: !0
    };
    goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function () {
      if (goog.DEBUG && "undefined" === typeof document) return !1;
      var a = document.createElement("div"),
          b = document.createElement("div");
      b.appendChild(document.createElement("div"));
      a.appendChild(b);
      if (goog.DEBUG && !a.firstChild) return !1;
      b = a.firstChild.firstChild;
      a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);
      return !b.parentElement;
    });

    goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function (a, b) {
      if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for (; a.lastChild;) {
        a.removeChild(a.lastChild);
      }
      a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
    };

    goog.dom.safe.setInnerHtml = function (a, b) {
      if (goog.asserts.ENABLE_ASSERTS) {
        var c = a.tagName.toUpperCase();
        if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + a.tagName + ".");
      }

      goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a, b);
    };

    goog.dom.safe.setOuterHtml = function (a, b) {
      a.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
    };

    goog.dom.safe.setFormElementAction = function (a, b) {
      b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
      goog.dom.asserts.assertIsHTMLFormElement(a).action = goog.html.SafeUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.setButtonFormAction = function (a, b) {
      b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
      goog.dom.asserts.assertIsHTMLButtonElement(a).formAction = goog.html.SafeUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.setInputFormAction = function (a, b) {
      b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
      goog.dom.asserts.assertIsHTMLInputElement(a).formAction = goog.html.SafeUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.setStyle = function (a, b) {
      a.style.cssText = goog.html.SafeStyle.unwrap(b);
    };

    goog.dom.safe.documentWrite = function (a, b) {
      a.write(goog.html.SafeHtml.unwrapTrustedHTML(b));
    };

    goog.dom.safe.setAnchorHref = function (a, b) {
      goog.dom.asserts.assertIsHTMLAnchorElement(a);
      b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
      a.href = goog.html.SafeUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.setImageSrc = function (a, b) {
      goog.dom.asserts.assertIsHTMLImageElement(a);

      if (!(b instanceof goog.html.SafeUrl)) {
        var c = /^data:image\//i.test(b);
        b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
      }

      a.src = goog.html.SafeUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.setAudioSrc = function (a, b) {
      goog.dom.asserts.assertIsHTMLAudioElement(a);

      if (!(b instanceof goog.html.SafeUrl)) {
        var c = /^data:audio\//i.test(b);
        b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
      }

      a.src = goog.html.SafeUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.setVideoSrc = function (a, b) {
      goog.dom.asserts.assertIsHTMLVideoElement(a);

      if (!(b instanceof goog.html.SafeUrl)) {
        var c = /^data:video\//i.test(b);
        b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
      }

      a.src = goog.html.SafeUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.setEmbedSrc = function (a, b) {
      goog.dom.asserts.assertIsHTMLEmbedElement(a);
      a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
    };

    goog.dom.safe.setFrameSrc = function (a, b) {
      goog.dom.asserts.assertIsHTMLFrameElement(a);
      a.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.setIframeSrc = function (a, b) {
      goog.dom.asserts.assertIsHTMLIFrameElement(a);
      a.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.setIframeSrcdoc = function (a, b) {
      goog.dom.asserts.assertIsHTMLIFrameElement(a);
      a.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b);
    };

    goog.dom.safe.setLinkHrefAndRel = function (a, b, c) {
      goog.dom.asserts.assertIsHTMLLinkElement(a);
      a.rel = c;
      goog.string.internal.caseInsensitiveContains(c, "stylesheet") ? (goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a.href = goog.html.TrustedResourceUrl.unwrapTrustedURL(b)) : a.href = b instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrapTrustedURL(b) : b instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrapTrustedURL(b) : goog.html.SafeUrl.unwrapTrustedURL(goog.html.SafeUrl.sanitizeAssertUnchanged(b));
    };

    goog.dom.safe.setObjectData = function (a, b) {
      goog.dom.asserts.assertIsHTMLObjectElement(a);
      a.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
    };

    goog.dom.safe.setScriptSrc = function (a, b) {
      goog.dom.asserts.assertIsHTMLScriptElement(a);
      a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
      (b = goog.getScriptNonce()) && a.setAttribute("nonce", b);
    };

    goog.dom.safe.setScriptContent = function (a, b) {
      goog.dom.asserts.assertIsHTMLScriptElement(a);
      a.text = goog.html.SafeScript.unwrapTrustedScript(b);
      (b = goog.getScriptNonce()) && a.setAttribute("nonce", b);
    };

    goog.dom.safe.setLocationHref = function (a, b) {
      goog.dom.asserts.assertIsLocation(a);
      b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
      a.href = goog.html.SafeUrl.unwrapTrustedURL(b);
    };

    goog.dom.safe.assignLocation = function (a, b) {
      goog.dom.asserts.assertIsLocation(a);
      b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
      a.assign(goog.html.SafeUrl.unwrapTrustedURL(b));
    };

    goog.dom.safe.replaceLocation = function (a, b) {
      goog.dom.asserts.assertIsLocation(a);
      b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
      a.replace(goog.html.SafeUrl.unwrapTrustedURL(b));
    };

    goog.dom.safe.openInWindow = function (a, b, c, d, e) {
      a = a instanceof goog.html.SafeUrl ? a : goog.html.SafeUrl.sanitizeAssertUnchanged(a);
      return (b || goog.global).open(goog.html.SafeUrl.unwrapTrustedURL(a), c ? goog.string.Const.unwrap(c) : "", d, e);
    };

    goog.dom.safe.parseFromStringHtml = function (a, b) {
      return goog.dom.safe.parseFromString(a, b, "text/html");
    };

    goog.dom.safe.parseFromString = function (a, b, c) {
      return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b), c);
    };

    goog.dom.safe.createImageFromBlob = function (a) {
      if (!/^image\/.*/g.test(a.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
      var b = goog.global.URL.createObjectURL(a);
      a = new goog.global.Image();

      a.onload = function () {
        goog.global.URL.revokeObjectURL(b);
      };

      goog.dom.safe.setImageSrc(a, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), b));
      return a;
    };

    goog.string.DETECT_DOUBLE_ESCAPING = !1;
    goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
    goog.string.Unicode = {
      NBSP: "\xA0"
    };
    goog.string.startsWith = goog.string.internal.startsWith;
    goog.string.endsWith = goog.string.internal.endsWith;
    goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith;
    goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith;
    goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals;

    goog.string.subs = function (a, b) {
      for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
        d += c.shift() + e.shift();
      }

      return d + c.join("%s");
    };

    goog.string.collapseWhitespace = function (a) {
      return a.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
    };

    goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace;

    goog.string.isEmptyString = function (a) {
      return 0 == a.length;
    };

    goog.string.isEmpty = goog.string.isEmptyOrWhitespace;

    goog.string.isEmptyOrWhitespaceSafe = function (a) {
      return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
    };

    goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;

    goog.string.isBreakingWhitespace = function (a) {
      return !/[^\t\n\r ]/.test(a);
    };

    goog.string.isAlpha = function (a) {
      return !/[^a-zA-Z]/.test(a);
    };

    goog.string.isNumeric = function (a) {
      return !/[^0-9]/.test(a);
    };

    goog.string.isAlphaNumeric = function (a) {
      return !/[^a-zA-Z0-9]/.test(a);
    };

    goog.string.isSpace = function (a) {
      return " " == a;
    };

    goog.string.isUnicodeChar = function (a) {
      return 1 == a.length && " " <= a && "~" >= a || "\x80" <= a && "\uFFFD" >= a;
    };

    goog.string.stripNewlines = function (a) {
      return a.replace(/(\r\n|\r|\n)+/g, " ");
    };

    goog.string.canonicalizeNewlines = function (a) {
      return a.replace(/(\r\n|\r|\n)/g, "\n");
    };

    goog.string.normalizeWhitespace = function (a) {
      return a.replace(/\xa0|\s/g, " ");
    };

    goog.string.normalizeSpaces = function (a) {
      return a.replace(/\xa0|[ \t]+/g, " ");
    };

    goog.string.collapseBreakingSpaces = function (a) {
      return a.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
    };

    goog.string.trim = goog.string.internal.trim;

    goog.string.trimLeft = function (a) {
      return a.replace(/^[\s\xa0]+/, "");
    };

    goog.string.trimRight = function (a) {
      return a.replace(/[\s\xa0]+$/, "");
    };

    goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare;

    goog.string.numberAwareCompare_ = function (a, b, c) {
      if (a == b) return 0;
      if (!a) return -1;
      if (!b) return 1;

      for (var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++) {
        c = d[g];
        var h = e[g];
        if (c != h) return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
      }

      return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
    };

    goog.string.intAwareCompare = function (a, b) {
      return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
    };

    goog.string.floatAwareCompare = function (a, b) {
      return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
    };

    goog.string.numerateCompare = goog.string.floatAwareCompare;

    goog.string.urlEncode = function (a) {
      return encodeURIComponent(String(a));
    };

    goog.string.urlDecode = function (a) {
      return decodeURIComponent(a.replace(/\+/g, " "));
    };

    goog.string.newLineToBr = goog.string.internal.newLineToBr;

    goog.string.htmlEscape = function (a, b) {
      a = goog.string.internal.htmlEscape(a, b);
      goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, "&#101;"));
      return a;
    };

    goog.string.E_RE_ = /e/g;

    goog.string.unescapeEntities = function (a) {
      return goog.string.contains(a, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
    };

    goog.string.unescapeEntitiesWithDocument = function (a, b) {
      return goog.string.contains(a, "&") ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
    };

    goog.string.unescapeEntitiesUsingDom_ = function (a, b) {
      var c = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"'
      };
      var d = b ? b.createElement("div") : goog.global.document.createElement("div");
      return a.replace(goog.string.HTML_ENTITY_PATTERN_, function (a, b) {
        var e = c[a];
        if (e) return e;
        "#" == b.charAt(0) && (b = Number("0" + b.substr(1)), isNaN(b) || (e = String.fromCharCode(b)));
        e || (goog.dom.safe.setInnerHtml(d, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), a + " ")), e = d.firstChild.nodeValue.slice(0, -1));
        return c[a] = e;
      });
    };

    goog.string.unescapePureXmlEntities_ = function (a) {
      return a.replace(/&([^;]+);/g, function (a, c) {
        switch (c) {
          case "amp":
            return "&";

          case "lt":
            return "<";

          case "gt":
            return ">";

          case "quot":
            return '"';

          default:
            return "#" != c.charAt(0) || (c = Number("0" + c.substr(1)), isNaN(c)) ? a : String.fromCharCode(c);
        }
      });
    };

    goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;

    goog.string.whitespaceEscape = function (a, b) {
      return goog.string.newLineToBr(a.replace(/  /g, " &#160;"), b);
    };

    goog.string.preserveSpaces = function (a) {
      return a.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
    };

    goog.string.stripQuotes = function (a, b) {
      for (var c = b.length, d = 0; d < c; d++) {
        var e = 1 == c ? b : b.charAt(d);
        if (a.charAt(0) == e && a.charAt(a.length - 1) == e) return a.substring(1, a.length - 1);
      }

      return a;
    };

    goog.string.truncate = function (a, b, c) {
      c && (a = goog.string.unescapeEntities(a));
      a.length > b && (a = a.substring(0, b - 3) + "...");
      c && (a = goog.string.htmlEscape(a));
      return a;
    };

    goog.string.truncateMiddle = function (a, b, c, d) {
      c && (a = goog.string.unescapeEntities(a));

      if (d && a.length > b) {
        d > b && (d = b);
        var e = a.length - d;
        a = a.substring(0, b - d) + "..." + a.substring(e);
      } else a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + "..." + a.substring(e));

      c && (a = goog.string.htmlEscape(a));
      return a;
    };

    goog.string.specialEscapeChars_ = {
      "\x00": "\\0",
      "\b": "\\b",
      "\f": "\\f",
      "\n": "\\n",
      "\r": "\\r",
      "\t": "\\t",
      "\x0B": "\\x0B",
      '"': '\\"',
      "\\": "\\\\",
      "<": "\\u003C"
    };
    goog.string.jsEscapeCache_ = {
      "'": "\\'"
    };

    goog.string.quote = function (a) {
      a = String(a);

      for (var b = ['"'], c = 0; c < a.length; c++) {
        var d = a.charAt(c),
            e = d.charCodeAt(0);
        b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
      }

      b.push('"');
      return b.join("");
    };

    goog.string.escapeString = function (a) {
      for (var b = [], c = 0; c < a.length; c++) {
        b[c] = goog.string.escapeChar(a.charAt(c));
      }

      return b.join("");
    };

    goog.string.escapeChar = function (a) {
      if (a in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[a];
      if (a in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
      var b = a.charCodeAt(0);
      if (31 < b && 127 > b) var c = a;else {
        if (256 > b) {
          if (c = "\\x", 16 > b || 256 < b) c += "0";
        } else c = "\\u", 4096 > b && (c += "0");

        c += b.toString(16).toUpperCase();
      }
      return goog.string.jsEscapeCache_[a] = c;
    };

    goog.string.contains = goog.string.internal.contains;
    goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains;

    goog.string.countOf = function (a, b) {
      return a && b ? a.split(b).length - 1 : 0;
    };

    goog.string.removeAt = function (a, b, c) {
      var d = a;
      0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
      return d;
    };

    goog.string.remove = function (a, b) {
      return a.replace(b, "");
    };

    goog.string.removeAll = function (a, b) {
      b = new RegExp(goog.string.regExpEscape(b), "g");
      return a.replace(b, "");
    };

    goog.string.replaceAll = function (a, b, c) {
      b = new RegExp(goog.string.regExpEscape(b), "g");
      return a.replace(b, c.replace(/\$/g, "$$$$"));
    };

    goog.string.regExpEscape = function (a) {
      return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
    };

    goog.string.repeat = String.prototype.repeat ? function (a, b) {
      return a.repeat(b);
    } : function (a, b) {
      return Array(b + 1).join(a);
    };

    goog.string.padNumber = function (a, b, c) {
      a = goog.isDef(c) ? a.toFixed(c) : String(a);
      c = a.indexOf(".");
      -1 == c && (c = a.length);
      return goog.string.repeat("0", Math.max(0, b - c)) + a;
    };

    goog.string.makeSafe = function (a) {
      return null == a ? "" : String(a);
    };

    goog.string.buildString = function (a) {
      return Array.prototype.join.call(arguments, "");
    };

    goog.string.getRandomString = function () {
      return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
    };

    goog.string.compareVersions = goog.string.internal.compareVersions;

    goog.string.hashCode = function (a) {
      for (var b = 0, c = 0; c < a.length; ++c) {
        b = 31 * b + a.charCodeAt(c) >>> 0;
      }

      return b;
    };

    goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;

    goog.string.createUniqueString = function () {
      return "goog_" + goog.string.uniqueStringCounter_++;
    };

    goog.string.toNumber = function (a) {
      var b = Number(a);
      return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
    };

    goog.string.isLowerCamelCase = function (a) {
      return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
    };

    goog.string.isUpperCamelCase = function (a) {
      return /^([A-Z][a-z]*)+$/.test(a);
    };

    goog.string.toCamelCase = function (a) {
      return String(a).replace(/\-([a-z])/g, function (a, c) {
        return c.toUpperCase();
      });
    };

    goog.string.toSelectorCase = function (a) {
      return String(a).replace(/([A-Z])/g, "-$1").toLowerCase();
    };

    goog.string.toTitleCase = function (a, b) {
      b = goog.isString(b) ? goog.string.regExpEscape(b) : "\\s";
      return a.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function (a, b, e) {
        return b + e.toUpperCase();
      });
    };

    goog.string.capitalize = function (a) {
      return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
    };

    goog.string.parseInt = function (a) {
      isFinite(a) && (a = String(a));
      return goog.isString(a) ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
    };

    goog.string.splitLimit = function (a, b, c) {
      a = a.split(b);

      for (var d = []; 0 < c && a.length;) {
        d.push(a.shift()), c--;
      }

      a.length && d.push(a.join(b));
      return d;
    };

    goog.string.lastComponent = function (a, b) {
      if (b) "string" == typeof b && (b = [b]);else return a;

      for (var c = -1, d = 0; d < b.length; d++) {
        if ("" != b[d]) {
          var e = a.lastIndexOf(b[d]);
          e > c && (c = e);
        }
      }

      return -1 == c ? a : a.slice(c + 1);
    };

    goog.string.editDistance = function (a, b) {
      var c = [],
          d = [];
      if (a == b) return 0;
      if (!a.length || !b.length) return Math.max(a.length, b.length);

      for (var e = 0; e < b.length + 1; e++) {
        c[e] = e;
      }

      for (e = 0; e < a.length; e++) {
        d[0] = e + 1;

        for (var f = 0; f < b.length; f++) {
          d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
        }

        for (f = 0; f < c.length; f++) {
          c[f] = d[f];
        }
      }

      return d[b.length];
    };

    goog.labs.userAgent.engine = {};

    goog.labs.userAgent.engine.isPresto = function () {
      return goog.labs.userAgent.util.matchUserAgent("Presto");
    };

    goog.labs.userAgent.engine.isTrident = function () {
      return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
    };

    goog.labs.userAgent.engine.isEdge = function () {
      return goog.labs.userAgent.util.matchUserAgent("Edge");
    };

    goog.labs.userAgent.engine.isWebKit = function () {
      return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
    };

    goog.labs.userAgent.engine.isGecko = function () {
      return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
    };

    goog.labs.userAgent.engine.getVersion = function () {
      var a = goog.labs.userAgent.util.getUserAgent();

      if (a) {
        a = goog.labs.userAgent.util.extractVersionTuples(a);
        var b = goog.labs.userAgent.engine.getEngineTuple_(a);
        if (b) return "Gecko" == b[0] ? goog.labs.userAgent.engine.getVersionForKey_(a, "Firefox") : b[1];
        a = a[0];
        var c;
        if (a && (c = a[2]) && (c = /Trident\/([^\s;]+)/.exec(c))) return c[1];
      }

      return "";
    };

    goog.labs.userAgent.engine.getEngineTuple_ = function (a) {
      if (!goog.labs.userAgent.engine.isEdge()) return a[1];

      for (var b = 0; b < a.length; b++) {
        var c = a[b];
        if ("Edge" == c[0]) return c;
      }
    };

    goog.labs.userAgent.engine.isVersionOrHigher = function (a) {
      return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), a);
    };

    goog.labs.userAgent.engine.getVersionForKey_ = function (a, b) {
      return (a = goog.array.find(a, function (a) {
        return b == a[0];
      })) && a[1] || "";
    };

    goog.labs.userAgent.platform = {};

    goog.labs.userAgent.platform.isAndroid = function () {
      return goog.labs.userAgent.util.matchUserAgent("Android");
    };

    goog.labs.userAgent.platform.isIpod = function () {
      return goog.labs.userAgent.util.matchUserAgent("iPod");
    };

    goog.labs.userAgent.platform.isIphone = function () {
      return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
    };

    goog.labs.userAgent.platform.isIpad = function () {
      return goog.labs.userAgent.util.matchUserAgent("iPad");
    };

    goog.labs.userAgent.platform.isIos = function () {
      return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
    };

    goog.labs.userAgent.platform.isMacintosh = function () {
      return goog.labs.userAgent.util.matchUserAgent("Macintosh");
    };

    goog.labs.userAgent.platform.isLinux = function () {
      return goog.labs.userAgent.util.matchUserAgent("Linux");
    };

    goog.labs.userAgent.platform.isWindows = function () {
      return goog.labs.userAgent.util.matchUserAgent("Windows");
    };

    goog.labs.userAgent.platform.isChromeOS = function () {
      return goog.labs.userAgent.util.matchUserAgent("CrOS");
    };

    goog.labs.userAgent.platform.isChromecast = function () {
      return goog.labs.userAgent.util.matchUserAgent("CrKey");
    };

    goog.labs.userAgent.platform.isKaiOS = function () {
      return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
    };

    goog.labs.userAgent.platform.isGo2Phone = function () {
      return goog.labs.userAgent.util.matchUserAgentIgnoreCase("GAFP");
    };

    goog.labs.userAgent.platform.getVersion = function () {
      var a = goog.labs.userAgent.util.getUserAgent(),
          b = "";
      goog.labs.userAgent.platform.isWindows() ? (b = /Windows (?:NT|Phone) ([0-9.]+)/, b = (a = b.exec(a)) ? a[1] : "0.0") : goog.labs.userAgent.platform.isIos() ? (b = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/, b = (a = b.exec(a)) && a[1].replace(/_/g, ".")) : goog.labs.userAgent.platform.isMacintosh() ? (b = /Mac OS X ([0-9_.]+)/, b = (a = b.exec(a)) ? a[1].replace(/_/g, ".") : "10") : goog.labs.userAgent.platform.isKaiOS() ? (b = /(?:KaiOS)\/(\S+)/i, b = (a = b.exec(a)) && a[1]) : goog.labs.userAgent.platform.isAndroid() ? (b = /Android\s+([^\);]+)(\)|;)/, b = (a = b.exec(a)) && a[1]) : goog.labs.userAgent.platform.isChromeOS() && (b = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/, b = (a = b.exec(a)) && a[1]);
      return b || "";
    };

    goog.labs.userAgent.platform.isVersionOrHigher = function (a) {
      return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), a);
    };

    goog.reflect = {};

    goog.reflect.object = function (a, b) {
      return b;
    };

    goog.reflect.objectProperty = function (a, b) {
      return a;
    };

    goog.reflect.sinkValue = function (a) {
      goog.reflect.sinkValue[" "](a);
      return a;
    };

    goog.reflect.sinkValue[" "] = goog.nullFunction;

    goog.reflect.canAccessProperty = function (a, b) {
      try {
        return goog.reflect.sinkValue(a[b]), !0;
      } catch (c) {}

      return !1;
    };

    goog.reflect.cache = function (a, b, c, d) {
      d = d ? d(b) : b;
      return Object.prototype.hasOwnProperty.call(a, d) ? a[d] : a[d] = c(b);
    };

    goog.userAgent = {};
    goog.userAgent.ASSUME_IE = !1;
    goog.userAgent.ASSUME_EDGE = !1;
    goog.userAgent.ASSUME_GECKO = !1;
    goog.userAgent.ASSUME_WEBKIT = !1;
    goog.userAgent.ASSUME_MOBILE_WEBKIT = !1;
    goog.userAgent.ASSUME_OPERA = !1;
    goog.userAgent.ASSUME_ANY_VERSION = !1;
    goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA;

    goog.userAgent.getUserAgentString = function () {
      return goog.labs.userAgent.util.getUserAgent();
    };

    goog.userAgent.getNavigatorTyped = function () {
      return goog.global.navigator || null;
    };

    goog.userAgent.getNavigator = function () {
      return goog.userAgent.getNavigatorTyped();
    };

    goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera();
    goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE();
    goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge();
    goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE;
    goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko();
    goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit();

    goog.userAgent.isMobile_ = function () {
      return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
    };

    goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_();
    goog.userAgent.SAFARI = goog.userAgent.WEBKIT;

    goog.userAgent.determinePlatform_ = function () {
      var a = goog.userAgent.getNavigatorTyped();
      return a && a.platform || "";
    };

    goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_();
    goog.userAgent.ASSUME_MAC = !1;
    goog.userAgent.ASSUME_WINDOWS = !1;
    goog.userAgent.ASSUME_LINUX = !1;
    goog.userAgent.ASSUME_X11 = !1;
    goog.userAgent.ASSUME_ANDROID = !1;
    goog.userAgent.ASSUME_IPHONE = !1;
    goog.userAgent.ASSUME_IPAD = !1;
    goog.userAgent.ASSUME_IPOD = !1;
    goog.userAgent.ASSUME_KAIOS = !1;
    goog.userAgent.ASSUME_GO2PHONE = !1;
    goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD;
    goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh();
    goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows();

    goog.userAgent.isLegacyLinux_ = function () {
      return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
    };

    goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_();

    goog.userAgent.isX11_ = function () {
      var a = goog.userAgent.getNavigatorTyped();
      return !!a && goog.string.contains(a.appVersion || "", "X11");
    };

    goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_();
    goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid();
    goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone();
    goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad();
    goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod();
    goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos();
    goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS();
    goog.userAgent.GO2PHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_GO2PHONE : goog.labs.userAgent.platform.isGo2Phone();

    goog.userAgent.determineVersion_ = function () {
      var a = "",
          b = goog.userAgent.getVersionRegexResult_();
      b && (a = b ? b[1] : "");
      return goog.userAgent.IE && (b = goog.userAgent.getDocumentMode_(), null != b && b > parseFloat(a)) ? String(b) : a;
    };

    goog.userAgent.getVersionRegexResult_ = function () {
      var a = goog.userAgent.getUserAgentString();
      if (goog.userAgent.GECKO) return /rv:([^\);]+)(\)|;)/.exec(a);
      if (goog.userAgent.EDGE) return /Edge\/([\d\.]+)/.exec(a);
      if (goog.userAgent.IE) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
      if (goog.userAgent.WEBKIT) return /WebKit\/(\S+)/.exec(a);
      if (goog.userAgent.OPERA) return /(?:Version)[ \/]?(\S+)/.exec(a);
    };

    goog.userAgent.getDocumentMode_ = function () {
      var a = goog.global.document;
      return a ? a.documentMode : void 0;
    };

    goog.userAgent.VERSION = goog.userAgent.determineVersion_();

    goog.userAgent.compare = function (a, b) {
      return goog.string.compareVersions(a, b);
    };

    goog.userAgent.isVersionOrHigherCache_ = {};

    goog.userAgent.isVersionOrHigher = function (a) {
      return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, a, function () {
        return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, a);
      });
    };

    goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher;

    goog.userAgent.isDocumentModeOrHigher = function (a) {
      return Number(goog.userAgent.DOCUMENT_MODE) >= a;
    };

    goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher;

    goog.userAgent.DOCUMENT_MODE = function () {
      if (goog.global.document && goog.userAgent.IE) return goog.userAgent.getDocumentMode_();
    }();

    goog.userAgent.product = {};
    goog.userAgent.product.ASSUME_FIREFOX = !1;
    goog.userAgent.product.ASSUME_IPHONE = !1;
    goog.userAgent.product.ASSUME_IPAD = !1;
    goog.userAgent.product.ASSUME_ANDROID = !1;
    goog.userAgent.product.ASSUME_CHROME = !1;
    goog.userAgent.product.ASSUME_SAFARI = !1;
    goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI;
    goog.userAgent.product.OPERA = goog.userAgent.OPERA;
    goog.userAgent.product.IE = goog.userAgent.IE;
    goog.userAgent.product.EDGE = goog.userAgent.EDGE;
    goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox();

    goog.userAgent.product.isIphoneOrIpod_ = function () {
      return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
    };

    goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_();
    goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad();
    goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser();
    goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome();

    goog.userAgent.product.isSafariDesktop_ = function () {
      return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
    };

    goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_();
    goog.crypt.base64 = {};
    goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=";
    goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.";
    goog.crypt.base64.Alphabet = {
      DEFAULT: 0,
      NO_PADDING: 1,
      WEBSAFE: 2,
      WEBSAFE_DOT_PADDING: 3,
      WEBSAFE_NO_PADDING: 4
    };
    goog.crypt.base64.paddingChars_ = "=.";

    goog.crypt.base64.isPadding_ = function (a) {
      return goog.string.contains(goog.crypt.base64.paddingChars_, a);
    };

    goog.crypt.base64.byteToCharMaps_ = {};
    goog.crypt.base64.charToByteMap_ = null;
    goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA;
    goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || "function" == typeof goog.global.btoa;
    goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && "function" == typeof goog.global.atob;

    goog.crypt.base64.encodeByteArray = function (a, b) {
      goog.asserts.assert(goog.isArrayLike(a), "encodeByteArray takes an array as a parameter");
      void 0 === b && (b = goog.crypt.base64.Alphabet.DEFAULT);
      goog.crypt.base64.init_();
      b = goog.crypt.base64.byteToCharMaps_[b];

      for (var c = [], d = 0; d < a.length; d += 3) {
        var e = a[d],
            f = d + 1 < a.length,
            g = f ? a[d + 1] : 0,
            h = d + 2 < a.length,
            k = h ? a[d + 2] : 0,
            l = e >> 2;
        e = (e & 3) << 4 | g >> 4;
        g = (g & 15) << 2 | k >> 6;
        k &= 63;
        h || (k = 64, f || (g = 64));
        c.push(b[l], b[e], b[g] || "", b[k] || "");
      }

      return c.join("");
    };

    goog.crypt.base64.encodeString = function (a, b) {
      return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !b ? goog.global.btoa(a) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(a), b);
    };

    goog.crypt.base64.decodeString = function (a, b) {
      if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !b) return goog.global.atob(a);
      var c = "";
      goog.crypt.base64.decodeStringInternal_(a, function (a) {
        c += String.fromCharCode(a);
      });
      return c;
    };

    goog.crypt.base64.decodeStringToByteArray = function (a, b) {
      var c = [];
      goog.crypt.base64.decodeStringInternal_(a, function (a) {
        c.push(a);
      });
      return c;
    };

    goog.crypt.base64.decodeStringToUint8Array = function (a) {
      goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
      var b = a.length,
          c = 3 * b / 4;
      c % 3 ? c = Math.floor(c) : goog.crypt.base64.isPadding_(a[b - 1]) && (c = goog.crypt.base64.isPadding_(a[b - 2]) ? c - 2 : c - 1);
      var d = new Uint8Array(c),
          e = 0;
      goog.crypt.base64.decodeStringInternal_(a, function (a) {
        d[e++] = a;
      });
      return d.subarray(0, e);
    };

    goog.crypt.base64.decodeStringInternal_ = function (a, b) {
      function c(b) {
        for (; d < a.length;) {
          var c = a.charAt(d++),
              e = goog.crypt.base64.charToByteMap_[c];
          if (null != e) return e;
          if (!goog.string.isEmptyOrWhitespace(c)) throw Error("Unknown base64 encoding at char: " + c);
        }

        return b;
      }

      goog.crypt.base64.init_();

      for (var d = 0;;) {
        var e = c(-1),
            f = c(0),
            g = c(64),
            h = c(64);
        if (64 === h && -1 === e) break;
        b(e << 2 | f >> 4);
        64 != g && (b(f << 4 & 240 | g >> 2), 64 != h && b(g << 6 & 192 | h));
      }
    };

    goog.crypt.base64.init_ = function () {
      if (!goog.crypt.base64.charToByteMap_) {
        goog.crypt.base64.charToByteMap_ = {};

        for (var a = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
          var d = a.concat(b[c].split(""));
          goog.crypt.base64.byteToCharMaps_[c] = d;

          for (var e = 0; e < d.length; e++) {
            var f = d[e],
                g = goog.crypt.base64.charToByteMap_[f];
            void 0 === g ? goog.crypt.base64.charToByteMap_[f] = e : goog.asserts.assert(g === e);
          }
        }
      }
    };

    jspb.utils = {};
    jspb.utils.split64Low = 0;
    jspb.utils.split64High = 0;

    jspb.utils.splitUint64 = function (a) {
      var b = a >>> 0;
      a = Math.floor((a - b) / jspb.BinaryConstants.TWO_TO_32) >>> 0;
      jspb.utils.split64Low = b;
      jspb.utils.split64High = a;
    };

    jspb.utils.splitInt64 = function (a) {
      var b = 0 > a;
      a = Math.abs(a);
      var c = a >>> 0;
      a = Math.floor((a - c) / jspb.BinaryConstants.TWO_TO_32);
      a >>>= 0;
      b && (a = ~a >>> 0, c = (~c >>> 0) + 1, 4294967295 < c && (c = 0, a++, 4294967295 < a && (a = 0)));
      jspb.utils.split64Low = c;
      jspb.utils.split64High = a;
    };

    jspb.utils.splitZigzag64 = function (a) {
      var b = 0 > a;
      a = 2 * Math.abs(a);
      jspb.utils.splitUint64(a);
      a = jspb.utils.split64Low;
      var c = jspb.utils.split64High;
      b && (0 == a ? 0 == c ? c = a = 4294967295 : (c--, a = 4294967295) : a--);
      jspb.utils.split64Low = a;
      jspb.utils.split64High = c;
    };

    jspb.utils.splitFloat32 = function (a) {
      var b = 0 > a ? 1 : 0;
      a = b ? -a : a;
      if (0 === a) 0 < 1 / a ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);else if (isNaN(a)) jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;else if (a > jspb.BinaryConstants.FLOAT32_MAX) jspb.utils.split64High = 0, jspb.utils.split64Low = (b << 31 | 2139095040) >>> 0;else if (a < jspb.BinaryConstants.FLOAT32_MIN) a = Math.round(a / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (b << 31 | a) >>> 0;else {
        var c = Math.floor(Math.log(a) / Math.LN2);
        a *= Math.pow(2, -c);
        a = Math.round(a * jspb.BinaryConstants.TWO_TO_23);
        16777216 <= a && ++c;
        jspb.utils.split64High = 0;
        jspb.utils.split64Low = (b << 31 | c + 127 << 23 | a & 8388607) >>> 0;
      }
    };

    jspb.utils.splitFloat64 = function (a) {
      var b = 0 > a ? 1 : 0;
      a = b ? -a : a;
      if (0 === a) jspb.utils.split64High = 0 < 1 / a ? 0 : 2147483648, jspb.utils.split64Low = 0;else if (isNaN(a)) jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;else if (a > jspb.BinaryConstants.FLOAT64_MAX) jspb.utils.split64High = (b << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;else if (a < jspb.BinaryConstants.FLOAT64_MIN) {
        var c = a / Math.pow(2, -1074);
        a = c / jspb.BinaryConstants.TWO_TO_32;
        jspb.utils.split64High = (b << 31 | a) >>> 0;
        jspb.utils.split64Low = c >>> 0;
      } else {
        c = a;
        var d = 0;
        if (2 <= c) for (; 2 <= c && 1023 > d;) {
          d++, c /= 2;
        } else for (; 1 > c && -1022 < d;) {
          c *= 2, d--;
        }
        c = a * Math.pow(2, -d);
        a = c * jspb.BinaryConstants.TWO_TO_20 & 1048575;
        c = c * jspb.BinaryConstants.TWO_TO_52 >>> 0;
        jspb.utils.split64High = (b << 31 | d + 1023 << 20 | a) >>> 0;
        jspb.utils.split64Low = c;
      }
    };

    jspb.utils.splitHash64 = function (a) {
      var b = a.charCodeAt(0),
          c = a.charCodeAt(1),
          d = a.charCodeAt(2),
          e = a.charCodeAt(3),
          f = a.charCodeAt(4),
          g = a.charCodeAt(5),
          h = a.charCodeAt(6);
      a = a.charCodeAt(7);
      jspb.utils.split64Low = b + (c << 8) + (d << 16) + (e << 24) >>> 0;
      jspb.utils.split64High = f + (g << 8) + (h << 16) + (a << 24) >>> 0;
    };

    jspb.utils.joinUint64 = function (a, b) {
      return b * jspb.BinaryConstants.TWO_TO_32 + (a >>> 0);
    };

    jspb.utils.joinInt64 = function (a, b) {
      var c = b & 2147483648;
      c && (a = ~a + 1 >>> 0, b = ~b >>> 0, 0 == a && (b = b + 1 >>> 0));
      a = jspb.utils.joinUint64(a, b);
      return c ? -a : a;
    };

    jspb.utils.toZigzag64 = function (a, b, c) {
      var d = b >> 31;
      return c(a << 1 ^ d, (b << 1 | a >>> 31) ^ d);
    };

    jspb.utils.joinZigzag64 = function (a, b) {
      return jspb.utils.fromZigzag64(a, b, jspb.utils.joinInt64);
    };

    jspb.utils.fromZigzag64 = function (a, b, c) {
      var d = -(a & 1);
      return c((a >>> 1 | b << 31) ^ d, b >>> 1 ^ d);
    };

    jspb.utils.joinFloat32 = function (a, b) {
      b = 2 * (a >> 31) + 1;
      var c = a >>> 23 & 255;
      a &= 8388607;
      return 255 == c ? a ? NaN : Infinity * b : 0 == c ? b * Math.pow(2, -149) * a : b * Math.pow(2, c - 150) * (a + Math.pow(2, 23));
    };

    jspb.utils.joinFloat64 = function (a, b) {
      var c = 2 * (b >> 31) + 1,
          d = b >>> 20 & 2047;
      a = jspb.BinaryConstants.TWO_TO_32 * (b & 1048575) + a;
      return 2047 == d ? a ? NaN : Infinity * c : 0 == d ? c * Math.pow(2, -1074) * a : c * Math.pow(2, d - 1075) * (a + jspb.BinaryConstants.TWO_TO_52);
    };

    jspb.utils.joinHash64 = function (a, b) {
      return String.fromCharCode(a >>> 0 & 255, a >>> 8 & 255, a >>> 16 & 255, a >>> 24 & 255, b >>> 0 & 255, b >>> 8 & 255, b >>> 16 & 255, b >>> 24 & 255);
    };

    jspb.utils.DIGITS = "0123456789abcdef".split("");
    jspb.utils.ZERO_CHAR_CODE_ = 48;
    jspb.utils.A_CHAR_CODE_ = 97;

    jspb.utils.joinUnsignedDecimalString = function (a, b) {
      function c(a, b) {
        a = a ? String(a) : "";
        return b ? "0000000".slice(a.length) + a : a;
      }

      if (2097151 >= b) return "" + jspb.utils.joinUint64(a, b);
      var d = (a >>> 24 | b << 8) >>> 0 & 16777215;
      b = b >> 16 & 65535;
      a = (a & 16777215) + 6777216 * d + 6710656 * b;
      d += 8147497 * b;
      b *= 2;
      1E7 <= a && (d += Math.floor(a / 1E7), a %= 1E7);
      1E7 <= d && (b += Math.floor(d / 1E7), d %= 1E7);
      return c(b, 0) + c(d, b) + c(a, 1);
    };

    jspb.utils.joinSignedDecimalString = function (a, b) {
      var c = b & 2147483648;
      c && (a = ~a + 1 >>> 0, b = ~b + (0 == a ? 1 : 0) >>> 0);
      a = jspb.utils.joinUnsignedDecimalString(a, b);
      return c ? "-" + a : a;
    };

    jspb.utils.hash64ToDecimalString = function (a, b) {
      jspb.utils.splitHash64(a);
      a = jspb.utils.split64Low;
      var c = jspb.utils.split64High;
      return b ? jspb.utils.joinSignedDecimalString(a, c) : jspb.utils.joinUnsignedDecimalString(a, c);
    };

    jspb.utils.hash64ArrayToDecimalStrings = function (a, b) {
      for (var c = Array(a.length), d = 0; d < a.length; d++) {
        c[d] = jspb.utils.hash64ToDecimalString(a[d], b);
      }

      return c;
    };

    jspb.utils.decimalStringToHash64 = function (a) {
      function b(a, b) {
        for (var c = 0; 8 > c && (1 !== a || 0 < b); c++) {
          b = a * e[c] + b, e[c] = b & 255, b >>>= 8;
        }
      }

      function c() {
        for (var a = 0; 8 > a; a++) {
          e[a] = ~e[a] & 255;
        }
      }

      goog.asserts.assert(0 < a.length);
      var d = !1;
      "-" === a[0] && (d = !0, a = a.slice(1));

      for (var e = [0, 0, 0, 0, 0, 0, 0, 0], f = 0; f < a.length; f++) {
        b(10, a.charCodeAt(f) - jspb.utils.ZERO_CHAR_CODE_);
      }

      d && (c(), b(1, 1));
      return goog.crypt.byteArrayToString(e);
    };

    jspb.utils.splitDecimalString = function (a) {
      jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a));
    };

    jspb.utils.toHexDigit_ = function (a) {
      return String.fromCharCode(10 > a ? jspb.utils.ZERO_CHAR_CODE_ + a : jspb.utils.A_CHAR_CODE_ - 10 + a);
    };

    jspb.utils.fromHexCharCode_ = function (a) {
      return a >= jspb.utils.A_CHAR_CODE_ ? a - jspb.utils.A_CHAR_CODE_ + 10 : a - jspb.utils.ZERO_CHAR_CODE_;
    };

    jspb.utils.hash64ToHexString = function (a) {
      var b = Array(18);
      b[0] = "0";
      b[1] = "x";

      for (var c = 0; 8 > c; c++) {
        var d = a.charCodeAt(7 - c);
        b[2 * c + 2] = jspb.utils.toHexDigit_(d >> 4);
        b[2 * c + 3] = jspb.utils.toHexDigit_(d & 15);
      }

      return b.join("");
    };

    jspb.utils.hexStringToHash64 = function (a) {
      a = a.toLowerCase();
      goog.asserts.assert(18 == a.length);
      goog.asserts.assert("0" == a[0]);
      goog.asserts.assert("x" == a[1]);

      for (var b = "", c = 0; 8 > c; c++) {
        var d = jspb.utils.fromHexCharCode_(a.charCodeAt(2 * c + 2)),
            e = jspb.utils.fromHexCharCode_(a.charCodeAt(2 * c + 3));
        b = String.fromCharCode(16 * d + e) + b;
      }

      return b;
    };

    jspb.utils.hash64ToNumber = function (a, b) {
      jspb.utils.splitHash64(a);
      a = jspb.utils.split64Low;
      var c = jspb.utils.split64High;
      return b ? jspb.utils.joinInt64(a, c) : jspb.utils.joinUint64(a, c);
    };

    jspb.utils.numberToHash64 = function (a) {
      jspb.utils.splitInt64(a);
      return jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
    };

    jspb.utils.countVarints = function (a, b, c) {
      for (var d = 0, e = b; e < c; e++) {
        d += a[e] >> 7;
      }

      return c - b - d;
    };

    jspb.utils.countVarintFields = function (a, b, c, d) {
      var e = 0;
      d = 8 * d + jspb.BinaryConstants.WireType.VARINT;
      if (128 > d) for (; b < c && a[b++] == d;) {
        for (e++;;) {
          var f = a[b++];
          if (0 == (f & 128)) break;
        }
      } else for (; b < c;) {
        for (f = d; 128 < f;) {
          if (a[b] != (f & 127 | 128)) return e;
          b++;
          f >>= 7;
        }

        if (a[b++] != f) break;

        for (e++; f = a[b++], 0 != (f & 128);) {
        }
      }
      return e;
    };

    jspb.utils.countFixedFields_ = function (a, b, c, d, e) {
      var f = 0;
      if (128 > d) for (; b < c && a[b++] == d;) {
        f++, b += e;
      } else for (; b < c;) {
        for (var g = d; 128 < g;) {
          if (a[b++] != (g & 127 | 128)) return f;
          g >>= 7;
        }

        if (a[b++] != g) break;
        f++;
        b += e;
      }
      return f;
    };

    jspb.utils.countFixed32Fields = function (a, b, c, d) {
      return jspb.utils.countFixedFields_(a, b, c, 8 * d + jspb.BinaryConstants.WireType.FIXED32, 4);
    };

    jspb.utils.countFixed64Fields = function (a, b, c, d) {
      return jspb.utils.countFixedFields_(a, b, c, 8 * d + jspb.BinaryConstants.WireType.FIXED64, 8);
    };

    jspb.utils.countDelimitedFields = function (a, b, c, d) {
      var e = 0;

      for (d = 8 * d + jspb.BinaryConstants.WireType.DELIMITED; b < c;) {
        for (var f = d; 128 < f;) {
          if (a[b++] != (f & 127 | 128)) return e;
          f >>= 7;
        }

        if (a[b++] != f) break;
        e++;

        for (var g = 0, h = 1; f = a[b++], g += (f & 127) * h, h *= 128, 0 != (f & 128);) {
        }

        b += g;
      }

      return e;
    };

    jspb.utils.debugBytesToTextFormat = function (a) {
      var b = '"';

      if (a) {
        a = jspb.utils.byteSourceToUint8Array(a);

        for (var c = 0; c < a.length; c++) {
          b += "\\x", 16 > a[c] && (b += "0"), b += a[c].toString(16);
        }
      }

      return b + '"';
    };

    jspb.utils.debugScalarToTextFormat = function (a) {
      return "string" === typeof a ? goog.string.quote(a) : a.toString();
    };

    jspb.utils.stringToByteArray = function (a) {
      for (var b = new Uint8Array(a.length), c = 0; c < a.length; c++) {
        var d = a.charCodeAt(c);
        if (255 < d) throw Error("Conversion error: string contains codepoint outside of byte range");
        b[c] = d;
      }

      return b;
    };

    jspb.utils.byteSourceToUint8Array = function (a) {
      if (a.constructor === Uint8Array) return a;
      if (a.constructor === ArrayBuffer || "undefined" != typeof Buffer$1 && a.constructor === Buffer$1 || a.constructor === Array) return new Uint8Array(a);
      if (a.constructor === String) return goog.crypt.base64.decodeStringToUint8Array(a);
      goog.asserts.fail("Type not convertible to Uint8Array.");
      return new Uint8Array(0);
    };

    jspb.BinaryDecoder = function (a, b, c) {
      this.bytes_ = null;
      this.cursor_ = this.end_ = this.start_ = 0;
      this.error_ = !1;
      a && this.setBlock(a, b, c);
    };

    jspb.BinaryDecoder.instanceCache_ = [];

    jspb.BinaryDecoder.alloc = function (a, b, c) {
      if (jspb.BinaryDecoder.instanceCache_.length) {
        var d = jspb.BinaryDecoder.instanceCache_.pop();
        a && d.setBlock(a, b, c);
        return d;
      }

      return new jspb.BinaryDecoder(a, b, c);
    };

    jspb.BinaryDecoder.prototype.free = function () {
      this.clear();
      100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
    };

    jspb.BinaryDecoder.prototype.clone = function () {
      return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
    };

    jspb.BinaryDecoder.prototype.clear = function () {
      this.bytes_ = null;
      this.cursor_ = this.end_ = this.start_ = 0;
      this.error_ = !1;
    };

    jspb.BinaryDecoder.prototype.getBuffer = function () {
      return this.bytes_;
    };

    jspb.BinaryDecoder.prototype.setBlock = function (a, b, c) {
      this.bytes_ = jspb.utils.byteSourceToUint8Array(a);
      this.start_ = void 0 !== b ? b : 0;
      this.end_ = void 0 !== c ? this.start_ + c : this.bytes_.length;
      this.cursor_ = this.start_;
    };

    jspb.BinaryDecoder.prototype.getEnd = function () {
      return this.end_;
    };

    jspb.BinaryDecoder.prototype.setEnd = function (a) {
      this.end_ = a;
    };

    jspb.BinaryDecoder.prototype.reset = function () {
      this.cursor_ = this.start_;
    };

    jspb.BinaryDecoder.prototype.getCursor = function () {
      return this.cursor_;
    };

    jspb.BinaryDecoder.prototype.setCursor = function (a) {
      this.cursor_ = a;
    };

    jspb.BinaryDecoder.prototype.advance = function (a) {
      this.cursor_ += a;
      goog.asserts.assert(this.cursor_ <= this.end_);
    };

    jspb.BinaryDecoder.prototype.atEnd = function () {
      return this.cursor_ == this.end_;
    };

    jspb.BinaryDecoder.prototype.pastEnd = function () {
      return this.cursor_ > this.end_;
    };

    jspb.BinaryDecoder.prototype.getError = function () {
      return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
    };

    jspb.BinaryDecoder.prototype.readSplitVarint64 = function (a) {
      for (var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++) {
        b = this.bytes_[this.cursor_++], c |= (b & 127) << 7 * e;
      }

      128 <= b && (b = this.bytes_[this.cursor_++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
      if (128 <= b) for (e = 0; 5 > e && 128 <= b; e++) {
        b = this.bytes_[this.cursor_++], d |= (b & 127) << 7 * e + 3;
      }
      if (128 > b) return a(c >>> 0, d >>> 0);
      goog.asserts.fail("Failed to read varint, encoding is invalid.");
      this.error_ = !0;
    };

    jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function (a) {
      return this.readSplitVarint64(function (b, c) {
        return jspb.utils.fromZigzag64(b, c, a);
      });
    };

    jspb.BinaryDecoder.prototype.readSplitFixed64 = function (a) {
      var b = this.bytes_,
          c = this.cursor_;
      this.cursor_ += 8;

      for (var d = 0, e = 0, f = c + 7; f >= c; f--) {
        d = d << 8 | b[f], e = e << 8 | b[f + 4];
      }

      return a(d, e);
    };

    jspb.BinaryDecoder.prototype.skipVarint = function () {
      for (; this.bytes_[this.cursor_] & 128;) {
        this.cursor_++;
      }

      this.cursor_++;
    };

    jspb.BinaryDecoder.prototype.unskipVarint = function (a) {
      for (; 128 < a;) {
        this.cursor_--, a >>>= 7;
      }

      this.cursor_--;
    };

    jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function () {
      var a = this.bytes_;
      var b = a[this.cursor_ + 0];
      var c = b & 127;
      if (128 > b) return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), c;
      b = a[this.cursor_ + 1];
      c |= (b & 127) << 7;
      if (128 > b) return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), c;
      b = a[this.cursor_ + 2];
      c |= (b & 127) << 14;
      if (128 > b) return this.cursor_ += 3, goog.asserts.assert(this.cursor_ <= this.end_), c;
      b = a[this.cursor_ + 3];
      c |= (b & 127) << 21;
      if (128 > b) return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), c;
      b = a[this.cursor_ + 4];
      c |= (b & 15) << 28;
      if (128 > b) return this.cursor_ += 5, goog.asserts.assert(this.cursor_ <= this.end_), c >>> 0;
      this.cursor_ += 5;
      128 <= a[this.cursor_++] && 128 <= a[this.cursor_++] && 128 <= a[this.cursor_++] && 128 <= a[this.cursor_++] && 128 <= a[this.cursor_++] && goog.asserts.assert(!1);
      goog.asserts.assert(this.cursor_ <= this.end_);
      return c;
    };

    jspb.BinaryDecoder.prototype.readSignedVarint32 = jspb.BinaryDecoder.prototype.readUnsignedVarint32;

    jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function () {
      return this.readUnsignedVarint32().toString();
    };

    jspb.BinaryDecoder.prototype.readSignedVarint32String = function () {
      return this.readSignedVarint32().toString();
    };

    jspb.BinaryDecoder.prototype.readZigzagVarint32 = function () {
      var a = this.readUnsignedVarint32();
      return a >>> 1 ^ -(a & 1);
    };

    jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function () {
      return this.readSplitVarint64(jspb.utils.joinUint64);
    };

    jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function () {
      return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
    };

    jspb.BinaryDecoder.prototype.readSignedVarint64 = function () {
      return this.readSplitVarint64(jspb.utils.joinInt64);
    };

    jspb.BinaryDecoder.prototype.readSignedVarint64String = function () {
      return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
    };

    jspb.BinaryDecoder.prototype.readZigzagVarint64 = function () {
      return this.readSplitVarint64(jspb.utils.joinZigzag64);
    };

    jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function () {
      return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
    };

    jspb.BinaryDecoder.prototype.readZigzagVarint64String = function () {
      return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
    };

    jspb.BinaryDecoder.prototype.readUint8 = function () {
      var a = this.bytes_[this.cursor_ + 0];
      this.cursor_ += 1;
      goog.asserts.assert(this.cursor_ <= this.end_);
      return a;
    };

    jspb.BinaryDecoder.prototype.readUint16 = function () {
      var a = this.bytes_[this.cursor_ + 0],
          b = this.bytes_[this.cursor_ + 1];
      this.cursor_ += 2;
      goog.asserts.assert(this.cursor_ <= this.end_);
      return a << 0 | b << 8;
    };

    jspb.BinaryDecoder.prototype.readUint32 = function () {
      var a = this.bytes_[this.cursor_ + 0],
          b = this.bytes_[this.cursor_ + 1],
          c = this.bytes_[this.cursor_ + 2],
          d = this.bytes_[this.cursor_ + 3];
      this.cursor_ += 4;
      goog.asserts.assert(this.cursor_ <= this.end_);
      return (a << 0 | b << 8 | c << 16 | d << 24) >>> 0;
    };

    jspb.BinaryDecoder.prototype.readUint64 = function () {
      var a = this.readUint32(),
          b = this.readUint32();
      return jspb.utils.joinUint64(a, b);
    };

    jspb.BinaryDecoder.prototype.readUint64String = function () {
      var a = this.readUint32(),
          b = this.readUint32();
      return jspb.utils.joinUnsignedDecimalString(a, b);
    };

    jspb.BinaryDecoder.prototype.readInt8 = function () {
      var a = this.bytes_[this.cursor_ + 0];
      this.cursor_ += 1;
      goog.asserts.assert(this.cursor_ <= this.end_);
      return a << 24 >> 24;
    };

    jspb.BinaryDecoder.prototype.readInt16 = function () {
      var a = this.bytes_[this.cursor_ + 0],
          b = this.bytes_[this.cursor_ + 1];
      this.cursor_ += 2;
      goog.asserts.assert(this.cursor_ <= this.end_);
      return (a << 0 | b << 8) << 16 >> 16;
    };

    jspb.BinaryDecoder.prototype.readInt32 = function () {
      var a = this.bytes_[this.cursor_ + 0],
          b = this.bytes_[this.cursor_ + 1],
          c = this.bytes_[this.cursor_ + 2],
          d = this.bytes_[this.cursor_ + 3];
      this.cursor_ += 4;
      goog.asserts.assert(this.cursor_ <= this.end_);
      return a << 0 | b << 8 | c << 16 | d << 24;
    };

    jspb.BinaryDecoder.prototype.readInt64 = function () {
      var a = this.readUint32(),
          b = this.readUint32();
      return jspb.utils.joinInt64(a, b);
    };

    jspb.BinaryDecoder.prototype.readInt64String = function () {
      var a = this.readUint32(),
          b = this.readUint32();
      return jspb.utils.joinSignedDecimalString(a, b);
    };

    jspb.BinaryDecoder.prototype.readFloat = function () {
      var a = this.readUint32();
      return jspb.utils.joinFloat32(a, 0);
    };

    jspb.BinaryDecoder.prototype.readDouble = function () {
      var a = this.readUint32(),
          b = this.readUint32();
      return jspb.utils.joinFloat64(a, b);
    };

    jspb.BinaryDecoder.prototype.readBool = function () {
      return !!this.bytes_[this.cursor_++];
    };

    jspb.BinaryDecoder.prototype.readEnum = function () {
      return this.readSignedVarint32();
    };

    jspb.BinaryDecoder.prototype.readString = function (a) {
      var b = this.bytes_,
          c = this.cursor_;
      a = c + a;

      for (var d = [], e = ""; c < a;) {
        var f = b[c++];
        if (128 > f) d.push(f);else if (192 > f) continue;else if (224 > f) {
          var g = b[c++];
          d.push((f & 31) << 6 | g & 63);
        } else if (240 > f) {
          g = b[c++];
          var h = b[c++];
          d.push((f & 15) << 12 | (g & 63) << 6 | h & 63);
        } else if (248 > f) {
          g = b[c++];
          h = b[c++];
          var k = b[c++];
          f = (f & 7) << 18 | (g & 63) << 12 | (h & 63) << 6 | k & 63;
          f -= 65536;
          d.push((f >> 10 & 1023) + 55296, (f & 1023) + 56320);
        }
        8192 <= d.length && (e += String.fromCharCode.apply(null, d), d.length = 0);
      }

      e += goog.crypt.byteArrayToString(d);
      this.cursor_ = c;
      return e;
    };

    jspb.BinaryDecoder.prototype.readStringWithLength = function () {
      var a = this.readUnsignedVarint32();
      return this.readString(a);
    };

    jspb.BinaryDecoder.prototype.readBytes = function (a) {
      if (0 > a || this.cursor_ + a > this.bytes_.length) return this.error_ = !0, goog.asserts.fail("Invalid byte length!"), new Uint8Array(0);
      var b = this.bytes_.subarray(this.cursor_, this.cursor_ + a);
      this.cursor_ += a;
      goog.asserts.assert(this.cursor_ <= this.end_);
      return b;
    };

    jspb.BinaryDecoder.prototype.readVarintHash64 = function () {
      return this.readSplitVarint64(jspb.utils.joinHash64);
    };

    jspb.BinaryDecoder.prototype.readFixedHash64 = function () {
      var a = this.bytes_,
          b = this.cursor_,
          c = a[b + 0],
          d = a[b + 1],
          e = a[b + 2],
          f = a[b + 3],
          g = a[b + 4],
          h = a[b + 5],
          k = a[b + 6];
      a = a[b + 7];
      this.cursor_ += 8;
      return String.fromCharCode(c, d, e, f, g, h, k, a);
    };

    jspb.BinaryReader = function (a, b, c) {
      this.decoder_ = jspb.BinaryDecoder.alloc(a, b, c);
      this.fieldCursor_ = this.decoder_.getCursor();
      this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
      this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
      this.error_ = !1;
      this.readCallbacks_ = null;
    };

    jspb.BinaryReader.instanceCache_ = [];

    jspb.BinaryReader.alloc = function (a, b, c) {
      if (jspb.BinaryReader.instanceCache_.length) {
        var d = jspb.BinaryReader.instanceCache_.pop();
        a && d.decoder_.setBlock(a, b, c);
        return d;
      }

      return new jspb.BinaryReader(a, b, c);
    };

    jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc;

    jspb.BinaryReader.prototype.free = function () {
      this.decoder_.clear();
      this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
      this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
      this.error_ = !1;
      this.readCallbacks_ = null;
      100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
    };

    jspb.BinaryReader.prototype.getFieldCursor = function () {
      return this.fieldCursor_;
    };

    jspb.BinaryReader.prototype.getCursor = function () {
      return this.decoder_.getCursor();
    };

    jspb.BinaryReader.prototype.getBuffer = function () {
      return this.decoder_.getBuffer();
    };

    jspb.BinaryReader.prototype.getFieldNumber = function () {
      return this.nextField_;
    };

    jspb.BinaryReader.prototype.getWireType = function () {
      return this.nextWireType_;
    };

    jspb.BinaryReader.prototype.isDelimited = function () {
      return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
    };

    jspb.BinaryReader.prototype.isEndGroup = function () {
      return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
    };

    jspb.BinaryReader.prototype.getError = function () {
      return this.error_ || this.decoder_.getError();
    };

    jspb.BinaryReader.prototype.setBlock = function (a, b, c) {
      this.decoder_.setBlock(a, b, c);
      this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
      this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    };

    jspb.BinaryReader.prototype.reset = function () {
      this.decoder_.reset();
      this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
      this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    };

    jspb.BinaryReader.prototype.advance = function (a) {
      this.decoder_.advance(a);
    };

    jspb.BinaryReader.prototype.nextField = function () {
      if (this.decoder_.atEnd()) return !1;
      if (this.getError()) return goog.asserts.fail("Decoder hit an error"), !1;
      this.fieldCursor_ = this.decoder_.getCursor();
      var a = this.decoder_.readUnsignedVarint32(),
          b = a >>> 3;
      a &= 7;
      if (a != jspb.BinaryConstants.WireType.VARINT && a != jspb.BinaryConstants.WireType.FIXED32 && a != jspb.BinaryConstants.WireType.FIXED64 && a != jspb.BinaryConstants.WireType.DELIMITED && a != jspb.BinaryConstants.WireType.START_GROUP && a != jspb.BinaryConstants.WireType.END_GROUP) return goog.asserts.fail("Invalid wire type: %s (at position %s)", a, this.fieldCursor_), this.error_ = !0, !1;
      this.nextField_ = b;
      this.nextWireType_ = a;
      return !0;
    };

    jspb.BinaryReader.prototype.unskipHeader = function () {
      this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
    };

    jspb.BinaryReader.prototype.skipMatchingFields = function () {
      var a = this.nextField_;

      for (this.unskipHeader(); this.nextField() && this.getFieldNumber() == a;) {
        this.skipField();
      }

      this.decoder_.atEnd() || this.unskipHeader();
    };

    jspb.BinaryReader.prototype.skipVarintField = function () {
      this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (goog.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
    };

    jspb.BinaryReader.prototype.skipDelimitedField = function () {
      if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED) goog.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();else {
        var a = this.decoder_.readUnsignedVarint32();
        this.decoder_.advance(a);
      }
    };

    jspb.BinaryReader.prototype.skipFixed32Field = function () {
      this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (goog.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
    };

    jspb.BinaryReader.prototype.skipFixed64Field = function () {
      this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (goog.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
    };

    jspb.BinaryReader.prototype.skipGroup = function () {
      var a = this.nextField_;

      do {
        if (!this.nextField()) {
          goog.asserts.fail("Unmatched start-group tag: stream EOF");
          this.error_ = !0;
          break;
        }

        if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
          this.nextField_ != a && (goog.asserts.fail("Unmatched end-group tag"), this.error_ = !0);
          break;
        }

        this.skipField();
      } while (1);
    };

    jspb.BinaryReader.prototype.skipField = function () {
      switch (this.nextWireType_) {
        case jspb.BinaryConstants.WireType.VARINT:
          this.skipVarintField();
          break;

        case jspb.BinaryConstants.WireType.FIXED64:
          this.skipFixed64Field();
          break;

        case jspb.BinaryConstants.WireType.DELIMITED:
          this.skipDelimitedField();
          break;

        case jspb.BinaryConstants.WireType.FIXED32:
          this.skipFixed32Field();
          break;

        case jspb.BinaryConstants.WireType.START_GROUP:
          this.skipGroup();
          break;

        default:
          goog.asserts.fail("Invalid wire encoding for field.");
      }
    };

    jspb.BinaryReader.prototype.registerReadCallback = function (a, b) {
      null === this.readCallbacks_ && (this.readCallbacks_ = {});
      goog.asserts.assert(!this.readCallbacks_[a]);
      this.readCallbacks_[a] = b;
    };

    jspb.BinaryReader.prototype.runReadCallback = function (a) {
      goog.asserts.assert(null !== this.readCallbacks_);
      a = this.readCallbacks_[a];
      goog.asserts.assert(a);
      return a(this);
    };

    jspb.BinaryReader.prototype.readAny = function (a) {
      this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(a);
      var b = jspb.BinaryConstants.FieldType;

      switch (a) {
        case b.DOUBLE:
          return this.readDouble();

        case b.FLOAT:
          return this.readFloat();

        case b.INT64:
          return this.readInt64();

        case b.UINT64:
          return this.readUint64();

        case b.INT32:
          return this.readInt32();

        case b.FIXED64:
          return this.readFixed64();

        case b.FIXED32:
          return this.readFixed32();

        case b.BOOL:
          return this.readBool();

        case b.STRING:
          return this.readString();

        case b.GROUP:
          goog.asserts.fail("Group field type not supported in readAny()");

        case b.MESSAGE:
          goog.asserts.fail("Message field type not supported in readAny()");

        case b.BYTES:
          return this.readBytes();

        case b.UINT32:
          return this.readUint32();

        case b.ENUM:
          return this.readEnum();

        case b.SFIXED32:
          return this.readSfixed32();

        case b.SFIXED64:
          return this.readSfixed64();

        case b.SINT32:
          return this.readSint32();

        case b.SINT64:
          return this.readSint64();

        case b.FHASH64:
          return this.readFixedHash64();

        case b.VHASH64:
          return this.readVarintHash64();

        default:
          goog.asserts.fail("Invalid field type in readAny()");
      }

      return 0;
    };

    jspb.BinaryReader.prototype.readMessage = function (a, b) {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
      var c = this.decoder_.getEnd(),
          d = this.decoder_.readUnsignedVarint32();
      d = this.decoder_.getCursor() + d;
      this.decoder_.setEnd(d);
      b(a, this);
      this.decoder_.setCursor(d);
      this.decoder_.setEnd(c);
    };

    jspb.BinaryReader.prototype.readGroup = function (a, b, c) {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP);
      goog.asserts.assert(this.nextField_ == a);
      c(b, this);
      this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (goog.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = !0);
    };

    jspb.BinaryReader.prototype.getFieldDecoder = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
      var a = this.decoder_.readUnsignedVarint32(),
          b = this.decoder_.getCursor(),
          c = b + a;
      a = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), b, a);
      this.decoder_.setCursor(c);
      return a;
    };

    jspb.BinaryReader.prototype.readInt32 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readSignedVarint32();
    };

    jspb.BinaryReader.prototype.readInt32String = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readSignedVarint32String();
    };

    jspb.BinaryReader.prototype.readInt64 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readSignedVarint64();
    };

    jspb.BinaryReader.prototype.readInt64String = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readSignedVarint64String();
    };

    jspb.BinaryReader.prototype.readUint32 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readUnsignedVarint32();
    };

    jspb.BinaryReader.prototype.readUint32String = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readUnsignedVarint32String();
    };

    jspb.BinaryReader.prototype.readUint64 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readUnsignedVarint64();
    };

    jspb.BinaryReader.prototype.readUint64String = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readUnsignedVarint64String();
    };

    jspb.BinaryReader.prototype.readSint32 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readZigzagVarint32();
    };

    jspb.BinaryReader.prototype.readSint64 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readZigzagVarint64();
    };

    jspb.BinaryReader.prototype.readSint64String = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readZigzagVarint64String();
    };

    jspb.BinaryReader.prototype.readFixed32 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
      return this.decoder_.readUint32();
    };

    jspb.BinaryReader.prototype.readFixed64 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
      return this.decoder_.readUint64();
    };

    jspb.BinaryReader.prototype.readFixed64String = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
      return this.decoder_.readUint64String();
    };

    jspb.BinaryReader.prototype.readSfixed32 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
      return this.decoder_.readInt32();
    };

    jspb.BinaryReader.prototype.readSfixed32String = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
      return this.decoder_.readInt32().toString();
    };

    jspb.BinaryReader.prototype.readSfixed64 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
      return this.decoder_.readInt64();
    };

    jspb.BinaryReader.prototype.readSfixed64String = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
      return this.decoder_.readInt64String();
    };

    jspb.BinaryReader.prototype.readFloat = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
      return this.decoder_.readFloat();
    };

    jspb.BinaryReader.prototype.readDouble = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
      return this.decoder_.readDouble();
    };

    jspb.BinaryReader.prototype.readBool = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return !!this.decoder_.readUnsignedVarint32();
    };

    jspb.BinaryReader.prototype.readEnum = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readSignedVarint64();
    };

    jspb.BinaryReader.prototype.readString = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
      var a = this.decoder_.readUnsignedVarint32();
      return this.decoder_.readString(a);
    };

    jspb.BinaryReader.prototype.readBytes = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
      var a = this.decoder_.readUnsignedVarint32();
      return this.decoder_.readBytes(a);
    };

    jspb.BinaryReader.prototype.readVarintHash64 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readVarintHash64();
    };

    jspb.BinaryReader.prototype.readSintHash64 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readZigzagVarintHash64();
    };

    jspb.BinaryReader.prototype.readSplitVarint64 = function (a) {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readSplitVarint64(a);
    };

    jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function (a) {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
      return this.decoder_.readSplitVarint64(function (b, c) {
        return jspb.utils.fromZigzag64(b, c, a);
      });
    };

    jspb.BinaryReader.prototype.readFixedHash64 = function () {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
      return this.decoder_.readFixedHash64();
    };

    jspb.BinaryReader.prototype.readSplitFixed64 = function (a) {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
      return this.decoder_.readSplitFixed64(a);
    };

    jspb.BinaryReader.prototype.readPackedField_ = function (a) {
      goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
      var b = this.decoder_.readUnsignedVarint32();
      b = this.decoder_.getCursor() + b;

      for (var c = []; this.decoder_.getCursor() < b;) {
        c.push(a.call(this.decoder_));
      }

      return c;
    };

    jspb.BinaryReader.prototype.readPackedInt32 = function () {
      return this.readPackedField_(this.decoder_.readSignedVarint32);
    };

    jspb.BinaryReader.prototype.readPackedInt32String = function () {
      return this.readPackedField_(this.decoder_.readSignedVarint32String);
    };

    jspb.BinaryReader.prototype.readPackedInt64 = function () {
      return this.readPackedField_(this.decoder_.readSignedVarint64);
    };

    jspb.BinaryReader.prototype.readPackedInt64String = function () {
      return this.readPackedField_(this.decoder_.readSignedVarint64String);
    };

    jspb.BinaryReader.prototype.readPackedUint32 = function () {
      return this.readPackedField_(this.decoder_.readUnsignedVarint32);
    };

    jspb.BinaryReader.prototype.readPackedUint32String = function () {
      return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
    };

    jspb.BinaryReader.prototype.readPackedUint64 = function () {
      return this.readPackedField_(this.decoder_.readUnsignedVarint64);
    };

    jspb.BinaryReader.prototype.readPackedUint64String = function () {
      return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
    };

    jspb.BinaryReader.prototype.readPackedSint32 = function () {
      return this.readPackedField_(this.decoder_.readZigzagVarint32);
    };

    jspb.BinaryReader.prototype.readPackedSint64 = function () {
      return this.readPackedField_(this.decoder_.readZigzagVarint64);
    };

    jspb.BinaryReader.prototype.readPackedSint64String = function () {
      return this.readPackedField_(this.decoder_.readZigzagVarint64String);
    };

    jspb.BinaryReader.prototype.readPackedFixed32 = function () {
      return this.readPackedField_(this.decoder_.readUint32);
    };

    jspb.BinaryReader.prototype.readPackedFixed64 = function () {
      return this.readPackedField_(this.decoder_.readUint64);
    };

    jspb.BinaryReader.prototype.readPackedFixed64String = function () {
      return this.readPackedField_(this.decoder_.readUint64String);
    };

    jspb.BinaryReader.prototype.readPackedSfixed32 = function () {
      return this.readPackedField_(this.decoder_.readInt32);
    };

    jspb.BinaryReader.prototype.readPackedSfixed64 = function () {
      return this.readPackedField_(this.decoder_.readInt64);
    };

    jspb.BinaryReader.prototype.readPackedSfixed64String = function () {
      return this.readPackedField_(this.decoder_.readInt64String);
    };

    jspb.BinaryReader.prototype.readPackedFloat = function () {
      return this.readPackedField_(this.decoder_.readFloat);
    };

    jspb.BinaryReader.prototype.readPackedDouble = function () {
      return this.readPackedField_(this.decoder_.readDouble);
    };

    jspb.BinaryReader.prototype.readPackedBool = function () {
      return this.readPackedField_(this.decoder_.readBool);
    };

    jspb.BinaryReader.prototype.readPackedEnum = function () {
      return this.readPackedField_(this.decoder_.readEnum);
    };

    jspb.BinaryReader.prototype.readPackedVarintHash64 = function () {
      return this.readPackedField_(this.decoder_.readVarintHash64);
    };

    jspb.BinaryReader.prototype.readPackedFixedHash64 = function () {
      return this.readPackedField_(this.decoder_.readFixedHash64);
    };

    jspb.BinaryEncoder = function () {
      this.buffer_ = [];
    };

    jspb.BinaryEncoder.prototype.length = function () {
      return this.buffer_.length;
    };

    jspb.BinaryEncoder.prototype.end = function () {
      var a = this.buffer_;
      this.buffer_ = [];
      return a;
    };

    jspb.BinaryEncoder.prototype.writeSplitVarint64 = function (a, b) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(b == Math.floor(b));
      goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_32);

      for (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32); 0 < b || 127 < a;) {
        this.buffer_.push(a & 127 | 128), a = (a >>> 7 | b << 25) >>> 0, b >>>= 7;
      }

      this.buffer_.push(a);
    };

    jspb.BinaryEncoder.prototype.writeSplitFixed64 = function (a, b) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(b == Math.floor(b));
      goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_32);
      goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32);
      this.writeUint32(a);
      this.writeUint32(b);
    };

    jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function (a) {
      goog.asserts.assert(a == Math.floor(a));

      for (goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_32); 127 < a;) {
        this.buffer_.push(a & 127 | 128), a >>>= 7;
      }

      this.buffer_.push(a);
    };

    jspb.BinaryEncoder.prototype.writeSignedVarint32 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_31 && a < jspb.BinaryConstants.TWO_TO_31);
      if (0 <= a) this.writeUnsignedVarint32(a);else {
        for (var b = 0; 9 > b; b++) {
          this.buffer_.push(a & 127 | 128), a >>= 7;
        }

        this.buffer_.push(1);
      }
    };

    jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_64);
      jspb.utils.splitInt64(a);
      this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
    };

    jspb.BinaryEncoder.prototype.writeSignedVarint64 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_63 && a < jspb.BinaryConstants.TWO_TO_63);
      jspb.utils.splitInt64(a);
      this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
    };

    jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_31 && a < jspb.BinaryConstants.TWO_TO_31);
      this.writeUnsignedVarint32((a << 1 ^ a >> 31) >>> 0);
    };

    jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_63 && a < jspb.BinaryConstants.TWO_TO_63);
      jspb.utils.splitZigzag64(a);
      this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
    };

    jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function (a) {
      this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(a));
    };

    jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function (a) {
      var b = this;
      jspb.utils.splitHash64(a);
      jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function (a, d) {
        b.writeSplitVarint64(a >>> 0, d >>> 0);
      });
    };

    jspb.BinaryEncoder.prototype.writeUint8 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(0 <= a && 256 > a);
      this.buffer_.push(a >>> 0 & 255);
    };

    jspb.BinaryEncoder.prototype.writeUint16 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(0 <= a && 65536 > a);
      this.buffer_.push(a >>> 0 & 255);
      this.buffer_.push(a >>> 8 & 255);
    };

    jspb.BinaryEncoder.prototype.writeUint32 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_32);
      this.buffer_.push(a >>> 0 & 255);
      this.buffer_.push(a >>> 8 & 255);
      this.buffer_.push(a >>> 16 & 255);
      this.buffer_.push(a >>> 24 & 255);
    };

    jspb.BinaryEncoder.prototype.writeUint64 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_64);
      jspb.utils.splitUint64(a);
      this.writeUint32(jspb.utils.split64Low);
      this.writeUint32(jspb.utils.split64High);
    };

    jspb.BinaryEncoder.prototype.writeInt8 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(-128 <= a && 128 > a);
      this.buffer_.push(a >>> 0 & 255);
    };

    jspb.BinaryEncoder.prototype.writeInt16 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(-32768 <= a && 32768 > a);
      this.buffer_.push(a >>> 0 & 255);
      this.buffer_.push(a >>> 8 & 255);
    };

    jspb.BinaryEncoder.prototype.writeInt32 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_31 && a < jspb.BinaryConstants.TWO_TO_31);
      this.buffer_.push(a >>> 0 & 255);
      this.buffer_.push(a >>> 8 & 255);
      this.buffer_.push(a >>> 16 & 255);
      this.buffer_.push(a >>> 24 & 255);
    };

    jspb.BinaryEncoder.prototype.writeInt64 = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_63 && a < jspb.BinaryConstants.TWO_TO_63);
      jspb.utils.splitInt64(a);
      this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
    };

    jspb.BinaryEncoder.prototype.writeInt64String = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(+a >= -jspb.BinaryConstants.TWO_TO_63 && +a < jspb.BinaryConstants.TWO_TO_63);
      jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a));
      this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
    };

    jspb.BinaryEncoder.prototype.writeFloat = function (a) {
      goog.asserts.assert(Infinity === a || -Infinity === a || isNaN(a) || a >= -jspb.BinaryConstants.FLOAT32_MAX && a <= jspb.BinaryConstants.FLOAT32_MAX);
      jspb.utils.splitFloat32(a);
      this.writeUint32(jspb.utils.split64Low);
    };

    jspb.BinaryEncoder.prototype.writeDouble = function (a) {
      goog.asserts.assert(Infinity === a || -Infinity === a || isNaN(a) || a >= -jspb.BinaryConstants.FLOAT64_MAX && a <= jspb.BinaryConstants.FLOAT64_MAX);
      jspb.utils.splitFloat64(a);
      this.writeUint32(jspb.utils.split64Low);
      this.writeUint32(jspb.utils.split64High);
    };

    jspb.BinaryEncoder.prototype.writeBool = function (a) {
      goog.asserts.assert("boolean" === typeof a || "number" === typeof a);
      this.buffer_.push(a ? 1 : 0);
    };

    jspb.BinaryEncoder.prototype.writeEnum = function (a) {
      goog.asserts.assert(a == Math.floor(a));
      goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_31 && a < jspb.BinaryConstants.TWO_TO_31);
      this.writeSignedVarint32(a);
    };

    jspb.BinaryEncoder.prototype.writeBytes = function (a) {
      this.buffer_.push.apply(this.buffer_, a);
    };

    jspb.BinaryEncoder.prototype.writeVarintHash64 = function (a) {
      jspb.utils.splitHash64(a);
      this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
    };

    jspb.BinaryEncoder.prototype.writeFixedHash64 = function (a) {
      jspb.utils.splitHash64(a);
      this.writeUint32(jspb.utils.split64Low);
      this.writeUint32(jspb.utils.split64High);
    };

    jspb.BinaryEncoder.prototype.writeString = function (a) {
      for (var b = this.buffer_.length, c = 0; c < a.length; c++) {
        var d = a.charCodeAt(c);
        if (128 > d) this.buffer_.push(d);else if (2048 > d) this.buffer_.push(d >> 6 | 192), this.buffer_.push(d & 63 | 128);else if (65536 > d) if (55296 <= d && 56319 >= d && c + 1 < a.length) {
          var e = a.charCodeAt(c + 1);
          56320 <= e && 57343 >= e && (d = 1024 * (d - 55296) + e - 56320 + 65536, this.buffer_.push(d >> 18 | 240), this.buffer_.push(d >> 12 & 63 | 128), this.buffer_.push(d >> 6 & 63 | 128), this.buffer_.push(d & 63 | 128), c++);
        } else this.buffer_.push(d >> 12 | 224), this.buffer_.push(d >> 6 & 63 | 128), this.buffer_.push(d & 63 | 128);
      }

      return this.buffer_.length - b;
    };

    jspb.arith = {};

    jspb.arith.UInt64 = function (a, b) {
      this.lo = a;
      this.hi = b;
    };

    jspb.arith.UInt64.prototype.cmp = function (a) {
      return this.hi < a.hi || this.hi == a.hi && this.lo < a.lo ? -1 : this.hi == a.hi && this.lo == a.lo ? 0 : 1;
    };

    jspb.arith.UInt64.prototype.rightShift = function () {
      return new jspb.arith.UInt64((this.lo >>> 1 | (this.hi & 1) << 31) >>> 0, this.hi >>> 1 >>> 0);
    };

    jspb.arith.UInt64.prototype.leftShift = function () {
      return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
    };

    jspb.arith.UInt64.prototype.msb = function () {
      return !!(this.hi & 2147483648);
    };

    jspb.arith.UInt64.prototype.lsb = function () {
      return !!(this.lo & 1);
    };

    jspb.arith.UInt64.prototype.zero = function () {
      return 0 == this.lo && 0 == this.hi;
    };

    jspb.arith.UInt64.prototype.add = function (a) {
      return new jspb.arith.UInt64((this.lo + a.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a.lo ? 1 : 0) >>> 0);
    };

    jspb.arith.UInt64.prototype.sub = function (a) {
      return new jspb.arith.UInt64((this.lo - a.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a.hi & 4294967295) >>> 0) - (0 > this.lo - a.lo ? 1 : 0) >>> 0);
    };

    jspb.arith.UInt64.mul32x32 = function (a, b) {
      var c = a & 65535;
      a >>>= 16;
      var d = b & 65535,
          e = b >>> 16;
      b = c * d + 65536 * (c * e & 65535) + 65536 * (a * d & 65535);

      for (c = a * e + (c * e >>> 16) + (a * d >>> 16); 4294967296 <= b;) {
        b -= 4294967296, c += 1;
      }

      return new jspb.arith.UInt64(b >>> 0, c >>> 0);
    };

    jspb.arith.UInt64.prototype.mul = function (a) {
      var b = jspb.arith.UInt64.mul32x32(this.lo, a);
      a = jspb.arith.UInt64.mul32x32(this.hi, a);
      a.hi = a.lo;
      a.lo = 0;
      return b.add(a);
    };

    jspb.arith.UInt64.prototype.div = function (a) {
      if (0 == a) return [];
      var b = new jspb.arith.UInt64(0, 0),
          c = new jspb.arith.UInt64(this.lo, this.hi);
      a = new jspb.arith.UInt64(a, 0);

      for (var d = new jspb.arith.UInt64(1, 0); !a.msb();) {
        a = a.leftShift(), d = d.leftShift();
      }

      for (; !d.zero();) {
        0 >= a.cmp(c) && (b = b.add(d), c = c.sub(a)), a = a.rightShift(), d = d.rightShift();
      }

      return [b, c];
    };

    jspb.arith.UInt64.prototype.toString = function () {
      for (var a = "", b = this; !b.zero();) {
        b = b.div(10);
        var c = b[0];
        a = b[1].lo + a;
        b = c;
      }

      "" == a && (a = "0");
      return a;
    };

    jspb.arith.UInt64.fromString = function (a) {
      for (var b = new jspb.arith.UInt64(0, 0), c = new jspb.arith.UInt64(0, 0), d = 0; d < a.length; d++) {
        if ("0" > a[d] || "9" < a[d]) return null;
        var e = parseInt(a[d], 10);
        c.lo = e;
        b = b.mul(10).add(c);
      }

      return b;
    };

    jspb.arith.UInt64.prototype.clone = function () {
      return new jspb.arith.UInt64(this.lo, this.hi);
    };

    jspb.arith.Int64 = function (a, b) {
      this.lo = a;
      this.hi = b;
    };

    jspb.arith.Int64.prototype.add = function (a) {
      return new jspb.arith.Int64((this.lo + a.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a.lo ? 1 : 0) >>> 0);
    };

    jspb.arith.Int64.prototype.sub = function (a) {
      return new jspb.arith.Int64((this.lo - a.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a.hi & 4294967295) >>> 0) - (0 > this.lo - a.lo ? 1 : 0) >>> 0);
    };

    jspb.arith.Int64.prototype.clone = function () {
      return new jspb.arith.Int64(this.lo, this.hi);
    };

    jspb.arith.Int64.prototype.toString = function () {
      var a = 0 != (this.hi & 2147483648),
          b = new jspb.arith.UInt64(this.lo, this.hi);
      a && (b = new jspb.arith.UInt64(0, 0).sub(b));
      return (a ? "-" : "") + b.toString();
    };

    jspb.arith.Int64.fromString = function (a) {
      var b = 0 < a.length && "-" == a[0];
      b && (a = a.substring(1));
      a = jspb.arith.UInt64.fromString(a);
      if (null === a) return null;
      b && (a = new jspb.arith.UInt64(0, 0).sub(a));
      return new jspb.arith.Int64(a.lo, a.hi);
    };

    jspb.BinaryWriter = function () {
      this.blocks_ = [];
      this.totalLength_ = 0;
      this.encoder_ = new jspb.BinaryEncoder();
      this.bookmarks_ = [];
    };

    jspb.BinaryWriter.prototype.appendUint8Array_ = function (a) {
      var b = this.encoder_.end();
      this.blocks_.push(b);
      this.blocks_.push(a);
      this.totalLength_ += b.length + a.length;
    };

    jspb.BinaryWriter.prototype.beginDelimited_ = function (a) {
      this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED);
      a = this.encoder_.end();
      this.blocks_.push(a);
      this.totalLength_ += a.length;
      a.push(this.totalLength_);
      return a;
    };

    jspb.BinaryWriter.prototype.endDelimited_ = function (a) {
      var b = a.pop();
      b = this.totalLength_ + this.encoder_.length() - b;

      for (goog.asserts.assert(0 <= b); 127 < b;) {
        a.push(b & 127 | 128), b >>>= 7, this.totalLength_++;
      }

      a.push(b);
      this.totalLength_++;
    };

    jspb.BinaryWriter.prototype.writeSerializedMessage = function (a, b, c) {
      this.appendUint8Array_(a.subarray(b, c));
    };

    jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function (a, b, c) {
      null != a && null != b && null != c && this.writeSerializedMessage(a, b, c);
    };

    jspb.BinaryWriter.prototype.reset = function () {
      this.blocks_ = [];
      this.encoder_.end();
      this.totalLength_ = 0;
      this.bookmarks_ = [];
    };

    jspb.BinaryWriter.prototype.getResultBuffer = function () {
      goog.asserts.assert(0 == this.bookmarks_.length);

      for (var a = new Uint8Array(this.totalLength_ + this.encoder_.length()), b = this.blocks_, c = b.length, d = 0, e = 0; e < c; e++) {
        var f = b[e];
        a.set(f, d);
        d += f.length;
      }

      b = this.encoder_.end();
      a.set(b, d);
      d += b.length;
      goog.asserts.assert(d == a.length);
      this.blocks_ = [a];
      return a;
    };

    jspb.BinaryWriter.prototype.getResultBase64String = function (a) {
      return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), a);
    };

    jspb.BinaryWriter.prototype.beginSubMessage = function (a) {
      this.bookmarks_.push(this.beginDelimited_(a));
    };

    jspb.BinaryWriter.prototype.endSubMessage = function () {
      goog.asserts.assert(0 <= this.bookmarks_.length);
      this.endDelimited_(this.bookmarks_.pop());
    };

    jspb.BinaryWriter.prototype.writeFieldHeader_ = function (a, b) {
      goog.asserts.assert(1 <= a && a == Math.floor(a));
      this.encoder_.writeUnsignedVarint32(8 * a + b);
    };

    jspb.BinaryWriter.prototype.writeAny = function (a, b, c) {
      var d = jspb.BinaryConstants.FieldType;

      switch (a) {
        case d.DOUBLE:
          this.writeDouble(b, c);
          break;

        case d.FLOAT:
          this.writeFloat(b, c);
          break;

        case d.INT64:
          this.writeInt64(b, c);
          break;

        case d.UINT64:
          this.writeUint64(b, c);
          break;

        case d.INT32:
          this.writeInt32(b, c);
          break;

        case d.FIXED64:
          this.writeFixed64(b, c);
          break;

        case d.FIXED32:
          this.writeFixed32(b, c);
          break;

        case d.BOOL:
          this.writeBool(b, c);
          break;

        case d.STRING:
          this.writeString(b, c);
          break;

        case d.GROUP:
          goog.asserts.fail("Group field type not supported in writeAny()");
          break;

        case d.MESSAGE:
          goog.asserts.fail("Message field type not supported in writeAny()");
          break;

        case d.BYTES:
          this.writeBytes(b, c);
          break;

        case d.UINT32:
          this.writeUint32(b, c);
          break;

        case d.ENUM:
          this.writeEnum(b, c);
          break;

        case d.SFIXED32:
          this.writeSfixed32(b, c);
          break;

        case d.SFIXED64:
          this.writeSfixed64(b, c);
          break;

        case d.SINT32:
          this.writeSint32(b, c);
          break;

        case d.SINT64:
          this.writeSint64(b, c);
          break;

        case d.FHASH64:
          this.writeFixedHash64(b, c);
          break;

        case d.VHASH64:
          this.writeVarintHash64(b, c);
          break;

        default:
          goog.asserts.fail("Invalid field type in writeAny()");
      }
    };

    jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(b));
    };

    jspb.BinaryWriter.prototype.writeSignedVarint32_ = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(b));
    };

    jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(b));
    };

    jspb.BinaryWriter.prototype.writeSignedVarint64_ = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(b));
    };

    jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(b));
    };

    jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(b));
    };

    jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(b));
    };

    jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(b));
    };

    jspb.BinaryWriter.prototype.writeInt32 = function (a, b) {
      null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(a, b));
    };

    jspb.BinaryWriter.prototype.writeInt32String = function (a, b) {
      null != b && (b = parseInt(b, 10), goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(a, b));
    };

    jspb.BinaryWriter.prototype.writeInt64 = function (a, b) {
      null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(a, b));
    };

    jspb.BinaryWriter.prototype.writeInt64String = function (a, b) {
      null != b && (b = jspb.arith.Int64.fromString(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(b.lo, b.hi));
    };

    jspb.BinaryWriter.prototype.writeUint32 = function (a, b) {
      null != b && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(a, b));
    };

    jspb.BinaryWriter.prototype.writeUint32String = function (a, b) {
      null != b && (b = parseInt(b, 10), goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(a, b));
    };

    jspb.BinaryWriter.prototype.writeUint64 = function (a, b) {
      null != b && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(a, b));
    };

    jspb.BinaryWriter.prototype.writeUint64String = function (a, b) {
      null != b && (b = jspb.arith.UInt64.fromString(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(b.lo, b.hi));
    };

    jspb.BinaryWriter.prototype.writeSint32 = function (a, b) {
      null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(a, b));
    };

    jspb.BinaryWriter.prototype.writeSint64 = function (a, b) {
      null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(a, b));
    };

    jspb.BinaryWriter.prototype.writeSintHash64 = function (a, b) {
      null != b && this.writeZigzagVarintHash64_(a, b);
    };

    jspb.BinaryWriter.prototype.writeSint64String = function (a, b) {
      null != b && this.writeZigzagVarint64String_(a, b);
    };

    jspb.BinaryWriter.prototype.writeFixed32 = function (a, b) {
      null != b && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(b));
    };

    jspb.BinaryWriter.prototype.writeFixed64 = function (a, b) {
      null != b && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(b));
    };

    jspb.BinaryWriter.prototype.writeFixed64String = function (a, b) {
      null != b && (b = jspb.arith.UInt64.fromString(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(b.lo, b.hi));
    };

    jspb.BinaryWriter.prototype.writeSfixed32 = function (a, b) {
      null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(b));
    };

    jspb.BinaryWriter.prototype.writeSfixed64 = function (a, b) {
      null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(b));
    };

    jspb.BinaryWriter.prototype.writeSfixed64String = function (a, b) {
      null != b && (b = jspb.arith.Int64.fromString(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(b.lo, b.hi));
    };

    jspb.BinaryWriter.prototype.writeFloat = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(b));
    };

    jspb.BinaryWriter.prototype.writeDouble = function (a, b) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(b));
    };

    jspb.BinaryWriter.prototype.writeBool = function (a, b) {
      null != b && (goog.asserts.assert("boolean" === typeof b || "number" === typeof b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(b));
    };

    jspb.BinaryWriter.prototype.writeEnum = function (a, b) {
      null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(b));
    };

    jspb.BinaryWriter.prototype.writeString = function (a, b) {
      null != b && (a = this.beginDelimited_(a), this.encoder_.writeString(b), this.endDelimited_(a));
    };

    jspb.BinaryWriter.prototype.writeBytes = function (a, b) {
      null != b && (b = jspb.utils.byteSourceToUint8Array(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(b.length), this.appendUint8Array_(b));
    };

    jspb.BinaryWriter.prototype.writeMessage = function (a, b, c) {
      null != b && (a = this.beginDelimited_(a), c(b, this), this.endDelimited_(a));
    };

    jspb.BinaryWriter.prototype.writeMessageSet = function (a, b, c) {
      null != b && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(a), a = this.beginDelimited_(3), c(b, this), this.endDelimited_(a), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
    };

    jspb.BinaryWriter.prototype.writeGroup = function (a, b, c) {
      null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.START_GROUP), c(b, this), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.END_GROUP));
    };

    jspb.BinaryWriter.prototype.writeFixedHash64 = function (a, b) {
      null != b && (goog.asserts.assert(8 == b.length), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(b));
    };

    jspb.BinaryWriter.prototype.writeVarintHash64 = function (a, b) {
      null != b && (goog.asserts.assert(8 == b.length), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(b));
    };

    jspb.BinaryWriter.prototype.writeSplitFixed64 = function (a, b, c) {
      this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64);
      this.encoder_.writeSplitFixed64(b, c);
    };

    jspb.BinaryWriter.prototype.writeSplitVarint64 = function (a, b, c) {
      this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT);
      this.encoder_.writeSplitVarint64(b, c);
    };

    jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function (a, b, c) {
      this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT);
      var d = this.encoder_;
      jspb.utils.toZigzag64(b, c, function (a, b) {
        d.writeSplitVarint64(a >>> 0, b >>> 0);
      });
    };

    jspb.BinaryWriter.prototype.writeRepeatedInt32 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeSignedVarint32_(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedInt32String = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeInt32String(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedInt64 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeSignedVarint64_(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function (a, b, c, d) {
      if (null != b) for (var e = 0; e < b.length; e++) {
        this.writeSplitFixed64(a, c(b[e]), d(b[e]));
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function (a, b, c, d) {
      if (null != b) for (var e = 0; e < b.length; e++) {
        this.writeSplitVarint64(a, c(b[e]), d(b[e]));
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function (a, b, c, d) {
      if (null != b) for (var e = 0; e < b.length; e++) {
        this.writeSplitZigzagVarint64(a, c(b[e]), d(b[e]));
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedInt64String = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeInt64String(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedUint32 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeUnsignedVarint32_(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedUint32String = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeUint32String(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedUint64 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeUnsignedVarint64_(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedUint64String = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeUint64String(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSint32 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeZigzagVarint32_(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSint64 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeZigzagVarint64_(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSint64String = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeZigzagVarint64String_(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeZigzagVarintHash64_(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeFixed32(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeFixed64(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeFixed64String(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeSfixed32(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeSfixed64(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeSfixed64String(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedFloat = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeFloat(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedDouble = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeDouble(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedBool = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeBool(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedEnum = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeEnum(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedString = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeString(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedBytes = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeBytes(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedMessage = function (a, b, c) {
      if (null != b) for (var d = 0; d < b.length; d++) {
        var e = this.beginDelimited_(a);
        c(b[d], this);
        this.endDelimited_(e);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedGroup = function (a, b, c) {
      if (null != b) for (var d = 0; d < b.length; d++) {
        this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.START_GROUP), c(b[d], this), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.END_GROUP);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeFixedHash64(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function (a, b) {
      if (null != b) for (var c = 0; c < b.length; c++) {
        this.writeVarintHash64(a, b[c]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedInt32 = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeSignedVarint32(b[c]);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedInt32String = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeSignedVarint32(parseInt(b[c], 10));
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedInt64 = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeSignedVarint64(b[c]);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function (a, b, c, d) {
      if (null != b) {
        a = this.beginDelimited_(a);

        for (var e = 0; e < b.length; e++) {
          this.encoder_.writeSplitFixed64(c(b[e]), d(b[e]));
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function (a, b, c, d) {
      if (null != b) {
        a = this.beginDelimited_(a);

        for (var e = 0; e < b.length; e++) {
          this.encoder_.writeSplitVarint64(c(b[e]), d(b[e]));
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function (a, b, c, d) {
      if (null != b) {
        a = this.beginDelimited_(a);

        for (var e = this.encoder_, f = 0; f < b.length; f++) {
          jspb.utils.toZigzag64(c(b[f]), d(b[f]), function (a, b) {
            e.writeSplitVarint64(a >>> 0, b >>> 0);
          });
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedInt64String = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          var d = jspb.arith.Int64.fromString(b[c]);
          this.encoder_.writeSplitVarint64(d.lo, d.hi);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedUint32 = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeUnsignedVarint32(b[c]);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedUint32String = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeUnsignedVarint32(parseInt(b[c], 10));
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedUint64 = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeUnsignedVarint64(b[c]);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedUint64String = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          var d = jspb.arith.UInt64.fromString(b[c]);
          this.encoder_.writeSplitVarint64(d.lo, d.hi);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSint32 = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeZigzagVarint32(b[c]);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSint64 = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeZigzagVarint64(b[c]);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSint64String = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(b[c]));
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSintHash64 = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeZigzagVarintHash64(b[c]);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedFixed32 = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a = 0; a < b.length; a++) {
        this.encoder_.writeUint32(b[a]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedFixed64 = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++) {
        this.encoder_.writeUint64(b[a]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedFixed64String = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++) {
        var c = jspb.arith.UInt64.fromString(b[a]);
        this.encoder_.writeSplitFixed64(c.lo, c.hi);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSfixed32 = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a = 0; a < b.length; a++) {
        this.encoder_.writeInt32(b[a]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSfixed64 = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++) {
        this.encoder_.writeInt64(b[a]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedSfixed64String = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++) {
        this.encoder_.writeInt64String(b[a]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedFloat = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a = 0; a < b.length; a++) {
        this.encoder_.writeFloat(b[a]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedDouble = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++) {
        this.encoder_.writeDouble(b[a]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedBool = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(b.length), a = 0; a < b.length; a++) {
        this.encoder_.writeBool(b[a]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedEnum = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeEnum(b[c]);
        }

        this.endDelimited_(a);
      }
    };

    jspb.BinaryWriter.prototype.writePackedFixedHash64 = function (a, b) {
      if (null != b && b.length) for (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++) {
        this.encoder_.writeFixedHash64(b[a]);
      }
    };

    jspb.BinaryWriter.prototype.writePackedVarintHash64 = function (a, b) {
      if (null != b && b.length) {
        a = this.beginDelimited_(a);

        for (var c = 0; c < b.length; c++) {
          this.encoder_.writeVarintHash64(b[c]);
        }

        this.endDelimited_(a);
      }
    };

    jspb.Map = function (a, b) {
      this.arr_ = a;
      this.valueCtor_ = b;
      this.map_ = {};
      this.arrClean = !0;
      0 < this.arr_.length && this.loadFromArray_();
    };

    jspb.Map.prototype.loadFromArray_ = function () {
      for (var a = 0; a < this.arr_.length; a++) {
        var b = this.arr_[a],
            c = b[0];
        this.map_[c.toString()] = new jspb.Map.Entry_(c, b[1]);
      }

      this.arrClean = !0;
    };

    jspb.Map.prototype.toArray = function () {
      if (this.arrClean) {
        if (this.valueCtor_) {
          var a = this.map_,
              b;

          for (b in a) {
            if (Object.prototype.hasOwnProperty.call(a, b)) {
              var c = a[b].valueWrapper;
              c && c.toArray();
            }
          }
        }
      } else {
        this.arr_.length = 0;
        a = this.stringKeys_();
        a.sort();

        for (b = 0; b < a.length; b++) {
          var d = this.map_[a[b]];
          (c = d.valueWrapper) && c.toArray();
          this.arr_.push([d.key, d.value]);
        }

        this.arrClean = !0;
      }

      return this.arr_;
    };

    jspb.Map.prototype.toObject = function (a, b) {
      for (var c = this.toArray(), d = [], e = 0; e < c.length; e++) {
        var f = this.map_[c[e][0].toString()];
        this.wrapEntry_(f);
        var g = f.valueWrapper;
        g ? (goog.asserts.assert(b), d.push([f.key, b(a, g)])) : d.push([f.key, f.value]);
      }

      return d;
    };

    jspb.Map.fromObject = function (a, b, c) {
      b = new jspb.Map([], b);

      for (var d = 0; d < a.length; d++) {
        var e = a[d][0],
            f = c(a[d][1]);
        b.set(e, f);
      }

      return b;
    };

    jspb.Map.ArrayIteratorIterable_ = function (a) {
      this.idx_ = 0;
      this.arr_ = a;
    };

    jspb.Map.ArrayIteratorIterable_.prototype.next = function () {
      return this.idx_ < this.arr_.length ? {
        done: !1,
        value: this.arr_[this.idx_++]
      } : {
        done: !0,
        value: void 0
      };
    };

    "undefined" != typeof Symbol && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function () {
      return this;
    });

    jspb.Map.prototype.getLength = function () {
      return this.stringKeys_().length;
    };

    jspb.Map.prototype.clear = function () {
      this.map_ = {};
      this.arrClean = !1;
    };

    jspb.Map.prototype.del = function (a) {
      a = a.toString();
      var b = this.map_.hasOwnProperty(a);
      delete this.map_[a];
      this.arrClean = !1;
      return b;
    };

    jspb.Map.prototype.getEntryList = function () {
      var a = [],
          b = this.stringKeys_();
      b.sort();

      for (var c = 0; c < b.length; c++) {
        var d = this.map_[b[c]];
        a.push([d.key, d.value]);
      }

      return a;
    };

    jspb.Map.prototype.entries = function () {
      var a = [],
          b = this.stringKeys_();
      b.sort();

      for (var c = 0; c < b.length; c++) {
        var d = this.map_[b[c]];
        a.push([d.key, this.wrapEntry_(d)]);
      }

      return new jspb.Map.ArrayIteratorIterable_(a);
    };

    jspb.Map.prototype.keys = function () {
      var a = [],
          b = this.stringKeys_();
      b.sort();

      for (var c = 0; c < b.length; c++) {
        a.push(this.map_[b[c]].key);
      }

      return new jspb.Map.ArrayIteratorIterable_(a);
    };

    jspb.Map.prototype.values = function () {
      var a = [],
          b = this.stringKeys_();
      b.sort();

      for (var c = 0; c < b.length; c++) {
        a.push(this.wrapEntry_(this.map_[b[c]]));
      }

      return new jspb.Map.ArrayIteratorIterable_(a);
    };

    jspb.Map.prototype.forEach = function (a, b) {
      var c = this.stringKeys_();
      c.sort();

      for (var d = 0; d < c.length; d++) {
        var e = this.map_[c[d]];
        a.call(b, this.wrapEntry_(e), e.key, this);
      }
    };

    jspb.Map.prototype.set = function (a, b) {
      var c = new jspb.Map.Entry_(a);
      this.valueCtor_ ? (c.valueWrapper = b, c.value = b.toArray()) : c.value = b;
      this.map_[a.toString()] = c;
      this.arrClean = !1;
      return this;
    };

    jspb.Map.prototype.wrapEntry_ = function (a) {
      return this.valueCtor_ ? (a.valueWrapper || (a.valueWrapper = new this.valueCtor_(a.value)), a.valueWrapper) : a.value;
    };

    jspb.Map.prototype.get = function (a) {
      if (a = this.map_[a.toString()]) return this.wrapEntry_(a);
    };

    jspb.Map.prototype.has = function (a) {
      return a.toString() in this.map_;
    };

    jspb.Map.prototype.serializeBinary = function (a, b, c, d, e) {
      var f = this.stringKeys_();
      f.sort();

      for (var g = 0; g < f.length; g++) {
        var h = this.map_[f[g]];
        b.beginSubMessage(a);
        c.call(b, 1, h.key);
        this.valueCtor_ ? d.call(b, 2, this.wrapEntry_(h), e) : d.call(b, 2, h.value);
        b.endSubMessage();
      }
    };

    jspb.Map.deserializeBinary = function (a, b, c, d, e, f, g) {
      for (; b.nextField() && !b.isEndGroup();) {
        var h = b.getFieldNumber();
        1 == h ? f = c.call(b) : 2 == h && (a.valueCtor_ ? (goog.asserts.assert(e), g || (g = new a.valueCtor_()), d.call(b, g, e)) : g = d.call(b));
      }

      goog.asserts.assert(void 0 != f);
      goog.asserts.assert(void 0 != g);
      a.set(f, g);
    };

    jspb.Map.prototype.stringKeys_ = function () {
      var a = this.map_,
          b = [],
          c;

      for (c in a) {
        Object.prototype.hasOwnProperty.call(a, c) && b.push(c);
      }

      return b;
    };

    jspb.Map.Entry_ = function (a, b) {
      this.key = a;
      this.value = b;
      this.valueWrapper = void 0;
    };

    jspb.ExtensionFieldInfo = function (a, b, c, d, e) {
      this.fieldIndex = a;
      this.fieldName = b;
      this.ctor = c;
      this.toObjectFn = d;
      this.isRepeated = e;
    };

    jspb.ExtensionFieldBinaryInfo = function (a, b, c, d, e, f) {
      this.fieldInfo = a;
      this.binaryReaderFn = b;
      this.binaryWriterFn = c;
      this.binaryMessageSerializeFn = d;
      this.binaryMessageDeserializeFn = e;
      this.isPacked = f;
    };

    jspb.ExtensionFieldInfo.prototype.isMessageType = function () {
      return !!this.ctor;
    };

    jspb.Message = function () {};

    jspb.Message.GENERATE_TO_OBJECT = !0;
    jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE;
    jspb.Message.GENERATE_TO_STRING = !0;
    jspb.Message.ASSUME_LOCAL_ARRAYS = !1;
    jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = !0;
    jspb.Message.SUPPORTS_UINT8ARRAY_ = "function" == typeof Uint8Array;

    jspb.Message.prototype.getJsPbMessageId = function () {
      return this.messageId_;
    };

    jspb.Message.getIndex_ = function (a, b) {
      return b + a.arrayIndexOffset_;
    };

    jspb.Message.hiddenES6Property_ = function () {};

    jspb.Message.getFieldNumber_ = function (a, b) {
      return b - a.arrayIndexOffset_;
    };

    jspb.Message.initialize = function (a, b, c, d, e, f) {
      a.wrappers_ = null;
      b || (b = c ? [c] : []);
      a.messageId_ = c ? String(c) : void 0;
      a.arrayIndexOffset_ = 0 === c ? -1 : 0;
      a.array = b;
      jspb.Message.initPivotAndExtensionObject_(a, d);
      a.convertedPrimitiveFields_ = {};
      jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (a.repeatedFields = e);
      if (e) for (b = 0; b < e.length; b++) {
        c = e[b], c < a.pivot_ ? (c = jspb.Message.getIndex_(a, c), a.array[c] = a.array[c] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(a), a.extensionObject_[c] = a.extensionObject_[c] || jspb.Message.EMPTY_LIST_SENTINEL_);
      }
      if (f && f.length) for (b = 0; b < f.length; b++) {
        jspb.Message.computeOneofCase(a, f[b]);
      }
    };

    jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [];

    jspb.Message.isArray_ = function (a) {
      return jspb.Message.ASSUME_LOCAL_ARRAYS ? a instanceof Array : Array.isArray(a);
    };

    jspb.Message.isExtensionObject_ = function (a) {
      return null !== a && "object" == _typeof(a) && !jspb.Message.isArray_(a) && !(jspb.Message.SUPPORTS_UINT8ARRAY_ && a instanceof Uint8Array);
    };

    jspb.Message.initPivotAndExtensionObject_ = function (a, b) {
      var c = a.array.length,
          d = -1;

      if (c && (d = c - 1, c = a.array[d], jspb.Message.isExtensionObject_(c))) {
        a.pivot_ = jspb.Message.getFieldNumber_(a, d);
        a.extensionObject_ = c;
        return;
      }

      -1 < b ? (a.pivot_ = Math.max(b, jspb.Message.getFieldNumber_(a, d + 1)), a.extensionObject_ = null) : a.pivot_ = Number.MAX_VALUE;
    };

    jspb.Message.maybeInitEmptyExtensionObject_ = function (a) {
      var b = jspb.Message.getIndex_(a, a.pivot_);
      a.array[b] || (a.extensionObject_ = a.array[b] = {});
    };

    jspb.Message.toObjectList = function (a, b, c) {
      for (var d = [], e = 0; e < a.length; e++) {
        d[e] = b.call(a[e], c, a[e]);
      }

      return d;
    };

    jspb.Message.toObjectExtension = function (a, b, c, d, e) {
      for (var f in c) {
        var g = c[f],
            h = d.call(a, g);

        if (null != h) {
          for (var k in g.fieldName) {
            if (g.fieldName.hasOwnProperty(k)) break;
          }

          b[k] = g.toObjectFn ? g.isRepeated ? jspb.Message.toObjectList(h, g.toObjectFn, e) : g.toObjectFn(e, h) : h;
        }
      }
    };

    jspb.Message.serializeBinaryExtensions = function (a, b, c, d) {
      for (var e in c) {
        var f = c[e],
            g = f.fieldInfo;
        if (!f.binaryWriterFn) throw Error("Message extension present that was generated without binary serialization support");
        var h = d.call(a, g);
        if (null != h) if (g.isMessageType()) {
          if (f.binaryMessageSerializeFn) f.binaryWriterFn.call(b, g.fieldIndex, h, f.binaryMessageSerializeFn);else throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
        } else f.binaryWriterFn.call(b, g.fieldIndex, h);
      }
    };

    jspb.Message.readBinaryExtension = function (a, b, c, d, e) {
      var f = c[b.getFieldNumber()];

      if (f) {
        c = f.fieldInfo;
        if (!f.binaryReaderFn) throw Error("Deserializing extension whose generated code does not support binary format");

        if (c.isMessageType()) {
          var g = new c.ctor();
          f.binaryReaderFn.call(b, g, f.binaryMessageDeserializeFn);
        } else g = f.binaryReaderFn.call(b);

        c.isRepeated && !f.isPacked ? (b = d.call(a, c)) ? b.push(g) : e.call(a, c, [g]) : e.call(a, c, g);
      } else b.skipField();
    };

    jspb.Message.getField = function (a, b) {
      if (b < a.pivot_) {
        b = jspb.Message.getIndex_(a, b);
        var c = a.array[b];
        return c === jspb.Message.EMPTY_LIST_SENTINEL_ ? a.array[b] = [] : c;
      }

      if (a.extensionObject_) return c = a.extensionObject_[b], c === jspb.Message.EMPTY_LIST_SENTINEL_ ? a.extensionObject_[b] = [] : c;
    };

    jspb.Message.getRepeatedField = function (a, b) {
      return jspb.Message.getField(a, b);
    };

    jspb.Message.getOptionalFloatingPointField = function (a, b) {
      a = jspb.Message.getField(a, b);
      return null == a ? a : +a;
    };

    jspb.Message.getBooleanField = function (a, b) {
      a = jspb.Message.getField(a, b);
      return null == a ? a : !!a;
    };

    jspb.Message.getRepeatedFloatingPointField = function (a, b) {
      var c = jspb.Message.getRepeatedField(a, b);
      a.convertedPrimitiveFields_ || (a.convertedPrimitiveFields_ = {});

      if (!a.convertedPrimitiveFields_[b]) {
        for (var d = 0; d < c.length; d++) {
          c[d] = +c[d];
        }

        a.convertedPrimitiveFields_[b] = !0;
      }

      return c;
    };

    jspb.Message.getRepeatedBooleanField = function (a, b) {
      var c = jspb.Message.getRepeatedField(a, b);
      a.convertedPrimitiveFields_ || (a.convertedPrimitiveFields_ = {});

      if (!a.convertedPrimitiveFields_[b]) {
        for (var d = 0; d < c.length; d++) {
          c[d] = !!c[d];
        }

        a.convertedPrimitiveFields_[b] = !0;
      }

      return c;
    };

    jspb.Message.bytesAsB64 = function (a) {
      if (null == a || "string" === typeof a) return a;
      if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a instanceof Uint8Array) return goog.crypt.base64.encodeByteArray(a);
      goog.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(a));
      return null;
    };

    jspb.Message.bytesAsU8 = function (a) {
      if (null == a || a instanceof Uint8Array) return a;
      if ("string" === typeof a) return goog.crypt.base64.decodeStringToUint8Array(a);
      goog.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(a));
      return null;
    };

    jspb.Message.bytesListAsB64 = function (a) {
      jspb.Message.assertConsistentTypes_(a);
      return a.length && "string" !== typeof a[0] ? goog.array.map(a, jspb.Message.bytesAsB64) : a;
    };

    jspb.Message.bytesListAsU8 = function (a) {
      jspb.Message.assertConsistentTypes_(a);
      return !a.length || a[0] instanceof Uint8Array ? a : goog.array.map(a, jspb.Message.bytesAsU8);
    };

    jspb.Message.assertConsistentTypes_ = function (a) {
      if (goog.DEBUG && a && 1 < a.length) {
        var b = goog.typeOf(a[0]);
        goog.array.forEach(a, function (a) {
          goog.typeOf(a) != b && goog.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(a) + " expected " + b);
        });
      }
    };

    jspb.Message.getFieldWithDefault = function (a, b, c) {
      a = jspb.Message.getField(a, b);
      return null == a ? c : a;
    };

    jspb.Message.getBooleanFieldWithDefault = function (a, b, c) {
      a = jspb.Message.getBooleanField(a, b);
      return null == a ? c : a;
    };

    jspb.Message.getFloatingPointFieldWithDefault = function (a, b, c) {
      a = jspb.Message.getOptionalFloatingPointField(a, b);
      return null == a ? c : a;
    };

    jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault;

    jspb.Message.getMapField = function (a, b, c, d) {
      a.wrappers_ || (a.wrappers_ = {});
      if (b in a.wrappers_) return a.wrappers_[b];
      var e = jspb.Message.getField(a, b);

      if (!e) {
        if (c) return;
        e = [];
        jspb.Message.setField(a, b, e);
      }

      return a.wrappers_[b] = new jspb.Map(e, d);
    };

    jspb.Message.setField = function (a, b, c) {
      goog.asserts.assertInstanceof(a, jspb.Message);
      b < a.pivot_ ? a.array[jspb.Message.getIndex_(a, b)] = c : (jspb.Message.maybeInitEmptyExtensionObject_(a), a.extensionObject_[b] = c);
      return a;
    };

    jspb.Message.setProto3IntField = function (a, b, c) {
      return jspb.Message.setFieldIgnoringDefault_(a, b, c, 0);
    };

    jspb.Message.setProto3FloatField = function (a, b, c) {
      return jspb.Message.setFieldIgnoringDefault_(a, b, c, 0);
    };

    jspb.Message.setProto3BooleanField = function (a, b, c) {
      return jspb.Message.setFieldIgnoringDefault_(a, b, c, !1);
    };

    jspb.Message.setProto3StringField = function (a, b, c) {
      return jspb.Message.setFieldIgnoringDefault_(a, b, c, "");
    };

    jspb.Message.setProto3BytesField = function (a, b, c) {
      return jspb.Message.setFieldIgnoringDefault_(a, b, c, "");
    };

    jspb.Message.setProto3EnumField = function (a, b, c) {
      return jspb.Message.setFieldIgnoringDefault_(a, b, c, 0);
    };

    jspb.Message.setProto3StringIntField = function (a, b, c) {
      return jspb.Message.setFieldIgnoringDefault_(a, b, c, "0");
    };

    jspb.Message.setFieldIgnoringDefault_ = function (a, b, c, d) {
      goog.asserts.assertInstanceof(a, jspb.Message);
      c !== d ? jspb.Message.setField(a, b, c) : b < a.pivot_ ? a.array[jspb.Message.getIndex_(a, b)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(a), delete a.extensionObject_[b]);
      return a;
    };

    jspb.Message.addToRepeatedField = function (a, b, c, d) {
      goog.asserts.assertInstanceof(a, jspb.Message);
      b = jspb.Message.getRepeatedField(a, b);
      void 0 != d ? b.splice(d, 0, c) : b.push(c);
      return a;
    };

    jspb.Message.setOneofField = function (a, b, c, d) {
      goog.asserts.assertInstanceof(a, jspb.Message);
      (c = jspb.Message.computeOneofCase(a, c)) && c !== b && void 0 !== d && (a.wrappers_ && c in a.wrappers_ && (a.wrappers_[c] = void 0), jspb.Message.setField(a, c, void 0));
      return jspb.Message.setField(a, b, d);
    };

    jspb.Message.computeOneofCase = function (a, b) {
      for (var c, d, e = 0; e < b.length; e++) {
        var f = b[e],
            g = jspb.Message.getField(a, f);
        null != g && (c = f, d = g, jspb.Message.setField(a, f, void 0));
      }

      return c ? (jspb.Message.setField(a, c, d), c) : 0;
    };

    jspb.Message.getWrapperField = function (a, b, c, d) {
      a.wrappers_ || (a.wrappers_ = {});

      if (!a.wrappers_[c]) {
        var e = jspb.Message.getField(a, c);
        if (d || e) a.wrappers_[c] = new b(e);
      }

      return a.wrappers_[c];
    };

    jspb.Message.getRepeatedWrapperField = function (a, b, c) {
      jspb.Message.wrapRepeatedField_(a, b, c);
      b = a.wrappers_[c];
      b == jspb.Message.EMPTY_LIST_SENTINEL_ && (b = a.wrappers_[c] = []);
      return b;
    };

    jspb.Message.wrapRepeatedField_ = function (a, b, c) {
      a.wrappers_ || (a.wrappers_ = {});

      if (!a.wrappers_[c]) {
        for (var d = jspb.Message.getRepeatedField(a, c), e = [], f = 0; f < d.length; f++) {
          e[f] = new b(d[f]);
        }

        a.wrappers_[c] = e;
      }
    };

    jspb.Message.setWrapperField = function (a, b, c) {
      goog.asserts.assertInstanceof(a, jspb.Message);
      a.wrappers_ || (a.wrappers_ = {});
      var d = c ? c.toArray() : c;
      a.wrappers_[b] = c;
      return jspb.Message.setField(a, b, d);
    };

    jspb.Message.setOneofWrapperField = function (a, b, c, d) {
      goog.asserts.assertInstanceof(a, jspb.Message);
      a.wrappers_ || (a.wrappers_ = {});
      var e = d ? d.toArray() : d;
      a.wrappers_[b] = d;
      return jspb.Message.setOneofField(a, b, c, e);
    };

    jspb.Message.setRepeatedWrapperField = function (a, b, c) {
      goog.asserts.assertInstanceof(a, jspb.Message);
      a.wrappers_ || (a.wrappers_ = {});
      c = c || [];

      for (var d = [], e = 0; e < c.length; e++) {
        d[e] = c[e].toArray();
      }

      a.wrappers_[b] = c;
      return jspb.Message.setField(a, b, d);
    };

    jspb.Message.addToRepeatedWrapperField = function (a, b, c, d, e) {
      jspb.Message.wrapRepeatedField_(a, d, b);
      var f = a.wrappers_[b];
      f || (f = a.wrappers_[b] = []);
      c = c ? c : new d();
      a = jspb.Message.getRepeatedField(a, b);
      void 0 != e ? (f.splice(e, 0, c), a.splice(e, 0, c.toArray())) : (f.push(c), a.push(c.toArray()));
      return c;
    };

    jspb.Message.toMap = function (a, b, c, d) {
      for (var e = {}, f = 0; f < a.length; f++) {
        e[b.call(a[f])] = c ? c.call(a[f], d, a[f]) : a[f];
      }

      return e;
    };

    jspb.Message.prototype.syncMapFields_ = function () {
      if (this.wrappers_) for (var a in this.wrappers_) {
        var b = this.wrappers_[a];
        if (Array.isArray(b)) for (var c = 0; c < b.length; c++) {
          b[c] && b[c].toArray();
        } else b && b.toArray();
      }
    };

    jspb.Message.prototype.toArray = function () {
      this.syncMapFields_();
      return this.array;
    };

    jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function () {
      this.syncMapFields_();
      return this.array.toString();
    });

    jspb.Message.prototype.getExtension = function (a) {
      if (this.extensionObject_) {
        this.wrappers_ || (this.wrappers_ = {});
        var b = a.fieldIndex;

        if (a.isRepeated) {
          if (a.isMessageType()) return this.wrappers_[b] || (this.wrappers_[b] = goog.array.map(this.extensionObject_[b] || [], function (b) {
            return new a.ctor(b);
          })), this.wrappers_[b];
        } else if (a.isMessageType()) return !this.wrappers_[b] && this.extensionObject_[b] && (this.wrappers_[b] = new a.ctor(this.extensionObject_[b])), this.wrappers_[b];

        return this.extensionObject_[b];
      }
    };

    jspb.Message.prototype.setExtension = function (a, b) {
      this.wrappers_ || (this.wrappers_ = {});
      jspb.Message.maybeInitEmptyExtensionObject_(this);
      var c = a.fieldIndex;
      a.isRepeated ? (b = b || [], a.isMessageType() ? (this.wrappers_[c] = b, this.extensionObject_[c] = goog.array.map(b, function (a) {
        return a.toArray();
      })) : this.extensionObject_[c] = b) : a.isMessageType() ? (this.wrappers_[c] = b, this.extensionObject_[c] = b ? b.toArray() : b) : this.extensionObject_[c] = b;
      return this;
    };

    jspb.Message.difference = function (a, b) {
      if (!(a instanceof b.constructor)) throw Error("Messages have different types.");
      var c = a.toArray();
      b = b.toArray();
      var d = [],
          e = 0,
          f = c.length > b.length ? c.length : b.length;
      a.getJsPbMessageId() && (d[0] = a.getJsPbMessageId(), e = 1);

      for (; e < f; e++) {
        jspb.Message.compareFields(c[e], b[e]) || (d[e] = b[e]);
      }

      return new a.constructor(d);
    };

    jspb.Message.equals = function (a, b) {
      return a == b || !(!a || !b) && a instanceof b.constructor && jspb.Message.compareFields(a.toArray(), b.toArray());
    };

    jspb.Message.compareExtensions = function (a, b) {
      a = a || {};
      b = b || {};
      var c = {},
          d;

      for (d in a) {
        c[d] = 0;
      }

      for (d in b) {
        c[d] = 0;
      }

      for (d in c) {
        if (!jspb.Message.compareFields(a[d], b[d])) return !1;
      }

      return !0;
    };

    jspb.Message.compareFields = function (a, b) {
      if (a == b) return !0;
      if (!goog.isObject(a) || !goog.isObject(b)) return "number" === typeof a && isNaN(a) || "number" === typeof b && isNaN(b) ? String(a) == String(b) : !1;
      if (a.constructor != b.constructor) return !1;

      if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a.constructor === Uint8Array) {
        if (a.length != b.length) return !1;

        for (var c = 0; c < a.length; c++) {
          if (a[c] != b[c]) return !1;
        }

        return !0;
      }

      if (a.constructor === Array) {
        var d = void 0,
            e = void 0,
            f = Math.max(a.length, b.length);

        for (c = 0; c < f; c++) {
          var g = a[c],
              h = b[c];
          g && g.constructor == Object && (goog.asserts.assert(void 0 === d), goog.asserts.assert(c === a.length - 1), d = g, g = void 0);
          h && h.constructor == Object && (goog.asserts.assert(void 0 === e), goog.asserts.assert(c === b.length - 1), e = h, h = void 0);
          if (!jspb.Message.compareFields(g, h)) return !1;
        }

        return d || e ? (d = d || {}, e = e || {}, jspb.Message.compareExtensions(d, e)) : !0;
      }

      if (a.constructor === Object) return jspb.Message.compareExtensions(a, b);
      throw Error("Invalid type in JSPB array");
    };

    jspb.Message.prototype.cloneMessage = function () {
      return jspb.Message.cloneMessage(this);
    };

    jspb.Message.prototype.clone = function () {
      return jspb.Message.cloneMessage(this);
    };

    jspb.Message.clone = function (a) {
      return jspb.Message.cloneMessage(a);
    };

    jspb.Message.cloneMessage = function (a) {
      return new a.constructor(jspb.Message.clone_(a.toArray()));
    };

    jspb.Message.copyInto = function (a, b) {
      goog.asserts.assertInstanceof(a, jspb.Message);
      goog.asserts.assertInstanceof(b, jspb.Message);
      goog.asserts.assert(a.constructor == b.constructor, "Copy source and target message should have the same type.");
      a = jspb.Message.clone(a);

      for (var c = b.toArray(), d = a.toArray(), e = c.length = 0; e < d.length; e++) {
        c[e] = d[e];
      }

      b.wrappers_ = a.wrappers_;
      b.extensionObject_ = a.extensionObject_;
    };

    jspb.Message.clone_ = function (a) {
      if (Array.isArray(a)) {
        for (var b = Array(a.length), c = 0; c < a.length; c++) {
          var d = a[c];
          null != d && (b[c] = "object" == _typeof(d) ? jspb.Message.clone_(goog.asserts.assert(d)) : d);
        }

        return b;
      }

      if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a instanceof Uint8Array) return new Uint8Array(a);
      b = {};

      for (c in a) {
        d = a[c], null != d && (b[c] = "object" == _typeof(d) ? jspb.Message.clone_(goog.asserts.assert(d)) : d);
      }

      return b;
    };

    jspb.Message.registerMessageType = function (a, b) {
      b.messageId = a;
    };

    jspb.Message.messageSetExtensions = {};
    jspb.Message.messageSetExtensionsBinary = {};
    jspb.Export = {};
     (exports.Map = jspb.Map, exports.Message = jspb.Message, exports.BinaryReader = jspb.BinaryReader, exports.BinaryWriter = jspb.BinaryWriter, exports.ExtensionFieldInfo = jspb.ExtensionFieldInfo, exports.ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo, exports.exportSymbol = goog.exportSymbol, exports.inherits = goog.inherits, exports.object = {
      extend: goog.object.extend
    }, exports.typeOf = goog.typeOf);
  });
  var googleProtobuf_1 = googleProtobuf.Map;
  var googleProtobuf_2 = googleProtobuf.Message;
  var googleProtobuf_3 = googleProtobuf.BinaryReader;
  var googleProtobuf_4 = googleProtobuf.BinaryWriter;
  var googleProtobuf_5 = googleProtobuf.ExtensionFieldInfo;
  var googleProtobuf_6 = googleProtobuf.ExtensionFieldBinaryInfo;
  var googleProtobuf_7 = googleProtobuf.exportSymbol;
  var googleProtobuf_8 = googleProtobuf.inherits;
  var googleProtobuf_9 = googleProtobuf.object;
  var googleProtobuf_10 = googleProtobuf.typeOf;

  var blockchain_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!
    var goog = googleProtobuf;
    var global = Function('return this')();
    goog.exportSymbol('proto.types.ABI', null, global);
    goog.exportSymbol('proto.types.AccountProof', null, global);
    goog.exportSymbol('proto.types.Block', null, global);
    goog.exportSymbol('proto.types.BlockBody', null, global);
    goog.exportSymbol('proto.types.BlockHeader', null, global);
    goog.exportSymbol('proto.types.ContractVarProof', null, global);
    goog.exportSymbol('proto.types.Event', null, global);
    goog.exportSymbol('proto.types.FilterInfo', null, global);
    goog.exportSymbol('proto.types.FnArgument', null, global);
    goog.exportSymbol('proto.types.Function', null, global);
    goog.exportSymbol('proto.types.Proposal', null, global);
    goog.exportSymbol('proto.types.Query', null, global);
    goog.exportSymbol('proto.types.Receipt', null, global);
    goog.exportSymbol('proto.types.State', null, global);
    goog.exportSymbol('proto.types.StateQuery', null, global);
    goog.exportSymbol('proto.types.StateQueryProof', null, global);
    goog.exportSymbol('proto.types.StateVar', null, global);
    goog.exportSymbol('proto.types.Tx', null, global);
    goog.exportSymbol('proto.types.TxBody', null, global);
    goog.exportSymbol('proto.types.TxIdx', null, global);
    goog.exportSymbol('proto.types.TxInBlock', null, global);
    goog.exportSymbol('proto.types.TxList', null, global);
    goog.exportSymbol('proto.types.TxType', null, global);
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */

    proto.types.Block = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Block, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Block.displayName = 'proto.types.Block';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Block.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Block.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Block} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Block.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          hash: msg.getHash_asB64(),
          header: (f = msg.getHeader()) && proto.types.BlockHeader.toObject(includeInstance, f),
          body: (f = msg.getBody()) && proto.types.BlockBody.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Block}
     */


    proto.types.Block.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Block();
      return proto.types.Block.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Block} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Block}
     */


    proto.types.Block.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setHash(value);
            break;

          case 2:
            var value = new proto.types.BlockHeader();
            reader.readMessage(value, proto.types.BlockHeader.deserializeBinaryFromReader);
            msg.setHeader(value);
            break;

          case 3:
            var value = new proto.types.BlockBody();
            reader.readMessage(value, proto.types.BlockBody.deserializeBinaryFromReader);
            msg.setBody(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Block.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Block.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Block} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Block.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getHeader();

      if (f != null) {
        writer.writeMessage(2, f, proto.types.BlockHeader.serializeBinaryToWriter);
      }

      f = message.getBody();

      if (f != null) {
        writer.writeMessage(3, f, proto.types.BlockBody.serializeBinaryToWriter);
      }
    };
    /**
     * optional bytes hash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Block.prototype.getHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes hash = 1;
     * This is a type-conversion wrapper around `getHash()`
     * @return {string}
     */


    proto.types.Block.prototype.getHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getHash())
      );
    };
    /**
     * optional bytes hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHash()`
     * @return {!Uint8Array}
     */


    proto.types.Block.prototype.getHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Block.prototype.setHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional BlockHeader header = 2;
     * @return {?proto.types.BlockHeader}
     */


    proto.types.Block.prototype.getHeader = function () {
      return (
        /** @type{?proto.types.BlockHeader} */
        googleProtobuf.Message.getWrapperField(this, proto.types.BlockHeader, 2)
      );
    };
    /** @param {?proto.types.BlockHeader|undefined} value */


    proto.types.Block.prototype.setHeader = function (value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };

    proto.types.Block.prototype.clearHeader = function () {
      this.setHeader(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.Block.prototype.hasHeader = function () {
      return googleProtobuf.Message.getField(this, 2) != null;
    };
    /**
     * optional BlockBody body = 3;
     * @return {?proto.types.BlockBody}
     */


    proto.types.Block.prototype.getBody = function () {
      return (
        /** @type{?proto.types.BlockBody} */
        googleProtobuf.Message.getWrapperField(this, proto.types.BlockBody, 3)
      );
    };
    /** @param {?proto.types.BlockBody|undefined} value */


    proto.types.Block.prototype.setBody = function (value) {
      googleProtobuf.Message.setWrapperField(this, 3, value);
    };

    proto.types.Block.prototype.clearBody = function () {
      this.setBody(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.Block.prototype.hasBody = function () {
      return googleProtobuf.Message.getField(this, 3) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.BlockHeader = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.BlockHeader, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.BlockHeader.displayName = 'proto.types.BlockHeader';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.BlockHeader.prototype.toObject = function (opt_includeInstance) {
        return proto.types.BlockHeader.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.BlockHeader} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.BlockHeader.toObject = function (includeInstance, msg) {
        var obj = {
          chainid: msg.getChainid_asB64(),
          prevblockhash: msg.getPrevblockhash_asB64(),
          blockno: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          timestamp: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0),
          blocksroothash: msg.getBlocksroothash_asB64(),
          txsroothash: msg.getTxsroothash_asB64(),
          receiptsroothash: msg.getReceiptsroothash_asB64(),
          confirms: googleProtobuf.Message.getFieldWithDefault(msg, 8, 0),
          pubkey: msg.getPubkey_asB64(),
          coinbaseaccount: msg.getCoinbaseaccount_asB64(),
          sign: msg.getSign_asB64(),
          consensus: msg.getConsensus_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.BlockHeader}
     */


    proto.types.BlockHeader.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.BlockHeader();
      return proto.types.BlockHeader.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.BlockHeader} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.BlockHeader}
     */


    proto.types.BlockHeader.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setChainid(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setPrevblockhash(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBlockno(value);
            break;

          case 4:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setTimestamp(value);
            break;

          case 5:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBlocksroothash(value);
            break;

          case 6:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setTxsroothash(value);
            break;

          case 7:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setReceiptsroothash(value);
            break;

          case 8:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setConfirms(value);
            break;

          case 9:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setPubkey(value);
            break;

          case 10:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setCoinbaseaccount(value);
            break;

          case 11:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setSign(value);
            break;

          case 12:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setConsensus(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.BlockHeader.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.BlockHeader} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.BlockHeader.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getChainid_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getPrevblockhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }

      f = message.getBlockno();

      if (f !== 0) {
        writer.writeUint64(3, f);
      }

      f = message.getTimestamp();

      if (f !== 0) {
        writer.writeInt64(4, f);
      }

      f = message.getBlocksroothash_asU8();

      if (f.length > 0) {
        writer.writeBytes(5, f);
      }

      f = message.getTxsroothash_asU8();

      if (f.length > 0) {
        writer.writeBytes(6, f);
      }

      f = message.getReceiptsroothash_asU8();

      if (f.length > 0) {
        writer.writeBytes(7, f);
      }

      f = message.getConfirms();

      if (f !== 0) {
        writer.writeUint64(8, f);
      }

      f = message.getPubkey_asU8();

      if (f.length > 0) {
        writer.writeBytes(9, f);
      }

      f = message.getCoinbaseaccount_asU8();

      if (f.length > 0) {
        writer.writeBytes(10, f);
      }

      f = message.getSign_asU8();

      if (f.length > 0) {
        writer.writeBytes(11, f);
      }

      f = message.getConsensus_asU8();

      if (f.length > 0) {
        writer.writeBytes(12, f);
      }
    };
    /**
     * optional bytes chainID = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockHeader.prototype.getChainid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes chainID = 1;
     * This is a type-conversion wrapper around `getChainid()`
     * @return {string}
     */


    proto.types.BlockHeader.prototype.getChainid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getChainid())
      );
    };
    /**
     * optional bytes chainID = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getChainid()`
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.getChainid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getChainid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockHeader.prototype.setChainid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional bytes prevBlockHash = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockHeader.prototype.getPrevblockhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes prevBlockHash = 2;
     * This is a type-conversion wrapper around `getPrevblockhash()`
     * @return {string}
     */


    proto.types.BlockHeader.prototype.getPrevblockhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getPrevblockhash())
      );
    };
    /**
     * optional bytes prevBlockHash = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPrevblockhash()`
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.getPrevblockhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getPrevblockhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockHeader.prototype.setPrevblockhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * optional uint64 blockNo = 3;
     * @return {number}
     */


    proto.types.BlockHeader.prototype.getBlockno = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockHeader.prototype.setBlockno = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional int64 timestamp = 4;
     * @return {number}
     */


    proto.types.BlockHeader.prototype.getTimestamp = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockHeader.prototype.setTimestamp = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 4, value);
    };
    /**
     * optional bytes blocksRootHash = 5;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockHeader.prototype.getBlocksroothash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, "")
      );
    };
    /**
     * optional bytes blocksRootHash = 5;
     * This is a type-conversion wrapper around `getBlocksroothash()`
     * @return {string}
     */


    proto.types.BlockHeader.prototype.getBlocksroothash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBlocksroothash())
      );
    };
    /**
     * optional bytes blocksRootHash = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBlocksroothash()`
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.getBlocksroothash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBlocksroothash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockHeader.prototype.setBlocksroothash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 5, value);
    };
    /**
     * optional bytes txsRootHash = 6;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockHeader.prototype.getTxsroothash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /**
     * optional bytes txsRootHash = 6;
     * This is a type-conversion wrapper around `getTxsroothash()`
     * @return {string}
     */


    proto.types.BlockHeader.prototype.getTxsroothash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getTxsroothash())
      );
    };
    /**
     * optional bytes txsRootHash = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTxsroothash()`
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.getTxsroothash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getTxsroothash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockHeader.prototype.setTxsroothash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 6, value);
    };
    /**
     * optional bytes receiptsRootHash = 7;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockHeader.prototype.getReceiptsroothash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, "")
      );
    };
    /**
     * optional bytes receiptsRootHash = 7;
     * This is a type-conversion wrapper around `getReceiptsroothash()`
     * @return {string}
     */


    proto.types.BlockHeader.prototype.getReceiptsroothash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getReceiptsroothash())
      );
    };
    /**
     * optional bytes receiptsRootHash = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getReceiptsroothash()`
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.getReceiptsroothash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getReceiptsroothash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockHeader.prototype.setReceiptsroothash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 7, value);
    };
    /**
     * optional uint64 confirms = 8;
     * @return {number}
     */


    proto.types.BlockHeader.prototype.getConfirms = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 8, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockHeader.prototype.setConfirms = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 8, value);
    };
    /**
     * optional bytes pubKey = 9;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockHeader.prototype.getPubkey = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 9, "")
      );
    };
    /**
     * optional bytes pubKey = 9;
     * This is a type-conversion wrapper around `getPubkey()`
     * @return {string}
     */


    proto.types.BlockHeader.prototype.getPubkey_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getPubkey())
      );
    };
    /**
     * optional bytes pubKey = 9;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPubkey()`
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.getPubkey_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getPubkey())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockHeader.prototype.setPubkey = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 9, value);
    };
    /**
     * optional bytes coinbaseAccount = 10;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockHeader.prototype.getCoinbaseaccount = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 10, "")
      );
    };
    /**
     * optional bytes coinbaseAccount = 10;
     * This is a type-conversion wrapper around `getCoinbaseaccount()`
     * @return {string}
     */


    proto.types.BlockHeader.prototype.getCoinbaseaccount_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getCoinbaseaccount())
      );
    };
    /**
     * optional bytes coinbaseAccount = 10;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getCoinbaseaccount()`
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.getCoinbaseaccount_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getCoinbaseaccount())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockHeader.prototype.setCoinbaseaccount = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 10, value);
    };
    /**
     * optional bytes sign = 11;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockHeader.prototype.getSign = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 11, "")
      );
    };
    /**
     * optional bytes sign = 11;
     * This is a type-conversion wrapper around `getSign()`
     * @return {string}
     */


    proto.types.BlockHeader.prototype.getSign_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getSign())
      );
    };
    /**
     * optional bytes sign = 11;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSign()`
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.getSign_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getSign())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockHeader.prototype.setSign = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 11, value);
    };
    /**
     * optional bytes consensus = 12;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockHeader.prototype.getConsensus = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 12, "")
      );
    };
    /**
     * optional bytes consensus = 12;
     * This is a type-conversion wrapper around `getConsensus()`
     * @return {string}
     */


    proto.types.BlockHeader.prototype.getConsensus_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getConsensus())
      );
    };
    /**
     * optional bytes consensus = 12;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getConsensus()`
     * @return {!Uint8Array}
     */


    proto.types.BlockHeader.prototype.getConsensus_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getConsensus())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockHeader.prototype.setConsensus = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 12, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.BlockBody = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.BlockBody.repeatedFields_, null);
    };

    goog.inherits(proto.types.BlockBody, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.BlockBody.displayName = 'proto.types.BlockBody';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.BlockBody.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.BlockBody.prototype.toObject = function (opt_includeInstance) {
        return proto.types.BlockBody.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.BlockBody} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.BlockBody.toObject = function (includeInstance, msg) {
        var obj = {
          txsList: googleProtobuf.Message.toObjectList(msg.getTxsList(), proto.types.Tx.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.BlockBody}
     */


    proto.types.BlockBody.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.BlockBody();
      return proto.types.BlockBody.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.BlockBody} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.BlockBody}
     */


    proto.types.BlockBody.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.Tx();
            reader.readMessage(value, proto.types.Tx.deserializeBinaryFromReader);
            msg.addTxs(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.BlockBody.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.BlockBody.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.BlockBody} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.BlockBody.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getTxsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, proto.types.Tx.serializeBinaryToWriter);
      }
    };
    /**
     * repeated Tx txs = 1;
     * @return {!Array<!proto.types.Tx>}
     */


    proto.types.BlockBody.prototype.getTxsList = function () {
      return (
        /** @type{!Array<!proto.types.Tx>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.Tx, 1)
      );
    };
    /** @param {!Array<!proto.types.Tx>} value */


    proto.types.BlockBody.prototype.setTxsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.Tx=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Tx}
     */


    proto.types.BlockBody.prototype.addTxs = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.Tx, opt_index);
    };

    proto.types.BlockBody.prototype.clearTxsList = function () {
      this.setTxsList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.TxList = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.TxList.repeatedFields_, null);
    };

    goog.inherits(proto.types.TxList, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.TxList.displayName = 'proto.types.TxList';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.TxList.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.TxList.prototype.toObject = function (opt_includeInstance) {
        return proto.types.TxList.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.TxList} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.TxList.toObject = function (includeInstance, msg) {
        var obj = {
          txsList: googleProtobuf.Message.toObjectList(msg.getTxsList(), proto.types.Tx.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.TxList}
     */


    proto.types.TxList.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.TxList();
      return proto.types.TxList.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.TxList} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.TxList}
     */


    proto.types.TxList.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.Tx();
            reader.readMessage(value, proto.types.Tx.deserializeBinaryFromReader);
            msg.addTxs(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.TxList.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.TxList.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.TxList} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.TxList.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getTxsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, proto.types.Tx.serializeBinaryToWriter);
      }
    };
    /**
     * repeated Tx txs = 1;
     * @return {!Array<!proto.types.Tx>}
     */


    proto.types.TxList.prototype.getTxsList = function () {
      return (
        /** @type{!Array<!proto.types.Tx>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.Tx, 1)
      );
    };
    /** @param {!Array<!proto.types.Tx>} value */


    proto.types.TxList.prototype.setTxsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.Tx=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Tx}
     */


    proto.types.TxList.prototype.addTxs = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.Tx, opt_index);
    };

    proto.types.TxList.prototype.clearTxsList = function () {
      this.setTxsList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Tx = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Tx, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Tx.displayName = 'proto.types.Tx';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Tx.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Tx.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Tx} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Tx.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          hash: msg.getHash_asB64(),
          body: (f = msg.getBody()) && proto.types.TxBody.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Tx}
     */


    proto.types.Tx.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Tx();
      return proto.types.Tx.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Tx} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Tx}
     */


    proto.types.Tx.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setHash(value);
            break;

          case 2:
            var value = new proto.types.TxBody();
            reader.readMessage(value, proto.types.TxBody.deserializeBinaryFromReader);
            msg.setBody(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Tx.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Tx.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Tx} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Tx.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getBody();

      if (f != null) {
        writer.writeMessage(2, f, proto.types.TxBody.serializeBinaryToWriter);
      }
    };
    /**
     * optional bytes hash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Tx.prototype.getHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes hash = 1;
     * This is a type-conversion wrapper around `getHash()`
     * @return {string}
     */


    proto.types.Tx.prototype.getHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getHash())
      );
    };
    /**
     * optional bytes hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHash()`
     * @return {!Uint8Array}
     */


    proto.types.Tx.prototype.getHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Tx.prototype.setHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional TxBody body = 2;
     * @return {?proto.types.TxBody}
     */


    proto.types.Tx.prototype.getBody = function () {
      return (
        /** @type{?proto.types.TxBody} */
        googleProtobuf.Message.getWrapperField(this, proto.types.TxBody, 2)
      );
    };
    /** @param {?proto.types.TxBody|undefined} value */


    proto.types.Tx.prototype.setBody = function (value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };

    proto.types.Tx.prototype.clearBody = function () {
      this.setBody(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.Tx.prototype.hasBody = function () {
      return googleProtobuf.Message.getField(this, 2) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.TxBody = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.TxBody, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.TxBody.displayName = 'proto.types.TxBody';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.TxBody.prototype.toObject = function (opt_includeInstance) {
        return proto.types.TxBody.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.TxBody} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.TxBody.toObject = function (includeInstance, msg) {
        var obj = {
          nonce: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          account: msg.getAccount_asB64(),
          recipient: msg.getRecipient_asB64(),
          amount: msg.getAmount_asB64(),
          payload: msg.getPayload_asB64(),
          gaslimit: googleProtobuf.Message.getFieldWithDefault(msg, 6, 0),
          gasprice: msg.getGasprice_asB64(),
          type: googleProtobuf.Message.getFieldWithDefault(msg, 8, 0),
          chainidhash: msg.getChainidhash_asB64(),
          sign: msg.getSign_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.TxBody}
     */


    proto.types.TxBody.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.TxBody();
      return proto.types.TxBody.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.TxBody} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.TxBody}
     */


    proto.types.TxBody.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setNonce(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setAccount(value);
            break;

          case 3:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setRecipient(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setAmount(value);
            break;

          case 5:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setPayload(value);
            break;

          case 6:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setGaslimit(value);
            break;

          case 7:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setGasprice(value);
            break;

          case 8:
            var value =
            /** @type {!proto.types.TxType} */
            reader.readEnum();
            msg.setType(value);
            break;

          case 9:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setChainidhash(value);
            break;

          case 10:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setSign(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.TxBody.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.TxBody.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.TxBody} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.TxBody.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getNonce();

      if (f !== 0) {
        writer.writeUint64(1, f);
      }

      f = message.getAccount_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }

      f = message.getRecipient_asU8();

      if (f.length > 0) {
        writer.writeBytes(3, f);
      }

      f = message.getAmount_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }

      f = message.getPayload_asU8();

      if (f.length > 0) {
        writer.writeBytes(5, f);
      }

      f = message.getGaslimit();

      if (f !== 0) {
        writer.writeUint64(6, f);
      }

      f = message.getGasprice_asU8();

      if (f.length > 0) {
        writer.writeBytes(7, f);
      }

      f = message.getType();

      if (f !== 0.0) {
        writer.writeEnum(8, f);
      }

      f = message.getChainidhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(9, f);
      }

      f = message.getSign_asU8();

      if (f.length > 0) {
        writer.writeBytes(10, f);
      }
    };
    /**
     * optional uint64 nonce = 1;
     * @return {number}
     */


    proto.types.TxBody.prototype.getNonce = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {number} value */


    proto.types.TxBody.prototype.setNonce = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 1, value);
    };
    /**
     * optional bytes account = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.TxBody.prototype.getAccount = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes account = 2;
     * This is a type-conversion wrapper around `getAccount()`
     * @return {string}
     */


    proto.types.TxBody.prototype.getAccount_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getAccount())
      );
    };
    /**
     * optional bytes account = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAccount()`
     * @return {!Uint8Array}
     */


    proto.types.TxBody.prototype.getAccount_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getAccount())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.TxBody.prototype.setAccount = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * optional bytes recipient = 3;
     * @return {!(string|Uint8Array)}
     */


    proto.types.TxBody.prototype.getRecipient = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /**
     * optional bytes recipient = 3;
     * This is a type-conversion wrapper around `getRecipient()`
     * @return {string}
     */


    proto.types.TxBody.prototype.getRecipient_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getRecipient())
      );
    };
    /**
     * optional bytes recipient = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getRecipient()`
     * @return {!Uint8Array}
     */


    proto.types.TxBody.prototype.getRecipient_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getRecipient())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.TxBody.prototype.setRecipient = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 3, value);
    };
    /**
     * optional bytes amount = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.TxBody.prototype.getAmount = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes amount = 4;
     * This is a type-conversion wrapper around `getAmount()`
     * @return {string}
     */


    proto.types.TxBody.prototype.getAmount_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getAmount())
      );
    };
    /**
     * optional bytes amount = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAmount()`
     * @return {!Uint8Array}
     */


    proto.types.TxBody.prototype.getAmount_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getAmount())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.TxBody.prototype.setAmount = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * optional bytes payload = 5;
     * @return {!(string|Uint8Array)}
     */


    proto.types.TxBody.prototype.getPayload = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, "")
      );
    };
    /**
     * optional bytes payload = 5;
     * This is a type-conversion wrapper around `getPayload()`
     * @return {string}
     */


    proto.types.TxBody.prototype.getPayload_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getPayload())
      );
    };
    /**
     * optional bytes payload = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPayload()`
     * @return {!Uint8Array}
     */


    proto.types.TxBody.prototype.getPayload_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getPayload())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.TxBody.prototype.setPayload = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 5, value);
    };
    /**
     * optional uint64 gasLimit = 6;
     * @return {number}
     */


    proto.types.TxBody.prototype.getGaslimit = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, 0)
      );
    };
    /** @param {number} value */


    proto.types.TxBody.prototype.setGaslimit = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 6, value);
    };
    /**
     * optional bytes gasPrice = 7;
     * @return {!(string|Uint8Array)}
     */


    proto.types.TxBody.prototype.getGasprice = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, "")
      );
    };
    /**
     * optional bytes gasPrice = 7;
     * This is a type-conversion wrapper around `getGasprice()`
     * @return {string}
     */


    proto.types.TxBody.prototype.getGasprice_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getGasprice())
      );
    };
    /**
     * optional bytes gasPrice = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getGasprice()`
     * @return {!Uint8Array}
     */


    proto.types.TxBody.prototype.getGasprice_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getGasprice())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.TxBody.prototype.setGasprice = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 7, value);
    };
    /**
     * optional TxType type = 8;
     * @return {!proto.types.TxType}
     */


    proto.types.TxBody.prototype.getType = function () {
      return (
        /** @type {!proto.types.TxType} */
        googleProtobuf.Message.getFieldWithDefault(this, 8, 0)
      );
    };
    /** @param {!proto.types.TxType} value */


    proto.types.TxBody.prototype.setType = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 8, value);
    };
    /**
     * optional bytes chainIdHash = 9;
     * @return {!(string|Uint8Array)}
     */


    proto.types.TxBody.prototype.getChainidhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 9, "")
      );
    };
    /**
     * optional bytes chainIdHash = 9;
     * This is a type-conversion wrapper around `getChainidhash()`
     * @return {string}
     */


    proto.types.TxBody.prototype.getChainidhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getChainidhash())
      );
    };
    /**
     * optional bytes chainIdHash = 9;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getChainidhash()`
     * @return {!Uint8Array}
     */


    proto.types.TxBody.prototype.getChainidhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getChainidhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.TxBody.prototype.setChainidhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 9, value);
    };
    /**
     * optional bytes sign = 10;
     * @return {!(string|Uint8Array)}
     */


    proto.types.TxBody.prototype.getSign = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 10, "")
      );
    };
    /**
     * optional bytes sign = 10;
     * This is a type-conversion wrapper around `getSign()`
     * @return {string}
     */


    proto.types.TxBody.prototype.getSign_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getSign())
      );
    };
    /**
     * optional bytes sign = 10;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSign()`
     * @return {!Uint8Array}
     */


    proto.types.TxBody.prototype.getSign_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getSign())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.TxBody.prototype.setSign = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 10, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.TxIdx = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.TxIdx, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.TxIdx.displayName = 'proto.types.TxIdx';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.TxIdx.prototype.toObject = function (opt_includeInstance) {
        return proto.types.TxIdx.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.TxIdx} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.TxIdx.toObject = function (includeInstance, msg) {
        var obj = {
          blockhash: msg.getBlockhash_asB64(),
          idx: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.TxIdx}
     */


    proto.types.TxIdx.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.TxIdx();
      return proto.types.TxIdx.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.TxIdx} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.TxIdx}
     */


    proto.types.TxIdx.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBlockhash(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readInt32();
            msg.setIdx(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.TxIdx.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.TxIdx.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.TxIdx} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.TxIdx.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getBlockhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getIdx();

      if (f !== 0) {
        writer.writeInt32(2, f);
      }
    };
    /**
     * optional bytes blockHash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.TxIdx.prototype.getBlockhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes blockHash = 1;
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {string}
     */


    proto.types.TxIdx.prototype.getBlockhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBlockhash())
      );
    };
    /**
     * optional bytes blockHash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {!Uint8Array}
     */


    proto.types.TxIdx.prototype.getBlockhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBlockhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.TxIdx.prototype.setBlockhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional int32 idx = 2;
     * @return {number}
     */


    proto.types.TxIdx.prototype.getIdx = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.TxIdx.prototype.setIdx = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.TxInBlock = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.TxInBlock, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.TxInBlock.displayName = 'proto.types.TxInBlock';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.TxInBlock.prototype.toObject = function (opt_includeInstance) {
        return proto.types.TxInBlock.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.TxInBlock} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.TxInBlock.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          txidx: (f = msg.getTxidx()) && proto.types.TxIdx.toObject(includeInstance, f),
          tx: (f = msg.getTx()) && proto.types.Tx.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.TxInBlock}
     */


    proto.types.TxInBlock.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.TxInBlock();
      return proto.types.TxInBlock.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.TxInBlock} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.TxInBlock}
     */


    proto.types.TxInBlock.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.TxIdx();
            reader.readMessage(value, proto.types.TxIdx.deserializeBinaryFromReader);
            msg.setTxidx(value);
            break;

          case 2:
            var value = new proto.types.Tx();
            reader.readMessage(value, proto.types.Tx.deserializeBinaryFromReader);
            msg.setTx(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.TxInBlock.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.TxInBlock.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.TxInBlock} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.TxInBlock.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getTxidx();

      if (f != null) {
        writer.writeMessage(1, f, proto.types.TxIdx.serializeBinaryToWriter);
      }

      f = message.getTx();

      if (f != null) {
        writer.writeMessage(2, f, proto.types.Tx.serializeBinaryToWriter);
      }
    };
    /**
     * optional TxIdx txIdx = 1;
     * @return {?proto.types.TxIdx}
     */


    proto.types.TxInBlock.prototype.getTxidx = function () {
      return (
        /** @type{?proto.types.TxIdx} */
        googleProtobuf.Message.getWrapperField(this, proto.types.TxIdx, 1)
      );
    };
    /** @param {?proto.types.TxIdx|undefined} value */


    proto.types.TxInBlock.prototype.setTxidx = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.TxInBlock.prototype.clearTxidx = function () {
      this.setTxidx(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.TxInBlock.prototype.hasTxidx = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional Tx tx = 2;
     * @return {?proto.types.Tx}
     */


    proto.types.TxInBlock.prototype.getTx = function () {
      return (
        /** @type{?proto.types.Tx} */
        googleProtobuf.Message.getWrapperField(this, proto.types.Tx, 2)
      );
    };
    /** @param {?proto.types.Tx|undefined} value */


    proto.types.TxInBlock.prototype.setTx = function (value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };

    proto.types.TxInBlock.prototype.clearTx = function () {
      this.setTx(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.TxInBlock.prototype.hasTx = function () {
      return googleProtobuf.Message.getField(this, 2) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.State = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.State, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.State.displayName = 'proto.types.State';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.State.prototype.toObject = function (opt_includeInstance) {
        return proto.types.State.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.State} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.State.toObject = function (includeInstance, msg) {
        var obj = {
          nonce: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          balance: msg.getBalance_asB64(),
          codehash: msg.getCodehash_asB64(),
          storageroot: msg.getStorageroot_asB64(),
          sqlrecoverypoint: googleProtobuf.Message.getFieldWithDefault(msg, 5, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.State}
     */


    proto.types.State.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.State();
      return proto.types.State.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.State} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.State}
     */


    proto.types.State.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setNonce(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBalance(value);
            break;

          case 3:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setCodehash(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setStorageroot(value);
            break;

          case 5:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setSqlrecoverypoint(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.State.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.State.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.State} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.State.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getNonce();

      if (f !== 0) {
        writer.writeUint64(1, f);
      }

      f = message.getBalance_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }

      f = message.getCodehash_asU8();

      if (f.length > 0) {
        writer.writeBytes(3, f);
      }

      f = message.getStorageroot_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }

      f = message.getSqlrecoverypoint();

      if (f !== 0) {
        writer.writeUint64(5, f);
      }
    };
    /**
     * optional uint64 nonce = 1;
     * @return {number}
     */


    proto.types.State.prototype.getNonce = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {number} value */


    proto.types.State.prototype.setNonce = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 1, value);
    };
    /**
     * optional bytes balance = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.State.prototype.getBalance = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes balance = 2;
     * This is a type-conversion wrapper around `getBalance()`
     * @return {string}
     */


    proto.types.State.prototype.getBalance_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBalance())
      );
    };
    /**
     * optional bytes balance = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBalance()`
     * @return {!Uint8Array}
     */


    proto.types.State.prototype.getBalance_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBalance())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.State.prototype.setBalance = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * optional bytes codeHash = 3;
     * @return {!(string|Uint8Array)}
     */


    proto.types.State.prototype.getCodehash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /**
     * optional bytes codeHash = 3;
     * This is a type-conversion wrapper around `getCodehash()`
     * @return {string}
     */


    proto.types.State.prototype.getCodehash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getCodehash())
      );
    };
    /**
     * optional bytes codeHash = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getCodehash()`
     * @return {!Uint8Array}
     */


    proto.types.State.prototype.getCodehash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getCodehash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.State.prototype.setCodehash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 3, value);
    };
    /**
     * optional bytes storageRoot = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.State.prototype.getStorageroot = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes storageRoot = 4;
     * This is a type-conversion wrapper around `getStorageroot()`
     * @return {string}
     */


    proto.types.State.prototype.getStorageroot_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getStorageroot())
      );
    };
    /**
     * optional bytes storageRoot = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getStorageroot()`
     * @return {!Uint8Array}
     */


    proto.types.State.prototype.getStorageroot_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getStorageroot())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.State.prototype.setStorageroot = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * optional uint64 sqlRecoveryPoint = 5;
     * @return {number}
     */


    proto.types.State.prototype.getSqlrecoverypoint = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    /** @param {number} value */


    proto.types.State.prototype.setSqlrecoverypoint = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 5, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.AccountProof = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.AccountProof.repeatedFields_, null);
    };

    goog.inherits(proto.types.AccountProof, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.AccountProof.displayName = 'proto.types.AccountProof';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.AccountProof.repeatedFields_ = [8];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.AccountProof.prototype.toObject = function (opt_includeInstance) {
        return proto.types.AccountProof.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.AccountProof} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.AccountProof.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          state: (f = msg.getState()) && proto.types.State.toObject(includeInstance, f),
          inclusion: googleProtobuf.Message.getFieldWithDefault(msg, 2, false),
          key: msg.getKey_asB64(),
          proofkey: msg.getProofkey_asB64(),
          proofval: msg.getProofval_asB64(),
          bitmap: msg.getBitmap_asB64(),
          height: googleProtobuf.Message.getFieldWithDefault(msg, 7, 0),
          auditpathList: msg.getAuditpathList_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.AccountProof}
     */


    proto.types.AccountProof.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.AccountProof();
      return proto.types.AccountProof.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.AccountProof} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.AccountProof}
     */


    proto.types.AccountProof.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.State();
            reader.readMessage(value, proto.types.State.deserializeBinaryFromReader);
            msg.setState(value);
            break;

          case 2:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setInclusion(value);
            break;

          case 3:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setKey(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setProofkey(value);
            break;

          case 5:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setProofval(value);
            break;

          case 6:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBitmap(value);
            break;

          case 7:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setHeight(value);
            break;

          case 8:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addAuditpath(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.AccountProof.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.AccountProof.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.AccountProof} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.AccountProof.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getState();

      if (f != null) {
        writer.writeMessage(1, f, proto.types.State.serializeBinaryToWriter);
      }

      f = message.getInclusion();

      if (f) {
        writer.writeBool(2, f);
      }

      f = message.getKey_asU8();

      if (f.length > 0) {
        writer.writeBytes(3, f);
      }

      f = message.getProofkey_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }

      f = message.getProofval_asU8();

      if (f.length > 0) {
        writer.writeBytes(5, f);
      }

      f = message.getBitmap_asU8();

      if (f.length > 0) {
        writer.writeBytes(6, f);
      }

      f = message.getHeight();

      if (f !== 0) {
        writer.writeUint32(7, f);
      }

      f = message.getAuditpathList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(8, f);
      }
    };
    /**
     * optional State state = 1;
     * @return {?proto.types.State}
     */


    proto.types.AccountProof.prototype.getState = function () {
      return (
        /** @type{?proto.types.State} */
        googleProtobuf.Message.getWrapperField(this, proto.types.State, 1)
      );
    };
    /** @param {?proto.types.State|undefined} value */


    proto.types.AccountProof.prototype.setState = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.AccountProof.prototype.clearState = function () {
      this.setState(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.AccountProof.prototype.hasState = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional bool inclusion = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.AccountProof.prototype.getInclusion = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, false)
      );
    };
    /** @param {boolean} value */


    proto.types.AccountProof.prototype.setInclusion = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 2, value);
    };
    /**
     * optional bytes key = 3;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AccountProof.prototype.getKey = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /**
     * optional bytes key = 3;
     * This is a type-conversion wrapper around `getKey()`
     * @return {string}
     */


    proto.types.AccountProof.prototype.getKey_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getKey())
      );
    };
    /**
     * optional bytes key = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getKey()`
     * @return {!Uint8Array}
     */


    proto.types.AccountProof.prototype.getKey_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getKey())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AccountProof.prototype.setKey = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 3, value);
    };
    /**
     * optional bytes proofKey = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AccountProof.prototype.getProofkey = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes proofKey = 4;
     * This is a type-conversion wrapper around `getProofkey()`
     * @return {string}
     */


    proto.types.AccountProof.prototype.getProofkey_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getProofkey())
      );
    };
    /**
     * optional bytes proofKey = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getProofkey()`
     * @return {!Uint8Array}
     */


    proto.types.AccountProof.prototype.getProofkey_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getProofkey())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AccountProof.prototype.setProofkey = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * optional bytes proofVal = 5;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AccountProof.prototype.getProofval = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, "")
      );
    };
    /**
     * optional bytes proofVal = 5;
     * This is a type-conversion wrapper around `getProofval()`
     * @return {string}
     */


    proto.types.AccountProof.prototype.getProofval_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getProofval())
      );
    };
    /**
     * optional bytes proofVal = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getProofval()`
     * @return {!Uint8Array}
     */


    proto.types.AccountProof.prototype.getProofval_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getProofval())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AccountProof.prototype.setProofval = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 5, value);
    };
    /**
     * optional bytes bitmap = 6;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AccountProof.prototype.getBitmap = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /**
     * optional bytes bitmap = 6;
     * This is a type-conversion wrapper around `getBitmap()`
     * @return {string}
     */


    proto.types.AccountProof.prototype.getBitmap_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBitmap())
      );
    };
    /**
     * optional bytes bitmap = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBitmap()`
     * @return {!Uint8Array}
     */


    proto.types.AccountProof.prototype.getBitmap_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBitmap())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AccountProof.prototype.setBitmap = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 6, value);
    };
    /**
     * optional uint32 height = 7;
     * @return {number}
     */


    proto.types.AccountProof.prototype.getHeight = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    /** @param {number} value */


    proto.types.AccountProof.prototype.setHeight = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 7, value);
    };
    /**
     * repeated bytes auditPath = 8;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.AccountProof.prototype.getAuditpathList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 8)
      );
    };
    /**
     * repeated bytes auditPath = 8;
     * This is a type-conversion wrapper around `getAuditpathList()`
     * @return {!Array<string>}
     */


    proto.types.AccountProof.prototype.getAuditpathList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getAuditpathList())
      );
    };
    /**
     * repeated bytes auditPath = 8;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAuditpathList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.AccountProof.prototype.getAuditpathList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getAuditpathList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.AccountProof.prototype.setAuditpathList = function (value) {
      googleProtobuf.Message.setField(this, 8, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.AccountProof.prototype.addAuditpath = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 8, value, opt_index);
    };

    proto.types.AccountProof.prototype.clearAuditpathList = function () {
      this.setAuditpathList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ContractVarProof = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.ContractVarProof.repeatedFields_, null);
    };

    goog.inherits(proto.types.ContractVarProof, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ContractVarProof.displayName = 'proto.types.ContractVarProof';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.ContractVarProof.repeatedFields_ = [8];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ContractVarProof.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ContractVarProof.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ContractVarProof} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ContractVarProof.toObject = function (includeInstance, msg) {
        var obj = {
          value: msg.getValue_asB64(),
          inclusion: googleProtobuf.Message.getFieldWithDefault(msg, 2, false),
          proofkey: msg.getProofkey_asB64(),
          proofval: msg.getProofval_asB64(),
          bitmap: msg.getBitmap_asB64(),
          height: googleProtobuf.Message.getFieldWithDefault(msg, 7, 0),
          auditpathList: msg.getAuditpathList_asB64(),
          key: msg.getKey_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ContractVarProof}
     */


    proto.types.ContractVarProof.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ContractVarProof();
      return proto.types.ContractVarProof.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ContractVarProof} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ContractVarProof}
     */


    proto.types.ContractVarProof.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setValue(value);
            break;

          case 2:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setInclusion(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setProofkey(value);
            break;

          case 5:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setProofval(value);
            break;

          case 6:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBitmap(value);
            break;

          case 7:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setHeight(value);
            break;

          case 8:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addAuditpath(value);
            break;

          case 9:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setKey(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ContractVarProof.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ContractVarProof.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ContractVarProof} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ContractVarProof.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getValue_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getInclusion();

      if (f) {
        writer.writeBool(2, f);
      }

      f = message.getProofkey_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }

      f = message.getProofval_asU8();

      if (f.length > 0) {
        writer.writeBytes(5, f);
      }

      f = message.getBitmap_asU8();

      if (f.length > 0) {
        writer.writeBytes(6, f);
      }

      f = message.getHeight();

      if (f !== 0) {
        writer.writeUint32(7, f);
      }

      f = message.getAuditpathList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(8, f);
      }

      f = message.getKey_asU8();

      if (f.length > 0) {
        writer.writeBytes(9, f);
      }
    };
    /**
     * optional bytes value = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ContractVarProof.prototype.getValue = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes value = 1;
     * This is a type-conversion wrapper around `getValue()`
     * @return {string}
     */


    proto.types.ContractVarProof.prototype.getValue_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getValue())
      );
    };
    /**
     * optional bytes value = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getValue()`
     * @return {!Uint8Array}
     */


    proto.types.ContractVarProof.prototype.getValue_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getValue())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ContractVarProof.prototype.setValue = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional bool inclusion = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.ContractVarProof.prototype.getInclusion = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, false)
      );
    };
    /** @param {boolean} value */


    proto.types.ContractVarProof.prototype.setInclusion = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 2, value);
    };
    /**
     * optional bytes proofKey = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ContractVarProof.prototype.getProofkey = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes proofKey = 4;
     * This is a type-conversion wrapper around `getProofkey()`
     * @return {string}
     */


    proto.types.ContractVarProof.prototype.getProofkey_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getProofkey())
      );
    };
    /**
     * optional bytes proofKey = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getProofkey()`
     * @return {!Uint8Array}
     */


    proto.types.ContractVarProof.prototype.getProofkey_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getProofkey())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ContractVarProof.prototype.setProofkey = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * optional bytes proofVal = 5;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ContractVarProof.prototype.getProofval = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, "")
      );
    };
    /**
     * optional bytes proofVal = 5;
     * This is a type-conversion wrapper around `getProofval()`
     * @return {string}
     */


    proto.types.ContractVarProof.prototype.getProofval_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getProofval())
      );
    };
    /**
     * optional bytes proofVal = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getProofval()`
     * @return {!Uint8Array}
     */


    proto.types.ContractVarProof.prototype.getProofval_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getProofval())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ContractVarProof.prototype.setProofval = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 5, value);
    };
    /**
     * optional bytes bitmap = 6;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ContractVarProof.prototype.getBitmap = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /**
     * optional bytes bitmap = 6;
     * This is a type-conversion wrapper around `getBitmap()`
     * @return {string}
     */


    proto.types.ContractVarProof.prototype.getBitmap_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBitmap())
      );
    };
    /**
     * optional bytes bitmap = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBitmap()`
     * @return {!Uint8Array}
     */


    proto.types.ContractVarProof.prototype.getBitmap_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBitmap())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ContractVarProof.prototype.setBitmap = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 6, value);
    };
    /**
     * optional uint32 height = 7;
     * @return {number}
     */


    proto.types.ContractVarProof.prototype.getHeight = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    /** @param {number} value */


    proto.types.ContractVarProof.prototype.setHeight = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 7, value);
    };
    /**
     * repeated bytes auditPath = 8;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.ContractVarProof.prototype.getAuditpathList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 8)
      );
    };
    /**
     * repeated bytes auditPath = 8;
     * This is a type-conversion wrapper around `getAuditpathList()`
     * @return {!Array<string>}
     */


    proto.types.ContractVarProof.prototype.getAuditpathList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getAuditpathList())
      );
    };
    /**
     * repeated bytes auditPath = 8;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAuditpathList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.ContractVarProof.prototype.getAuditpathList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getAuditpathList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.ContractVarProof.prototype.setAuditpathList = function (value) {
      googleProtobuf.Message.setField(this, 8, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.ContractVarProof.prototype.addAuditpath = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 8, value, opt_index);
    };

    proto.types.ContractVarProof.prototype.clearAuditpathList = function () {
      this.setAuditpathList([]);
    };
    /**
     * optional bytes key = 9;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ContractVarProof.prototype.getKey = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 9, "")
      );
    };
    /**
     * optional bytes key = 9;
     * This is a type-conversion wrapper around `getKey()`
     * @return {string}
     */


    proto.types.ContractVarProof.prototype.getKey_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getKey())
      );
    };
    /**
     * optional bytes key = 9;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getKey()`
     * @return {!Uint8Array}
     */


    proto.types.ContractVarProof.prototype.getKey_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getKey())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ContractVarProof.prototype.setKey = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 9, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.StateQueryProof = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.StateQueryProof.repeatedFields_, null);
    };

    goog.inherits(proto.types.StateQueryProof, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.StateQueryProof.displayName = 'proto.types.StateQueryProof';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.StateQueryProof.repeatedFields_ = [2];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.StateQueryProof.prototype.toObject = function (opt_includeInstance) {
        return proto.types.StateQueryProof.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.StateQueryProof} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.StateQueryProof.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          contractproof: (f = msg.getContractproof()) && proto.types.AccountProof.toObject(includeInstance, f),
          varproofsList: googleProtobuf.Message.toObjectList(msg.getVarproofsList(), proto.types.ContractVarProof.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.StateQueryProof}
     */


    proto.types.StateQueryProof.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.StateQueryProof();
      return proto.types.StateQueryProof.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.StateQueryProof} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.StateQueryProof}
     */


    proto.types.StateQueryProof.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.AccountProof();
            reader.readMessage(value, proto.types.AccountProof.deserializeBinaryFromReader);
            msg.setContractproof(value);
            break;

          case 2:
            var value = new proto.types.ContractVarProof();
            reader.readMessage(value, proto.types.ContractVarProof.deserializeBinaryFromReader);
            msg.addVarproofs(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.StateQueryProof.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.StateQueryProof.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.StateQueryProof} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.StateQueryProof.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getContractproof();

      if (f != null) {
        writer.writeMessage(1, f, proto.types.AccountProof.serializeBinaryToWriter);
      }

      f = message.getVarproofsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(2, f, proto.types.ContractVarProof.serializeBinaryToWriter);
      }
    };
    /**
     * optional AccountProof contractProof = 1;
     * @return {?proto.types.AccountProof}
     */


    proto.types.StateQueryProof.prototype.getContractproof = function () {
      return (
        /** @type{?proto.types.AccountProof} */
        googleProtobuf.Message.getWrapperField(this, proto.types.AccountProof, 1)
      );
    };
    /** @param {?proto.types.AccountProof|undefined} value */


    proto.types.StateQueryProof.prototype.setContractproof = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.StateQueryProof.prototype.clearContractproof = function () {
      this.setContractproof(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.StateQueryProof.prototype.hasContractproof = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * repeated ContractVarProof varProofs = 2;
     * @return {!Array<!proto.types.ContractVarProof>}
     */


    proto.types.StateQueryProof.prototype.getVarproofsList = function () {
      return (
        /** @type{!Array<!proto.types.ContractVarProof>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.ContractVarProof, 2)
      );
    };
    /** @param {!Array<!proto.types.ContractVarProof>} value */


    proto.types.StateQueryProof.prototype.setVarproofsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };
    /**
     * @param {!proto.types.ContractVarProof=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.ContractVarProof}
     */


    proto.types.StateQueryProof.prototype.addVarproofs = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.types.ContractVarProof, opt_index);
    };

    proto.types.StateQueryProof.prototype.clearVarproofsList = function () {
      this.setVarproofsList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Receipt = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.Receipt.repeatedFields_, null);
    };

    goog.inherits(proto.types.Receipt, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Receipt.displayName = 'proto.types.Receipt';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.Receipt.repeatedFields_ = [8];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Receipt.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Receipt.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Receipt} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Receipt.toObject = function (includeInstance, msg) {
        var obj = {
          contractaddress: msg.getContractaddress_asB64(),
          status: googleProtobuf.Message.getFieldWithDefault(msg, 2, ""),
          ret: googleProtobuf.Message.getFieldWithDefault(msg, 3, ""),
          txhash: msg.getTxhash_asB64(),
          feeused: msg.getFeeused_asB64(),
          cumulativefeeused: msg.getCumulativefeeused_asB64(),
          bloom: msg.getBloom_asB64(),
          eventsList: googleProtobuf.Message.toObjectList(msg.getEventsList(), proto.types.Event.toObject, includeInstance),
          blockno: googleProtobuf.Message.getFieldWithDefault(msg, 9, 0),
          blockhash: msg.getBlockhash_asB64(),
          txindex: googleProtobuf.Message.getFieldWithDefault(msg, 11, 0),
          from: msg.getFrom_asB64(),
          to: msg.getTo_asB64(),
          feedelegation: googleProtobuf.Message.getFieldWithDefault(msg, 14, false),
          gasused: googleProtobuf.Message.getFieldWithDefault(msg, 15, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Receipt}
     */


    proto.types.Receipt.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Receipt();
      return proto.types.Receipt.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Receipt} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Receipt}
     */


    proto.types.Receipt.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setContractaddress(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setStatus(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setRet(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setTxhash(value);
            break;

          case 5:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setFeeused(value);
            break;

          case 6:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setCumulativefeeused(value);
            break;

          case 7:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBloom(value);
            break;

          case 8:
            var value = new proto.types.Event();
            reader.readMessage(value, proto.types.Event.deserializeBinaryFromReader);
            msg.addEvents(value);
            break;

          case 9:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBlockno(value);
            break;

          case 10:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBlockhash(value);
            break;

          case 11:
            var value =
            /** @type {number} */
            reader.readInt32();
            msg.setTxindex(value);
            break;

          case 12:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setFrom(value);
            break;

          case 13:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setTo(value);
            break;

          case 14:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setFeedelegation(value);
            break;

          case 15:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setGasused(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Receipt.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Receipt.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Receipt} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Receipt.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getContractaddress_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getStatus();

      if (f.length > 0) {
        writer.writeString(2, f);
      }

      f = message.getRet();

      if (f.length > 0) {
        writer.writeString(3, f);
      }

      f = message.getTxhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }

      f = message.getFeeused_asU8();

      if (f.length > 0) {
        writer.writeBytes(5, f);
      }

      f = message.getCumulativefeeused_asU8();

      if (f.length > 0) {
        writer.writeBytes(6, f);
      }

      f = message.getBloom_asU8();

      if (f.length > 0) {
        writer.writeBytes(7, f);
      }

      f = message.getEventsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(8, f, proto.types.Event.serializeBinaryToWriter);
      }

      f = message.getBlockno();

      if (f !== 0) {
        writer.writeUint64(9, f);
      }

      f = message.getBlockhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(10, f);
      }

      f = message.getTxindex();

      if (f !== 0) {
        writer.writeInt32(11, f);
      }

      f = message.getFrom_asU8();

      if (f.length > 0) {
        writer.writeBytes(12, f);
      }

      f = message.getTo_asU8();

      if (f.length > 0) {
        writer.writeBytes(13, f);
      }

      f = message.getFeedelegation();

      if (f) {
        writer.writeBool(14, f);
      }

      f = message.getGasused();

      if (f !== 0) {
        writer.writeUint64(15, f);
      }
    };
    /**
     * optional bytes contractAddress = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Receipt.prototype.getContractaddress = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {string}
     */


    proto.types.Receipt.prototype.getContractaddress_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getContractaddress())
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {!Uint8Array}
     */


    proto.types.Receipt.prototype.getContractaddress_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getContractaddress())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Receipt.prototype.setContractaddress = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional string status = 2;
     * @return {string}
     */


    proto.types.Receipt.prototype.getStatus = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.Receipt.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * optional string ret = 3;
     * @return {string}
     */


    proto.types.Receipt.prototype.getRet = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.Receipt.prototype.setRet = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * optional bytes txHash = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Receipt.prototype.getTxhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes txHash = 4;
     * This is a type-conversion wrapper around `getTxhash()`
     * @return {string}
     */


    proto.types.Receipt.prototype.getTxhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getTxhash())
      );
    };
    /**
     * optional bytes txHash = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTxhash()`
     * @return {!Uint8Array}
     */


    proto.types.Receipt.prototype.getTxhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getTxhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Receipt.prototype.setTxhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * optional bytes feeUsed = 5;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Receipt.prototype.getFeeused = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, "")
      );
    };
    /**
     * optional bytes feeUsed = 5;
     * This is a type-conversion wrapper around `getFeeused()`
     * @return {string}
     */


    proto.types.Receipt.prototype.getFeeused_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getFeeused())
      );
    };
    /**
     * optional bytes feeUsed = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getFeeused()`
     * @return {!Uint8Array}
     */


    proto.types.Receipt.prototype.getFeeused_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getFeeused())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Receipt.prototype.setFeeused = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 5, value);
    };
    /**
     * optional bytes cumulativeFeeUsed = 6;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Receipt.prototype.getCumulativefeeused = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /**
     * optional bytes cumulativeFeeUsed = 6;
     * This is a type-conversion wrapper around `getCumulativefeeused()`
     * @return {string}
     */


    proto.types.Receipt.prototype.getCumulativefeeused_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getCumulativefeeused())
      );
    };
    /**
     * optional bytes cumulativeFeeUsed = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getCumulativefeeused()`
     * @return {!Uint8Array}
     */


    proto.types.Receipt.prototype.getCumulativefeeused_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getCumulativefeeused())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Receipt.prototype.setCumulativefeeused = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 6, value);
    };
    /**
     * optional bytes bloom = 7;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Receipt.prototype.getBloom = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, "")
      );
    };
    /**
     * optional bytes bloom = 7;
     * This is a type-conversion wrapper around `getBloom()`
     * @return {string}
     */


    proto.types.Receipt.prototype.getBloom_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBloom())
      );
    };
    /**
     * optional bytes bloom = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBloom()`
     * @return {!Uint8Array}
     */


    proto.types.Receipt.prototype.getBloom_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBloom())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Receipt.prototype.setBloom = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 7, value);
    };
    /**
     * repeated Event events = 8;
     * @return {!Array<!proto.types.Event>}
     */


    proto.types.Receipt.prototype.getEventsList = function () {
      return (
        /** @type{!Array<!proto.types.Event>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.Event, 8)
      );
    };
    /** @param {!Array<!proto.types.Event>} value */


    proto.types.Receipt.prototype.setEventsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 8, value);
    };
    /**
     * @param {!proto.types.Event=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Event}
     */


    proto.types.Receipt.prototype.addEvents = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.types.Event, opt_index);
    };

    proto.types.Receipt.prototype.clearEventsList = function () {
      this.setEventsList([]);
    };
    /**
     * optional uint64 blockNo = 9;
     * @return {number}
     */


    proto.types.Receipt.prototype.getBlockno = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 9, 0)
      );
    };
    /** @param {number} value */


    proto.types.Receipt.prototype.setBlockno = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 9, value);
    };
    /**
     * optional bytes blockHash = 10;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Receipt.prototype.getBlockhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 10, "")
      );
    };
    /**
     * optional bytes blockHash = 10;
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {string}
     */


    proto.types.Receipt.prototype.getBlockhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBlockhash())
      );
    };
    /**
     * optional bytes blockHash = 10;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {!Uint8Array}
     */


    proto.types.Receipt.prototype.getBlockhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBlockhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Receipt.prototype.setBlockhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 10, value);
    };
    /**
     * optional int32 txIndex = 11;
     * @return {number}
     */


    proto.types.Receipt.prototype.getTxindex = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 11, 0)
      );
    };
    /** @param {number} value */


    proto.types.Receipt.prototype.setTxindex = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 11, value);
    };
    /**
     * optional bytes from = 12;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Receipt.prototype.getFrom = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 12, "")
      );
    };
    /**
     * optional bytes from = 12;
     * This is a type-conversion wrapper around `getFrom()`
     * @return {string}
     */


    proto.types.Receipt.prototype.getFrom_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getFrom())
      );
    };
    /**
     * optional bytes from = 12;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getFrom()`
     * @return {!Uint8Array}
     */


    proto.types.Receipt.prototype.getFrom_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getFrom())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Receipt.prototype.setFrom = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 12, value);
    };
    /**
     * optional bytes to = 13;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Receipt.prototype.getTo = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 13, "")
      );
    };
    /**
     * optional bytes to = 13;
     * This is a type-conversion wrapper around `getTo()`
     * @return {string}
     */


    proto.types.Receipt.prototype.getTo_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getTo())
      );
    };
    /**
     * optional bytes to = 13;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTo()`
     * @return {!Uint8Array}
     */


    proto.types.Receipt.prototype.getTo_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getTo())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Receipt.prototype.setTo = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 13, value);
    };
    /**
     * optional bool feeDelegation = 14;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.Receipt.prototype.getFeedelegation = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 14, false)
      );
    };
    /** @param {boolean} value */


    proto.types.Receipt.prototype.setFeedelegation = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 14, value);
    };
    /**
     * optional uint64 gasUsed = 15;
     * @return {number}
     */


    proto.types.Receipt.prototype.getGasused = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 15, 0)
      );
    };
    /** @param {number} value */


    proto.types.Receipt.prototype.setGasused = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 15, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Event = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Event, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Event.displayName = 'proto.types.Event';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Event.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Event.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Event} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Event.toObject = function (includeInstance, msg) {
        var obj = {
          contractaddress: msg.getContractaddress_asB64(),
          eventname: googleProtobuf.Message.getFieldWithDefault(msg, 2, ""),
          jsonargs: googleProtobuf.Message.getFieldWithDefault(msg, 3, ""),
          eventidx: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0),
          txhash: msg.getTxhash_asB64(),
          blockhash: msg.getBlockhash_asB64(),
          blockno: googleProtobuf.Message.getFieldWithDefault(msg, 7, 0),
          txindex: googleProtobuf.Message.getFieldWithDefault(msg, 8, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Event}
     */


    proto.types.Event.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Event();
      return proto.types.Event.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Event} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Event}
     */


    proto.types.Event.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setContractaddress(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setEventname(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setJsonargs(value);
            break;

          case 4:
            var value =
            /** @type {number} */
            reader.readInt32();
            msg.setEventidx(value);
            break;

          case 5:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setTxhash(value);
            break;

          case 6:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBlockhash(value);
            break;

          case 7:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBlockno(value);
            break;

          case 8:
            var value =
            /** @type {number} */
            reader.readInt32();
            msg.setTxindex(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Event.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Event.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Event} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Event.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getContractaddress_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getEventname();

      if (f.length > 0) {
        writer.writeString(2, f);
      }

      f = message.getJsonargs();

      if (f.length > 0) {
        writer.writeString(3, f);
      }

      f = message.getEventidx();

      if (f !== 0) {
        writer.writeInt32(4, f);
      }

      f = message.getTxhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(5, f);
      }

      f = message.getBlockhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(6, f);
      }

      f = message.getBlockno();

      if (f !== 0) {
        writer.writeUint64(7, f);
      }

      f = message.getTxindex();

      if (f !== 0) {
        writer.writeInt32(8, f);
      }
    };
    /**
     * optional bytes contractAddress = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Event.prototype.getContractaddress = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {string}
     */


    proto.types.Event.prototype.getContractaddress_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getContractaddress())
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {!Uint8Array}
     */


    proto.types.Event.prototype.getContractaddress_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getContractaddress())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Event.prototype.setContractaddress = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional string eventName = 2;
     * @return {string}
     */


    proto.types.Event.prototype.getEventname = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.Event.prototype.setEventname = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * optional string jsonArgs = 3;
     * @return {string}
     */


    proto.types.Event.prototype.getJsonargs = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.Event.prototype.setJsonargs = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * optional int32 eventIdx = 4;
     * @return {number}
     */


    proto.types.Event.prototype.getEventidx = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    /** @param {number} value */


    proto.types.Event.prototype.setEventidx = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 4, value);
    };
    /**
     * optional bytes txHash = 5;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Event.prototype.getTxhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, "")
      );
    };
    /**
     * optional bytes txHash = 5;
     * This is a type-conversion wrapper around `getTxhash()`
     * @return {string}
     */


    proto.types.Event.prototype.getTxhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getTxhash())
      );
    };
    /**
     * optional bytes txHash = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTxhash()`
     * @return {!Uint8Array}
     */


    proto.types.Event.prototype.getTxhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getTxhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Event.prototype.setTxhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 5, value);
    };
    /**
     * optional bytes blockHash = 6;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Event.prototype.getBlockhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /**
     * optional bytes blockHash = 6;
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {string}
     */


    proto.types.Event.prototype.getBlockhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBlockhash())
      );
    };
    /**
     * optional bytes blockHash = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {!Uint8Array}
     */


    proto.types.Event.prototype.getBlockhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBlockhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Event.prototype.setBlockhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 6, value);
    };
    /**
     * optional uint64 blockNo = 7;
     * @return {number}
     */


    proto.types.Event.prototype.getBlockno = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    /** @param {number} value */


    proto.types.Event.prototype.setBlockno = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 7, value);
    };
    /**
     * optional int32 txIndex = 8;
     * @return {number}
     */


    proto.types.Event.prototype.getTxindex = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 8, 0)
      );
    };
    /** @param {number} value */


    proto.types.Event.prototype.setTxindex = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 8, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.FnArgument = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.FnArgument, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.FnArgument.displayName = 'proto.types.FnArgument';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.FnArgument.prototype.toObject = function (opt_includeInstance) {
        return proto.types.FnArgument.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.FnArgument} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.FnArgument.toObject = function (includeInstance, msg) {
        var obj = {
          name: googleProtobuf.Message.getFieldWithDefault(msg, 1, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.FnArgument}
     */


    proto.types.FnArgument.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.FnArgument();
      return proto.types.FnArgument.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.FnArgument} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.FnArgument}
     */


    proto.types.FnArgument.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setName(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.FnArgument.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.FnArgument.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.FnArgument} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.FnArgument.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getName();

      if (f.length > 0) {
        writer.writeString(1, f);
      }
    };
    /**
     * optional string name = 1;
     * @return {string}
     */


    proto.types.FnArgument.prototype.getName = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.FnArgument.prototype.setName = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Function = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.Function.repeatedFields_, null);
    };

    goog.inherits(proto.types.Function, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Function.displayName = 'proto.types.Function';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.Function.repeatedFields_ = [2];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Function.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Function.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Function} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Function.toObject = function (includeInstance, msg) {
        var obj = {
          name: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          argumentsList: googleProtobuf.Message.toObjectList(msg.getArgumentsList(), proto.types.FnArgument.toObject, includeInstance),
          payable: googleProtobuf.Message.getFieldWithDefault(msg, 3, false),
          view: googleProtobuf.Message.getFieldWithDefault(msg, 4, false),
          feeDelegation: googleProtobuf.Message.getFieldWithDefault(msg, 5, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Function}
     */


    proto.types.Function.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Function();
      return proto.types.Function.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Function} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Function}
     */


    proto.types.Function.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setName(value);
            break;

          case 2:
            var value = new proto.types.FnArgument();
            reader.readMessage(value, proto.types.FnArgument.deserializeBinaryFromReader);
            msg.addArguments(value);
            break;

          case 3:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setPayable(value);
            break;

          case 4:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setView(value);
            break;

          case 5:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setFeeDelegation(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Function.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Function.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Function} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Function.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getName();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getArgumentsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(2, f, proto.types.FnArgument.serializeBinaryToWriter);
      }

      f = message.getPayable();

      if (f) {
        writer.writeBool(3, f);
      }

      f = message.getView();

      if (f) {
        writer.writeBool(4, f);
      }

      f = message.getFeeDelegation();

      if (f) {
        writer.writeBool(5, f);
      }
    };
    /**
     * optional string name = 1;
     * @return {string}
     */


    proto.types.Function.prototype.getName = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.Function.prototype.setName = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * repeated FnArgument arguments = 2;
     * @return {!Array<!proto.types.FnArgument>}
     */


    proto.types.Function.prototype.getArgumentsList = function () {
      return (
        /** @type{!Array<!proto.types.FnArgument>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.FnArgument, 2)
      );
    };
    /** @param {!Array<!proto.types.FnArgument>} value */


    proto.types.Function.prototype.setArgumentsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };
    /**
     * @param {!proto.types.FnArgument=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.FnArgument}
     */


    proto.types.Function.prototype.addArguments = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.types.FnArgument, opt_index);
    };

    proto.types.Function.prototype.clearArgumentsList = function () {
      this.setArgumentsList([]);
    };
    /**
     * optional bool payable = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.Function.prototype.getPayable = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, false)
      );
    };
    /** @param {boolean} value */


    proto.types.Function.prototype.setPayable = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 3, value);
    };
    /**
     * optional bool view = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.Function.prototype.getView = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, false)
      );
    };
    /** @param {boolean} value */


    proto.types.Function.prototype.setView = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 4, value);
    };
    /**
     * optional bool fee_delegation = 5;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.Function.prototype.getFeeDelegation = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, false)
      );
    };
    /** @param {boolean} value */


    proto.types.Function.prototype.setFeeDelegation = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 5, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.StateVar = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.StateVar, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.StateVar.displayName = 'proto.types.StateVar';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.StateVar.prototype.toObject = function (opt_includeInstance) {
        return proto.types.StateVar.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.StateVar} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.StateVar.toObject = function (includeInstance, msg) {
        var obj = {
          name: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          type: googleProtobuf.Message.getFieldWithDefault(msg, 2, ""),
          len: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.StateVar}
     */


    proto.types.StateVar.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.StateVar();
      return proto.types.StateVar.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.StateVar} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.StateVar}
     */


    proto.types.StateVar.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setName(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setType(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readInt32();
            msg.setLen(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.StateVar.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.StateVar.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.StateVar} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.StateVar.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getName();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getType();

      if (f.length > 0) {
        writer.writeString(2, f);
      }

      f = message.getLen();

      if (f !== 0) {
        writer.writeInt32(3, f);
      }
    };
    /**
     * optional string name = 1;
     * @return {string}
     */


    proto.types.StateVar.prototype.getName = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.StateVar.prototype.setName = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional string type = 2;
     * @return {string}
     */


    proto.types.StateVar.prototype.getType = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.StateVar.prototype.setType = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * optional int32 len = 3;
     * @return {number}
     */


    proto.types.StateVar.prototype.getLen = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.StateVar.prototype.setLen = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ABI = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.ABI.repeatedFields_, null);
    };

    goog.inherits(proto.types.ABI, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ABI.displayName = 'proto.types.ABI';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.ABI.repeatedFields_ = [3, 4];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ABI.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ABI.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ABI} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ABI.toObject = function (includeInstance, msg) {
        var obj = {
          version: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          language: googleProtobuf.Message.getFieldWithDefault(msg, 2, ""),
          functionsList: googleProtobuf.Message.toObjectList(msg.getFunctionsList(), proto.types.Function.toObject, includeInstance),
          stateVariablesList: googleProtobuf.Message.toObjectList(msg.getStateVariablesList(), proto.types.StateVar.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ABI}
     */


    proto.types.ABI.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ABI();
      return proto.types.ABI.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ABI} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ABI}
     */


    proto.types.ABI.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setVersion(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setLanguage(value);
            break;

          case 3:
            var value = new proto.types.Function();
            reader.readMessage(value, proto.types.Function.deserializeBinaryFromReader);
            msg.addFunctions(value);
            break;

          case 4:
            var value = new proto.types.StateVar();
            reader.readMessage(value, proto.types.StateVar.deserializeBinaryFromReader);
            msg.addStateVariables(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ABI.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ABI.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ABI} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ABI.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getVersion();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getLanguage();

      if (f.length > 0) {
        writer.writeString(2, f);
      }

      f = message.getFunctionsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(3, f, proto.types.Function.serializeBinaryToWriter);
      }

      f = message.getStateVariablesList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(4, f, proto.types.StateVar.serializeBinaryToWriter);
      }
    };
    /**
     * optional string version = 1;
     * @return {string}
     */


    proto.types.ABI.prototype.getVersion = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.ABI.prototype.setVersion = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional string language = 2;
     * @return {string}
     */


    proto.types.ABI.prototype.getLanguage = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.ABI.prototype.setLanguage = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * repeated Function functions = 3;
     * @return {!Array<!proto.types.Function>}
     */


    proto.types.ABI.prototype.getFunctionsList = function () {
      return (
        /** @type{!Array<!proto.types.Function>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.Function, 3)
      );
    };
    /** @param {!Array<!proto.types.Function>} value */


    proto.types.ABI.prototype.setFunctionsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 3, value);
    };
    /**
     * @param {!proto.types.Function=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Function}
     */


    proto.types.ABI.prototype.addFunctions = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.types.Function, opt_index);
    };

    proto.types.ABI.prototype.clearFunctionsList = function () {
      this.setFunctionsList([]);
    };
    /**
     * repeated StateVar state_variables = 4;
     * @return {!Array<!proto.types.StateVar>}
     */


    proto.types.ABI.prototype.getStateVariablesList = function () {
      return (
        /** @type{!Array<!proto.types.StateVar>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.StateVar, 4)
      );
    };
    /** @param {!Array<!proto.types.StateVar>} value */


    proto.types.ABI.prototype.setStateVariablesList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 4, value);
    };
    /**
     * @param {!proto.types.StateVar=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.StateVar}
     */


    proto.types.ABI.prototype.addStateVariables = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.types.StateVar, opt_index);
    };

    proto.types.ABI.prototype.clearStateVariablesList = function () {
      this.setStateVariablesList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Query = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Query, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Query.displayName = 'proto.types.Query';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Query.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Query.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Query} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Query.toObject = function (includeInstance, msg) {
        var obj = {
          contractaddress: msg.getContractaddress_asB64(),
          queryinfo: msg.getQueryinfo_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Query}
     */


    proto.types.Query.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Query();
      return proto.types.Query.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Query} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Query}
     */


    proto.types.Query.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setContractaddress(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setQueryinfo(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Query.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Query.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Query} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Query.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getContractaddress_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getQueryinfo_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }
    };
    /**
     * optional bytes contractAddress = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Query.prototype.getContractaddress = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {string}
     */


    proto.types.Query.prototype.getContractaddress_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getContractaddress())
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {!Uint8Array}
     */


    proto.types.Query.prototype.getContractaddress_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getContractaddress())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Query.prototype.setContractaddress = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional bytes queryinfo = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Query.prototype.getQueryinfo = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes queryinfo = 2;
     * This is a type-conversion wrapper around `getQueryinfo()`
     * @return {string}
     */


    proto.types.Query.prototype.getQueryinfo_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getQueryinfo())
      );
    };
    /**
     * optional bytes queryinfo = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getQueryinfo()`
     * @return {!Uint8Array}
     */


    proto.types.Query.prototype.getQueryinfo_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getQueryinfo())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Query.prototype.setQueryinfo = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.StateQuery = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.StateQuery.repeatedFields_, null);
    };

    goog.inherits(proto.types.StateQuery, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.StateQuery.displayName = 'proto.types.StateQuery';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.StateQuery.repeatedFields_ = [5];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.StateQuery.prototype.toObject = function (opt_includeInstance) {
        return proto.types.StateQuery.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.StateQuery} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.StateQuery.toObject = function (includeInstance, msg) {
        var obj = {
          contractaddress: msg.getContractaddress_asB64(),
          root: msg.getRoot_asB64(),
          compressed: googleProtobuf.Message.getFieldWithDefault(msg, 4, false),
          storagekeysList: msg.getStoragekeysList_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.StateQuery}
     */


    proto.types.StateQuery.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.StateQuery();
      return proto.types.StateQuery.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.StateQuery} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.StateQuery}
     */


    proto.types.StateQuery.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setContractaddress(value);
            break;

          case 3:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setRoot(value);
            break;

          case 4:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setCompressed(value);
            break;

          case 5:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addStoragekeys(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.StateQuery.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.StateQuery.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.StateQuery} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.StateQuery.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getContractaddress_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getRoot_asU8();

      if (f.length > 0) {
        writer.writeBytes(3, f);
      }

      f = message.getCompressed();

      if (f) {
        writer.writeBool(4, f);
      }

      f = message.getStoragekeysList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(5, f);
      }
    };
    /**
     * optional bytes contractAddress = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.StateQuery.prototype.getContractaddress = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {string}
     */


    proto.types.StateQuery.prototype.getContractaddress_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getContractaddress())
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {!Uint8Array}
     */


    proto.types.StateQuery.prototype.getContractaddress_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getContractaddress())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.StateQuery.prototype.setContractaddress = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional bytes root = 3;
     * @return {!(string|Uint8Array)}
     */


    proto.types.StateQuery.prototype.getRoot = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /**
     * optional bytes root = 3;
     * This is a type-conversion wrapper around `getRoot()`
     * @return {string}
     */


    proto.types.StateQuery.prototype.getRoot_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getRoot())
      );
    };
    /**
     * optional bytes root = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getRoot()`
     * @return {!Uint8Array}
     */


    proto.types.StateQuery.prototype.getRoot_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getRoot())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.StateQuery.prototype.setRoot = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 3, value);
    };
    /**
     * optional bool compressed = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.StateQuery.prototype.getCompressed = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, false)
      );
    };
    /** @param {boolean} value */


    proto.types.StateQuery.prototype.setCompressed = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 4, value);
    };
    /**
     * repeated bytes storageKeys = 5;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.StateQuery.prototype.getStoragekeysList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 5)
      );
    };
    /**
     * repeated bytes storageKeys = 5;
     * This is a type-conversion wrapper around `getStoragekeysList()`
     * @return {!Array<string>}
     */


    proto.types.StateQuery.prototype.getStoragekeysList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getStoragekeysList())
      );
    };
    /**
     * repeated bytes storageKeys = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getStoragekeysList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.StateQuery.prototype.getStoragekeysList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getStoragekeysList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.StateQuery.prototype.setStoragekeysList = function (value) {
      googleProtobuf.Message.setField(this, 5, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.StateQuery.prototype.addStoragekeys = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 5, value, opt_index);
    };

    proto.types.StateQuery.prototype.clearStoragekeysList = function () {
      this.setStoragekeysList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.FilterInfo = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.FilterInfo, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.FilterInfo.displayName = 'proto.types.FilterInfo';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.FilterInfo.prototype.toObject = function (opt_includeInstance) {
        return proto.types.FilterInfo.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.FilterInfo} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.FilterInfo.toObject = function (includeInstance, msg) {
        var obj = {
          contractaddress: msg.getContractaddress_asB64(),
          eventname: googleProtobuf.Message.getFieldWithDefault(msg, 2, ""),
          blockfrom: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          blockto: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0),
          desc: googleProtobuf.Message.getFieldWithDefault(msg, 5, false),
          argfilter: msg.getArgfilter_asB64(),
          recentblockcnt: googleProtobuf.Message.getFieldWithDefault(msg, 7, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.FilterInfo}
     */


    proto.types.FilterInfo.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.FilterInfo();
      return proto.types.FilterInfo.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.FilterInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.FilterInfo}
     */


    proto.types.FilterInfo.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setContractaddress(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setEventname(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBlockfrom(value);
            break;

          case 4:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBlockto(value);
            break;

          case 5:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setDesc(value);
            break;

          case 6:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setArgfilter(value);
            break;

          case 7:
            var value =
            /** @type {number} */
            reader.readInt32();
            msg.setRecentblockcnt(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.FilterInfo.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.FilterInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.FilterInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.FilterInfo.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getContractaddress_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getEventname();

      if (f.length > 0) {
        writer.writeString(2, f);
      }

      f = message.getBlockfrom();

      if (f !== 0) {
        writer.writeUint64(3, f);
      }

      f = message.getBlockto();

      if (f !== 0) {
        writer.writeUint64(4, f);
      }

      f = message.getDesc();

      if (f) {
        writer.writeBool(5, f);
      }

      f = message.getArgfilter_asU8();

      if (f.length > 0) {
        writer.writeBytes(6, f);
      }

      f = message.getRecentblockcnt();

      if (f !== 0) {
        writer.writeInt32(7, f);
      }
    };
    /**
     * optional bytes contractAddress = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.FilterInfo.prototype.getContractaddress = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {string}
     */


    proto.types.FilterInfo.prototype.getContractaddress_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getContractaddress())
      );
    };
    /**
     * optional bytes contractAddress = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getContractaddress()`
     * @return {!Uint8Array}
     */


    proto.types.FilterInfo.prototype.getContractaddress_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getContractaddress())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.FilterInfo.prototype.setContractaddress = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional string eventName = 2;
     * @return {string}
     */


    proto.types.FilterInfo.prototype.getEventname = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.FilterInfo.prototype.setEventname = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * optional uint64 blockfrom = 3;
     * @return {number}
     */


    proto.types.FilterInfo.prototype.getBlockfrom = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.FilterInfo.prototype.setBlockfrom = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional uint64 blockto = 4;
     * @return {number}
     */


    proto.types.FilterInfo.prototype.getBlockto = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    /** @param {number} value */


    proto.types.FilterInfo.prototype.setBlockto = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 4, value);
    };
    /**
     * optional bool desc = 5;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.FilterInfo.prototype.getDesc = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, false)
      );
    };
    /** @param {boolean} value */


    proto.types.FilterInfo.prototype.setDesc = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 5, value);
    };
    /**
     * optional bytes argFilter = 6;
     * @return {!(string|Uint8Array)}
     */


    proto.types.FilterInfo.prototype.getArgfilter = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /**
     * optional bytes argFilter = 6;
     * This is a type-conversion wrapper around `getArgfilter()`
     * @return {string}
     */


    proto.types.FilterInfo.prototype.getArgfilter_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getArgfilter())
      );
    };
    /**
     * optional bytes argFilter = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getArgfilter()`
     * @return {!Uint8Array}
     */


    proto.types.FilterInfo.prototype.getArgfilter_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getArgfilter())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.FilterInfo.prototype.setArgfilter = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 6, value);
    };
    /**
     * optional int32 recentBlockCnt = 7;
     * @return {number}
     */


    proto.types.FilterInfo.prototype.getRecentblockcnt = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    /** @param {number} value */


    proto.types.FilterInfo.prototype.setRecentblockcnt = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 7, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Proposal = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Proposal, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Proposal.displayName = 'proto.types.Proposal';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Proposal.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Proposal.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Proposal} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Proposal.toObject = function (includeInstance, msg) {
        var obj = {
          id: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          description: googleProtobuf.Message.getFieldWithDefault(msg, 3, ""),
          multiplechoice: googleProtobuf.Message.getFieldWithDefault(msg, 6, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Proposal}
     */


    proto.types.Proposal.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Proposal();
      return proto.types.Proposal.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Proposal} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Proposal}
     */


    proto.types.Proposal.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setId(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setDescription(value);
            break;

          case 6:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setMultiplechoice(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Proposal.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Proposal.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Proposal} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Proposal.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getId();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getDescription();

      if (f.length > 0) {
        writer.writeString(3, f);
      }

      f = message.getMultiplechoice();

      if (f !== 0) {
        writer.writeUint32(6, f);
      }
    };
    /**
     * optional string id = 1;
     * @return {string}
     */


    proto.types.Proposal.prototype.getId = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.Proposal.prototype.setId = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional string description = 3;
     * @return {string}
     */


    proto.types.Proposal.prototype.getDescription = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.Proposal.prototype.setDescription = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * optional uint32 multipleChoice = 6;
     * @return {number}
     */


    proto.types.Proposal.prototype.getMultiplechoice = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, 0)
      );
    };
    /** @param {number} value */


    proto.types.Proposal.prototype.setMultiplechoice = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 6, value);
    };
    /**
     * @enum {number}
     */


    proto.types.TxType = {
      NORMAL: 0,
      GOVERNANCE: 1,
      REDEPLOY: 2,
      FEEDELEGATION: 3,
      TRANSFER: 4,
      CALL: 5,
      DEPLOY: 6,
      MULTICALL: 7
    };
    goog.object.extend(exports, proto.types);
  });
  var blockchain_pb_1 = blockchain_pb.TxList;
  var blockchain_pb_2 = blockchain_pb.TxBody;
  var blockchain_pb_3 = blockchain_pb.Tx;
  var blockchain_pb_4 = blockchain_pb.TxType;
  var blockchain_pb_5 = blockchain_pb.Block;
  var blockchain_pb_6 = blockchain_pb.Query;
  var blockchain_pb_7 = blockchain_pb.StateQuery;
  var blockchain_pb_8 = blockchain_pb.FilterInfo;

  var account_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!
    var goog = googleProtobuf;
    var global = Function('return this')();
    goog.exportSymbol('proto.types.Account', null, global);
    goog.exportSymbol('proto.types.AccountList', null, global);
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */

    proto.types.Account = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Account, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Account.displayName = 'proto.types.Account';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Account.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Account.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Account} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Account.toObject = function (includeInstance, msg) {
        var obj = {
          address: msg.getAddress_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Account}
     */


    proto.types.Account.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Account();
      return proto.types.Account.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Account} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Account}
     */


    proto.types.Account.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setAddress(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Account.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Account.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Account} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Account.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getAddress_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }
    };
    /**
     * optional bytes address = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Account.prototype.getAddress = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes address = 1;
     * This is a type-conversion wrapper around `getAddress()`
     * @return {string}
     */


    proto.types.Account.prototype.getAddress_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getAddress())
      );
    };
    /**
     * optional bytes address = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAddress()`
     * @return {!Uint8Array}
     */


    proto.types.Account.prototype.getAddress_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getAddress())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Account.prototype.setAddress = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.AccountList = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.AccountList.repeatedFields_, null);
    };

    goog.inherits(proto.types.AccountList, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.AccountList.displayName = 'proto.types.AccountList';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.AccountList.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.AccountList.prototype.toObject = function (opt_includeInstance) {
        return proto.types.AccountList.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.AccountList} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.AccountList.toObject = function (includeInstance, msg) {
        var obj = {
          accountsList: googleProtobuf.Message.toObjectList(msg.getAccountsList(), proto.types.Account.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.AccountList}
     */


    proto.types.AccountList.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.AccountList();
      return proto.types.AccountList.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.AccountList} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.AccountList}
     */


    proto.types.AccountList.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.Account();
            reader.readMessage(value, proto.types.Account.deserializeBinaryFromReader);
            msg.addAccounts(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.AccountList.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.AccountList.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.AccountList} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.AccountList.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getAccountsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, proto.types.Account.serializeBinaryToWriter);
      }
    };
    /**
     * repeated Account accounts = 1;
     * @return {!Array<!proto.types.Account>}
     */


    proto.types.AccountList.prototype.getAccountsList = function () {
      return (
        /** @type{!Array<!proto.types.Account>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.Account, 1)
      );
    };
    /** @param {!Array<!proto.types.Account>} value */


    proto.types.AccountList.prototype.setAccountsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.Account=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Account}
     */


    proto.types.AccountList.prototype.addAccounts = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.Account, opt_index);
    };

    proto.types.AccountList.prototype.clearAccountsList = function () {
      this.setAccountsList([]);
    };

    goog.object.extend(exports, proto.types);
  });
  var account_pb_1 = account_pb.Account;

  var node_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!
    var goog = googleProtobuf;
    var global = Function('return this')();
    goog.exportSymbol('proto.types.AgentCertificate', null, global);
    goog.exportSymbol('proto.types.PeerAddress', null, global);
    goog.exportSymbol('proto.types.PeerRole', null, global);
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */

    proto.types.PeerAddress = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.PeerAddress.repeatedFields_, null);
    };

    goog.inherits(proto.types.PeerAddress, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.PeerAddress.displayName = 'proto.types.PeerAddress';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.PeerAddress.repeatedFields_ = [6, 7];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.PeerAddress.prototype.toObject = function (opt_includeInstance) {
        return proto.types.PeerAddress.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.PeerAddress} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.PeerAddress.toObject = function (includeInstance, msg) {
        var obj = {
          address: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          port: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          peerid: msg.getPeerid_asB64(),
          role: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0),
          version: googleProtobuf.Message.getFieldWithDefault(msg, 5, ""),
          addressesList: googleProtobuf.Message.getRepeatedField(msg, 6),
          produceridsList: msg.getProduceridsList_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.PeerAddress}
     */


    proto.types.PeerAddress.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.PeerAddress();
      return proto.types.PeerAddress.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.PeerAddress} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.PeerAddress}
     */


    proto.types.PeerAddress.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setAddress(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setPort(value);
            break;

          case 3:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setPeerid(value);
            break;

          case 4:
            var value =
            /** @type {!proto.types.PeerRole} */
            reader.readEnum();
            msg.setRole(value);
            break;

          case 5:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setVersion(value);
            break;

          case 6:
            var value =
            /** @type {string} */
            reader.readString();
            msg.addAddresses(value);
            break;

          case 7:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addProducerids(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.PeerAddress.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.PeerAddress.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.PeerAddress} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.PeerAddress.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getAddress();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getPort();

      if (f !== 0) {
        writer.writeUint32(2, f);
      }

      f = message.getPeerid_asU8();

      if (f.length > 0) {
        writer.writeBytes(3, f);
      }

      f = message.getRole();

      if (f !== 0.0) {
        writer.writeEnum(4, f);
      }

      f = message.getVersion();

      if (f.length > 0) {
        writer.writeString(5, f);
      }

      f = message.getAddressesList();

      if (f.length > 0) {
        writer.writeRepeatedString(6, f);
      }

      f = message.getProduceridsList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(7, f);
      }
    };
    /**
     * optional string address = 1;
     * @return {string}
     */


    proto.types.PeerAddress.prototype.getAddress = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.PeerAddress.prototype.setAddress = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional uint32 port = 2;
     * @return {number}
     */


    proto.types.PeerAddress.prototype.getPort = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.PeerAddress.prototype.setPort = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional bytes peerID = 3;
     * @return {!(string|Uint8Array)}
     */


    proto.types.PeerAddress.prototype.getPeerid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /**
     * optional bytes peerID = 3;
     * This is a type-conversion wrapper around `getPeerid()`
     * @return {string}
     */


    proto.types.PeerAddress.prototype.getPeerid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getPeerid())
      );
    };
    /**
     * optional bytes peerID = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPeerid()`
     * @return {!Uint8Array}
     */


    proto.types.PeerAddress.prototype.getPeerid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getPeerid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.PeerAddress.prototype.setPeerid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 3, value);
    };
    /**
     * optional PeerRole role = 4;
     * @return {!proto.types.PeerRole}
     */


    proto.types.PeerAddress.prototype.getRole = function () {
      return (
        /** @type {!proto.types.PeerRole} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    /** @param {!proto.types.PeerRole} value */


    proto.types.PeerAddress.prototype.setRole = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 4, value);
    };
    /**
     * optional string version = 5;
     * @return {string}
     */


    proto.types.PeerAddress.prototype.getVersion = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, "")
      );
    };
    /** @param {string} value */


    proto.types.PeerAddress.prototype.setVersion = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 5, value);
    };
    /**
     * repeated string addresses = 6;
     * @return {!Array<string>}
     */


    proto.types.PeerAddress.prototype.getAddressesList = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.getRepeatedField(this, 6)
      );
    };
    /** @param {!Array<string>} value */


    proto.types.PeerAddress.prototype.setAddressesList = function (value) {
      googleProtobuf.Message.setField(this, 6, value || []);
    };
    /**
     * @param {string} value
     * @param {number=} opt_index
     */


    proto.types.PeerAddress.prototype.addAddresses = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 6, value, opt_index);
    };

    proto.types.PeerAddress.prototype.clearAddressesList = function () {
      this.setAddressesList([]);
    };
    /**
     * repeated bytes producerIDs = 7;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.PeerAddress.prototype.getProduceridsList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 7)
      );
    };
    /**
     * repeated bytes producerIDs = 7;
     * This is a type-conversion wrapper around `getProduceridsList()`
     * @return {!Array<string>}
     */


    proto.types.PeerAddress.prototype.getProduceridsList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getProduceridsList())
      );
    };
    /**
     * repeated bytes producerIDs = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getProduceridsList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.PeerAddress.prototype.getProduceridsList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getProduceridsList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.PeerAddress.prototype.setProduceridsList = function (value) {
      googleProtobuf.Message.setField(this, 7, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.PeerAddress.prototype.addProducerids = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 7, value, opt_index);
    };

    proto.types.PeerAddress.prototype.clearProduceridsList = function () {
      this.setProduceridsList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.AgentCertificate = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.AgentCertificate.repeatedFields_, null);
    };

    goog.inherits(proto.types.AgentCertificate, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.AgentCertificate.displayName = 'proto.types.AgentCertificate';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.AgentCertificate.repeatedFields_ = [7];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.AgentCertificate.prototype.toObject = function (opt_includeInstance) {
        return proto.types.AgentCertificate.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.AgentCertificate} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.AgentCertificate.toObject = function (includeInstance, msg) {
        var obj = {
          certversion: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          bpid: msg.getBpid_asB64(),
          bppubkey: msg.getBppubkey_asB64(),
          createtime: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0),
          expiretime: googleProtobuf.Message.getFieldWithDefault(msg, 5, 0),
          agentid: msg.getAgentid_asB64(),
          agentaddressList: msg.getAgentaddressList_asB64(),
          signature: msg.getSignature_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.AgentCertificate}
     */


    proto.types.AgentCertificate.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.AgentCertificate();
      return proto.types.AgentCertificate.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.AgentCertificate} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.AgentCertificate}
     */


    proto.types.AgentCertificate.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setCertversion(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBpid(value);
            break;

          case 3:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBppubkey(value);
            break;

          case 4:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setCreatetime(value);
            break;

          case 5:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setExpiretime(value);
            break;

          case 6:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setAgentid(value);
            break;

          case 7:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addAgentaddress(value);
            break;

          case 8:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setSignature(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.AgentCertificate.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.AgentCertificate.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.AgentCertificate} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.AgentCertificate.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getCertversion();

      if (f !== 0) {
        writer.writeUint32(1, f);
      }

      f = message.getBpid_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }

      f = message.getBppubkey_asU8();

      if (f.length > 0) {
        writer.writeBytes(3, f);
      }

      f = message.getCreatetime();

      if (f !== 0) {
        writer.writeInt64(4, f);
      }

      f = message.getExpiretime();

      if (f !== 0) {
        writer.writeInt64(5, f);
      }

      f = message.getAgentid_asU8();

      if (f.length > 0) {
        writer.writeBytes(6, f);
      }

      f = message.getAgentaddressList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(7, f);
      }

      f = message.getSignature_asU8();

      if (f.length > 0) {
        writer.writeBytes(8, f);
      }
    };
    /**
     * optional uint32 certVersion = 1;
     * @return {number}
     */


    proto.types.AgentCertificate.prototype.getCertversion = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {number} value */


    proto.types.AgentCertificate.prototype.setCertversion = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 1, value);
    };
    /**
     * optional bytes BPID = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AgentCertificate.prototype.getBpid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes BPID = 2;
     * This is a type-conversion wrapper around `getBpid()`
     * @return {string}
     */


    proto.types.AgentCertificate.prototype.getBpid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBpid())
      );
    };
    /**
     * optional bytes BPID = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBpid()`
     * @return {!Uint8Array}
     */


    proto.types.AgentCertificate.prototype.getBpid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBpid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AgentCertificate.prototype.setBpid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * optional bytes BPPubKey = 3;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AgentCertificate.prototype.getBppubkey = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /**
     * optional bytes BPPubKey = 3;
     * This is a type-conversion wrapper around `getBppubkey()`
     * @return {string}
     */


    proto.types.AgentCertificate.prototype.getBppubkey_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBppubkey())
      );
    };
    /**
     * optional bytes BPPubKey = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBppubkey()`
     * @return {!Uint8Array}
     */


    proto.types.AgentCertificate.prototype.getBppubkey_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBppubkey())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AgentCertificate.prototype.setBppubkey = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 3, value);
    };
    /**
     * optional int64 createTime = 4;
     * @return {number}
     */


    proto.types.AgentCertificate.prototype.getCreatetime = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    /** @param {number} value */


    proto.types.AgentCertificate.prototype.setCreatetime = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 4, value);
    };
    /**
     * optional int64 expireTime = 5;
     * @return {number}
     */


    proto.types.AgentCertificate.prototype.getExpiretime = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    /** @param {number} value */


    proto.types.AgentCertificate.prototype.setExpiretime = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 5, value);
    };
    /**
     * optional bytes agentID = 6;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AgentCertificate.prototype.getAgentid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /**
     * optional bytes agentID = 6;
     * This is a type-conversion wrapper around `getAgentid()`
     * @return {string}
     */


    proto.types.AgentCertificate.prototype.getAgentid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getAgentid())
      );
    };
    /**
     * optional bytes agentID = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAgentid()`
     * @return {!Uint8Array}
     */


    proto.types.AgentCertificate.prototype.getAgentid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getAgentid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AgentCertificate.prototype.setAgentid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 6, value);
    };
    /**
     * repeated bytes AgentAddress = 7;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.AgentCertificate.prototype.getAgentaddressList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 7)
      );
    };
    /**
     * repeated bytes AgentAddress = 7;
     * This is a type-conversion wrapper around `getAgentaddressList()`
     * @return {!Array<string>}
     */


    proto.types.AgentCertificate.prototype.getAgentaddressList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getAgentaddressList())
      );
    };
    /**
     * repeated bytes AgentAddress = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAgentaddressList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.AgentCertificate.prototype.getAgentaddressList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getAgentaddressList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.AgentCertificate.prototype.setAgentaddressList = function (value) {
      googleProtobuf.Message.setField(this, 7, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.AgentCertificate.prototype.addAgentaddress = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 7, value, opt_index);
    };

    proto.types.AgentCertificate.prototype.clearAgentaddressList = function () {
      this.setAgentaddressList([]);
    };
    /**
     * optional bytes signature = 8;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AgentCertificate.prototype.getSignature = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 8, "")
      );
    };
    /**
     * optional bytes signature = 8;
     * This is a type-conversion wrapper around `getSignature()`
     * @return {string}
     */


    proto.types.AgentCertificate.prototype.getSignature_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getSignature())
      );
    };
    /**
     * optional bytes signature = 8;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignature()`
     * @return {!Uint8Array}
     */


    proto.types.AgentCertificate.prototype.getSignature_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getSignature())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AgentCertificate.prototype.setSignature = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 8, value);
    };
    /**
     * @enum {number}
     */


    proto.types.PeerRole = {
      LEGACYVERSION: 0,
      PRODUCER: 1,
      WATCHER: 2,
      AGENT: 3
    };
    goog.object.extend(exports, proto.types);
  });
  var node_pb_1 = node_pb.PeerRole;

  var p2p_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!
    var goog = googleProtobuf;
    var global = Function('return this')();
    goog.object.extend(proto, blockchain_pb);
    goog.object.extend(proto, node_pb);
    goog.exportSymbol('proto.types.AddressesRequest', null, global);
    goog.exportSymbol('proto.types.AddressesResponse', null, global);
    goog.exportSymbol('proto.types.BlockProducedNotice', null, global);
    goog.exportSymbol('proto.types.CertificateRenewedNotice', null, global);
    goog.exportSymbol('proto.types.GetAncestorRequest', null, global);
    goog.exportSymbol('proto.types.GetAncestorResponse', null, global);
    goog.exportSymbol('proto.types.GetBlockHeadersRequest', null, global);
    goog.exportSymbol('proto.types.GetBlockHeadersResponse', null, global);
    goog.exportSymbol('proto.types.GetBlockRequest', null, global);
    goog.exportSymbol('proto.types.GetBlockResponse', null, global);
    goog.exportSymbol('proto.types.GetHashByNo', null, global);
    goog.exportSymbol('proto.types.GetHashByNoResponse', null, global);
    goog.exportSymbol('proto.types.GetHashesRequest', null, global);
    goog.exportSymbol('proto.types.GetHashesResponse', null, global);
    goog.exportSymbol('proto.types.GetMissingRequest', null, global);
    goog.exportSymbol('proto.types.GetTransactionsRequest', null, global);
    goog.exportSymbol('proto.types.GetTransactionsResponse', null, global);
    goog.exportSymbol('proto.types.GoAwayNotice', null, global);
    goog.exportSymbol('proto.types.IssueCertificateRequest', null, global);
    goog.exportSymbol('proto.types.IssueCertificateResponse', null, global);
    goog.exportSymbol('proto.types.MsgHeader', null, global);
    goog.exportSymbol('proto.types.NewBlockNotice', null, global);
    goog.exportSymbol('proto.types.NewTransactionsNotice', null, global);
    goog.exportSymbol('proto.types.P2PMessage', null, global);
    goog.exportSymbol('proto.types.Ping', null, global);
    goog.exportSymbol('proto.types.Pong', null, global);
    goog.exportSymbol('proto.types.ResultStatus', null, global);
    goog.exportSymbol('proto.types.Status', null, global);
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */

    proto.types.MsgHeader = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.MsgHeader, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.MsgHeader.displayName = 'proto.types.MsgHeader';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.MsgHeader.prototype.toObject = function (opt_includeInstance) {
        return proto.types.MsgHeader.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.MsgHeader} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.MsgHeader.toObject = function (includeInstance, msg) {
        var obj = {
          clientversion: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          timestamp: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          id: googleProtobuf.Message.getFieldWithDefault(msg, 3, ""),
          gossip: googleProtobuf.Message.getFieldWithDefault(msg, 4, false),
          peerid: msg.getPeerid_asB64(),
          nodepubkey: msg.getNodepubkey_asB64(),
          sign: msg.getSign_asB64(),
          subprotocol: googleProtobuf.Message.getFieldWithDefault(msg, 8, 0),
          length: googleProtobuf.Message.getFieldWithDefault(msg, 9, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.MsgHeader}
     */


    proto.types.MsgHeader.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.MsgHeader();
      return proto.types.MsgHeader.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.MsgHeader} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.MsgHeader}
     */


    proto.types.MsgHeader.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setClientversion(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setTimestamp(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setId(value);
            break;

          case 4:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setGossip(value);
            break;

          case 5:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setPeerid(value);
            break;

          case 6:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setNodepubkey(value);
            break;

          case 7:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setSign(value);
            break;

          case 8:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setSubprotocol(value);
            break;

          case 9:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setLength(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.MsgHeader.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.MsgHeader.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.MsgHeader} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.MsgHeader.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getClientversion();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getTimestamp();

      if (f !== 0) {
        writer.writeInt64(2, f);
      }

      f = message.getId();

      if (f.length > 0) {
        writer.writeString(3, f);
      }

      f = message.getGossip();

      if (f) {
        writer.writeBool(4, f);
      }

      f = message.getPeerid_asU8();

      if (f.length > 0) {
        writer.writeBytes(5, f);
      }

      f = message.getNodepubkey_asU8();

      if (f.length > 0) {
        writer.writeBytes(6, f);
      }

      f = message.getSign_asU8();

      if (f.length > 0) {
        writer.writeBytes(7, f);
      }

      f = message.getSubprotocol();

      if (f !== 0) {
        writer.writeUint32(8, f);
      }

      f = message.getLength();

      if (f !== 0) {
        writer.writeUint32(9, f);
      }
    };
    /**
     * optional string clientVersion = 1;
     * @return {string}
     */


    proto.types.MsgHeader.prototype.getClientversion = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.MsgHeader.prototype.setClientversion = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional int64 timestamp = 2;
     * @return {number}
     */


    proto.types.MsgHeader.prototype.getTimestamp = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.MsgHeader.prototype.setTimestamp = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional string id = 3;
     * @return {string}
     */


    proto.types.MsgHeader.prototype.getId = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.MsgHeader.prototype.setId = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * optional bool gossip = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.MsgHeader.prototype.getGossip = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, false)
      );
    };
    /** @param {boolean} value */


    proto.types.MsgHeader.prototype.setGossip = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 4, value);
    };
    /**
     * optional bytes peerID = 5;
     * @return {!(string|Uint8Array)}
     */


    proto.types.MsgHeader.prototype.getPeerid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, "")
      );
    };
    /**
     * optional bytes peerID = 5;
     * This is a type-conversion wrapper around `getPeerid()`
     * @return {string}
     */


    proto.types.MsgHeader.prototype.getPeerid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getPeerid())
      );
    };
    /**
     * optional bytes peerID = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPeerid()`
     * @return {!Uint8Array}
     */


    proto.types.MsgHeader.prototype.getPeerid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getPeerid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.MsgHeader.prototype.setPeerid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 5, value);
    };
    /**
     * optional bytes nodePubKey = 6;
     * @return {!(string|Uint8Array)}
     */


    proto.types.MsgHeader.prototype.getNodepubkey = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /**
     * optional bytes nodePubKey = 6;
     * This is a type-conversion wrapper around `getNodepubkey()`
     * @return {string}
     */


    proto.types.MsgHeader.prototype.getNodepubkey_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getNodepubkey())
      );
    };
    /**
     * optional bytes nodePubKey = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getNodepubkey()`
     * @return {!Uint8Array}
     */


    proto.types.MsgHeader.prototype.getNodepubkey_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getNodepubkey())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.MsgHeader.prototype.setNodepubkey = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 6, value);
    };
    /**
     * optional bytes sign = 7;
     * @return {!(string|Uint8Array)}
     */


    proto.types.MsgHeader.prototype.getSign = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, "")
      );
    };
    /**
     * optional bytes sign = 7;
     * This is a type-conversion wrapper around `getSign()`
     * @return {string}
     */


    proto.types.MsgHeader.prototype.getSign_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getSign())
      );
    };
    /**
     * optional bytes sign = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSign()`
     * @return {!Uint8Array}
     */


    proto.types.MsgHeader.prototype.getSign_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getSign())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.MsgHeader.prototype.setSign = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 7, value);
    };
    /**
     * optional uint32 subprotocol = 8;
     * @return {number}
     */


    proto.types.MsgHeader.prototype.getSubprotocol = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 8, 0)
      );
    };
    /** @param {number} value */


    proto.types.MsgHeader.prototype.setSubprotocol = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 8, value);
    };
    /**
     * optional uint32 length = 9;
     * @return {number}
     */


    proto.types.MsgHeader.prototype.getLength = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 9, 0)
      );
    };
    /** @param {number} value */


    proto.types.MsgHeader.prototype.setLength = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 9, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.P2PMessage = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.P2PMessage, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.P2PMessage.displayName = 'proto.types.P2PMessage';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.P2PMessage.prototype.toObject = function (opt_includeInstance) {
        return proto.types.P2PMessage.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.P2PMessage} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.P2PMessage.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          header: (f = msg.getHeader()) && proto.types.MsgHeader.toObject(includeInstance, f),
          data: msg.getData_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.P2PMessage}
     */


    proto.types.P2PMessage.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.P2PMessage();
      return proto.types.P2PMessage.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.P2PMessage} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.P2PMessage}
     */


    proto.types.P2PMessage.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.MsgHeader();
            reader.readMessage(value, proto.types.MsgHeader.deserializeBinaryFromReader);
            msg.setHeader(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setData(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.P2PMessage.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.P2PMessage.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.P2PMessage} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.P2PMessage.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHeader();

      if (f != null) {
        writer.writeMessage(1, f, proto.types.MsgHeader.serializeBinaryToWriter);
      }

      f = message.getData_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }
    };
    /**
     * optional MsgHeader header = 1;
     * @return {?proto.types.MsgHeader}
     */


    proto.types.P2PMessage.prototype.getHeader = function () {
      return (
        /** @type{?proto.types.MsgHeader} */
        googleProtobuf.Message.getWrapperField(this, proto.types.MsgHeader, 1)
      );
    };
    /** @param {?proto.types.MsgHeader|undefined} value */


    proto.types.P2PMessage.prototype.setHeader = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.P2PMessage.prototype.clearHeader = function () {
      this.setHeader(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.P2PMessage.prototype.hasHeader = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional bytes data = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.P2PMessage.prototype.getData = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes data = 2;
     * This is a type-conversion wrapper around `getData()`
     * @return {string}
     */


    proto.types.P2PMessage.prototype.getData_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getData())
      );
    };
    /**
     * optional bytes data = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getData()`
     * @return {!Uint8Array}
     */


    proto.types.P2PMessage.prototype.getData_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getData())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.P2PMessage.prototype.setData = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Ping = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Ping, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Ping.displayName = 'proto.types.Ping';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Ping.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Ping.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Ping} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Ping.toObject = function (includeInstance, msg) {
        var obj = {
          bestBlockHash: msg.getBestBlockHash_asB64(),
          bestHeight: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Ping}
     */


    proto.types.Ping.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Ping();
      return proto.types.Ping.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Ping} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Ping}
     */


    proto.types.Ping.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBestBlockHash(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBestHeight(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Ping.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Ping.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Ping} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Ping.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getBestBlockHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getBestHeight();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }
    };
    /**
     * optional bytes best_block_hash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Ping.prototype.getBestBlockHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes best_block_hash = 1;
     * This is a type-conversion wrapper around `getBestBlockHash()`
     * @return {string}
     */


    proto.types.Ping.prototype.getBestBlockHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBestBlockHash())
      );
    };
    /**
     * optional bytes best_block_hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBestBlockHash()`
     * @return {!Uint8Array}
     */


    proto.types.Ping.prototype.getBestBlockHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBestBlockHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Ping.prototype.setBestBlockHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 best_height = 2;
     * @return {number}
     */


    proto.types.Ping.prototype.getBestHeight = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.Ping.prototype.setBestHeight = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Pong = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Pong, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Pong.displayName = 'proto.types.Pong';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Pong.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Pong.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Pong} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Pong.toObject = function (includeInstance, msg) {
        var obj = {
          bestblockhash: msg.getBestblockhash_asB64(),
          bestheight: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Pong}
     */


    proto.types.Pong.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Pong();
      return proto.types.Pong.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Pong} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Pong}
     */


    proto.types.Pong.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBestblockhash(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBestheight(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Pong.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Pong.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Pong} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Pong.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getBestblockhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getBestheight();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }
    };
    /**
     * optional bytes bestBlockHash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Pong.prototype.getBestblockhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes bestBlockHash = 1;
     * This is a type-conversion wrapper around `getBestblockhash()`
     * @return {string}
     */


    proto.types.Pong.prototype.getBestblockhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBestblockhash())
      );
    };
    /**
     * optional bytes bestBlockHash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBestblockhash()`
     * @return {!Uint8Array}
     */


    proto.types.Pong.prototype.getBestblockhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBestblockhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Pong.prototype.setBestblockhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 bestHeight = 2;
     * @return {number}
     */


    proto.types.Pong.prototype.getBestheight = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.Pong.prototype.setBestheight = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Status = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.Status.repeatedFields_, null);
    };

    goog.inherits(proto.types.Status, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Status.displayName = 'proto.types.Status';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.Status.repeatedFields_ = [8];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Status.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Status.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Status} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Status.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          sender: (f = msg.getSender()) && node_pb.PeerAddress.toObject(includeInstance, f),
          bestblockhash: msg.getBestblockhash_asB64(),
          bestheight: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          chainid: msg.getChainid_asB64(),
          noexpose: googleProtobuf.Message.getFieldWithDefault(msg, 5, false),
          version: googleProtobuf.Message.getFieldWithDefault(msg, 6, ""),
          genesis: msg.getGenesis_asB64(),
          certificatesList: googleProtobuf.Message.toObjectList(msg.getCertificatesList(), node_pb.AgentCertificate.toObject, includeInstance),
          issuecertificate: googleProtobuf.Message.getFieldWithDefault(msg, 9, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Status}
     */


    proto.types.Status.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Status();
      return proto.types.Status.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Status} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Status}
     */


    proto.types.Status.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new node_pb.PeerAddress();
            reader.readMessage(value, node_pb.PeerAddress.deserializeBinaryFromReader);
            msg.setSender(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBestblockhash(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBestheight(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setChainid(value);
            break;

          case 5:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setNoexpose(value);
            break;

          case 6:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setVersion(value);
            break;

          case 7:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setGenesis(value);
            break;

          case 8:
            var value = new node_pb.AgentCertificate();
            reader.readMessage(value, node_pb.AgentCertificate.deserializeBinaryFromReader);
            msg.addCertificates(value);
            break;

          case 9:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setIssuecertificate(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Status.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Status.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Status} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Status.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getSender();

      if (f != null) {
        writer.writeMessage(1, f, node_pb.PeerAddress.serializeBinaryToWriter);
      }

      f = message.getBestblockhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }

      f = message.getBestheight();

      if (f !== 0) {
        writer.writeUint64(3, f);
      }

      f = message.getChainid_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }

      f = message.getNoexpose();

      if (f) {
        writer.writeBool(5, f);
      }

      f = message.getVersion();

      if (f.length > 0) {
        writer.writeString(6, f);
      }

      f = message.getGenesis_asU8();

      if (f.length > 0) {
        writer.writeBytes(7, f);
      }

      f = message.getCertificatesList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(8, f, node_pb.AgentCertificate.serializeBinaryToWriter);
      }

      f = message.getIssuecertificate();

      if (f) {
        writer.writeBool(9, f);
      }
    };
    /**
     * optional PeerAddress sender = 1;
     * @return {?proto.types.PeerAddress}
     */


    proto.types.Status.prototype.getSender = function () {
      return (
        /** @type{?proto.types.PeerAddress} */
        googleProtobuf.Message.getWrapperField(this, node_pb.PeerAddress, 1)
      );
    };
    /** @param {?proto.types.PeerAddress|undefined} value */


    proto.types.Status.prototype.setSender = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.Status.prototype.clearSender = function () {
      this.setSender(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.Status.prototype.hasSender = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional bytes bestBlockHash = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Status.prototype.getBestblockhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes bestBlockHash = 2;
     * This is a type-conversion wrapper around `getBestblockhash()`
     * @return {string}
     */


    proto.types.Status.prototype.getBestblockhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBestblockhash())
      );
    };
    /**
     * optional bytes bestBlockHash = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBestblockhash()`
     * @return {!Uint8Array}
     */


    proto.types.Status.prototype.getBestblockhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBestblockhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Status.prototype.setBestblockhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * optional uint64 bestHeight = 3;
     * @return {number}
     */


    proto.types.Status.prototype.getBestheight = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.Status.prototype.setBestheight = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional bytes chainID = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Status.prototype.getChainid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes chainID = 4;
     * This is a type-conversion wrapper around `getChainid()`
     * @return {string}
     */


    proto.types.Status.prototype.getChainid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getChainid())
      );
    };
    /**
     * optional bytes chainID = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getChainid()`
     * @return {!Uint8Array}
     */


    proto.types.Status.prototype.getChainid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getChainid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Status.prototype.setChainid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * optional bool noExpose = 5;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.Status.prototype.getNoexpose = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, false)
      );
    };
    /** @param {boolean} value */


    proto.types.Status.prototype.setNoexpose = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 5, value);
    };
    /**
     * optional string version = 6;
     * @return {string}
     */


    proto.types.Status.prototype.getVersion = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /** @param {string} value */


    proto.types.Status.prototype.setVersion = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 6, value);
    };
    /**
     * optional bytes genesis = 7;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Status.prototype.getGenesis = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, "")
      );
    };
    /**
     * optional bytes genesis = 7;
     * This is a type-conversion wrapper around `getGenesis()`
     * @return {string}
     */


    proto.types.Status.prototype.getGenesis_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getGenesis())
      );
    };
    /**
     * optional bytes genesis = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getGenesis()`
     * @return {!Uint8Array}
     */


    proto.types.Status.prototype.getGenesis_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getGenesis())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Status.prototype.setGenesis = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 7, value);
    };
    /**
     * repeated AgentCertificate certificates = 8;
     * @return {!Array<!proto.types.AgentCertificate>}
     */


    proto.types.Status.prototype.getCertificatesList = function () {
      return (
        /** @type{!Array<!proto.types.AgentCertificate>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, node_pb.AgentCertificate, 8)
      );
    };
    /** @param {!Array<!proto.types.AgentCertificate>} value */


    proto.types.Status.prototype.setCertificatesList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 8, value);
    };
    /**
     * @param {!proto.types.AgentCertificate=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.AgentCertificate}
     */


    proto.types.Status.prototype.addCertificates = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.types.AgentCertificate, opt_index);
    };

    proto.types.Status.prototype.clearCertificatesList = function () {
      this.setCertificatesList([]);
    };
    /**
     * optional bool issueCertificate = 9;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.Status.prototype.getIssuecertificate = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 9, false)
      );
    };
    /** @param {boolean} value */


    proto.types.Status.prototype.setIssuecertificate = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 9, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GoAwayNotice = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.GoAwayNotice, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GoAwayNotice.displayName = 'proto.types.GoAwayNotice';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GoAwayNotice.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GoAwayNotice.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GoAwayNotice} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GoAwayNotice.toObject = function (includeInstance, msg) {
        var obj = {
          message: googleProtobuf.Message.getFieldWithDefault(msg, 1, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GoAwayNotice}
     */


    proto.types.GoAwayNotice.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GoAwayNotice();
      return proto.types.GoAwayNotice.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GoAwayNotice} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GoAwayNotice}
     */


    proto.types.GoAwayNotice.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setMessage(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GoAwayNotice.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GoAwayNotice.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GoAwayNotice} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GoAwayNotice.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getMessage();

      if (f.length > 0) {
        writer.writeString(1, f);
      }
    };
    /**
     * optional string message = 1;
     * @return {string}
     */


    proto.types.GoAwayNotice.prototype.getMessage = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.GoAwayNotice.prototype.setMessage = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.AddressesRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.AddressesRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.AddressesRequest.displayName = 'proto.types.AddressesRequest';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.AddressesRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.AddressesRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.AddressesRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.AddressesRequest.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          sender: (f = msg.getSender()) && node_pb.PeerAddress.toObject(includeInstance, f),
          maxsize: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.AddressesRequest}
     */


    proto.types.AddressesRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.AddressesRequest();
      return proto.types.AddressesRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.AddressesRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.AddressesRequest}
     */


    proto.types.AddressesRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new node_pb.PeerAddress();
            reader.readMessage(value, node_pb.PeerAddress.deserializeBinaryFromReader);
            msg.setSender(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setMaxsize(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.AddressesRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.AddressesRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.AddressesRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.AddressesRequest.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getSender();

      if (f != null) {
        writer.writeMessage(1, f, node_pb.PeerAddress.serializeBinaryToWriter);
      }

      f = message.getMaxsize();

      if (f !== 0) {
        writer.writeUint32(2, f);
      }
    };
    /**
     * optional PeerAddress sender = 1;
     * @return {?proto.types.PeerAddress}
     */


    proto.types.AddressesRequest.prototype.getSender = function () {
      return (
        /** @type{?proto.types.PeerAddress} */
        googleProtobuf.Message.getWrapperField(this, node_pb.PeerAddress, 1)
      );
    };
    /** @param {?proto.types.PeerAddress|undefined} value */


    proto.types.AddressesRequest.prototype.setSender = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.AddressesRequest.prototype.clearSender = function () {
      this.setSender(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.AddressesRequest.prototype.hasSender = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional uint32 maxSize = 2;
     * @return {number}
     */


    proto.types.AddressesRequest.prototype.getMaxsize = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.AddressesRequest.prototype.setMaxsize = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.AddressesResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.AddressesResponse.repeatedFields_, null);
    };

    goog.inherits(proto.types.AddressesResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.AddressesResponse.displayName = 'proto.types.AddressesResponse';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.AddressesResponse.repeatedFields_ = [2];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.AddressesResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.AddressesResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.AddressesResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.AddressesResponse.toObject = function (includeInstance, msg) {
        var obj = {
          status: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          peersList: googleProtobuf.Message.toObjectList(msg.getPeersList(), node_pb.PeerAddress.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.AddressesResponse}
     */


    proto.types.AddressesResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.AddressesResponse();
      return proto.types.AddressesResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.AddressesResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.AddressesResponse}
     */


    proto.types.AddressesResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ResultStatus} */
            reader.readEnum();
            msg.setStatus(value);
            break;

          case 2:
            var value = new node_pb.PeerAddress();
            reader.readMessage(value, node_pb.PeerAddress.deserializeBinaryFromReader);
            msg.addPeers(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.AddressesResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.AddressesResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.AddressesResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.AddressesResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatus();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getPeersList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(2, f, node_pb.PeerAddress.serializeBinaryToWriter);
      }
    };
    /**
     * optional ResultStatus status = 1;
     * @return {!proto.types.ResultStatus}
     */


    proto.types.AddressesResponse.prototype.getStatus = function () {
      return (
        /** @type {!proto.types.ResultStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ResultStatus} value */


    proto.types.AddressesResponse.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * repeated PeerAddress peers = 2;
     * @return {!Array<!proto.types.PeerAddress>}
     */


    proto.types.AddressesResponse.prototype.getPeersList = function () {
      return (
        /** @type{!Array<!proto.types.PeerAddress>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, node_pb.PeerAddress, 2)
      );
    };
    /** @param {!Array<!proto.types.PeerAddress>} value */


    proto.types.AddressesResponse.prototype.setPeersList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };
    /**
     * @param {!proto.types.PeerAddress=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.PeerAddress}
     */


    proto.types.AddressesResponse.prototype.addPeers = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.types.PeerAddress, opt_index);
    };

    proto.types.AddressesResponse.prototype.clearPeersList = function () {
      this.setPeersList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.NewBlockNotice = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.NewBlockNotice, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.NewBlockNotice.displayName = 'proto.types.NewBlockNotice';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.NewBlockNotice.prototype.toObject = function (opt_includeInstance) {
        return proto.types.NewBlockNotice.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.NewBlockNotice} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.NewBlockNotice.toObject = function (includeInstance, msg) {
        var obj = {
          blockhash: msg.getBlockhash_asB64(),
          blockno: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.NewBlockNotice}
     */


    proto.types.NewBlockNotice.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.NewBlockNotice();
      return proto.types.NewBlockNotice.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.NewBlockNotice} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.NewBlockNotice}
     */


    proto.types.NewBlockNotice.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBlockhash(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBlockno(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.NewBlockNotice.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.NewBlockNotice.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.NewBlockNotice} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.NewBlockNotice.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getBlockhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getBlockno();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }
    };
    /**
     * optional bytes blockHash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.NewBlockNotice.prototype.getBlockhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes blockHash = 1;
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {string}
     */


    proto.types.NewBlockNotice.prototype.getBlockhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBlockhash())
      );
    };
    /**
     * optional bytes blockHash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {!Uint8Array}
     */


    proto.types.NewBlockNotice.prototype.getBlockhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBlockhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.NewBlockNotice.prototype.setBlockhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 blockNo = 2;
     * @return {number}
     */


    proto.types.NewBlockNotice.prototype.getBlockno = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.NewBlockNotice.prototype.setBlockno = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.BlockProducedNotice = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.BlockProducedNotice, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.BlockProducedNotice.displayName = 'proto.types.BlockProducedNotice';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.BlockProducedNotice.prototype.toObject = function (opt_includeInstance) {
        return proto.types.BlockProducedNotice.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.BlockProducedNotice} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.BlockProducedNotice.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          producerid: msg.getProducerid_asB64(),
          blockno: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          block: (f = msg.getBlock()) && blockchain_pb.Block.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.BlockProducedNotice}
     */


    proto.types.BlockProducedNotice.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.BlockProducedNotice();
      return proto.types.BlockProducedNotice.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.BlockProducedNotice} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.BlockProducedNotice}
     */


    proto.types.BlockProducedNotice.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setProducerid(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBlockno(value);
            break;

          case 3:
            var value = new blockchain_pb.Block();
            reader.readMessage(value, blockchain_pb.Block.deserializeBinaryFromReader);
            msg.setBlock(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.BlockProducedNotice.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.BlockProducedNotice.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.BlockProducedNotice} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.BlockProducedNotice.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getProducerid_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getBlockno();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }

      f = message.getBlock();

      if (f != null) {
        writer.writeMessage(3, f, blockchain_pb.Block.serializeBinaryToWriter);
      }
    };
    /**
     * optional bytes producerID = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockProducedNotice.prototype.getProducerid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes producerID = 1;
     * This is a type-conversion wrapper around `getProducerid()`
     * @return {string}
     */


    proto.types.BlockProducedNotice.prototype.getProducerid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getProducerid())
      );
    };
    /**
     * optional bytes producerID = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getProducerid()`
     * @return {!Uint8Array}
     */


    proto.types.BlockProducedNotice.prototype.getProducerid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getProducerid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockProducedNotice.prototype.setProducerid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 blockNo = 2;
     * @return {number}
     */


    proto.types.BlockProducedNotice.prototype.getBlockno = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockProducedNotice.prototype.setBlockno = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional Block block = 3;
     * @return {?proto.types.Block}
     */


    proto.types.BlockProducedNotice.prototype.getBlock = function () {
      return (
        /** @type{?proto.types.Block} */
        googleProtobuf.Message.getWrapperField(this, blockchain_pb.Block, 3)
      );
    };
    /** @param {?proto.types.Block|undefined} value */


    proto.types.BlockProducedNotice.prototype.setBlock = function (value) {
      googleProtobuf.Message.setWrapperField(this, 3, value);
    };

    proto.types.BlockProducedNotice.prototype.clearBlock = function () {
      this.setBlock(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.BlockProducedNotice.prototype.hasBlock = function () {
      return googleProtobuf.Message.getField(this, 3) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetBlockHeadersRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.GetBlockHeadersRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetBlockHeadersRequest.displayName = 'proto.types.GetBlockHeadersRequest';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetBlockHeadersRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetBlockHeadersRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetBlockHeadersRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetBlockHeadersRequest.toObject = function (includeInstance, msg) {
        var obj = {
          hash: msg.getHash_asB64(),
          height: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          offset: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          size: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0),
          asc: googleProtobuf.Message.getFieldWithDefault(msg, 5, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetBlockHeadersRequest}
     */


    proto.types.GetBlockHeadersRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetBlockHeadersRequest();
      return proto.types.GetBlockHeadersRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetBlockHeadersRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetBlockHeadersRequest}
     */


    proto.types.GetBlockHeadersRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setHash(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setHeight(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setOffset(value);
            break;

          case 4:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setSize(value);
            break;

          case 5:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setAsc(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetBlockHeadersRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetBlockHeadersRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetBlockHeadersRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetBlockHeadersRequest.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getHeight();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }

      f = message.getOffset();

      if (f !== 0) {
        writer.writeUint64(3, f);
      }

      f = message.getSize();

      if (f !== 0) {
        writer.writeUint32(4, f);
      }

      f = message.getAsc();

      if (f) {
        writer.writeBool(5, f);
      }
    };
    /**
     * optional bytes hash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.GetBlockHeadersRequest.prototype.getHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes hash = 1;
     * This is a type-conversion wrapper around `getHash()`
     * @return {string}
     */


    proto.types.GetBlockHeadersRequest.prototype.getHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getHash())
      );
    };
    /**
     * optional bytes hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHash()`
     * @return {!Uint8Array}
     */


    proto.types.GetBlockHeadersRequest.prototype.getHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.GetBlockHeadersRequest.prototype.setHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 height = 2;
     * @return {number}
     */


    proto.types.GetBlockHeadersRequest.prototype.getHeight = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.GetBlockHeadersRequest.prototype.setHeight = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional uint64 offset = 3;
     * @return {number}
     */


    proto.types.GetBlockHeadersRequest.prototype.getOffset = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.GetBlockHeadersRequest.prototype.setOffset = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional uint32 size = 4;
     * @return {number}
     */


    proto.types.GetBlockHeadersRequest.prototype.getSize = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    /** @param {number} value */


    proto.types.GetBlockHeadersRequest.prototype.setSize = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 4, value);
    };
    /**
     * optional bool asc = 5;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.GetBlockHeadersRequest.prototype.getAsc = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, false)
      );
    };
    /** @param {boolean} value */


    proto.types.GetBlockHeadersRequest.prototype.setAsc = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 5, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetBlockHeadersResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.GetBlockHeadersResponse.repeatedFields_, null);
    };

    goog.inherits(proto.types.GetBlockHeadersResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetBlockHeadersResponse.displayName = 'proto.types.GetBlockHeadersResponse';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.GetBlockHeadersResponse.repeatedFields_ = [2, 3];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetBlockHeadersResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetBlockHeadersResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetBlockHeadersResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetBlockHeadersResponse.toObject = function (includeInstance, msg) {
        var obj = {
          status: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          hashesList: msg.getHashesList_asB64(),
          headersList: googleProtobuf.Message.toObjectList(msg.getHeadersList(), blockchain_pb.BlockHeader.toObject, includeInstance),
          hasnext: googleProtobuf.Message.getFieldWithDefault(msg, 4, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetBlockHeadersResponse}
     */


    proto.types.GetBlockHeadersResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetBlockHeadersResponse();
      return proto.types.GetBlockHeadersResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetBlockHeadersResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetBlockHeadersResponse}
     */


    proto.types.GetBlockHeadersResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ResultStatus} */
            reader.readEnum();
            msg.setStatus(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addHashes(value);
            break;

          case 3:
            var value = new blockchain_pb.BlockHeader();
            reader.readMessage(value, blockchain_pb.BlockHeader.deserializeBinaryFromReader);
            msg.addHeaders(value);
            break;

          case 4:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setHasnext(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetBlockHeadersResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetBlockHeadersResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetBlockHeadersResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetBlockHeadersResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatus();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getHashesList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(2, f);
      }

      f = message.getHeadersList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(3, f, blockchain_pb.BlockHeader.serializeBinaryToWriter);
      }

      f = message.getHasnext();

      if (f) {
        writer.writeBool(4, f);
      }
    };
    /**
     * optional ResultStatus status = 1;
     * @return {!proto.types.ResultStatus}
     */


    proto.types.GetBlockHeadersResponse.prototype.getStatus = function () {
      return (
        /** @type {!proto.types.ResultStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ResultStatus} value */


    proto.types.GetBlockHeadersResponse.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * repeated bytes hashes = 2;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.GetBlockHeadersResponse.prototype.getHashesList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 2)
      );
    };
    /**
     * repeated bytes hashes = 2;
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<string>}
     */


    proto.types.GetBlockHeadersResponse.prototype.getHashesList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getHashesList())
      );
    };
    /**
     * repeated bytes hashes = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.GetBlockHeadersResponse.prototype.getHashesList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getHashesList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.GetBlockHeadersResponse.prototype.setHashesList = function (value) {
      googleProtobuf.Message.setField(this, 2, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.GetBlockHeadersResponse.prototype.addHashes = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 2, value, opt_index);
    };

    proto.types.GetBlockHeadersResponse.prototype.clearHashesList = function () {
      this.setHashesList([]);
    };
    /**
     * repeated BlockHeader headers = 3;
     * @return {!Array<!proto.types.BlockHeader>}
     */


    proto.types.GetBlockHeadersResponse.prototype.getHeadersList = function () {
      return (
        /** @type{!Array<!proto.types.BlockHeader>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, blockchain_pb.BlockHeader, 3)
      );
    };
    /** @param {!Array<!proto.types.BlockHeader>} value */


    proto.types.GetBlockHeadersResponse.prototype.setHeadersList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 3, value);
    };
    /**
     * @param {!proto.types.BlockHeader=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.BlockHeader}
     */


    proto.types.GetBlockHeadersResponse.prototype.addHeaders = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.types.BlockHeader, opt_index);
    };

    proto.types.GetBlockHeadersResponse.prototype.clearHeadersList = function () {
      this.setHeadersList([]);
    };
    /**
     * optional bool hasNext = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.GetBlockHeadersResponse.prototype.getHasnext = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, false)
      );
    };
    /** @param {boolean} value */


    proto.types.GetBlockHeadersResponse.prototype.setHasnext = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 4, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetBlockRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.GetBlockRequest.repeatedFields_, null);
    };

    goog.inherits(proto.types.GetBlockRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetBlockRequest.displayName = 'proto.types.GetBlockRequest';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.GetBlockRequest.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetBlockRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetBlockRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetBlockRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetBlockRequest.toObject = function (includeInstance, msg) {
        var obj = {
          hashesList: msg.getHashesList_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetBlockRequest}
     */


    proto.types.GetBlockRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetBlockRequest();
      return proto.types.GetBlockRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetBlockRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetBlockRequest}
     */


    proto.types.GetBlockRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addHashes(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetBlockRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetBlockRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetBlockRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetBlockRequest.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHashesList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(1, f);
      }
    };
    /**
     * repeated bytes hashes = 1;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.GetBlockRequest.prototype.getHashesList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 1)
      );
    };
    /**
     * repeated bytes hashes = 1;
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<string>}
     */


    proto.types.GetBlockRequest.prototype.getHashesList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getHashesList())
      );
    };
    /**
     * repeated bytes hashes = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.GetBlockRequest.prototype.getHashesList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getHashesList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.GetBlockRequest.prototype.setHashesList = function (value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.GetBlockRequest.prototype.addHashes = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };

    proto.types.GetBlockRequest.prototype.clearHashesList = function () {
      this.setHashesList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetBlockResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.GetBlockResponse.repeatedFields_, null);
    };

    goog.inherits(proto.types.GetBlockResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetBlockResponse.displayName = 'proto.types.GetBlockResponse';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.GetBlockResponse.repeatedFields_ = [2];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetBlockResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetBlockResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetBlockResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetBlockResponse.toObject = function (includeInstance, msg) {
        var obj = {
          status: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          blocksList: googleProtobuf.Message.toObjectList(msg.getBlocksList(), blockchain_pb.Block.toObject, includeInstance),
          hasnext: googleProtobuf.Message.getFieldWithDefault(msg, 3, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetBlockResponse}
     */


    proto.types.GetBlockResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetBlockResponse();
      return proto.types.GetBlockResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetBlockResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetBlockResponse}
     */


    proto.types.GetBlockResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ResultStatus} */
            reader.readEnum();
            msg.setStatus(value);
            break;

          case 2:
            var value = new blockchain_pb.Block();
            reader.readMessage(value, blockchain_pb.Block.deserializeBinaryFromReader);
            msg.addBlocks(value);
            break;

          case 3:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setHasnext(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetBlockResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetBlockResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetBlockResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetBlockResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatus();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getBlocksList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(2, f, blockchain_pb.Block.serializeBinaryToWriter);
      }

      f = message.getHasnext();

      if (f) {
        writer.writeBool(3, f);
      }
    };
    /**
     * optional ResultStatus status = 1;
     * @return {!proto.types.ResultStatus}
     */


    proto.types.GetBlockResponse.prototype.getStatus = function () {
      return (
        /** @type {!proto.types.ResultStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ResultStatus} value */


    proto.types.GetBlockResponse.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * repeated Block blocks = 2;
     * @return {!Array<!proto.types.Block>}
     */


    proto.types.GetBlockResponse.prototype.getBlocksList = function () {
      return (
        /** @type{!Array<!proto.types.Block>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, blockchain_pb.Block, 2)
      );
    };
    /** @param {!Array<!proto.types.Block>} value */


    proto.types.GetBlockResponse.prototype.setBlocksList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };
    /**
     * @param {!proto.types.Block=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Block}
     */


    proto.types.GetBlockResponse.prototype.addBlocks = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.types.Block, opt_index);
    };

    proto.types.GetBlockResponse.prototype.clearBlocksList = function () {
      this.setBlocksList([]);
    };
    /**
     * optional bool hasNext = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.GetBlockResponse.prototype.getHasnext = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, false)
      );
    };
    /** @param {boolean} value */


    proto.types.GetBlockResponse.prototype.setHasnext = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.NewTransactionsNotice = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.NewTransactionsNotice.repeatedFields_, null);
    };

    goog.inherits(proto.types.NewTransactionsNotice, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.NewTransactionsNotice.displayName = 'proto.types.NewTransactionsNotice';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.NewTransactionsNotice.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.NewTransactionsNotice.prototype.toObject = function (opt_includeInstance) {
        return proto.types.NewTransactionsNotice.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.NewTransactionsNotice} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.NewTransactionsNotice.toObject = function (includeInstance, msg) {
        var obj = {
          txhashesList: msg.getTxhashesList_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.NewTransactionsNotice}
     */


    proto.types.NewTransactionsNotice.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.NewTransactionsNotice();
      return proto.types.NewTransactionsNotice.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.NewTransactionsNotice} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.NewTransactionsNotice}
     */


    proto.types.NewTransactionsNotice.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addTxhashes(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.NewTransactionsNotice.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.NewTransactionsNotice.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.NewTransactionsNotice} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.NewTransactionsNotice.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getTxhashesList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(1, f);
      }
    };
    /**
     * repeated bytes txHashes = 1;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.NewTransactionsNotice.prototype.getTxhashesList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 1)
      );
    };
    /**
     * repeated bytes txHashes = 1;
     * This is a type-conversion wrapper around `getTxhashesList()`
     * @return {!Array<string>}
     */


    proto.types.NewTransactionsNotice.prototype.getTxhashesList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getTxhashesList())
      );
    };
    /**
     * repeated bytes txHashes = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTxhashesList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.NewTransactionsNotice.prototype.getTxhashesList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getTxhashesList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.NewTransactionsNotice.prototype.setTxhashesList = function (value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.NewTransactionsNotice.prototype.addTxhashes = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };

    proto.types.NewTransactionsNotice.prototype.clearTxhashesList = function () {
      this.setTxhashesList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetTransactionsRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.GetTransactionsRequest.repeatedFields_, null);
    };

    goog.inherits(proto.types.GetTransactionsRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetTransactionsRequest.displayName = 'proto.types.GetTransactionsRequest';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.GetTransactionsRequest.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetTransactionsRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetTransactionsRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetTransactionsRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetTransactionsRequest.toObject = function (includeInstance, msg) {
        var obj = {
          hashesList: msg.getHashesList_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetTransactionsRequest}
     */


    proto.types.GetTransactionsRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetTransactionsRequest();
      return proto.types.GetTransactionsRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetTransactionsRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetTransactionsRequest}
     */


    proto.types.GetTransactionsRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addHashes(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetTransactionsRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetTransactionsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetTransactionsRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetTransactionsRequest.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHashesList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(1, f);
      }
    };
    /**
     * repeated bytes hashes = 1;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.GetTransactionsRequest.prototype.getHashesList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 1)
      );
    };
    /**
     * repeated bytes hashes = 1;
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<string>}
     */


    proto.types.GetTransactionsRequest.prototype.getHashesList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getHashesList())
      );
    };
    /**
     * repeated bytes hashes = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.GetTransactionsRequest.prototype.getHashesList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getHashesList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.GetTransactionsRequest.prototype.setHashesList = function (value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.GetTransactionsRequest.prototype.addHashes = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };

    proto.types.GetTransactionsRequest.prototype.clearHashesList = function () {
      this.setHashesList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetTransactionsResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.GetTransactionsResponse.repeatedFields_, null);
    };

    goog.inherits(proto.types.GetTransactionsResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetTransactionsResponse.displayName = 'proto.types.GetTransactionsResponse';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.GetTransactionsResponse.repeatedFields_ = [2, 3];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetTransactionsResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetTransactionsResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetTransactionsResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetTransactionsResponse.toObject = function (includeInstance, msg) {
        var obj = {
          status: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          hashesList: msg.getHashesList_asB64(),
          txsList: googleProtobuf.Message.toObjectList(msg.getTxsList(), blockchain_pb.Tx.toObject, includeInstance),
          hasnext: googleProtobuf.Message.getFieldWithDefault(msg, 4, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetTransactionsResponse}
     */


    proto.types.GetTransactionsResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetTransactionsResponse();
      return proto.types.GetTransactionsResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetTransactionsResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetTransactionsResponse}
     */


    proto.types.GetTransactionsResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ResultStatus} */
            reader.readEnum();
            msg.setStatus(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addHashes(value);
            break;

          case 3:
            var value = new blockchain_pb.Tx();
            reader.readMessage(value, blockchain_pb.Tx.deserializeBinaryFromReader);
            msg.addTxs(value);
            break;

          case 4:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setHasnext(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetTransactionsResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetTransactionsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetTransactionsResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetTransactionsResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatus();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getHashesList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(2, f);
      }

      f = message.getTxsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(3, f, blockchain_pb.Tx.serializeBinaryToWriter);
      }

      f = message.getHasnext();

      if (f) {
        writer.writeBool(4, f);
      }
    };
    /**
     * optional ResultStatus status = 1;
     * @return {!proto.types.ResultStatus}
     */


    proto.types.GetTransactionsResponse.prototype.getStatus = function () {
      return (
        /** @type {!proto.types.ResultStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ResultStatus} value */


    proto.types.GetTransactionsResponse.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * repeated bytes hashes = 2;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.GetTransactionsResponse.prototype.getHashesList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 2)
      );
    };
    /**
     * repeated bytes hashes = 2;
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<string>}
     */


    proto.types.GetTransactionsResponse.prototype.getHashesList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getHashesList())
      );
    };
    /**
     * repeated bytes hashes = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.GetTransactionsResponse.prototype.getHashesList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getHashesList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.GetTransactionsResponse.prototype.setHashesList = function (value) {
      googleProtobuf.Message.setField(this, 2, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.GetTransactionsResponse.prototype.addHashes = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 2, value, opt_index);
    };

    proto.types.GetTransactionsResponse.prototype.clearHashesList = function () {
      this.setHashesList([]);
    };
    /**
     * repeated Tx txs = 3;
     * @return {!Array<!proto.types.Tx>}
     */


    proto.types.GetTransactionsResponse.prototype.getTxsList = function () {
      return (
        /** @type{!Array<!proto.types.Tx>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, blockchain_pb.Tx, 3)
      );
    };
    /** @param {!Array<!proto.types.Tx>} value */


    proto.types.GetTransactionsResponse.prototype.setTxsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 3, value);
    };
    /**
     * @param {!proto.types.Tx=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Tx}
     */


    proto.types.GetTransactionsResponse.prototype.addTxs = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.types.Tx, opt_index);
    };

    proto.types.GetTransactionsResponse.prototype.clearTxsList = function () {
      this.setTxsList([]);
    };
    /**
     * optional bool hasNext = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.GetTransactionsResponse.prototype.getHasnext = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, false)
      );
    };
    /** @param {boolean} value */


    proto.types.GetTransactionsResponse.prototype.setHasnext = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 4, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetMissingRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.GetMissingRequest.repeatedFields_, null);
    };

    goog.inherits(proto.types.GetMissingRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetMissingRequest.displayName = 'proto.types.GetMissingRequest';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.GetMissingRequest.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetMissingRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetMissingRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetMissingRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetMissingRequest.toObject = function (includeInstance, msg) {
        var obj = {
          hashesList: msg.getHashesList_asB64(),
          stophash: msg.getStophash_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetMissingRequest}
     */


    proto.types.GetMissingRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetMissingRequest();
      return proto.types.GetMissingRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetMissingRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetMissingRequest}
     */


    proto.types.GetMissingRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addHashes(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setStophash(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetMissingRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetMissingRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetMissingRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetMissingRequest.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHashesList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(1, f);
      }

      f = message.getStophash_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }
    };
    /**
     * repeated bytes hashes = 1;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.GetMissingRequest.prototype.getHashesList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 1)
      );
    };
    /**
     * repeated bytes hashes = 1;
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<string>}
     */


    proto.types.GetMissingRequest.prototype.getHashesList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getHashesList())
      );
    };
    /**
     * repeated bytes hashes = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.GetMissingRequest.prototype.getHashesList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getHashesList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.GetMissingRequest.prototype.setHashesList = function (value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.GetMissingRequest.prototype.addHashes = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };

    proto.types.GetMissingRequest.prototype.clearHashesList = function () {
      this.setHashesList([]);
    };
    /**
     * optional bytes stophash = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.GetMissingRequest.prototype.getStophash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes stophash = 2;
     * This is a type-conversion wrapper around `getStophash()`
     * @return {string}
     */


    proto.types.GetMissingRequest.prototype.getStophash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getStophash())
      );
    };
    /**
     * optional bytes stophash = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getStophash()`
     * @return {!Uint8Array}
     */


    proto.types.GetMissingRequest.prototype.getStophash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getStophash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.GetMissingRequest.prototype.setStophash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetAncestorRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.GetAncestorRequest.repeatedFields_, null);
    };

    goog.inherits(proto.types.GetAncestorRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetAncestorRequest.displayName = 'proto.types.GetAncestorRequest';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.GetAncestorRequest.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetAncestorRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetAncestorRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetAncestorRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetAncestorRequest.toObject = function (includeInstance, msg) {
        var obj = {
          hashesList: msg.getHashesList_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetAncestorRequest}
     */


    proto.types.GetAncestorRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetAncestorRequest();
      return proto.types.GetAncestorRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetAncestorRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetAncestorRequest}
     */


    proto.types.GetAncestorRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addHashes(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetAncestorRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetAncestorRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetAncestorRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetAncestorRequest.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHashesList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(1, f);
      }
    };
    /**
     * repeated bytes hashes = 1;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.GetAncestorRequest.prototype.getHashesList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 1)
      );
    };
    /**
     * repeated bytes hashes = 1;
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<string>}
     */


    proto.types.GetAncestorRequest.prototype.getHashesList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getHashesList())
      );
    };
    /**
     * repeated bytes hashes = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.GetAncestorRequest.prototype.getHashesList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getHashesList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.GetAncestorRequest.prototype.setHashesList = function (value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.GetAncestorRequest.prototype.addHashes = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };

    proto.types.GetAncestorRequest.prototype.clearHashesList = function () {
      this.setHashesList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetAncestorResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.GetAncestorResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetAncestorResponse.displayName = 'proto.types.GetAncestorResponse';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetAncestorResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetAncestorResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetAncestorResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetAncestorResponse.toObject = function (includeInstance, msg) {
        var obj = {
          status: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          ancestorhash: msg.getAncestorhash_asB64(),
          ancestorno: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetAncestorResponse}
     */


    proto.types.GetAncestorResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetAncestorResponse();
      return proto.types.GetAncestorResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetAncestorResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetAncestorResponse}
     */


    proto.types.GetAncestorResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ResultStatus} */
            reader.readEnum();
            msg.setStatus(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setAncestorhash(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setAncestorno(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetAncestorResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetAncestorResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetAncestorResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetAncestorResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatus();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getAncestorhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }

      f = message.getAncestorno();

      if (f !== 0) {
        writer.writeUint64(3, f);
      }
    };
    /**
     * optional ResultStatus status = 1;
     * @return {!proto.types.ResultStatus}
     */


    proto.types.GetAncestorResponse.prototype.getStatus = function () {
      return (
        /** @type {!proto.types.ResultStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ResultStatus} value */


    proto.types.GetAncestorResponse.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * optional bytes ancestorHash = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.GetAncestorResponse.prototype.getAncestorhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes ancestorHash = 2;
     * This is a type-conversion wrapper around `getAncestorhash()`
     * @return {string}
     */


    proto.types.GetAncestorResponse.prototype.getAncestorhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getAncestorhash())
      );
    };
    /**
     * optional bytes ancestorHash = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAncestorhash()`
     * @return {!Uint8Array}
     */


    proto.types.GetAncestorResponse.prototype.getAncestorhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getAncestorhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.GetAncestorResponse.prototype.setAncestorhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * optional uint64 ancestorNo = 3;
     * @return {number}
     */


    proto.types.GetAncestorResponse.prototype.getAncestorno = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.GetAncestorResponse.prototype.setAncestorno = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetHashByNo = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.GetHashByNo, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetHashByNo.displayName = 'proto.types.GetHashByNo';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetHashByNo.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetHashByNo.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetHashByNo} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetHashByNo.toObject = function (includeInstance, msg) {
        var obj = {
          blockno: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetHashByNo}
     */


    proto.types.GetHashByNo.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetHashByNo();
      return proto.types.GetHashByNo.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetHashByNo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetHashByNo}
     */


    proto.types.GetHashByNo.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBlockno(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetHashByNo.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetHashByNo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetHashByNo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetHashByNo.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getBlockno();

      if (f !== 0) {
        writer.writeUint64(1, f);
      }
    };
    /**
     * optional uint64 blockNo = 1;
     * @return {number}
     */


    proto.types.GetHashByNo.prototype.getBlockno = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {number} value */


    proto.types.GetHashByNo.prototype.setBlockno = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetHashByNoResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.GetHashByNoResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetHashByNoResponse.displayName = 'proto.types.GetHashByNoResponse';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetHashByNoResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetHashByNoResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetHashByNoResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetHashByNoResponse.toObject = function (includeInstance, msg) {
        var obj = {
          status: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          blockhash: msg.getBlockhash_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetHashByNoResponse}
     */


    proto.types.GetHashByNoResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetHashByNoResponse();
      return proto.types.GetHashByNoResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetHashByNoResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetHashByNoResponse}
     */


    proto.types.GetHashByNoResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ResultStatus} */
            reader.readEnum();
            msg.setStatus(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBlockhash(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetHashByNoResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetHashByNoResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetHashByNoResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetHashByNoResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatus();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getBlockhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }
    };
    /**
     * optional ResultStatus status = 1;
     * @return {!proto.types.ResultStatus}
     */


    proto.types.GetHashByNoResponse.prototype.getStatus = function () {
      return (
        /** @type {!proto.types.ResultStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ResultStatus} value */


    proto.types.GetHashByNoResponse.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * optional bytes blockHash = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.GetHashByNoResponse.prototype.getBlockhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes blockHash = 2;
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {string}
     */


    proto.types.GetHashByNoResponse.prototype.getBlockhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBlockhash())
      );
    };
    /**
     * optional bytes blockHash = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBlockhash()`
     * @return {!Uint8Array}
     */


    proto.types.GetHashByNoResponse.prototype.getBlockhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBlockhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.GetHashByNoResponse.prototype.setBlockhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetHashesRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.GetHashesRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetHashesRequest.displayName = 'proto.types.GetHashesRequest';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetHashesRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetHashesRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetHashesRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetHashesRequest.toObject = function (includeInstance, msg) {
        var obj = {
          prevhash: msg.getPrevhash_asB64(),
          prevnumber: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          size: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetHashesRequest}
     */


    proto.types.GetHashesRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetHashesRequest();
      return proto.types.GetHashesRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetHashesRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetHashesRequest}
     */


    proto.types.GetHashesRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setPrevhash(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setPrevnumber(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setSize(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetHashesRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetHashesRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetHashesRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetHashesRequest.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getPrevhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getPrevnumber();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }

      f = message.getSize();

      if (f !== 0) {
        writer.writeUint64(3, f);
      }
    };
    /**
     * optional bytes prevHash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.GetHashesRequest.prototype.getPrevhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes prevHash = 1;
     * This is a type-conversion wrapper around `getPrevhash()`
     * @return {string}
     */


    proto.types.GetHashesRequest.prototype.getPrevhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getPrevhash())
      );
    };
    /**
     * optional bytes prevHash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPrevhash()`
     * @return {!Uint8Array}
     */


    proto.types.GetHashesRequest.prototype.getPrevhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getPrevhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.GetHashesRequest.prototype.setPrevhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 prevNumber = 2;
     * @return {number}
     */


    proto.types.GetHashesRequest.prototype.getPrevnumber = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.GetHashesRequest.prototype.setPrevnumber = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional uint64 size = 3;
     * @return {number}
     */


    proto.types.GetHashesRequest.prototype.getSize = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.GetHashesRequest.prototype.setSize = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetHashesResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.GetHashesResponse.repeatedFields_, null);
    };

    goog.inherits(proto.types.GetHashesResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetHashesResponse.displayName = 'proto.types.GetHashesResponse';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.GetHashesResponse.repeatedFields_ = [2];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetHashesResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetHashesResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetHashesResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetHashesResponse.toObject = function (includeInstance, msg) {
        var obj = {
          status: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          hashesList: msg.getHashesList_asB64(),
          hasnext: googleProtobuf.Message.getFieldWithDefault(msg, 3, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetHashesResponse}
     */


    proto.types.GetHashesResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetHashesResponse();
      return proto.types.GetHashesResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetHashesResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetHashesResponse}
     */


    proto.types.GetHashesResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ResultStatus} */
            reader.readEnum();
            msg.setStatus(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addHashes(value);
            break;

          case 3:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setHasnext(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetHashesResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetHashesResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetHashesResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetHashesResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatus();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getHashesList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(2, f);
      }

      f = message.getHasnext();

      if (f) {
        writer.writeBool(3, f);
      }
    };
    /**
     * optional ResultStatus status = 1;
     * @return {!proto.types.ResultStatus}
     */


    proto.types.GetHashesResponse.prototype.getStatus = function () {
      return (
        /** @type {!proto.types.ResultStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ResultStatus} value */


    proto.types.GetHashesResponse.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * repeated bytes hashes = 2;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.GetHashesResponse.prototype.getHashesList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 2)
      );
    };
    /**
     * repeated bytes hashes = 2;
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<string>}
     */


    proto.types.GetHashesResponse.prototype.getHashesList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getHashesList())
      );
    };
    /**
     * repeated bytes hashes = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHashesList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.GetHashesResponse.prototype.getHashesList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getHashesList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.GetHashesResponse.prototype.setHashesList = function (value) {
      googleProtobuf.Message.setField(this, 2, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.GetHashesResponse.prototype.addHashes = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 2, value, opt_index);
    };

    proto.types.GetHashesResponse.prototype.clearHashesList = function () {
      this.setHashesList([]);
    };
    /**
     * optional bool hasNext = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.GetHashesResponse.prototype.getHasnext = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, false)
      );
    };
    /** @param {boolean} value */


    proto.types.GetHashesResponse.prototype.setHasnext = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.IssueCertificateRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.IssueCertificateRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.IssueCertificateRequest.displayName = 'proto.types.IssueCertificateRequest';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.IssueCertificateRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.IssueCertificateRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.IssueCertificateRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.IssueCertificateRequest.toObject = function (includeInstance, msg) {
        var obj = {};

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.IssueCertificateRequest}
     */


    proto.types.IssueCertificateRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.IssueCertificateRequest();
      return proto.types.IssueCertificateRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.IssueCertificateRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.IssueCertificateRequest}
     */


    proto.types.IssueCertificateRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.IssueCertificateRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.IssueCertificateRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.IssueCertificateRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.IssueCertificateRequest.serializeBinaryToWriter = function (message, writer) {
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.IssueCertificateResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.IssueCertificateResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.IssueCertificateResponse.displayName = 'proto.types.IssueCertificateResponse';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.IssueCertificateResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.IssueCertificateResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.IssueCertificateResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.IssueCertificateResponse.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          status: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          certificate: (f = msg.getCertificate()) && node_pb.AgentCertificate.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.IssueCertificateResponse}
     */


    proto.types.IssueCertificateResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.IssueCertificateResponse();
      return proto.types.IssueCertificateResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.IssueCertificateResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.IssueCertificateResponse}
     */


    proto.types.IssueCertificateResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ResultStatus} */
            reader.readEnum();
            msg.setStatus(value);
            break;

          case 2:
            var value = new node_pb.AgentCertificate();
            reader.readMessage(value, node_pb.AgentCertificate.deserializeBinaryFromReader);
            msg.setCertificate(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.IssueCertificateResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.IssueCertificateResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.IssueCertificateResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.IssueCertificateResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatus();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getCertificate();

      if (f != null) {
        writer.writeMessage(2, f, node_pb.AgentCertificate.serializeBinaryToWriter);
      }
    };
    /**
     * optional ResultStatus status = 1;
     * @return {!proto.types.ResultStatus}
     */


    proto.types.IssueCertificateResponse.prototype.getStatus = function () {
      return (
        /** @type {!proto.types.ResultStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ResultStatus} value */


    proto.types.IssueCertificateResponse.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * optional AgentCertificate certificate = 2;
     * @return {?proto.types.AgentCertificate}
     */


    proto.types.IssueCertificateResponse.prototype.getCertificate = function () {
      return (
        /** @type{?proto.types.AgentCertificate} */
        googleProtobuf.Message.getWrapperField(this, node_pb.AgentCertificate, 2)
      );
    };
    /** @param {?proto.types.AgentCertificate|undefined} value */


    proto.types.IssueCertificateResponse.prototype.setCertificate = function (value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };

    proto.types.IssueCertificateResponse.prototype.clearCertificate = function () {
      this.setCertificate(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.IssueCertificateResponse.prototype.hasCertificate = function () {
      return googleProtobuf.Message.getField(this, 2) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.CertificateRenewedNotice = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.CertificateRenewedNotice, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.CertificateRenewedNotice.displayName = 'proto.types.CertificateRenewedNotice';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.CertificateRenewedNotice.prototype.toObject = function (opt_includeInstance) {
        return proto.types.CertificateRenewedNotice.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.CertificateRenewedNotice} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.CertificateRenewedNotice.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          certificate: (f = msg.getCertificate()) && node_pb.AgentCertificate.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.CertificateRenewedNotice}
     */


    proto.types.CertificateRenewedNotice.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.CertificateRenewedNotice();
      return proto.types.CertificateRenewedNotice.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.CertificateRenewedNotice} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.CertificateRenewedNotice}
     */


    proto.types.CertificateRenewedNotice.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 2:
            var value = new node_pb.AgentCertificate();
            reader.readMessage(value, node_pb.AgentCertificate.deserializeBinaryFromReader);
            msg.setCertificate(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.CertificateRenewedNotice.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.CertificateRenewedNotice.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.CertificateRenewedNotice} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.CertificateRenewedNotice.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getCertificate();

      if (f != null) {
        writer.writeMessage(2, f, node_pb.AgentCertificate.serializeBinaryToWriter);
      }
    };
    /**
     * optional AgentCertificate certificate = 2;
     * @return {?proto.types.AgentCertificate}
     */


    proto.types.CertificateRenewedNotice.prototype.getCertificate = function () {
      return (
        /** @type{?proto.types.AgentCertificate} */
        googleProtobuf.Message.getWrapperField(this, node_pb.AgentCertificate, 2)
      );
    };
    /** @param {?proto.types.AgentCertificate|undefined} value */


    proto.types.CertificateRenewedNotice.prototype.setCertificate = function (value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };

    proto.types.CertificateRenewedNotice.prototype.clearCertificate = function () {
      this.setCertificate(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.CertificateRenewedNotice.prototype.hasCertificate = function () {
      return googleProtobuf.Message.getField(this, 2) != null;
    };
    /**
     * @enum {number}
     */


    proto.types.ResultStatus = {
      OK: 0,
      CANCELED: 1,
      UNKNOWN: 2,
      INVALID_ARGUMENT: 3,
      DEADLINE_EXCEEDED: 4,
      NOT_FOUND: 5,
      ALREADY_EXISTS: 6,
      PERMISSION_DENIED: 7,
      RESOURCE_EXHAUSTED: 8,
      FAILED_PRECONDITION: 9,
      ABORTED: 10,
      OUT_OF_RANGE: 11,
      UNIMPLEMENTED: 12,
      INTERNAL: 13,
      UNAVAILABLE: 14,
      DATA_LOSS: 15,
      UNAUTHENTICATED: 16
    };
    goog.object.extend(exports, proto.types);
  });

  var metric_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!
    var goog = googleProtobuf;
    var global = Function('return this')();
    goog.exportSymbol('proto.types.MetricType', null, global);
    goog.exportSymbol('proto.types.Metrics', null, global);
    goog.exportSymbol('proto.types.MetricsRequest', null, global);
    goog.exportSymbol('proto.types.PeerMetric', null, global);
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */

    proto.types.MetricsRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.MetricsRequest.repeatedFields_, null);
    };

    goog.inherits(proto.types.MetricsRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.MetricsRequest.displayName = 'proto.types.MetricsRequest';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.MetricsRequest.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.MetricsRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.MetricsRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.MetricsRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.MetricsRequest.toObject = function (includeInstance, msg) {
        var obj = {
          typesList: googleProtobuf.Message.getRepeatedField(msg, 1)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.MetricsRequest}
     */


    proto.types.MetricsRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.MetricsRequest();
      return proto.types.MetricsRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.MetricsRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.MetricsRequest}
     */


    proto.types.MetricsRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Array<!proto.types.MetricType>} */
            reader.readPackedEnum();
            msg.setTypesList(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.MetricsRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.MetricsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.MetricsRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.MetricsRequest.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getTypesList();

      if (f.length > 0) {
        writer.writePackedEnum(1, f);
      }
    };
    /**
     * repeated MetricType types = 1;
     * @return {!Array<!proto.types.MetricType>}
     */


    proto.types.MetricsRequest.prototype.getTypesList = function () {
      return (
        /** @type {!Array<!proto.types.MetricType>} */
        googleProtobuf.Message.getRepeatedField(this, 1)
      );
    };
    /** @param {!Array<!proto.types.MetricType>} value */


    proto.types.MetricsRequest.prototype.setTypesList = function (value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };
    /**
     * @param {!proto.types.MetricType} value
     * @param {number=} opt_index
     */


    proto.types.MetricsRequest.prototype.addTypes = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };

    proto.types.MetricsRequest.prototype.clearTypesList = function () {
      this.setTypesList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Metrics = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.Metrics.repeatedFields_, null);
    };

    goog.inherits(proto.types.Metrics, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Metrics.displayName = 'proto.types.Metrics';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.Metrics.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Metrics.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Metrics.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Metrics} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Metrics.toObject = function (includeInstance, msg) {
        var obj = {
          peersList: googleProtobuf.Message.toObjectList(msg.getPeersList(), proto.types.PeerMetric.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Metrics}
     */


    proto.types.Metrics.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Metrics();
      return proto.types.Metrics.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Metrics} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Metrics}
     */


    proto.types.Metrics.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.PeerMetric();
            reader.readMessage(value, proto.types.PeerMetric.deserializeBinaryFromReader);
            msg.addPeers(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Metrics.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Metrics.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Metrics} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Metrics.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getPeersList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, proto.types.PeerMetric.serializeBinaryToWriter);
      }
    };
    /**
     * repeated PeerMetric peers = 1;
     * @return {!Array<!proto.types.PeerMetric>}
     */


    proto.types.Metrics.prototype.getPeersList = function () {
      return (
        /** @type{!Array<!proto.types.PeerMetric>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.PeerMetric, 1)
      );
    };
    /** @param {!Array<!proto.types.PeerMetric>} value */


    proto.types.Metrics.prototype.setPeersList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.PeerMetric=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.PeerMetric}
     */


    proto.types.Metrics.prototype.addPeers = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.PeerMetric, opt_index);
    };

    proto.types.Metrics.prototype.clearPeersList = function () {
      this.setPeersList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.PeerMetric = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.PeerMetric, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.PeerMetric.displayName = 'proto.types.PeerMetric';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.PeerMetric.prototype.toObject = function (opt_includeInstance) {
        return proto.types.PeerMetric.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.PeerMetric} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.PeerMetric.toObject = function (includeInstance, msg) {
        var obj = {
          peerid: msg.getPeerid_asB64(),
          sumin: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          avrin: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          sumout: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0),
          avrout: googleProtobuf.Message.getFieldWithDefault(msg, 5, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.PeerMetric}
     */


    proto.types.PeerMetric.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.PeerMetric();
      return proto.types.PeerMetric.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.PeerMetric} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.PeerMetric}
     */


    proto.types.PeerMetric.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setPeerid(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setSumin(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setAvrin(value);
            break;

          case 4:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setSumout(value);
            break;

          case 5:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setAvrout(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.PeerMetric.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.PeerMetric.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.PeerMetric} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.PeerMetric.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getPeerid_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getSumin();

      if (f !== 0) {
        writer.writeInt64(2, f);
      }

      f = message.getAvrin();

      if (f !== 0) {
        writer.writeInt64(3, f);
      }

      f = message.getSumout();

      if (f !== 0) {
        writer.writeInt64(4, f);
      }

      f = message.getAvrout();

      if (f !== 0) {
        writer.writeInt64(5, f);
      }
    };
    /**
     * optional bytes peerID = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.PeerMetric.prototype.getPeerid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes peerID = 1;
     * This is a type-conversion wrapper around `getPeerid()`
     * @return {string}
     */


    proto.types.PeerMetric.prototype.getPeerid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getPeerid())
      );
    };
    /**
     * optional bytes peerID = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPeerid()`
     * @return {!Uint8Array}
     */


    proto.types.PeerMetric.prototype.getPeerid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getPeerid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.PeerMetric.prototype.setPeerid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional int64 sumIn = 2;
     * @return {number}
     */


    proto.types.PeerMetric.prototype.getSumin = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.PeerMetric.prototype.setSumin = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional int64 avrIn = 3;
     * @return {number}
     */


    proto.types.PeerMetric.prototype.getAvrin = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.PeerMetric.prototype.setAvrin = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional int64 sumOut = 4;
     * @return {number}
     */


    proto.types.PeerMetric.prototype.getSumout = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    /** @param {number} value */


    proto.types.PeerMetric.prototype.setSumout = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 4, value);
    };
    /**
     * optional int64 avrOut = 5;
     * @return {number}
     */


    proto.types.PeerMetric.prototype.getAvrout = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    /** @param {number} value */


    proto.types.PeerMetric.prototype.setAvrout = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 5, value);
    };
    /**
     * @enum {number}
     */


    proto.types.MetricType = {
      NOTHING: 0,
      P2P_NETWORK: 1
    };
    goog.object.extend(exports, proto.types);
  });

  var raft_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!
    var goog = googleProtobuf;
    var global = Function('return this')();
    goog.object.extend(proto, p2p_pb);
    goog.exportSymbol('proto.types.ConfChangeProgress', null, global);
    goog.exportSymbol('proto.types.ConfChangeState', null, global);
    goog.exportSymbol('proto.types.GetClusterInfoRequest', null, global);
    goog.exportSymbol('proto.types.GetClusterInfoResponse', null, global);
    goog.exportSymbol('proto.types.HardStateInfo', null, global);
    goog.exportSymbol('proto.types.MemberAttr', null, global);
    goog.exportSymbol('proto.types.MembershipChange', null, global);
    goog.exportSymbol('proto.types.MembershipChangeReply', null, global);
    goog.exportSymbol('proto.types.MembershipChangeType', null, global);
    goog.exportSymbol('proto.types.SnapshotResponse', null, global);
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */

    proto.types.MemberAttr = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.MemberAttr, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.MemberAttr.displayName = 'proto.types.MemberAttr';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.MemberAttr.prototype.toObject = function (opt_includeInstance) {
        return proto.types.MemberAttr.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.MemberAttr} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.MemberAttr.toObject = function (includeInstance, msg) {
        var obj = {
          id: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          name: googleProtobuf.Message.getFieldWithDefault(msg, 2, ""),
          address: googleProtobuf.Message.getFieldWithDefault(msg, 3, ""),
          peerid: msg.getPeerid_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.MemberAttr}
     */


    proto.types.MemberAttr.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.MemberAttr();
      return proto.types.MemberAttr.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.MemberAttr} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.MemberAttr}
     */


    proto.types.MemberAttr.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setId(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setName(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setAddress(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setPeerid(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.MemberAttr.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.MemberAttr.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.MemberAttr} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.MemberAttr.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getId();

      if (f !== 0) {
        writer.writeUint64(1, f);
      }

      f = message.getName();

      if (f.length > 0) {
        writer.writeString(2, f);
      }

      f = message.getAddress();

      if (f.length > 0) {
        writer.writeString(3, f);
      }

      f = message.getPeerid_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }
    };
    /**
     * optional uint64 ID = 1;
     * @return {number}
     */


    proto.types.MemberAttr.prototype.getId = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {number} value */


    proto.types.MemberAttr.prototype.setId = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 1, value);
    };
    /**
     * optional string name = 2;
     * @return {string}
     */


    proto.types.MemberAttr.prototype.getName = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.MemberAttr.prototype.setName = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * optional string address = 3;
     * @return {string}
     */


    proto.types.MemberAttr.prototype.getAddress = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.MemberAttr.prototype.setAddress = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * optional bytes peerID = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.MemberAttr.prototype.getPeerid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes peerID = 4;
     * This is a type-conversion wrapper around `getPeerid()`
     * @return {string}
     */


    proto.types.MemberAttr.prototype.getPeerid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getPeerid())
      );
    };
    /**
     * optional bytes peerID = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPeerid()`
     * @return {!Uint8Array}
     */


    proto.types.MemberAttr.prototype.getPeerid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getPeerid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.MemberAttr.prototype.setPeerid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.MembershipChange = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.MembershipChange, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.MembershipChange.displayName = 'proto.types.MembershipChange';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.MembershipChange.prototype.toObject = function (opt_includeInstance) {
        return proto.types.MembershipChange.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.MembershipChange} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.MembershipChange.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          type: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          requestid: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          attr: (f = msg.getAttr()) && proto.types.MemberAttr.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.MembershipChange}
     */


    proto.types.MembershipChange.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.MembershipChange();
      return proto.types.MembershipChange.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.MembershipChange} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.MembershipChange}
     */


    proto.types.MembershipChange.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.MembershipChangeType} */
            reader.readEnum();
            msg.setType(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setRequestid(value);
            break;

          case 3:
            var value = new proto.types.MemberAttr();
            reader.readMessage(value, proto.types.MemberAttr.deserializeBinaryFromReader);
            msg.setAttr(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.MembershipChange.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.MembershipChange.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.MembershipChange} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.MembershipChange.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getType();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getRequestid();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }

      f = message.getAttr();

      if (f != null) {
        writer.writeMessage(3, f, proto.types.MemberAttr.serializeBinaryToWriter);
      }
    };
    /**
     * optional MembershipChangeType type = 1;
     * @return {!proto.types.MembershipChangeType}
     */


    proto.types.MembershipChange.prototype.getType = function () {
      return (
        /** @type {!proto.types.MembershipChangeType} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.MembershipChangeType} value */


    proto.types.MembershipChange.prototype.setType = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * optional uint64 requestID = 2;
     * @return {number}
     */


    proto.types.MembershipChange.prototype.getRequestid = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.MembershipChange.prototype.setRequestid = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional MemberAttr attr = 3;
     * @return {?proto.types.MemberAttr}
     */


    proto.types.MembershipChange.prototype.getAttr = function () {
      return (
        /** @type{?proto.types.MemberAttr} */
        googleProtobuf.Message.getWrapperField(this, proto.types.MemberAttr, 3)
      );
    };
    /** @param {?proto.types.MemberAttr|undefined} value */


    proto.types.MembershipChange.prototype.setAttr = function (value) {
      googleProtobuf.Message.setWrapperField(this, 3, value);
    };

    proto.types.MembershipChange.prototype.clearAttr = function () {
      this.setAttr(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.MembershipChange.prototype.hasAttr = function () {
      return googleProtobuf.Message.getField(this, 3) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.MembershipChangeReply = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.MembershipChangeReply, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.MembershipChangeReply.displayName = 'proto.types.MembershipChangeReply';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.MembershipChangeReply.prototype.toObject = function (opt_includeInstance) {
        return proto.types.MembershipChangeReply.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.MembershipChangeReply} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.MembershipChangeReply.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          attr: (f = msg.getAttr()) && proto.types.MemberAttr.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.MembershipChangeReply}
     */


    proto.types.MembershipChangeReply.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.MembershipChangeReply();
      return proto.types.MembershipChangeReply.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.MembershipChangeReply} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.MembershipChangeReply}
     */


    proto.types.MembershipChangeReply.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.MemberAttr();
            reader.readMessage(value, proto.types.MemberAttr.deserializeBinaryFromReader);
            msg.setAttr(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.MembershipChangeReply.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.MembershipChangeReply.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.MembershipChangeReply} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.MembershipChangeReply.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getAttr();

      if (f != null) {
        writer.writeMessage(1, f, proto.types.MemberAttr.serializeBinaryToWriter);
      }
    };
    /**
     * optional MemberAttr attr = 1;
     * @return {?proto.types.MemberAttr}
     */


    proto.types.MembershipChangeReply.prototype.getAttr = function () {
      return (
        /** @type{?proto.types.MemberAttr} */
        googleProtobuf.Message.getWrapperField(this, proto.types.MemberAttr, 1)
      );
    };
    /** @param {?proto.types.MemberAttr|undefined} value */


    proto.types.MembershipChangeReply.prototype.setAttr = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.MembershipChangeReply.prototype.clearAttr = function () {
      this.setAttr(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.MembershipChangeReply.prototype.hasAttr = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.HardStateInfo = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.HardStateInfo, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.HardStateInfo.displayName = 'proto.types.HardStateInfo';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.HardStateInfo.prototype.toObject = function (opt_includeInstance) {
        return proto.types.HardStateInfo.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.HardStateInfo} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.HardStateInfo.toObject = function (includeInstance, msg) {
        var obj = {
          term: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          commit: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.HardStateInfo}
     */


    proto.types.HardStateInfo.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.HardStateInfo();
      return proto.types.HardStateInfo.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.HardStateInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.HardStateInfo}
     */


    proto.types.HardStateInfo.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setTerm(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setCommit(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.HardStateInfo.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.HardStateInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.HardStateInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.HardStateInfo.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getTerm();

      if (f !== 0) {
        writer.writeUint64(1, f);
      }

      f = message.getCommit();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }
    };
    /**
     * optional uint64 term = 1;
     * @return {number}
     */


    proto.types.HardStateInfo.prototype.getTerm = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {number} value */


    proto.types.HardStateInfo.prototype.setTerm = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 1, value);
    };
    /**
     * optional uint64 commit = 2;
     * @return {number}
     */


    proto.types.HardStateInfo.prototype.getCommit = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.HardStateInfo.prototype.setCommit = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetClusterInfoRequest = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.GetClusterInfoRequest, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetClusterInfoRequest.displayName = 'proto.types.GetClusterInfoRequest';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetClusterInfoRequest.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetClusterInfoRequest.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetClusterInfoRequest} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetClusterInfoRequest.toObject = function (includeInstance, msg) {
        var obj = {
          bestblockhash: msg.getBestblockhash_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetClusterInfoRequest}
     */


    proto.types.GetClusterInfoRequest.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetClusterInfoRequest();
      return proto.types.GetClusterInfoRequest.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetClusterInfoRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetClusterInfoRequest}
     */


    proto.types.GetClusterInfoRequest.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBestblockhash(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetClusterInfoRequest.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetClusterInfoRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetClusterInfoRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetClusterInfoRequest.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getBestblockhash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }
    };
    /**
     * optional bytes bestBlockHash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.GetClusterInfoRequest.prototype.getBestblockhash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes bestBlockHash = 1;
     * This is a type-conversion wrapper around `getBestblockhash()`
     * @return {string}
     */


    proto.types.GetClusterInfoRequest.prototype.getBestblockhash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBestblockhash())
      );
    };
    /**
     * optional bytes bestBlockHash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBestblockhash()`
     * @return {!Uint8Array}
     */


    proto.types.GetClusterInfoRequest.prototype.getBestblockhash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBestblockhash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.GetClusterInfoRequest.prototype.setBestblockhash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.GetClusterInfoResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.GetClusterInfoResponse.repeatedFields_, null);
    };

    goog.inherits(proto.types.GetClusterInfoResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.GetClusterInfoResponse.displayName = 'proto.types.GetClusterInfoResponse';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.GetClusterInfoResponse.repeatedFields_ = [4];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.GetClusterInfoResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.GetClusterInfoResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.GetClusterInfoResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.GetClusterInfoResponse.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          chainid: msg.getChainid_asB64(),
          clusterid: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          error: googleProtobuf.Message.getFieldWithDefault(msg, 3, ""),
          mbrattrsList: googleProtobuf.Message.toObjectList(msg.getMbrattrsList(), proto.types.MemberAttr.toObject, includeInstance),
          bestblockno: googleProtobuf.Message.getFieldWithDefault(msg, 5, 0),
          hardstateinfo: (f = msg.getHardstateinfo()) && proto.types.HardStateInfo.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.GetClusterInfoResponse}
     */


    proto.types.GetClusterInfoResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.GetClusterInfoResponse();
      return proto.types.GetClusterInfoResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.GetClusterInfoResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.GetClusterInfoResponse}
     */


    proto.types.GetClusterInfoResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setChainid(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setClusterid(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setError(value);
            break;

          case 4:
            var value = new proto.types.MemberAttr();
            reader.readMessage(value, proto.types.MemberAttr.deserializeBinaryFromReader);
            msg.addMbrattrs(value);
            break;

          case 5:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBestblockno(value);
            break;

          case 6:
            var value = new proto.types.HardStateInfo();
            reader.readMessage(value, proto.types.HardStateInfo.deserializeBinaryFromReader);
            msg.setHardstateinfo(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.GetClusterInfoResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.GetClusterInfoResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.GetClusterInfoResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.GetClusterInfoResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getChainid_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getClusterid();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }

      f = message.getError();

      if (f.length > 0) {
        writer.writeString(3, f);
      }

      f = message.getMbrattrsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(4, f, proto.types.MemberAttr.serializeBinaryToWriter);
      }

      f = message.getBestblockno();

      if (f !== 0) {
        writer.writeUint64(5, f);
      }

      f = message.getHardstateinfo();

      if (f != null) {
        writer.writeMessage(6, f, proto.types.HardStateInfo.serializeBinaryToWriter);
      }
    };
    /**
     * optional bytes chainID = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.GetClusterInfoResponse.prototype.getChainid = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes chainID = 1;
     * This is a type-conversion wrapper around `getChainid()`
     * @return {string}
     */


    proto.types.GetClusterInfoResponse.prototype.getChainid_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getChainid())
      );
    };
    /**
     * optional bytes chainID = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getChainid()`
     * @return {!Uint8Array}
     */


    proto.types.GetClusterInfoResponse.prototype.getChainid_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getChainid())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.GetClusterInfoResponse.prototype.setChainid = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 clusterID = 2;
     * @return {number}
     */


    proto.types.GetClusterInfoResponse.prototype.getClusterid = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.GetClusterInfoResponse.prototype.setClusterid = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional string error = 3;
     * @return {string}
     */


    proto.types.GetClusterInfoResponse.prototype.getError = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.GetClusterInfoResponse.prototype.setError = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * repeated MemberAttr mbrAttrs = 4;
     * @return {!Array<!proto.types.MemberAttr>}
     */


    proto.types.GetClusterInfoResponse.prototype.getMbrattrsList = function () {
      return (
        /** @type{!Array<!proto.types.MemberAttr>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.MemberAttr, 4)
      );
    };
    /** @param {!Array<!proto.types.MemberAttr>} value */


    proto.types.GetClusterInfoResponse.prototype.setMbrattrsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 4, value);
    };
    /**
     * @param {!proto.types.MemberAttr=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.MemberAttr}
     */


    proto.types.GetClusterInfoResponse.prototype.addMbrattrs = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.types.MemberAttr, opt_index);
    };

    proto.types.GetClusterInfoResponse.prototype.clearMbrattrsList = function () {
      this.setMbrattrsList([]);
    };
    /**
     * optional uint64 bestBlockNo = 5;
     * @return {number}
     */


    proto.types.GetClusterInfoResponse.prototype.getBestblockno = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    /** @param {number} value */


    proto.types.GetClusterInfoResponse.prototype.setBestblockno = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 5, value);
    };
    /**
     * optional HardStateInfo hardStateInfo = 6;
     * @return {?proto.types.HardStateInfo}
     */


    proto.types.GetClusterInfoResponse.prototype.getHardstateinfo = function () {
      return (
        /** @type{?proto.types.HardStateInfo} */
        googleProtobuf.Message.getWrapperField(this, proto.types.HardStateInfo, 6)
      );
    };
    /** @param {?proto.types.HardStateInfo|undefined} value */


    proto.types.GetClusterInfoResponse.prototype.setHardstateinfo = function (value) {
      googleProtobuf.Message.setWrapperField(this, 6, value);
    };

    proto.types.GetClusterInfoResponse.prototype.clearHardstateinfo = function () {
      this.setHardstateinfo(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.GetClusterInfoResponse.prototype.hasHardstateinfo = function () {
      return googleProtobuf.Message.getField(this, 6) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ConfChangeProgress = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.ConfChangeProgress.repeatedFields_, null);
    };

    goog.inherits(proto.types.ConfChangeProgress, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ConfChangeProgress.displayName = 'proto.types.ConfChangeProgress';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.ConfChangeProgress.repeatedFields_ = [3];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ConfChangeProgress.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ConfChangeProgress.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ConfChangeProgress} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ConfChangeProgress.toObject = function (includeInstance, msg) {
        var obj = {
          state: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          err: googleProtobuf.Message.getFieldWithDefault(msg, 2, ""),
          membersList: googleProtobuf.Message.toObjectList(msg.getMembersList(), proto.types.MemberAttr.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ConfChangeProgress}
     */


    proto.types.ConfChangeProgress.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ConfChangeProgress();
      return proto.types.ConfChangeProgress.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ConfChangeProgress} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ConfChangeProgress}
     */


    proto.types.ConfChangeProgress.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ConfChangeState} */
            reader.readEnum();
            msg.setState(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setErr(value);
            break;

          case 3:
            var value = new proto.types.MemberAttr();
            reader.readMessage(value, proto.types.MemberAttr.deserializeBinaryFromReader);
            msg.addMembers(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ConfChangeProgress.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ConfChangeProgress.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ConfChangeProgress} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ConfChangeProgress.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getState();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getErr();

      if (f.length > 0) {
        writer.writeString(2, f);
      }

      f = message.getMembersList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(3, f, proto.types.MemberAttr.serializeBinaryToWriter);
      }
    };
    /**
     * optional ConfChangeState State = 1;
     * @return {!proto.types.ConfChangeState}
     */


    proto.types.ConfChangeProgress.prototype.getState = function () {
      return (
        /** @type {!proto.types.ConfChangeState} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ConfChangeState} value */


    proto.types.ConfChangeProgress.prototype.setState = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * optional string Err = 2;
     * @return {string}
     */


    proto.types.ConfChangeProgress.prototype.getErr = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.ConfChangeProgress.prototype.setErr = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * repeated MemberAttr Members = 3;
     * @return {!Array<!proto.types.MemberAttr>}
     */


    proto.types.ConfChangeProgress.prototype.getMembersList = function () {
      return (
        /** @type{!Array<!proto.types.MemberAttr>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.MemberAttr, 3)
      );
    };
    /** @param {!Array<!proto.types.MemberAttr>} value */


    proto.types.ConfChangeProgress.prototype.setMembersList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 3, value);
    };
    /**
     * @param {!proto.types.MemberAttr=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.MemberAttr}
     */


    proto.types.ConfChangeProgress.prototype.addMembers = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.types.MemberAttr, opt_index);
    };

    proto.types.ConfChangeProgress.prototype.clearMembersList = function () {
      this.setMembersList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.SnapshotResponse = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.SnapshotResponse, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.SnapshotResponse.displayName = 'proto.types.SnapshotResponse';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.SnapshotResponse.prototype.toObject = function (opt_includeInstance) {
        return proto.types.SnapshotResponse.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.SnapshotResponse} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.SnapshotResponse.toObject = function (includeInstance, msg) {
        var obj = {
          status: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          message: googleProtobuf.Message.getFieldWithDefault(msg, 2, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.SnapshotResponse}
     */


    proto.types.SnapshotResponse.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.SnapshotResponse();
      return proto.types.SnapshotResponse.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.SnapshotResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.SnapshotResponse}
     */


    proto.types.SnapshotResponse.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!proto.types.ResultStatus} */
            reader.readEnum();
            msg.setStatus(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setMessage(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.SnapshotResponse.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.SnapshotResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.SnapshotResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.SnapshotResponse.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatus();

      if (f !== 0.0) {
        writer.writeEnum(1, f);
      }

      f = message.getMessage();

      if (f.length > 0) {
        writer.writeString(2, f);
      }
    };
    /**
     * optional ResultStatus status = 1;
     * @return {!proto.types.ResultStatus}
     */


    proto.types.SnapshotResponse.prototype.getStatus = function () {
      return (
        /** @type {!proto.types.ResultStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {!proto.types.ResultStatus} value */


    proto.types.SnapshotResponse.prototype.setStatus = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 1, value);
    };
    /**
     * optional string message = 2;
     * @return {string}
     */


    proto.types.SnapshotResponse.prototype.getMessage = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.SnapshotResponse.prototype.setMessage = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * @enum {number}
     */


    proto.types.MembershipChangeType = {
      ADD_MEMBER: 0,
      REMOVE_MEMBER: 1
    };
    /**
     * @enum {number}
     */

    proto.types.ConfChangeState = {
      CONF_CHANGE_STATE_PROPOSED: 0,
      CONF_CHANGE_STATE_SAVED: 1,
      CONF_CHANGE_STATE_APPLIED: 2
    };
    goog.object.extend(exports, proto.types);
  });

  var rpc_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!
    var goog = googleProtobuf;
    var global = Function('return this')();
    goog.object.extend(proto, blockchain_pb);
    goog.object.extend(proto, account_pb);
    goog.object.extend(proto, node_pb);
    goog.object.extend(proto, p2p_pb);
    goog.object.extend(proto, metric_pb);
    goog.object.extend(proto, raft_pb);
    goog.exportSymbol('proto.types.AccountAddress', null, global);
    goog.exportSymbol('proto.types.AccountAndRoot', null, global);
    goog.exportSymbol('proto.types.AccountVoteInfo', null, global);
    goog.exportSymbol('proto.types.BlockBodyPaged', null, global);
    goog.exportSymbol('proto.types.BlockBodyParams', null, global);
    goog.exportSymbol('proto.types.BlockHeaderList', null, global);
    goog.exportSymbol('proto.types.BlockMetadata', null, global);
    goog.exportSymbol('proto.types.BlockMetadataList', null, global);
    goog.exportSymbol('proto.types.BlockchainStatus', null, global);
    goog.exportSymbol('proto.types.ChainId', null, global);
    goog.exportSymbol('proto.types.ChainInfo', null, global);
    goog.exportSymbol('proto.types.ChainStats', null, global);
    goog.exportSymbol('proto.types.CommitResult', null, global);
    goog.exportSymbol('proto.types.CommitResultList', null, global);
    goog.exportSymbol('proto.types.CommitStatus', null, global);
    goog.exportSymbol('proto.types.ConfigItem', null, global);
    goog.exportSymbol('proto.types.ConsensusInfo', null, global);
    goog.exportSymbol('proto.types.Empty', null, global);
    goog.exportSymbol('proto.types.EnterpriseConfig', null, global);
    goog.exportSymbol('proto.types.EnterpriseConfigKey', null, global);
    goog.exportSymbol('proto.types.EventList', null, global);
    goog.exportSymbol('proto.types.ImportFormat', null, global);
    goog.exportSymbol('proto.types.Input', null, global);
    goog.exportSymbol('proto.types.KeyParams', null, global);
    goog.exportSymbol('proto.types.ListParams', null, global);
    goog.exportSymbol('proto.types.Name', null, global);
    goog.exportSymbol('proto.types.NameInfo', null, global);
    goog.exportSymbol('proto.types.NodeReq', null, global);
    goog.exportSymbol('proto.types.Output', null, global);
    goog.exportSymbol('proto.types.PageParams', null, global);
    goog.exportSymbol('proto.types.Peer', null, global);
    goog.exportSymbol('proto.types.PeerList', null, global);
    goog.exportSymbol('proto.types.PeersParams', null, global);
    goog.exportSymbol('proto.types.Personal', null, global);
    goog.exportSymbol('proto.types.ServerInfo', null, global);
    goog.exportSymbol('proto.types.SingleBytes', null, global);
    goog.exportSymbol('proto.types.SingleString', null, global);
    goog.exportSymbol('proto.types.Staking', null, global);
    goog.exportSymbol('proto.types.VerifyResult', null, global);
    goog.exportSymbol('proto.types.VerifyStatus', null, global);
    goog.exportSymbol('proto.types.Vote', null, global);
    goog.exportSymbol('proto.types.VoteInfo', null, global);
    goog.exportSymbol('proto.types.VoteList', null, global);
    goog.exportSymbol('proto.types.VoteParams', null, global);
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */

    proto.types.BlockchainStatus = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.BlockchainStatus, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.BlockchainStatus.displayName = 'proto.types.BlockchainStatus';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.BlockchainStatus.prototype.toObject = function (opt_includeInstance) {
        return proto.types.BlockchainStatus.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.BlockchainStatus} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.BlockchainStatus.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          bestBlockHash: msg.getBestBlockHash_asB64(),
          bestHeight: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          consensusInfo: googleProtobuf.Message.getFieldWithDefault(msg, 3, ""),
          bestChainIdHash: msg.getBestChainIdHash_asB64(),
          chainInfo: (f = msg.getChainInfo()) && proto.types.ChainInfo.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.BlockchainStatus}
     */


    proto.types.BlockchainStatus.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.BlockchainStatus();
      return proto.types.BlockchainStatus.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.BlockchainStatus} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.BlockchainStatus}
     */


    proto.types.BlockchainStatus.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBestBlockHash(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBestHeight(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setConsensusInfo(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setBestChainIdHash(value);
            break;

          case 5:
            var value = new proto.types.ChainInfo();
            reader.readMessage(value, proto.types.ChainInfo.deserializeBinaryFromReader);
            msg.setChainInfo(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.BlockchainStatus.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.BlockchainStatus.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.BlockchainStatus} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.BlockchainStatus.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getBestBlockHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getBestHeight();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }

      f = message.getConsensusInfo();

      if (f.length > 0) {
        writer.writeString(3, f);
      }

      f = message.getBestChainIdHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }

      f = message.getChainInfo();

      if (f != null) {
        writer.writeMessage(5, f, proto.types.ChainInfo.serializeBinaryToWriter);
      }
    };
    /**
     * optional bytes best_block_hash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockchainStatus.prototype.getBestBlockHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes best_block_hash = 1;
     * This is a type-conversion wrapper around `getBestBlockHash()`
     * @return {string}
     */


    proto.types.BlockchainStatus.prototype.getBestBlockHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBestBlockHash())
      );
    };
    /**
     * optional bytes best_block_hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBestBlockHash()`
     * @return {!Uint8Array}
     */


    proto.types.BlockchainStatus.prototype.getBestBlockHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBestBlockHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockchainStatus.prototype.setBestBlockHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 best_height = 2;
     * @return {number}
     */


    proto.types.BlockchainStatus.prototype.getBestHeight = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockchainStatus.prototype.setBestHeight = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional string consensus_info = 3;
     * @return {string}
     */


    proto.types.BlockchainStatus.prototype.getConsensusInfo = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.BlockchainStatus.prototype.setConsensusInfo = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * optional bytes best_chain_id_hash = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockchainStatus.prototype.getBestChainIdHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes best_chain_id_hash = 4;
     * This is a type-conversion wrapper around `getBestChainIdHash()`
     * @return {string}
     */


    proto.types.BlockchainStatus.prototype.getBestChainIdHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getBestChainIdHash())
      );
    };
    /**
     * optional bytes best_chain_id_hash = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBestChainIdHash()`
     * @return {!Uint8Array}
     */


    proto.types.BlockchainStatus.prototype.getBestChainIdHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getBestChainIdHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockchainStatus.prototype.setBestChainIdHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * optional ChainInfo chain_info = 5;
     * @return {?proto.types.ChainInfo}
     */


    proto.types.BlockchainStatus.prototype.getChainInfo = function () {
      return (
        /** @type{?proto.types.ChainInfo} */
        googleProtobuf.Message.getWrapperField(this, proto.types.ChainInfo, 5)
      );
    };
    /** @param {?proto.types.ChainInfo|undefined} value */


    proto.types.BlockchainStatus.prototype.setChainInfo = function (value) {
      googleProtobuf.Message.setWrapperField(this, 5, value);
    };

    proto.types.BlockchainStatus.prototype.clearChainInfo = function () {
      this.setChainInfo(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.BlockchainStatus.prototype.hasChainInfo = function () {
      return googleProtobuf.Message.getField(this, 5) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ChainId = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.ChainId, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ChainId.displayName = 'proto.types.ChainId';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ChainId.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ChainId.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ChainId} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ChainId.toObject = function (includeInstance, msg) {
        var obj = {
          magic: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          pb_public: googleProtobuf.Message.getFieldWithDefault(msg, 2, false),
          mainnet: googleProtobuf.Message.getFieldWithDefault(msg, 3, false),
          consensus: googleProtobuf.Message.getFieldWithDefault(msg, 4, ""),
          version: googleProtobuf.Message.getFieldWithDefault(msg, 5, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ChainId}
     */


    proto.types.ChainId.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ChainId();
      return proto.types.ChainId.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ChainId} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ChainId}
     */


    proto.types.ChainId.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setMagic(value);
            break;

          case 2:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setPublic(value);
            break;

          case 3:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setMainnet(value);
            break;

          case 4:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setConsensus(value);
            break;

          case 5:
            var value =
            /** @type {number} */
            reader.readInt32();
            msg.setVersion(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ChainId.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ChainId.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ChainId} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ChainId.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getMagic();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getPublic();

      if (f) {
        writer.writeBool(2, f);
      }

      f = message.getMainnet();

      if (f) {
        writer.writeBool(3, f);
      }

      f = message.getConsensus();

      if (f.length > 0) {
        writer.writeString(4, f);
      }

      f = message.getVersion();

      if (f !== 0) {
        writer.writeInt32(5, f);
      }
    };
    /**
     * optional string magic = 1;
     * @return {string}
     */


    proto.types.ChainId.prototype.getMagic = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.ChainId.prototype.setMagic = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional bool public = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.ChainId.prototype.getPublic = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, false)
      );
    };
    /** @param {boolean} value */


    proto.types.ChainId.prototype.setPublic = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 2, value);
    };
    /**
     * optional bool mainnet = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.ChainId.prototype.getMainnet = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, false)
      );
    };
    /** @param {boolean} value */


    proto.types.ChainId.prototype.setMainnet = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 3, value);
    };
    /**
     * optional string consensus = 4;
     * @return {string}
     */


    proto.types.ChainId.prototype.getConsensus = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /** @param {string} value */


    proto.types.ChainId.prototype.setConsensus = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 4, value);
    };
    /**
     * optional int32 version = 5;
     * @return {number}
     */


    proto.types.ChainId.prototype.getVersion = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    /** @param {number} value */


    proto.types.ChainId.prototype.setVersion = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 5, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ChainInfo = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.ChainInfo, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ChainInfo.displayName = 'proto.types.ChainInfo';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ChainInfo.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ChainInfo.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ChainInfo} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ChainInfo.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          id: (f = msg.getId()) && proto.types.ChainId.toObject(includeInstance, f),
          bpnumber: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          maxblocksize: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          maxtokens: msg.getMaxtokens_asB64(),
          stakingminimum: msg.getStakingminimum_asB64(),
          totalstaking: msg.getTotalstaking_asB64(),
          gasprice: msg.getGasprice_asB64(),
          nameprice: msg.getNameprice_asB64(),
          totalvotingpower: msg.getTotalvotingpower_asB64(),
          votingreward: msg.getVotingreward_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ChainInfo}
     */


    proto.types.ChainInfo.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ChainInfo();
      return proto.types.ChainInfo.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ChainInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ChainInfo}
     */


    proto.types.ChainInfo.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.ChainId();
            reader.readMessage(value, proto.types.ChainId.deserializeBinaryFromReader);
            msg.setId(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setBpnumber(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setMaxblocksize(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setMaxtokens(value);
            break;

          case 5:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setStakingminimum(value);
            break;

          case 6:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setTotalstaking(value);
            break;

          case 7:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setGasprice(value);
            break;

          case 8:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setNameprice(value);
            break;

          case 9:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setTotalvotingpower(value);
            break;

          case 10:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setVotingreward(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ChainInfo.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ChainInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ChainInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ChainInfo.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getId();

      if (f != null) {
        writer.writeMessage(1, f, proto.types.ChainId.serializeBinaryToWriter);
      }

      f = message.getBpnumber();

      if (f !== 0) {
        writer.writeUint32(2, f);
      }

      f = message.getMaxblocksize();

      if (f !== 0) {
        writer.writeUint64(3, f);
      }

      f = message.getMaxtokens_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }

      f = message.getStakingminimum_asU8();

      if (f.length > 0) {
        writer.writeBytes(5, f);
      }

      f = message.getTotalstaking_asU8();

      if (f.length > 0) {
        writer.writeBytes(6, f);
      }

      f = message.getGasprice_asU8();

      if (f.length > 0) {
        writer.writeBytes(7, f);
      }

      f = message.getNameprice_asU8();

      if (f.length > 0) {
        writer.writeBytes(8, f);
      }

      f = message.getTotalvotingpower_asU8();

      if (f.length > 0) {
        writer.writeBytes(9, f);
      }

      f = message.getVotingreward_asU8();

      if (f.length > 0) {
        writer.writeBytes(10, f);
      }
    };
    /**
     * optional ChainId id = 1;
     * @return {?proto.types.ChainId}
     */


    proto.types.ChainInfo.prototype.getId = function () {
      return (
        /** @type{?proto.types.ChainId} */
        googleProtobuf.Message.getWrapperField(this, proto.types.ChainId, 1)
      );
    };
    /** @param {?proto.types.ChainId|undefined} value */


    proto.types.ChainInfo.prototype.setId = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.ChainInfo.prototype.clearId = function () {
      this.setId(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.ChainInfo.prototype.hasId = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional uint32 bpNumber = 2;
     * @return {number}
     */


    proto.types.ChainInfo.prototype.getBpnumber = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.ChainInfo.prototype.setBpnumber = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional uint64 maxblocksize = 3;
     * @return {number}
     */


    proto.types.ChainInfo.prototype.getMaxblocksize = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.ChainInfo.prototype.setMaxblocksize = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional bytes maxtokens = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ChainInfo.prototype.getMaxtokens = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes maxtokens = 4;
     * This is a type-conversion wrapper around `getMaxtokens()`
     * @return {string}
     */


    proto.types.ChainInfo.prototype.getMaxtokens_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getMaxtokens())
      );
    };
    /**
     * optional bytes maxtokens = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMaxtokens()`
     * @return {!Uint8Array}
     */


    proto.types.ChainInfo.prototype.getMaxtokens_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getMaxtokens())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ChainInfo.prototype.setMaxtokens = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * optional bytes stakingminimum = 5;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ChainInfo.prototype.getStakingminimum = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, "")
      );
    };
    /**
     * optional bytes stakingminimum = 5;
     * This is a type-conversion wrapper around `getStakingminimum()`
     * @return {string}
     */


    proto.types.ChainInfo.prototype.getStakingminimum_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getStakingminimum())
      );
    };
    /**
     * optional bytes stakingminimum = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getStakingminimum()`
     * @return {!Uint8Array}
     */


    proto.types.ChainInfo.prototype.getStakingminimum_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getStakingminimum())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ChainInfo.prototype.setStakingminimum = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 5, value);
    };
    /**
     * optional bytes totalstaking = 6;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ChainInfo.prototype.getTotalstaking = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, "")
      );
    };
    /**
     * optional bytes totalstaking = 6;
     * This is a type-conversion wrapper around `getTotalstaking()`
     * @return {string}
     */


    proto.types.ChainInfo.prototype.getTotalstaking_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getTotalstaking())
      );
    };
    /**
     * optional bytes totalstaking = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTotalstaking()`
     * @return {!Uint8Array}
     */


    proto.types.ChainInfo.prototype.getTotalstaking_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getTotalstaking())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ChainInfo.prototype.setTotalstaking = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 6, value);
    };
    /**
     * optional bytes gasprice = 7;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ChainInfo.prototype.getGasprice = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, "")
      );
    };
    /**
     * optional bytes gasprice = 7;
     * This is a type-conversion wrapper around `getGasprice()`
     * @return {string}
     */


    proto.types.ChainInfo.prototype.getGasprice_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getGasprice())
      );
    };
    /**
     * optional bytes gasprice = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getGasprice()`
     * @return {!Uint8Array}
     */


    proto.types.ChainInfo.prototype.getGasprice_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getGasprice())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ChainInfo.prototype.setGasprice = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 7, value);
    };
    /**
     * optional bytes nameprice = 8;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ChainInfo.prototype.getNameprice = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 8, "")
      );
    };
    /**
     * optional bytes nameprice = 8;
     * This is a type-conversion wrapper around `getNameprice()`
     * @return {string}
     */


    proto.types.ChainInfo.prototype.getNameprice_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getNameprice())
      );
    };
    /**
     * optional bytes nameprice = 8;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getNameprice()`
     * @return {!Uint8Array}
     */


    proto.types.ChainInfo.prototype.getNameprice_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getNameprice())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ChainInfo.prototype.setNameprice = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 8, value);
    };
    /**
     * optional bytes totalvotingpower = 9;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ChainInfo.prototype.getTotalvotingpower = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 9, "")
      );
    };
    /**
     * optional bytes totalvotingpower = 9;
     * This is a type-conversion wrapper around `getTotalvotingpower()`
     * @return {string}
     */


    proto.types.ChainInfo.prototype.getTotalvotingpower_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getTotalvotingpower())
      );
    };
    /**
     * optional bytes totalvotingpower = 9;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTotalvotingpower()`
     * @return {!Uint8Array}
     */


    proto.types.ChainInfo.prototype.getTotalvotingpower_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getTotalvotingpower())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ChainInfo.prototype.setTotalvotingpower = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 9, value);
    };
    /**
     * optional bytes votingreward = 10;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ChainInfo.prototype.getVotingreward = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 10, "")
      );
    };
    /**
     * optional bytes votingreward = 10;
     * This is a type-conversion wrapper around `getVotingreward()`
     * @return {string}
     */


    proto.types.ChainInfo.prototype.getVotingreward_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getVotingreward())
      );
    };
    /**
     * optional bytes votingreward = 10;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getVotingreward()`
     * @return {!Uint8Array}
     */


    proto.types.ChainInfo.prototype.getVotingreward_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getVotingreward())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ChainInfo.prototype.setVotingreward = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 10, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ChainStats = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.ChainStats, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ChainStats.displayName = 'proto.types.ChainStats';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ChainStats.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ChainStats.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ChainStats} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ChainStats.toObject = function (includeInstance, msg) {
        var obj = {
          report: googleProtobuf.Message.getFieldWithDefault(msg, 1, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ChainStats}
     */


    proto.types.ChainStats.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ChainStats();
      return proto.types.ChainStats.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ChainStats} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ChainStats}
     */


    proto.types.ChainStats.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setReport(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ChainStats.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ChainStats.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ChainStats} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ChainStats.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getReport();

      if (f.length > 0) {
        writer.writeString(1, f);
      }
    };
    /**
     * optional string report = 1;
     * @return {string}
     */


    proto.types.ChainStats.prototype.getReport = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.ChainStats.prototype.setReport = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Input = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.Input.repeatedFields_, null);
    };

    goog.inherits(proto.types.Input, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Input.displayName = 'proto.types.Input';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.Input.repeatedFields_ = [2];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Input.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Input.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Input} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Input.toObject = function (includeInstance, msg) {
        var obj = {
          hash: msg.getHash_asB64(),
          addressList: msg.getAddressList_asB64(),
          value: msg.getValue_asB64(),
          script: msg.getScript_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Input}
     */


    proto.types.Input.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Input();
      return proto.types.Input.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Input} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Input}
     */


    proto.types.Input.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setHash(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.addAddress(value);
            break;

          case 3:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setValue(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setScript(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Input.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Input.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Input} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Input.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getAddressList_asU8();

      if (f.length > 0) {
        writer.writeRepeatedBytes(2, f);
      }

      f = message.getValue_asU8();

      if (f.length > 0) {
        writer.writeBytes(3, f);
      }

      f = message.getScript_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }
    };
    /**
     * optional bytes hash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Input.prototype.getHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes hash = 1;
     * This is a type-conversion wrapper around `getHash()`
     * @return {string}
     */


    proto.types.Input.prototype.getHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getHash())
      );
    };
    /**
     * optional bytes hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHash()`
     * @return {!Uint8Array}
     */


    proto.types.Input.prototype.getHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Input.prototype.setHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * repeated bytes address = 2;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */


    proto.types.Input.prototype.getAddressList = function () {
      return (
        /** @type {!(Array<!Uint8Array>|Array<string>)} */
        googleProtobuf.Message.getRepeatedField(this, 2)
      );
    };
    /**
     * repeated bytes address = 2;
     * This is a type-conversion wrapper around `getAddressList()`
     * @return {!Array<string>}
     */


    proto.types.Input.prototype.getAddressList_asB64 = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.bytesListAsB64(this.getAddressList())
      );
    };
    /**
     * repeated bytes address = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAddressList()`
     * @return {!Array<!Uint8Array>}
     */


    proto.types.Input.prototype.getAddressList_asU8 = function () {
      return (
        /** @type {!Array<!Uint8Array>} */
        googleProtobuf.Message.bytesListAsU8(this.getAddressList())
      );
    };
    /** @param {!(Array<!Uint8Array>|Array<string>)} value */


    proto.types.Input.prototype.setAddressList = function (value) {
      googleProtobuf.Message.setField(this, 2, value || []);
    };
    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */


    proto.types.Input.prototype.addAddress = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 2, value, opt_index);
    };

    proto.types.Input.prototype.clearAddressList = function () {
      this.setAddressList([]);
    };
    /**
     * optional bytes value = 3;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Input.prototype.getValue = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /**
     * optional bytes value = 3;
     * This is a type-conversion wrapper around `getValue()`
     * @return {string}
     */


    proto.types.Input.prototype.getValue_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getValue())
      );
    };
    /**
     * optional bytes value = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getValue()`
     * @return {!Uint8Array}
     */


    proto.types.Input.prototype.getValue_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getValue())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Input.prototype.setValue = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 3, value);
    };
    /**
     * optional bytes script = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Input.prototype.getScript = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes script = 4;
     * This is a type-conversion wrapper around `getScript()`
     * @return {string}
     */


    proto.types.Input.prototype.getScript_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getScript())
      );
    };
    /**
     * optional bytes script = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getScript()`
     * @return {!Uint8Array}
     */


    proto.types.Input.prototype.getScript_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getScript())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Input.prototype.setScript = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Output = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Output, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Output.displayName = 'proto.types.Output';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Output.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Output.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Output} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Output.toObject = function (includeInstance, msg) {
        var obj = {
          index: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          address: msg.getAddress_asB64(),
          value: msg.getValue_asB64(),
          script: msg.getScript_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Output}
     */


    proto.types.Output.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Output();
      return proto.types.Output.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Output} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Output}
     */


    proto.types.Output.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setIndex(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setAddress(value);
            break;

          case 3:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setValue(value);
            break;

          case 4:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setScript(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Output.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Output.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Output} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Output.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getIndex();

      if (f !== 0) {
        writer.writeUint32(1, f);
      }

      f = message.getAddress_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }

      f = message.getValue_asU8();

      if (f.length > 0) {
        writer.writeBytes(3, f);
      }

      f = message.getScript_asU8();

      if (f.length > 0) {
        writer.writeBytes(4, f);
      }
    };
    /**
     * optional uint32 index = 1;
     * @return {number}
     */


    proto.types.Output.prototype.getIndex = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {number} value */


    proto.types.Output.prototype.setIndex = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 1, value);
    };
    /**
     * optional bytes address = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Output.prototype.getAddress = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes address = 2;
     * This is a type-conversion wrapper around `getAddress()`
     * @return {string}
     */


    proto.types.Output.prototype.getAddress_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getAddress())
      );
    };
    /**
     * optional bytes address = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAddress()`
     * @return {!Uint8Array}
     */


    proto.types.Output.prototype.getAddress_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getAddress())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Output.prototype.setAddress = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * optional bytes value = 3;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Output.prototype.getValue = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /**
     * optional bytes value = 3;
     * This is a type-conversion wrapper around `getValue()`
     * @return {string}
     */


    proto.types.Output.prototype.getValue_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getValue())
      );
    };
    /**
     * optional bytes value = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getValue()`
     * @return {!Uint8Array}
     */


    proto.types.Output.prototype.getValue_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getValue())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Output.prototype.setValue = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 3, value);
    };
    /**
     * optional bytes script = 4;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Output.prototype.getScript = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, "")
      );
    };
    /**
     * optional bytes script = 4;
     * This is a type-conversion wrapper around `getScript()`
     * @return {string}
     */


    proto.types.Output.prototype.getScript_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getScript())
      );
    };
    /**
     * optional bytes script = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getScript()`
     * @return {!Uint8Array}
     */


    proto.types.Output.prototype.getScript_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getScript())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Output.prototype.setScript = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 4, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Empty = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Empty, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Empty.displayName = 'proto.types.Empty';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Empty.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Empty.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Empty} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Empty.toObject = function (includeInstance, msg) {
        var obj = {};

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Empty}
     */


    proto.types.Empty.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Empty();
      return proto.types.Empty.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Empty} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Empty}
     */


    proto.types.Empty.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Empty.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Empty.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Empty} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Empty.serializeBinaryToWriter = function (message, writer) {
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.SingleBytes = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.SingleBytes, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.SingleBytes.displayName = 'proto.types.SingleBytes';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.SingleBytes.prototype.toObject = function (opt_includeInstance) {
        return proto.types.SingleBytes.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.SingleBytes} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.SingleBytes.toObject = function (includeInstance, msg) {
        var obj = {
          value: msg.getValue_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.SingleBytes}
     */


    proto.types.SingleBytes.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.SingleBytes();
      return proto.types.SingleBytes.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.SingleBytes} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.SingleBytes}
     */


    proto.types.SingleBytes.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setValue(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.SingleBytes.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.SingleBytes.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.SingleBytes} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.SingleBytes.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getValue_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }
    };
    /**
     * optional bytes value = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.SingleBytes.prototype.getValue = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes value = 1;
     * This is a type-conversion wrapper around `getValue()`
     * @return {string}
     */


    proto.types.SingleBytes.prototype.getValue_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getValue())
      );
    };
    /**
     * optional bytes value = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getValue()`
     * @return {!Uint8Array}
     */


    proto.types.SingleBytes.prototype.getValue_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getValue())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.SingleBytes.prototype.setValue = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.SingleString = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.SingleString, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.SingleString.displayName = 'proto.types.SingleString';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.SingleString.prototype.toObject = function (opt_includeInstance) {
        return proto.types.SingleString.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.SingleString} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.SingleString.toObject = function (includeInstance, msg) {
        var obj = {
          value: googleProtobuf.Message.getFieldWithDefault(msg, 1, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.SingleString}
     */


    proto.types.SingleString.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.SingleString();
      return proto.types.SingleString.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.SingleString} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.SingleString}
     */


    proto.types.SingleString.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setValue(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.SingleString.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.SingleString.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.SingleString} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.SingleString.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getValue();

      if (f.length > 0) {
        writer.writeString(1, f);
      }
    };
    /**
     * optional string value = 1;
     * @return {string}
     */


    proto.types.SingleString.prototype.getValue = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.SingleString.prototype.setValue = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.AccountAddress = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.AccountAddress, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.AccountAddress.displayName = 'proto.types.AccountAddress';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.AccountAddress.prototype.toObject = function (opt_includeInstance) {
        return proto.types.AccountAddress.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.AccountAddress} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.AccountAddress.toObject = function (includeInstance, msg) {
        var obj = {
          value: msg.getValue_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.AccountAddress}
     */


    proto.types.AccountAddress.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.AccountAddress();
      return proto.types.AccountAddress.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.AccountAddress} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.AccountAddress}
     */


    proto.types.AccountAddress.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setValue(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.AccountAddress.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.AccountAddress.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.AccountAddress} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.AccountAddress.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getValue_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }
    };
    /**
     * optional bytes value = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AccountAddress.prototype.getValue = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes value = 1;
     * This is a type-conversion wrapper around `getValue()`
     * @return {string}
     */


    proto.types.AccountAddress.prototype.getValue_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getValue())
      );
    };
    /**
     * optional bytes value = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getValue()`
     * @return {!Uint8Array}
     */


    proto.types.AccountAddress.prototype.getValue_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getValue())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AccountAddress.prototype.setValue = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.AccountAndRoot = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.AccountAndRoot, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.AccountAndRoot.displayName = 'proto.types.AccountAndRoot';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.AccountAndRoot.prototype.toObject = function (opt_includeInstance) {
        return proto.types.AccountAndRoot.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.AccountAndRoot} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.AccountAndRoot.toObject = function (includeInstance, msg) {
        var obj = {
          account: msg.getAccount_asB64(),
          root: msg.getRoot_asB64(),
          compressed: googleProtobuf.Message.getFieldWithDefault(msg, 3, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.AccountAndRoot}
     */


    proto.types.AccountAndRoot.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.AccountAndRoot();
      return proto.types.AccountAndRoot.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.AccountAndRoot} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.AccountAndRoot}
     */


    proto.types.AccountAndRoot.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setAccount(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setRoot(value);
            break;

          case 3:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setCompressed(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.AccountAndRoot.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.AccountAndRoot.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.AccountAndRoot} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.AccountAndRoot.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getAccount_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getRoot_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }

      f = message.getCompressed();

      if (f) {
        writer.writeBool(3, f);
      }
    };
    /**
     * optional bytes Account = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AccountAndRoot.prototype.getAccount = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes Account = 1;
     * This is a type-conversion wrapper around `getAccount()`
     * @return {string}
     */


    proto.types.AccountAndRoot.prototype.getAccount_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getAccount())
      );
    };
    /**
     * optional bytes Account = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAccount()`
     * @return {!Uint8Array}
     */


    proto.types.AccountAndRoot.prototype.getAccount_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getAccount())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AccountAndRoot.prototype.setAccount = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional bytes Root = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.AccountAndRoot.prototype.getRoot = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes Root = 2;
     * This is a type-conversion wrapper around `getRoot()`
     * @return {string}
     */


    proto.types.AccountAndRoot.prototype.getRoot_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getRoot())
      );
    };
    /**
     * optional bytes Root = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getRoot()`
     * @return {!Uint8Array}
     */


    proto.types.AccountAndRoot.prototype.getRoot_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getRoot())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.AccountAndRoot.prototype.setRoot = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * optional bool Compressed = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.AccountAndRoot.prototype.getCompressed = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, false)
      );
    };
    /** @param {boolean} value */


    proto.types.AccountAndRoot.prototype.setCompressed = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Peer = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.Peer.repeatedFields_, null);
    };

    goog.inherits(proto.types.Peer, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Peer.displayName = 'proto.types.Peer';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.Peer.repeatedFields_ = [8];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Peer.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Peer.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Peer} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Peer.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          address: (f = msg.getAddress()) && node_pb.PeerAddress.toObject(includeInstance, f),
          bestblock: (f = msg.getBestblock()) && p2p_pb.NewBlockNotice.toObject(includeInstance, f),
          state: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          hidden: googleProtobuf.Message.getFieldWithDefault(msg, 4, false),
          lashcheck: googleProtobuf.Message.getFieldWithDefault(msg, 5, 0),
          selfpeer: googleProtobuf.Message.getFieldWithDefault(msg, 6, false),
          version: googleProtobuf.Message.getFieldWithDefault(msg, 7, ""),
          certificatesList: googleProtobuf.Message.toObjectList(msg.getCertificatesList(), node_pb.AgentCertificate.toObject, includeInstance),
          acceptedrole: googleProtobuf.Message.getFieldWithDefault(msg, 9, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Peer}
     */


    proto.types.Peer.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Peer();
      return proto.types.Peer.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Peer} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Peer}
     */


    proto.types.Peer.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new node_pb.PeerAddress();
            reader.readMessage(value, node_pb.PeerAddress.deserializeBinaryFromReader);
            msg.setAddress(value);
            break;

          case 2:
            var value = new p2p_pb.NewBlockNotice();
            reader.readMessage(value, p2p_pb.NewBlockNotice.deserializeBinaryFromReader);
            msg.setBestblock(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readInt32();
            msg.setState(value);
            break;

          case 4:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setHidden(value);
            break;

          case 5:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setLashcheck(value);
            break;

          case 6:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setSelfpeer(value);
            break;

          case 7:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setVersion(value);
            break;

          case 8:
            var value = new node_pb.AgentCertificate();
            reader.readMessage(value, node_pb.AgentCertificate.deserializeBinaryFromReader);
            msg.addCertificates(value);
            break;

          case 9:
            var value =
            /** @type {!proto.types.PeerRole} */
            reader.readEnum();
            msg.setAcceptedrole(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Peer.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Peer.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Peer} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Peer.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getAddress();

      if (f != null) {
        writer.writeMessage(1, f, node_pb.PeerAddress.serializeBinaryToWriter);
      }

      f = message.getBestblock();

      if (f != null) {
        writer.writeMessage(2, f, p2p_pb.NewBlockNotice.serializeBinaryToWriter);
      }

      f = message.getState();

      if (f !== 0) {
        writer.writeInt32(3, f);
      }

      f = message.getHidden();

      if (f) {
        writer.writeBool(4, f);
      }

      f = message.getLashcheck();

      if (f !== 0) {
        writer.writeInt64(5, f);
      }

      f = message.getSelfpeer();

      if (f) {
        writer.writeBool(6, f);
      }

      f = message.getVersion();

      if (f.length > 0) {
        writer.writeString(7, f);
      }

      f = message.getCertificatesList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(8, f, node_pb.AgentCertificate.serializeBinaryToWriter);
      }

      f = message.getAcceptedrole();

      if (f !== 0.0) {
        writer.writeEnum(9, f);
      }
    };
    /**
     * optional PeerAddress address = 1;
     * @return {?proto.types.PeerAddress}
     */


    proto.types.Peer.prototype.getAddress = function () {
      return (
        /** @type{?proto.types.PeerAddress} */
        googleProtobuf.Message.getWrapperField(this, node_pb.PeerAddress, 1)
      );
    };
    /** @param {?proto.types.PeerAddress|undefined} value */


    proto.types.Peer.prototype.setAddress = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.Peer.prototype.clearAddress = function () {
      this.setAddress(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.Peer.prototype.hasAddress = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional NewBlockNotice bestblock = 2;
     * @return {?proto.types.NewBlockNotice}
     */


    proto.types.Peer.prototype.getBestblock = function () {
      return (
        /** @type{?proto.types.NewBlockNotice} */
        googleProtobuf.Message.getWrapperField(this, p2p_pb.NewBlockNotice, 2)
      );
    };
    /** @param {?proto.types.NewBlockNotice|undefined} value */


    proto.types.Peer.prototype.setBestblock = function (value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };

    proto.types.Peer.prototype.clearBestblock = function () {
      this.setBestblock(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.Peer.prototype.hasBestblock = function () {
      return googleProtobuf.Message.getField(this, 2) != null;
    };
    /**
     * optional int32 state = 3;
     * @return {number}
     */


    proto.types.Peer.prototype.getState = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.Peer.prototype.setState = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional bool hidden = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.Peer.prototype.getHidden = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, false)
      );
    };
    /** @param {boolean} value */


    proto.types.Peer.prototype.setHidden = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 4, value);
    };
    /**
     * optional int64 lashCheck = 5;
     * @return {number}
     */


    proto.types.Peer.prototype.getLashcheck = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    /** @param {number} value */


    proto.types.Peer.prototype.setLashcheck = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 5, value);
    };
    /**
     * optional bool selfpeer = 6;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.Peer.prototype.getSelfpeer = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 6, false)
      );
    };
    /** @param {boolean} value */


    proto.types.Peer.prototype.setSelfpeer = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 6, value);
    };
    /**
     * optional string version = 7;
     * @return {string}
     */


    proto.types.Peer.prototype.getVersion = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 7, "")
      );
    };
    /** @param {string} value */


    proto.types.Peer.prototype.setVersion = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 7, value);
    };
    /**
     * repeated AgentCertificate certificates = 8;
     * @return {!Array<!proto.types.AgentCertificate>}
     */


    proto.types.Peer.prototype.getCertificatesList = function () {
      return (
        /** @type{!Array<!proto.types.AgentCertificate>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, node_pb.AgentCertificate, 8)
      );
    };
    /** @param {!Array<!proto.types.AgentCertificate>} value */


    proto.types.Peer.prototype.setCertificatesList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 8, value);
    };
    /**
     * @param {!proto.types.AgentCertificate=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.AgentCertificate}
     */


    proto.types.Peer.prototype.addCertificates = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.types.AgentCertificate, opt_index);
    };

    proto.types.Peer.prototype.clearCertificatesList = function () {
      this.setCertificatesList([]);
    };
    /**
     * optional PeerRole acceptedRole = 9;
     * @return {!proto.types.PeerRole}
     */


    proto.types.Peer.prototype.getAcceptedrole = function () {
      return (
        /** @type {!proto.types.PeerRole} */
        googleProtobuf.Message.getFieldWithDefault(this, 9, 0)
      );
    };
    /** @param {!proto.types.PeerRole} value */


    proto.types.Peer.prototype.setAcceptedrole = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 9, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.PeerList = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.PeerList.repeatedFields_, null);
    };

    goog.inherits(proto.types.PeerList, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.PeerList.displayName = 'proto.types.PeerList';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.PeerList.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.PeerList.prototype.toObject = function (opt_includeInstance) {
        return proto.types.PeerList.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.PeerList} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.PeerList.toObject = function (includeInstance, msg) {
        var obj = {
          peersList: googleProtobuf.Message.toObjectList(msg.getPeersList(), proto.types.Peer.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.PeerList}
     */


    proto.types.PeerList.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.PeerList();
      return proto.types.PeerList.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.PeerList} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.PeerList}
     */


    proto.types.PeerList.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.Peer();
            reader.readMessage(value, proto.types.Peer.deserializeBinaryFromReader);
            msg.addPeers(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.PeerList.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.PeerList.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.PeerList} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.PeerList.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getPeersList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, proto.types.Peer.serializeBinaryToWriter);
      }
    };
    /**
     * repeated Peer peers = 1;
     * @return {!Array<!proto.types.Peer>}
     */


    proto.types.PeerList.prototype.getPeersList = function () {
      return (
        /** @type{!Array<!proto.types.Peer>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.Peer, 1)
      );
    };
    /** @param {!Array<!proto.types.Peer>} value */


    proto.types.PeerList.prototype.setPeersList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.Peer=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Peer}
     */


    proto.types.PeerList.prototype.addPeers = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.Peer, opt_index);
    };

    proto.types.PeerList.prototype.clearPeersList = function () {
      this.setPeersList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ListParams = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.ListParams, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ListParams.displayName = 'proto.types.ListParams';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ListParams.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ListParams.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ListParams} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ListParams.toObject = function (includeInstance, msg) {
        var obj = {
          hash: msg.getHash_asB64(),
          height: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          size: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          offset: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0),
          asc: googleProtobuf.Message.getFieldWithDefault(msg, 5, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ListParams}
     */


    proto.types.ListParams.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ListParams();
      return proto.types.ListParams.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ListParams} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ListParams}
     */


    proto.types.ListParams.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setHash(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setHeight(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setSize(value);
            break;

          case 4:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setOffset(value);
            break;

          case 5:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setAsc(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ListParams.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ListParams.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ListParams} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ListParams.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getHeight();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }

      f = message.getSize();

      if (f !== 0) {
        writer.writeUint32(3, f);
      }

      f = message.getOffset();

      if (f !== 0) {
        writer.writeUint32(4, f);
      }

      f = message.getAsc();

      if (f) {
        writer.writeBool(5, f);
      }
    };
    /**
     * optional bytes hash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.ListParams.prototype.getHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes hash = 1;
     * This is a type-conversion wrapper around `getHash()`
     * @return {string}
     */


    proto.types.ListParams.prototype.getHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getHash())
      );
    };
    /**
     * optional bytes hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHash()`
     * @return {!Uint8Array}
     */


    proto.types.ListParams.prototype.getHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.ListParams.prototype.setHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 height = 2;
     * @return {number}
     */


    proto.types.ListParams.prototype.getHeight = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.ListParams.prototype.setHeight = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional uint32 size = 3;
     * @return {number}
     */


    proto.types.ListParams.prototype.getSize = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.ListParams.prototype.setSize = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional uint32 offset = 4;
     * @return {number}
     */


    proto.types.ListParams.prototype.getOffset = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    /** @param {number} value */


    proto.types.ListParams.prototype.setOffset = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 4, value);
    };
    /**
     * optional bool asc = 5;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.ListParams.prototype.getAsc = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 5, false)
      );
    };
    /** @param {boolean} value */


    proto.types.ListParams.prototype.setAsc = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 5, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.PageParams = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.PageParams, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.PageParams.displayName = 'proto.types.PageParams';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.PageParams.prototype.toObject = function (opt_includeInstance) {
        return proto.types.PageParams.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.PageParams} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.PageParams.toObject = function (includeInstance, msg) {
        var obj = {
          offset: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          size: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.PageParams}
     */


    proto.types.PageParams.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.PageParams();
      return proto.types.PageParams.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.PageParams} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.PageParams}
     */


    proto.types.PageParams.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setOffset(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setSize(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.PageParams.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.PageParams.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.PageParams} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.PageParams.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getOffset();

      if (f !== 0) {
        writer.writeUint32(1, f);
      }

      f = message.getSize();

      if (f !== 0) {
        writer.writeUint32(2, f);
      }
    };
    /**
     * optional uint32 offset = 1;
     * @return {number}
     */


    proto.types.PageParams.prototype.getOffset = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {number} value */


    proto.types.PageParams.prototype.setOffset = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 1, value);
    };
    /**
     * optional uint32 size = 2;
     * @return {number}
     */


    proto.types.PageParams.prototype.getSize = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.PageParams.prototype.setSize = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.BlockBodyPaged = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.BlockBodyPaged, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.BlockBodyPaged.displayName = 'proto.types.BlockBodyPaged';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.BlockBodyPaged.prototype.toObject = function (opt_includeInstance) {
        return proto.types.BlockBodyPaged.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.BlockBodyPaged} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.BlockBodyPaged.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          total: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
          offset: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          size: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          body: (f = msg.getBody()) && blockchain_pb.BlockBody.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.BlockBodyPaged}
     */


    proto.types.BlockBodyPaged.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.BlockBodyPaged();
      return proto.types.BlockBodyPaged.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.BlockBodyPaged} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.BlockBodyPaged}
     */


    proto.types.BlockBodyPaged.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setTotal(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setOffset(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setSize(value);
            break;

          case 4:
            var value = new blockchain_pb.BlockBody();
            reader.readMessage(value, blockchain_pb.BlockBody.deserializeBinaryFromReader);
            msg.setBody(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.BlockBodyPaged.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.BlockBodyPaged.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.BlockBodyPaged} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.BlockBodyPaged.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getTotal();

      if (f !== 0) {
        writer.writeUint32(1, f);
      }

      f = message.getOffset();

      if (f !== 0) {
        writer.writeUint32(2, f);
      }

      f = message.getSize();

      if (f !== 0) {
        writer.writeUint32(3, f);
      }

      f = message.getBody();

      if (f != null) {
        writer.writeMessage(4, f, blockchain_pb.BlockBody.serializeBinaryToWriter);
      }
    };
    /**
     * optional uint32 total = 1;
     * @return {number}
     */


    proto.types.BlockBodyPaged.prototype.getTotal = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockBodyPaged.prototype.setTotal = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 1, value);
    };
    /**
     * optional uint32 offset = 2;
     * @return {number}
     */


    proto.types.BlockBodyPaged.prototype.getOffset = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockBodyPaged.prototype.setOffset = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * optional uint32 size = 3;
     * @return {number}
     */


    proto.types.BlockBodyPaged.prototype.getSize = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockBodyPaged.prototype.setSize = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional BlockBody body = 4;
     * @return {?proto.types.BlockBody}
     */


    proto.types.BlockBodyPaged.prototype.getBody = function () {
      return (
        /** @type{?proto.types.BlockBody} */
        googleProtobuf.Message.getWrapperField(this, blockchain_pb.BlockBody, 4)
      );
    };
    /** @param {?proto.types.BlockBody|undefined} value */


    proto.types.BlockBodyPaged.prototype.setBody = function (value) {
      googleProtobuf.Message.setWrapperField(this, 4, value);
    };

    proto.types.BlockBodyPaged.prototype.clearBody = function () {
      this.setBody(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.BlockBodyPaged.prototype.hasBody = function () {
      return googleProtobuf.Message.getField(this, 4) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.BlockBodyParams = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.BlockBodyParams, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.BlockBodyParams.displayName = 'proto.types.BlockBodyParams';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.BlockBodyParams.prototype.toObject = function (opt_includeInstance) {
        return proto.types.BlockBodyParams.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.BlockBodyParams} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.BlockBodyParams.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          hashornumber: msg.getHashornumber_asB64(),
          paging: (f = msg.getPaging()) && proto.types.PageParams.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.BlockBodyParams}
     */


    proto.types.BlockBodyParams.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.BlockBodyParams();
      return proto.types.BlockBodyParams.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.BlockBodyParams} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.BlockBodyParams}
     */


    proto.types.BlockBodyParams.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setHashornumber(value);
            break;

          case 2:
            var value = new proto.types.PageParams();
            reader.readMessage(value, proto.types.PageParams.deserializeBinaryFromReader);
            msg.setPaging(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.BlockBodyParams.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.BlockBodyParams.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.BlockBodyParams} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.BlockBodyParams.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHashornumber_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getPaging();

      if (f != null) {
        writer.writeMessage(2, f, proto.types.PageParams.serializeBinaryToWriter);
      }
    };
    /**
     * optional bytes hashornumber = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockBodyParams.prototype.getHashornumber = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes hashornumber = 1;
     * This is a type-conversion wrapper around `getHashornumber()`
     * @return {string}
     */


    proto.types.BlockBodyParams.prototype.getHashornumber_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getHashornumber())
      );
    };
    /**
     * optional bytes hashornumber = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHashornumber()`
     * @return {!Uint8Array}
     */


    proto.types.BlockBodyParams.prototype.getHashornumber_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getHashornumber())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockBodyParams.prototype.setHashornumber = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional PageParams paging = 2;
     * @return {?proto.types.PageParams}
     */


    proto.types.BlockBodyParams.prototype.getPaging = function () {
      return (
        /** @type{?proto.types.PageParams} */
        googleProtobuf.Message.getWrapperField(this, proto.types.PageParams, 2)
      );
    };
    /** @param {?proto.types.PageParams|undefined} value */


    proto.types.BlockBodyParams.prototype.setPaging = function (value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };

    proto.types.BlockBodyParams.prototype.clearPaging = function () {
      this.setPaging(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.BlockBodyParams.prototype.hasPaging = function () {
      return googleProtobuf.Message.getField(this, 2) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.BlockHeaderList = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.BlockHeaderList.repeatedFields_, null);
    };

    goog.inherits(proto.types.BlockHeaderList, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.BlockHeaderList.displayName = 'proto.types.BlockHeaderList';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.BlockHeaderList.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.BlockHeaderList.prototype.toObject = function (opt_includeInstance) {
        return proto.types.BlockHeaderList.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.BlockHeaderList} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.BlockHeaderList.toObject = function (includeInstance, msg) {
        var obj = {
          blocksList: googleProtobuf.Message.toObjectList(msg.getBlocksList(), blockchain_pb.Block.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.BlockHeaderList}
     */


    proto.types.BlockHeaderList.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.BlockHeaderList();
      return proto.types.BlockHeaderList.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.BlockHeaderList} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.BlockHeaderList}
     */


    proto.types.BlockHeaderList.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new blockchain_pb.Block();
            reader.readMessage(value, blockchain_pb.Block.deserializeBinaryFromReader);
            msg.addBlocks(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.BlockHeaderList.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.BlockHeaderList.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.BlockHeaderList} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.BlockHeaderList.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getBlocksList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, blockchain_pb.Block.serializeBinaryToWriter);
      }
    };
    /**
     * repeated Block blocks = 1;
     * @return {!Array<!proto.types.Block>}
     */


    proto.types.BlockHeaderList.prototype.getBlocksList = function () {
      return (
        /** @type{!Array<!proto.types.Block>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, blockchain_pb.Block, 1)
      );
    };
    /** @param {!Array<!proto.types.Block>} value */


    proto.types.BlockHeaderList.prototype.setBlocksList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.Block=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Block}
     */


    proto.types.BlockHeaderList.prototype.addBlocks = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.Block, opt_index);
    };

    proto.types.BlockHeaderList.prototype.clearBlocksList = function () {
      this.setBlocksList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.BlockMetadata = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.BlockMetadata, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.BlockMetadata.displayName = 'proto.types.BlockMetadata';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.BlockMetadata.prototype.toObject = function (opt_includeInstance) {
        return proto.types.BlockMetadata.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.BlockMetadata} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.BlockMetadata.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          hash: msg.getHash_asB64(),
          header: (f = msg.getHeader()) && blockchain_pb.BlockHeader.toObject(includeInstance, f),
          txcount: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
          size: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.BlockMetadata}
     */


    proto.types.BlockMetadata.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.BlockMetadata();
      return proto.types.BlockMetadata.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.BlockMetadata} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.BlockMetadata}
     */


    proto.types.BlockMetadata.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setHash(value);
            break;

          case 2:
            var value = new blockchain_pb.BlockHeader();
            reader.readMessage(value, blockchain_pb.BlockHeader.deserializeBinaryFromReader);
            msg.setHeader(value);
            break;

          case 3:
            var value =
            /** @type {number} */
            reader.readInt32();
            msg.setTxcount(value);
            break;

          case 4:
            var value =
            /** @type {number} */
            reader.readInt64();
            msg.setSize(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.BlockMetadata.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.BlockMetadata.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.BlockMetadata} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.BlockMetadata.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getHeader();

      if (f != null) {
        writer.writeMessage(2, f, blockchain_pb.BlockHeader.serializeBinaryToWriter);
      }

      f = message.getTxcount();

      if (f !== 0) {
        writer.writeInt32(3, f);
      }

      f = message.getSize();

      if (f !== 0) {
        writer.writeInt64(4, f);
      }
    };
    /**
     * optional bytes hash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.BlockMetadata.prototype.getHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes hash = 1;
     * This is a type-conversion wrapper around `getHash()`
     * @return {string}
     */


    proto.types.BlockMetadata.prototype.getHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getHash())
      );
    };
    /**
     * optional bytes hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHash()`
     * @return {!Uint8Array}
     */


    proto.types.BlockMetadata.prototype.getHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.BlockMetadata.prototype.setHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional BlockHeader header = 2;
     * @return {?proto.types.BlockHeader}
     */


    proto.types.BlockMetadata.prototype.getHeader = function () {
      return (
        /** @type{?proto.types.BlockHeader} */
        googleProtobuf.Message.getWrapperField(this, blockchain_pb.BlockHeader, 2)
      );
    };
    /** @param {?proto.types.BlockHeader|undefined} value */


    proto.types.BlockMetadata.prototype.setHeader = function (value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };

    proto.types.BlockMetadata.prototype.clearHeader = function () {
      this.setHeader(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.BlockMetadata.prototype.hasHeader = function () {
      return googleProtobuf.Message.getField(this, 2) != null;
    };
    /**
     * optional int32 txcount = 3;
     * @return {number}
     */


    proto.types.BlockMetadata.prototype.getTxcount = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockMetadata.prototype.setTxcount = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 3, value);
    };
    /**
     * optional int64 size = 4;
     * @return {number}
     */


    proto.types.BlockMetadata.prototype.getSize = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    /** @param {number} value */


    proto.types.BlockMetadata.prototype.setSize = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 4, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.BlockMetadataList = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.BlockMetadataList.repeatedFields_, null);
    };

    goog.inherits(proto.types.BlockMetadataList, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.BlockMetadataList.displayName = 'proto.types.BlockMetadataList';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.BlockMetadataList.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.BlockMetadataList.prototype.toObject = function (opt_includeInstance) {
        return proto.types.BlockMetadataList.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.BlockMetadataList} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.BlockMetadataList.toObject = function (includeInstance, msg) {
        var obj = {
          blocksList: googleProtobuf.Message.toObjectList(msg.getBlocksList(), proto.types.BlockMetadata.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.BlockMetadataList}
     */


    proto.types.BlockMetadataList.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.BlockMetadataList();
      return proto.types.BlockMetadataList.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.BlockMetadataList} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.BlockMetadataList}
     */


    proto.types.BlockMetadataList.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.BlockMetadata();
            reader.readMessage(value, proto.types.BlockMetadata.deserializeBinaryFromReader);
            msg.addBlocks(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.BlockMetadataList.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.BlockMetadataList.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.BlockMetadataList} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.BlockMetadataList.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getBlocksList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, proto.types.BlockMetadata.serializeBinaryToWriter);
      }
    };
    /**
     * repeated BlockMetadata blocks = 1;
     * @return {!Array<!proto.types.BlockMetadata>}
     */


    proto.types.BlockMetadataList.prototype.getBlocksList = function () {
      return (
        /** @type{!Array<!proto.types.BlockMetadata>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.BlockMetadata, 1)
      );
    };
    /** @param {!Array<!proto.types.BlockMetadata>} value */


    proto.types.BlockMetadataList.prototype.setBlocksList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.BlockMetadata=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.BlockMetadata}
     */


    proto.types.BlockMetadataList.prototype.addBlocks = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.BlockMetadata, opt_index);
    };

    proto.types.BlockMetadataList.prototype.clearBlocksList = function () {
      this.setBlocksList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.CommitResult = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.CommitResult, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.CommitResult.displayName = 'proto.types.CommitResult';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.CommitResult.prototype.toObject = function (opt_includeInstance) {
        return proto.types.CommitResult.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.CommitResult} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.CommitResult.toObject = function (includeInstance, msg) {
        var obj = {
          hash: msg.getHash_asB64(),
          error: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0),
          detail: googleProtobuf.Message.getFieldWithDefault(msg, 3, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.CommitResult}
     */


    proto.types.CommitResult.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.CommitResult();
      return proto.types.CommitResult.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.CommitResult} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.CommitResult}
     */


    proto.types.CommitResult.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setHash(value);
            break;

          case 2:
            var value =
            /** @type {!proto.types.CommitStatus} */
            reader.readEnum();
            msg.setError(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setDetail(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.CommitResult.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.CommitResult.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.CommitResult} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.CommitResult.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getHash_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getError();

      if (f !== 0.0) {
        writer.writeEnum(2, f);
      }

      f = message.getDetail();

      if (f.length > 0) {
        writer.writeString(3, f);
      }
    };
    /**
     * optional bytes hash = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.CommitResult.prototype.getHash = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes hash = 1;
     * This is a type-conversion wrapper around `getHash()`
     * @return {string}
     */


    proto.types.CommitResult.prototype.getHash_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getHash())
      );
    };
    /**
     * optional bytes hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHash()`
     * @return {!Uint8Array}
     */


    proto.types.CommitResult.prototype.getHash_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getHash())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.CommitResult.prototype.setHash = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional CommitStatus error = 2;
     * @return {!proto.types.CommitStatus}
     */


    proto.types.CommitResult.prototype.getError = function () {
      return (
        /** @type {!proto.types.CommitStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {!proto.types.CommitStatus} value */


    proto.types.CommitResult.prototype.setError = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 2, value);
    };
    /**
     * optional string detail = 3;
     * @return {string}
     */


    proto.types.CommitResult.prototype.getDetail = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.CommitResult.prototype.setDetail = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.CommitResultList = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.CommitResultList.repeatedFields_, null);
    };

    goog.inherits(proto.types.CommitResultList, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.CommitResultList.displayName = 'proto.types.CommitResultList';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.CommitResultList.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.CommitResultList.prototype.toObject = function (opt_includeInstance) {
        return proto.types.CommitResultList.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.CommitResultList} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.CommitResultList.toObject = function (includeInstance, msg) {
        var obj = {
          resultsList: googleProtobuf.Message.toObjectList(msg.getResultsList(), proto.types.CommitResult.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.CommitResultList}
     */


    proto.types.CommitResultList.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.CommitResultList();
      return proto.types.CommitResultList.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.CommitResultList} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.CommitResultList}
     */


    proto.types.CommitResultList.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.CommitResult();
            reader.readMessage(value, proto.types.CommitResult.deserializeBinaryFromReader);
            msg.addResults(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.CommitResultList.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.CommitResultList.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.CommitResultList} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.CommitResultList.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getResultsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, proto.types.CommitResult.serializeBinaryToWriter);
      }
    };
    /**
     * repeated CommitResult results = 1;
     * @return {!Array<!proto.types.CommitResult>}
     */


    proto.types.CommitResultList.prototype.getResultsList = function () {
      return (
        /** @type{!Array<!proto.types.CommitResult>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.CommitResult, 1)
      );
    };
    /** @param {!Array<!proto.types.CommitResult>} value */


    proto.types.CommitResultList.prototype.setResultsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.CommitResult=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.CommitResult}
     */


    proto.types.CommitResultList.prototype.addResults = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.CommitResult, opt_index);
    };

    proto.types.CommitResultList.prototype.clearResultsList = function () {
      this.setResultsList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.VerifyResult = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.VerifyResult, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.VerifyResult.displayName = 'proto.types.VerifyResult';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.VerifyResult.prototype.toObject = function (opt_includeInstance) {
        return proto.types.VerifyResult.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.VerifyResult} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.VerifyResult.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          tx: (f = msg.getTx()) && blockchain_pb.Tx.toObject(includeInstance, f),
          error: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.VerifyResult}
     */


    proto.types.VerifyResult.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.VerifyResult();
      return proto.types.VerifyResult.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.VerifyResult} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.VerifyResult}
     */


    proto.types.VerifyResult.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new blockchain_pb.Tx();
            reader.readMessage(value, blockchain_pb.Tx.deserializeBinaryFromReader);
            msg.setTx(value);
            break;

          case 2:
            var value =
            /** @type {!proto.types.VerifyStatus} */
            reader.readEnum();
            msg.setError(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.VerifyResult.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.VerifyResult.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.VerifyResult} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.VerifyResult.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getTx();

      if (f != null) {
        writer.writeMessage(1, f, blockchain_pb.Tx.serializeBinaryToWriter);
      }

      f = message.getError();

      if (f !== 0.0) {
        writer.writeEnum(2, f);
      }
    };
    /**
     * optional Tx tx = 1;
     * @return {?proto.types.Tx}
     */


    proto.types.VerifyResult.prototype.getTx = function () {
      return (
        /** @type{?proto.types.Tx} */
        googleProtobuf.Message.getWrapperField(this, blockchain_pb.Tx, 1)
      );
    };
    /** @param {?proto.types.Tx|undefined} value */


    proto.types.VerifyResult.prototype.setTx = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.VerifyResult.prototype.clearTx = function () {
      this.setTx(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.VerifyResult.prototype.hasTx = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional VerifyStatus error = 2;
     * @return {!proto.types.VerifyStatus}
     */


    proto.types.VerifyResult.prototype.getError = function () {
      return (
        /** @type {!proto.types.VerifyStatus} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {!proto.types.VerifyStatus} value */


    proto.types.VerifyResult.prototype.setError = function (value) {
      googleProtobuf.Message.setProto3EnumField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Personal = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Personal, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Personal.displayName = 'proto.types.Personal';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Personal.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Personal.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Personal} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Personal.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          passphrase: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          account: (f = msg.getAccount()) && account_pb.Account.toObject(includeInstance, f)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Personal}
     */


    proto.types.Personal.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Personal();
      return proto.types.Personal.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Personal} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Personal}
     */


    proto.types.Personal.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setPassphrase(value);
            break;

          case 2:
            var value = new account_pb.Account();
            reader.readMessage(value, account_pb.Account.deserializeBinaryFromReader);
            msg.setAccount(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Personal.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Personal.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Personal} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Personal.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getPassphrase();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getAccount();

      if (f != null) {
        writer.writeMessage(2, f, account_pb.Account.serializeBinaryToWriter);
      }
    };
    /**
     * optional string passphrase = 1;
     * @return {string}
     */


    proto.types.Personal.prototype.getPassphrase = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.Personal.prototype.setPassphrase = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional Account account = 2;
     * @return {?proto.types.Account}
     */


    proto.types.Personal.prototype.getAccount = function () {
      return (
        /** @type{?proto.types.Account} */
        googleProtobuf.Message.getWrapperField(this, account_pb.Account, 2)
      );
    };
    /** @param {?proto.types.Account|undefined} value */


    proto.types.Personal.prototype.setAccount = function (value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };

    proto.types.Personal.prototype.clearAccount = function () {
      this.setAccount(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.Personal.prototype.hasAccount = function () {
      return googleProtobuf.Message.getField(this, 2) != null;
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ImportFormat = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.ImportFormat, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ImportFormat.displayName = 'proto.types.ImportFormat';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ImportFormat.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ImportFormat.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ImportFormat} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ImportFormat.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          wif: (f = msg.getWif()) && proto.types.SingleBytes.toObject(includeInstance, f),
          oldpass: googleProtobuf.Message.getFieldWithDefault(msg, 2, ""),
          newpass: googleProtobuf.Message.getFieldWithDefault(msg, 3, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ImportFormat}
     */


    proto.types.ImportFormat.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ImportFormat();
      return proto.types.ImportFormat.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ImportFormat} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ImportFormat}
     */


    proto.types.ImportFormat.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.SingleBytes();
            reader.readMessage(value, proto.types.SingleBytes.deserializeBinaryFromReader);
            msg.setWif(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setOldpass(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setNewpass(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ImportFormat.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ImportFormat.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ImportFormat} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ImportFormat.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getWif();

      if (f != null) {
        writer.writeMessage(1, f, proto.types.SingleBytes.serializeBinaryToWriter);
      }

      f = message.getOldpass();

      if (f.length > 0) {
        writer.writeString(2, f);
      }

      f = message.getNewpass();

      if (f.length > 0) {
        writer.writeString(3, f);
      }
    };
    /**
     * optional SingleBytes wif = 1;
     * @return {?proto.types.SingleBytes}
     */


    proto.types.ImportFormat.prototype.getWif = function () {
      return (
        /** @type{?proto.types.SingleBytes} */
        googleProtobuf.Message.getWrapperField(this, proto.types.SingleBytes, 1)
      );
    };
    /** @param {?proto.types.SingleBytes|undefined} value */


    proto.types.ImportFormat.prototype.setWif = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.ImportFormat.prototype.clearWif = function () {
      this.setWif(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.ImportFormat.prototype.hasWif = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional string oldpass = 2;
     * @return {string}
     */


    proto.types.ImportFormat.prototype.getOldpass = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.ImportFormat.prototype.setOldpass = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * optional string newpass = 3;
     * @return {string}
     */


    proto.types.ImportFormat.prototype.getNewpass = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.ImportFormat.prototype.setNewpass = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Staking = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Staking, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Staking.displayName = 'proto.types.Staking';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Staking.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Staking.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Staking} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Staking.toObject = function (includeInstance, msg) {
        var obj = {
          amount: msg.getAmount_asB64(),
          when: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Staking}
     */


    proto.types.Staking.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Staking();
      return proto.types.Staking.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Staking} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Staking}
     */


    proto.types.Staking.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setAmount(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setWhen(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Staking.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Staking.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Staking} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Staking.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getAmount_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getWhen();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }
    };
    /**
     * optional bytes amount = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Staking.prototype.getAmount = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes amount = 1;
     * This is a type-conversion wrapper around `getAmount()`
     * @return {string}
     */


    proto.types.Staking.prototype.getAmount_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getAmount())
      );
    };
    /**
     * optional bytes amount = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAmount()`
     * @return {!Uint8Array}
     */


    proto.types.Staking.prototype.getAmount_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getAmount())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Staking.prototype.setAmount = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional uint64 when = 2;
     * @return {number}
     */


    proto.types.Staking.prototype.getWhen = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.Staking.prototype.setWhen = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Vote = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Vote, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Vote.displayName = 'proto.types.Vote';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Vote.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Vote.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Vote} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Vote.toObject = function (includeInstance, msg) {
        var obj = {
          candidate: msg.getCandidate_asB64(),
          amount: msg.getAmount_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Vote}
     */


    proto.types.Vote.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Vote();
      return proto.types.Vote.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Vote} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Vote}
     */


    proto.types.Vote.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setCandidate(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setAmount(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Vote.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Vote.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Vote} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Vote.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getCandidate_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getAmount_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }
    };
    /**
     * optional bytes candidate = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Vote.prototype.getCandidate = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes candidate = 1;
     * This is a type-conversion wrapper around `getCandidate()`
     * @return {string}
     */


    proto.types.Vote.prototype.getCandidate_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getCandidate())
      );
    };
    /**
     * optional bytes candidate = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getCandidate()`
     * @return {!Uint8Array}
     */


    proto.types.Vote.prototype.getCandidate_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getCandidate())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Vote.prototype.setCandidate = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional bytes amount = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.Vote.prototype.getAmount = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes amount = 2;
     * This is a type-conversion wrapper around `getAmount()`
     * @return {string}
     */


    proto.types.Vote.prototype.getAmount_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getAmount())
      );
    };
    /**
     * optional bytes amount = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAmount()`
     * @return {!Uint8Array}
     */


    proto.types.Vote.prototype.getAmount_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getAmount())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.Vote.prototype.setAmount = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.VoteParams = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.VoteParams, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.VoteParams.displayName = 'proto.types.VoteParams';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.VoteParams.prototype.toObject = function (opt_includeInstance) {
        return proto.types.VoteParams.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.VoteParams} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.VoteParams.toObject = function (includeInstance, msg) {
        var obj = {
          id: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          count: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.VoteParams}
     */


    proto.types.VoteParams.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.VoteParams();
      return proto.types.VoteParams.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.VoteParams} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.VoteParams}
     */


    proto.types.VoteParams.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setId(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint32();
            msg.setCount(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.VoteParams.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.VoteParams.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.VoteParams} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.VoteParams.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getId();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getCount();

      if (f !== 0) {
        writer.writeUint32(2, f);
      }
    };
    /**
     * optional string id = 1;
     * @return {string}
     */


    proto.types.VoteParams.prototype.getId = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.VoteParams.prototype.setId = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional uint32 count = 2;
     * @return {number}
     */


    proto.types.VoteParams.prototype.getCount = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.VoteParams.prototype.setCount = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.AccountVoteInfo = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.AccountVoteInfo.repeatedFields_, null);
    };

    goog.inherits(proto.types.AccountVoteInfo, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.AccountVoteInfo.displayName = 'proto.types.AccountVoteInfo';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.AccountVoteInfo.repeatedFields_ = [2];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.AccountVoteInfo.prototype.toObject = function (opt_includeInstance) {
        return proto.types.AccountVoteInfo.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.AccountVoteInfo} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.AccountVoteInfo.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          staking: (f = msg.getStaking()) && proto.types.Staking.toObject(includeInstance, f),
          votingList: googleProtobuf.Message.toObjectList(msg.getVotingList(), proto.types.VoteInfo.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.AccountVoteInfo}
     */


    proto.types.AccountVoteInfo.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.AccountVoteInfo();
      return proto.types.AccountVoteInfo.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.AccountVoteInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.AccountVoteInfo}
     */


    proto.types.AccountVoteInfo.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.Staking();
            reader.readMessage(value, proto.types.Staking.deserializeBinaryFromReader);
            msg.setStaking(value);
            break;

          case 2:
            var value = new proto.types.VoteInfo();
            reader.readMessage(value, proto.types.VoteInfo.deserializeBinaryFromReader);
            msg.addVoting(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.AccountVoteInfo.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.AccountVoteInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.AccountVoteInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.AccountVoteInfo.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStaking();

      if (f != null) {
        writer.writeMessage(1, f, proto.types.Staking.serializeBinaryToWriter);
      }

      f = message.getVotingList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(2, f, proto.types.VoteInfo.serializeBinaryToWriter);
      }
    };
    /**
     * optional Staking staking = 1;
     * @return {?proto.types.Staking}
     */


    proto.types.AccountVoteInfo.prototype.getStaking = function () {
      return (
        /** @type{?proto.types.Staking} */
        googleProtobuf.Message.getWrapperField(this, proto.types.Staking, 1)
      );
    };
    /** @param {?proto.types.Staking|undefined} value */


    proto.types.AccountVoteInfo.prototype.setStaking = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.AccountVoteInfo.prototype.clearStaking = function () {
      this.setStaking(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.AccountVoteInfo.prototype.hasStaking = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * repeated VoteInfo voting = 2;
     * @return {!Array<!proto.types.VoteInfo>}
     */


    proto.types.AccountVoteInfo.prototype.getVotingList = function () {
      return (
        /** @type{!Array<!proto.types.VoteInfo>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.VoteInfo, 2)
      );
    };
    /** @param {!Array<!proto.types.VoteInfo>} value */


    proto.types.AccountVoteInfo.prototype.setVotingList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };
    /**
     * @param {!proto.types.VoteInfo=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.VoteInfo}
     */


    proto.types.AccountVoteInfo.prototype.addVoting = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.types.VoteInfo, opt_index);
    };

    proto.types.AccountVoteInfo.prototype.clearVotingList = function () {
      this.setVotingList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.VoteInfo = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.VoteInfo.repeatedFields_, null);
    };

    goog.inherits(proto.types.VoteInfo, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.VoteInfo.displayName = 'proto.types.VoteInfo';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.VoteInfo.repeatedFields_ = [2];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.VoteInfo.prototype.toObject = function (opt_includeInstance) {
        return proto.types.VoteInfo.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.VoteInfo} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.VoteInfo.toObject = function (includeInstance, msg) {
        var obj = {
          id: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          candidatesList: googleProtobuf.Message.getRepeatedField(msg, 2),
          amount: googleProtobuf.Message.getFieldWithDefault(msg, 3, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.VoteInfo}
     */


    proto.types.VoteInfo.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.VoteInfo();
      return proto.types.VoteInfo.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.VoteInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.VoteInfo}
     */


    proto.types.VoteInfo.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setId(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.addCandidates(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setAmount(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.VoteInfo.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.VoteInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.VoteInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.VoteInfo.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getId();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getCandidatesList();

      if (f.length > 0) {
        writer.writeRepeatedString(2, f);
      }

      f = message.getAmount();

      if (f.length > 0) {
        writer.writeString(3, f);
      }
    };
    /**
     * optional string id = 1;
     * @return {string}
     */


    proto.types.VoteInfo.prototype.getId = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.VoteInfo.prototype.setId = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * repeated string candidates = 2;
     * @return {!Array<string>}
     */


    proto.types.VoteInfo.prototype.getCandidatesList = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.getRepeatedField(this, 2)
      );
    };
    /** @param {!Array<string>} value */


    proto.types.VoteInfo.prototype.setCandidatesList = function (value) {
      googleProtobuf.Message.setField(this, 2, value || []);
    };
    /**
     * @param {string} value
     * @param {number=} opt_index
     */


    proto.types.VoteInfo.prototype.addCandidates = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 2, value, opt_index);
    };

    proto.types.VoteInfo.prototype.clearCandidatesList = function () {
      this.setCandidatesList([]);
    };
    /**
     * optional string amount = 3;
     * @return {string}
     */


    proto.types.VoteInfo.prototype.getAmount = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /** @param {string} value */


    proto.types.VoteInfo.prototype.setAmount = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.VoteList = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.VoteList.repeatedFields_, null);
    };

    goog.inherits(proto.types.VoteList, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.VoteList.displayName = 'proto.types.VoteList';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.VoteList.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.VoteList.prototype.toObject = function (opt_includeInstance) {
        return proto.types.VoteList.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.VoteList} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.VoteList.toObject = function (includeInstance, msg) {
        var obj = {
          votesList: googleProtobuf.Message.toObjectList(msg.getVotesList(), proto.types.Vote.toObject, includeInstance),
          id: googleProtobuf.Message.getFieldWithDefault(msg, 2, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.VoteList}
     */


    proto.types.VoteList.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.VoteList();
      return proto.types.VoteList.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.VoteList} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.VoteList}
     */


    proto.types.VoteList.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.Vote();
            reader.readMessage(value, proto.types.Vote.deserializeBinaryFromReader);
            msg.addVotes(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setId(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.VoteList.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.VoteList.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.VoteList} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.VoteList.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getVotesList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, proto.types.Vote.serializeBinaryToWriter);
      }

      f = message.getId();

      if (f.length > 0) {
        writer.writeString(2, f);
      }
    };
    /**
     * repeated Vote votes = 1;
     * @return {!Array<!proto.types.Vote>}
     */


    proto.types.VoteList.prototype.getVotesList = function () {
      return (
        /** @type{!Array<!proto.types.Vote>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.types.Vote, 1)
      );
    };
    /** @param {!Array<!proto.types.Vote>} value */


    proto.types.VoteList.prototype.setVotesList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.Vote=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Vote}
     */


    proto.types.VoteList.prototype.addVotes = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.Vote, opt_index);
    };

    proto.types.VoteList.prototype.clearVotesList = function () {
      this.setVotesList([]);
    };
    /**
     * optional string id = 2;
     * @return {string}
     */


    proto.types.VoteList.prototype.getId = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.VoteList.prototype.setId = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.NodeReq = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.NodeReq, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.NodeReq.displayName = 'proto.types.NodeReq';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.NodeReq.prototype.toObject = function (opt_includeInstance) {
        return proto.types.NodeReq.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.NodeReq} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.NodeReq.toObject = function (includeInstance, msg) {
        var obj = {
          timeout: msg.getTimeout_asB64(),
          component: msg.getComponent_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.NodeReq}
     */


    proto.types.NodeReq.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.NodeReq();
      return proto.types.NodeReq.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.NodeReq} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.NodeReq}
     */


    proto.types.NodeReq.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setTimeout(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setComponent(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.NodeReq.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.NodeReq.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.NodeReq} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.NodeReq.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getTimeout_asU8();

      if (f.length > 0) {
        writer.writeBytes(1, f);
      }

      f = message.getComponent_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }
    };
    /**
     * optional bytes timeout = 1;
     * @return {!(string|Uint8Array)}
     */


    proto.types.NodeReq.prototype.getTimeout = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /**
     * optional bytes timeout = 1;
     * This is a type-conversion wrapper around `getTimeout()`
     * @return {string}
     */


    proto.types.NodeReq.prototype.getTimeout_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getTimeout())
      );
    };
    /**
     * optional bytes timeout = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTimeout()`
     * @return {!Uint8Array}
     */


    proto.types.NodeReq.prototype.getTimeout_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getTimeout())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.NodeReq.prototype.setTimeout = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 1, value);
    };
    /**
     * optional bytes component = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.NodeReq.prototype.getComponent = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes component = 2;
     * This is a type-conversion wrapper around `getComponent()`
     * @return {string}
     */


    proto.types.NodeReq.prototype.getComponent_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getComponent())
      );
    };
    /**
     * optional bytes component = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getComponent()`
     * @return {!Uint8Array}
     */


    proto.types.NodeReq.prototype.getComponent_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getComponent())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.NodeReq.prototype.setComponent = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.Name = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.Name, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.Name.displayName = 'proto.types.Name';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.Name.prototype.toObject = function (opt_includeInstance) {
        return proto.types.Name.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.Name} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.Name.toObject = function (includeInstance, msg) {
        var obj = {
          name: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          blockno: googleProtobuf.Message.getFieldWithDefault(msg, 2, 0)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.Name}
     */


    proto.types.Name.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.Name();
      return proto.types.Name.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.Name} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.Name}
     */


    proto.types.Name.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setName(value);
            break;

          case 2:
            var value =
            /** @type {number} */
            reader.readUint64();
            msg.setBlockno(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.Name.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.Name.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.Name} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.Name.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getName();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getBlockno();

      if (f !== 0) {
        writer.writeUint64(2, f);
      }
    };
    /**
     * optional string name = 1;
     * @return {string}
     */


    proto.types.Name.prototype.getName = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.Name.prototype.setName = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional uint64 blockNo = 2;
     * @return {number}
     */


    proto.types.Name.prototype.getBlockno = function () {
      return (
        /** @type {number} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    /** @param {number} value */


    proto.types.Name.prototype.setBlockno = function (value) {
      googleProtobuf.Message.setProto3IntField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.NameInfo = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.NameInfo, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.NameInfo.displayName = 'proto.types.NameInfo';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.NameInfo.prototype.toObject = function (opt_includeInstance) {
        return proto.types.NameInfo.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.NameInfo} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.NameInfo.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          name: (f = msg.getName()) && proto.types.Name.toObject(includeInstance, f),
          owner: msg.getOwner_asB64(),
          destination: msg.getDestination_asB64()
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.NameInfo}
     */


    proto.types.NameInfo.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.NameInfo();
      return proto.types.NameInfo.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.NameInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.NameInfo}
     */


    proto.types.NameInfo.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new proto.types.Name();
            reader.readMessage(value, proto.types.Name.deserializeBinaryFromReader);
            msg.setName(value);
            break;

          case 2:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setOwner(value);
            break;

          case 3:
            var value =
            /** @type {!Uint8Array} */
            reader.readBytes();
            msg.setDestination(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.NameInfo.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.NameInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.NameInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.NameInfo.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getName();

      if (f != null) {
        writer.writeMessage(1, f, proto.types.Name.serializeBinaryToWriter);
      }

      f = message.getOwner_asU8();

      if (f.length > 0) {
        writer.writeBytes(2, f);
      }

      f = message.getDestination_asU8();

      if (f.length > 0) {
        writer.writeBytes(3, f);
      }
    };
    /**
     * optional Name name = 1;
     * @return {?proto.types.Name}
     */


    proto.types.NameInfo.prototype.getName = function () {
      return (
        /** @type{?proto.types.Name} */
        googleProtobuf.Message.getWrapperField(this, proto.types.Name, 1)
      );
    };
    /** @param {?proto.types.Name|undefined} value */


    proto.types.NameInfo.prototype.setName = function (value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };

    proto.types.NameInfo.prototype.clearName = function () {
      this.setName(undefined);
    };
    /**
     * Returns whether this field is set.
     * @return {boolean}
     */


    proto.types.NameInfo.prototype.hasName = function () {
      return googleProtobuf.Message.getField(this, 1) != null;
    };
    /**
     * optional bytes owner = 2;
     * @return {!(string|Uint8Array)}
     */


    proto.types.NameInfo.prototype.getOwner = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /**
     * optional bytes owner = 2;
     * This is a type-conversion wrapper around `getOwner()`
     * @return {string}
     */


    proto.types.NameInfo.prototype.getOwner_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getOwner())
      );
    };
    /**
     * optional bytes owner = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getOwner()`
     * @return {!Uint8Array}
     */


    proto.types.NameInfo.prototype.getOwner_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getOwner())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.NameInfo.prototype.setOwner = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 2, value);
    };
    /**
     * optional bytes destination = 3;
     * @return {!(string|Uint8Array)}
     */


    proto.types.NameInfo.prototype.getDestination = function () {
      return (
        /** @type {!(string|Uint8Array)} */
        googleProtobuf.Message.getFieldWithDefault(this, 3, "")
      );
    };
    /**
     * optional bytes destination = 3;
     * This is a type-conversion wrapper around `getDestination()`
     * @return {string}
     */


    proto.types.NameInfo.prototype.getDestination_asB64 = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.bytesAsB64(this.getDestination())
      );
    };
    /**
     * optional bytes destination = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getDestination()`
     * @return {!Uint8Array}
     */


    proto.types.NameInfo.prototype.getDestination_asU8 = function () {
      return (
        /** @type {!Uint8Array} */
        googleProtobuf.Message.bytesAsU8(this.getDestination())
      );
    };
    /** @param {!(string|Uint8Array)} value */


    proto.types.NameInfo.prototype.setDestination = function (value) {
      googleProtobuf.Message.setProto3BytesField(this, 3, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.PeersParams = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.PeersParams, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.PeersParams.displayName = 'proto.types.PeersParams';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.PeersParams.prototype.toObject = function (opt_includeInstance) {
        return proto.types.PeersParams.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.PeersParams} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.PeersParams.toObject = function (includeInstance, msg) {
        var obj = {
          nohidden: googleProtobuf.Message.getFieldWithDefault(msg, 1, false),
          showself: googleProtobuf.Message.getFieldWithDefault(msg, 2, false)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.PeersParams}
     */


    proto.types.PeersParams.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.PeersParams();
      return proto.types.PeersParams.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.PeersParams} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.PeersParams}
     */


    proto.types.PeersParams.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setNohidden(value);
            break;

          case 2:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setShowself(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.PeersParams.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.PeersParams.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.PeersParams} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.PeersParams.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getNohidden();

      if (f) {
        writer.writeBool(1, f);
      }

      f = message.getShowself();

      if (f) {
        writer.writeBool(2, f);
      }
    };
    /**
     * optional bool noHidden = 1;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.PeersParams.prototype.getNohidden = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, false)
      );
    };
    /** @param {boolean} value */


    proto.types.PeersParams.prototype.setNohidden = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 1, value);
    };
    /**
     * optional bool showSelf = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.PeersParams.prototype.getShowself = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, false)
      );
    };
    /** @param {boolean} value */


    proto.types.PeersParams.prototype.setShowself = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 2, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.KeyParams = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.KeyParams.repeatedFields_, null);
    };

    goog.inherits(proto.types.KeyParams, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.KeyParams.displayName = 'proto.types.KeyParams';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.KeyParams.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.KeyParams.prototype.toObject = function (opt_includeInstance) {
        return proto.types.KeyParams.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.KeyParams} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.KeyParams.toObject = function (includeInstance, msg) {
        var obj = {
          keyList: googleProtobuf.Message.getRepeatedField(msg, 1)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.KeyParams}
     */


    proto.types.KeyParams.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.KeyParams();
      return proto.types.KeyParams.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.KeyParams} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.KeyParams}
     */


    proto.types.KeyParams.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.addKey(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.KeyParams.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.KeyParams.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.KeyParams} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.KeyParams.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getKeyList();

      if (f.length > 0) {
        writer.writeRepeatedString(1, f);
      }
    };
    /**
     * repeated string key = 1;
     * @return {!Array<string>}
     */


    proto.types.KeyParams.prototype.getKeyList = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.getRepeatedField(this, 1)
      );
    };
    /** @param {!Array<string>} value */


    proto.types.KeyParams.prototype.setKeyList = function (value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };
    /**
     * @param {string} value
     * @param {number=} opt_index
     */


    proto.types.KeyParams.prototype.addKey = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };

    proto.types.KeyParams.prototype.clearKeyList = function () {
      this.setKeyList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ServerInfo = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.ServerInfo, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ServerInfo.displayName = 'proto.types.ServerInfo';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ServerInfo.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ServerInfo.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ServerInfo} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ServerInfo.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          statusMap: (f = msg.getStatusMap()) ? f.toObject(includeInstance, undefined) : [],
          configMap: (f = msg.getConfigMap()) ? f.toObject(includeInstance, proto.types.ConfigItem.toObject) : []
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ServerInfo}
     */


    proto.types.ServerInfo.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ServerInfo();
      return proto.types.ServerInfo.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ServerInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ServerInfo}
     */


    proto.types.ServerInfo.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = msg.getStatusMap();
            reader.readMessage(value, function (message, reader) {
              googleProtobuf.Map.deserializeBinary(message, reader, googleProtobuf.BinaryReader.prototype.readString, googleProtobuf.BinaryReader.prototype.readString, null, "");
            });
            break;

          case 2:
            var value = msg.getConfigMap();
            reader.readMessage(value, function (message, reader) {
              googleProtobuf.Map.deserializeBinary(message, reader, googleProtobuf.BinaryReader.prototype.readString, googleProtobuf.BinaryReader.prototype.readMessage, proto.types.ConfigItem.deserializeBinaryFromReader, "");
            });
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ServerInfo.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ServerInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ServerInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ServerInfo.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getStatusMap(true);

      if (f && f.getLength() > 0) {
        f.serializeBinary(1, writer, googleProtobuf.BinaryWriter.prototype.writeString, googleProtobuf.BinaryWriter.prototype.writeString);
      }

      f = message.getConfigMap(true);

      if (f && f.getLength() > 0) {
        f.serializeBinary(2, writer, googleProtobuf.BinaryWriter.prototype.writeString, googleProtobuf.BinaryWriter.prototype.writeMessage, proto.types.ConfigItem.serializeBinaryToWriter);
      }
    };
    /**
     * map<string, string> status = 1;
     * @param {boolean=} opt_noLazyCreate Do not create the map if
     * empty, instead returning `undefined`
     * @return {!jspb.Map<string,string>}
     */


    proto.types.ServerInfo.prototype.getStatusMap = function (opt_noLazyCreate) {
      return (
        /** @type {!jspb.Map<string,string>} */
        googleProtobuf.Message.getMapField(this, 1, opt_noLazyCreate, null)
      );
    };

    proto.types.ServerInfo.prototype.clearStatusMap = function () {
      this.getStatusMap().clear();
    };
    /**
     * map<string, ConfigItem> config = 2;
     * @param {boolean=} opt_noLazyCreate Do not create the map if
     * empty, instead returning `undefined`
     * @return {!jspb.Map<string,!proto.types.ConfigItem>}
     */


    proto.types.ServerInfo.prototype.getConfigMap = function (opt_noLazyCreate) {
      return (
        /** @type {!jspb.Map<string,!proto.types.ConfigItem>} */
        googleProtobuf.Message.getMapField(this, 2, opt_noLazyCreate, proto.types.ConfigItem)
      );
    };

    proto.types.ServerInfo.prototype.clearConfigMap = function () {
      this.getConfigMap().clear();
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ConfigItem = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.ConfigItem, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ConfigItem.displayName = 'proto.types.ConfigItem';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ConfigItem.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ConfigItem.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ConfigItem} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ConfigItem.toObject = function (includeInstance, msg) {
        var f,
            obj = {
          propsMap: (f = msg.getPropsMap()) ? f.toObject(includeInstance, undefined) : []
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ConfigItem}
     */


    proto.types.ConfigItem.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ConfigItem();
      return proto.types.ConfigItem.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ConfigItem} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ConfigItem}
     */


    proto.types.ConfigItem.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 2:
            var value = msg.getPropsMap();
            reader.readMessage(value, function (message, reader) {
              googleProtobuf.Map.deserializeBinary(message, reader, googleProtobuf.BinaryReader.prototype.readString, googleProtobuf.BinaryReader.prototype.readString, null, "");
            });
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ConfigItem.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ConfigItem.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ConfigItem} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ConfigItem.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getPropsMap(true);

      if (f && f.getLength() > 0) {
        f.serializeBinary(2, writer, googleProtobuf.BinaryWriter.prototype.writeString, googleProtobuf.BinaryWriter.prototype.writeString);
      }
    };
    /**
     * map<string, string> props = 2;
     * @param {boolean=} opt_noLazyCreate Do not create the map if
     * empty, instead returning `undefined`
     * @return {!jspb.Map<string,string>}
     */


    proto.types.ConfigItem.prototype.getPropsMap = function (opt_noLazyCreate) {
      return (
        /** @type {!jspb.Map<string,string>} */
        googleProtobuf.Message.getMapField(this, 2, opt_noLazyCreate, null)
      );
    };

    proto.types.ConfigItem.prototype.clearPropsMap = function () {
      this.getPropsMap().clear();
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.EventList = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.EventList.repeatedFields_, null);
    };

    goog.inherits(proto.types.EventList, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.EventList.displayName = 'proto.types.EventList';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.EventList.repeatedFields_ = [1];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.EventList.prototype.toObject = function (opt_includeInstance) {
        return proto.types.EventList.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.EventList} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.EventList.toObject = function (includeInstance, msg) {
        var obj = {
          eventsList: googleProtobuf.Message.toObjectList(msg.getEventsList(), blockchain_pb.Event.toObject, includeInstance)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.EventList}
     */


    proto.types.EventList.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.EventList();
      return proto.types.EventList.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.EventList} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.EventList}
     */


    proto.types.EventList.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value = new blockchain_pb.Event();
            reader.readMessage(value, blockchain_pb.Event.deserializeBinaryFromReader);
            msg.addEvents(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.EventList.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.EventList.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.EventList} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.EventList.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getEventsList();

      if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, blockchain_pb.Event.serializeBinaryToWriter);
      }
    };
    /**
     * repeated Event events = 1;
     * @return {!Array<!proto.types.Event>}
     */


    proto.types.EventList.prototype.getEventsList = function () {
      return (
        /** @type{!Array<!proto.types.Event>} */
        googleProtobuf.Message.getRepeatedWrapperField(this, blockchain_pb.Event, 1)
      );
    };
    /** @param {!Array<!proto.types.Event>} value */


    proto.types.EventList.prototype.setEventsList = function (value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };
    /**
     * @param {!proto.types.Event=} opt_value
     * @param {number=} opt_index
     * @return {!proto.types.Event}
     */


    proto.types.EventList.prototype.addEvents = function (opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.types.Event, opt_index);
    };

    proto.types.EventList.prototype.clearEventsList = function () {
      this.setEventsList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.ConsensusInfo = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.ConsensusInfo.repeatedFields_, null);
    };

    goog.inherits(proto.types.ConsensusInfo, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.ConsensusInfo.displayName = 'proto.types.ConsensusInfo';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.ConsensusInfo.repeatedFields_ = [3];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.ConsensusInfo.prototype.toObject = function (opt_includeInstance) {
        return proto.types.ConsensusInfo.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.ConsensusInfo} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.ConsensusInfo.toObject = function (includeInstance, msg) {
        var obj = {
          type: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          info: googleProtobuf.Message.getFieldWithDefault(msg, 2, ""),
          bpsList: googleProtobuf.Message.getRepeatedField(msg, 3)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.ConsensusInfo}
     */


    proto.types.ConsensusInfo.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.ConsensusInfo();
      return proto.types.ConsensusInfo.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.ConsensusInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.ConsensusInfo}
     */


    proto.types.ConsensusInfo.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setType(value);
            break;

          case 2:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setInfo(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.addBps(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.ConsensusInfo.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.ConsensusInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.ConsensusInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.ConsensusInfo.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getType();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getInfo();

      if (f.length > 0) {
        writer.writeString(2, f);
      }

      f = message.getBpsList();

      if (f.length > 0) {
        writer.writeRepeatedString(3, f);
      }
    };
    /**
     * optional string type = 1;
     * @return {string}
     */


    proto.types.ConsensusInfo.prototype.getType = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.ConsensusInfo.prototype.setType = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional string info = 2;
     * @return {string}
     */


    proto.types.ConsensusInfo.prototype.getInfo = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, "")
      );
    };
    /** @param {string} value */


    proto.types.ConsensusInfo.prototype.setInfo = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 2, value);
    };
    /**
     * repeated string bps = 3;
     * @return {!Array<string>}
     */


    proto.types.ConsensusInfo.prototype.getBpsList = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.getRepeatedField(this, 3)
      );
    };
    /** @param {!Array<string>} value */


    proto.types.ConsensusInfo.prototype.setBpsList = function (value) {
      googleProtobuf.Message.setField(this, 3, value || []);
    };
    /**
     * @param {string} value
     * @param {number=} opt_index
     */


    proto.types.ConsensusInfo.prototype.addBps = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 3, value, opt_index);
    };

    proto.types.ConsensusInfo.prototype.clearBpsList = function () {
      this.setBpsList([]);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.EnterpriseConfigKey = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };

    goog.inherits(proto.types.EnterpriseConfigKey, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.EnterpriseConfigKey.displayName = 'proto.types.EnterpriseConfigKey';
    }

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.EnterpriseConfigKey.prototype.toObject = function (opt_includeInstance) {
        return proto.types.EnterpriseConfigKey.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.EnterpriseConfigKey} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.EnterpriseConfigKey.toObject = function (includeInstance, msg) {
        var obj = {
          key: googleProtobuf.Message.getFieldWithDefault(msg, 1, "")
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.EnterpriseConfigKey}
     */


    proto.types.EnterpriseConfigKey.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.EnterpriseConfigKey();
      return proto.types.EnterpriseConfigKey.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.EnterpriseConfigKey} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.EnterpriseConfigKey}
     */


    proto.types.EnterpriseConfigKey.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setKey(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.EnterpriseConfigKey.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.EnterpriseConfigKey.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.EnterpriseConfigKey} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.EnterpriseConfigKey.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getKey();

      if (f.length > 0) {
        writer.writeString(1, f);
      }
    };
    /**
     * optional string key = 1;
     * @return {string}
     */


    proto.types.EnterpriseConfigKey.prototype.getKey = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.EnterpriseConfigKey.prototype.setKey = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */


    proto.types.EnterpriseConfig = function (opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.types.EnterpriseConfig.repeatedFields_, null);
    };

    goog.inherits(proto.types.EnterpriseConfig, googleProtobuf.Message);

    if (goog.DEBUG && !COMPILED) {
      proto.types.EnterpriseConfig.displayName = 'proto.types.EnterpriseConfig';
    }
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */


    proto.types.EnterpriseConfig.repeatedFields_ = [3];

    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
      /**
       * Creates an object representation of this proto suitable for use in Soy templates.
       * Field names that are reserved in JavaScript and will be renamed to pb_name.
       * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
       * For the list of reserved names please see:
       *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
       * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
       *     for transitional soy proto support: http://goto/soy-param-migration
       * @return {!Object}
       */
      proto.types.EnterpriseConfig.prototype.toObject = function (opt_includeInstance) {
        return proto.types.EnterpriseConfig.toObject(opt_includeInstance, this);
      };
      /**
       * Static version of the {@see toObject} method.
       * @param {boolean|undefined} includeInstance Whether to include the JSPB
       *     instance for transitional soy proto support:
       *     http://goto/soy-param-migration
       * @param {!proto.types.EnterpriseConfig} msg The msg instance to transform.
       * @return {!Object}
       * @suppress {unusedLocalVariables} f is only used for nested messages
       */


      proto.types.EnterpriseConfig.toObject = function (includeInstance, msg) {
        var obj = {
          key: googleProtobuf.Message.getFieldWithDefault(msg, 1, ""),
          on: googleProtobuf.Message.getFieldWithDefault(msg, 2, false),
          valuesList: googleProtobuf.Message.getRepeatedField(msg, 3)
        };

        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }

        return obj;
      };
    }
    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.types.EnterpriseConfig}
     */


    proto.types.EnterpriseConfig.deserializeBinary = function (bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.types.EnterpriseConfig();
      return proto.types.EnterpriseConfig.deserializeBinaryFromReader(msg, reader);
    };
    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.types.EnterpriseConfig} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.types.EnterpriseConfig}
     */


    proto.types.EnterpriseConfig.deserializeBinaryFromReader = function (msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }

        var field = reader.getFieldNumber();

        switch (field) {
          case 1:
            var value =
            /** @type {string} */
            reader.readString();
            msg.setKey(value);
            break;

          case 2:
            var value =
            /** @type {boolean} */
            reader.readBool();
            msg.setOn(value);
            break;

          case 3:
            var value =
            /** @type {string} */
            reader.readString();
            msg.addValues(value);
            break;

          default:
            reader.skipField();
            break;
        }
      }

      return msg;
    };
    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */


    proto.types.EnterpriseConfig.prototype.serializeBinary = function () {
      var writer = new googleProtobuf.BinaryWriter();
      proto.types.EnterpriseConfig.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.types.EnterpriseConfig} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */


    proto.types.EnterpriseConfig.serializeBinaryToWriter = function (message, writer) {
      var f = undefined;
      f = message.getKey();

      if (f.length > 0) {
        writer.writeString(1, f);
      }

      f = message.getOn();

      if (f) {
        writer.writeBool(2, f);
      }

      f = message.getValuesList();

      if (f.length > 0) {
        writer.writeRepeatedString(3, f);
      }
    };
    /**
     * optional string key = 1;
     * @return {string}
     */


    proto.types.EnterpriseConfig.prototype.getKey = function () {
      return (
        /** @type {string} */
        googleProtobuf.Message.getFieldWithDefault(this, 1, "")
      );
    };
    /** @param {string} value */


    proto.types.EnterpriseConfig.prototype.setKey = function (value) {
      googleProtobuf.Message.setProto3StringField(this, 1, value);
    };
    /**
     * optional bool on = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */


    proto.types.EnterpriseConfig.prototype.getOn = function () {
      return (
        /** @type {boolean} */
        googleProtobuf.Message.getFieldWithDefault(this, 2, false)
      );
    };
    /** @param {boolean} value */


    proto.types.EnterpriseConfig.prototype.setOn = function (value) {
      googleProtobuf.Message.setProto3BooleanField(this, 2, value);
    };
    /**
     * repeated string values = 3;
     * @return {!Array<string>}
     */


    proto.types.EnterpriseConfig.prototype.getValuesList = function () {
      return (
        /** @type {!Array<string>} */
        googleProtobuf.Message.getRepeatedField(this, 3)
      );
    };
    /** @param {!Array<string>} value */


    proto.types.EnterpriseConfig.prototype.setValuesList = function (value) {
      googleProtobuf.Message.setField(this, 3, value || []);
    };
    /**
     * @param {string} value
     * @param {number=} opt_index
     */


    proto.types.EnterpriseConfig.prototype.addValues = function (value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 3, value, opt_index);
    };

    proto.types.EnterpriseConfig.prototype.clearValuesList = function () {
      this.setValuesList([]);
    };
    /**
     * @enum {number}
     */


    proto.types.CommitStatus = {
      TX_OK: 0,
      TX_NONCE_TOO_LOW: 1,
      TX_ALREADY_EXISTS: 2,
      TX_INVALID_HASH: 3,
      TX_INVALID_SIGN: 4,
      TX_INVALID_FORMAT: 5,
      TX_INSUFFICIENT_BALANCE: 6,
      TX_HAS_SAME_NONCE: 7,
      TX_INTERNAL_ERROR: 9
    };
    /**
     * @enum {number}
     */

    proto.types.VerifyStatus = {
      VERIFY_STATUS_OK: 0,
      VERIFY_STATUS_SIGN_NOT_MATCH: 1,
      VERIFY_STATUS_INVALID_HASH: 2
    };
    goog.object.extend(exports, proto.types);
  });
  var rpc_pb_1 = rpc_pb.AccountAddress;
  var rpc_pb_2 = rpc_pb.Empty;
  var rpc_pb_3 = rpc_pb.Personal;
  var rpc_pb_4 = rpc_pb.SingleBytes;
  var rpc_pb_5 = rpc_pb.TxList;
  var rpc_pb_6 = rpc_pb.TxBody;
  var rpc_pb_7 = rpc_pb.Tx;
  var rpc_pb_8 = rpc_pb.CommitStatus;
  var rpc_pb_9 = rpc_pb.ListParams;
  var rpc_pb_10 = rpc_pb.Query;
  var rpc_pb_11 = rpc_pb.Name;
  var rpc_pb_12 = rpc_pb.PeersParams;
  var rpc_pb_13 = rpc_pb.VoteParams;
  var rpc_pb_14 = rpc_pb.NodeReq;
  var rpc_pb_15 = rpc_pb.KeyParams;
  var rpc_pb_16 = rpc_pb.BlockMetadata;
  var rpc_pb_17 = rpc_pb.PageParams;
  var rpc_pb_18 = rpc_pb.BlockBodyParams;

  var errorMessageForCode = function errorMessageForCode(code) {
    var errorMessage = 'UNDEFINED_ERROR';

    if (code && code < Object.values(rpc_pb_8).length) {
      errorMessage = Object.keys(rpc_pb_8)[Object.values(rpc_pb_8).indexOf(code)];
    }

    return errorMessage;
  };
  function waterfall(fns) {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (input) {
        var result = input;

        var _iterator = _createForOfIteratorHelper(fns),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var fn = _step.value;
            result = yield fn(result);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return result;
      });

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  }

  var inherits_browser = createCommonjsModule(function (module) {
    if (typeof Object.create === 'function') {
      // implementation from standard node.js 'util' module
      module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor;
          ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
              value: ctor,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
        }
      };
    } else {
      // old school shim for old browsers
      module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor;

          var TempCtor = function TempCtor() {};

          TempCtor.prototype = superCtor.prototype;
          ctor.prototype = new TempCtor();
          ctor.prototype.constructor = ctor;
        }
      };
    }
  });

  var safeBuffer = createCommonjsModule(function (module, exports) {
    /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */

    /* eslint-disable node/no-deprecated-api */
    var Buffer = bufferEs6.Buffer; // alternative to using Object.keys for old browsers

    function copyProps(src, dst) {
      for (var key in src) {
        dst[key] = src[key];
      }
    }

    if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
      module.exports = bufferEs6;
    } else {
      // Copy properties from require('buffer')
      copyProps(bufferEs6, exports);
      exports.Buffer = SafeBuffer;
    }

    function SafeBuffer(arg, encodingOrOffset, length) {
      return Buffer(arg, encodingOrOffset, length);
    }

    SafeBuffer.prototype = Object.create(Buffer.prototype); // Copy static methods from Buffer

    copyProps(Buffer, SafeBuffer);

    SafeBuffer.from = function (arg, encodingOrOffset, length) {
      if (typeof arg === 'number') {
        throw new TypeError('Argument must not be a number');
      }

      return Buffer(arg, encodingOrOffset, length);
    };

    SafeBuffer.alloc = function (size, fill, encoding) {
      if (typeof size !== 'number') {
        throw new TypeError('Argument must be a number');
      }

      var buf = Buffer(size);

      if (fill !== undefined) {
        if (typeof encoding === 'string') {
          buf.fill(fill, encoding);
        } else {
          buf.fill(fill);
        }
      } else {
        buf.fill(0);
      }

      return buf;
    };

    SafeBuffer.allocUnsafe = function (size) {
      if (typeof size !== 'number') {
        throw new TypeError('Argument must be a number');
      }

      return Buffer(size);
    };

    SafeBuffer.allocUnsafeSlow = function (size) {
      if (typeof size !== 'number') {
        throw new TypeError('Argument must be a number');
      }

      return bufferEs6.SlowBuffer(size);
    };
  });
  var safeBuffer_1 = safeBuffer.Buffer;

  // shim for using process in browser
  // based off https://github.com/defunctzombie/node-process/blob/master/browser.js
  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }

  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }

  var cachedSetTimeout = defaultSetTimout;
  var cachedClearTimeout = defaultClearTimeout;

  if (typeof global$1.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
  }

  if (typeof global$1.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
  }

  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    } // if setTimeout wasn't available but was latter defined


    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }

  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    } // if clearTimeout wasn't available but was latter defined


    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }

  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }

    draining = false;

    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }

    if (queue.length) {
      drainQueue();
    }
  }

  function drainQueue() {
    if (draining) {
      return;
    }

    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;

    while (len) {
      currentQueue = queue;
      queue = [];

      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }

      queueIndex = -1;
      len = queue.length;
    }

    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }

  function nextTick(fun) {
    var args = new Array(arguments.length - 1);

    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }

    queue.push(new Item(fun, args));

    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  } // v8 likes predictible objects

  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }

  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  var title = 'browser';
  var platform = 'browser';
  var browser = true;
  var env = {};
  var argv = [];
  var version = ''; // empty string to avoid regexp issues

  var versions = {};
  var release = {};
  var config = {};

  function noop() {}

  var on = noop;
  var addListener = noop;
  var once = noop;
  var off = noop;
  var removeListener = noop;
  var removeAllListeners = noop;
  var emit = noop;
  function binding(name) {
    throw new Error('process.binding is not supported');
  }
  function cwd() {
    return '/';
  }
  function chdir(dir) {
    throw new Error('process.chdir is not supported');
  }
  function umask() {
    return 0;
  } // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js

  var performance = global$1.performance || {};

  var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function () {
    return new Date().getTime();
  }; // generate timestamp or delta
  // see http://nodejs.org/api/process.html#process_process_hrtime


  function hrtime(previousTimestamp) {
    var clocktime = performanceNow.call(performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);

    if (previousTimestamp) {
      seconds = seconds - previousTimestamp[0];
      nanoseconds = nanoseconds - previousTimestamp[1];

      if (nanoseconds < 0) {
        seconds--;
        nanoseconds += 1e9;
      }
    }

    return [seconds, nanoseconds];
  }
  var startTime = new Date();
  function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
  }
  var process = {
    nextTick: nextTick,
    title: title,
    browser: browser,
    env: env,
    argv: argv,
    version: version,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config,
    uptime: uptime
  };

  var domain; // This constructor is used to store event handlers. Instantiating this is
  // faster than explicitly calling `Object.create(null)` to get a "clean" empty
  // object (tested with v8 v4.9).

  function EventHandlers() {}

  EventHandlers.prototype = Object.create(null);

  function EventEmitter() {
    EventEmitter.init.call(this);
  }
  // require('events') === require('events').EventEmitter

  EventEmitter.EventEmitter = EventEmitter;
  EventEmitter.usingDomains = false;
  EventEmitter.prototype.domain = undefined;
  EventEmitter.prototype._events = undefined;
  EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
  // added to it. This is a useful default which helps finding memory leaks.

  EventEmitter.defaultMaxListeners = 10;

  EventEmitter.init = function () {
    this.domain = null;

    if (EventEmitter.usingDomains) {
      // if there is an active domain, then attach to it.
      if (domain.active ) ;
    }

    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
      this._events = new EventHandlers();
      this._eventsCount = 0;
    }

    this._maxListeners = this._maxListeners || undefined;
  }; // Obviously not all Emitters should be limited to 10. This function allows
  // that to be increased. Set to zero for unlimited.


  EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
  };

  function $getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
  }

  EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $getMaxListeners(this);
  }; // These standalone emit* functions are used to optimize calling of event
  // handlers for fast cases because emit() itself often has a variable number of
  // arguments and can be deoptimized because of that. These functions always have
  // the same number of arguments and thus do not get deoptimized, so the code
  // inside them can execute faster.


  function emitNone(handler, isFn, self) {
    if (isFn) handler.call(self);else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);

      for (var i = 0; i < len; ++i) {
        listeners[i].call(self);
      }
    }
  }

  function emitOne(handler, isFn, self, arg1) {
    if (isFn) handler.call(self, arg1);else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);

      for (var i = 0; i < len; ++i) {
        listeners[i].call(self, arg1);
      }
    }
  }

  function emitTwo(handler, isFn, self, arg1, arg2) {
    if (isFn) handler.call(self, arg1, arg2);else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);

      for (var i = 0; i < len; ++i) {
        listeners[i].call(self, arg1, arg2);
      }
    }
  }

  function emitThree(handler, isFn, self, arg1, arg2, arg3) {
    if (isFn) handler.call(self, arg1, arg2, arg3);else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);

      for (var i = 0; i < len; ++i) {
        listeners[i].call(self, arg1, arg2, arg3);
      }
    }
  }

  function emitMany(handler, isFn, self, args) {
    if (isFn) handler.apply(self, args);else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);

      for (var i = 0; i < len; ++i) {
        listeners[i].apply(self, args);
      }
    }
  }

  EventEmitter.prototype.emit = function emit(type) {
    var er, handler, len, args, i, events, domain;
    var doError = type === 'error';
    events = this._events;
    if (events) doError = doError && events.error == null;else if (!doError) return false;
    domain = this.domain; // If there is no 'error' event listener then throw.

    if (doError) {
      er = arguments[1];

      if (domain) {
        if (!er) er = new Error('Uncaught, unspecified "error" event');
        er.domainEmitter = this;
        er.domain = domain;
        er.domainThrown = false;
        domain.emit('error', er);
      } else if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }

      return false;
    }

    handler = events[type];
    if (!handler) return false;
    var isFn = typeof handler === 'function';
    len = arguments.length;

    switch (len) {
      // fast cases
      case 1:
        emitNone(handler, isFn, this);
        break;

      case 2:
        emitOne(handler, isFn, this, arguments[1]);
        break;

      case 3:
        emitTwo(handler, isFn, this, arguments[1], arguments[2]);
        break;

      case 4:
        emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
        break;
      // slower

      default:
        args = new Array(len - 1);

        for (i = 1; i < len; i++) {
          args[i - 1] = arguments[i];
        }

        emitMany(handler, isFn, this, args);
    }
    return true;
  };

  function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    events = target._events;

    if (!events) {
      events = target._events = new EventHandlers();
      target._eventsCount = 0;
    } else {
      // To avoid recursion in the case that type === "newListener"! Before
      // adding it to the listeners, first emit "newListener".
      if (events.newListener) {
        target.emit('newListener', type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
        // this._events to be assigned to a new object

        events = target._events;
      }

      existing = events[type];
    }

    if (!existing) {
      // Optimize the case of one listener. Don't need the extra array object.
      existing = events[type] = listener;
      ++target._eventsCount;
    } else {
      if (typeof existing === 'function') {
        // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [listener, existing] : [existing, listener];
      } else {
        // If we've already got an array, just append.
        if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
      } // Check for listener leak


      if (!existing.warned) {
        m = $getMaxListeners(target);

        if (m && m > 0 && existing.length > m) {
          existing.warned = true;
          var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + type + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit');
          w.name = 'MaxListenersExceededWarning';
          w.emitter = target;
          w.type = type;
          w.count = existing.length;
          emitWarning(w);
        }
      }
    }

    return target;
  }

  function emitWarning(e) {
    typeof console.warn === 'function' ? console.warn(e) : console.log(e);
  }

  EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
  };

  EventEmitter.prototype.on = EventEmitter.prototype.addListener;

  EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
  };

  function _onceWrap(target, type, listener) {
    var fired = false;

    function g() {
      target.removeListener(type, g);

      if (!fired) {
        fired = true;
        listener.apply(target, arguments);
      }
    }

    g.listener = listener;
    return g;
  }

  EventEmitter.prototype.once = function once(type, listener) {
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    this.on(type, _onceWrap(this, type, listener));
    return this;
  };

  EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
  }; // emits a 'removeListener' event iff the listener was removed


  EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    events = this._events;
    if (!events) return this;
    list = events[type];
    if (!list) return this;

    if (list === listener || list.listener && list.listener === listener) {
      if (--this._eventsCount === 0) this._events = new EventHandlers();else {
        delete events[type];
        if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
      }
    } else if (typeof list !== 'function') {
      position = -1;

      for (i = list.length; i-- > 0;) {
        if (list[i] === listener || list[i].listener && list[i].listener === listener) {
          originalListener = list[i].listener;
          position = i;
          break;
        }
      }

      if (position < 0) return this;

      if (list.length === 1) {
        list[0] = undefined;

        if (--this._eventsCount === 0) {
          this._events = new EventHandlers();
          return this;
        } else {
          delete events[type];
        }
      } else {
        spliceOne(list, position);
      }

      if (events.removeListener) this.emit('removeListener', type, originalListener || listener);
    }

    return this;
  };

  EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events;
    events = this._events;
    if (!events) return this; // not listening for removeListener, no need to emit

    if (!events.removeListener) {
      if (arguments.length === 0) {
        this._events = new EventHandlers();
        this._eventsCount = 0;
      } else if (events[type]) {
        if (--this._eventsCount === 0) this._events = new EventHandlers();else delete events[type];
      }

      return this;
    } // emit removeListener for all listeners on all events


    if (arguments.length === 0) {
      var keys = Object.keys(events);

      for (var i = 0, key; i < keys.length; ++i) {
        key = keys[i];
        if (key === 'removeListener') continue;
        this.removeAllListeners(key);
      }

      this.removeAllListeners('removeListener');
      this._events = new EventHandlers();
      this._eventsCount = 0;
      return this;
    }

    listeners = events[type];

    if (typeof listeners === 'function') {
      this.removeListener(type, listeners);
    } else if (listeners) {
      // LIFO order
      do {
        this.removeListener(type, listeners[listeners.length - 1]);
      } while (listeners[0]);
    }

    return this;
  };

  EventEmitter.prototype.listeners = function listeners(type) {
    var evlistener;
    var ret;
    var events = this._events;
    if (!events) ret = [];else {
      evlistener = events[type];
      if (!evlistener) ret = [];else if (typeof evlistener === 'function') ret = [evlistener.listener || evlistener];else ret = unwrapListeners(evlistener);
    }
    return ret;
  };

  EventEmitter.listenerCount = function (emitter, type) {
    if (typeof emitter.listenerCount === 'function') {
      return emitter.listenerCount(type);
    } else {
      return listenerCount.call(emitter, type);
    }
  };

  EventEmitter.prototype.listenerCount = listenerCount;

  function listenerCount(type) {
    var events = this._events;

    if (events) {
      var evlistener = events[type];

      if (typeof evlistener === 'function') {
        return 1;
      } else if (evlistener) {
        return evlistener.length;
      }
    }

    return 0;
  }

  EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  }; // About 1.5x faster than the two-arg version of Array#splice().


  function spliceOne(list, index) {
    for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
      list[i] = list[k];
    }

    list.pop();
  }

  function arrayClone(arr, i) {
    var copy = new Array(i);

    while (i--) {
      copy[i] = arr[i];
    }

    return copy;
  }

  function unwrapListeners(arr) {
    var ret = new Array(arr.length);

    for (var i = 0; i < ret.length; ++i) {
      ret[i] = arr[i].listener || arr[i];
    }

    return ret;
  }

  var streamBrowser = EventEmitter.EventEmitter;

  var inherits;

  if (typeof Object.create === 'function') {
    inherits = function inherits(ctor, superCtor) {
      // implementation from standard node.js 'util' module
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    inherits = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;

      var TempCtor = function TempCtor() {};

      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }

  var inherits$1 = inherits;

  var formatRegExp = /%[sdj%]/g;
  function format(f) {
    if (!isString(f)) {
      var objects = [];

      for (var i = 0; i < arguments.length; i++) {
        objects.push(inspect(arguments[i]));
      }

      return objects.join(' ');
    }

    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') return '%';
      if (i >= len) return x;

      switch (x) {
        case '%s':
          return String(args[i++]);

        case '%d':
          return Number(args[i++]);

        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }

        default:
          return x;
      }
    });

    for (var x = args[i]; i < len; x = args[++i]) {
      if (isNull(x) || !isObject(x)) {
        str += ' ' + x;
      } else {
        str += ' ' + inspect(x);
      }
    }

    return str;
  }
  // Returns a modified function which warns once by default.
  // If --no-deprecation is set, then it is a no-op.

  function deprecate(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if (isUndefined(global$1.process)) {
      return function () {
        return deprecate(fn, msg).apply(this, arguments);
      };
    }

    var warned = false;

    function deprecated() {
      if (!warned) {
        {
          console.error(msg);
        }

        warned = true;
      }

      return fn.apply(this, arguments);
    }

    return deprecated;
  }
  var debugs = {};
  var debugEnviron;
  function debuglog(set) {
    if (isUndefined(debugEnviron)) debugEnviron =  '';
    set = set.toUpperCase();

    if (!debugs[set]) {
      if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
        var pid = 0;

        debugs[set] = function () {
          var msg = format.apply(null, arguments);
          console.error('%s %d: %s', set, pid, msg);
        };
      } else {
        debugs[set] = function () {};
      }
    }

    return debugs[set];
  }
  /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */

  /* legacy: obj, showHidden, depth, colors*/

  function inspect(obj, opts) {
    // default options
    var ctx = {
      seen: [],
      stylize: stylizeNoColor
    }; // legacy...

    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];

    if (isBoolean(opts)) {
      // legacy...
      ctx.showHidden = opts;
    } else if (opts) {
      // got an "options" object
      _extend(ctx, opts);
    } // set default options


    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
  } // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics

  inspect.colors = {
    'bold': [1, 22],
    'italic': [3, 23],
    'underline': [4, 24],
    'inverse': [7, 27],
    'white': [37, 39],
    'grey': [90, 39],
    'black': [30, 39],
    'blue': [34, 39],
    'cyan': [36, 39],
    'green': [32, 39],
    'magenta': [35, 39],
    'red': [31, 39],
    'yellow': [33, 39]
  }; // Don't use 'blue' not visible on cmd.exe

  inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
  };

  function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];

    if (style) {
      return "\x1B[" + inspect.colors[style][0] + 'm' + str + "\x1B[" + inspect.colors[style][1] + 'm';
    } else {
      return str;
    }
  }

  function stylizeNoColor(str, styleType) {
    return str;
  }

  function arrayToHash(array) {
    var hash = {};
    array.forEach(function (val, idx) {
      hash[val] = true;
    });
    return hash;
  }

  function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
      var ret = value.inspect(recurseTimes, ctx);

      if (!isString(ret)) {
        ret = formatValue(ctx, ret, recurseTimes);
      }

      return ret;
    } // Primitive types cannot have properties


    var primitive = formatPrimitive(ctx, value);

    if (primitive) {
      return primitive;
    } // Look up the keys of the object.


    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);

    if (ctx.showHidden) {
      keys = Object.getOwnPropertyNames(value);
    } // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx


    if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
      return formatError(value);
    } // Some type of object without properties can be shortcutted.


    if (keys.length === 0) {
      if (isFunction(value)) {
        var name = value.name ? ': ' + value.name : '';
        return ctx.stylize('[Function' + name + ']', 'special');
      }

      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      }

      if (isDate(value)) {
        return ctx.stylize(Date.prototype.toString.call(value), 'date');
      }

      if (isError(value)) {
        return formatError(value);
      }
    }

    var base = '',
        array = false,
        braces = ['{', '}']; // Make Array say that they are Array

    if (isArray$1(value)) {
      array = true;
      braces = ['[', ']'];
    } // Make functions say that they are functions


    if (isFunction(value)) {
      var n = value.name ? ': ' + value.name : '';
      base = ' [Function' + n + ']';
    } // Make RegExps say that they are RegExps


    if (isRegExp(value)) {
      base = ' ' + RegExp.prototype.toString.call(value);
    } // Make dates with properties first say the date


    if (isDate(value)) {
      base = ' ' + Date.prototype.toUTCString.call(value);
    } // Make error with message first say the error


    if (isError(value)) {
      base = ' ' + formatError(value);
    }

    if (keys.length === 0 && (!array || value.length == 0)) {
      return braces[0] + base + braces[1];
    }

    if (recurseTimes < 0) {
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      } else {
        return ctx.stylize('[Object]', 'special');
      }
    }

    ctx.seen.push(value);
    var output;

    if (array) {
      output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    } else {
      output = keys.map(function (key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
      });
    }

    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
  }

  function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');

    if (isString(value)) {
      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
      return ctx.stylize(simple, 'string');
    }

    if (isNumber(value)) return ctx.stylize('' + value, 'number');
    if (isBoolean(value)) return ctx.stylize('' + value, 'boolean'); // For some reason typeof null is "object", so special case here.

    if (isNull(value)) return ctx.stylize('null', 'null');
  }

  function formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
  }

  function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];

    for (var i = 0, l = value.length; i < l; ++i) {
      if (hasOwnProperty(value, String(i))) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
      } else {
        output.push('');
      }
    }

    keys.forEach(function (key) {
      if (!key.match(/^\d+$/)) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
      }
    });
    return output;
  }

  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
      value: value[key]
    };

    if (desc.get) {
      if (desc.set) {
        str = ctx.stylize('[Getter/Setter]', 'special');
      } else {
        str = ctx.stylize('[Getter]', 'special');
      }
    } else {
      if (desc.set) {
        str = ctx.stylize('[Setter]', 'special');
      }
    }

    if (!hasOwnProperty(visibleKeys, key)) {
      name = '[' + key + ']';
    }

    if (!str) {
      if (ctx.seen.indexOf(desc.value) < 0) {
        if (isNull(recurseTimes)) {
          str = formatValue(ctx, desc.value, null);
        } else {
          str = formatValue(ctx, desc.value, recurseTimes - 1);
        }

        if (str.indexOf('\n') > -1) {
          if (array) {
            str = str.split('\n').map(function (line) {
              return '  ' + line;
            }).join('\n').substr(2);
          } else {
            str = '\n' + str.split('\n').map(function (line) {
              return '   ' + line;
            }).join('\n');
          }
        }
      } else {
        str = ctx.stylize('[Circular]', 'special');
      }
    }

    if (isUndefined(name)) {
      if (array && key.match(/^\d+$/)) {
        return str;
      }

      name = JSON.stringify('' + key);

      if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
        name = name.substr(1, name.length - 2);
        name = ctx.stylize(name, 'name');
      } else {
        name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
        name = ctx.stylize(name, 'string');
      }
    }

    return name + ': ' + str;
  }

  function reduceToSingleString(output, base, braces) {
    var length = output.reduce(function (prev, cur) {
      if (cur.indexOf('\n') >= 0) ;
      return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);

    if (length > 60) {
      return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    }

    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
  } // NOTE: These type checking functions intentionally don't use `instanceof`
  // because it is fragile and can be easily faked with `Object.create()`.


  function isArray$1(ar) {
    return Array.isArray(ar);
  }
  function isBoolean(arg) {
    return typeof arg === 'boolean';
  }
  function isNull(arg) {
    return arg === null;
  }
  function isNullOrUndefined(arg) {
    return arg == null;
  }
  function isNumber(arg) {
    return typeof arg === 'number';
  }
  function isString(arg) {
    return typeof arg === 'string';
  }
  function isSymbol(arg) {
    return _typeof(arg) === 'symbol';
  }
  function isUndefined(arg) {
    return arg === void 0;
  }
  function isRegExp(re) {
    return isObject(re) && objectToString(re) === '[object RegExp]';
  }
  function isObject(arg) {
    return _typeof(arg) === 'object' && arg !== null;
  }
  function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
  }
  function isError(e) {
    return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
  }
  function isFunction(arg) {
    return typeof arg === 'function';
  }
  function isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || _typeof(arg) === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
  }
  function isBuffer$1(maybeBuf) {
    return isBuffer(maybeBuf);
  }

  function objectToString(o) {
    return Object.prototype.toString.call(o);
  }

  function pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
  }

  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; // 26 Feb 16:19:34

  function timestamp() {
    var d = new Date();
    var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
    return [d.getDate(), months[d.getMonth()], time].join(' ');
  } // log is just a thin wrapper to console.log that prepends a timestamp


  function log() {
    console.log('%s - %s', timestamp(), format.apply(null, arguments));
  }
  function _extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;

    while (i--) {
      origin[keys[i]] = add[keys[i]];
    }

    return origin;
  }

  function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  var debugUtil = {
    inherits: inherits$1,
    _extend: _extend,
    log: log,
    isBuffer: isBuffer$1,
    isPrimitive: isPrimitive,
    isFunction: isFunction,
    isError: isError,
    isDate: isDate,
    isObject: isObject,
    isRegExp: isRegExp,
    isUndefined: isUndefined,
    isSymbol: isSymbol,
    isString: isString,
    isNumber: isNumber,
    isNullOrUndefined: isNullOrUndefined,
    isNull: isNull,
    isBoolean: isBoolean,
    isArray: isArray$1,
    inspect: inspect,
    deprecate: deprecate,
    format: format,
    debuglog: debuglog
  };

  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$1(Object(source), true).forEach(function (key) {
          _defineProperty$1(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }

  var Buffer$2 = bufferEs6.Buffer;
  var inspect$1 = debugUtil.inspect;
  var custom = inspect$1 && inspect$1.custom || 'inspect';

  function copyBuffer(src, target, offset) {
    Buffer$2.prototype.copy.call(src, target, offset);
  }

  var buffer_list = /*#__PURE__*/function () {
    function BufferList() {
      _classCallCheck$1(this, BufferList);

      this.head = null;
      this.tail = null;
      this.length = 0;
    }

    _createClass$1(BufferList, [{
      key: "push",
      value: function push(v) {
        var entry = {
          data: v,
          next: null
        };
        if (this.length > 0) this.tail.next = entry;else this.head = entry;
        this.tail = entry;
        ++this.length;
      }
    }, {
      key: "unshift",
      value: function unshift(v) {
        var entry = {
          data: v,
          next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
      }
    }, {
      key: "shift",
      value: function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
        --this.length;
        return ret;
      }
    }, {
      key: "clear",
      value: function clear() {
        this.head = this.tail = null;
        this.length = 0;
      }
    }, {
      key: "join",
      value: function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;

        while (p = p.next) {
          ret += s + p.data;
        }

        return ret;
      }
    }, {
      key: "concat",
      value: function concat(n) {
        if (this.length === 0) return Buffer$2.alloc(0);
        var ret = Buffer$2.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;

        while (p) {
          copyBuffer(p.data, ret, i);
          i += p.data.length;
          p = p.next;
        }

        return ret;
      } // Consumes a specified amount of bytes or characters from the buffered data.

    }, {
      key: "consume",
      value: function consume(n, hasStrings) {
        var ret;

        if (n < this.head.data.length) {
          // `slice` is the same for buffers and strings.
          ret = this.head.data.slice(0, n);
          this.head.data = this.head.data.slice(n);
        } else if (n === this.head.data.length) {
          // First chunk is a perfect match.
          ret = this.shift();
        } else {
          // Result spans more than one buffer.
          ret = hasStrings ? this._getString(n) : this._getBuffer(n);
        }

        return ret;
      }
    }, {
      key: "first",
      value: function first() {
        return this.head.data;
      } // Consumes a specified amount of characters from the buffered data.

    }, {
      key: "_getString",
      value: function _getString(n) {
        var p = this.head;
        var c = 1;
        var ret = p.data;
        n -= ret.length;

        while (p = p.next) {
          var str = p.data;
          var nb = n > str.length ? str.length : n;
          if (nb === str.length) ret += str;else ret += str.slice(0, n);
          n -= nb;

          if (n === 0) {
            if (nb === str.length) {
              ++c;
              if (p.next) this.head = p.next;else this.head = this.tail = null;
            } else {
              this.head = p;
              p.data = str.slice(nb);
            }

            break;
          }

          ++c;
        }

        this.length -= c;
        return ret;
      } // Consumes a specified amount of bytes from the buffered data.

    }, {
      key: "_getBuffer",
      value: function _getBuffer(n) {
        var ret = Buffer$2.allocUnsafe(n);
        var p = this.head;
        var c = 1;
        p.data.copy(ret);
        n -= p.data.length;

        while (p = p.next) {
          var buf = p.data;
          var nb = n > buf.length ? buf.length : n;
          buf.copy(ret, ret.length - n, 0, nb);
          n -= nb;

          if (n === 0) {
            if (nb === buf.length) {
              ++c;
              if (p.next) this.head = p.next;else this.head = this.tail = null;
            } else {
              this.head = p;
              p.data = buf.slice(nb);
            }

            break;
          }

          ++c;
        }

        this.length -= c;
        return ret;
      } // Make sure the linked list only shows the minimal necessary information.

    }, {
      key: custom,
      value: function value(_, options) {
        return inspect$1(this, _objectSpread({}, options, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: false
        }));
      }
    }]);

    return BufferList;
  }();

  function destroy(err, cb) {
    var _this = this;

    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;

    if (readableDestroyed || writableDestroyed) {
      if (cb) {
        cb(err);
      } else if (err) {
        if (!this._writableState) {
          nextTick(emitErrorNT, this, err);
        } else if (!this._writableState.errorEmitted) {
          this._writableState.errorEmitted = true;
          nextTick(emitErrorNT, this, err);
        }
      }

      return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks


    if (this._readableState) {
      this._readableState.destroyed = true;
    } // if this is a duplex stream mark the writable part as destroyed as well


    if (this._writableState) {
      this._writableState.destroyed = true;
    }

    this._destroy(err || null, function (err) {
      if (!cb && err) {
        if (!_this._writableState) {
          nextTick(emitErrorAndCloseNT, _this, err);
        } else if (!_this._writableState.errorEmitted) {
          _this._writableState.errorEmitted = true;
          nextTick(emitErrorAndCloseNT, _this, err);
        } else {
          nextTick(emitCloseNT, _this);
        }
      } else if (cb) {
        nextTick(emitCloseNT, _this);
        cb(err);
      } else {
        nextTick(emitCloseNT, _this);
      }
    });

    return this;
  }

  function emitErrorAndCloseNT(self, err) {
    emitErrorNT(self, err);
    emitCloseNT(self);
  }

  function emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
  }

  function undestroy() {
    if (this._readableState) {
      this._readableState.destroyed = false;
      this._readableState.reading = false;
      this._readableState.ended = false;
      this._readableState.endEmitted = false;
    }

    if (this._writableState) {
      this._writableState.destroyed = false;
      this._writableState.ended = false;
      this._writableState.ending = false;
      this._writableState.finalCalled = false;
      this._writableState.prefinished = false;
      this._writableState.finished = false;
      this._writableState.errorEmitted = false;
    }
  }

  function emitErrorNT(self, err) {
    self.emit('error', err);
  }

  function errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
  }

  var destroy_1 = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy
  };

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  var codes = {};

  function createErrorType(code, message, Base) {
    if (!Base) {
      Base = Error;
    }

    function getMessage(arg1, arg2, arg3) {
      if (typeof message === 'string') {
        return message;
      } else {
        return message(arg1, arg2, arg3);
      }
    }

    var NodeError = /*#__PURE__*/function (_Base) {
      _inheritsLoose(NodeError, _Base);

      function NodeError(arg1, arg2, arg3) {
        return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
      }

      return NodeError;
    }(Base);

    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
  } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


  function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
      var len = expected.length;
      expected = expected.map(function (i) {
        return String(i);
      });

      if (len > 2) {
        return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
      } else if (len === 2) {
        return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
      } else {
        return "of ".concat(thing, " ").concat(expected[0]);
      }
    } else {
      return "of ".concat(thing, " ").concat(String(expected));
    }
  } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


  function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


  function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) {
      this_len = str.length;
    }

    return str.substring(this_len - search.length, this_len) === search;
  } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


  function includes(str, search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > str.length) {
      return false;
    } else {
      return str.indexOf(search, start) !== -1;
    }
  }

  createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
  }, TypeError);
  createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;

    if (typeof expected === 'string' && startsWith(expected, 'not ')) {
      determiner = 'must not be';
      expected = expected.replace(/^not /, '');
    } else {
      determiner = 'must be';
    }

    var msg;

    if (endsWith(name, ' argument')) {
      // For cases like 'first argument'
      msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    } else {
      var type = includes(name, '.') ? 'property' : 'argument';
      msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    }

    msg += ". Received type ".concat(_typeof(actual));
    return msg;
  }, TypeError);
  createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
  createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
    return 'The ' + name + ' method is not implemented';
  });
  createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
  createErrorType('ERR_STREAM_DESTROYED', function (name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
  });
  createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
  createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
  createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
  createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
  createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
    return 'Unknown encoding: ' + arg;
  }, TypeError);
  createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
  var codes_1 = codes;
  var errorsBrowser = {
    codes: codes_1
  };

  var ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;

  function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
  }

  function getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);

    if (hwm != null) {
      if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
        var name = isDuplex ? duplexKey : 'highWaterMark';
        throw new ERR_INVALID_OPT_VALUE(name, hwm);
      }

      return Math.floor(hwm);
    } // Default value


    return state.objectMode ? 16 : 16 * 1024;
  }

  var state = {
    getHighWaterMark: getHighWaterMark
  };

  /**
   * Module exports.
   */

  var browser$1 = deprecate$1;
  /**
   * Mark that a method should not be used.
   * Returns a modified function which warns once by default.
   *
   * If `localStorage.noDeprecation = true` is set, then it is a no-op.
   *
   * If `localStorage.throwDeprecation = true` is set, then deprecated functions
   * will throw an Error when invoked.
   *
   * If `localStorage.traceDeprecation = true` is set, then deprecated functions
   * will invoke `console.trace()` instead of `console.error()`.
   *
   * @param {Function} fn - the function to deprecate
   * @param {String} msg - the string to print to the console when `fn` is invoked
   * @returns {Function} a new "deprecated" version of `fn`
   * @api public
   */

  function deprecate$1(fn, msg) {
    if (config$1('noDeprecation')) {
      return fn;
    }

    var warned = false;

    function deprecated() {
      if (!warned) {
        if (config$1('throwDeprecation')) {
          throw new Error(msg);
        } else if (config$1('traceDeprecation')) {
          console.trace(msg);
        } else {
          console.warn(msg);
        }

        warned = true;
      }

      return fn.apply(this, arguments);
    }

    return deprecated;
  }
  /**
   * Checks `localStorage` for boolean values for the given `name`.
   *
   * @param {String} name
   * @returns {Boolean}
   * @api private
   */


  function config$1(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
      if (!commonjsGlobal.localStorage) return false;
    } catch (_) {
      return false;
    }

    var val = commonjsGlobal.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
  }

  var _stream_writable = Writable;
  // there will be only 2 of these for each stream


  function CorkedRequest(state) {
    var _this = this;

    this.next = null;
    this.entry = null;

    this.finish = function () {
      onCorkedFinish(_this, state);
    };
  }
  /* </replacement> */

  /*<replacement>*/


  var Duplex;
  /*</replacement>*/

  Writable.WritableState = WritableState;
  /*<replacement>*/

  var internalUtil = {
    deprecate: browser$1
  };
  /*</replacement>*/

  /*<replacement>*/

  /*</replacement>*/

  var Buffer$3 = bufferEs6.Buffer;

  var OurUint8Array = commonjsGlobal.Uint8Array || function () {};

  function _uint8ArrayToBuffer(chunk) {
    return Buffer$3.from(chunk);
  }

  function _isUint8Array(obj) {
    return Buffer$3.isBuffer(obj) || obj instanceof OurUint8Array;
  }

  var getHighWaterMark$1 = state.getHighWaterMark;
  var _require$codes = errorsBrowser.codes,
      ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
      ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
      ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
      ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
      ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
      ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
      ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
      ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
  var errorOrDestroy$1 = destroy_1.errorOrDestroy;
  inherits_browser(Writable, streamBrowser);

  function nop() {}

  function WritableState(options, stream, isDuplex) {
    Duplex = Duplex || _stream_duplex;
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.

    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.

    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()

    this.highWaterMark = getHighWaterMark$1(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called

    this.finalCalled = false; // drain event flag.

    this.needDrain = false; // at the start of calling end()

    this.ending = false; // when end() has been called, and returned

    this.ended = false; // when 'finish' is emitted

    this.finished = false; // has it been destroyed

    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.

    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.

    this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.

    this.length = 0; // a flag to see when we're in the middle of a write.

    this.writing = false; // when true all writes will be buffered until .uncork() call

    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.

    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.

    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

    this.onwrite = function (er) {
      onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)


    this.writecb = null; // the amount that is being written when _write is called.

    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted

    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams

    this.prefinished = false; // True if the error was already emitted and should not be thrown again

    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.

    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')

    this.autoDestroy = !!options.autoDestroy; // count buffered requests

    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two

    this.corkedRequestsFree = new CorkedRequest(this);
  }

  WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];

    while (current) {
      out.push(current);
      current = current.next;
    }

    return out;
  };

  (function () {
    try {
      Object.defineProperty(WritableState.prototype, 'buffer', {
        get: internalUtil.deprecate(function writableStateBufferGetter() {
          return this.getBuffer();
        }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
      });
    } catch (_) {}
  })(); // Test _writableState for inheritance to account for Duplex streams,
  // whose prototype chain only points to Readable.


  var realHasInstance;

  if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
      value: function value(object) {
        if (realHasInstance.call(this, object)) return true;
        if (this !== Writable) return false;
        return object && object._writableState instanceof WritableState;
      }
    });
  } else {
    realHasInstance = function realHasInstance(object) {
      return object instanceof this;
    };
  }

  function Writable(options) {
    Duplex = Duplex || _stream_duplex; // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5

    var isDuplex = this instanceof Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex); // legacy.

    this.writable = true;

    if (options) {
      if (typeof options.write === 'function') this._write = options.write;
      if (typeof options.writev === 'function') this._writev = options.writev;
      if (typeof options.destroy === 'function') this._destroy = options.destroy;
      if (typeof options["final"] === 'function') this._final = options["final"];
    }

    streamBrowser.call(this);
  } // Otherwise people can pipe Writable streams, which is just wrong.


  Writable.prototype.pipe = function () {
    errorOrDestroy$1(this, new ERR_STREAM_CANNOT_PIPE());
  };

  function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb

    errorOrDestroy$1(stream, er);
    nextTick(cb, er);
  } // Checks that a user-supplied chunk is valid, especially for the particular
  // mode the stream is in. Currently this means that `null` is never accepted
  // and undefined/non-string values are only allowed in object mode.


  function validChunk(stream, state, chunk, cb) {
    var er;

    if (chunk === null) {
      er = new ERR_STREAM_NULL_VALUES();
    } else if (typeof chunk !== 'string' && !state.objectMode) {
      er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
    }

    if (er) {
      errorOrDestroy$1(stream, er);
      nextTick(cb, er);
      return false;
    }

    return true;
  }

  Writable.prototype.write = function (chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;

    var isBuf = !state.objectMode && _isUint8Array(chunk);

    if (isBuf && !Buffer$3.isBuffer(chunk)) {
      chunk = _uint8ArrayToBuffer(chunk);
    }

    if (typeof encoding === 'function') {
      cb = encoding;
      encoding = null;
    }

    if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = nop;
    if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
      state.pendingcb++;
      ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
  };

  Writable.prototype.cork = function () {
    this._writableState.corked++;
  };

  Writable.prototype.uncork = function () {
    var state = this._writableState;

    if (state.corked) {
      state.corked--;
      if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
  };

  Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
  };

  Object.defineProperty(Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._writableState && this._writableState.getBuffer();
    }
  });

  function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
      chunk = Buffer$3.from(chunk, encoding);
    }

    return chunk;
  }

  Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._writableState.highWaterMark;
    }
  }); // if we're already writing something, then just put this
  // in the queue, and wait our turn.  Otherwise, call _write
  // If we return false, then we need a drain event, so set that flag.

  function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
      var newChunk = decodeChunk(state, chunk, encoding);

      if (chunk !== newChunk) {
        isBuf = true;
        encoding = 'buffer';
        chunk = newChunk;
      }
    }

    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

    if (!ret) state.needDrain = true;

    if (state.writing || state.corked) {
      var last = state.lastBufferedRequest;
      state.lastBufferedRequest = {
        chunk: chunk,
        encoding: encoding,
        isBuf: isBuf,
        callback: cb,
        next: null
      };

      if (last) {
        last.next = state.lastBufferedRequest;
      } else {
        state.bufferedRequest = state.lastBufferedRequest;
      }

      state.bufferedRequestCount += 1;
    } else {
      doWrite(stream, state, false, len, chunk, encoding, cb);
    }

    return ret;
  }

  function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
  }

  function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;

    if (sync) {
      // defer the callback if we are being called synchronously
      // to avoid piling up things on the stack
      nextTick(cb, er); // this can emit finish, and it will always happen
      // after error

      nextTick(finishMaybe, stream, state);
      stream._writableState.errorEmitted = true;
      errorOrDestroy$1(stream, er);
    } else {
      // the caller expect this to happen before if
      // it is async
      cb(er);
      stream._writableState.errorEmitted = true;
      errorOrDestroy$1(stream, er); // this can emit finish, but finish must
      // always follow error

      finishMaybe(stream, state);
    }
  }

  function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
  }

  function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);else {
      // Check if we're actually ready to finish, but don't emit yet
      var finished = needFinish(state) || stream.destroyed;

      if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
        clearBuffer(stream, state);
      }

      if (sync) {
        nextTick(afterWrite, stream, state, finished, cb);
      } else {
        afterWrite(stream, state, finished, cb);
      }
    }
  }

  function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
  } // Must force callback to be called on nextTick, so that we don't
  // emit 'drain' before the write() consumer gets the 'false' return
  // value, and has a chance to attach a 'drain' listener.


  function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
      state.needDrain = false;
      stream.emit('drain');
    }
  } // if there's something in the buffer waiting, then process it


  function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;

    if (stream._writev && entry && entry.next) {
      // Fast case, write everything using _writev()
      var l = state.bufferedRequestCount;
      var buffer = new Array(l);
      var holder = state.corkedRequestsFree;
      holder.entry = entry;
      var count = 0;
      var allBuffers = true;

      while (entry) {
        buffer[count] = entry;
        if (!entry.isBuf) allBuffers = false;
        entry = entry.next;
        count += 1;
      }

      buffer.allBuffers = allBuffers;
      doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
      // as the hot path ends with doWrite

      state.pendingcb++;
      state.lastBufferedRequest = null;

      if (holder.next) {
        state.corkedRequestsFree = holder.next;
        holder.next = null;
      } else {
        state.corkedRequestsFree = new CorkedRequest(state);
      }

      state.bufferedRequestCount = 0;
    } else {
      // Slow case, write chunks one-by-one
      while (entry) {
        var chunk = entry.chunk;
        var encoding = entry.encoding;
        var cb = entry.callback;
        var len = state.objectMode ? 1 : chunk.length;
        doWrite(stream, state, false, len, chunk, encoding, cb);
        entry = entry.next;
        state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
        // it means that we need to wait until it does.
        // also, that means that the chunk and cb are currently
        // being processed, so move the buffer counter past them.

        if (state.writing) {
          break;
        }
      }

      if (entry === null) state.lastBufferedRequest = null;
    }

    state.bufferedRequest = entry;
    state.bufferProcessing = false;
  }

  Writable.prototype._write = function (chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
  };

  Writable.prototype._writev = null;

  Writable.prototype.end = function (chunk, encoding, cb) {
    var state = this._writableState;

    if (typeof chunk === 'function') {
      cb = chunk;
      chunk = null;
      encoding = null;
    } else if (typeof encoding === 'function') {
      cb = encoding;
      encoding = null;
    }

    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

    if (state.corked) {
      state.corked = 1;
      this.uncork();
    } // ignore unnecessary end() calls.


    if (!state.ending) endWritable(this, state, cb);
    return this;
  };

  Object.defineProperty(Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._writableState.length;
    }
  });

  function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
  }

  function callFinal(stream, state) {
    stream._final(function (err) {
      state.pendingcb--;

      if (err) {
        errorOrDestroy$1(stream, err);
      }

      state.prefinished = true;
      stream.emit('prefinish');
      finishMaybe(stream, state);
    });
  }

  function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
      if (typeof stream._final === 'function' && !state.destroyed) {
        state.pendingcb++;
        state.finalCalled = true;
        nextTick(callFinal, stream, state);
      } else {
        state.prefinished = true;
        stream.emit('prefinish');
      }
    }
  }

  function finishMaybe(stream, state) {
    var need = needFinish(state);

    if (need) {
      prefinish(stream, state);

      if (state.pendingcb === 0) {
        state.finished = true;
        stream.emit('finish');

        if (state.autoDestroy) {
          // In case of duplex streams we need a way to detect
          // if the readable side is ready for autoDestroy as well
          var rState = stream._readableState;

          if (!rState || rState.autoDestroy && rState.endEmitted) {
            stream.destroy();
          }
        }
      }
    }

    return need;
  }

  function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);

    if (cb) {
      if (state.finished) nextTick(cb);else stream.once('finish', cb);
    }

    state.ended = true;
    stream.writable = false;
  }

  function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;

    while (entry) {
      var cb = entry.callback;
      state.pendingcb--;
      cb(err);
      entry = entry.next;
    } // reuse the free corkReq.


    state.corkedRequestsFree.next = corkReq;
  }

  Object.defineProperty(Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      if (this._writableState === undefined) {
        return false;
      }

      return this._writableState.destroyed;
    },
    set: function set(value) {
      // we ignore the value if the stream
      // has not been initialized yet
      if (!this._writableState) {
        return;
      } // backward compatibility, the user is explicitly
      // managing destroyed


      this._writableState.destroyed = value;
    }
  });
  Writable.prototype.destroy = destroy_1.destroy;
  Writable.prototype._undestroy = destroy_1.undestroy;

  Writable.prototype._destroy = function (err, cb) {
    cb(err);
  };

  /*<replacement>*/


  var objectKeys = Object.keys || function (obj) {
    var keys = [];

    for (var key in obj) {
      keys.push(key);
    }

    return keys;
  };
  /*</replacement>*/


  var _stream_duplex = Duplex$1;
  inherits_browser(Duplex$1, _stream_readable);
  {
    // Allow the keys array to be GC'ed.
    var keys = objectKeys(_stream_writable.prototype);

    for (var v = 0; v < keys.length; v++) {
      var method = keys[v];
      if (!Duplex$1.prototype[method]) Duplex$1.prototype[method] = _stream_writable.prototype[method];
    }
  }

  function Duplex$1(options) {
    if (!(this instanceof Duplex$1)) return new Duplex$1(options);
    _stream_readable.call(this, options);
    _stream_writable.call(this, options);
    this.allowHalfOpen = true;

    if (options) {
      if (options.readable === false) this.readable = false;
      if (options.writable === false) this.writable = false;

      if (options.allowHalfOpen === false) {
        this.allowHalfOpen = false;
        this.once('end', onend);
      }
    }
  }

  Object.defineProperty(Duplex$1.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._writableState.highWaterMark;
    }
  });
  Object.defineProperty(Duplex$1.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  Object.defineProperty(Duplex$1.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._writableState.length;
    }
  }); // the no-half-open enforcer

  function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.

    nextTick(onEndNT, this);
  }

  function onEndNT(self) {
    self.end();
  }

  Object.defineProperty(Duplex$1.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      if (this._readableState === undefined || this._writableState === undefined) {
        return false;
      }

      return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
      // we ignore the value if the stream
      // has not been initialized yet
      if (this._readableState === undefined || this._writableState === undefined) {
        return;
      } // backward compatibility, the user is explicitly
      // managing destroyed


      this._readableState.destroyed = value;
      this._writableState.destroyed = value;
    }
  });

  /*<replacement>*/


  var Buffer$4 = safeBuffer.Buffer;
  /*</replacement>*/

  var isEncoding = Buffer$4.isEncoding || function (encoding) {
    encoding = '' + encoding;

    switch (encoding && encoding.toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
      case 'raw':
        return true;

      default:
        return false;
    }
  };

  function _normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;

    while (true) {
      switch (enc) {
        case 'utf8':
        case 'utf-8':
          return 'utf8';

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return 'utf16le';

        case 'latin1':
        case 'binary':
          return 'latin1';

        case 'base64':
        case 'ascii':
        case 'hex':
          return enc;

        default:
          if (retried) return; // undefined

          enc = ('' + enc).toLowerCase();
          retried = true;
      }
    }
  }
  // modules monkey-patch it to support additional encodings

  function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);

    if (typeof nenc !== 'string' && (Buffer$4.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
  } // StringDecoder provides an interface for efficiently splitting a series of
  // buffers into a series of JS strings without breaking apart multi-byte
  // characters.


  var StringDecoder_1 = StringDecoder;

  function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;

    switch (this.encoding) {
      case 'utf16le':
        this.text = utf16Text;
        this.end = utf16End;
        nb = 4;
        break;

      case 'utf8':
        this.fillLast = utf8FillLast;
        nb = 4;
        break;

      case 'base64':
        this.text = base64Text;
        this.end = base64End;
        nb = 3;
        break;

      default:
        this.write = simpleWrite;
        this.end = simpleEnd;
        return;
    }

    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer$4.allocUnsafe(nb);
  }

  StringDecoder.prototype.write = function (buf) {
    if (buf.length === 0) return '';
    var r;
    var i;

    if (this.lastNeed) {
      r = this.fillLast(buf);
      if (r === undefined) return '';
      i = this.lastNeed;
      this.lastNeed = 0;
    } else {
      i = 0;
    }

    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
  };

  StringDecoder.prototype.end = utf8End; // Returns only complete characters in a Buffer

  StringDecoder.prototype.text = utf8Text; // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer

  StringDecoder.prototype.fillLast = function (buf) {
    if (this.lastNeed <= buf.length) {
      buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
      return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }

    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
  }; // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
  // continuation byte. If an invalid byte is detected, -2 is returned.


  function utf8CheckByte(_byte) {
    if (_byte <= 0x7F) return 0;else if (_byte >> 5 === 0x06) return 2;else if (_byte >> 4 === 0x0E) return 3;else if (_byte >> 3 === 0x1E) return 4;
    return _byte >> 6 === 0x02 ? -1 : -2;
  } // Checks at most 3 bytes at the end of a Buffer in order to detect an
  // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
  // needed to complete the UTF-8 character (if applicable) are returned.


  function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);

    if (nb >= 0) {
      if (nb > 0) self.lastNeed = nb - 1;
      return nb;
    }

    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);

    if (nb >= 0) {
      if (nb > 0) self.lastNeed = nb - 2;
      return nb;
    }

    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);

    if (nb >= 0) {
      if (nb > 0) {
        if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
      }

      return nb;
    }

    return 0;
  } // Validates as many continuation bytes for a multi-byte UTF-8 character as
  // needed or are available. If we see a non-continuation byte where we expect
  // one, we "replace" the validated continuation bytes we've seen so far with
  // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
  // behavior. The continuation byte check is included three times in the case
  // where all of the continuation bytes for a character exist in the same buffer.
  // It is also done this way as a slight performance increase instead of using a
  // loop.


  function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
      self.lastNeed = 0;
      return "\uFFFD";
    }

    if (self.lastNeed > 1 && buf.length > 1) {
      if ((buf[1] & 0xC0) !== 0x80) {
        self.lastNeed = 1;
        return "\uFFFD";
      }

      if (self.lastNeed > 2 && buf.length > 2) {
        if ((buf[2] & 0xC0) !== 0x80) {
          self.lastNeed = 2;
          return "\uFFFD";
        }
      }
    }
  } // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.


  function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf);
    if (r !== undefined) return r;

    if (this.lastNeed <= buf.length) {
      buf.copy(this.lastChar, p, 0, this.lastNeed);
      return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }

    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
  } // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
  // partial character, the character's bytes are buffered until the required
  // number of bytes are available.


  function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
  } // For UTF-8, a replacement character is added when ending on a partial
  // character.


  function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + "\uFFFD";
    return r;
  } // UTF-16LE typically needs two bytes per character, but even if we have an even
  // number of bytes available, we need to check if we end on a leading/high
  // surrogate. In that case, we need to wait for the next two bytes in order to
  // decode the last character properly.


  function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
      var r = buf.toString('utf16le', i);

      if (r) {
        var c = r.charCodeAt(r.length - 1);

        if (c >= 0xD800 && c <= 0xDBFF) {
          this.lastNeed = 2;
          this.lastTotal = 4;
          this.lastChar[0] = buf[buf.length - 2];
          this.lastChar[1] = buf[buf.length - 1];
          return r.slice(0, -1);
        }
      }

      return r;
    }

    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
  } // For UTF-16LE we do not explicitly append special replacement characters if we
  // end on a partial character, we simply let v8 handle that.


  function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';

    if (this.lastNeed) {
      var end = this.lastTotal - this.lastNeed;
      return r + this.lastChar.toString('utf16le', 0, end);
    }

    return r;
  }

  function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;

    if (n === 1) {
      this.lastChar[0] = buf[buf.length - 1];
    } else {
      this.lastChar[0] = buf[buf.length - 2];
      this.lastChar[1] = buf[buf.length - 1];
    }

    return buf.toString('base64', i, buf.length - n);
  }

  function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
  } // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)


  function simpleWrite(buf) {
    return buf.toString(this.encoding);
  }

  function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
  }

  var string_decoder = {
    StringDecoder: StringDecoder_1
  };

  var ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;

  function once$1(callback) {
    var called = false;
    return function () {
      if (called) return;
      called = true;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      callback.apply(this, args);
    };
  }

  function noop$1() {}

  function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
  }

  function eos(stream, opts, callback) {
    if (typeof opts === 'function') return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once$1(callback || noop$1);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;

    var onlegacyfinish = function onlegacyfinish() {
      if (!stream.writable) onfinish();
    };

    var writableEnded = stream._writableState && stream._writableState.finished;

    var onfinish = function onfinish() {
      writable = false;
      writableEnded = true;
      if (!readable) callback.call(stream);
    };

    var readableEnded = stream._readableState && stream._readableState.endEmitted;

    var onend = function onend() {
      readable = false;
      readableEnded = true;
      if (!writable) callback.call(stream);
    };

    var onerror = function onerror(err) {
      callback.call(stream, err);
    };

    var onclose = function onclose() {
      var err;

      if (readable && !readableEnded) {
        if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
        return callback.call(stream, err);
      }

      if (writable && !writableEnded) {
        if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
        return callback.call(stream, err);
      }
    };

    var onrequest = function onrequest() {
      stream.req.on('finish', onfinish);
    };

    if (isRequest(stream)) {
      stream.on('complete', onfinish);
      stream.on('abort', onclose);
      if (stream.req) onrequest();else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
      // legacy streams
      stream.on('end', onlegacyfinish);
      stream.on('close', onlegacyfinish);
    }

    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function () {
      stream.removeListener('complete', onfinish);
      stream.removeListener('abort', onclose);
      stream.removeListener('request', onrequest);
      if (stream.req) stream.req.removeListener('finish', onfinish);
      stream.removeListener('end', onlegacyfinish);
      stream.removeListener('close', onlegacyfinish);
      stream.removeListener('finish', onfinish);
      stream.removeListener('end', onend);
      stream.removeListener('error', onerror);
      stream.removeListener('close', onclose);
    };
  }

  var endOfStream = eos;

  var _Object$setPrototypeO;

  function _defineProperty$2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var kLastResolve = Symbol('lastResolve');
  var kLastReject = Symbol('lastReject');
  var kError = Symbol('error');
  var kEnded = Symbol('ended');
  var kLastPromise = Symbol('lastPromise');
  var kHandlePromise = Symbol('handlePromise');
  var kStream = Symbol('stream');

  function createIterResult(value, done) {
    return {
      value: value,
      done: done
    };
  }

  function readAndResolve(iter) {
    var resolve = iter[kLastResolve];

    if (resolve !== null) {
      var data = iter[kStream].read(); // we defer if data is null
      // we can be expecting either 'end' or
      // 'error'

      if (data !== null) {
        iter[kLastPromise] = null;
        iter[kLastResolve] = null;
        iter[kLastReject] = null;
        resolve(createIterResult(data, false));
      }
    }
  }

  function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    nextTick(readAndResolve, iter);
  }

  function wrapForNext(lastPromise, iter) {
    return function (resolve, reject) {
      lastPromise.then(function () {
        if (iter[kEnded]) {
          resolve(createIterResult(undefined, true));
          return;
        }

        iter[kHandlePromise](resolve, reject);
      }, reject);
    };
  }

  var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
  var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream() {
      return this[kStream];
    },

    next: function next() {
      var _this = this; // if we have detected an error in the meanwhile
      // reject straight away


      var error = this[kError];

      if (error !== null) {
        return Promise.reject(error);
      }

      if (this[kEnded]) {
        return Promise.resolve(createIterResult(undefined, true));
      }

      if (this[kStream].destroyed) {
        // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function (resolve, reject) {
          nextTick(function () {
            if (_this[kError]) {
              reject(_this[kError]);
            } else {
              resolve(createIterResult(undefined, true));
            }
          });
        });
      } // if we have multiple next() calls
      // we will wait for the previous Promise to finish
      // this logic is optimized to support for await loops,
      // where next() is only called once at a time


      var lastPromise = this[kLastPromise];
      var promise;

      if (lastPromise) {
        promise = new Promise(wrapForNext(lastPromise, this));
      } else {
        // fast path needed to support multiple this.push()
        // without triggering the next() queue
        var data = this[kStream].read();

        if (data !== null) {
          return Promise.resolve(createIterResult(data, false));
        }

        promise = new Promise(this[kHandlePromise]);
      }

      this[kLastPromise] = promise;
      return promise;
    }
  }, _defineProperty$2(_Object$setPrototypeO, Symbol.asyncIterator, function () {
    return this;
  }), _defineProperty$2(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this; // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to


    return new Promise(function (resolve, reject) {
      _this2[kStream].destroy(null, function (err) {
        if (err) {
          reject(err);
          return;
        }

        resolve(createIterResult(undefined, true));
      });
    });
  }), _Object$setPrototypeO), AsyncIteratorPrototype);

  var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;

    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty$2(_Object$create, kStream, {
      value: stream,
      writable: true
    }), _defineProperty$2(_Object$create, kLastResolve, {
      value: null,
      writable: true
    }), _defineProperty$2(_Object$create, kLastReject, {
      value: null,
      writable: true
    }), _defineProperty$2(_Object$create, kError, {
      value: null,
      writable: true
    }), _defineProperty$2(_Object$create, kEnded, {
      value: stream._readableState.endEmitted,
      writable: true
    }), _defineProperty$2(_Object$create, kHandlePromise, {
      value: function value(resolve, reject) {
        var data = iterator[kStream].read();

        if (data) {
          iterator[kLastPromise] = null;
          iterator[kLastResolve] = null;
          iterator[kLastReject] = null;
          resolve(createIterResult(data, false));
        } else {
          iterator[kLastResolve] = resolve;
          iterator[kLastReject] = reject;
        }
      },
      writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    endOfStream(stream, function (err) {
      if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
        var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
        // returned by next() and store the error

        if (reject !== null) {
          iterator[kLastPromise] = null;
          iterator[kLastResolve] = null;
          iterator[kLastReject] = null;
          reject(err);
        }

        iterator[kError] = err;
        return;
      }

      var resolve = iterator[kLastResolve];

      if (resolve !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(undefined, true));
      }

      iterator[kEnded] = true;
    });
    stream.on('readable', onReadable.bind(null, iterator));
    return iterator;
  };

  var async_iterator = createReadableStreamAsyncIterator;

  var fromBrowser = function fromBrowser() {
    throw new Error('Readable.from is not available in the browser');
  };

  var _stream_readable = Readable;
  /*<replacement>*/

  var Duplex$2;
  /*</replacement>*/

  Readable.ReadableState = ReadableState;

  var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
  };
  /*</replacement>*/

  /*<replacement>*/

  /*</replacement>*/


  var Buffer$5 = bufferEs6.Buffer;

  var OurUint8Array$1 = commonjsGlobal.Uint8Array || function () {};

  function _uint8ArrayToBuffer$1(chunk) {
    return Buffer$5.from(chunk);
  }

  function _isUint8Array$1(obj) {
    return Buffer$5.isBuffer(obj) || obj instanceof OurUint8Array$1;
  }
  /*<replacement>*/


  var debug;

  if (debugUtil && debugUtil.debuglog) {
    debug = debugUtil.debuglog('stream');
  } else {
    debug = function debug() {};
  }
  /*</replacement>*/


  var getHighWaterMark$2 = state.getHighWaterMark;
  var _require$codes$1 = errorsBrowser.codes,
      ERR_INVALID_ARG_TYPE$1 = _require$codes$1.ERR_INVALID_ARG_TYPE,
      ERR_STREAM_PUSH_AFTER_EOF = _require$codes$1.ERR_STREAM_PUSH_AFTER_EOF,
      ERR_METHOD_NOT_IMPLEMENTED$1 = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED,
      ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes$1.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.

  var StringDecoder$1;
  var createReadableStreamAsyncIterator$1;
  var from$1;
  inherits_browser(Readable, streamBrowser);
  var errorOrDestroy$2 = destroy_1.errorOrDestroy;
  var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

  function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.

    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
  }

  function ReadableState(options, stream, isDuplex) {
    Duplex$2 = Duplex$2 || _stream_duplex;
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.

    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex$2; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away

    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"

    this.highWaterMark = getHighWaterMark$2(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()

    this.buffer = new buffer_list();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.

    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.

    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.

    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')

    this.autoDestroy = !!options.autoDestroy; // has it been destroyed

    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.

    this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;

    if (options.encoding) {
      if (!StringDecoder$1) StringDecoder$1 = string_decoder.StringDecoder;
      this.decoder = new StringDecoder$1(options.encoding);
      this.encoding = options.encoding;
    }
  }

  function Readable(options) {
    Duplex$2 = Duplex$2 || _stream_duplex;
    if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5

    var isDuplex = this instanceof Duplex$2;
    this._readableState = new ReadableState(options, this, isDuplex); // legacy

    this.readable = true;

    if (options) {
      if (typeof options.read === 'function') this._read = options.read;
      if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }

    streamBrowser.call(this);
  }

  Object.defineProperty(Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      if (this._readableState === undefined) {
        return false;
      }

      return this._readableState.destroyed;
    },
    set: function set(value) {
      // we ignore the value if the stream
      // has not been initialized yet
      if (!this._readableState) {
        return;
      } // backward compatibility, the user is explicitly
      // managing destroyed


      this._readableState.destroyed = value;
    }
  });
  Readable.prototype.destroy = destroy_1.destroy;
  Readable.prototype._undestroy = destroy_1.undestroy;

  Readable.prototype._destroy = function (err, cb) {
    cb(err);
  }; // Manually shove something into the read() buffer.
  // This returns true if the highWaterMark has not been hit yet,
  // similar to how Writable.write() returns true if you should
  // write() some more.


  Readable.prototype.push = function (chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;

    if (!state.objectMode) {
      if (typeof chunk === 'string') {
        encoding = encoding || state.defaultEncoding;

        if (encoding !== state.encoding) {
          chunk = Buffer$5.from(chunk, encoding);
          encoding = '';
        }

        skipChunkCheck = true;
      }
    } else {
      skipChunkCheck = true;
    }

    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
  }; // Unshift should *always* be something directly out of read()


  Readable.prototype.unshift = function (chunk) {
    return readableAddChunk(this, chunk, null, true, false);
  };

  function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug('readableAddChunk', chunk);
    var state = stream._readableState;

    if (chunk === null) {
      state.reading = false;
      onEofChunk(stream, state);
    } else {
      var er;
      if (!skipChunkCheck) er = chunkInvalid(state, chunk);

      if (er) {
        errorOrDestroy$2(stream, er);
      } else if (state.objectMode || chunk && chunk.length > 0) {
        if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer$5.prototype) {
          chunk = _uint8ArrayToBuffer$1(chunk);
        }

        if (addToFront) {
          if (state.endEmitted) errorOrDestroy$2(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
        } else if (state.ended) {
          errorOrDestroy$2(stream, new ERR_STREAM_PUSH_AFTER_EOF());
        } else if (state.destroyed) {
          return false;
        } else {
          state.reading = false;

          if (state.decoder && !encoding) {
            chunk = state.decoder.write(chunk);
            if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
          } else {
            addChunk(stream, state, chunk, false);
          }
        }
      } else if (!addToFront) {
        state.reading = false;
        maybeReadMore(stream, state);
      }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.


    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
  }

  function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
      state.awaitDrain = 0;
      stream.emit('data', chunk);
    } else {
      // update the buffer info.
      state.length += state.objectMode ? 1 : chunk.length;
      if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
      if (state.needReadable) emitReadable(stream);
    }

    maybeReadMore(stream, state);
  }

  function chunkInvalid(state, chunk) {
    var er;

    if (!_isUint8Array$1(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
      er = new ERR_INVALID_ARG_TYPE$1('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
    }

    return er;
  }

  Readable.prototype.isPaused = function () {
    return this._readableState.flowing === false;
  }; // backwards compatibility.


  Readable.prototype.setEncoding = function (enc) {
    if (!StringDecoder$1) StringDecoder$1 = string_decoder.StringDecoder;
    var decoder = new StringDecoder$1(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8

    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:

    var p = this._readableState.buffer.head;
    var content = '';

    while (p !== null) {
      content += decoder.write(p.data);
      p = p.next;
    }

    this._readableState.buffer.clear();

    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
  }; // Don't raise the hwm > 1GB


  var MAX_HWM = 0x40000000;

  function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) {
      // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
      n = MAX_HWM;
    } else {
      // Get the next highest power of 2 to prevent increasing hwm excessively in
      // tiny amounts
      n--;
      n |= n >>> 1;
      n |= n >>> 2;
      n |= n >>> 4;
      n |= n >>> 8;
      n |= n >>> 16;
      n++;
    }

    return n;
  } // This function is designed to be inlinable, so please take care when making
  // changes to the function body.


  function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;

    if (n !== n) {
      // Only flow one buffer at a time
      if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.


    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough

    if (!state.ended) {
      state.needReadable = true;
      return 0;
    }

    return state.length;
  } // you can override either this method, or the async _read(n) below.


  Readable.prototype.read = function (n) {
    debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.

    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
      debug('read: emitReadable', state.length, state.ended);
      if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
      return null;
    }

    n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

    if (n === 0 && state.ended) {
      if (state.length === 0) endReadable(this);
      return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.


    var doRead = state.needReadable;
    debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

    if (state.length === 0 || state.length - n < state.highWaterMark) {
      doRead = true;
      debug('length less than watermark', doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.


    if (state.ended || state.reading) {
      doRead = false;
      debug('reading or ended', doRead);
    } else if (doRead) {
      debug('do read');
      state.reading = true;
      state.sync = true; // if the length is currently zero, then we *need* a readable event.

      if (state.length === 0) state.needReadable = true; // call internal read method

      this._read(state.highWaterMark);

      state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
      // and we need to re-evaluate how much data we can return to the user.

      if (!state.reading) n = howMuchToRead(nOrig, state);
    }

    var ret;
    if (n > 0) ret = fromList(n, state);else ret = null;

    if (ret === null) {
      state.needReadable = state.length <= state.highWaterMark;
      n = 0;
    } else {
      state.length -= n;
      state.awaitDrain = 0;
    }

    if (state.length === 0) {
      // If we have nothing in the buffer, then we want to know
      // as soon as we *do* get something into the buffer.
      if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

      if (nOrig !== n && state.ended) endReadable(this);
    }

    if (ret !== null) this.emit('data', ret);
    return ret;
  };

  function onEofChunk(stream, state) {
    debug('onEofChunk');
    if (state.ended) return;

    if (state.decoder) {
      var chunk = state.decoder.end();

      if (chunk && chunk.length) {
        state.buffer.push(chunk);
        state.length += state.objectMode ? 1 : chunk.length;
      }
    }

    state.ended = true;

    if (state.sync) {
      // if we are sync, wait until next tick to emit the data.
      // Otherwise we risk emitting data in the flow()
      // the readable code triggers during a read() call
      emitReadable(stream);
    } else {
      // emit 'readable' now to make sure it gets picked up.
      state.needReadable = false;

      if (!state.emittedReadable) {
        state.emittedReadable = true;
        emitReadable_(stream);
      }
    }
  } // Don't emit readable right away in sync mode, because this can trigger
  // another read() call => stack overflow.  This way, it might trigger
  // a nextTick recursion warning, but that's not so bad.


  function emitReadable(stream) {
    var state = stream._readableState;
    debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;

    if (!state.emittedReadable) {
      debug('emitReadable', state.flowing);
      state.emittedReadable = true;
      nextTick(emitReadable_, stream);
    }
  }

  function emitReadable_(stream) {
    var state = stream._readableState;
    debug('emitReadable_', state.destroyed, state.length, state.ended);

    if (!state.destroyed && (state.length || state.ended)) {
      stream.emit('readable');
      state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.


    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
  } // at this point, the user has presumably seen the 'readable' event,
  // and called read() to consume some data.  that may have triggered
  // in turn another _read(n) call, in which case reading = true if
  // it's in progress.
  // However, if we're not ended, or reading, and the length < hwm,
  // then go ahead and try to read some more preemptively.


  function maybeReadMore(stream, state) {
    if (!state.readingMore) {
      state.readingMore = true;
      nextTick(maybeReadMore_, stream, state);
    }
  }

  function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
      var len = state.length;
      debug('maybeReadMore read 0');
      stream.read(0);
      if (len === state.length) // didn't get any data, stop spinning.
        break;
    }

    state.readingMore = false;
  } // abstract method.  to be overridden in specific implementation classes.
  // call cb(er, data) where data is <= n in length.
  // for virtual (non-string, non-buffer) streams, "length" is somewhat
  // arbitrary, and perhaps not very meaningful.


  Readable.prototype._read = function (n) {
    errorOrDestroy$2(this, new ERR_METHOD_NOT_IMPLEMENTED$1('_read()'));
  };

  Readable.prototype.pipe = function (dest, pipeOpts) {
    var src = this;
    var state = this._readableState;

    switch (state.pipesCount) {
      case 0:
        state.pipes = dest;
        break;

      case 1:
        state.pipes = [state.pipes, dest];
        break;

      default:
        state.pipes.push(dest);
        break;
    }

    state.pipesCount += 1;
    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) nextTick(endFn);else src.once('end', endFn);
    dest.on('unpipe', onunpipe);

    function onunpipe(readable, unpipeInfo) {
      debug('onunpipe');

      if (readable === src) {
        if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
          unpipeInfo.hasUnpiped = true;
          cleanup();
        }
      }
    }

    function onend() {
      debug('onend');
      dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.


    var ondrain = pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;

    function cleanup() {
      debug('cleanup'); // cleanup event handlers once the pipe is broken

      dest.removeListener('close', onclose);
      dest.removeListener('finish', onfinish);
      dest.removeListener('drain', ondrain);
      dest.removeListener('error', onerror);
      dest.removeListener('unpipe', onunpipe);
      src.removeListener('end', onend);
      src.removeListener('end', unpipe);
      src.removeListener('data', ondata);
      cleanedUp = true; // if the reader is waiting for a drain event from this
      // specific writer, then it would cause it to never start
      // flowing again.
      // So, if this is awaiting a drain, then we just call it now.
      // If we don't know, then assume that we are waiting for one.

      if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }

    src.on('data', ondata);

    function ondata(chunk) {
      debug('ondata');
      var ret = dest.write(chunk);
      debug('dest.write', ret);

      if (ret === false) {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
          debug('false write response, pause', state.awaitDrain);
          state.awaitDrain++;
        }

        src.pause();
      }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.


    function onerror(er) {
      debug('onerror', er);
      unpipe();
      dest.removeListener('error', onerror);
      if (EElistenerCount(dest, 'error') === 0) errorOrDestroy$2(dest, er);
    } // Make sure our error handler is attached before userland ones.


    prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

    function onclose() {
      dest.removeListener('finish', onfinish);
      unpipe();
    }

    dest.once('close', onclose);

    function onfinish() {
      debug('onfinish');
      dest.removeListener('close', onclose);
      unpipe();
    }

    dest.once('finish', onfinish);

    function unpipe() {
      debug('unpipe');
      src.unpipe(dest);
    } // tell the dest that it's being piped to


    dest.emit('pipe', src); // start the flow if it hasn't been started already.

    if (!state.flowing) {
      debug('pipe resume');
      src.resume();
    }

    return dest;
  };

  function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
      var state = src._readableState;
      debug('pipeOnDrain', state.awaitDrain);
      if (state.awaitDrain) state.awaitDrain--;

      if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
        state.flowing = true;
        flow(src);
      }
    };
  }

  Readable.prototype.unpipe = function (dest) {
    var state = this._readableState;
    var unpipeInfo = {
      hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.

    if (state.pipesCount === 0) return this; // just one destination.  most common case.

    if (state.pipesCount === 1) {
      // passed in one, but it's not the right one.
      if (dest && dest !== state.pipes) return this;
      if (!dest) dest = state.pipes; // got a match.

      state.pipes = null;
      state.pipesCount = 0;
      state.flowing = false;
      if (dest) dest.emit('unpipe', this, unpipeInfo);
      return this;
    } // slow case. multiple pipe destinations.


    if (!dest) {
      // remove all.
      var dests = state.pipes;
      var len = state.pipesCount;
      state.pipes = null;
      state.pipesCount = 0;
      state.flowing = false;

      for (var i = 0; i < len; i++) {
        dests[i].emit('unpipe', this, {
          hasUnpiped: false
        });
      }

      return this;
    } // try to find the right one.


    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
  }; // set up data events if they are asked for
  // Ensure readable listeners eventually get something


  Readable.prototype.on = function (ev, fn) {
    var res = streamBrowser.prototype.on.call(this, ev, fn);
    var state = this._readableState;

    if (ev === 'data') {
      // update readableListening so that resume() may be a no-op
      // a few lines down. This is needed to support once('readable').
      state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused

      if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
      if (!state.endEmitted && !state.readableListening) {
        state.readableListening = state.needReadable = true;
        state.flowing = false;
        state.emittedReadable = false;
        debug('on readable', state.length, state.reading);

        if (state.length) {
          emitReadable(this);
        } else if (!state.reading) {
          nextTick(nReadingNextTick, this);
        }
      }
    }

    return res;
  };

  Readable.prototype.addListener = Readable.prototype.on;

  Readable.prototype.removeListener = function (ev, fn) {
    var res = streamBrowser.prototype.removeListener.call(this, ev, fn);

    if (ev === 'readable') {
      // We need to check if there is someone still listening to
      // readable and reset the state. However this needs to happen
      // after readable has been emitted but before I/O (nextTick) to
      // support once('readable', fn) cycles. This means that calling
      // resume within the same tick will have no
      // effect.
      nextTick(updateReadableListening, this);
    }

    return res;
  };

  Readable.prototype.removeAllListeners = function (ev) {
    var res = streamBrowser.prototype.removeAllListeners.apply(this, arguments);

    if (ev === 'readable' || ev === undefined) {
      // We need to check if there is someone still listening to
      // readable and reset the state. However this needs to happen
      // after readable has been emitted but before I/O (nextTick) to
      // support once('readable', fn) cycles. This means that calling
      // resume within the same tick will have no
      // effect.
      nextTick(updateReadableListening, this);
    }

    return res;
  };

  function updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;

    if (state.resumeScheduled && !state.paused) {
      // flowing needs to be set to true now, otherwise
      // the upcoming resume will not flow.
      state.flowing = true; // crude way to check if we should resume
    } else if (self.listenerCount('data') > 0) {
      self.resume();
    }
  }

  function nReadingNextTick(self) {
    debug('readable nexttick read 0');
    self.read(0);
  } // pause() and resume() are remnants of the legacy readable stream API
  // If the user uses them, then switch into old mode.


  Readable.prototype.resume = function () {
    var state = this._readableState;

    if (!state.flowing) {
      debug('resume'); // we flow only if there is no one listening
      // for readable, but we still have to call
      // resume()

      state.flowing = !state.readableListening;
      resume(this, state);
    }

    state.paused = false;
    return this;
  };

  function resume(stream, state) {
    if (!state.resumeScheduled) {
      state.resumeScheduled = true;
      nextTick(resume_, stream, state);
    }
  }

  function resume_(stream, state) {
    debug('resume', state.reading);

    if (!state.reading) {
      stream.read(0);
    }

    state.resumeScheduled = false;
    stream.emit('resume');
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
  }

  Readable.prototype.pause = function () {
    debug('call pause flowing=%j', this._readableState.flowing);

    if (this._readableState.flowing !== false) {
      debug('pause');
      this._readableState.flowing = false;
      this.emit('pause');
    }

    this._readableState.paused = true;
    return this;
  };

  function flow(stream) {
    var state = stream._readableState;
    debug('flow', state.flowing);

    while (state.flowing && stream.read() !== null) {
    }
  } // wrap an old-style stream as the async data source.
  // This is *not* part of the readable stream interface.
  // It is an ugly unfortunate mess of history.


  Readable.prototype.wrap = function (stream) {
    var _this = this;

    var state = this._readableState;
    var paused = false;
    stream.on('end', function () {
      debug('wrapped end');

      if (state.decoder && !state.ended) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) _this.push(chunk);
      }

      _this.push(null);
    });
    stream.on('data', function (chunk) {
      debug('wrapped data');
      if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

      if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

      var ret = _this.push(chunk);

      if (!ret) {
        paused = true;
        stream.pause();
      }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.

    for (var i in stream) {
      if (this[i] === undefined && typeof stream[i] === 'function') {
        this[i] = function methodWrap(method) {
          return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
          };
        }(i);
      }
    } // proxy certain important events.


    for (var n = 0; n < kProxyEvents.length; n++) {
      stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    } // when we try to consume some more bytes, simply unpause the
    // underlying stream.


    this._read = function (n) {
      debug('wrapped _read', n);

      if (paused) {
        paused = false;
        stream.resume();
      }
    };

    return this;
  };

  if (typeof Symbol === 'function') {
    Readable.prototype[Symbol.asyncIterator] = function () {
      if (createReadableStreamAsyncIterator$1 === undefined) {
        createReadableStreamAsyncIterator$1 = async_iterator;
      }

      return createReadableStreamAsyncIterator$1(this);
    };
  }

  Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._readableState.highWaterMark;
    }
  });
  Object.defineProperty(Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._readableState && this._readableState.buffer;
    }
  });
  Object.defineProperty(Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._readableState.flowing;
    },
    set: function set(state) {
      if (this._readableState) {
        this._readableState.flowing = state;
      }
    }
  }); // exposed for testing purposes only.

  Readable._fromList = fromList;
  Object.defineProperty(Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
      return this._readableState.length;
    }
  }); // Pluck off n bytes from an array of buffers.
  // Length is the combined lengths of all the buffers in the list.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.

  function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
      // read it all, truncate the list
      if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
      state.buffer.clear();
    } else {
      // read part of list
      ret = state.buffer.consume(n, state.decoder);
    }
    return ret;
  }

  function endReadable(stream) {
    var state = stream._readableState;
    debug('endReadable', state.endEmitted);

    if (!state.endEmitted) {
      state.ended = true;
      nextTick(endReadableNT, state, stream);
    }
  }

  function endReadableNT(state, stream) {
    debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.

    if (!state.endEmitted && state.length === 0) {
      state.endEmitted = true;
      stream.readable = false;
      stream.emit('end');

      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the writable side is ready for autoDestroy as well
        var wState = stream._writableState;

        if (!wState || wState.autoDestroy && wState.finished) {
          stream.destroy();
        }
      }
    }
  }

  if (typeof Symbol === 'function') {
    Readable.from = function (iterable, opts) {
      if (from$1 === undefined) {
        from$1 = fromBrowser;
      }

      return from$1(Readable, iterable, opts);
    };
  }

  function indexOf(xs, x) {
    for (var i = 0, l = xs.length; i < l; i++) {
      if (xs[i] === x) return i;
    }

    return -1;
  }

  var _stream_transform = Transform;
  var _require$codes$2 = errorsBrowser.codes,
      ERR_METHOD_NOT_IMPLEMENTED$2 = _require$codes$2.ERR_METHOD_NOT_IMPLEMENTED,
      ERR_MULTIPLE_CALLBACK$1 = _require$codes$2.ERR_MULTIPLE_CALLBACK,
      ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$2.ERR_TRANSFORM_ALREADY_TRANSFORMING,
      ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$2.ERR_TRANSFORM_WITH_LENGTH_0;
  inherits_browser(Transform, _stream_duplex);

  function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;

    if (cb === null) {
      return this.emit('error', new ERR_MULTIPLE_CALLBACK$1());
    }

    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
      this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;

    if (rs.needReadable || rs.length < rs.highWaterMark) {
      this._read(rs.highWaterMark);
    }
  }

  function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    _stream_duplex.call(this, options);
    this._transformState = {
      afterTransform: afterTransform.bind(this),
      needTransform: false,
      transforming: false,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }; // start out asking for a readable event once data is transformed.

    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.

    this._readableState.sync = false;

    if (options) {
      if (typeof options.transform === 'function') this._transform = options.transform;
      if (typeof options.flush === 'function') this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.


    this.on('prefinish', prefinish$1);
  }

  function prefinish$1() {
    var _this = this;

    if (typeof this._flush === 'function' && !this._readableState.destroyed) {
      this._flush(function (er, data) {
        done(_this, er, data);
      });
    } else {
      done(this, null, null);
    }
  }

  Transform.prototype.push = function (chunk, encoding) {
    this._transformState.needTransform = false;
    return _stream_duplex.prototype.push.call(this, chunk, encoding);
  }; // This is the part where you do stuff!
  // override this function in implementation classes.
  // 'chunk' is an input chunk.
  //
  // Call `push(newChunk)` to pass along transformed output
  // to the readable side.  You may call 'push' zero or more times.
  //
  // Call `cb(err)` when you are done with this chunk.  If you pass
  // an error, then that'll put the hurt on the whole operation.  If you
  // never call cb(), then you'll never get another chunk.


  Transform.prototype._transform = function (chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED$2('_transform()'));
  };

  Transform.prototype._write = function (chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;

    if (!ts.transforming) {
      var rs = this._readableState;
      if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
  }; // Doesn't matter what the args are here.
  // _transform does all the work.
  // That we got here means that the readable side wants more data.


  Transform.prototype._read = function (n) {
    var ts = this._transformState;

    if (ts.writechunk !== null && !ts.transforming) {
      ts.transforming = true;

      this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else {
      // mark that we need a transform, so that any data that comes in
      // will get processed, now that we've asked for it.
      ts.needTransform = true;
    }
  };

  Transform.prototype._destroy = function (err, cb) {
    _stream_duplex.prototype._destroy.call(this, err, function (err2) {
      cb(err2);
    });
  };

  function done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
      stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided

    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
  }

  var _stream_passthrough = PassThrough;
  inherits_browser(PassThrough, _stream_transform);

  function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    _stream_transform.call(this, options);
  }

  PassThrough.prototype._transform = function (chunk, encoding, cb) {
    cb(null, chunk);
  };

  var eos$1;

  function once$2(callback) {
    var called = false;
    return function () {
      if (called) return;
      called = true;
      callback.apply(void 0, arguments);
    };
  }

  var _require$codes$3 = errorsBrowser.codes,
      ERR_MISSING_ARGS = _require$codes$3.ERR_MISSING_ARGS,
      ERR_STREAM_DESTROYED$1 = _require$codes$3.ERR_STREAM_DESTROYED;

  function noop$2(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
  }

  function isRequest$1(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
  }

  function destroyer(stream, reading, writing, callback) {
    callback = once$2(callback);
    var closed = false;
    stream.on('close', function () {
      closed = true;
    });
    if (eos$1 === undefined) eos$1 = endOfStream;
    eos$1(stream, {
      readable: reading,
      writable: writing
    }, function (err) {
      if (err) return callback(err);
      closed = true;
      callback();
    });
    var destroyed = false;
    return function (err) {
      if (closed) return;
      if (destroyed) return;
      destroyed = true; // request.destroy just do .end - .abort is what we want

      if (isRequest$1(stream)) return stream.abort();
      if (typeof stream.destroy === 'function') return stream.destroy();
      callback(err || new ERR_STREAM_DESTROYED$1('pipe'));
    };
  }

  function call(fn) {
    fn();
  }

  function pipe(from, to) {
    return from.pipe(to);
  }

  function popCallback(streams) {
    if (!streams.length) return noop$2;
    if (typeof streams[streams.length - 1] !== 'function') return noop$2;
    return streams.pop();
  }

  function pipeline() {
    for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
      streams[_key] = arguments[_key];
    }

    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];

    if (streams.length < 2) {
      throw new ERR_MISSING_ARGS('streams');
    }

    var error;
    var destroys = streams.map(function (stream, i) {
      var reading = i < streams.length - 1;
      var writing = i > 0;
      return destroyer(stream, reading, writing, function (err) {
        if (!error) error = err;
        if (err) destroys.forEach(call);
        if (reading) return;
        destroys.forEach(call);
        callback(error);
      });
    });
    return streams.reduce(pipe);
  }

  var pipeline_1 = pipeline;

  var readableBrowser = createCommonjsModule(function (module, exports) {
    exports = module.exports = _stream_readable;
    exports.Stream = exports;
    exports.Readable = exports;
    exports.Writable = _stream_writable;
    exports.Duplex = _stream_duplex;
    exports.Transform = _stream_transform;
    exports.PassThrough = _stream_passthrough;
    exports.finished = endOfStream;
    exports.pipeline = pipeline_1;
  });
  var readableBrowser_1 = readableBrowser.Stream;
  var readableBrowser_2 = readableBrowser.Readable;
  var readableBrowser_3 = readableBrowser.Writable;
  var readableBrowser_4 = readableBrowser.Duplex;
  var readableBrowser_5 = readableBrowser.Transform;
  var readableBrowser_6 = readableBrowser.PassThrough;
  var readableBrowser_7 = readableBrowser.finished;
  var readableBrowser_8 = readableBrowser.pipeline;

  var Buffer$6 = safeBuffer.Buffer;
  var Transform$1 = readableBrowser.Transform;

  function throwIfNotStringOrBuffer(val, prefix) {
    if (!Buffer$6.isBuffer(val) && typeof val !== 'string') {
      throw new TypeError(prefix + ' must be a string or a buffer');
    }
  }

  function HashBase(blockSize) {
    Transform$1.call(this);
    this._block = Buffer$6.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [0, 0, 0, 0];
    this._finalized = false;
  }

  inherits_browser(HashBase, Transform$1);

  HashBase.prototype._transform = function (chunk, encoding, callback) {
    var error = null;

    try {
      this.update(chunk, encoding);
    } catch (err) {
      error = err;
    }

    callback(error);
  };

  HashBase.prototype._flush = function (callback) {
    var error = null;

    try {
      this.push(this.digest());
    } catch (err) {
      error = err;
    }

    callback(error);
  };

  HashBase.prototype.update = function (data, encoding) {
    throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!Buffer$6.isBuffer(data)) data = Buffer$6.from(data, encoding); // consume data

    var block = this._block;
    var offset = 0;

    while (this._blockOffset + data.length - offset >= this._blockSize) {
      for (var i = this._blockOffset; i < this._blockSize;) {
        block[i++] = data[offset++];
      }

      this._update();

      this._blockOffset = 0;
    }

    while (offset < data.length) {
      block[this._blockOffset++] = data[offset++];
    } // update length


    for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
      this._length[j] += carry;
      carry = this._length[j] / 0x0100000000 | 0;
      if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }

    return this;
  };

  HashBase.prototype._update = function () {
    throw new Error('_update is not implemented');
  };

  HashBase.prototype.digest = function (encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;

    var digest = this._digest();

    if (encoding !== undefined) digest = digest.toString(encoding); // reset state

    this._block.fill(0);

    this._blockOffset = 0;

    for (var i = 0; i < 4; ++i) {
      this._length[i] = 0;
    }

    return digest;
  };

  HashBase.prototype._digest = function () {
    throw new Error('_digest is not implemented');
  };

  var hashBase = HashBase;

  var Buffer$7 = safeBuffer.Buffer;
  var ARRAY16 = new Array(16);

  function MD5() {
    hashBase.call(this, 64); // state

    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
  }

  inherits_browser(MD5, hashBase);

  MD5.prototype._update = function () {
    var M = ARRAY16;

    for (var i = 0; i < 16; ++i) {
      M[i] = this._block.readInt32LE(i * 4);
    }

    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
  };

  MD5.prototype._digest = function () {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;

    if (this._blockOffset > 56) {
      this._block.fill(0, this._blockOffset, 64);

      this._update();

      this._blockOffset = 0;
    }

    this._block.fill(0, this._blockOffset, 56);

    this._block.writeUInt32LE(this._length[0], 56);

    this._block.writeUInt32LE(this._length[1], 60);

    this._update(); // produce result


    var buffer = Buffer$7.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
  };

  function rotl(x, n) {
    return x << n | x >>> 32 - n;
  }

  function fnF(a, b, c, d, m, k, s) {
    return rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
  }

  function fnG(a, b, c, d, m, k, s) {
    return rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
  }

  function fnH(a, b, c, d, m, k, s) {
    return rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
  }

  function fnI(a, b, c, d, m, k, s) {
    return rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
  }

  var md5_js = MD5;

  var Buffer$8 = bufferEs6.Buffer;
  var ARRAY16$1 = new Array(16);
  var zl = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13];
  var zr = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11];
  var sl = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6];
  var sr = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
  var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
  var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];

  function RIPEMD160() {
    hashBase.call(this, 64); // state

    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
  }

  inherits_browser(RIPEMD160, hashBase);

  RIPEMD160.prototype._update = function () {
    var words = ARRAY16$1;

    for (var j = 0; j < 16; ++j) {
      words[j] = this._block.readInt32LE(j * 4);
    }

    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0; // computation

    for (var i = 0; i < 80; i += 1) {
      var tl;
      var tr;

      if (i < 16) {
        tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
        tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
      } else if (i < 32) {
        tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
        tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
      } else if (i < 48) {
        tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
        tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
      } else if (i < 64) {
        tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
        tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
      } else {
        // if (i<80) {
        tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
        tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
      }

      al = el;
      el = dl;
      dl = rotl$1(cl, 10);
      cl = bl;
      bl = tl;
      ar = er;
      er = dr;
      dr = rotl$1(cr, 10);
      cr = br;
      br = tr;
    } // update state


    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
  };

  RIPEMD160.prototype._digest = function () {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;

    if (this._blockOffset > 56) {
      this._block.fill(0, this._blockOffset, 64);

      this._update();

      this._blockOffset = 0;
    }

    this._block.fill(0, this._blockOffset, 56);

    this._block.writeUInt32LE(this._length[0], 56);

    this._block.writeUInt32LE(this._length[1], 60);

    this._update(); // produce result


    var buffer = Buffer$8.alloc ? Buffer$8.alloc(20) : new Buffer$8(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
  };

  function rotl$1(x, n) {
    return x << n | x >>> 32 - n;
  }

  function fn1(a, b, c, d, e, m, k, s) {
    return rotl$1(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
  }

  function fn2(a, b, c, d, e, m, k, s) {
    return rotl$1(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
  }

  function fn3(a, b, c, d, e, m, k, s) {
    return rotl$1(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
  }

  function fn4(a, b, c, d, e, m, k, s) {
    return rotl$1(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
  }

  function fn5(a, b, c, d, e, m, k, s) {
    return rotl$1(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
  }

  var ripemd160 = RIPEMD160;

  var Buffer$9 = safeBuffer.Buffer; // prototype class for hash functions

  function Hash(blockSize, finalSize) {
    this._block = Buffer$9.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
  }

  Hash.prototype.update = function (data, enc) {
    if (typeof data === 'string') {
      enc = enc || 'utf8';
      data = Buffer$9.from(data, enc);
    }

    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;

    for (var offset = 0; offset < length;) {
      var assigned = accum % blockSize;
      var remainder = Math.min(length - offset, blockSize - assigned);

      for (var i = 0; i < remainder; i++) {
        block[assigned + i] = data[offset + i];
      }

      accum += remainder;
      offset += remainder;

      if (accum % blockSize === 0) {
        this._update(block);
      }
    }

    this._len += length;
    return this;
  };

  Hash.prototype.digest = function (enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80; // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize

    this._block.fill(0, rem + 1);

    if (rem >= this._finalSize) {
      this._update(this._block);

      this._block.fill(0);
    }

    var bits = this._len * 8; // uint32

    if (bits <= 0xffffffff) {
      this._block.writeUInt32BE(bits, this._blockSize - 4); // uint64

    } else {
      var lowBits = (bits & 0xffffffff) >>> 0;
      var highBits = (bits - lowBits) / 0x100000000;

      this._block.writeUInt32BE(highBits, this._blockSize - 8);

      this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }

    this._update(this._block);

    var hash = this._hash();

    return enc ? hash.toString(enc) : hash;
  };

  Hash.prototype._update = function () {
    throw new Error('_update must be implemented by subclass');
  };

  var hash = Hash;

  /*
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
   * in FIPS PUB 180-1
   * This source code is derived from sha1.js of the same repository.
   * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
   * operation was added.
   */

  var Buffer$a = safeBuffer.Buffer;
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];
  var W = new Array(80);

  function Sha() {
    this.init();
    this._w = W;
    hash.call(this, 64, 56);
  }

  inherits_browser(Sha, hash);

  Sha.prototype.init = function () {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
  };

  function rotl5(num) {
    return num << 5 | num >>> 27;
  }

  function rotl30(num) {
    return num << 30 | num >>> 2;
  }

  function ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
  }

  Sha.prototype._update = function (M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;

    for (var i = 0; i < 16; ++i) {
      W[i] = M.readInt32BE(i * 4);
    }

    for (; i < 80; ++i) {
      W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    }

    for (var j = 0; j < 80; ++j) {
      var s = ~~(j / 20);
      var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
      e = d;
      d = c;
      c = rotl30(b);
      b = a;
      a = t;
    }

    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
  };

  Sha.prototype._hash = function () {
    var H = Buffer$a.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
  };

  var sha = Sha;

  /*
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
   * in FIPS PUB 180-1
   * Version 2.1a Copyright Paul Johnston 2000 - 2002.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * Distributed under the BSD License
   * See http://pajhome.org.uk/crypt/md5 for details.
   */

  var Buffer$b = safeBuffer.Buffer;
  var K$1 = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];
  var W$1 = new Array(80);

  function Sha1() {
    this.init();
    this._w = W$1;
    hash.call(this, 64, 56);
  }

  inherits_browser(Sha1, hash);

  Sha1.prototype.init = function () {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
  };

  function rotl1(num) {
    return num << 1 | num >>> 31;
  }

  function rotl5$1(num) {
    return num << 5 | num >>> 27;
  }

  function rotl30$1(num) {
    return num << 30 | num >>> 2;
  }

  function ft$1(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
  }

  Sha1.prototype._update = function (M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;

    for (var i = 0; i < 16; ++i) {
      W[i] = M.readInt32BE(i * 4);
    }

    for (; i < 80; ++i) {
      W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    }

    for (var j = 0; j < 80; ++j) {
      var s = ~~(j / 20);
      var t = rotl5$1(a) + ft$1(s, b, c, d) + e + W[j] + K$1[s] | 0;
      e = d;
      d = c;
      c = rotl30$1(b);
      b = a;
      a = t;
    }

    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
  };

  Sha1.prototype._hash = function () {
    var H = Buffer$b.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
  };

  var sha1 = Sha1;

  /**
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
   * in FIPS 180-2
   * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   *
   */

  var Buffer$c = safeBuffer.Buffer;
  var K$2 = [0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2];
  var W$2 = new Array(64);

  function Sha256() {
    this.init();
    this._w = W$2; // new Array(64)

    hash.call(this, 64, 56);
  }

  inherits_browser(Sha256, hash);

  Sha256.prototype.init = function () {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
  };

  function ch(x, y, z) {
    return z ^ x & (y ^ z);
  }

  function maj(x, y, z) {
    return x & y | z & (x | y);
  }

  function sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
  }

  function sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
  }

  function gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
  }

  function gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
  }

  Sha256.prototype._update = function (M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;

    for (var i = 0; i < 16; ++i) {
      W[i] = M.readInt32BE(i * 4);
    }

    for (; i < 64; ++i) {
      W[i] = gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16] | 0;
    }

    for (var j = 0; j < 64; ++j) {
      var T1 = h + sigma1(e) + ch(e, f, g) + K$2[j] + W[j] | 0;
      var T2 = sigma0(a) + maj(a, b, c) | 0;
      h = g;
      g = f;
      f = e;
      e = d + T1 | 0;
      d = c;
      c = b;
      b = a;
      a = T1 + T2 | 0;
    }

    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
  };

  Sha256.prototype._hash = function () {
    var H = Buffer$c.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
  };

  var sha256 = Sha256;

  /**
   * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
   * in FIPS 180-2
   * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   *
   */

  var Buffer$d = safeBuffer.Buffer;
  var W$3 = new Array(64);

  function Sha224() {
    this.init();
    this._w = W$3; // new Array(64)

    hash.call(this, 64, 56);
  }

  inherits_browser(Sha224, sha256);

  Sha224.prototype.init = function () {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
  };

  Sha224.prototype._hash = function () {
    var H = Buffer$d.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
  };

  var sha224 = Sha224;

  var Buffer$e = safeBuffer.Buffer;
  var K$3 = [0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe, 0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65, 0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725, 0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b, 0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53, 0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec, 0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6, 0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817];
  var W$4 = new Array(160);

  function Sha512() {
    this.init();
    this._w = W$4;
    hash.call(this, 128, 112);
  }

  inherits_browser(Sha512, hash);

  Sha512.prototype.init = function () {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
  };

  function Ch(x, y, z) {
    return z ^ x & (y ^ z);
  }

  function maj$1(x, y, z) {
    return x & y | z & (x | y);
  }

  function sigma0$1(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
  }

  function sigma1$1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
  }

  function Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
  }

  function Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
  }

  function Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
  }

  function Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
  }

  function getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
  }

  Sha512.prototype._update = function (M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;

    for (var i = 0; i < 32; i += 2) {
      W[i] = M.readInt32BE(i * 4);
      W[i + 1] = M.readInt32BE(i * 4 + 4);
    }

    for (; i < 160; i += 2) {
      var xh = W[i - 15 * 2];
      var xl = W[i - 15 * 2 + 1];
      var gamma0 = Gamma0(xh, xl);
      var gamma0l = Gamma0l(xl, xh);
      xh = W[i - 2 * 2];
      xl = W[i - 2 * 2 + 1];
      var gamma1 = Gamma1(xh, xl);
      var gamma1l = Gamma1l(xl, xh); // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]

      var Wi7h = W[i - 7 * 2];
      var Wi7l = W[i - 7 * 2 + 1];
      var Wi16h = W[i - 16 * 2];
      var Wi16l = W[i - 16 * 2 + 1];
      var Wil = gamma0l + Wi7l | 0;
      var Wih = gamma0 + Wi7h + getCarry(Wil, gamma0l) | 0;
      Wil = Wil + gamma1l | 0;
      Wih = Wih + gamma1 + getCarry(Wil, gamma1l) | 0;
      Wil = Wil + Wi16l | 0;
      Wih = Wih + Wi16h + getCarry(Wil, Wi16l) | 0;
      W[i] = Wih;
      W[i + 1] = Wil;
    }

    for (var j = 0; j < 160; j += 2) {
      Wih = W[j];
      Wil = W[j + 1];
      var majh = maj$1(ah, bh, ch);
      var majl = maj$1(al, bl, cl);
      var sigma0h = sigma0$1(ah, al);
      var sigma0l = sigma0$1(al, ah);
      var sigma1h = sigma1$1(eh, el);
      var sigma1l = sigma1$1(el, eh); // t1 = h + sigma1 + ch + K[j] + W[j]

      var Kih = K$3[j];
      var Kil = K$3[j + 1];
      var chh = Ch(eh, fh, gh);
      var chl = Ch(el, fl, gl);
      var t1l = hl + sigma1l | 0;
      var t1h = hh + sigma1h + getCarry(t1l, hl) | 0;
      t1l = t1l + chl | 0;
      t1h = t1h + chh + getCarry(t1l, chl) | 0;
      t1l = t1l + Kil | 0;
      t1h = t1h + Kih + getCarry(t1l, Kil) | 0;
      t1l = t1l + Wil | 0;
      t1h = t1h + Wih + getCarry(t1l, Wil) | 0; // t2 = sigma0 + maj

      var t2l = sigma0l + majl | 0;
      var t2h = sigma0h + majh + getCarry(t2l, sigma0l) | 0;
      hh = gh;
      hl = gl;
      gh = fh;
      gl = fl;
      fh = eh;
      fl = el;
      el = dl + t1l | 0;
      eh = dh + t1h + getCarry(el, dl) | 0;
      dh = ch;
      dl = cl;
      ch = bh;
      cl = bl;
      bh = ah;
      bl = al;
      al = t1l + t2l | 0;
      ah = t1h + t2h + getCarry(al, t1l) | 0;
    }

    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + getCarry(this._hl, hl) | 0;
  };

  Sha512.prototype._hash = function () {
    var H = Buffer$e.allocUnsafe(64);

    function writeInt64BE(h, l, offset) {
      H.writeInt32BE(h, offset);
      H.writeInt32BE(l, offset + 4);
    }

    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
  };

  var sha512 = Sha512;

  var Buffer$f = safeBuffer.Buffer;
  var W$5 = new Array(160);

  function Sha384() {
    this.init();
    this._w = W$5;
    hash.call(this, 128, 112);
  }

  inherits_browser(Sha384, sha512);

  Sha384.prototype.init = function () {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
  };

  Sha384.prototype._hash = function () {
    var H = Buffer$f.allocUnsafe(48);

    function writeInt64BE(h, l, offset) {
      H.writeInt32BE(h, offset);
      H.writeInt32BE(l, offset + 4);
    }

    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
  };

  var sha384 = Sha384;

  var sha_js = createCommonjsModule(function (module) {
    var exports = module.exports = function SHA(algorithm) {
      algorithm = algorithm.toLowerCase();
      var Algorithm = exports[algorithm];
      if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
      return new Algorithm();
    };

    exports.sha = sha;
    exports.sha1 = sha1;
    exports.sha224 = sha224;
    exports.sha256 = sha256;
    exports.sha384 = sha384;
    exports.sha512 = sha512;
  });

  function BufferList() {
    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function (v) {
    var entry = {
      data: v,
      next: null
    };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function (v) {
    var entry = {
      data: v,
      next: this.head
    };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function () {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function () {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function (s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;

    while (p = p.next) {
      ret += s + p.data;
    }

    return ret;
  };

  BufferList.prototype.concat = function (n) {
    if (this.length === 0) return Buffer$1.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer$1.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;

    while (p) {
      p.data.copy(ret, i);
      i += p.data.length;
      p = p.next;
    }

    return ret;
  };

  // Copyright Joyent, Inc. and other Node contributors.

  var isBufferEncoding = Buffer$1.isEncoding || function (encoding) {
    switch (encoding && encoding.toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
      case 'raw':
        return true;

      default:
        return false;
    }
  };

  function assertEncoding(encoding) {
    if (encoding && !isBufferEncoding(encoding)) {
      throw new Error('Unknown encoding: ' + encoding);
    }
  } // StringDecoder provides an interface for efficiently splitting a series of
  // buffers into a series of JS strings without breaking apart multi-byte
  // characters. CESU-8 is handled as part of the UTF-8 encoding.
  //
  // @TODO Handling all encodings inside a single object makes it very difficult
  // to reason about this code, so it should be split up in the future.
  // @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
  // points as used by CESU-8.


  function StringDecoder$2(encoding) {
    this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
    assertEncoding(encoding);

    switch (this.encoding) {
      case 'utf8':
        // CESU-8 represents each of Surrogate Pair by 3-bytes
        this.surrogateSize = 3;
        break;

      case 'ucs2':
      case 'utf16le':
        // UTF-16 represents each of Surrogate Pair by 2-bytes
        this.surrogateSize = 2;
        this.detectIncompleteChar = utf16DetectIncompleteChar;
        break;

      case 'base64':
        // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
        this.surrogateSize = 3;
        this.detectIncompleteChar = base64DetectIncompleteChar;
        break;

      default:
        this.write = passThroughWrite;
        return;
    } // Enough space to store all bytes of a single character. UTF-8 needs 4
    // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).


    this.charBuffer = new Buffer$1(6); // Number of bytes received for the current incomplete multi-byte character.

    this.charReceived = 0; // Number of bytes expected for the current incomplete multi-byte character.

    this.charLength = 0;
  }
  // guaranteed to not contain any partial multi-byte characters. Any partial
  // character found at the end of the buffer is buffered up, and will be
  // returned when calling write again with the remaining bytes.
  //
  // Note: Converting a Buffer containing an orphan surrogate to a String
  // currently works, but converting a String to a Buffer (via `new Buffer`, or
  // Buffer#write) will replace incomplete surrogates with the unicode
  // replacement character. See https://codereview.chromium.org/121173009/ .

  StringDecoder$2.prototype.write = function (buffer) {
    var charStr = ''; // if our last write ended with an incomplete multibyte character

    while (this.charLength) {
      // determine how many remaining bytes this buffer has to offer for this char
      var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length; // add the new bytes to the char buffer

      buffer.copy(this.charBuffer, this.charReceived, 0, available);
      this.charReceived += available;

      if (this.charReceived < this.charLength) {
        // still not enough chars in this buffer? wait for more ...
        return '';
      } // remove bytes belonging to the current character from the buffer


      buffer = buffer.slice(available, buffer.length); // get the character that was split

      charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding); // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character

      var charCode = charStr.charCodeAt(charStr.length - 1);

      if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        this.charLength += this.surrogateSize;
        charStr = '';
        continue;
      }

      this.charReceived = this.charLength = 0; // if there are no more bytes in this buffer, just emit our char

      if (buffer.length === 0) {
        return charStr;
      }

      break;
    } // determine and set charLength / charReceived


    this.detectIncompleteChar(buffer);
    var end = buffer.length;

    if (this.charLength) {
      // buffer the incomplete character bytes we got
      buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
      end -= this.charReceived;
    }

    charStr += buffer.toString(this.encoding, 0, end);
    var end = charStr.length - 1;
    var charCode = charStr.charCodeAt(end); // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character

    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      var size = this.surrogateSize;
      this.charLength += size;
      this.charReceived += size;
      this.charBuffer.copy(this.charBuffer, size, 0, size);
      buffer.copy(this.charBuffer, 0, 0, size);
      return charStr.substring(0, end);
    } // or just emit the charStr


    return charStr;
  }; // detectIncompleteChar determines if there is an incomplete UTF-8 character at
  // the end of the given buffer. If so, it sets this.charLength to the byte
  // length that character, and sets this.charReceived to the number of bytes
  // that are available for this character.


  StringDecoder$2.prototype.detectIncompleteChar = function (buffer) {
    // determine how many bytes we have to check at the end of this buffer
    var i = buffer.length >= 3 ? 3 : buffer.length; // Figure out if one of the last i bytes of our buffer announces an
    // incomplete char.

    for (; i > 0; i--) {
      var c = buffer[buffer.length - i]; // See http://en.wikipedia.org/wiki/UTF-8#Description
      // 110XXXXX

      if (i == 1 && c >> 5 == 0x06) {
        this.charLength = 2;
        break;
      } // 1110XXXX


      if (i <= 2 && c >> 4 == 0x0E) {
        this.charLength = 3;
        break;
      } // 11110XXX


      if (i <= 3 && c >> 3 == 0x1E) {
        this.charLength = 4;
        break;
      }
    }

    this.charReceived = i;
  };

  StringDecoder$2.prototype.end = function (buffer) {
    var res = '';
    if (buffer && buffer.length) res = this.write(buffer);

    if (this.charReceived) {
      var cr = this.charReceived;
      var buf = this.charBuffer;
      var enc = this.encoding;
      res += buf.slice(0, cr).toString(enc);
    }

    return res;
  };

  function passThroughWrite(buffer) {
    return buffer.toString(this.encoding);
  }

  function utf16DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 2;
    this.charLength = this.charReceived ? 2 : 0;
  }

  function base64DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 3;
    this.charLength = this.charReceived ? 3 : 0;
  }

  var stringDecoder = /*#__PURE__*/Object.freeze({
    __proto__: null,
    StringDecoder: StringDecoder$2
  });

  Readable$1.ReadableState = ReadableState$1;
  var debug$1 = debuglog('stream');
  inherits$1(Readable$1, EventEmitter);

  function prependListener$1(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') {
      return emitter.prependListener(event, fn);
    } else {
      // This is a hack to make sure that our error handler is attached before any
      // userland ones.  NEVER DO THIS. This is here only because this code needs
      // to continue to work with older versions of Node.js that do not include
      // the prependListener() method. The goal is to eventually remove this hack.
      if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
    }
  }

  function listenerCount$1(emitter, type) {
    return emitter.listeners(type).length;
  }

  function ReadableState$1(options, stream) {
    options = options || {}; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away

    this.objectMode = !!options.objectMode;
    if (stream instanceof Duplex$3) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"

    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16 * 1024;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm; // cast to ints.

    this.highWaterMark = ~~this.highWaterMark; // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()

    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.

    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.

    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.

    this.defaultEncoding = options.defaultEncoding || 'utf8'; // when piping, we only care about 'readable' events that happen
    // after read()ing all the bytes and not getting any pushback.

    this.ranOut = false; // the number of writers that are awaiting a drain event in .pipe()s

    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;

    if (options.encoding) {
      this.decoder = new StringDecoder$2(options.encoding);
      this.encoding = options.encoding;
    }
  }
  function Readable$1(options) {
    if (!(this instanceof Readable$1)) return new Readable$1(options);
    this._readableState = new ReadableState$1(options, this); // legacy

    this.readable = true;
    if (options && typeof options.read === 'function') this._read = options.read;
    EventEmitter.call(this);
  } // Manually shove something into the read() buffer.
  // This returns true if the highWaterMark has not been hit yet,
  // similar to how Writable.write() returns true if you should
  // write() some more.

  Readable$1.prototype.push = function (chunk, encoding) {
    var state = this._readableState;

    if (!state.objectMode && typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;

      if (encoding !== state.encoding) {
        chunk = Buffer$1.from(chunk, encoding);
        encoding = '';
      }
    }

    return readableAddChunk$1(this, state, chunk, encoding, false);
  }; // Unshift should *always* be something directly out of read()


  Readable$1.prototype.unshift = function (chunk) {
    var state = this._readableState;
    return readableAddChunk$1(this, state, chunk, '', true);
  };

  Readable$1.prototype.isPaused = function () {
    return this._readableState.flowing === false;
  };

  function readableAddChunk$1(stream, state, chunk, encoding, addToFront) {
    var er = chunkInvalid$1(state, chunk);

    if (er) {
      stream.emit('error', er);
    } else if (chunk === null) {
      state.reading = false;
      onEofChunk$1(stream, state);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (state.ended && !addToFront) {
        var e = new Error('stream.push() after EOF');
        stream.emit('error', e);
      } else if (state.endEmitted && addToFront) {
        var _e = new Error('stream.unshift() after end event');

        stream.emit('error', _e);
      } else {
        var skipAdd;

        if (state.decoder && !addToFront && !encoding) {
          chunk = state.decoder.write(chunk);
          skipAdd = !state.objectMode && chunk.length === 0;
        }

        if (!addToFront) state.reading = false; // Don't add to the buffer if we've decoded to an empty string chunk and
        // we're not in object mode

        if (!skipAdd) {
          // if we want the data now, just emit it.
          if (state.flowing && state.length === 0 && !state.sync) {
            stream.emit('data', chunk);
            stream.read(0);
          } else {
            // update the buffer info.
            state.length += state.objectMode ? 1 : chunk.length;
            if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
            if (state.needReadable) emitReadable$1(stream);
          }
        }

        maybeReadMore$1(stream, state);
      }
    } else if (!addToFront) {
      state.reading = false;
    }

    return needMoreData(state);
  } // if it's past the high water mark, we can push in some more.
  // Also, if we have no data yet, we can stand some
  // more bytes.  This is to work around cases where hwm=0,
  // such as the repl.  Also, if the push() triggered a
  // readable event, and the user called read(largeNumber) such that
  // needReadable was set, then we ought to push more, so that another
  // 'readable' event will be triggered.


  function needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
  } // backwards compatibility.


  Readable$1.prototype.setEncoding = function (enc) {
    this._readableState.decoder = new StringDecoder$2(enc);
    this._readableState.encoding = enc;
    return this;
  }; // Don't raise the hwm > 8MB


  var MAX_HWM$1 = 0x800000;

  function computeNewHighWaterMark$1(n) {
    if (n >= MAX_HWM$1) {
      n = MAX_HWM$1;
    } else {
      // Get the next highest power of 2 to prevent increasing hwm excessively in
      // tiny amounts
      n--;
      n |= n >>> 1;
      n |= n >>> 2;
      n |= n >>> 4;
      n |= n >>> 8;
      n |= n >>> 16;
      n++;
    }

    return n;
  } // This function is designed to be inlinable, so please take care when making
  // changes to the function body.


  function howMuchToRead$1(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;

    if (n !== n) {
      // Only flow one buffer at a time
      if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.


    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark$1(n);
    if (n <= state.length) return n; // Don't have enough

    if (!state.ended) {
      state.needReadable = true;
      return 0;
    }

    return state.length;
  } // you can override either this method, or the async _read(n) below.


  Readable$1.prototype.read = function (n) {
    debug$1('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.

    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
      debug$1('read: emitReadable', state.length, state.ended);
      if (state.length === 0 && state.ended) endReadable$1(this);else emitReadable$1(this);
      return null;
    }

    n = howMuchToRead$1(n, state); // if we've ended, and we're now clear, then finish it up.

    if (n === 0 && state.ended) {
      if (state.length === 0) endReadable$1(this);
      return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.


    var doRead = state.needReadable;
    debug$1('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

    if (state.length === 0 || state.length - n < state.highWaterMark) {
      doRead = true;
      debug$1('length less than watermark', doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.


    if (state.ended || state.reading) {
      doRead = false;
      debug$1('reading or ended', doRead);
    } else if (doRead) {
      debug$1('do read');
      state.reading = true;
      state.sync = true; // if the length is currently zero, then we *need* a readable event.

      if (state.length === 0) state.needReadable = true; // call internal read method

      this._read(state.highWaterMark);

      state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
      // and we need to re-evaluate how much data we can return to the user.

      if (!state.reading) n = howMuchToRead$1(nOrig, state);
    }

    var ret;
    if (n > 0) ret = fromList$1(n, state);else ret = null;

    if (ret === null) {
      state.needReadable = true;
      n = 0;
    } else {
      state.length -= n;
    }

    if (state.length === 0) {
      // If we have nothing in the buffer, then we want to know
      // as soon as we *do* get something into the buffer.
      if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

      if (nOrig !== n && state.ended) endReadable$1(this);
    }

    if (ret !== null) this.emit('data', ret);
    return ret;
  };

  function chunkInvalid$1(state, chunk) {
    var er = null;

    if (!isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
      er = new TypeError('Invalid non-string/buffer chunk');
    }

    return er;
  }

  function onEofChunk$1(stream, state) {
    if (state.ended) return;

    if (state.decoder) {
      var chunk = state.decoder.end();

      if (chunk && chunk.length) {
        state.buffer.push(chunk);
        state.length += state.objectMode ? 1 : chunk.length;
      }
    }

    state.ended = true; // emit 'readable' now to make sure it gets picked up.

    emitReadable$1(stream);
  } // Don't emit readable right away in sync mode, because this can trigger
  // another read() call => stack overflow.  This way, it might trigger
  // a nextTick recursion warning, but that's not so bad.


  function emitReadable$1(stream) {
    var state = stream._readableState;
    state.needReadable = false;

    if (!state.emittedReadable) {
      debug$1('emitReadable', state.flowing);
      state.emittedReadable = true;
      if (state.sync) nextTick(emitReadable_$1, stream);else emitReadable_$1(stream);
    }
  }

  function emitReadable_$1(stream) {
    debug$1('emit readable');
    stream.emit('readable');
    flow$1(stream);
  } // at this point, the user has presumably seen the 'readable' event,
  // and called read() to consume some data.  that may have triggered
  // in turn another _read(n) call, in which case reading = true if
  // it's in progress.
  // However, if we're not ended, or reading, and the length < hwm,
  // then go ahead and try to read some more preemptively.


  function maybeReadMore$1(stream, state) {
    if (!state.readingMore) {
      state.readingMore = true;
      nextTick(maybeReadMore_$1, stream, state);
    }
  }

  function maybeReadMore_$1(stream, state) {
    var len = state.length;

    while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
      debug$1('maybeReadMore read 0');
      stream.read(0);
      if (len === state.length) // didn't get any data, stop spinning.
        break;else len = state.length;
    }

    state.readingMore = false;
  } // abstract method.  to be overridden in specific implementation classes.
  // call cb(er, data) where data is <= n in length.
  // for virtual (non-string, non-buffer) streams, "length" is somewhat
  // arbitrary, and perhaps not very meaningful.


  Readable$1.prototype._read = function (n) {
    this.emit('error', new Error('not implemented'));
  };

  Readable$1.prototype.pipe = function (dest, pipeOpts) {
    var src = this;
    var state = this._readableState;

    switch (state.pipesCount) {
      case 0:
        state.pipes = dest;
        break;

      case 1:
        state.pipes = [state.pipes, dest];
        break;

      default:
        state.pipes.push(dest);
        break;
    }

    state.pipesCount += 1;
    debug$1('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = !pipeOpts || pipeOpts.end !== false;
    var endFn = doEnd ? onend : cleanup;
    if (state.endEmitted) nextTick(endFn);else src.once('end', endFn);
    dest.on('unpipe', onunpipe);

    function onunpipe(readable) {
      debug$1('onunpipe');

      if (readable === src) {
        cleanup();
      }
    }

    function onend() {
      debug$1('onend');
      dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.


    var ondrain = pipeOnDrain$1(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;

    function cleanup() {
      debug$1('cleanup'); // cleanup event handlers once the pipe is broken

      dest.removeListener('close', onclose);
      dest.removeListener('finish', onfinish);
      dest.removeListener('drain', ondrain);
      dest.removeListener('error', onerror);
      dest.removeListener('unpipe', onunpipe);
      src.removeListener('end', onend);
      src.removeListener('end', cleanup);
      src.removeListener('data', ondata);
      cleanedUp = true; // if the reader is waiting for a drain event from this
      // specific writer, then it would cause it to never start
      // flowing again.
      // So, if this is awaiting a drain, then we just call it now.
      // If we don't know, then assume that we are waiting for one.

      if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    } // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.


    var increasedAwaitDrain = false;
    src.on('data', ondata);

    function ondata(chunk) {
      debug$1('ondata');
      increasedAwaitDrain = false;
      var ret = dest.write(chunk);

      if (false === ret && !increasedAwaitDrain) {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf$1(state.pipes, dest) !== -1) && !cleanedUp) {
          debug$1('false write response, pause', src._readableState.awaitDrain);
          src._readableState.awaitDrain++;
          increasedAwaitDrain = true;
        }

        src.pause();
      }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.


    function onerror(er) {
      debug$1('onerror', er);
      unpipe();
      dest.removeListener('error', onerror);
      if (listenerCount$1(dest, 'error') === 0) dest.emit('error', er);
    } // Make sure our error handler is attached before userland ones.


    prependListener$1(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

    function onclose() {
      dest.removeListener('finish', onfinish);
      unpipe();
    }

    dest.once('close', onclose);

    function onfinish() {
      debug$1('onfinish');
      dest.removeListener('close', onclose);
      unpipe();
    }

    dest.once('finish', onfinish);

    function unpipe() {
      debug$1('unpipe');
      src.unpipe(dest);
    } // tell the dest that it's being piped to


    dest.emit('pipe', src); // start the flow if it hasn't been started already.

    if (!state.flowing) {
      debug$1('pipe resume');
      src.resume();
    }

    return dest;
  };

  function pipeOnDrain$1(src) {
    return function () {
      var state = src._readableState;
      debug$1('pipeOnDrain', state.awaitDrain);
      if (state.awaitDrain) state.awaitDrain--;

      if (state.awaitDrain === 0 && src.listeners('data').length) {
        state.flowing = true;
        flow$1(src);
      }
    };
  }

  Readable$1.prototype.unpipe = function (dest) {
    var state = this._readableState; // if we're not piping anywhere, then do nothing.

    if (state.pipesCount === 0) return this; // just one destination.  most common case.

    if (state.pipesCount === 1) {
      // passed in one, but it's not the right one.
      if (dest && dest !== state.pipes) return this;
      if (!dest) dest = state.pipes; // got a match.

      state.pipes = null;
      state.pipesCount = 0;
      state.flowing = false;
      if (dest) dest.emit('unpipe', this);
      return this;
    } // slow case. multiple pipe destinations.


    if (!dest) {
      // remove all.
      var dests = state.pipes;
      var len = state.pipesCount;
      state.pipes = null;
      state.pipesCount = 0;
      state.flowing = false;

      for (var _i = 0; _i < len; _i++) {
        dests[_i].emit('unpipe', this);
      }

      return this;
    } // try to find the right one.


    var i = indexOf$1(state.pipes, dest);
    if (i === -1) return this;
    state.pipes.splice(i, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this);
    return this;
  }; // set up data events if they are asked for
  // Ensure readable listeners eventually get something


  Readable$1.prototype.on = function (ev, fn) {
    var res = EventEmitter.prototype.on.call(this, ev, fn);

    if (ev === 'data') {
      // Start flowing on next tick if stream isn't explicitly paused
      if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
      var state = this._readableState;

      if (!state.endEmitted && !state.readableListening) {
        state.readableListening = state.needReadable = true;
        state.emittedReadable = false;

        if (!state.reading) {
          nextTick(nReadingNextTick$1, this);
        } else if (state.length) {
          emitReadable$1(this);
        }
      }
    }

    return res;
  };

  Readable$1.prototype.addListener = Readable$1.prototype.on;

  function nReadingNextTick$1(self) {
    debug$1('readable nexttick read 0');
    self.read(0);
  } // pause() and resume() are remnants of the legacy readable stream API
  // If the user uses them, then switch into old mode.


  Readable$1.prototype.resume = function () {
    var state = this._readableState;

    if (!state.flowing) {
      debug$1('resume');
      state.flowing = true;
      resume$1(this, state);
    }

    return this;
  };

  function resume$1(stream, state) {
    if (!state.resumeScheduled) {
      state.resumeScheduled = true;
      nextTick(resume_$1, stream, state);
    }
  }

  function resume_$1(stream, state) {
    if (!state.reading) {
      debug$1('resume read 0');
      stream.read(0);
    }

    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    flow$1(stream);
    if (state.flowing && !state.reading) stream.read(0);
  }

  Readable$1.prototype.pause = function () {
    debug$1('call pause flowing=%j', this._readableState.flowing);

    if (false !== this._readableState.flowing) {
      debug$1('pause');
      this._readableState.flowing = false;
      this.emit('pause');
    }

    return this;
  };

  function flow$1(stream) {
    var state = stream._readableState;
    debug$1('flow', state.flowing);

    while (state.flowing && stream.read() !== null) {}
  } // wrap an old-style stream as the async data source.
  // This is *not* part of the readable stream interface.
  // It is an ugly unfortunate mess of history.


  Readable$1.prototype.wrap = function (stream) {
    var state = this._readableState;
    var paused = false;
    var self = this;
    stream.on('end', function () {
      debug$1('wrapped end');

      if (state.decoder && !state.ended) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) self.push(chunk);
      }

      self.push(null);
    });
    stream.on('data', function (chunk) {
      debug$1('wrapped data');
      if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

      if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
      var ret = self.push(chunk);

      if (!ret) {
        paused = true;
        stream.pause();
      }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.

    for (var i in stream) {
      if (this[i] === undefined && typeof stream[i] === 'function') {
        this[i] = function (method) {
          return function () {
            return stream[method].apply(stream, arguments);
          };
        }(i);
      }
    } // proxy certain important events.


    var events = ['error', 'close', 'destroy', 'pause', 'resume'];
    forEach(events, function (ev) {
      stream.on(ev, self.emit.bind(self, ev));
    }); // when we try to consume some more bytes, simply unpause the
    // underlying stream.

    self._read = function (n) {
      debug$1('wrapped _read', n);

      if (paused) {
        paused = false;
        stream.resume();
      }
    };

    return self;
  }; // exposed for testing purposes only.


  Readable$1._fromList = fromList$1; // Pluck off n bytes from an array of buffers.
  // Length is the combined lengths of all the buffers in the list.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.

  function fromList$1(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
      // read it all, truncate the list
      if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
      state.buffer.clear();
    } else {
      // read part of list
      ret = fromListPartial(n, state.buffer, state.decoder);
    }
    return ret;
  } // Extracts only enough buffered data to satisfy the amount requested.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.


  function fromListPartial(n, list, hasStrings) {
    var ret;

    if (n < list.head.data.length) {
      // slice is the same for buffers and strings
      ret = list.head.data.slice(0, n);
      list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) {
      // first chunk is a perfect match
      ret = list.shift();
    } else {
      // result spans more than one buffer
      ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
    }

    return ret;
  } // Copies a specified amount of characters from the list of buffered data
  // chunks.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.


  function copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;

    while (p = p.next) {
      var str = p.data;
      var nb = n > str.length ? str.length : n;
      if (nb === str.length) ret += str;else ret += str.slice(0, n);
      n -= nb;

      if (n === 0) {
        if (nb === str.length) {
          ++c;
          if (p.next) list.head = p.next;else list.head = list.tail = null;
        } else {
          list.head = p;
          p.data = str.slice(nb);
        }

        break;
      }

      ++c;
    }

    list.length -= c;
    return ret;
  } // Copies a specified amount of bytes from the list of buffered data chunks.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.


  function copyFromBuffer(n, list) {
    var ret = Buffer$1.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;

    while (p = p.next) {
      var buf = p.data;
      var nb = n > buf.length ? buf.length : n;
      buf.copy(ret, ret.length - n, 0, nb);
      n -= nb;

      if (n === 0) {
        if (nb === buf.length) {
          ++c;
          if (p.next) list.head = p.next;else list.head = list.tail = null;
        } else {
          list.head = p;
          p.data = buf.slice(nb);
        }

        break;
      }

      ++c;
    }

    list.length -= c;
    return ret;
  }

  function endReadable$1(stream) {
    var state = stream._readableState; // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.

    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

    if (!state.endEmitted) {
      state.ended = true;
      nextTick(endReadableNT$1, state, stream);
    }
  }

  function endReadableNT$1(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
      state.endEmitted = true;
      stream.readable = false;
      stream.emit('end');
    }
  }

  function forEach(xs, f) {
    for (var i = 0, l = xs.length; i < l; i++) {
      f(xs[i], i);
    }
  }

  function indexOf$1(xs, x) {
    for (var i = 0, l = xs.length; i < l; i++) {
      if (xs[i] === x) return i;
    }

    return -1;
  }

  // A bit simpler than readable streams.
  Writable$1.WritableState = WritableState$1;
  inherits$1(Writable$1, EventEmitter);

  function nop$1() {}

  function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
  }

  function WritableState$1(options, stream) {
    Object.defineProperty(this, 'buffer', {
      get: deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
    options = options || {}; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.

    this.objectMode = !!options.objectMode;
    if (stream instanceof Duplex$3) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()

    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16 * 1024;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm; // cast to ints.

    this.highWaterMark = ~~this.highWaterMark;
    this.needDrain = false; // at the start of calling end()

    this.ending = false; // when end() has been called, and returned

    this.ended = false; // when 'finish' is emitted

    this.finished = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.

    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.

    this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.

    this.length = 0; // a flag to see when we're in the middle of a write.

    this.writing = false; // when true all writes will be buffered until .uncork() call

    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.

    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.

    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

    this.onwrite = function (er) {
      onwrite$1(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)


    this.writecb = null; // the amount that is being written when _write is called.

    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted

    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams

    this.prefinished = false; // True if the error was already emitted and should not be thrown again

    this.errorEmitted = false; // count buffered requests

    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two

    this.corkedRequestsFree = new CorkedRequest$1(this);
  }

  WritableState$1.prototype.getBuffer = function writableStateGetBuffer() {
    var current = this.bufferedRequest;
    var out = [];

    while (current) {
      out.push(current);
      current = current.next;
    }

    return out;
  };
  function Writable$1(options) {
    // Writable ctor is applied to Duplexes, though they're not
    // instanceof Writable, they're instanceof Readable.
    if (!(this instanceof Writable$1) && !(this instanceof Duplex$3)) return new Writable$1(options);
    this._writableState = new WritableState$1(options, this); // legacy.

    this.writable = true;

    if (options) {
      if (typeof options.write === 'function') this._write = options.write;
      if (typeof options.writev === 'function') this._writev = options.writev;
    }

    EventEmitter.call(this);
  } // Otherwise people can pipe Writable streams, which is just wrong.

  Writable$1.prototype.pipe = function () {
    this.emit('error', new Error('Cannot pipe, not readable'));
  };

  function writeAfterEnd$1(stream, cb) {
    var er = new Error('write after end'); // TODO: defer error events consistently everywhere, not just the cb

    stream.emit('error', er);
    nextTick(cb, er);
  } // If we get something that is not a buffer, string, null, or undefined,
  // and we're not in objectMode, then that's an error.
  // Otherwise stream chunks are all considered to be of length=1, and the
  // watermarks determine how many objects to keep in the buffer, rather than
  // how many bytes or characters.


  function validChunk$1(stream, state, chunk, cb) {
    var valid = true;
    var er = false; // Always throw error if a null is written
    // if we are not in object mode then throw
    // if it is not a buffer, string, or undefined.

    if (chunk === null) {
      er = new TypeError('May not write null values to stream');
    } else if (!Buffer$1.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
      er = new TypeError('Invalid non-string/buffer chunk');
    }

    if (er) {
      stream.emit('error', er);
      nextTick(cb, er);
      valid = false;
    }

    return valid;
  }

  Writable$1.prototype.write = function (chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;

    if (typeof encoding === 'function') {
      cb = encoding;
      encoding = null;
    }

    if (Buffer$1.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = nop$1;
    if (state.ended) writeAfterEnd$1(this, cb);else if (validChunk$1(this, state, chunk, cb)) {
      state.pendingcb++;
      ret = writeOrBuffer$1(this, state, chunk, encoding, cb);
    }
    return ret;
  };

  Writable$1.prototype.cork = function () {
    var state = this._writableState;
    state.corked++;
  };

  Writable$1.prototype.uncork = function () {
    var state = this._writableState;

    if (state.corked) {
      state.corked--;
      if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer$1(this, state);
    }
  };

  Writable$1.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
  };

  function decodeChunk$1(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
      chunk = Buffer$1.from(chunk, encoding);
    }

    return chunk;
  } // if we're already writing something, then just put this
  // in the queue, and wait our turn.  Otherwise, call _write
  // If we return false, then we need a drain event, so set that flag.


  function writeOrBuffer$1(stream, state, chunk, encoding, cb) {
    chunk = decodeChunk$1(state, chunk, encoding);
    if (Buffer$1.isBuffer(chunk)) encoding = 'buffer';
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

    if (!ret) state.needDrain = true;

    if (state.writing || state.corked) {
      var last = state.lastBufferedRequest;
      state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);

      if (last) {
        last.next = state.lastBufferedRequest;
      } else {
        state.bufferedRequest = state.lastBufferedRequest;
      }

      state.bufferedRequestCount += 1;
    } else {
      doWrite$1(stream, state, false, len, chunk, encoding, cb);
    }

    return ret;
  }

  function doWrite$1(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
  }

  function onwriteError$1(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) nextTick(cb, er);else cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  }

  function onwriteStateUpdate$1(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
  }

  function onwrite$1(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    onwriteStateUpdate$1(state);
    if (er) onwriteError$1(stream, state, sync, er, cb);else {
      // Check if we're actually ready to finish, but don't emit yet
      var finished = needFinish$1(state);

      if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
        clearBuffer$1(stream, state);
      }

      if (sync) {
        /*<replacement>*/
        nextTick(afterWrite$1, stream, state, finished, cb);
        /*</replacement>*/
      } else {
        afterWrite$1(stream, state, finished, cb);
      }
    }
  }

  function afterWrite$1(stream, state, finished, cb) {
    if (!finished) onwriteDrain$1(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe$1(stream, state);
  } // Must force callback to be called on nextTick, so that we don't
  // emit 'drain' before the write() consumer gets the 'false' return
  // value, and has a chance to attach a 'drain' listener.


  function onwriteDrain$1(stream, state) {
    if (state.length === 0 && state.needDrain) {
      state.needDrain = false;
      stream.emit('drain');
    }
  } // if there's something in the buffer waiting, then process it


  function clearBuffer$1(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;

    if (stream._writev && entry && entry.next) {
      // Fast case, write everything using _writev()
      var l = state.bufferedRequestCount;
      var buffer = new Array(l);
      var holder = state.corkedRequestsFree;
      holder.entry = entry;
      var count = 0;

      while (entry) {
        buffer[count] = entry;
        entry = entry.next;
        count += 1;
      }

      doWrite$1(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
      // as the hot path ends with doWrite

      state.pendingcb++;
      state.lastBufferedRequest = null;

      if (holder.next) {
        state.corkedRequestsFree = holder.next;
        holder.next = null;
      } else {
        state.corkedRequestsFree = new CorkedRequest$1(state);
      }
    } else {
      // Slow case, write chunks one-by-one
      while (entry) {
        var chunk = entry.chunk;
        var encoding = entry.encoding;
        var cb = entry.callback;
        var len = state.objectMode ? 1 : chunk.length;
        doWrite$1(stream, state, false, len, chunk, encoding, cb);
        entry = entry.next; // if we didn't call the onwrite immediately, then
        // it means that we need to wait until it does.
        // also, that means that the chunk and cb are currently
        // being processed, so move the buffer counter past them.

        if (state.writing) {
          break;
        }
      }

      if (entry === null) state.lastBufferedRequest = null;
    }

    state.bufferedRequestCount = 0;
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
  }

  Writable$1.prototype._write = function (chunk, encoding, cb) {
    cb(new Error('not implemented'));
  };

  Writable$1.prototype._writev = null;

  Writable$1.prototype.end = function (chunk, encoding, cb) {
    var state = this._writableState;

    if (typeof chunk === 'function') {
      cb = chunk;
      chunk = null;
      encoding = null;
    } else if (typeof encoding === 'function') {
      cb = encoding;
      encoding = null;
    }

    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

    if (state.corked) {
      state.corked = 1;
      this.uncork();
    } // ignore unnecessary end() calls.


    if (!state.ending && !state.finished) endWritable$1(this, state, cb);
  };

  function needFinish$1(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
  }

  function prefinish$2(stream, state) {
    if (!state.prefinished) {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }

  function finishMaybe$1(stream, state) {
    var need = needFinish$1(state);

    if (need) {
      if (state.pendingcb === 0) {
        prefinish$2(stream, state);
        state.finished = true;
        stream.emit('finish');
      } else {
        prefinish$2(stream, state);
      }
    }

    return need;
  }

  function endWritable$1(stream, state, cb) {
    state.ending = true;
    finishMaybe$1(stream, state);

    if (cb) {
      if (state.finished) nextTick(cb);else stream.once('finish', cb);
    }

    state.ended = true;
    stream.writable = false;
  } // It seems a linked list but it is not
  // there will be only 2 of these for each stream


  function CorkedRequest$1(state) {
    var _this = this;

    this.next = null;
    this.entry = null;

    this.finish = function (err) {
      var entry = _this.entry;
      _this.entry = null;

      while (entry) {
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
      }

      if (state.corkedRequestsFree) {
        state.corkedRequestsFree.next = _this;
      } else {
        state.corkedRequestsFree = _this;
      }
    };
  }

  inherits$1(Duplex$3, Readable$1);
  var keys$1 = Object.keys(Writable$1.prototype);

  for (var v$1 = 0; v$1 < keys$1.length; v$1++) {
    var method$1 = keys$1[v$1];
    if (!Duplex$3.prototype[method$1]) Duplex$3.prototype[method$1] = Writable$1.prototype[method$1];
  }
  function Duplex$3(options) {
    if (!(this instanceof Duplex$3)) return new Duplex$3(options);
    Readable$1.call(this, options);
    Writable$1.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', onend$1);
  } // the no-half-open enforcer

  function onend$1() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.

    nextTick(onEndNT$1, this);
  }

  function onEndNT$1(self) {
    self.end();
  }

  // a transform stream is a readable/writable stream where you do
  inherits$1(Transform$2, Duplex$3);

  function TransformState(stream) {
    this.afterTransform = function (er, data) {
      return afterTransform$1(stream, er, data);
    };

    this.needTransform = false;
    this.transforming = false;
    this.writecb = null;
    this.writechunk = null;
    this.writeencoding = null;
  }

  function afterTransform$1(stream, er, data) {
    var ts = stream._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data !== null && data !== undefined) stream.push(data);
    cb(er);
    var rs = stream._readableState;
    rs.reading = false;

    if (rs.needReadable || rs.length < rs.highWaterMark) {
      stream._read(rs.highWaterMark);
    }
  }
  function Transform$2(options) {
    if (!(this instanceof Transform$2)) return new Transform$2(options);
    Duplex$3.call(this, options);
    this._transformState = new TransformState(this); // when the writable side finishes, then flush out anything remaining.

    var stream = this; // start out asking for a readable event once data is transformed.

    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.

    this._readableState.sync = false;

    if (options) {
      if (typeof options.transform === 'function') this._transform = options.transform;
      if (typeof options.flush === 'function') this._flush = options.flush;
    }

    this.once('prefinish', function () {
      if (typeof this._flush === 'function') this._flush(function (er) {
        done$1(stream, er);
      });else done$1(stream);
    });
  }

  Transform$2.prototype.push = function (chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex$3.prototype.push.call(this, chunk, encoding);
  }; // This is the part where you do stuff!
  // override this function in implementation classes.
  // 'chunk' is an input chunk.
  //
  // Call `push(newChunk)` to pass along transformed output
  // to the readable side.  You may call 'push' zero or more times.
  //
  // Call `cb(err)` when you are done with this chunk.  If you pass
  // an error, then that'll put the hurt on the whole operation.  If you
  // never call cb(), then you'll never get another chunk.


  Transform$2.prototype._transform = function (chunk, encoding, cb) {
    throw new Error('Not implemented');
  };

  Transform$2.prototype._write = function (chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;

    if (!ts.transforming) {
      var rs = this._readableState;
      if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
  }; // Doesn't matter what the args are here.
  // _transform does all the work.
  // That we got here means that the readable side wants more data.


  Transform$2.prototype._read = function (n) {
    var ts = this._transformState;

    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
      ts.transforming = true;

      this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else {
      // mark that we need a transform, so that any data that comes in
      // will get processed, now that we've asked for it.
      ts.needTransform = true;
    }
  };

  function done$1(stream, er) {
    if (er) return stream.emit('error', er); // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided

    var ws = stream._writableState;
    var ts = stream._transformState;
    if (ws.length) throw new Error('Calling transform done when ws.length != 0');
    if (ts.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
  }

  inherits$1(PassThrough$1, Transform$2);
  function PassThrough$1(options) {
    if (!(this instanceof PassThrough$1)) return new PassThrough$1(options);
    Transform$2.call(this, options);
  }

  PassThrough$1.prototype._transform = function (chunk, encoding, cb) {
    cb(null, chunk);
  };

  inherits$1(Stream, EventEmitter);
  Stream.Readable = Readable$1;
  Stream.Writable = Writable$1;
  Stream.Duplex = Duplex$3;
  Stream.Transform = Transform$2;
  Stream.PassThrough = PassThrough$1; // Backwards-compat with node 0.4.x

  Stream.Stream = Stream;
  // part of this class) is overridden in the Readable class.

  function Stream() {
    EventEmitter.call(this);
  }

  Stream.prototype.pipe = function (dest, options) {
    var source = this;

    function ondata(chunk) {
      if (dest.writable) {
        if (false === dest.write(chunk) && source.pause) {
          source.pause();
        }
      }
    }

    source.on('data', ondata);

    function ondrain() {
      if (source.readable && source.resume) {
        source.resume();
      }
    }

    dest.on('drain', ondrain); // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.

    if (!dest._isStdio && (!options || options.end !== false)) {
      source.on('end', onend);
      source.on('close', onclose);
    }

    var didOnEnd = false;

    function onend() {
      if (didOnEnd) return;
      didOnEnd = true;
      dest.end();
    }

    function onclose() {
      if (didOnEnd) return;
      didOnEnd = true;
      if (typeof dest.destroy === 'function') dest.destroy();
    } // don't leave dangling pipes when there are errors.


    function onerror(er) {
      cleanup();

      if (EventEmitter.listenerCount(this, 'error') === 0) {
        throw er; // Unhandled stream error in pipe.
      }
    }

    source.on('error', onerror);
    dest.on('error', onerror); // remove all the event listeners that were added.

    function cleanup() {
      source.removeListener('data', ondata);
      dest.removeListener('drain', ondrain);
      source.removeListener('end', onend);
      source.removeListener('close', onclose);
      source.removeListener('error', onerror);
      dest.removeListener('error', onerror);
      source.removeListener('end', cleanup);
      source.removeListener('close', cleanup);
      dest.removeListener('close', cleanup);
    }

    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source); // Allow for unix-like usage: A.pipe(B).pipe(C)

    return dest;
  };

  var Buffer$g = safeBuffer.Buffer;
  var Transform$3 = Stream.Transform;
  var StringDecoder$3 = stringDecoder.StringDecoder;

  function CipherBase(hashMode) {
    Transform$3.call(this);
    this.hashMode = typeof hashMode === 'string';

    if (this.hashMode) {
      this[hashMode] = this._finalOrDigest;
    } else {
      this["final"] = this._finalOrDigest;
    }

    if (this._final) {
      this.__final = this._final;
      this._final = null;
    }

    this._decoder = null;
    this._encoding = null;
  }

  inherits_browser(CipherBase, Transform$3);

  CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
    if (typeof data === 'string') {
      data = Buffer$g.from(data, inputEnc);
    }

    var outData = this._update(data);

    if (this.hashMode) return this;

    if (outputEnc) {
      outData = this._toString(outData, outputEnc);
    }

    return outData;
  };

  CipherBase.prototype.setAutoPadding = function () {};

  CipherBase.prototype.getAuthTag = function () {
    throw new Error('trying to get auth tag in unsupported state');
  };

  CipherBase.prototype.setAuthTag = function () {
    throw new Error('trying to set auth tag in unsupported state');
  };

  CipherBase.prototype.setAAD = function () {
    throw new Error('trying to set aad in unsupported state');
  };

  CipherBase.prototype._transform = function (data, _, next) {
    var err;

    try {
      if (this.hashMode) {
        this._update(data);
      } else {
        this.push(this._update(data));
      }
    } catch (e) {
      err = e;
    } finally {
      next(err);
    }
  };

  CipherBase.prototype._flush = function (done) {
    var err;

    try {
      this.push(this.__final());
    } catch (e) {
      err = e;
    }

    done(err);
  };

  CipherBase.prototype._finalOrDigest = function (outputEnc) {
    var outData = this.__final() || Buffer$g.alloc(0);

    if (outputEnc) {
      outData = this._toString(outData, outputEnc, true);
    }

    return outData;
  };

  CipherBase.prototype._toString = function (value, enc, fin) {
    if (!this._decoder) {
      this._decoder = new StringDecoder$3(enc);
      this._encoding = enc;
    }

    if (this._encoding !== enc) throw new Error('can\'t switch encodings');

    var out = this._decoder.write(value);

    if (fin) {
      out += this._decoder.end();
    }

    return out;
  };

  var cipherBase = CipherBase;

  function Hash$1(hash) {
    cipherBase.call(this, 'digest');
    this._hash = hash;
  }

  inherits_browser(Hash$1, cipherBase);

  Hash$1.prototype._update = function (data) {
    this._hash.update(data);
  };

  Hash$1.prototype._final = function () {
    return this._hash.digest();
  };

  var browser$2 = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new md5_js();
    if (alg === 'rmd160' || alg === 'ripemd160') return new ripemd160();
    return new Hash$1(sha_js(alg));
  };

  var jsbiUmd = createCommonjsModule(function (module, exports) {
    (function (i, _) {
       module.exports = _() ;
    })(commonjsGlobal, function () {

      var i = Math.imul,
          _ = Math.clz32,
          t = Math.abs,
          e = Math.max,
          g = Math.floor;

      var o = /*#__PURE__*/function (_Array) {
        _inherits(o, _Array);

        var _super = _createSuper(o);

        function o(i, _) {
          var _this;

          _classCallCheck(this, o);

          if (_this = _super.call(this, i), _this.sign = _, i > o.__kMaxLength) throw new RangeError("Maximum BigInt size exceeded");
          return _possibleConstructorReturn(_this);
        }

        _createClass(o, [{
          key: "toDebugString",
          value: function toDebugString() {
            var i = ["BigInt["];

            var _iterator = _createForOfIteratorHelper(this),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _2 = _step.value;
                i.push((_2 ? (_2 >>> 0).toString(16) : _2) + ", ");
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return i.push("]"), i.join("");
          }
        }, {
          key: "toString",
          value: function toString() {
            var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
            if (2 > i || 36 < i) throw new RangeError("toString() radix argument must be between 2 and 36");
            return 0 === this.length ? "0" : 0 == (i & i - 1) ? o.__toStringBasePowerOfTwo(this, i) : o.__toStringGeneric(this, i, !1);
          }
        }, {
          key: "__copy",
          value: function __copy() {
            var _ = new o(this.length, this.sign);

            for (var _t = 0; _t < this.length; _t++) {
              _[_t] = this[_t];
            }

            return _;
          }
        }, {
          key: "__trim",
          value: function __trim() {
            var i = this.length,
                _ = this[i - 1];

            for (; 0 === _;) {
              i--, _ = this[i - 1], this.pop();
            }

            return 0 === i && (this.sign = !1), this;
          }
        }, {
          key: "__initializeDigits",
          value: function __initializeDigits() {
            for (var _3 = 0; _3 < this.length; _3++) {
              this[_3] = 0;
            }
          }
        }, {
          key: "__clzmsd",
          value: function __clzmsd() {
            return o.__clz30(this.__digit(this.length - 1));
          }
        }, {
          key: "__inplaceMultiplyAdd",
          value: function __inplaceMultiplyAdd(i, _, t) {
            t > this.length && (t = this.length);
            var e = 32767 & i,
                n = i >>> 15;
            var g = 0,
                s = _;

            for (var l = 0; l < t; l++) {
              var _i = this.__digit(l),
                  _4 = 32767 & _i,
                  _t2 = _i >>> 15,
                  r = o.__imul(_4, e),
                  a = o.__imul(_4, n),
                  u = o.__imul(_t2, e),
                  d = o.__imul(_t2, n);

              var h = s + r + g;
              g = h >>> 30, h &= 1073741823, h += ((32767 & a) << 15) + ((32767 & u) << 15), g += h >>> 30, s = d + (a >>> 15) + (u >>> 15), this.__setDigit(l, 1073741823 & h);
            }

            if (0 != g || 0 !== s) throw new Error("implementation bug");
          }
        }, {
          key: "__inplaceAdd",
          value: function __inplaceAdd(_, t, e) {
            var n = 0;

            for (var _g = 0; _g < e; _g++) {
              var _i2 = this.__halfDigit(t + _g) + _.__halfDigit(_g) + n;

              n = _i2 >>> 15, this.__setHalfDigit(t + _g, 32767 & _i2);
            }

            return n;
          }
        }, {
          key: "__inplaceSub",
          value: function __inplaceSub(_, t, e) {
            var n = 0;

            if (1 & t) {
              t >>= 1;

              var _g2 = this.__digit(t),
                  _o11 = 32767 & _g2,
                  s = 0;

              for (; s < e - 1 >>> 1; s++) {
                var _i4 = _.__digit(s),
                    _e = (_g2 >>> 15) - (32767 & _i4) - n;

                n = 1 & _e >>> 15, this.__setDigit(t + s, (32767 & _e) << 15 | 32767 & _o11), _g2 = this.__digit(t + s + 1), _o11 = (32767 & _g2) - (_i4 >>> 15) - n, n = 1 & _o11 >>> 15;
              }

              var _i3 = _.__digit(s),
                  l = (_g2 >>> 15) - (32767 & _i3) - n;

              n = 1 & l >>> 15, this.__setDigit(t + s, (32767 & l) << 15 | 32767 & _o11);
              if (t + s + 1 >= this.length) throw new RangeError("out of bounds");
              0 == (1 & e) && (_g2 = this.__digit(t + s + 1), _o11 = (32767 & _g2) - (_i3 >>> 15) - n, n = 1 & _o11 >>> 15, this.__setDigit(t + _.length, 1073709056 & _g2 | 32767 & _o11));
            } else {
              t >>= 1;
              var _g3 = 0;

              for (; _g3 < _.length - 1; _g3++) {
                var _i6 = this.__digit(t + _g3),
                    _e2 = _.__digit(_g3),
                    _o13 = (32767 & _i6) - (32767 & _e2) - n;

                n = 1 & _o13 >>> 15;

                var _s2 = (_i6 >>> 15) - (_e2 >>> 15) - n;

                n = 1 & _s2 >>> 15, this.__setDigit(t + _g3, (32767 & _s2) << 15 | 32767 & _o13);
              }

              var _i5 = this.__digit(t + _g3),
                  _o12 = _.__digit(_g3),
                  _s = (32767 & _i5) - (32767 & _o12) - n;

              n = 1 & _s >>> 15;
              var _l = 0;
              0 == (1 & e) && (_l = (_i5 >>> 15) - (_o12 >>> 15) - n, n = 1 & _l >>> 15), this.__setDigit(t + _g3, (32767 & _l) << 15 | 32767 & _s);
            }

            return n;
          }
        }, {
          key: "__inplaceRightShift",
          value: function __inplaceRightShift(_) {
            if (0 === _) return;

            var t = this.__digit(0) >>> _;

            var e = this.length - 1;

            for (var n = 0; n < e; n++) {
              var _i7 = this.__digit(n + 1);

              this.__setDigit(n, 1073741823 & _i7 << 30 - _ | t), t = _i7 >>> _;
            }

            this.__setDigit(e, t);
          }
        }, {
          key: "__digit",
          value: function __digit(_) {
            return this[_];
          }
        }, {
          key: "__unsignedDigit",
          value: function __unsignedDigit(_) {
            return this[_] >>> 0;
          }
        }, {
          key: "__setDigit",
          value: function __setDigit(_, i) {
            this[_] = 0 | i;
          }
        }, {
          key: "__setDigitGrow",
          value: function __setDigitGrow(_, i) {
            this[_] = 0 | i;
          }
        }, {
          key: "__halfDigitLength",
          value: function __halfDigitLength() {
            var i = this.length;
            return 32767 >= this.__unsignedDigit(i - 1) ? 2 * i - 1 : 2 * i;
          }
        }, {
          key: "__halfDigit",
          value: function __halfDigit(_) {
            return 32767 & this[_ >>> 1] >>> 15 * (1 & _);
          }
        }, {
          key: "__setHalfDigit",
          value: function __setHalfDigit(_, i) {
            var t = _ >>> 1,
                e = this.__digit(t),
                n = 1 & _ ? 32767 & e | i << 15 : 1073709056 & e | 32767 & i;

            this.__setDigit(t, n);
          }
        }], [{
          key: "BigInt",
          value: function BigInt(i) {
            var _ = Number.isFinite;

            if ("number" == typeof i) {
              if (0 === i) return o.__zero();
              if (o.__isOneDigitInt(i)) return 0 > i ? o.__oneDigit(-i, !0) : o.__oneDigit(i, !1);
              if (!_(i) || g(i) !== i) throw new RangeError("The number " + i + " cannot be converted to BigInt because it is not an integer");
              return o.__fromDouble(i);
            }

            if ("string" == typeof i) {
              var _5 = o.__fromString(i);

              if (null === _5) throw new SyntaxError("Cannot convert " + i + " to a BigInt");
              return _5;
            }

            if ("boolean" == typeof i) return !0 === i ? o.__oneDigit(1, !1) : o.__zero();

            if ("object" == _typeof(i)) {
              if (i.constructor === o) return i;

              var _6 = o.__toPrimitive(i);

              return o.BigInt(_6);
            }

            throw new TypeError("Cannot convert " + i + " to a BigInt");
          }
        }, {
          key: "toNumber",
          value: function toNumber(i) {
            var _ = i.length;
            if (0 === _) return 0;

            if (1 === _) {
              var _7 = i.__unsignedDigit(0);

              return i.sign ? -_7 : _7;
            }

            var t = i.__digit(_ - 1),
                e = o.__clz30(t),
                n = 30 * _ - e;

            if (1024 < n) return i.sign ? -Infinity : 1 / 0;
            var g = n - 1,
                s = t,
                l = _ - 1;
            var r = e + 3;
            var a = 32 === r ? 0 : s << r;
            a >>>= 12;
            var u = r - 12;
            var d = 12 <= r ? 0 : s << 20 + r,
                h = 20 + r;

            for (0 < u && 0 < l && (l--, s = i.__digit(l), a |= s >>> 30 - u, d = s << u + 2, h = u + 2); 0 < h && 0 < l;) {
              l--, s = i.__digit(l), d |= 30 <= h ? s << h - 30 : s >>> 30 - h, h -= 30;
            }

            var m = o.__decideRounding(i, h, l, s);

            if ((1 === m || 0 === m && 1 == (1 & d)) && (d = d + 1 >>> 0, 0 === d && (a++, 0 != a >>> 20 && (a = 0, g++, 1023 < g)))) return i.sign ? -Infinity : 1 / 0;
            var b = i.sign ? -2147483648 : 0;
            return g = g + 1023 << 20, o.__kBitConversionInts[1] = b | g | a, o.__kBitConversionInts[0] = d, o.__kBitConversionDouble[0];
          }
        }, {
          key: "unaryMinus",
          value: function unaryMinus(i) {
            if (0 === i.length) return i;

            var _ = i.__copy();

            return _.sign = !i.sign, _;
          }
        }, {
          key: "bitwiseNot",
          value: function bitwiseNot(i) {
            return i.sign ? o.__absoluteSubOne(i).__trim() : o.__absoluteAddOne(i, !0);
          }
        }, {
          key: "exponentiate",
          value: function exponentiate(i, _) {
            if (_.sign) throw new RangeError("Exponent must be positive");
            if (0 === _.length) return o.__oneDigit(1, !1);
            if (0 === i.length) return i;
            if (1 === i.length && 1 === i.__digit(0)) return i.sign && 0 == (1 & _.__digit(0)) ? o.unaryMinus(i) : i;
            if (1 < _.length) throw new RangeError("BigInt too big");

            var t = _.__unsignedDigit(0);

            if (1 === t) return i;
            if (t >= o.__kMaxLengthBits) throw new RangeError("BigInt too big");

            if (1 === i.length && 2 === i.__digit(0)) {
              var _8 = 1 + (0 | t / 30),
                  _e3 = i.sign && 0 != (1 & t),
                  _n = new o(_8, _e3);

              _n.__initializeDigits();

              var _g4 = 1 << t % 30;

              return _n.__setDigit(_8 - 1, _g4), _n;
            }

            var e = null,
                n = i;

            for (0 != (1 & t) && (e = i), t >>= 1; 0 !== t; t >>= 1) {
              n = o.multiply(n, n), 0 != (1 & t) && (null === e ? e = n : e = o.multiply(e, n));
            }

            return e;
          }
        }, {
          key: "multiply",
          value: function multiply(_, t) {
            if (0 === _.length) return _;
            if (0 === t.length) return t;
            var i = _.length + t.length;
            30 <= _.__clzmsd() + t.__clzmsd() && i--;
            var e = new o(i, _.sign !== t.sign);

            e.__initializeDigits();

            for (var n = 0; n < _.length; n++) {
              o.__multiplyAccumulate(t, _.__digit(n), e, n);
            }

            return e.__trim();
          }
        }, {
          key: "divide",
          value: function divide(i, _) {
            if (0 === _.length) throw new RangeError("Division by zero");
            if (0 > o.__absoluteCompare(i, _)) return o.__zero();

            var t = i.sign !== _.sign,
                e = _.__unsignedDigit(0);

            var n;

            if (1 === _.length && 32767 >= e) {
              if (1 === e) return t === i.sign ? i : o.unaryMinus(i);
              n = o.__absoluteDivSmall(i, e, null);
            } else n = o.__absoluteDivLarge(i, _, !0, !1);

            return n.sign = t, n.__trim();
          }
        }, {
          key: "remainder",
          value: function remainder(i, _) {
            if (0 === _.length) throw new RangeError("Division by zero");
            if (0 > o.__absoluteCompare(i, _)) return i;

            var t = _.__unsignedDigit(0);

            if (1 === _.length && 32767 >= t) {
              if (1 === t) return o.__zero();

              var _9 = o.__absoluteModSmall(i, t);

              return 0 === _9 ? o.__zero() : o.__oneDigit(_9, i.sign);
            }

            var e = o.__absoluteDivLarge(i, _, !1, !0);

            return e.sign = i.sign, e.__trim();
          }
        }, {
          key: "add",
          value: function add(i, _) {
            var t = i.sign;
            return t === _.sign ? o.__absoluteAdd(i, _, t) : 0 <= o.__absoluteCompare(i, _) ? o.__absoluteSub(i, _, t) : o.__absoluteSub(_, i, !t);
          }
        }, {
          key: "subtract",
          value: function subtract(i, _) {
            var t = i.sign;
            return t === _.sign ? 0 <= o.__absoluteCompare(i, _) ? o.__absoluteSub(i, _, t) : o.__absoluteSub(_, i, !t) : o.__absoluteAdd(i, _, t);
          }
        }, {
          key: "leftShift",
          value: function leftShift(i, _) {
            return 0 === _.length || 0 === i.length ? i : _.sign ? o.__rightShiftByAbsolute(i, _) : o.__leftShiftByAbsolute(i, _);
          }
        }, {
          key: "signedRightShift",
          value: function signedRightShift(i, _) {
            return 0 === _.length || 0 === i.length ? i : _.sign ? o.__leftShiftByAbsolute(i, _) : o.__rightShiftByAbsolute(i, _);
          }
        }, {
          key: "unsignedRightShift",
          value: function unsignedRightShift() {
            throw new TypeError("BigInts have no unsigned right shift; use >> instead");
          }
        }, {
          key: "lessThan",
          value: function lessThan(i, _) {
            return 0 > o.__compareToBigInt(i, _);
          }
        }, {
          key: "lessThanOrEqual",
          value: function lessThanOrEqual(i, _) {
            return 0 >= o.__compareToBigInt(i, _);
          }
        }, {
          key: "greaterThan",
          value: function greaterThan(i, _) {
            return 0 < o.__compareToBigInt(i, _);
          }
        }, {
          key: "greaterThanOrEqual",
          value: function greaterThanOrEqual(i, _) {
            return 0 <= o.__compareToBigInt(i, _);
          }
        }, {
          key: "equal",
          value: function equal(_, t) {
            if (_.sign !== t.sign) return !1;
            if (_.length !== t.length) return !1;

            for (var _e4 = 0; _e4 < _.length; _e4++) {
              if (_.__digit(_e4) !== t.__digit(_e4)) return !1;
            }

            return !0;
          }
        }, {
          key: "notEqual",
          value: function notEqual(i, _) {
            return !o.equal(i, _);
          }
        }, {
          key: "bitwiseAnd",
          value: function bitwiseAnd(i, _) {
            var _ref;

            if (!i.sign && !_.sign) return o.__absoluteAnd(i, _).__trim();

            if (i.sign && _.sign) {
              var _t3 = e(i.length, _.length) + 1;

              var n = o.__absoluteSubOne(i, _t3);

              var _g5 = o.__absoluteSubOne(_);

              return n = o.__absoluteOr(n, _g5, n), o.__absoluteAddOne(n, !0, n).__trim();
            }

            return i.sign && (_ref = [_, i], i = _ref[0], _ = _ref[1], _ref), o.__absoluteAndNot(i, o.__absoluteSubOne(_)).__trim();
          }
        }, {
          key: "bitwiseXor",
          value: function bitwiseXor(i, _) {
            var _ref2;

            if (!i.sign && !_.sign) return o.__absoluteXor(i, _).__trim();

            if (i.sign && _.sign) {
              var _t4 = e(i.length, _.length),
                  _n2 = o.__absoluteSubOne(i, _t4),
                  _g6 = o.__absoluteSubOne(_);

              return o.__absoluteXor(_n2, _g6, _n2).__trim();
            }

            var t = e(i.length, _.length) + 1;
            i.sign && (_ref2 = [_, i], i = _ref2[0], _ = _ref2[1], _ref2);

            var n = o.__absoluteSubOne(_, t);

            return n = o.__absoluteXor(n, i, n), o.__absoluteAddOne(n, !0, n).__trim();
          }
        }, {
          key: "bitwiseOr",
          value: function bitwiseOr(i, _) {
            var _ref3;

            var t = e(i.length, _.length);
            if (!i.sign && !_.sign) return o.__absoluteOr(i, _).__trim();

            if (i.sign && _.sign) {
              var _e5 = o.__absoluteSubOne(i, t);

              var _n3 = o.__absoluteSubOne(_);

              return _e5 = o.__absoluteAnd(_e5, _n3, _e5), o.__absoluteAddOne(_e5, !0, _e5).__trim();
            }

            i.sign && (_ref3 = [_, i], i = _ref3[0], _ = _ref3[1], _ref3);

            var n = o.__absoluteSubOne(_, t);

            return n = o.__absoluteAndNot(n, i, n), o.__absoluteAddOne(n, !0, n).__trim();
          }
        }, {
          key: "asIntN",
          value: function asIntN(_, t) {
            if (0 === t.length) return t;
            if (_ = g(_), 0 > _) throw new RangeError("Invalid value: not (convertible to) a safe integer");
            if (0 === _) return o.__zero();
            if (_ >= o.__kMaxLengthBits) return t;
            var e = 0 | (_ + 29) / 30;
            if (t.length < e) return t;

            var s = t.__unsignedDigit(e - 1),
                l = 1 << (_ - 1) % 30;

            if (t.length === e && s < l) return t;
            if (!((s & l) === l)) return o.__truncateToNBits(_, t);
            if (!t.sign) return o.__truncateAndSubFromPowerOfTwo(_, t, !0);

            if (0 == (s & l - 1)) {
              for (var n = e - 2; 0 <= n; n--) {
                if (0 !== t.__digit(n)) return o.__truncateAndSubFromPowerOfTwo(_, t, !1);
              }

              return t.length === e && s === l ? t : o.__truncateToNBits(_, t);
            }

            return o.__truncateAndSubFromPowerOfTwo(_, t, !1);
          }
        }, {
          key: "asUintN",
          value: function asUintN(i, _) {
            if (0 === _.length) return _;
            if (i = g(i), 0 > i) throw new RangeError("Invalid value: not (convertible to) a safe integer");
            if (0 === i) return o.__zero();

            if (_.sign) {
              if (i > o.__kMaxLengthBits) throw new RangeError("BigInt too big");
              return o.__truncateAndSubFromPowerOfTwo(i, _, !1);
            }

            if (i >= o.__kMaxLengthBits) return _;
            var t = 0 | (i + 29) / 30;
            if (_.length < t) return _;
            var e = i % 30;

            if (_.length == t) {
              if (0 === e) return _;

              var _i8 = _.__digit(t - 1);

              if (0 == _i8 >>> e) return _;
            }

            return o.__truncateToNBits(i, _);
          }
        }, {
          key: "ADD",
          value: function ADD(i, _) {
            if (i = o.__toPrimitive(i), _ = o.__toPrimitive(_), "string" == typeof i) return "string" != typeof _ && (_ = _.toString()), i + _;
            if ("string" == typeof _) return i.toString() + _;
            if (i = o.__toNumeric(i), _ = o.__toNumeric(_), o.__isBigInt(i) && o.__isBigInt(_)) return o.add(i, _);
            if ("number" == typeof i && "number" == typeof _) return i + _;
            throw new TypeError("Cannot mix BigInt and other types, use explicit conversions");
          }
        }, {
          key: "LT",
          value: function LT(i, _) {
            return o.__compare(i, _, 0);
          }
        }, {
          key: "LE",
          value: function LE(i, _) {
            return o.__compare(i, _, 1);
          }
        }, {
          key: "GT",
          value: function GT(i, _) {
            return o.__compare(i, _, 2);
          }
        }, {
          key: "GE",
          value: function GE(i, _) {
            return o.__compare(i, _, 3);
          }
        }, {
          key: "EQ",
          value: function EQ(i, _) {
            for (;;) {
              if (o.__isBigInt(i)) return o.__isBigInt(_) ? o.equal(i, _) : o.EQ(_, i);

              if ("number" == typeof i) {
                if (o.__isBigInt(_)) return o.__equalToNumber(_, i);
                if ("object" != _typeof(_)) return i == _;
                _ = o.__toPrimitive(_);
              } else if ("string" == typeof i) {
                if (o.__isBigInt(_)) return i = o.__fromString(i), null !== i && o.equal(i, _);
                if ("object" != _typeof(_)) return i == _;
                _ = o.__toPrimitive(_);
              } else if ("boolean" == typeof i) {
                if (o.__isBigInt(_)) return o.__equalToNumber(_, +i);
                if ("object" != _typeof(_)) return i == _;
                _ = o.__toPrimitive(_);
              } else if ("symbol" == _typeof(i)) {
                if (o.__isBigInt(_)) return !1;
                if ("object" != _typeof(_)) return i == _;
                _ = o.__toPrimitive(_);
              } else if ("object" == _typeof(i)) {
                if ("object" == _typeof(_) && _.constructor !== o) return i == _;
                i = o.__toPrimitive(i);
              } else return i == _;
            }
          }
        }, {
          key: "NE",
          value: function NE(i, _) {
            return !o.EQ(i, _);
          }
        }, {
          key: "__zero",
          value: function __zero() {
            return new o(0, !1);
          }
        }, {
          key: "__oneDigit",
          value: function __oneDigit(i, _) {
            var t = new o(1, _);
            return t.__setDigit(0, i), t;
          }
        }, {
          key: "__decideRounding",
          value: function __decideRounding(i, _, t, e) {
            if (0 < _) return -1;
            var n;
            if (0 > _) n = -_ - 1;else {
              if (0 === t) return -1;
              t--, e = i.__digit(t), n = 29;
            }
            var g = 1 << n;
            if (0 == (e & g)) return -1;
            if (g -= 1, 0 != (e & g)) return 1;

            for (; 0 < t;) {
              if (t--, 0 !== i.__digit(t)) return 1;
            }

            return 0;
          }
        }, {
          key: "__fromDouble",
          value: function __fromDouble(i) {
            o.__kBitConversionDouble[0] = i;

            var _ = 2047 & o.__kBitConversionInts[1] >>> 20,
                t = _ - 1023,
                e = (0 | t / 30) + 1,
                n = new o(e, 0 > i);

            var g = 1048575 & o.__kBitConversionInts[1] | 1048576,
                s = o.__kBitConversionInts[0];
            var l = 20,
                r = t % 30;
            var a,
                u = 0;

            if (20 > r) {
              var _i9 = l - r;

              u = _i9 + 32, a = g >>> _i9, g = g << 32 - _i9 | s >>> _i9, s <<= 32 - _i9;
            } else if (20 === r) u = 32, a = g, g = s, s = 0;else {
              var _i10 = r - l;

              u = 32 - _i10, a = g << _i10 | s >>> 32 - _i10, g = s << _i10, s = 0;
            }

            n.__setDigit(e - 1, a);

            for (var _10 = e - 2; 0 <= _10; _10--) {
              0 < u ? (u -= 30, a = g >>> 2, g = g << 30 | s >>> 2, s <<= 30) : a = 0, n.__setDigit(_10, a);
            }

            return n.__trim();
          }
        }, {
          key: "__isWhitespace",
          value: function __isWhitespace(i) {
            return !!(13 >= i && 9 <= i) || (159 >= i ? 32 == i : 131071 >= i ? 160 == i || 5760 == i : 196607 >= i ? (i &= 131071, 10 >= i || 40 == i || 41 == i || 47 == i || 95 == i || 4096 == i) : 65279 == i);
          }
        }, {
          key: "__fromString",
          value: function __fromString(i) {
            var _ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var t = 0;
            var e = i.length;
            var n = 0;
            if (n === e) return o.__zero();
            var g = i.charCodeAt(n);

            for (; o.__isWhitespace(g);) {
              if (++n === e) return o.__zero();
              g = i.charCodeAt(n);
            }

            if (43 === g) {
              if (++n === e) return null;
              g = i.charCodeAt(n), t = 1;
            } else if (45 === g) {
              if (++n === e) return null;
              g = i.charCodeAt(n), t = -1;
            }

            if (0 === _) {
              if (_ = 10, 48 === g) {
                if (++n === e) return o.__zero();

                if (g = i.charCodeAt(n), 88 === g || 120 === g) {
                  if (_ = 16, ++n === e) return null;
                  g = i.charCodeAt(n);
                } else if (79 === g || 111 === g) {
                  if (_ = 8, ++n === e) return null;
                  g = i.charCodeAt(n);
                } else if (66 === g || 98 === g) {
                  if (_ = 2, ++n === e) return null;
                  g = i.charCodeAt(n);
                }
              }
            } else if (16 === _ && 48 === g) {
              if (++n === e) return o.__zero();

              if (g = i.charCodeAt(n), 88 === g || 120 === g) {
                if (++n === e) return null;
                g = i.charCodeAt(n);
              }
            }

            if (0 != t && 10 !== _) return null;

            for (; 48 === g;) {
              if (++n === e) return o.__zero();
              g = i.charCodeAt(n);
            }

            var s = e - n;
            var l = o.__kMaxBitsPerChar[_],
                r = o.__kBitsPerCharTableMultiplier - 1;
            if (s > 1073741824 / l) return null;
            var a = l * s + r >>> o.__kBitsPerCharTableShift,
                u = new o(0 | (a + 29) / 30, !1),
                h = 10 > _ ? _ : 10,
                b = 10 < _ ? _ - 10 : 0;

            if (0 == (_ & _ - 1)) {
              l >>= o.__kBitsPerCharTableShift;
              var _11 = [],
                  _t5 = [];

              var _s3 = !1;

              do {
                var _o14 = 0,
                    _r = 0;

                for (;;) {
                  var _12 = void 0;

                  if (g - 48 >>> 0 < h) _12 = g - 48;else if ((32 | g) - 97 >>> 0 < b) _12 = (32 | g) - 87;else {
                    _s3 = !0;
                    break;
                  }

                  if (_r += l, _o14 = _o14 << l | _12, ++n === e) {
                    _s3 = !0;
                    break;
                  }

                  if (g = i.charCodeAt(n), 30 < _r + l) break;
                }

                _11.push(_o14), _t5.push(_r);
              } while (!_s3);

              o.__fillFromParts(u, _11, _t5);
            } else {
              u.__initializeDigits();

              var _t6 = !1,
                  _s4 = 0;

              do {
                var _a = 0,
                    D = 1;

                for (;;) {
                  var _o15 = void 0;

                  if (g - 48 >>> 0 < h) _o15 = g - 48;else if ((32 | g) - 97 >>> 0 < b) _o15 = (32 | g) - 87;else {
                    _t6 = !0;
                    break;
                  }

                  var _l2 = D * _;

                  if (1073741823 < _l2) break;

                  if (D = _l2, _a = _a * _ + _o15, _s4++, ++n === e) {
                    _t6 = !0;
                    break;
                  }

                  g = i.charCodeAt(n);
                }

                r = 30 * o.__kBitsPerCharTableMultiplier - 1;
                var c = 0 | (l * _s4 + r >>> o.__kBitsPerCharTableShift) / 30;

                u.__inplaceMultiplyAdd(D, _a, c);
              } while (!_t6);
            }

            if (n !== e) {
              if (!o.__isWhitespace(g)) return null;

              for (n++; n < e; n++) {
                if (g = i.charCodeAt(n), !o.__isWhitespace(g)) return null;
              }
            }

            return u.sign = -1 == t, u.__trim();
          }
        }, {
          key: "__fillFromParts",
          value: function __fillFromParts(_, t, e) {
            var n = 0,
                g = 0,
                _o3 = 0;

            for (var s = t.length - 1; 0 <= s; s--) {
              var _i11 = t[s],
                  l = e[s];
              g |= _i11 << _o3, _o3 += l, 30 === _o3 ? (_.__setDigit(n++, g), _o3 = 0, g = 0) : 30 < _o3 && (_.__setDigit(n++, 1073741823 & g), _o3 -= 30, g = _i11 >>> l - _o3);
            }

            if (0 !== g) {
              if (n >= _.length) throw new Error("implementation bug");

              _.__setDigit(n++, g);
            }

            for (; n < _.length; n++) {
              _.__setDigit(n, 0);
            }
          }
        }, {
          key: "__toStringBasePowerOfTwo",
          value: function __toStringBasePowerOfTwo(_, i) {
            var t = _.length;
            var e = i - 1;
            e = (85 & e >>> 1) + (85 & e), e = (51 & e >>> 2) + (51 & e), e = (15 & e >>> 4) + (15 & e);

            var n = e,
                g = i - 1,
                s = _.__digit(t - 1),
                l = o.__clz30(s);

            var r = 0 | (30 * t - l + n - 1) / n;
            if (_.sign && r++, 268435456 < r) throw new Error("string too long");
            var a = Array(r);
            var u = r - 1,
                d = 0,
                h = 0;

            for (var _e6 = 0; _e6 < t - 1; _e6++) {
              var _i12 = _.__digit(_e6),
                  _t7 = (d | _i12 << h) & g;

              a[u--] = o.__kConversionChars[_t7];

              var _s5 = n - h;

              for (d = _i12 >>> _s5, h = 30 - _s5; h >= n;) {
                a[u--] = o.__kConversionChars[d & g], d >>>= n, h -= n;
              }
            }

            var m = (d | s << h) & g;

            for (a[u--] = o.__kConversionChars[m], d = s >>> n - h; 0 !== d;) {
              a[u--] = o.__kConversionChars[d & g], d >>>= n;
            }

            if (_.sign && (a[u--] = "-"), -1 != u) throw new Error("implementation bug");
            return a.join("");
          }
        }, {
          key: "__toStringGeneric",
          value: function __toStringGeneric(_, i, t) {
            var e = _.length;
            if (0 === e) return "";

            if (1 === e) {
              var _e7 = _.__unsignedDigit(0).toString(i);

              return !1 === t && _.sign && (_e7 = "-" + _e7), _e7;
            }

            var n = 30 * e - o.__clz30(_.__digit(e - 1)),
                g = o.__kMaxBitsPerChar[i],
                s = g - 1;

            var l = n * o.__kBitsPerCharTableMultiplier;
            l += s - 1, l = 0 | l / s;
            var r = l + 1 >> 1,
                a = o.exponentiate(o.__oneDigit(i, !1), o.__oneDigit(r, !1));
            var u, d;

            var h = a.__unsignedDigit(0);

            if (1 === a.length && 32767 >= h) {
              u = new o(_.length, !1), u.__initializeDigits();
              var _t8 = 0;

              for (var _e8 = 2 * _.length - 1; 0 <= _e8; _e8--) {
                var _i13 = _t8 << 15 | _.__halfDigit(_e8);

                u.__setHalfDigit(_e8, 0 | _i13 / h), _t8 = 0 | _i13 % h;
              }

              d = _t8.toString(i);
            } else {
              var _t9 = o.__absoluteDivLarge(_, a, !0, !0);

              u = _t9.quotient;

              var _e9 = _t9.remainder.__trim();

              d = o.__toStringGeneric(_e9, i, !0);
            }

            u.__trim();

            var m = o.__toStringGeneric(u, i, !0);

            for (; d.length < r;) {
              d = "0" + d;
            }

            return !1 === t && _.sign && (m = "-" + m), m + d;
          }
        }, {
          key: "__unequalSign",
          value: function __unequalSign(i) {
            return i ? -1 : 1;
          }
        }, {
          key: "__absoluteGreater",
          value: function __absoluteGreater(i) {
            return i ? -1 : 1;
          }
        }, {
          key: "__absoluteLess",
          value: function __absoluteLess(i) {
            return i ? 1 : -1;
          }
        }, {
          key: "__compareToBigInt",
          value: function __compareToBigInt(i, _) {
            var t = i.sign;
            if (t !== _.sign) return o.__unequalSign(t);

            var e = o.__absoluteCompare(i, _);

            return 0 < e ? o.__absoluteGreater(t) : 0 > e ? o.__absoluteLess(t) : 0;
          }
        }, {
          key: "__compareToNumber",
          value: function __compareToNumber(i, _) {
            if (o.__isOneDigitInt(_)) {
              var _e10 = i.sign,
                  n = 0 > _;
              if (_e10 !== n) return o.__unequalSign(_e10);

              if (0 === i.length) {
                if (n) throw new Error("implementation bug");
                return 0 === _ ? 0 : -1;
              }

              if (1 < i.length) return o.__absoluteGreater(_e10);

              var _g7 = t(_),
                  s = i.__unsignedDigit(0);

              return s > _g7 ? o.__absoluteGreater(_e10) : s < _g7 ? o.__absoluteLess(_e10) : 0;
            }

            return o.__compareToDouble(i, _);
          }
        }, {
          key: "__compareToDouble",
          value: function __compareToDouble(i, _) {
            if (_ !== _) return _;
            if (_ === 1 / 0) return -1;
            if (_ === -Infinity) return 1;
            var t = i.sign;
            if (t !== 0 > _) return o.__unequalSign(t);
            if (0 === _) throw new Error("implementation bug: should be handled elsewhere");
            if (0 === i.length) return -1;
            o.__kBitConversionDouble[0] = _;
            var e = 2047 & o.__kBitConversionInts[1] >>> 20;
            if (2047 == e) throw new Error("implementation bug: handled elsewhere");
            var n = e - 1023;
            if (0 > n) return o.__absoluteGreater(t);
            var g = i.length;

            var s = i.__digit(g - 1);

            var l = o.__clz30(s),
                r = 30 * g - l,
                a = n + 1;

            if (r < a) return o.__absoluteLess(t);
            if (r > a) return o.__absoluteGreater(t);
            var u = 1048576 | 1048575 & o.__kBitConversionInts[1],
                d = o.__kBitConversionInts[0];
            var h = 20,
                m = 29 - l;
            if (m !== (0 | (r - 1) % 30)) throw new Error("implementation bug");
            var b,
                D = 0;

            if (20 > m) {
              var _i14 = h - m;

              D = _i14 + 32, b = u >>> _i14, u = u << 32 - _i14 | d >>> _i14, d <<= 32 - _i14;
            } else if (20 === m) D = 32, b = u, u = d, d = 0;else {
              var _i15 = m - h;

              D = 32 - _i15, b = u << _i15 | d >>> 32 - _i15, u = d << _i15, d = 0;
            }

            if (s >>>= 0, b >>>= 0, s > b) return o.__absoluteGreater(t);
            if (s < b) return o.__absoluteLess(t);

            for (var _e11 = g - 2; 0 <= _e11; _e11--) {
              0 < D ? (D -= 30, b = u >>> 2, u = u << 30 | d >>> 2, d <<= 30) : b = 0;

              var _13 = i.__unsignedDigit(_e11);

              if (_13 > b) return o.__absoluteGreater(t);
              if (_13 < b) return o.__absoluteLess(t);
            }

            if (0 !== u || 0 !== d) {
              if (0 === D) throw new Error("implementation bug");
              return o.__absoluteLess(t);
            }

            return 0;
          }
        }, {
          key: "__equalToNumber",
          value: function __equalToNumber(i, _) {
            return o.__isOneDigitInt(_) ? 0 === _ ? 0 === i.length : 1 === i.length && i.sign === 0 > _ && i.__unsignedDigit(0) === t(_) : 0 === o.__compareToDouble(i, _);
          }
        }, {
          key: "__comparisonResultToBool",
          value: function __comparisonResultToBool(i, _) {
            return 0 === _ ? 0 > i : 1 === _ ? 0 >= i : 2 === _ ? 0 < i : 3 === _ ? 0 <= i : void 0;
          }
        }, {
          key: "__compare",
          value: function __compare(i, _, t) {
            if (i = o.__toPrimitive(i), _ = o.__toPrimitive(_), "string" == typeof i && "string" == typeof _) switch (t) {
              case 0:
                return i < _;

              case 1:
                return i <= _;

              case 2:
                return i > _;

              case 3:
                return i >= _;
            }
            if (o.__isBigInt(i) && "string" == typeof _) return _ = o.__fromString(_), null !== _ && o.__comparisonResultToBool(o.__compareToBigInt(i, _), t);
            if ("string" == typeof i && o.__isBigInt(_)) return i = o.__fromString(i), null !== i && o.__comparisonResultToBool(o.__compareToBigInt(i, _), t);

            if (i = o.__toNumeric(i), _ = o.__toNumeric(_), o.__isBigInt(i)) {
              if (o.__isBigInt(_)) return o.__comparisonResultToBool(o.__compareToBigInt(i, _), t);
              if ("number" != typeof _) throw new Error("implementation bug");
              return o.__comparisonResultToBool(o.__compareToNumber(i, _), t);
            }

            if ("number" != typeof i) throw new Error("implementation bug");
            if (o.__isBigInt(_)) return o.__comparisonResultToBool(o.__compareToNumber(_, i), 2 ^ t);
            if ("number" != typeof _) throw new Error("implementation bug");
            return 0 === t ? i < _ : 1 === t ? i <= _ : 2 === t ? i > _ : 3 === t ? i >= _ : void 0;
          }
        }, {
          key: "__absoluteAdd",
          value: function __absoluteAdd(_, t, e) {
            if (_.length < t.length) return o.__absoluteAdd(t, _, e);
            if (0 === _.length) return _;
            if (0 === t.length) return _.sign === e ? _ : o.unaryMinus(_);
            var n = _.length;
            (0 === _.__clzmsd() || t.length === _.length && 0 === t.__clzmsd()) && n++;
            var g = new o(n, e);
            var s = 0,
                l = 0;

            for (; l < t.length; l++) {
              var _i16 = _.__digit(l) + t.__digit(l) + s;

              s = _i16 >>> 30, g.__setDigit(l, 1073741823 & _i16);
            }

            for (; l < _.length; l++) {
              var _i17 = _.__digit(l) + s;

              s = _i17 >>> 30, g.__setDigit(l, 1073741823 & _i17);
            }

            return l < g.length && g.__setDigit(l, s), g.__trim();
          }
        }, {
          key: "__absoluteSub",
          value: function __absoluteSub(_, t, e) {
            if (0 === _.length) return _;
            if (0 === t.length) return _.sign === e ? _ : o.unaryMinus(_);
            var n = new o(_.length, e);
            var g = 0,
                s = 0;

            for (; s < t.length; s++) {
              var _i18 = _.__digit(s) - t.__digit(s) - g;

              g = 1 & _i18 >>> 30, n.__setDigit(s, 1073741823 & _i18);
            }

            for (; s < _.length; s++) {
              var _i19 = _.__digit(s) - g;

              g = 1 & _i19 >>> 30, n.__setDigit(s, 1073741823 & _i19);
            }

            return n.__trim();
          }
        }, {
          key: "__absoluteAddOne",
          value: function __absoluteAddOne(_, i) {
            var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var e = _.length;
            null === t ? t = new o(e, i) : t.sign = i;
            var n = 1;

            for (var _g8 = 0; _g8 < e; _g8++) {
              var _i20 = _.__digit(_g8) + n;

              n = _i20 >>> 30, t.__setDigit(_g8, 1073741823 & _i20);
            }

            return 0 != n && t.__setDigitGrow(e, 1), t;
          }
        }, {
          key: "__absoluteSubOne",
          value: function __absoluteSubOne(_, t) {
            var e = _.length;
            t = t || e;
            var n = new o(t, !1);
            var g = 1;

            for (var _o16 = 0; _o16 < e; _o16++) {
              var _i21 = _.__digit(_o16) - g;

              g = 1 & _i21 >>> 30, n.__setDigit(_o16, 1073741823 & _i21);
            }

            if (0 != g) throw new Error("implementation bug");

            for (var _g9 = e; _g9 < t; _g9++) {
              n.__setDigit(_g9, 0);
            }

            return n;
          }
        }, {
          key: "__absoluteAnd",
          value: function __absoluteAnd(_, t) {
            var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var n = _.length,
                g = t.length,
                s = g;

            if (n < g) {
              s = n;
              var _i22 = _,
                  _e12 = n;
              _ = t, n = g, t = _i22, g = _e12;
            }

            var l = s;
            null === e ? e = new o(l, !1) : l = e.length;
            var r = 0;

            for (; r < s; r++) {
              e.__setDigit(r, _.__digit(r) & t.__digit(r));
            }

            for (; r < l; r++) {
              e.__setDigit(r, 0);
            }

            return e;
          }
        }, {
          key: "__absoluteAndNot",
          value: function __absoluteAndNot(_, t) {
            var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var n = _.length,
                g = t.length;
            var s = g;
            n < g && (s = n);
            var l = n;
            null === e ? e = new o(l, !1) : l = e.length;
            var r = 0;

            for (; r < s; r++) {
              e.__setDigit(r, _.__digit(r) & ~t.__digit(r));
            }

            for (; r < n; r++) {
              e.__setDigit(r, _.__digit(r));
            }

            for (; r < l; r++) {
              e.__setDigit(r, 0);
            }

            return e;
          }
        }, {
          key: "__absoluteOr",
          value: function __absoluteOr(_, t) {
            var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var n = _.length,
                g = t.length,
                s = g;

            if (n < g) {
              s = n;
              var _i23 = _,
                  _e13 = n;
              _ = t, n = g, t = _i23, g = _e13;
            }

            var l = n;
            null === e ? e = new o(l, !1) : l = e.length;
            var r = 0;

            for (; r < s; r++) {
              e.__setDigit(r, _.__digit(r) | t.__digit(r));
            }

            for (; r < n; r++) {
              e.__setDigit(r, _.__digit(r));
            }

            for (; r < l; r++) {
              e.__setDigit(r, 0);
            }

            return e;
          }
        }, {
          key: "__absoluteXor",
          value: function __absoluteXor(_, t) {
            var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var n = _.length,
                g = t.length,
                s = g;

            if (n < g) {
              s = n;
              var _i24 = _,
                  _e14 = n;
              _ = t, n = g, t = _i24, g = _e14;
            }

            var l = n;
            null === e ? e = new o(l, !1) : l = e.length;
            var r = 0;

            for (; r < s; r++) {
              e.__setDigit(r, _.__digit(r) ^ t.__digit(r));
            }

            for (; r < n; r++) {
              e.__setDigit(r, _.__digit(r));
            }

            for (; r < l; r++) {
              e.__setDigit(r, 0);
            }

            return e;
          }
        }, {
          key: "__absoluteCompare",
          value: function __absoluteCompare(_, t) {
            var e = _.length - t.length;
            if (0 != e) return e;
            var n = _.length - 1;

            for (; 0 <= n && _.__digit(n) === t.__digit(n);) {
              n--;
            }

            return 0 > n ? 0 : _.__unsignedDigit(n) > t.__unsignedDigit(n) ? 1 : -1;
          }
        }, {
          key: "__multiplyAccumulate",
          value: function __multiplyAccumulate(_, t, e, n) {
            if (0 === t) return;
            var g = 32767 & t,
                s = t >>> 15;
            var l = 0,
                r = 0;

            for (var a, u = 0; u < _.length; u++, n++) {
              a = e.__digit(n);

              var _i25 = _.__digit(u),
                  _t10 = 32767 & _i25,
                  d = _i25 >>> 15,
                  h = o.__imul(_t10, g),
                  m = o.__imul(_t10, s),
                  b = o.__imul(d, g),
                  D = o.__imul(d, s);

              a += r + h + l, l = a >>> 30, a &= 1073741823, a += ((32767 & m) << 15) + ((32767 & b) << 15), l += a >>> 30, r = D + (m >>> 15) + (b >>> 15), e.__setDigit(n, 1073741823 & a);
            }

            for (; 0 != l || 0 !== r; n++) {
              var _i26 = e.__digit(n);

              _i26 += l + r, r = 0, l = _i26 >>> 30, e.__setDigit(n, 1073741823 & _i26);
            }
          }
        }, {
          key: "__internalMultiplyAdd",
          value: function __internalMultiplyAdd(_, t, e, g, s) {
            var l = e,
                a = 0;

            for (var n = 0; n < g; n++) {
              var _i27 = _.__digit(n),
                  _e15 = o.__imul(32767 & _i27, t),
                  _g10 = o.__imul(_i27 >>> 15, t),
                  u = _e15 + ((32767 & _g10) << 15) + a + l;

              l = u >>> 30, a = _g10 >>> 15, s.__setDigit(n, 1073741823 & u);
            }

            if (s.length > g) for (s.__setDigit(g++, l + a); g < s.length;) {
              s.__setDigit(g++, 0);
            } else if (0 !== l + a) throw new Error("implementation bug");
          }
        }, {
          key: "__absoluteDivSmall",
          value: function __absoluteDivSmall(_, t) {
            var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            null === e && (e = new o(_.length, !1));
            var n = 0;

            for (var _g11, _o17 = 2 * _.length - 1; 0 <= _o17; _o17 -= 2) {
              _g11 = (n << 15 | _.__halfDigit(_o17)) >>> 0;

              var _i28 = 0 | _g11 / t;

              n = 0 | _g11 % t, _g11 = (n << 15 | _.__halfDigit(_o17 - 1)) >>> 0;
              var s = 0 | _g11 / t;
              n = 0 | _g11 % t, e.__setDigit(_o17 >>> 1, _i28 << 15 | s);
            }

            return e;
          }
        }, {
          key: "__absoluteModSmall",
          value: function __absoluteModSmall(_, t) {
            var e = 0;

            for (var n = 2 * _.length - 1; 0 <= n; n--) {
              var _i29 = (e << 15 | _.__halfDigit(n)) >>> 0;

              e = 0 | _i29 % t;
            }

            return e;
          }
        }, {
          key: "__absoluteDivLarge",
          value: function __absoluteDivLarge(i, _, t, e) {
            var g = _.__halfDigitLength(),
                n = _.length,
                s = i.__halfDigitLength() - g;

            var l = null;
            t && (l = new o(s + 2 >>> 1, !1), l.__initializeDigits());
            var r = new o(g + 2 >>> 1, !1);

            r.__initializeDigits();

            var a = o.__clz15(_.__halfDigit(g - 1));

            0 < a && (_ = o.__specialLeftShift(_, a, 0));

            var d = o.__specialLeftShift(i, a, 1),
                u = _.__halfDigit(g - 1);

            var h = 0;

            for (var _a2, m = s; 0 <= m; m--) {
              _a2 = 32767;

              var _i30 = d.__halfDigit(m + g);

              if (_i30 !== u) {
                var _t11 = (_i30 << 15 | d.__halfDigit(m + g - 1)) >>> 0;

                _a2 = 0 | _t11 / u;

                var _e17 = 0 | _t11 % u;

                var _n4 = _.__halfDigit(g - 2),
                    _s6 = d.__halfDigit(m + g - 2);

                for (; o.__imul(_a2, _n4) >>> 0 > (_e17 << 16 | _s6) >>> 0 && (_a2--, _e17 += u, !(32767 < _e17));) {
                }
              }

              o.__internalMultiplyAdd(_, _a2, 0, n, r);

              var _e16 = d.__inplaceSub(r, m, g + 1);

              0 !== _e16 && (_e16 = d.__inplaceAdd(_, m, g), d.__setHalfDigit(m + g, 32767 & d.__halfDigit(m + g) + _e16), _a2--), t && (1 & m ? h = _a2 << 15 : l.__setDigit(m >>> 1, h | _a2));
            }

            if (e) return d.__inplaceRightShift(a), t ? {
              quotient: l,
              remainder: d
            } : d;
            if (t) return l;
            throw new Error("unreachable");
          }
        }, {
          key: "__clz15",
          value: function __clz15(i) {
            return o.__clz30(i) - 15;
          }
        }, {
          key: "__specialLeftShift",
          value: function __specialLeftShift(_, t, e) {
            var g = _.length,
                n = new o(g + e, !1);

            if (0 === t) {
              for (var _t12 = 0; _t12 < g; _t12++) {
                n.__setDigit(_t12, _.__digit(_t12));
              }

              return 0 < e && n.__setDigit(g, 0), n;
            }

            var s = 0;

            for (var _o18 = 0; _o18 < g; _o18++) {
              var _i31 = _.__digit(_o18);

              n.__setDigit(_o18, 1073741823 & _i31 << t | s), s = _i31 >>> 30 - t;
            }

            return 0 < e && n.__setDigit(g, s), n;
          }
        }, {
          key: "__leftShiftByAbsolute",
          value: function __leftShiftByAbsolute(_, i) {
            var t = o.__toShiftAmount(i);

            if (0 > t) throw new RangeError("BigInt too big");
            var e = 0 | t / 30,
                n = t % 30,
                g = _.length,
                s = 0 !== n && 0 != _.__digit(g - 1) >>> 30 - n,
                l = g + e + (s ? 1 : 0),
                r = new o(l, _.sign);

            if (0 === n) {
              var _t13 = 0;

              for (; _t13 < e; _t13++) {
                r.__setDigit(_t13, 0);
              }

              for (; _t13 < l; _t13++) {
                r.__setDigit(_t13, _.__digit(_t13 - e));
              }
            } else {
              var _t14 = 0;

              for (var _14 = 0; _14 < e; _14++) {
                r.__setDigit(_14, 0);
              }

              for (var _o19 = 0; _o19 < g; _o19++) {
                var _i32 = _.__digit(_o19);

                r.__setDigit(_o19 + e, 1073741823 & _i32 << n | _t14), _t14 = _i32 >>> 30 - n;
              }

              if (s) r.__setDigit(g + e, _t14);else if (0 !== _t14) throw new Error("implementation bug");
            }

            return r.__trim();
          }
        }, {
          key: "__rightShiftByAbsolute",
          value: function __rightShiftByAbsolute(_, i) {
            var t = _.length,
                e = _.sign,
                n = o.__toShiftAmount(i);

            if (0 > n) return o.__rightShiftByMaximum(e);
            var g = 0 | n / 30,
                s = n % 30;
            var l = t - g;
            if (0 >= l) return o.__rightShiftByMaximum(e);
            var r = !1;

            if (e) {
              if (0 != (_.__digit(g) & (1 << s) - 1)) r = !0;else for (var _t15 = 0; _t15 < g; _t15++) {
                if (0 !== _.__digit(_t15)) {
                  r = !0;
                  break;
                }
              }
            }

            if (r && 0 === s) {
              var _i33 = _.__digit(t - 1);

              0 == ~_i33 && l++;
            }

            var a = new o(l, e);

            if (0 === s) {
              a.__setDigit(l - 1, 0);

              for (var _e18 = g; _e18 < t; _e18++) {
                a.__setDigit(_e18 - g, _.__digit(_e18));
              }
            } else {
              var _e19 = _.__digit(g) >>> s;

              var _n5 = t - g - 1;

              for (var _t16 = 0; _t16 < _n5; _t16++) {
                var _i34 = _.__digit(_t16 + g + 1);

                a.__setDigit(_t16, 1073741823 & _i34 << 30 - s | _e19), _e19 = _i34 >>> s;
              }

              a.__setDigit(_n5, _e19);
            }

            return r && (a = o.__absoluteAddOne(a, !0, a)), a.__trim();
          }
        }, {
          key: "__rightShiftByMaximum",
          value: function __rightShiftByMaximum(i) {
            return i ? o.__oneDigit(1, !0) : o.__zero();
          }
        }, {
          key: "__toShiftAmount",
          value: function __toShiftAmount(i) {
            if (1 < i.length) return -1;

            var _ = i.__unsignedDigit(0);

            return _ > o.__kMaxLengthBits ? -1 : _;
          }
        }, {
          key: "__toPrimitive",
          value: function __toPrimitive(i) {
            var _ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";

            if ("object" != _typeof(i)) return i;
            if (i.constructor === o) return i;

            if ("undefined" != typeof Symbol && "symbol" == _typeof(Symbol.toPrimitive)) {
              var _t17 = i[Symbol.toPrimitive];

              if (_t17) {
                var _i35 = _t17(_);

                if ("object" != _typeof(_i35)) return _i35;
                throw new TypeError("Cannot convert object to primitive value");
              }
            }

            var t = i.valueOf;

            if (t) {
              var _15 = t.call(i);

              if ("object" != _typeof(_15)) return _15;
            }

            var e = i.toString;

            if (e) {
              var _16 = e.call(i);

              if ("object" != _typeof(_16)) return _16;
            }

            throw new TypeError("Cannot convert object to primitive value");
          }
        }, {
          key: "__toNumeric",
          value: function __toNumeric(i) {
            return o.__isBigInt(i) ? i : +i;
          }
        }, {
          key: "__isBigInt",
          value: function __isBigInt(i) {
            return "object" == _typeof(i) && null !== i && i.constructor === o;
          }
        }, {
          key: "__truncateToNBits",
          value: function __truncateToNBits(i, _) {
            var t = 0 | (i + 29) / 30,
                e = new o(t, _.sign),
                n = t - 1;

            for (var _t18 = 0; _t18 < n; _t18++) {
              e.__setDigit(_t18, _.__digit(_t18));
            }

            var g = _.__digit(n);

            if (0 != i % 30) {
              var _17 = 32 - i % 30;

              g = g << _17 >>> _17;
            }

            return e.__setDigit(n, g), e.__trim();
          }
        }, {
          key: "__truncateAndSubFromPowerOfTwo",
          value: function __truncateAndSubFromPowerOfTwo(_, t, e) {
            var n = Math.min;
            var g = 0 | (_ + 29) / 30,
                s = new o(g, e);
            var l = 0;
            var r = g - 1;
            var a = 0;

            for (var _i36 = n(r, t.length); l < _i36; l++) {
              var _i37 = 0 - t.__digit(l) - a;

              a = 1 & _i37 >>> 30, s.__setDigit(l, 1073741823 & _i37);
            }

            for (; l < r; l++) {
              s.__setDigit(l, 0 | 1073741823 & -a);
            }

            var u = r < t.length ? t.__digit(r) : 0;
            var d = _ % 30;
            var h;
            if (0 == d) h = 0 - u - a, h &= 1073741823;else {
              var _i38 = 32 - d;

              u = u << _i38 >>> _i38;

              var _18 = 1 << 32 - _i38;

              h = _18 - u - a, h &= _18 - 1;
            }
            return s.__setDigit(r, h), s.__trim();
          }
        }, {
          key: "__digitPow",
          value: function __digitPow(i, _) {
            var t = 1;

            for (; 0 < _;) {
              1 & _ && (t *= i), _ >>>= 1, i *= i;
            }

            return t;
          }
        }, {
          key: "__isOneDigitInt",
          value: function __isOneDigitInt(i) {
            return (1073741823 & i) === i;
          }
        }]);

        return o;
      }( /*#__PURE__*/_wrapNativeSuper(Array));

      return o.__kMaxLength = 33554432, o.__kMaxLengthBits = o.__kMaxLength << 5, o.__kMaxBitsPerChar = [0, 0, 32, 51, 64, 75, 83, 90, 96, 102, 107, 111, 115, 119, 122, 126, 128, 131, 134, 136, 139, 141, 143, 145, 147, 149, 151, 153, 154, 156, 158, 159, 160, 162, 163, 165, 166], o.__kBitsPerCharTableShift = 5, o.__kBitsPerCharTableMultiplier = 1 << o.__kBitsPerCharTableShift, o.__kConversionChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], o.__kBitConversionBuffer = new ArrayBuffer(8), o.__kBitConversionDouble = new Float64Array(o.__kBitConversionBuffer), o.__kBitConversionInts = new Int32Array(o.__kBitConversionBuffer), o.__clz30 = _ ? function (i) {
        return _(i) - 2;
      } : function (i) {
        var _ = Math.LN2,
            t = Math.log;
        return 0 === i ? 30 : 0 | 29 - (0 | t(i >>> 0) / _);
      }, o.__imul = i || function (i, _) {
        return 0 | i * _;
      }, o;
    });
  });

  /**
   * This is a Typescript port of the base-x package
   */

  function base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    BASE_MAP.fill(255);

    for (var i = 0; i < ALPHABET.length; i++) {
      var x = ALPHABET.charAt(i);
      var xc = x.charCodeAt(0);
      if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
      BASE_MAP[xc] = i;
    }

    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256); // log(BASE) / log(256), rounded up

    var iFACTOR = Math.log(256) / Math.log(BASE); // log(256) / log(BASE), rounded up

    function encode(source) {
      if (!Buffer$1.isBuffer(source)) throw new TypeError('Expected Buffer');
      if (source.length === 0) return ''; // Skip & count leading zeroes.

      var zeroes = 0;
      var length = 0;
      var pbegin = 0;
      var pend = source.length;

      while (pbegin !== pend && source[pbegin] === 0) {
        pbegin++;
        zeroes++;
      } // Allocate enough space in big-endian base58 representation.


      var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
      var b58 = new Uint8Array(size); // Process the bytes.

      while (pbegin !== pend) {
        var carry = source[pbegin]; // Apply "b58 = b58 * 256 + ch".

        var _i = 0;

        for (var _it = size - 1; (carry !== 0 || _i < length) && _it !== -1; _it--, _i++) {
          carry += 256 * b58[_it] >>> 0;
          b58[_it] = carry % BASE >>> 0;
          carry = carry / BASE >>> 0;
        }

        if (carry !== 0) throw new Error('Non-zero carry');
        length = _i;
        pbegin++;
      } // Skip leading zeroes in base58 result.


      var it = size - length;

      while (it !== size && b58[it] === 0) {
        it++;
      } // Translate the result into a string.


      var str = LEADER.repeat(zeroes);

      for (; it < size; ++it) {
        str += ALPHABET.charAt(b58[it]);
      }

      return str;
    }

    function decodeUnsafe(source) {
      if (typeof source !== 'string') throw new TypeError('Expected String');
      if (source.length === 0) return Buffer$1.alloc(0);
      var psz = 0; // Skip leading spaces.

      if (source[psz] === ' ') return; // Skip and count leading '1's.

      var zeroes = 0;
      var length = 0;

      while (source[psz] === LEADER) {
        zeroes++;
        psz++;
      } // Allocate enough space in big-endian base256 representation.


      var size = (source.length - psz) * FACTOR + 1 >>> 0; // log(58) / log(256), rounded up.

      var b256 = new Uint8Array(size); // Process the characters.

      while (source[psz]) {
        // Decode character
        var carry = BASE_MAP[source.charCodeAt(psz)]; // Invalid character

        if (carry === 255) return;
        var _i2 = 0;

        for (var _it2 = size - 1; (carry !== 0 || _i2 < length) && _it2 !== -1; _it2--, _i2++) {
          carry += BASE * b256[_it2] >>> 0;
          b256[_it2] = carry % 256 >>> 0;
          carry = carry / 256 >>> 0;
        }

        if (carry !== 0) throw new Error('Non-zero carry');
        length = _i2;
        psz++;
      } // Skip trailing spaces.


      if (source[psz] === ' ') return; // Skip leading zeroes in b256.

      var it = size - length;

      while (it !== size && b256[it] === 0) {
        it++;
      }

      var vch = Buffer$1.allocUnsafe(zeroes + (size - it));
      vch.fill(0x00, 0, zeroes);
      var j = zeroes;

      while (it !== size) {
        vch[j++] = b256[it++];
      }

      return vch;
    }

    function decode(source) {
      var buffer = decodeUnsafe(source);
      if (buffer) return buffer;
      throw new Error('Non-base' + BASE + ' character');
    }

    return {
      encode: encode,
      decodeUnsafe: decodeUnsafe,
      decode: decode
    };
  }

  var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
  var base58 = base(ALPHABET);

  function encodeBuffer(val) {
    var enc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base58';

    if (enc === 'base58') {
      return base58.encode(Buffer$1.from(val));
    }

    return Buffer$1.from(val).toString(enc);
  }
  /**
   * @param bytes anything to a hex string that has an iterable that returns numbers and a reduce method, e.g. number[], Uint8Array, Buffer
   * @param format add the string '0x' in front of the output
   */


  var toHexString = function toHexString(bytes) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var result = bytes.reduce(function (str, _byte) {
      return str + _byte.toString(16).padStart(2, '0');
    }, '');
    if (!format) return result;
    if (result === '00' || result === '') return '0x0';
    return '0x' + result;
  };

  var fromHexString = function fromHexString(hexString) {
    if (hexString.length === 0) return Uint8Array.from([]);
    if (hexString.length % 2 === 1) hexString = '0' + hexString;
    var match = hexString.match(/.{1,2}/g);
    if (!match) throw new Error('cannot parse string as hex');
    return new Uint8Array(match.map(function (_byte2) {
      return parseInt(_byte2, 16);
    }));
  };
  /**
   * Convert number to Uint8Array
   * @param d 
   * @param length 
   */


  var fromNumber = function fromNumber(d) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

    if (d >= Math.pow(2, length * 8)) {
      throw new Error('Number exeeds range');
    }

    var arr = new Uint8Array(length);

    for (var i = 0, j = 1; i < 8; i++, j *= 0x100) {
      arr[i] = d / j & 0xff;
    }

    return arr;
  };
  /**
   * This is a Typescript port of the bs58check package
   */


  function bs58checkBase(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
      var checksum = checksumFn(payload);
      return base58.encode(Buffer$1.concat([payload, checksum], payload.length + 4));
    }

    function decodeRaw(buffer) {
      var payload = buffer.slice(0, -4);
      var checksum = buffer.slice(-4);
      var newChecksum = checksumFn(payload);
      if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
      return payload;
    } // Decode a base58-check encoded string to a buffer, no result if checksum is wrong


    function decodeUnsafe(string) {
      var buffer = base58.decodeUnsafe(string);
      if (!buffer) return;
      return decodeRaw(buffer);
    }

    function decode(string) {
      var buffer = base58.decode(string);
      var payload = decodeRaw(buffer);
      if (!payload) throw new Error('Invalid checksum');
      return payload;
    }

    return {
      encode: encode,
      decode: decode,
      decodeUnsafe: decodeUnsafe
    };
  } // SHA256(SHA256(buffer))


  function sha256x2(buffer) {
    var tmp = browser$2('sha256').update(buffer).digest();
    return browser$2('sha256').update(tmp).digest();
  }

  var bs58check = bs58checkBase(sha256x2);

  function _typeof$1(obj) {
    "@babel/helpers - typeof";

    return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof$1(obj);
  }

  function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty$3(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
  }

  function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
  }

  function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
  }

  function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
  }

  function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  /**
   * Returns the next interval to use for exponential backoff.
   * This curve yields every value 4 times before doubling in the next step.
   * The function is :code:`multiplier * 2**Math.floor(n/4)`.
   * By default (multiplier = 1s), the intervals reach ca. 1 minute (total time elapsed ca. 4 minutes) after step 24,
   * so it is advised to declare a timeout after a certain number of steps.
   * @param n step on the interval curve
   * @param multiplier multiplier, default 1000 (1s)
   */


  function backoffIntervalStep(n) {
    var multiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    return multiplier * Math.pow(2, Math.floor(n / 4));
  }
  /**
   * A promisified version of setTimeout
   * @param ms 
   */


  function waitFor(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  var ADDRESS_PREFIXES = {
    ACCOUNT: 0x42,
    CONTRACT: 0xC0,
    PRIVATE_KEY: 0xAA
  };
  var ACCOUNT_NAME_LENGTH = 12;
  var SYSTEM_ADDRESSES = ['aergo.system', 'aergo.name', 'aergo.enterprise', 'aergo.vault'];
  var UNITS = {
    NATIVE_TOKEN: {
      baseLabel: 'Aergo',
      baseDigits: 18,
      subUnits: [{
        e: 0,
        label: 'aer'
      }, {
        e: 18,
        label: 'aergo'
      }],
      unitSize: {
        'aergo': 18,
        'gaer': 9,
        'aer': 0
      }
    }
  };
  var BIP44_ID = 441;
  var WALLET_HDPATH = "m/44'/".concat(BIP44_ID, "'/0'/0/");
  var constants = {
    ADDRESS_PREFIXES: ADDRESS_PREFIXES,
    UNITS: UNITS,
    ACCOUNT_NAME_LENGTH: ACCOUNT_NAME_LENGTH,
    BIP44_ID: BIP44_ID,
    WALLET_HDPATH: WALLET_HDPATH,
    SYSTEM_ADDRESSES: SYSTEM_ADDRESSES
  };
  var DEFAULT_USER_UNIT = 'aergo';
  var DEFAULT_NETWORK_UNIT = 'aer';

  function getUnitPrecision(unit) {
    var units = UNITS.NATIVE_TOKEN.unitSize;

    function isValidUnit(unit) {
      return unit in units;
    }

    if (!isValidUnit(unit)) {
      throw new TypeError("unrecognized unit: ".concat(unit));
    }

    return units[unit];
  }
  /**
   * A wrapper around amounts with units.
   * Over the network, amounts are sent as raw bytes.
   * In the client, they are exposed as BigInts, but also compatible with plain strings or numbers (if smaller than 2^31-1)
   * Uses 'aergo' as default unit when passing strings or numbers.
   * Uses 'aer' as default unit when passing BigInts, buffers or byte arrays.
   * Whenever you pass amounts to other functions, they will try to coerce them to BigInt using this class.
   */


  var Amount = /*#__PURE__*/function () {
    function Amount(value) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var newUnit = arguments.length > 2 ? arguments[2] : undefined;

      _classCallCheck$2(this, Amount);

      _defineProperty$3(this, "value", void 0);

      _defineProperty$3(this, "unit", void 0);

      if (value instanceof Amount) {
        return value;
      }

      if (typeof value === 'string') {
        var _value$split = value.split(' ', 2),
            _value$split2 = _slicedToArray$1(_value$split, 2),
            amount = _value$split2[0],
            _unit = _value$split2[1];

        unit = unit || _unit;
        this.value = Amount._valueFromString(amount, unit);
      } else if (typeof value === 'number') {
        this.value = Amount._valueFromString('' + value, unit);
      } else if (value instanceof jsbiUmd) {
        if (typeof unit === 'undefined' || unit === '') {
          unit = DEFAULT_NETWORK_UNIT;
        }

        this.value = jsbiUmd.BigInt(value);
      } else if (value instanceof Buffer$1 || value instanceof Uint8Array) {
        if (typeof unit === 'undefined' || unit === '') {
          unit = DEFAULT_NETWORK_UNIT;
        }

        this.value = jsbiUmd.BigInt(toHexString(value, true));
      } else {
        throw new Error("Instantiate Amount with JSBI|number|string|Buffer|Uint8Array, not ".concat(value, " (").concat(_typeof$1(value), ")"));
      }

      this.unit = unit;

      if (typeof this.unit === 'undefined' || this.unit === '') {
        this.unit = DEFAULT_USER_UNIT;
      } // Set new unit for displaying


      if (typeof newUnit !== 'undefined') {
        this.unit = newUnit;
      } // Freeze value. Otherwise some libraries mess this up since it is actually an Array subclass with a custom propery


      this.value = Object.freeze(this.value);
    }
    /**
     * Returns value as byte buffer
     */


    _createClass$2(Amount, [{
      key: "asBytes",
      value: function asBytes() {
        return Buffer$1.from(fromHexString(this.value.toString(16)));
      }
      /**
       * JSON.stringifes to string with unit aer, which can be easily deserialized by new Amount(x)
       */

    }, {
      key: "toJSON",
      value: function toJSON() {
        return this.toUnit('aer').toString();
      }
      /**
       * Returns formatted string including unit
       */

    }, {
      key: "toString",
      value: function toString() {
        if (this.unit) {
          return "".concat(this.formatNumber(), " ").concat(this.unit);
        }

        return "".concat(this.formatNumber());
      }
      /**
       * Move decimal point in string by digits, positive to the right, negative to the left.
       * This extends the string if necessary.
       * Example: ("0.0001", 4 => "1"), ("0.0001", -4 => "0.00000001")
       * @param str 
       * @param digits 
       */

    }, {
      key: "formatNumber",
      value: function formatNumber() {
        var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        if (unit === '') unit = this.unit;
        if (unit === '') return this.value.toString();
        var prec = getUnitPrecision(unit);
        return Amount.moveDecimalPoint(this.value.toString(), -prec);
      }
      /**
       * Convert to another unit
       * @param unit string (aer, gaer, aergo)
       */

    }, {
      key: "toUnit",
      value: function toUnit(unit) {
        return new Amount(this.value, '', unit);
      }
      /**
       * Convert arg into JSBI value
       * Can optionally provide a defaultUnit that is used if arg does not contain a unit.
       */

    }, {
      key: "compare",
      value:
      /**
       * Compare this amount with other amount.
       * If otherAmount has no unit, assumes unit of this amount.
       * this >  other -> +1
       * this  < other -> -1
       * this == other -> 0
       * @param otherAmount 
       */
      function compare(otherAmount) {
        var a = this.value;
        var b = Amount.toJSBI(otherAmount, this.unit);
        return jsbiUmd.equal(a, b) ? 0 : jsbiUmd.lessThan(a, b) ? -1 : 1;
      }
      /**
       * Return true if otherAmount is equal to this amount.
       * @param otherAmount 
       */

    }, {
      key: "equal",
      value: function equal(otherAmount) {
        return this.compare(otherAmount) === 0;
      }
      /**
       * Add another amount to amount.
       * If otherAmount has no unit, assumes unit of this amount.
       * 10 aergo + 10 = 20 aergo
       * 10 aer + 10 = 20 aer
       * 10 aergo + 10 aer = 10.00000000000000001 aergo
       * @param otherAmount 
       */

    }, {
      key: "add",
      value: function add(otherAmount) {
        var sum = jsbiUmd.add(this.value, Amount.toJSBI(otherAmount, this.unit));
        return new Amount(sum, this.unit);
      }
      /**
       * Subtract another amount from amount.
       * If otherAmount has no unit, assumes unit of this amount.
       * 10 aergo - 5 = 5 aergo
       * 10 aer - 5 = 5 aer
       * 1 aer - 1 aergo = -999999999999999999 aer
       * @param otherAmount 
       */

    }, {
      key: "sub",
      value: function sub(otherAmount) {
        var sum = jsbiUmd.subtract(this.value, Amount.toJSBI(otherAmount, this.unit));
        return new Amount(sum, this.unit);
      }
      /**
       * Divide amount by another amount.
       * Warning: double check your units. The division is based on the aer value, so
       * if your otherAmount has a unit, it will be converted to aer.
       * This function tries to do the right thing in regards to dividing units:
       * 10 aergo / 10 = 1 aergo  (keep unit)
       * 10 aergo / 10 aergo = 1  (unit-less)
       * 1 aer / 2 aer = 0  (truncation of sub 1 aer amount)
       * @param otherAmount 
       */

    }, {
      key: "div",
      value: function div(otherAmount) {
        var newUnit;
        var sum = jsbiUmd.divide(this.value, Amount.toJSBI(otherAmount, 'aer')); // if both amounts had units, the result should be unit-less

        var otherHasUnit = otherAmount instanceof Amount && Boolean(otherAmount.unit);

        if (!otherHasUnit && typeof otherAmount === 'string') {
          var _$split = "".concat(otherAmount).split(' ', 2),
              _$split2 = _slicedToArray$1(_$split, 2),
              _unit = _$split2[1];

          otherHasUnit = Boolean(_unit);
        }

        if (otherHasUnit) {
          newUnit = '';
        }

        return new Amount(sum, this.unit, newUnit);
      }
      /**
       * Multiply amount by another amount.
       * Warning: double check your units. The multiplication is based on the aer value, so
       * if your otherAmount has a unit, it will be converted to aer.
       * However, while the value is correct, there's no way to display unit^2.
       * 10 aergo * 10 aergo = 10 * 10^18 aer * 10 * 10^18 aer = 100 * 10^36 aer = 100 * 10^18 aergo
       * 10 aergo * 10 = 10 * 10^18 aer * 10 = 100 * 10^18 aer = 100 aergo
       * @param otherAmount 
       */

    }, {
      key: "mul",
      value: function mul(otherAmount) {
        var sum = jsbiUmd.multiply(this.value, Amount.toJSBI(otherAmount, 'aer'));
        return new Amount(sum, this.unit);
      }
    }], [{
      key: "_valueFromString",
      value: // value in base unit
      // unit for displaying
      function _valueFromString(value) {
        var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        if (unit === '') {
          unit = DEFAULT_USER_UNIT;
        }

        var prec = getUnitPrecision(unit);

        if (prec > 0) {
          value = Amount.moveDecimalPoint(value, prec);
        }

        return jsbiUmd.BigInt(value);
      }
    }, {
      key: "moveDecimalPoint",
      value: function moveDecimalPoint(str, digits) {
        if (digits === 0 || str === '0') return str;

        if (str.indexOf('.') === -1) {
          str = str + '.';
        }

        var idx = str.indexOf('.'); // Extend string to have enough space to move decimal point

        if (digits > str.length - idx) {
          str = str.padEnd(digits + idx + 1, '0');
        }

        if (digits < -idx) {
          str = str.padStart(str.length - idx - digits, '0');
        } // remove decimal point and reinsert at new location


        idx = str.indexOf('.');
        str = str.replace('.', '');
        str = str.substr(0, idx + digits) + '.' + str.substr(idx + digits); // remove trailing 0 and .

        str = str.replace(/\.?0*$/, ''); // remove leading 0

        str = str.replace(/^0+/, ''); // add leading 0 before .

        str = str.replace(/^\./, '0.');
        return str;
      }
    }, {
      key: "toJSBI",
      value: function toJSBI(arg) {
        var defaultUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        if (!(arg instanceof Amount)) {
          var _$split3 = "".concat(arg).split(' ', 2),
              _$split4 = _slicedToArray$1(_$split3, 2),
              amount = _$split4[0],
              _unit = _$split4[1];

          var unit = _unit || defaultUnit;
          arg = new Amount(amount, unit);
        }

        return jsbiUmd.BigInt(arg.value);
      }
    }]);

    return Amount;
  }();

  var systemAddresses = _toConsumableArray$1(SYSTEM_ADDRESSES);
  /**
   * A wrapper around addresses. Internally addresses are stored and sent as raw bytes,
   * but client-side they are displayed as base58-check encoded strings.
   * The encoding requires some computation, so you should only convert address objects to strings when needed.
   */


  var Address = /*#__PURE__*/function () {
    function Address(address) {
      _classCallCheck$2(this, Address);

      _defineProperty$3(this, "value", void 0);

      _defineProperty$3(this, "encoded", void 0);

      _defineProperty$3(this, "isName", void 0);

      this.isName = false;

      if (address instanceof Address) {
        // Just copy buffer
        this.value = Buffer$1.from(address.value);
      } else if (typeof address === 'string') {
        // Parse string
        if (address.length <= ACCOUNT_NAME_LENGTH || Address.isSystemName(address)) {
          this.value = Buffer$1.from(address);
          this.isName = true;
        } else {
          try {
            this.value = Address.decode(address);
          } catch (e) {
            throw new Error("Address \"".concat(address, "\" could not be parsed as a base58-check encoded string and is not a valid name. ").concat(e));
          }
        }

        this.encoded = address;
      } else if (address instanceof Buffer$1) {
        this.value = address;
      } else if (address instanceof Uint8Array) {
        // Treat array-like as buffer
        this.value = Buffer$1.from(address);
      } else {
        throw new Error("Instantiate Address with raw bytes, a string in base58-check encoding, or a valid name, not ".concat(address));
      } // Check for name encoded as bytes


      if (!this.isName) {
        var arrValue = Array.from(this.value); // Remove trailing 0s

        while (arrValue[arrValue.length - 1] === 0) {
          arrValue.pop();
        }

        var buf = Buffer$1.from(arrValue);

        if (buf.length <= ACCOUNT_NAME_LENGTH || Address.isSystemName(buf.toString())) {
          this.isName = true;
          this.value = buf;
        }
      }
    }

    _createClass$2(Address, [{
      key: "asBytes",
      value: function asBytes() {
        return new Uint8Array(this.value);
      }
    }, {
      key: "bytes",
      get: function get() {
        return this.asBytes();
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return this.toString();
      }
    }, {
      key: "toString",
      value: function toString() {
        if (typeof this.encoded !== 'undefined' && this.encoded !== null) {
          return this.encoded;
        }

        if (this.isName) {
          this.encoded = Buffer$1.from(this.value).toString();
        } else {
          this.encoded = Address.encode(this.value);
        }

        return this.encoded;
      }
      /**
       * Decode bs58check string into bytes
       */

    }, {
      key: "equal",
      value: function equal(_otherAddress) {
        var otherAddress = _otherAddress instanceof Address ? _otherAddress : new Address(_otherAddress);
        return Address.valueEqual(this.value, otherAddress.value);
      }
      /**
       * Returns true if the address is empty, i.e. '' or empty buffer
       */

    }, {
      key: "isEmpty",
      value: function isEmpty() {
        return this.value.length === 0;
      }
    }, {
      key: "length",
      get: function get() {
        return this.value.length;
      }
    }, {
      key: "isSystemAddress",
      value: function isSystemAddress() {
        return this.isName && Address.isSystemName(this.toString());
      }
    }], [{
      key: "decode",
      value: function decode(bs58string) {
        var decoded = bs58check.decode(bs58string);
        if (decoded[0] !== ADDRESS_PREFIXES.ACCOUNT) throw new Error("invalid address prefix (".concat(decoded[0], ")"));
        if (decoded.length !== 33 + 1) throw new Error("invalid address length (".concat(decoded.length - 1, ")"));
        return Buffer$1.from(decoded.slice(1));
      }
      /**
       * Encode bytes into bs58check string
       */

    }, {
      key: "encode",
      value: function encode(byteArray) {
        if (!byteArray || byteArray.length === 0) return ''; // return empty string for null address

        var buf = Buffer$1.from([ADDRESS_PREFIXES.ACCOUNT].concat(_toConsumableArray$1(byteArray)));
        return bs58check.encode(buf);
      }
    }, {
      key: "isSystemName",
      value: function isSystemName(name) {
        return systemAddresses.indexOf(name) !== -1;
      }
    }, {
      key: "setSystemAddresses",
      value: function setSystemAddresses(addresses) {
        systemAddresses = addresses;
      }
    }, {
      key: "valueEqual",
      value: function valueEqual(a, b) {
        return a.length == b.length && a.every(function (aElem, i) {
          return aElem === b[i];
        });
      }
    }]);

    return Address;
  }();

  var TxTypes;
  /**
   * This interface defines a type for user provided tx data.
   * Internal functions can use different types but this is the publicly facing API.
   */

  (function (TxTypes) {
    TxTypes[TxTypes["Normal"] = 0] = "Normal";
    TxTypes[TxTypes["Governance"] = 1] = "Governance";
    TxTypes[TxTypes["Redeploy"] = 2] = "Redeploy";
    TxTypes[TxTypes["FeeDelegation"] = 3] = "FeeDelegation";
    TxTypes[TxTypes["Transfer"] = 4] = "Transfer";
    TxTypes[TxTypes["Call"] = 5] = "Call";
    TxTypes[TxTypes["Deploy"] = 6] = "Deploy";
    TxTypes[TxTypes["MultiCall"] = 7] = "MultiCall";
  })(TxTypes || (TxTypes = {}));

  function encodeTxHash(bytes) {
    return base58.encode(Buffer$1.from(bytes));
  }
  function decodeTxHash(bs58string) {
    return base58.decode(bs58string);
  }

  var TransactionError = /*#__PURE__*/function (_Error) {
    _inherits(TransactionError, _Error);

    var _super = _createSuper(TransactionError);

    function TransactionError() {
      _classCallCheck(this, TransactionError);

      return _super.apply(this, arguments);
    }

    return _createClass(TransactionError);
  }( /*#__PURE__*/_wrapNativeSuper(Error));

  function bufferOrB58(input) {
    if (typeof input === 'string') {
      return Uint8Array.from(decodeTxHash(input));
    } else {
      return Uint8Array.from(Buffer$1.from(input));
    }
  }
  /**
   * Class for converting transaction data to and from network representation.
   * You usually don't need to interact with this class manually, you can pass simple JSON objects.
   * This class is used when passing transaction data to client methods.
   */


  var Tx = /*#__PURE__*/function () {
    /**
     * Map of tx types.
     * Use as Tx.Type.NORMAL, Tx.Type.GOVERNANCE, Tx.Type.REDEPLOY, Tx.Type.FEEDELEGATION
     */
    function Tx(data) {
      _classCallCheck(this, Tx);

      _defineProperty(this, "hash", void 0);

      _defineProperty(this, "nonce", void 0);

      _defineProperty(this, "from", void 0);

      _defineProperty(this, "to", void 0);

      _defineProperty(this, "amount", void 0);

      _defineProperty(this, "payload", void 0);

      _defineProperty(this, "sign", void 0);

      _defineProperty(this, "type", void 0);

      _defineProperty(this, "limit", void 0);

      _defineProperty(this, "price", void 0);

      _defineProperty(this, "chainIdHash", void 0);

      Object.assign(this, data);
      this.amount = new Amount(this.amount || 0);
      this.price = new Amount(this.price || 0);

      if (!this.type) {
        this.type = this.inferType();
      }
    }

    _createClass(Tx, [{
      key: "inferType",
      value:
      /**
       * Infer a tx type based on body. Can be overriden by exlicitly passing type.
       */
      function inferType() {
        if (!this.to) {
          return Tx.Type.DEPLOY;
        }

        if ("".concat(this.to) === 'aergo.system' || "".concat(this.to) === 'aergo.enterprise') {
          return Tx.Type.GOVERNANCE;
        }

        return Tx.Type.NORMAL;
      }
    }, {
      key: "toGrpc",
      value: function toGrpc() {
        var msgtxbody = new blockchain_pb_2();
        msgtxbody.setType(this.type ? this.type : 0);
        msgtxbody.setNonce(this.nonce);

        if (typeof this.from === 'undefined' || !this.from) {
          throw new Error('Missing required transaction parameter \'from\'');
        }

        msgtxbody.setAccount(new Address(this.from).asBytes());

        if (typeof this.to !== 'undefined' && this.to !== null) {
          msgtxbody.setRecipient(new Address(this.to).asBytes());
        }

        msgtxbody.setAmount(Uint8Array.from(this.amount.asBytes()));

        if (typeof this.price !== 'undefined') {
          msgtxbody.setGasprice(Uint8Array.from(this.price.asBytes()));
        }

        msgtxbody.setGaslimit(this.limit || 0);

        if (this.payload != null) {
          msgtxbody.setPayload(Buffer$1.from(this.payload));
        }

        if (typeof this.sign === 'string') {
          msgtxbody.setSign(Buffer$1.from(this.sign, 'base64'));
        } else if (this.sign) {
          msgtxbody.setSign(this.sign);
        }

        if (typeof this.chainIdHash === 'undefined' || !this.chainIdHash) {
          var msg = 'Missing required transaction parameter \'chainIdHash\'. ' + 'Use aergoClient.getChainIdHash() to retrieve from connected node, ' + 'or hard-code for increased security and performance.';
          throw new Error(msg);
        }

        msgtxbody.setChainidhash(bufferOrB58(this.chainIdHash));
        var msgtx = new blockchain_pb_3();

        if (this.hash != null) {
          msgtx.setHash(bufferOrB58(this.hash));
        }

        msgtx.setBody(msgtxbody);
        return msgtx;
      }
    }], [{
      key: "encodeHash",
      value: function encodeHash(buf) {
        return encodeTxHash(buf);
      }
    }, {
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        var body = grpcObject.getBody();
        var hash = Tx.encodeHash(grpcObject.getHash_asU8());
        if (!body) throw new Error('tx missing body');
        return new Tx({
          hash: hash,
          nonce: body.getNonce(),
          from: new Address(body.getAccount_asU8()),
          to: new Address(body.getRecipient_asU8()),
          amount: new Amount(body.getAmount_asU8()),
          payload: body.getPayload_asU8(),
          sign: body.getSign_asB64(),
          type: body.getType(),
          limit: body.getGaslimit(),
          price: new Amount(body.getGasprice_asU8()),
          chainIdHash: Tx.encodeHash(body.getChainidhash_asU8())
        });
      }
    }]);

    return Tx;
  }();

  _defineProperty(Tx, "Type", blockchain_pb_4);
  var SignedTx = /*#__PURE__*/function (_Tx) {
    _inherits(SignedTx, _Tx);

    var _super = _createSuper(SignedTx);

    function SignedTx() {
      var _this;

      _classCallCheck(this, SignedTx);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "sign", void 0);

      _defineProperty(_assertThisInitialized(_this), "hash", void 0);

      return _this;
    }

    return _createClass(SignedTx);
  }(Tx);

  /**
   * Accounts controller. It is exposed at `aergoClient.accounts`.
   */
  var Accounts = /*#__PURE__*/function () {
    function Accounts(aergo) {
      _classCallCheck(this, Accounts);

      _defineProperty(this, "client", void 0);

      _defineProperty(this, "aergo", void 0);

      this.client = aergo.client;
      this.aergo = aergo;
    }
    /**
     * Create a new account in the node.
     * @param {string} passphrase 
     * @returns {Promise<Address>} newly created account address
     */


    _createClass(Accounts, [{
      key: "create",
      value: function create(passphrase) {
        var _this = this;

        return new Promise(function (resolve, reject) {
          var personal = new rpc_pb_3();
          personal.setPassphrase(passphrase);

          try {
            _this.client.client.createAccount(personal, function (err, rsp) {
              if (err) {
                reject(err);
              } else {
                var createdAddress = rsp.getAddress_asU8();
                resolve(new Address(createdAddress));
              }
            });
          } catch (exception) {
            reject(exception);
          }
        });
      }
      /**
       * Get list of accounts.
       * @returns {Promise<Address[]>} list of account addresses
       */

    }, {
      key: "get",
      value: function get() {
        var _this2 = this;

        return new Promise(function (resolve, reject) {
          var empty = new rpc_pb_2();

          try {
            _this2.client.client.getAccounts(empty, function (err, rsp) {
              if (err) {
                reject(err);
              } else {
                var accounts = rsp.getAccountsList();
                var addresses = accounts.map(function (account) {
                  return new Address(account.getAddress_asU8());
                });
                resolve(addresses);
              }
            });
          } catch (exception) {
            reject(exception);
          }
        });
      }
      /**
       * Unlock account.
       * @param {Address|string} address 
       * @param {Address|string} passphrase 
       * @returns {Promise<Address>} unlocked account address
       */

    }, {
      key: "unlock",
      value: function unlock(address, passphrase) {
        var _this3 = this;

        return new Promise(function (resolve, reject) {
          var account = new account_pb_1();
          account.setAddress(new Address(address).asBytes());
          var personal = new rpc_pb_3();
          personal.setPassphrase(passphrase);
          personal.setAccount(account);

          try {
            _this3.client.client.unlockAccount(personal, function (err, rsp) {
              if (err) {
                reject(err);
              } else {
                var createdAddress = rsp.getAddress_asU8();
                resolve(new Address(createdAddress));
              }
            });
          } catch (exception) {
            reject(exception);
          }
        });
      }
      /**
       * Lock account.
       * @param {Address|string} address 
       * @param {Address|string} passphrase 
       * @returns {Promise<Address>} locked account address
       */

    }, {
      key: "lock",
      value: function lock(address, passphrase) {
        var _this4 = this;

        return new Promise(function (resolve, reject) {
          var account = new account_pb_1();
          account.setAddress(new Address(address).asBytes());
          var personal = new rpc_pb_3();
          personal.setPassphrase(passphrase);
          personal.setAccount(account);

          try {
            _this4.client.client.lockAccount(personal, function (err, rsp) {
              if (err) {
                reject(err);
              } else {
                var createdAddress = rsp.getAddress_asU8();
                resolve(new Address(createdAddress));
              }
            });
          } catch (exception) {
            reject(exception);
          }
        });
      }
      /**
       * Convenience method to send transaction from account.
       * This method automatically retrieves the nonce, signs the transaction, and sends it to the network.
       * @param {Tx} tx transaction data
       * @returns {Promise<string>} transaction hash
       */

    }, {
      key: "sendTransaction",
      value: function sendTransaction(_tx) {
        var tx = _tx instanceof Tx ? _tx : new Tx(_tx);

        if (typeof tx.limit === 'undefined' && this.aergo.defaultLimit) {
          tx.limit = this.aergo.defaultLimit;
        }

        return promisify(this.client.client.sendTX, this.client.client)(tx.toGrpc()).then(function (result) {
          var obj = result.toObject();

          if (obj.error && obj.detail) {
            throw new Error(errorMessageForCode(obj.error) + ': ' + obj.detail);
          }

          return encodeTxHash(result.getHash_asU8());
        });
      }
      /**
       * Sign transaction.
       * @param {Tx} tx transaction data
       * @returns {Promise<Tx>} transaction data including signature
       */

    }, {
      key: "signTransaction",
      value: function signTransaction(_tx) {
        var tx = _tx instanceof Tx ? _tx : new Tx(_tx);

        if (typeof tx.limit === 'undefined' && this.aergo.defaultLimit) {
          tx.limit = this.aergo.defaultLimit;
        }

        return promisify(this.client.client.signTX, this.client.client)(tx.toGrpc()).then(function (signedtx) {
          return Tx.fromGrpc(signedtx);
        });
      }
    }]);

    return Accounts;
  }();

  var Block = /*#__PURE__*/function () {
    function Block(data) {
      _classCallCheck(this, Block);

      _defineProperty(this, "hash", void 0);

      _defineProperty(this, "header", void 0);

      _defineProperty(this, "body", void 0);

      Object.assign(this, data);
    }

    _createClass(Block, [{
      key: "toGrpc",
      value: function toGrpc() {
        throw new Error('Not implemented');
      }
    }, {
      key: "voteReward",
      get: function get() {
        return Block.getVoteReward(this);
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        var obj = grpcObject.toObject();
        var txsList = [];
        var body = grpcObject.getBody();

        if (obj.body && body) {
          txsList = body.getTxsList().map(function (tx) {
            return SignedTx.fromGrpc(tx);
          });
        }

        var header = grpcObject.getHeader();
        return new Block({
          hash: Block.encodeHash(grpcObject.getHash_asU8()),
          header: header ? _objectSpread2({}, obj.header, {
            blockno: header.getBlockno(),
            timestamp: header.getTimestamp(),
            confirms: header.getConfirms(),
            sign: header.getSign(),
            chainid: Buffer$1.from(header.getChainid_asU8()).toString('utf8'),
            prevblockhash: Block.encodeHash(header.getPrevblockhash_asU8()),
            blocksroothash: Block.encodeHash(header.getBlocksroothash_asU8()),
            txsroothash: Block.encodeHash(header.getTxsroothash_asU8()),
            receiptsroothash: Block.encodeHash(header.getReceiptsroothash_asU8()),
            coinbaseaccount: new Address(header.getCoinbaseaccount_asU8()),
            pubkey: Block.encodeHash(header.getPubkey_asU8()),
            rewardaccount: new Address(header.getConsensus_asU8())
          }) : undefined,
          body: {
            txsList: txsList
          }
        });
      }
    }, {
      key: "encodeHash",
      value: function encodeHash(bytes) {
        return base58.encode(Buffer$1.from(bytes));
      }
    }, {
      key: "decodeHash",
      value: function decodeHash(bs58string) {
        return base58.decode(bs58string);
      }
    }, {
      key: "getVoteReward",
      value: function getVoteReward(block) {
        if (block.header && !block.header.rewardaccount.isEmpty()) {
          return new Amount('0.16 aergo');
        }

        return new Amount(0);
      }
    }]);

    return Block;
  }();

  var BlockMetadata = /*#__PURE__*/function () {
    function BlockMetadata(data) {
      _classCallCheck(this, BlockMetadata);

      _defineProperty(this, "hash", void 0);

      _defineProperty(this, "header", void 0);

      _defineProperty(this, "txcount", void 0);

      _defineProperty(this, "size", void 0);

      Object.assign(this, data);
    }

    _createClass(BlockMetadata, [{
      key: "toGrpc",
      value: function toGrpc() {
        throw new Error('Not implemented');
      }
    }, {
      key: "voteReward",
      get: function get() {
        return Block.getVoteReward(this);
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        var obj = grpcObject.toObject();
        var header = grpcObject.getHeader();
        return new BlockMetadata({
          hash: Block.encodeHash(grpcObject.getHash_asU8()),
          header: header ? _objectSpread2({}, obj.header, {
            blockno: header.getBlockno(),
            timestamp: header.getTimestamp(),
            confirms: header.getConfirms(),
            sign: header.getSign(),
            chainid: Buffer$1.from(header.getChainid_asU8()).toString('utf8'),
            prevblockhash: Block.encodeHash(header.getPrevblockhash_asU8()),
            blocksroothash: Block.encodeHash(header.getBlocksroothash_asU8()),
            txsroothash: Block.encodeHash(header.getTxsroothash_asU8()),
            receiptsroothash: Block.encodeHash(header.getReceiptsroothash_asU8()),
            coinbaseaccount: new Address(header.getCoinbaseaccount_asU8()),
            pubkey: Block.encodeHash(header.getPubkey_asU8()),
            rewardaccount: new Address(header.getConsensus_asU8())
          }) : undefined,
          txcount: obj.txcount,
          size: obj.size
        });
      }
    }]);

    return BlockMetadata;
  }();

  var ChainInfo = /*#__PURE__*/function () {
    function ChainInfo(data) {
      _classCallCheck(this, ChainInfo);

      _defineProperty(this, "chainid", void 0);

      _defineProperty(this, "bpnumber", void 0);

      _defineProperty(this, "maxblocksize", void 0);

      _defineProperty(this, "maxtokens", void 0);

      _defineProperty(this, "stakingminimum", void 0);

      _defineProperty(this, "stakingtotal", void 0);

      _defineProperty(this, "gasprice", void 0);

      _defineProperty(this, "nameprice", void 0);

      _defineProperty(this, "totalvotingpower", void 0);

      _defineProperty(this, "votingreward", void 0);

      Object.assign(this, data);
    }

    _createClass(ChainInfo, [{
      key: "toGrpc",
      value: function toGrpc() {
        throw new Error('Not implemented');
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        var chainid = grpcObject.getId();
        return new ChainInfo({
          chainid: chainid ? {
            magic: chainid.getMagic(),
            "public": chainid.getPublic(),
            mainnet: chainid.getMainnet(),
            consensus: chainid.getConsensus()
          } : {
            magic: 'unknown',
            "public": false,
            mainnet: false,
            consensus: 'unknown'
          },
          bpnumber: grpcObject.getBpnumber(),
          maxblocksize: grpcObject.getMaxblocksize(),
          maxtokens: new Amount(grpcObject.getMaxtokens_asU8()),
          stakingminimum: new Amount(grpcObject.getStakingminimum_asU8()),
          stakingtotal: new Amount(grpcObject.getTotalstaking_asU8()),
          gasprice: new Amount(grpcObject.getGasprice_asU8()),
          nameprice: new Amount(grpcObject.getNameprice_asU8()),
          totalvotingpower: new Amount(grpcObject.getTotalvotingpower_asU8()),
          votingreward: new Amount(grpcObject.getVotingreward_asU8())
        });
      }
    }]);

    return ChainInfo;
  }();

  var minimalisticAssert = assert;

  function assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
  };

  var inherits_1 = inherits_browser;

  function isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
      return false;
    }

    if (i < 0 || i + 1 >= msg.length) {
      return false;
    }

    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
  }

  function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];

    if (typeof msg === 'string') {
      if (!enc) {
        // Inspired by stringToUtf8ByteArray() in closure-library by Google
        // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
        // Apache License 2.0
        // https://github.com/google/closure-library/blob/master/LICENSE
        var p = 0;

        for (var i = 0; i < msg.length; i++) {
          var c = msg.charCodeAt(i);

          if (c < 128) {
            res[p++] = c;
          } else if (c < 2048) {
            res[p++] = c >> 6 | 192;
            res[p++] = c & 63 | 128;
          } else if (isSurrogatePair(msg, i)) {
            c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
            res[p++] = c >> 18 | 240;
            res[p++] = c >> 12 & 63 | 128;
            res[p++] = c >> 6 & 63 | 128;
            res[p++] = c & 63 | 128;
          } else {
            res[p++] = c >> 12 | 224;
            res[p++] = c >> 6 & 63 | 128;
            res[p++] = c & 63 | 128;
          }
        }
      } else if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;

        for (i = 0; i < msg.length; i += 2) {
          res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
      }
    } else {
      for (i = 0; i < msg.length; i++) {
        res[i] = msg[i] | 0;
      }
    }

    return res;
  }

  var toArray_1 = toArray;

  function toHex$1(msg) {
    var res = '';

    for (var i = 0; i < msg.length; i++) {
      res += zero2(msg[i].toString(16));
    }

    return res;
  }

  var toHex_1 = toHex$1;

  function htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
  }

  var htonl_1 = htonl;

  function toHex32(msg, endian) {
    var res = '';

    for (var i = 0; i < msg.length; i++) {
      var w = msg[i];
      if (endian === 'little') w = htonl(w);
      res += zero8(w.toString(16));
    }

    return res;
  }

  var toHex32_1 = toHex32;

  function zero2(word) {
    if (word.length === 1) return '0' + word;else return word;
  }

  var zero2_1 = zero2;

  function zero8(word) {
    if (word.length === 7) return '0' + word;else if (word.length === 6) return '00' + word;else if (word.length === 5) return '000' + word;else if (word.length === 4) return '0000' + word;else if (word.length === 3) return '00000' + word;else if (word.length === 2) return '000000' + word;else if (word.length === 1) return '0000000' + word;else return word;
  }

  var zero8_1 = zero8;

  function join32(msg, start, end, endian) {
    var len = end - start;
    minimalisticAssert(len % 4 === 0);
    var res = new Array(len / 4);

    for (var i = 0, k = start; i < res.length; i++, k += 4) {
      var w;
      if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
      res[i] = w >>> 0;
    }

    return res;
  }

  var join32_1 = join32;

  function split32(msg, endian) {
    var res = new Array(msg.length * 4);

    for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
      var m = msg[i];

      if (endian === 'big') {
        res[k] = m >>> 24;
        res[k + 1] = m >>> 16 & 0xff;
        res[k + 2] = m >>> 8 & 0xff;
        res[k + 3] = m & 0xff;
      } else {
        res[k + 3] = m >>> 24;
        res[k + 2] = m >>> 16 & 0xff;
        res[k + 1] = m >>> 8 & 0xff;
        res[k] = m & 0xff;
      }
    }

    return res;
  }

  var split32_1 = split32;

  function rotr32(w, b) {
    return w >>> b | w << 32 - b;
  }

  var rotr32_1 = rotr32;

  function rotl32(w, b) {
    return w << b | w >>> 32 - b;
  }

  var rotl32_1 = rotl32;

  function sum32(a, b) {
    return a + b >>> 0;
  }

  var sum32_1 = sum32;

  function sum32_3(a, b, c) {
    return a + b + c >>> 0;
  }

  var sum32_3_1 = sum32_3;

  function sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
  }

  var sum32_4_1 = sum32_4;

  function sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
  }

  var sum32_5_1 = sum32_5;

  function sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
  }

  var sum64_1 = sum64;

  function sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
  }

  var sum64_hi_1 = sum64_hi;

  function sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
  }

  var sum64_lo_1 = sum64_lo;

  function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
  }

  var sum64_4_hi_1 = sum64_4_hi;

  function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
  }

  var sum64_4_lo_1 = sum64_4_lo;

  function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
  }

  var sum64_5_hi_1 = sum64_5_hi;

  function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
  }

  var sum64_5_lo_1 = sum64_5_lo;

  function rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
  }

  var rotr64_hi_1 = rotr64_hi;

  function rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
  }

  var rotr64_lo_1 = rotr64_lo;

  function shr64_hi(ah, al, num) {
    return ah >>> num;
  }

  var shr64_hi_1 = shr64_hi;

  function shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
  }

  var shr64_lo_1 = shr64_lo;
  var utils = {
    inherits: inherits_1,
    toArray: toArray_1,
    toHex: toHex_1,
    htonl: htonl_1,
    toHex32: toHex32_1,
    zero2: zero2_1,
    zero8: zero8_1,
    join32: join32_1,
    split32: split32_1,
    rotr32: rotr32_1,
    rotl32: rotl32_1,
    sum32: sum32_1,
    sum32_3: sum32_3_1,
    sum32_4: sum32_4_1,
    sum32_5: sum32_5_1,
    sum64: sum64_1,
    sum64_hi: sum64_hi_1,
    sum64_lo: sum64_lo_1,
    sum64_4_hi: sum64_4_hi_1,
    sum64_4_lo: sum64_4_lo_1,
    sum64_5_hi: sum64_5_hi_1,
    sum64_5_lo: sum64_5_lo_1,
    rotr64_hi: rotr64_hi_1,
    rotr64_lo: rotr64_lo_1,
    shr64_hi: shr64_hi_1,
    shr64_lo: shr64_lo_1
  };

  function BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
  }

  var BlockHash_1 = BlockHash;

  BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = utils.toArray(msg, enc);
    if (!this.pending) this.pending = msg;else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length; // Enough data, try updating

    if (this.pending.length >= this._delta8) {
      msg = this.pending; // Process pending data in blocks

      var r = msg.length % this._delta8;
      this.pending = msg.slice(msg.length - r, msg.length);
      if (this.pending.length === 0) this.pending = null;
      msg = utils.join32(msg, 0, msg.length - r, this.endian);

      for (var i = 0; i < msg.length; i += this._delta32) {
        this._update(msg, i, i + this._delta32);
      }
    }

    return this;
  };

  BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    minimalisticAssert(this.pending === null);
    return this._digest(enc);
  };

  BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;

    for (var i = 1; i < k; i++) {
      res[i] = 0;
    } // Append length


    len <<= 3;

    if (this.endian === 'big') {
      for (var t = 8; t < this.padLength; t++) {
        res[i++] = 0;
      }

      res[i++] = 0;
      res[i++] = 0;
      res[i++] = 0;
      res[i++] = 0;
      res[i++] = len >>> 24 & 0xff;
      res[i++] = len >>> 16 & 0xff;
      res[i++] = len >>> 8 & 0xff;
      res[i++] = len & 0xff;
    } else {
      res[i++] = len & 0xff;
      res[i++] = len >>> 8 & 0xff;
      res[i++] = len >>> 16 & 0xff;
      res[i++] = len >>> 24 & 0xff;
      res[i++] = 0;
      res[i++] = 0;
      res[i++] = 0;
      res[i++] = 0;

      for (t = 8; t < this.padLength; t++) {
        res[i++] = 0;
      }
    }

    return res;
  };

  var common = {
    BlockHash: BlockHash_1
  };

  var rotr32$1 = utils.rotr32;

  function ft_1(s, x, y, z) {
    if (s === 0) return ch32(x, y, z);
    if (s === 1 || s === 3) return p32(x, y, z);
    if (s === 2) return maj32(x, y, z);
  }

  var ft_1_1 = ft_1;

  function ch32(x, y, z) {
    return x & y ^ ~x & z;
  }

  var ch32_1 = ch32;

  function maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
  }

  var maj32_1 = maj32;

  function p32(x, y, z) {
    return x ^ y ^ z;
  }

  var p32_1 = p32;

  function s0_256(x) {
    return rotr32$1(x, 2) ^ rotr32$1(x, 13) ^ rotr32$1(x, 22);
  }

  var s0_256_1 = s0_256;

  function s1_256(x) {
    return rotr32$1(x, 6) ^ rotr32$1(x, 11) ^ rotr32$1(x, 25);
  }

  var s1_256_1 = s1_256;

  function g0_256(x) {
    return rotr32$1(x, 7) ^ rotr32$1(x, 18) ^ x >>> 3;
  }

  var g0_256_1 = g0_256;

  function g1_256(x) {
    return rotr32$1(x, 17) ^ rotr32$1(x, 19) ^ x >>> 10;
  }

  var g1_256_1 = g1_256;
  var common$1 = {
    ft_1: ft_1_1,
    ch32: ch32_1,
    maj32: maj32_1,
    p32: p32_1,
    s0_256: s0_256_1,
    s1_256: s1_256_1,
    g0_256: g0_256_1,
    g1_256: g1_256_1
  };

  var sum32$1 = utils.sum32;
  var sum32_4$1 = utils.sum32_4;
  var sum32_5$1 = utils.sum32_5;
  var ch32$1 = common$1.ch32;
  var maj32$1 = common$1.maj32;
  var s0_256$1 = common$1.s0_256;
  var s1_256$1 = common$1.s1_256;
  var g0_256$1 = common$1.g0_256;
  var g1_256$1 = common$1.g1_256;
  var BlockHash$1 = common.BlockHash;
  var sha256_K = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];

  function SHA256() {
    if (!(this instanceof SHA256)) return new SHA256();
    BlockHash$1.call(this);
    this.h = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];
    this.k = sha256_K;
    this.W = new Array(64);
  }

  utils.inherits(SHA256, BlockHash$1);
  var _256 = SHA256;
  SHA256.blockSize = 512;
  SHA256.outSize = 256;
  SHA256.hmacStrength = 192;
  SHA256.padLength = 64;

  SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;

    for (var i = 0; i < 16; i++) {
      W[i] = msg[start + i];
    }

    for (; i < W.length; i++) {
      W[i] = sum32_4$1(g1_256$1(W[i - 2]), W[i - 7], g0_256$1(W[i - 15]), W[i - 16]);
    }

    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    minimalisticAssert(this.k.length === W.length);

    for (i = 0; i < W.length; i++) {
      var T1 = sum32_5$1(h, s1_256$1(e), ch32$1(e, f, g), this.k[i], W[i]);
      var T2 = sum32$1(s0_256$1(a), maj32$1(a, b, c));
      h = g;
      g = f;
      f = e;
      e = sum32$1(d, T1);
      d = c;
      c = b;
      b = a;
      a = sum32$1(T1, T2);
    }

    this.h[0] = sum32$1(this.h[0], a);
    this.h[1] = sum32$1(this.h[1], b);
    this.h[2] = sum32$1(this.h[2], c);
    this.h[3] = sum32$1(this.h[3], d);
    this.h[4] = sum32$1(this.h[4], e);
    this.h[5] = sum32$1(this.h[5], f);
    this.h[6] = sum32$1(this.h[6], g);
    this.h[7] = sum32$1(this.h[7], h);
  };

  SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return utils.toHex32(this.h, 'big');else return utils.split32(this.h, 'big');
  };

  /**
   * Data structure for contract function calls.
   * You should not need to build these yourself, they are returned from contract instance functions and
   * can be passed to the client.
   */
  var FunctionCall = /*#__PURE__*/function () {
    function FunctionCall(contractInstance, definition, args) {
      _classCallCheck(this, FunctionCall);

      _defineProperty(this, "definition", void 0);

      _defineProperty(this, "args", void 0);

      _defineProperty(this, "contractInstance", void 0);

      this.definition = definition;
      this.args = args;
      this.contractInstance = contractInstance;
    }
    /**
     * Generate transaction object that can be passed to :meth:`aergoClient.accounts.sendTrasaction`
     * 
     * .. code-block:: javascript
     * 
     *     import { Contract } from '@herajs/client';
     *     const contract = Contract.fromAbi(abi).atAddress(address);
     *     const functionCall = contract.someAbiFunction();
     *     aergo.accounts.sendTransaction(functionCall.asTransaction({
     *         from: myAddress
     *     })).then(result => {
     *         console.log(result);
     *     })
     * @param {obj} extraArgs
     * @param {string} extraArgs.from set from address for the transaction
     * @return {obj} transaction data
     */


    _createClass(FunctionCall, [{
      key: "asTransaction",
      value: function asTransaction(extraArgs) {
        var payload = JSON.stringify({
          Name: this.definition.name,
          Args: this.args
        });
        if (!this.contractInstance.address) throw new Error('Set address of contract before creating transactions');

        if (typeof extraArgs === 'undefined' || !extraArgs.from || extraArgs.from.length === 0) {
          throw new Error('Missing required transaction parameter \'from\'. Call with asTransaction({from: ...})');
        }

        return _objectSpread2({
          to: this.contractInstance.address,
          payload: payload,
          amount: new Amount('0 aer'),
          type: Tx.Type.CALL
        }, extraArgs);
      }
      /**
       * Generate query info that can be passed to the API.
       * You usually do not need to call this function yourself, :meth:`AergoClient.queryContract` takes care of that.
       * 
       * .. code-block:: javascript
       * 
       *     import { Contract } from '@herajs/client';
       *     const contract = Contract.fromAbi(abi).atAddress(address);
       *     const functionCall = contract.someAbiFunction();
       *     aergo.queryContract(functionCall).then(result => {
       *         console.log(result);
       *     })
       * 
       * @return {obj} queryInfo data
       */

    }, {
      key: "asQueryInfo",
      value: function asQueryInfo() {
        return {
          Name: this.definition.name,
          Args: this.args
        };
      }
    }, {
      key: "toGrpc",
      value: function toGrpc() {
        var q = new blockchain_pb_6();

        if (!this.contractInstance.address) {
          throw new Error('set contract address before creating state query');
        }

        q.setContractaddress(Uint8Array.from(new Address(this.contractInstance.address).asBytes()));
        q.setQueryinfo(Uint8Array.from(Buffer.from(JSON.stringify(this.asQueryInfo()))));
        return q;
      }
    }]);

    return FunctionCall;
  }();
  /**
   * Query contract state directlty without using ABI methods.
   * 
   * .. code-block:: javascript
   * 
   *     import { Contract } from '@herajs/client';
   *     const contract = Contract.fromAbi(abi).atAddress(address);
   *     const query = contract.queryState('stateVariableName');
   *     aergo.queryContractState(query).then(result => {
   *         console.log(result);
   *     })
   */

  var StateQuery = /*#__PURE__*/function () {
    function StateQuery(contractInstance, storageKeys, compressed, root) {
      _classCallCheck(this, StateQuery);

      _defineProperty(this, "contractInstance", void 0);

      _defineProperty(this, "storageKeys", void 0);

      _defineProperty(this, "root", void 0);

      _defineProperty(this, "compressed", void 0);

      this.contractInstance = contractInstance;
      this.storageKeys = storageKeys;
      this.compressed = compressed || false;
      this.root = root;
    }

    _createClass(StateQuery, [{
      key: "toGrpc",
      value: function toGrpc() {
        var q = new blockchain_pb_7();

        if (!this.contractInstance.address) {
          throw new Error('set contract address before creating state query');
        }

        q.setContractaddress(this.contractInstance.address.asBytes());
        var storageKeys = this.storageKeys.map(function (key) {
          var buf = typeof key === 'string' ? Buffer.from(key) : key;
          return Uint8Array.from(_256().update(buf).digest());
        });
        q.setStoragekeysList(storageKeys);
        q.setCompressed(this.compressed);

        if (this.root) {
          q.setRoot(Uint8Array.from(this.root));
        }

        return q;
      }
    }]);

    return StateQuery;
  }();
  /**
   * Smart contract interface.
   * You usually instantiante this class by using one of the static methods.
   * Most of the instance methods return the contract so they can be chained.
   * When an ABI is loaded, its functions will be added to the instance and can be called directly.
   * ABI functions return `FunctionCall` objects that can be queried or called.
   * 
   * .. code-block:: javascript
   * 
   *     import { Contract } from '@herajs/client';
   *     const contract = Contract.fromAbi(abi).setAddress(address);
   *     aergo.queryContract(contract.someAbiFunction()).then(result => {
   *         console.log(result);
   *     })
   * 
   */

  var Contract = /*#__PURE__*/function () {
    function Contract(data) {
      _classCallCheck(this, Contract);

      _defineProperty(this, "code", void 0);

      _defineProperty(this, "address", void 0);

      _defineProperty(this, "functions", void 0);

      Object.assign(this, data);
      this.functions = {};

      function isNotProxied(obj, field) {
        return field in obj;
      } // This class acts as a proxy that passes ABI method calls


      return new Proxy(this, {
        get: function get(obj, field) {
          if (isNotProxied(obj, field)) return obj[field];
          if (field in obj.functions) return obj.functions[field];
          return undefined;
        }
      });
    }
    /**
     * Create contract instance from code
     * @param {string} bs58checkCode base58-check encoded code
     * @return {Contract} contract instance
     */


    _createClass(Contract, [{
      key: "setAddress",
      value:
      /**
       * Set address of contract instance
       * @param {Address|string} address 
       * @return {Contract} contract instance
       */
      function setAddress(address) {
        this.address = new Address(address);
        return this;
      }
      /**
       * Load contract ABI
       * @param {obj} abi parsed JSON ABI
       * @return {Contract} contract instance
       */

    }, {
      key: "loadAbi",
      value: function loadAbi(abi) {
        var _this = this;

        var _iterator = _createForOfIteratorHelper(abi.functions),
            _step;

        try {
          var _loop = function _loop() {
            var definition = _step.value;

            _this.functions[definition.name] = function () {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return new FunctionCall({
                address: _this.address
              }, definition, args);
            };
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return this;
      }
      /**
       * Return contract code as payload for transaction
       * @param {args}
       * @return {Buffer} a byte buffer
       */

    }, {
      key: "asPayload",
      value: function asPayload(args) {
        if (!this.code || !this.code.length) {
          throw new Error('Code is required to generate payload');
        } // First 4 bytes are the length of code (incl. ABI)


        var len = Buffer.from(fromNumber(4 + this.code.length, 4));

        if (typeof args !== 'undefined') {
          var argsDecoded = Buffer.from(JSON.stringify(args));
          return Buffer.concat([len, this.code, argsDecoded]);
        }

        return Buffer.concat([len, this.code]);
      }
      /**
       * Create query object to query contract state.
       * @param keys list of keys, either strings or Buffer-like byte arrays
       * @param compressed return compressed proof (default: false)
       * @param root root hash
       */

    }, {
      key: "queryState",
      value: function queryState(keys, compressed, root) {
        function isBufferLike(arr) {
          return keys instanceof Buffer || keys instanceof Uint8Array || arr.length > 0 && typeof arr[0] === 'number';
        }

        var keyArray = typeof keys === 'string' || isBufferLike(keys) ? [keys] : keys; // `as any` is needed b/c https://github.com/microsoft/TypeScript/issues/14107#issuecomment-483995795

        return new StateQuery(this, keyArray, compressed, root);
      }
    }], [{
      key: "fromCode",
      value: function fromCode(bs58checkCode) {
        var decoded = Contract.decodeCode(bs58checkCode);
        return new Contract({
          code: decoded
        });
      }
      /**
       * Create contract instance and set address
       * @param {Address} address 
       * @return {Contract} contract instance 
       */

    }, {
      key: "atAddress",
      value: function atAddress(address) {
        var contract = new Contract({});
        contract.setAddress(address);
        return contract;
      }
      /**
       * Create contract instance from ABI
       * @param {obj} abi parsed JSON ABI
       * @return {Contract} contract instance
       */

    }, {
      key: "fromAbi",
      value: function fromAbi(abi) {
        var contract = new Contract({});
        contract.loadAbi(abi);
        return contract;
      }
    }, {
      key: "encodeCode",
      value: function encodeCode(byteArray) {
        var buf = Buffer.from([constants.ADDRESS_PREFIXES.CONTRACT].concat(_toConsumableArray(byteArray)));
        return bs58check.encode(buf);
      }
    }, {
      key: "decodeCode",
      value: function decodeCode(bs58checkCode) {
        return bs58check.decode(bs58checkCode).slice(1);
      }
    }]);

    return Contract;
  }();

  var Event = /*#__PURE__*/function () {
    function Event(data) {
      _classCallCheck(this, Event);

      _defineProperty(this, "address", void 0);

      _defineProperty(this, "args", void 0);

      _defineProperty(this, "eventName", void 0);

      _defineProperty(this, "eventidx", void 0);

      _defineProperty(this, "blockhash", void 0);

      _defineProperty(this, "txhash", void 0);

      _defineProperty(this, "blockno", void 0);

      _defineProperty(this, "txidx", void 0);

      Object.assign(this, data);
      this.address = new Address(this.address);
    }

    _createClass(Event, [{
      key: "toGrpc",
      value: function toGrpc() {
        throw new Error('Not implemented');
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        return new Event({
          args: JSON.parse(grpcObject.getJsonargs()),
          address: new Address(grpcObject.getContractaddress_asU8()),
          eventName: grpcObject.getEventname(),
          blockhash: Block.encodeHash(grpcObject.getBlockhash_asU8()),
          txhash: Block.encodeHash(grpcObject.getTxhash_asU8()),
          txidx: grpcObject.getTxindex(),
          eventidx: grpcObject.getEventidx(),
          blockno: grpcObject.getBlockno()
        });
      }
    }]);

    return Event;
  }();

  function isArgMap(obj) {
    return obj instanceof Map;
  }

  var FilterInfo = /*#__PURE__*/function () {
    function FilterInfo(data) {
      _classCallCheck(this, FilterInfo);

      _defineProperty(this, "address", void 0);

      _defineProperty(this, "args", void 0);

      _defineProperty(this, "eventName", void 0);

      _defineProperty(this, "blockfrom", 0);

      _defineProperty(this, "blockto", 0);

      _defineProperty(this, "desc", true);

      Object.assign(this, data);
    }

    _createClass(FilterInfo, [{
      key: "toGrpc",
      value: function toGrpc() {
        var fi = new blockchain_pb_8();
        fi.setContractaddress(new Address(this.address).asBytes());

        if (this.args) {
          // The RPC handler only understands maps, not simple arrays
          // The advantage of this is that you can query positional arguments directly
          // Herajs supports both, so pass args either as a Map([[idx, value]]) or 0-indexed array [value]
          var argsAsObj;
          var argsObj = {};

          if (isArgMap(this.args)) {
            argsAsObj = Array.from(this.args).reduce(function (obj, _ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  idx = _ref2[0],
                  value = _ref2[1];

              obj['' + idx] = value;
              return obj;
            }, argsObj);
          } else {
            argsAsObj = this.args.reduce(function (obj, value, idx) {
              obj['' + idx] = value;
              return obj;
            }, argsObj);
          }

          var argsAsJson = JSON.stringify(argsAsObj);
          fi.setArgfilter(Buffer$1.from(argsAsJson));
        }

        if (this.eventName) {
          fi.setEventname(this.eventName);
        }

        if (this.blockfrom) {
          fi.setBlockfrom(this.blockfrom);
        }

        if (this.blockto) {
          fi.setBlockto(this.blockto);
        }

        if (this.desc) {
          fi.setDesc(this.desc);
        }

        return fi;
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        return new FilterInfo({
          args: JSON.parse(Buffer$1.from(grpcObject.getArgfilter_asU8()).toString()),
          address: new Address(grpcObject.getContractaddress_asU8()),
          eventName: grpcObject.getEventname(),
          blockfrom: grpcObject.getBlockfrom(),
          blockto: grpcObject.getBlockto(),
          desc: grpcObject.getDesc()
        });
      }
    }]);

    return FilterInfo;
  }();

  function keys$2(o) {
    return Object.keys(o);
  }

  var Peer = /*#__PURE__*/function () {
    function Peer(data) {
      _classCallCheck(this, Peer);

      _defineProperty(this, "acceptedrole", void 0);

      Object.assign(this, data);
    }

    _createClass(Peer, [{
      key: "acceptedroleLabel",
      get: function get() {
        var _this = this;

        var roles = Peer.Role;
        var key = keys$2(roles).find(function (key) {
          return roles[key] === _this.acceptedrole;
        });
        return key || '';
      }
    }, {
      key: "toGrpc",
      value: function toGrpc() {
        throw new Error('Not implemented');
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        var obj = grpcObject.toObject();
        var bestblock = grpcObject.getBestblock();

        if (bestblock && obj.bestblock) {
          obj.bestblock.blockhash = Block.encodeHash(bestblock.getBlockhash_asU8());
        }

        var address = grpcObject.getAddress();

        if (address) {
          // @ts-ignore
          obj.address = _objectSpread2({}, obj.address, {
            peerid: base58.encode(Buffer.from(address.getPeerid_asU8()))
          });
        }

        return new Peer(obj);
      }
    }]);

    return Peer;
  }();

  _defineProperty(Peer, "Role", node_pb_1);

  var State = /*#__PURE__*/function () {
    function State(data) {
      _classCallCheck(this, State);

      _defineProperty(this, "nonce", void 0);

      _defineProperty(this, "balance", void 0);

      _defineProperty(this, "codehash", void 0);

      _defineProperty(this, "storageroot", void 0);

      _defineProperty(this, "sqlrecoverypoint", void 0);

      Object.assign(this, data);
    }

    _createClass(State, [{
      key: "toGrpc",
      value: function toGrpc() {
        throw new Error('not implemented');
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        return new State({
          nonce: grpcObject.getNonce(),
          balance: new Amount(grpcObject.getBalance_asU8()),
          codehash: grpcObject.getCodehash_asB64(),
          storageroot: grpcObject.getStorageroot_asB64(),
          sqlrecoverypoint: grpcObject.getSqlrecoverypoint()
        });
      }
    }]);

    return State;
  }();

  var ContractVarProof = /*#__PURE__*/function () {
    function ContractVarProof(data) {
      _classCallCheck(this, ContractVarProof);

      _defineProperty(this, "inclusion", void 0);

      _defineProperty(this, "key", void 0);

      _defineProperty(this, "value", void 0);

      _defineProperty(this, "proofKey", void 0);

      _defineProperty(this, "proofVal", void 0);

      _defineProperty(this, "bitmap", void 0);

      _defineProperty(this, "height", void 0);

      _defineProperty(this, "auditPath", void 0);

      Object.assign(this, data);
    }

    _createClass(ContractVarProof, [{
      key: "toGrpc",
      value: function toGrpc() {
        throw new Error('Not implemented');
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        var valueRaw = grpcObject.getValue_asU8();
        var value = undefined;

        if (grpcObject.getInclusion()) {
          if (valueRaw.length > 0) {
            value = JSON.parse(Buffer.from(valueRaw).toString());
          } else {
            value = null;
          }
        }

        return new ContractVarProof({
          inclusion: grpcObject.getInclusion(),
          key: grpcObject.getKey_asU8(),
          value: value,
          proofKey: grpcObject.getProofkey_asU8(),
          proofVal: grpcObject.getProofval_asU8(),
          bitmap: grpcObject.getBitmap_asU8(),
          height: grpcObject.getHeight(),
          auditPath: grpcObject.getAuditpathList_asU8()
        });
      }
    }]);

    return ContractVarProof;
  }();

  var AccountProof = /*#__PURE__*/function () {
    function AccountProof(data) {
      _classCallCheck(this, AccountProof);

      _defineProperty(this, "state", void 0);

      _defineProperty(this, "inclusion", void 0);

      _defineProperty(this, "key", void 0);

      _defineProperty(this, "proofKey", void 0);

      _defineProperty(this, "proofVal", void 0);

      _defineProperty(this, "bitmap", void 0);

      _defineProperty(this, "height", void 0);

      _defineProperty(this, "auditPath", void 0);

      Object.assign(this, data);
    }

    _createClass(AccountProof, [{
      key: "toGrpc",
      value: function toGrpc() {
        throw new Error('Not implemented');
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        var state = grpcObject.getState();
        return new AccountProof({
          state: state ? State.fromGrpc(state) : undefined,
          inclusion: grpcObject.getInclusion(),
          key: grpcObject.getKey_asU8(),
          proofKey: grpcObject.getProofkey_asU8(),
          proofVal: grpcObject.getProofval_asU8(),
          bitmap: grpcObject.getBitmap_asU8(),
          height: grpcObject.getHeight(),
          auditPath: grpcObject.getAuditpathList_asU8()
        });
      }
    }]);

    return AccountProof;
  }();

  var StateQueryProof = /*#__PURE__*/function () {
    function StateQueryProof(data) {
      _classCallCheck(this, StateQueryProof);

      _defineProperty(this, "contractProof", void 0);

      _defineProperty(this, "varProofs", void 0);

      Object.assign(this, data);
    }

    _createClass(StateQueryProof, [{
      key: "toGrpc",
      value: function toGrpc() {
        throw new Error('Not implemented');
      }
    }], [{
      key: "fromGrpc",
      value: function fromGrpc(grpcObject) {
        var contractProof = grpcObject.getContractproof();
        return new StateQueryProof({
          contractProof: contractProof ? AccountProof.fromGrpc(contractProof) : undefined,
          varProofs: grpcObject.getVarproofsList().map(function (grpcObject) {
            return ContractVarProof.fromGrpc(grpcObject);
          })
        });
      }
    }]);

    return StateQueryProof;
  }();

  function marshalEmpty() {
    return _marshalEmpty.apply(this, arguments);
  }

  function _marshalEmpty() {
    _marshalEmpty = _asyncToGenerator(function* () {
      return new rpc_pb_2();
    });
    return _marshalEmpty.apply(this, arguments);
  }

  function marshalHashOrNumberToSingleBytes(_x) {
    return _marshalHashOrNumberToSingleBytes.apply(this, arguments);
  }
  /**
   * Main aergo client controller.
   */


  function _marshalHashOrNumberToSingleBytes() {
    _marshalHashOrNumberToSingleBytes = _asyncToGenerator(function* (hashOrNumber) {
      if (typeof hashOrNumber === 'undefined') {
        throw new Error('Missing argument block hash or number');
      }

      var input;

      if (typeof hashOrNumber === 'string') {
        input = Block.decodeHash(hashOrNumber);
      } else if (typeof hashOrNumber === 'number') {
        input = fromNumber(hashOrNumber);
      }

      if (input.length != 32 && input.length != 8) {
        throw new Error('Invalid block hash. Must be 32 byte encoded in bs58. Did you mean to pass a block number?');
      }

      var singleBytes = new rpc_pb_4();
      singleBytes.setValue(Uint8Array.from(input));
      return singleBytes;
    });
    return _marshalHashOrNumberToSingleBytes.apply(this, arguments);
  }

  var AergoClient = /*#__PURE__*/function () {
    // @ts-ignore

    /**
     * Create a new auto-configured client with:
     * 
     * .. code-block:: javascript
     * 
     *     import AergoClient from '@herajs/client';
     *     const aergo = new AergoClient();
     * 
     * @param [object] configuration. Unused at the moment.
     * @param [Provider] custom configured provider. By default a provider is configured automatically depending on the environment.
     */
    function AergoClient() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      _classCallCheck(this, AergoClient);

      _defineProperty(this, "config", void 0);

      _defineProperty(this, "client", void 0);

      _defineProperty(this, "accounts", void 0);

      _defineProperty(this, "target", void 0);

      _defineProperty(this, "chainIdHash", void 0);

      _defineProperty(this, "defaultLimit", void 0);

      this.config = _objectSpread2({}, config);
      this.client = provider || this.defaultProvider();
      this.accounts = new Accounts(this);
    }

    _createClass(AergoClient, [{
      key: "defaultProvider",
      value: function defaultProvider() {
        // returns a new instance of defaultProviderClass
        // which will be overriden during build according to platform
        return new AergoClient.defaultProviderClass();
      }
      /**
       * Set a new provider
       * @param {Provider} provider
       */

    }, {
      key: "setProvider",
      value: function setProvider(provider) {
        this.client = provider;
        this.chainIdHash = undefined;
      }
    }, {
      key: "getConfig",
      value: function getConfig() {
        return this.config;
      }
    }, {
      key: "isConnected",
      value: function isConnected() {
        // Legacy code for backwards compatability
        return false;
      }
    }, {
      key: "grpcMethod",
      value: function grpcMethod(method) {
        var _this2 = this;

        return function (request) {
          return promisify(method, _this2.client.client)(request);
        };
      }
      /**
       * Set the chain id hash to use for subsequent transactions.
       * @param hash string (base58 encoded) or byte array
       */

    }, {
      key: "setChainIdHash",
      value: function setChainIdHash(hash) {
        if (typeof hash === 'string') {
          this.chainIdHash = base58.decode(hash);
        } else {
          this.chainIdHash = hash;
        }
      }
      /**
       * Set the default gas limit to use for transactions that do not define their own.
       */

    }, {
      key: "setDefaultLimit",
      value: function setDefaultLimit(limit) {
        this.defaultLimit = limit;
      }
      /**
       * Request chain id hash. This automatically gathers the chain id hash
       * from the current node if not specified.
       * @param enc set to 'base58' to retrieve the hash encoded in base58. Otherwise returns a Uint8Array.
       * @returns {Promise<Uint8Array | string>} Uint8Array by default, base58 encoded string if enc = 'base58'.
       */
      //async getChainIdHash(enc?: 'base58'): Promise<string>;
      //async getChainIdHash(enc?: '' | undefined): Promise<Uint8Array>;

    }, {
      key: "getChainIdHash",
      value: function () {
        var _getChainIdHash = _asyncToGenerator(function* (enc) {
          if (typeof this.chainIdHash === 'undefined') {
            // Fetch blockchain data to set chainIdHash
            yield this.blockchain();
          }

          return encodeBuffer(this.chainIdHash, enc);
        });

        function getChainIdHash(_x2) {
          return _getChainIdHash.apply(this, arguments);
        }

        return getChainIdHash;
      }()
      /**
       * Request current status of blockchain.
       * @returns {Promise<object>} an object detailing the current status
       */

    }, {
      key: "blockchain",
      value: function blockchain() {
        var _this = this;

        return waterfall([marshalEmpty, this.grpcMethod(this.client.client.blockchain), /*#__PURE__*/function () {
          var _unmarshal = _asyncToGenerator(function* (response) {
            if (typeof _this.chainIdHash === 'undefined') {
              // set chainIdHash automatically
              _this.setChainIdHash(Buffer$1.from(response.getBestChainIdHash_asU8()));
            }

            return {
              bestHeight: response.getBestHeight(),
              bestBlockHash: Block.encodeHash(response.getBestBlockHash_asU8()),
              bestChainIdHash: Block.encodeHash(response.getBestChainIdHash_asU8()),
              chainInfo: ChainInfo.fromGrpc(response.getChainInfo()),
              consensusInfo: JSON.parse(response.getConsensusInfo())
            };
          });

          function unmarshal(_x3) {
            return _unmarshal.apply(this, arguments);
          }

          return unmarshal;
        }()])(null);
      }
      /**
       * Request current status of blockchain.
       * @returns {Promise<object>} an object detailing the current status
       */

    }, {
      key: "getChainInfo",
      value: function getChainInfo() {
        return waterfall([marshalEmpty, this.grpcMethod(this.client.client.getChainInfo), /*#__PURE__*/function () {
          var _unmarshal2 = _asyncToGenerator(function* (response) {
            return ChainInfo.fromGrpc(response);
          });

          function unmarshal(_x4) {
            return _unmarshal2.apply(this, arguments);
          }

          return unmarshal;
        }()])(null);
      }
      /**
       * Request current status of node.
       * @returns {Promise<any>} an object detailing the state of various node components
       */

    }, {
      key: "getNodeState",
      value: function getNodeState(component) {
        var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
        return waterfall([/*#__PURE__*/function () {
          var _marshal = _asyncToGenerator(function* (component) {
            var params = new rpc_pb_14();
            params.setTimeout(fromNumber(timeout));

            if (typeof component !== 'undefined') {
              params.setComponent(Buffer$1.from(component));
            }

            return params;
          });

          function marshal(_x5) {
            return _marshal.apply(this, arguments);
          }

          return marshal;
        }(), this.grpcMethod(this.client.client.nodeState), /*#__PURE__*/function () {
          var _unmarshal3 = _asyncToGenerator(function* (response) {
            return JSON.parse(Buffer$1.from(response.getValue_asU8()).toString());
          });

          function unmarshal(_x6) {
            return _unmarshal3.apply(this, arguments);
          }

          return unmarshal;
        }()])(component);
      }
      /**
       * Get transaction information in the aergo node. 
       * If transaction is in the block return result with block hash and index.
       * @param {string} txhash transaction hash
       * @returns {Promise<object>} transaction details, object of tx: <Tx> and block: { hash, idx }
       */

    }, {
      key: "getTransaction",
      value: function getTransaction(txhash) {
        var _this3 = this;

        var singleBytes = new rpc_pb_4();
        singleBytes.setValue(Uint8Array.from(decodeTxHash(txhash)));
        return new Promise(function (resolve, reject) {
          _this3.client.client.getBlockTX(singleBytes, function (err, result) {
            if (err) {
              _this3.client.client.getTX(singleBytes, function (err, result) {
                if (err) {
                  reject(err);
                } else {
                  var res = {
                    tx: SignedTx.fromGrpc(result)
                  };
                  resolve(res);
                }
              });
            } else {
              var res = {
                block: {
                  hash: Block.encodeHash(result.getTxidx().getBlockhash_asU8()),
                  idx: result.getTxidx().getIdx()
                },
                tx: SignedTx.fromGrpc(result.getTx())
              };
              resolve(res);
            }
          });
        });
      }
      /**
       * Retrieve information about a block.
       * 
       * @param hashOrNumber either 32-byte block hash encoded as a bs58 string or block height as a number.
       * @returns block details
       */

    }, {
      key: "getBlock",
      value: function getBlock(hashOrNumber) {
        return waterfall([marshalHashOrNumberToSingleBytes, this.grpcMethod(this.client.client.getBlock), /*#__PURE__*/function () {
          var _unmarshal4 = _asyncToGenerator(function* (response) {
            return Block.fromGrpc(response);
          });

          function unmarshal(_x7) {
            return _unmarshal4.apply(this, arguments);
          }

          return unmarshal;
        }()])(hashOrNumber);
      }
      /**
       * Retrieve block metadata (excluding body).
       * 
       * @param hashOrNumber either 32-byte block hash encoded as a bs58 string or block height as a number.
       * @returns block metadata
       */

    }, {
      key: "getBlockMetadata",
      value: function getBlockMetadata(hashOrNumber) {
        return waterfall([marshalHashOrNumberToSingleBytes, this.grpcMethod(this.client.client.getBlockMetadata), /*#__PURE__*/function () {
          var _unmarshal5 = _asyncToGenerator(function* (response) {
            return BlockMetadata.fromGrpc(response);
          });

          function unmarshal(_x8) {
            return _unmarshal5.apply(this, arguments);
          }

          return unmarshal;
        }()])(hashOrNumber);
      }
      /**
       * Retrieve the last n blocks, beginning from given block
       * 
       * @param {string|number} hashOrNumber either 32-byte block hash encoded as a bs58 string or block height as a number.
       * @param {number} size number of blocks to return
       * @param {number} offset number of blocks to skip
       * @param {boolean} desc order of blocks
       * @returns {Promise<Block[]>} list of block headers (blocks without body)
       */

    }, {
      key: "getBlockHeaders",
      value: function getBlockHeaders(hashOrNumber) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var desc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        var params = new rpc_pb_9();

        if (typeof hashOrNumber === 'string') {
          var decodedHash = Block.decodeHash(hashOrNumber);

          if (decodedHash.length != 32) {
            throw new Error('Invalid block hash. Must be 32 byte encoded in bs58. Did you mean to pass a block number?');
          }

          params.setHash(Uint8Array.from(decodedHash));
        } else if (typeof hashOrNumber === 'number') {
          params.setHeight(hashOrNumber);
        } else {
          throw new Error('Block hash or number required.');
        }

        params.setSize(size);
        params.setOffset(offset);
        params.setAsc(!desc);
        return promisify(this.client.client.listBlockHeaders, this.client.client)(params).then(function (result) {
          return result.getBlocksList().map(function (item) {
            return Block.fromGrpc(item);
          });
        });
      }
    }, {
      key: "getBlockStream",
      value: function getBlockStream() {
        var empty = new rpc_pb_2();
        var stream = this.client.client.listBlockStream(empty);

        try {
          stream.on('error', function (error) {
            if (error.code === 1) {
              // grpc.status.CANCELLED
              return;
            }
          });
        } catch (e) {// ignore. 'error' does not work on grpc-web implementation
        }

        var ret = {
          _stream: stream,
          on: function on(ev, callback) {
            return stream.on(ev, function (data) {
              return callback(Block.fromGrpc(data));
            });
          },
          cancel: function cancel() {
            return stream.cancel();
          }
        };
        return ret;
      }
      /**
       * Returns a stream of block metadata
       */

    }, {
      key: "getBlockMetadataStream",
      value: function getBlockMetadataStream() {
        var empty = new rpc_pb_2();
        var stream = this.client.client.listBlockMetadataStream(empty);

        try {
          stream.on('error', function (error) {
            if (error.code === 1) {
              // grpc.status.CANCELLED
              return;
            }
          });
        } catch (e) {// ignore. 'error' does not work on grpc-web implementation
        }

        var ret = {
          _stream: stream,
          on: function on(ev, callback) {
            return stream.on(ev, function (data) {
              return callback(BlockMetadata.fromGrpc(data));
            });
          },
          cancel: function cancel() {
            return stream.cancel();
          }
        };
        return ret;
      }
      /**
       * Get the transactions of a block in a paged manner
       * @param hash 
       * @param offset 
       * @param size 
       */

    }, {
      key: "getBlockBody",
      value: function () {
        var _getBlockBody = _asyncToGenerator(function* (hashOrNumber) {
          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
          var paging = new rpc_pb_17();
          paging.setOffset(offset);
          paging.setSize(size);
          var params = new rpc_pb_18();
          params.setHashornumber((yield marshalHashOrNumberToSingleBytes(hashOrNumber)).getValue());
          params.setPaging(paging);
          return yield promisify(this.client.client.getBlockBody, this.client.client)(params).then(function (grpcObject) {
            var obj = grpcObject.toObject();

            if (obj.body && obj.body.txsList) {
              // @ts-ignore
              obj.body.txsList = grpcObject.getBody().getTxsList().map(function (tx) {
                return Tx.fromGrpc(tx);
              });
            }

            return obj;
          });
        });

        function getBlockBody(_x9) {
          return _getBlockBody.apply(this, arguments);
        }

        return getBlockBody;
      }()
      /**
       * Returns a stream that yields new events matching the specified filter in real-time.
       * 
       * .. code-block:: javascript
       * 
       *      const stream = aergo.getEventStream({
       *          address: 'Am....'
       *      });
       *      stream.on('data', (event) => {
       *         console.log(event);
       *         stream.cancel();
       *      });
       * 
       * @param {FilterInfo} filter :class:`FilterInfo`
       * @returns {Stream<Event>} event stream
       */

    }, {
      key: "getEventStream",
      value: function getEventStream(filter) {
        var fi = new FilterInfo(filter);
        var query = fi.toGrpc();
        var stream = this.client.client.listEventStream(query);

        try {
          stream.on('error', function (error) {
            if (error.code === 1) {
              // grpc.status.CANCELLED
              return;
            }
          });
        } catch (e) {// ignore. 'error' does not work on grpc-web implementation
        }

        var ret = {
          _stream: stream,
          on: function on(ev, callback) {
            return stream.on(ev, function (data) {
              return callback(Event.fromGrpc(data));
            });
          },
          cancel: function cancel() {
            return stream.cancel();
          }
        };
        return ret;
      }
      /**
       * Retrieve account state, including current balance and nonce.
       * @param {string} address Account address encoded in Base58check
       * @returns {Promise<object>} account state
       */

    }, {
      key: "getState",
      value: function getState(address) {
        var singleBytes = new rpc_pb_4();
        singleBytes.setValue(Uint8Array.from(new Address(address).asBytes()));
        return promisify(this.client.client.getState, this.client.client)(singleBytes).then(function (grpcObject) {
          return State.fromGrpc(grpcObject);
        });
      }
      /**
       * Retrieve account's most recenlty used nonce.
       * This is a shortcut function as the same information is also returned by getState.
       * @param {string} address Account address encoded in Base58check
       * @returns {Promise<object>} account state
       */

    }, {
      key: "getNonce",
      value: function getNonce(address) {
        var singleBytes = new rpc_pb_4();
        singleBytes.setValue(Uint8Array.from(new Address(address).asBytes()));
        return promisify(this.client.client.getState, this.client.client)(singleBytes).then(function (grpcObject) {
          return grpcObject.getNonce();
        });
      }
      /**
       * Send one or more signed transaction to the network.
       * @param {Tx} tx signed transaction or array of multiple signed transactions
       * @returns {Promise<string>} transaction hash
       */

    }, {
      key: "sendSignedTransaction",
      value: function sendSignedTransaction(tx) {
        var _this4 = this;

        return new Promise(function (resolve, reject) {
          var txList = new blockchain_pb_1();
          var txs = Array.isArray(tx) ? tx : [tx];
          var txCount = txs.length;

          var _iterator = _createForOfIteratorHelper(txs.entries()),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _slicedToArray(_step.value, 2),
                  index = _step$value[0],
                  _tx = _step$value[1];

              var _tx2 = _tx instanceof Tx ? _tx : new Tx(_tx);

              txList.addTxs(_tx2.toGrpc(), index);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          _this4.client.client.commitTX(txList, function (err, result) {
            if (err == null && result.getResultsList()[0].getError() && txCount === 1) {
              var obj = result.getResultsList()[0].toObject();
              err = new TransactionError(errorMessageForCode(obj.error) + ': ' + obj.detail);
            }

            if (err) {
              reject(new TransactionError(err.message));
            } else {
              var hashes = result.getResultsList().map(function (res) {
                var error = res.getError();

                if (error) {
                  return {
                    error: errorMessageForCode(error) + ': ' + res.getDetail()
                  };
                }

                return {
                  hash: encodeTxHash(res.getHash_asU8())
                };
              });

              if (txCount === 1) {
                resolve(hashes[0].hash);
              } else {
                resolve(hashes);
              }
            }
          });
        });
      }
      /**
       * Return the top {count} result for a vote
       * @param count number
       * @param id vote identifier, default: voteBP
       */

    }, {
      key: "getTopVotes",
      value: function getTopVotes(count) {
        var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'voteBP';
        var params = new rpc_pb_13();
        params.setCount(count);
        params.setId(id);
        return promisify(this.client.client.getVotes, this.client.client)(params).then(function (state) {
          return state.getVotesList().map(function (item) {
            return {
              amount: new Amount(item.getAmount_asU8()),
              candidate: id === 'voteBP' ? base58.encode(Buffer$1.from(item.getCandidate_asU8())) : Buffer$1.from(item.getCandidate_asU8()).toString()
            };
          });
        });
      }
      /**
       * Return the top voted-for block producer or system parameter
       * @param address string
       */

    }, {
      key: "getAccountVotes",
      value: function getAccountVotes(address) {
        var accountAddress = new rpc_pb_1();
        accountAddress.setValue(Uint8Array.from(new Address(address).asBytes()));
        return promisify(this.client.client.getAccountVotes, this.client.client)(accountAddress);
      }
      /**
       * Return information for account name
       * @param {string} address Account address encoded in Base58check
       */

    }, {
      key: "getStaking",
      value: function getStaking(address) {
        var accountAddress = new rpc_pb_1();
        accountAddress.setValue(Uint8Array.from(new Address(address).asBytes()));
        return promisify(this.client.client.getStaking, this.client.client)(accountAddress).then(function (grpcObject) {
          return {
            amount: new Amount(grpcObject.getAmount_asU8()),
            when: grpcObject.getWhen()
          };
        });
      }
      /**
       * Retrieve the transaction receipt for a transaction
       * @param {string} txhash transaction hash
       * @return {Promise<object>} transaction receipt
       */

    }, {
      key: "getTransactionReceipt",
      value: function getTransactionReceipt(txhash) {
        var singleBytes = new rpc_pb_4();
        singleBytes.setValue(Uint8Array.from(decodeTxHash(txhash)));
        return promisify(this.client.client.getReceipt, this.client.client)(singleBytes).then(function (grpcObject) {
          var obj = grpcObject.toObject();
          var ret = {
            contractaddress: new Address(grpcObject.getContractaddress_asU8()),
            result: obj.ret,
            status: obj.status,
            fee: new Amount(grpcObject.getFeeused_asU8()),
            cumulativefee: new Amount(grpcObject.getCumulativefeeused_asU8()),
            blockno: obj.blockno,
            blockhash: Block.encodeHash(grpcObject.getBlockhash_asU8()),
            feeDelegation: obj.feedelegation,
            gasused: obj.gasused,
            events: grpcObject.getEventsList().map(function (item) {
              return Event.fromGrpc(item);
            })
          };
          return ret;
        });
      }
      /**
       * Retrieve the transaction receipt for a transaction, but keep retrying if not available yet.
       * Uses expoinential backoff and a final timeout.
       * @param {string} txhash transaction hash
       * @param {number} timeout throws error when timeout is reached
       * @param {number} baseBackoffInterval base time for exponentail backoff
       * @return {Promise<object>} transaction receipt
       */

    }, {
      key: "waitForTransactionReceipt",
      value: function waitForTransactionReceipt(txhash) {
        var _this5 = this;

        var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var baseBackoffInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
        var started = new Date();
        var retryCount = 0;

        var retryLoad = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(function* () {
            try {
              return yield _this5.getTransactionReceipt(txhash);
            } catch (e) {
              var details = "".concat(e.details || e.message);

              if (!details.match(/tx not found/)) {
                throw e;
              }

              var interval = backoffIntervalStep(retryCount++, baseBackoffInterval);

              if (timeout) {
                var elapsed = +new Date() - +started;

                if (elapsed + interval >= timeout) {
                  var unit = elapsed < 1000 ? 'ms' : 's';
                  var elapsedFormat = elapsed < 1000 ? elapsed : Math.round(elapsed / 100) / 10;
                  throw new Error("timeout after ".concat(elapsedFormat).concat(unit, ": tx not found"));
                }
              }

              yield waitFor(interval);
              return yield retryLoad();
            }
          });

          return function retryLoad() {
            return _ref.apply(this, arguments);
          };
        }();

        return retryLoad();
      }
      /**
       * Query contract, either through ABI or manually.
       * Either pass a FunctionCall object (created through contract interface)
       * or a manual call (address, name, ...args).
       * @returns {Promise<object>} result of query
       */

    }, {
      key: "queryContract",
      value: function queryContract() {
        var functionCall;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (args[0] instanceof Address || typeof args[0] === 'string') {
          var _address = args[0],
              name = args[1],
              callArgs = args.slice(2);
          functionCall = new FunctionCall({
            address: new Address(_address)
          }, {
            name: name
          }, callArgs);
        } else {
          functionCall = args[0];
        }

        var query = functionCall.toGrpc();
        return promisify(this.client.client.queryContract, this.client.client)(query).then(function (grpcObject) {
          return JSON.parse(Buffer$1.from(grpcObject.getValue()).toString());
        });
      }
      /**
       * Query contract state.
       * This only works for variables explicitly defines as state variables.
       * Throws when contract do not exist, or when variable does not exist when requesting single key.
       * @param {StateQuery} stateQuery query details obtained from contract.queryState()
       * @returns {Promise<JsonData>} result of query: single value if requesting one key, list of values when requesting multiple keys.
       */

    }, {
      key: "queryContractState",
      value: function queryContractState(stateQuery) {
        var query = stateQuery.toGrpc();
        return promisify(this.client.client.queryContractState, this.client.client)(query).then(function (grpcObject) {
          var addr = new Address(query.getContractaddress_asU8());

          if (grpcObject.getContractproof().getInclusion() === false) {
            throw Error("contract does not exist at address ".concat(addr.toString()));
          }

          var list = grpcObject.getVarproofsList();

          if (list.length === 1) {
            var varProof = list[0];

            if (varProof.getInclusion() === false) {
              throw Error("queried variable 0x".concat(Buffer$1.from(stateQuery.storageKeys[0]).toString('hex'), " does not exist in state at address ").concat(addr.toString()));
            }

            var value = varProof.getValue_asU8();

            if (value.length > 0) {
              return JSON.parse(Buffer$1.from(value).toString());
            }
          }

          return list.map(function (varProof) {
            var value = varProof.getValue_asU8();

            if (value.length > 0) {
              return JSON.parse(Buffer$1.from(value).toString());
            }

            return void 0;
          });
        });
      }
      /**
       * Query contract state, including proofs.
       * This only works vor variables explicitly defines as state variables.
       * @param {StateQuery} stateQuery query details obtained from contract.queryState()
       * @returns {Promise<StateQueryProof>} result of query, including account and var proofs
       */

    }, {
      key: "queryContractStateProof",
      value: function queryContractStateProof(stateQuery) {
        var query = stateQuery.toGrpc();
        return promisify(this.client.client.queryContractState, this.client.client)(query).then(function (grpcObject) {
          return StateQueryProof.fromGrpc(grpcObject);
        });
      }
      /**
       * Query contract state
       * This only works vor variables explicitly defines as state variables.
       * @param {FilterInfo} filter :class:`FilterInfo`
       * @returns {Event[]} list of events
       */

    }, {
      key: "getEvents",
      value: function getEvents(filter) {
        var fi = new FilterInfo(filter);
        var query = fi.toGrpc();
        return promisify(this.client.client.listEvents, this.client.client)(query).then(function (grpcObject) {
          var list = grpcObject.getEventsList();
          return list.map(function (item) {
            return Event.fromGrpc(item);
          });
        });
      }
      /**
       * Query contract ABI
       * @param {string} address of contract
       * @returns {Promise<object>} abi
       */

    }, {
      key: "getABI",
      value: function getABI(address) {
        var singleBytes = new rpc_pb_4();
        singleBytes.setValue(Uint8Array.from(new Address(address).asBytes()));
        return promisify(this.client.client.getABI, this.client.client)(singleBytes).then(function (grpcObject) {
          var obj = grpcObject.toObject();
          return {
            language: obj.language,
            version: obj.version,
            functions: obj.functionsList.map(function (item) {
              return {
                name: item.name,
                arguments: item.argumentsList,
                view: item.view,
                payable: item.payable,
                feeDelegation: item.feeDelegation
              };
            }),
            'state_variables': obj.stateVariablesList
          };
        });
      }
      /**
       * Get list of peers of connected node
       */

    }, {
      key: "getPeers",
      value: function getPeers() {
        var showself = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var showhidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var query = new rpc_pb_12();
        query.setNohidden(!showhidden);
        query.setShowself(showself);
        return promisify(this.client.client.getPeers, this.client.client)(query).then(function (grpcObject) {
          return grpcObject.getPeersList().map(function (peer) {
            return Peer.fromGrpc(peer);
          });
        });
      }
      /**
       * Return information for account name
       * @param name 
       */

    }, {
      key: "getNameInfo",
      value: function getNameInfo(name) {
        var blockno = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var nameObj = new rpc_pb_11();
        nameObj.setName(name);
        nameObj.setBlockno(blockno);
        return promisify(this.client.client.getNameInfo, this.client.client)(nameObj).then(function (grpcObject) {
          var obj = grpcObject.toObject();
          return {
            name: obj.name.name,
            owner: new Address(grpcObject.getOwner_asU8()),
            destination: new Address(grpcObject.getDestination_asU8())
          };
        });
      }
      /**
       * Return consensus info. The included fields can differ by consensus type.
       */

    }, {
      key: "getConsensusInfo",
      value: function getConsensusInfo() {
        return waterfall([marshalEmpty, this.grpcMethod(this.client.client.getConsensusInfo), /*#__PURE__*/function () {
          var _unmarshal6 = _asyncToGenerator(function* (response) {
            var obj = response.toObject();
            var result = {
              type: obj.type,
              info: obj.info ? JSON.parse(obj.info) : {},
              bpsList: obj.bpsList.map(function (info) {
                return JSON.parse(info);
              })
            };
            return result;
          });

          function unmarshal(_x10) {
            return _unmarshal6.apply(this, arguments);
          }

          return unmarshal;
        }()])(null);
      }
      /**
       * Return server info
       */

    }, {
      key: "getServerInfo",
      value: function getServerInfo(keys) {
        return waterfall([/*#__PURE__*/function () {
          var _marshal2 = _asyncToGenerator(function* (keys) {
            var params = new rpc_pb_15();

            if (typeof keys !== 'undefined') {
              params.setKeyList(keys);
            }

            return params;
          });

          function marshal(_x11) {
            return _marshal2.apply(this, arguments);
          }

          return marshal;
        }(), this.grpcMethod(this.client.client.getServerInfo), /*#__PURE__*/function () {
          var _unmarshal7 = _asyncToGenerator(function* (response) {
            var obj = response.toObject();
            var result = {
              configMap: new Map(),
              statusMap: new Map(obj.statusMap)
            };
            var configMap = new Map(obj.configMap);

            var _iterator2 = _createForOfIteratorHelper(configMap),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _step2$value = _slicedToArray(_step2.value, 2),
                    key = _step2$value[0],
                    item = _step2$value[1];

                result.configMap.set(key, new Map(item.propsMap));
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            return result;
          });

          function unmarshal(_x12) {
            return _unmarshal7.apply(this, arguments);
          }

          return unmarshal;
        }()])(keys);
      }
    }]);

    return AergoClient;
  }();

  _defineProperty(AergoClient, "defaultProviderClass", void 0);

  _defineProperty(AergoClient, "platform", '');

  var grpcWebClient_umd = createCommonjsModule(function (module, exports) {
    !function (e, t) {
      module.exports = t();
    }(commonjsGlobal, function () {
      return function (e) {
        var t = {};

        function n(r) {
          if (t[r]) return t[r].exports;
          var o = t[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }

        return n.m = e, n.c = t, n.d = function (e, t, r) {
          n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
          });
        }, n.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, n.t = function (e, t) {
          if (1 & t && (e = n(e)), 8 & t) return e;
          if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
          var r = Object.create(null);
          if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var o in e) {
            n.d(r, o, function (t) {
              return e[t];
            }.bind(null, o));
          }
          return r;
        }, n.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e["default"];
          } : function () {
            return e;
          };
          return n.d(t, "a", t), t;
        }, n.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 11);
      }([function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(4);
        t.Metadata = r.BrowserHeaders;
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.debug = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          console.debug ? console.debug.apply(null, e) : console.log.apply(null, e);
        };
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = null;

        t["default"] = function (e) {
          null === r ? (r = [e], setTimeout(function () {
            !function e() {
              if (r) {
                var t = r;
                r = null;

                for (var n = 0; n < t.length; n++) {
                  try {
                    t[n]();
                  } catch (s) {
                    null === r && (r = [], setTimeout(function () {
                      e();
                    }, 0));

                    for (var o = t.length - 1; o > n; o--) {
                      r.unshift(t[o]);
                    }

                    throw s;
                  }
                }
              }
            }();
          }, 0)) : r.push(e);
        };
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(0),
            o = n(9),
            s = n(10),
            i = n(1),
            a = n(2),
            u = n(5),
            d = n(15);

        t.client = function (e, t) {
          return new c(e, t);
        };

        var c = function () {
          function e(e, t) {
            this.started = !1, this.sentFirstMessage = !1, this.completed = !1, this.closed = !1, this.finishedSending = !1, this.onHeadersCallbacks = [], this.onMessageCallbacks = [], this.onEndCallbacks = [], this.parser = new o.ChunkParser(), this.methodDefinition = e, this.props = t, this.createTransport();
          }

          return e.prototype.createTransport = function () {
            var e = this.props.host + "/" + this.methodDefinition.service.serviceName + "/" + this.methodDefinition.methodName,
                t = {
              methodDefinition: this.methodDefinition,
              debug: this.props.debug || !1,
              url: e,
              onHeaders: this.onTransportHeaders.bind(this),
              onChunk: this.onTransportChunk.bind(this),
              onEnd: this.onTransportEnd.bind(this)
            };
            this.props.transport ? this.transport = this.props.transport(t) : this.transport = u.makeDefaultTransport(t);
          }, e.prototype.onTransportHeaders = function (e, t) {
            if (this.props.debug && i.debug("onHeaders", e, t), this.closed) this.props.debug && i.debug("grpc.onHeaders received after request was closed - ignoring");else if (0 === t) ;else {
              this.responseHeaders = e, this.props.debug && i.debug("onHeaders.responseHeaders", JSON.stringify(this.responseHeaders, null, 2));
              var n = p(e);
              this.props.debug && i.debug("onHeaders.gRPCStatus", n);
              var r = n && n >= 0 ? n : s.httpStatusToCode(t);
              this.props.debug && i.debug("onHeaders.code", r);
              var o = e.get("grpc-message") || [];

              if (this.props.debug && i.debug("onHeaders.gRPCMessage", o), this.rawOnHeaders(e), r !== s.Code.OK) {
                var a = this.decodeGRPCStatus(o[0]);
                this.rawOnError(r, a, e);
              }
            }
          }, e.prototype.onTransportChunk = function (e) {
            var t = this;
            if (this.closed) this.props.debug && i.debug("grpc.onChunk received after request was closed - ignoring");else {
              var n = [];

              try {
                n = this.parser.parse(e);
              } catch (e) {
                return this.props.debug && i.debug("onChunk.parsing error", e, e.message), void this.rawOnError(s.Code.Internal, "parsing error: " + e.message);
              }

              n.forEach(function (e) {
                if (e.chunkType === o.ChunkType.MESSAGE) {
                  var n = t.methodDefinition.responseType.deserializeBinary(e.data);
                  t.rawOnMessage(n);
                } else e.chunkType === o.ChunkType.TRAILERS && (t.responseHeaders ? (t.responseTrailers = new r.Metadata(e.trailers), t.props.debug && i.debug("onChunk.trailers", t.responseTrailers)) : (t.responseHeaders = new r.Metadata(e.trailers), t.rawOnHeaders(t.responseHeaders)));
              });
            }
          }, e.prototype.onTransportEnd = function () {
            if (this.props.debug && i.debug("grpc.onEnd"), this.closed) this.props.debug && i.debug("grpc.onEnd received after request was closed - ignoring");else if (void 0 !== this.responseTrailers) {
              var e = p(this.responseTrailers);

              if (null !== e) {
                var t = this.responseTrailers.get("grpc-message"),
                    n = this.decodeGRPCStatus(t[0]);
                this.rawOnEnd(e, n, this.responseTrailers);
              } else this.rawOnError(s.Code.Internal, "Response closed without grpc-status (Trailers provided)");
            } else {
              if (void 0 === this.responseHeaders) return void this.rawOnError(s.Code.Unknown, "Response closed without headers");
              var r = p(this.responseHeaders),
                  o = this.responseHeaders.get("grpc-message");
              if (this.props.debug && i.debug("grpc.headers only response ", r, o), null === r) return void this.rawOnEnd(s.Code.Unknown, "Response closed without grpc-status (Headers only)", this.responseHeaders);
              var a = this.decodeGRPCStatus(o[0]);
              this.rawOnEnd(r, a, this.responseHeaders);
            }
          }, e.prototype.decodeGRPCStatus = function (e) {
            if (!e) return "";

            try {
              return decodeURIComponent(e);
            } catch (t) {
              return e;
            }
          }, e.prototype.rawOnEnd = function (e, t, n) {
            var r = this;
            this.props.debug && i.debug("rawOnEnd", e, t, n), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (o) {
              a["default"](function () {
                r.closed || o(e, t, n);
              });
            }));
          }, e.prototype.rawOnHeaders = function (e) {
            this.props.debug && i.debug("rawOnHeaders", e), this.completed || this.onHeadersCallbacks.forEach(function (t) {
              a["default"](function () {
                t(e);
              });
            });
          }, e.prototype.rawOnError = function (e, t, n) {
            var o = this;
            void 0 === n && (n = new r.Metadata()), this.props.debug && i.debug("rawOnError", e, t), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (r) {
              a["default"](function () {
                o.closed || r(e, t, n);
              });
            }));
          }, e.prototype.rawOnMessage = function (e) {
            var t = this;
            this.props.debug && i.debug("rawOnMessage", e.toObject()), this.completed || this.closed || this.onMessageCallbacks.forEach(function (n) {
              a["default"](function () {
                t.closed || n(e);
              });
            });
          }, e.prototype.onHeaders = function (e) {
            this.onHeadersCallbacks.push(e);
          }, e.prototype.onMessage = function (e) {
            this.onMessageCallbacks.push(e);
          }, e.prototype.onEnd = function (e) {
            this.onEndCallbacks.push(e);
          }, e.prototype.start = function (e) {
            if (this.started) throw new Error("Client already started - cannot .start()");
            this.started = !0;
            var t = new r.Metadata(e || {});
            t.set("content-type", "application/grpc-web+proto"), t.set("x-grpc-web", "1"), this.transport.start(t);
          }, e.prototype.send = function (e) {
            if (!this.started) throw new Error("Client not started - .start() must be called before .send()");
            if (this.closed) throw new Error("Client already closed - cannot .send()");
            if (this.finishedSending) throw new Error("Client already finished sending - cannot .send()");
            if (!this.methodDefinition.requestStream && this.sentFirstMessage) throw new Error("Message already sent for non-client-streaming method - cannot .send()");
            this.sentFirstMessage = !0;
            var t = d.frameRequest(e);
            this.transport.sendMessage(t);
          }, e.prototype.finishSend = function () {
            if (!this.started) throw new Error("Client not started - .finishSend() must be called before .close()");
            if (this.closed) throw new Error("Client already closed - cannot .send()");
            if (this.finishedSending) throw new Error("Client already finished sending - cannot .finishSend()");
            this.finishedSending = !0, this.transport.finishSend();
          }, e.prototype.close = function () {
            if (!this.started) throw new Error("Client not started - .start() must be called before .close()");
            if (this.closed) throw new Error("Client already closed - cannot .close()");
            this.closed = !0, this.props.debug && i.debug("request.abort aborting request"), this.transport.cancel();
          }, e;
        }();

        function p(e) {
          var t = e.get("grpc-status") || [];
          if (t.length > 0) try {
            var n = t[0];
            return parseInt(n, 10);
          } catch (e) {
            return null;
          }
          return null;
        }
      }, function (e, t, n) {
        var r;
        r = function r() {
          return function (e) {
            var t = {};

            function n(r) {
              if (t[r]) return t[r].exports;
              var o = t[r] = {
                i: r,
                l: !1,
                exports: {}
              };
              return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
            }

            return n.m = e, n.c = t, n.i = function (e) {
              return e;
            }, n.d = function (e, t, r) {
              n.o(e, t) || Object.defineProperty(e, t, {
                configurable: !1,
                enumerable: !0,
                get: r
              });
            }, n.n = function (e) {
              var t = e && e.__esModule ? function () {
                return e["default"];
              } : function () {
                return e;
              };
              return n.d(t, "a", t), t;
            }, n.o = function (e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }, n.p = "", n(n.s = 1);
          }([function (e, t, n) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(3);

            var o = function () {
              function e(e, t) {
                void 0 === e && (e = {}), void 0 === t && (t = {
                  splitValues: !1
                });
                var n,
                    o = this;
                if (this.headersMap = {}, e) if ("undefined" != typeof Headers && e instanceof Headers) r.getHeaderKeys(e).forEach(function (n) {
                  r.getHeaderValues(e, n).forEach(function (e) {
                    t.splitValues ? o.append(n, r.splitHeaderValue(e)) : o.append(n, e);
                  });
                });else if ("object" == _typeof(n = e) && "object" == _typeof(n.headersMap) && "function" == typeof n.forEach) e.forEach(function (e, t) {
                  o.append(e, t);
                });else if ("undefined" != typeof Map && e instanceof Map) {
                  e.forEach(function (e, t) {
                    o.append(t, e);
                  });
                } else "string" == typeof e ? this.appendFromString(e) : "object" == _typeof(e) && Object.getOwnPropertyNames(e).forEach(function (t) {
                  var n = e[t];
                  Array.isArray(n) ? n.forEach(function (e) {
                    o.append(t, e);
                  }) : o.append(t, n);
                });
              }

              return e.prototype.appendFromString = function (e) {
                for (var t = e.split("\r\n"), n = 0; n < t.length; n++) {
                  var r = t[n],
                      o = r.indexOf(":");

                  if (o > 0) {
                    var s = r.substring(0, o).trim(),
                        i = r.substring(o + 1).trim();
                    this.append(s, i);
                  }
                }
              }, e.prototype["delete"] = function (e, t) {
                var n = r.normalizeName(e);
                if (void 0 === t) delete this.headersMap[n];else {
                  var o = this.headersMap[n];

                  if (o) {
                    var s = o.indexOf(t);
                    s >= 0 && o.splice(s, 1), 0 === o.length && delete this.headersMap[n];
                  }
                }
              }, e.prototype.append = function (e, t) {
                var n = this,
                    o = r.normalizeName(e);
                Array.isArray(this.headersMap[o]) || (this.headersMap[o] = []), Array.isArray(t) ? t.forEach(function (e) {
                  n.headersMap[o].push(r.normalizeValue(e));
                }) : this.headersMap[o].push(r.normalizeValue(t));
              }, e.prototype.set = function (e, t) {
                var n = r.normalizeName(e);

                if (Array.isArray(t)) {
                  var o = [];
                  t.forEach(function (e) {
                    o.push(r.normalizeValue(e));
                  }), this.headersMap[n] = o;
                } else this.headersMap[n] = [r.normalizeValue(t)];
              }, e.prototype.has = function (e, t) {
                var n = this.headersMap[r.normalizeName(e)];
                if (!Array.isArray(n)) return !1;

                if (void 0 !== t) {
                  var o = r.normalizeValue(t);
                  return n.indexOf(o) >= 0;
                }

                return !0;
              }, e.prototype.get = function (e) {
                var t = this.headersMap[r.normalizeName(e)];
                return void 0 !== t ? t.concat() : [];
              }, e.prototype.forEach = function (e) {
                var t = this;
                Object.getOwnPropertyNames(this.headersMap).forEach(function (n) {
                  e(n, t.headersMap[n]);
                }, this);
              }, e.prototype.toHeaders = function () {
                if ("undefined" != typeof Headers) {
                  var e = new Headers();
                  return this.forEach(function (t, n) {
                    n.forEach(function (n) {
                      e.append(t, n);
                    });
                  }), e;
                }

                throw new Error("Headers class is not defined");
              }, e;
            }();

            t.BrowserHeaders = o;
          }, function (e, t, n) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(0);
            t.BrowserHeaders = r.BrowserHeaders;
          }, function (e, t, n) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.iterateHeaders = function (e, t) {
              for (var n = e[Symbol.iterator](), r = n.next(); !r.done;) {
                t(r.value[0]), r = n.next();
              }
            }, t.iterateHeadersKeys = function (e, t) {
              for (var n = e.keys(), r = n.next(); !r.done;) {
                t(r.value), r = n.next();
              }
            };
          }, function (e, t, n) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(2);

            function o(e) {
              return e;
            }

            t.normalizeName = function (e) {
              if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
              return e.toLowerCase();
            }, t.normalizeValue = function (e) {
              return "string" != typeof e && (e = String(e)), e;
            }, t.getHeaderValues = function (e, t) {
              var n = o(e);
              if (n instanceof Headers && n.getAll) return n.getAll(t);
              var r = n.get(t);
              return r && "string" == typeof r ? [r] : r;
            }, t.getHeaderKeys = function (e) {
              var t = o(e),
                  n = {},
                  s = [];
              return t.keys ? r.iterateHeadersKeys(t, function (e) {
                n[e] || (n[e] = !0, s.push(e));
              }) : t.forEach ? t.forEach(function (e, t) {
                n[t] || (n[t] = !0, s.push(t));
              }) : r.iterateHeaders(t, function (e) {
                var t = e[0];
                n[t] || (n[t] = !0, s.push(t));
              }), s;
            }, t.splitHeaderValue = function (e) {
              var t = [];
              return e.split(", ").forEach(function (e) {
                e.split(",").forEach(function (e) {
                  t.push(e);
                });
              }), t;
            };
          }]);
        }, e.exports = r();
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r = n(6),
            o = function o(e) {
          return r.CrossBrowserHttpTransport({
            withCredentials: !1
          })(e);
        };

        t.setDefaultTransportFactory = function (e) {
          o = e;
        }, t.makeDefaultTransport = function (e) {
          return o(e);
        };
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(7),
            o = n(8);

        t.CrossBrowserHttpTransport = function (e) {
          if (r.detectFetchSupport()) {
            var t = {
              credentials: e.withCredentials ? "include" : "same-origin"
            };
            return r.FetchReadableStreamTransport(t);
          }

          return o.XhrTransport({
            withCredentials: e.withCredentials
          });
        };
      }, function (e, t, n) {

        var r = this && this.__assign || function () {
          return (r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }).apply(this, arguments);
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(0),
            s = n(1),
            i = n(2);

        t.FetchReadableStreamTransport = function (e) {
          return function (t) {
            return function (e, t) {
              return e.debug && s.debug("fetchRequest", e), new a(e, t);
            }(t, e);
          };
        };

        var a = function () {
          function e(e, t) {
            this.cancelled = !1, this.controller = self.AbortController && new AbortController(), this.options = e, this.init = t;
          }

          return e.prototype.pump = function (e, t) {
            var n = this;
            if (this.reader = e, this.cancelled) return this.options.debug && s.debug("Fetch.pump.cancel at first pump"), void this.reader.cancel();
            this.reader.read().then(function (e) {
              if (e.done) return i["default"](function () {
                n.options.onEnd();
              }), t;
              i["default"](function () {
                n.options.onChunk(e.value);
              }), n.pump(n.reader, t);
            })["catch"](function (e) {
              n.cancelled ? n.options.debug && s.debug("Fetch.catch - request cancelled") : (n.cancelled = !0, n.options.debug && s.debug("Fetch.catch", e.message), i["default"](function () {
                n.options.onEnd(e);
              }));
            });
          }, e.prototype.send = function (e) {
            var t = this;
            fetch(this.options.url, r({}, this.init, {
              headers: this.metadata.toHeaders(),
              method: "POST",
              body: e,
              signal: this.controller && this.controller.signal
            })).then(function (e) {
              if (t.options.debug && s.debug("Fetch.response", e), i["default"](function () {
                t.options.onHeaders(new o.Metadata(e.headers), e.status);
              }), !e.body) return e;
              t.pump(e.body.getReader(), e);
            })["catch"](function (e) {
              t.cancelled ? t.options.debug && s.debug("Fetch.catch - request cancelled") : (t.cancelled = !0, t.options.debug && s.debug("Fetch.catch", e.message), i["default"](function () {
                t.options.onEnd(e);
              }));
            });
          }, e.prototype.sendMessage = function (e) {
            this.send(e);
          }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
            this.metadata = e;
          }, e.prototype.cancel = function () {
            this.cancelled ? this.options.debug && s.debug("Fetch.abort.cancel already cancelled") : (this.cancelled = !0, this.reader ? (this.options.debug && s.debug("Fetch.abort.cancel"), this.reader.cancel()) : this.options.debug && s.debug("Fetch.abort.cancel before reader"), this.controller && this.controller.abort());
          }, e;
        }();

        t.detectFetchSupport = function () {
          return "undefined" != typeof Response && Response.prototype.hasOwnProperty("body") && "function" == typeof Headers;
        };
      }, function (e, t, n) {

        var _r,
            o = this && this.__extends || (_r = function r(e, t) {
          return (_r = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) {
              t.hasOwnProperty(n) && (e[n] = t[n]);
            }
          })(e, t);
        }, function (e, t) {
          function n() {
            this.constructor = e;
          }

          _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        });

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var s = n(0),
            i = n(1),
            a = n(2),
            u = n(12);

        t.XhrTransport = function (e) {
          return function (t) {
            if (u.detectMozXHRSupport()) return new c(t, e);
            if (u.detectXHROverrideMimeTypeSupport()) return new d(t, e);
            throw new Error("This environment's XHR implementation cannot support binary transfer.");
          };
        };

        var d = function () {
          function e(e, t) {
            this.options = e, this.init = t;
          }

          return e.prototype.onProgressEvent = function () {
            var e = this;
            this.options.debug && i.debug("XHR.onProgressEvent.length: ", this.xhr.response.length);
            var t = this.xhr.response.substr(this.index);
            this.index = this.xhr.response.length;
            var n = f(t);
            a["default"](function () {
              e.options.onChunk(n);
            });
          }, e.prototype.onLoadEvent = function () {
            var e = this;
            this.options.debug && i.debug("XHR.onLoadEvent"), a["default"](function () {
              e.options.onEnd();
            });
          }, e.prototype.onStateChange = function () {
            var e = this;
            this.options.debug && i.debug("XHR.onStateChange", this.xhr.readyState), this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && a["default"](function () {
              e.options.onHeaders(new s.Metadata(e.xhr.getAllResponseHeaders()), e.xhr.status);
            });
          }, e.prototype.sendMessage = function (e) {
            this.xhr.send(e);
          }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
            var t = this;
            this.metadata = e;
            var n = new XMLHttpRequest();
            this.xhr = n, n.open("POST", this.options.url), this.configureXhr(), this.metadata.forEach(function (e, t) {
              n.setRequestHeader(e, t.join(", "));
            }), n.withCredentials = Boolean(this.init.withCredentials), n.addEventListener("readystatechange", this.onStateChange.bind(this)), n.addEventListener("progress", this.onProgressEvent.bind(this)), n.addEventListener("loadend", this.onLoadEvent.bind(this)), n.addEventListener("error", function (e) {
              t.options.debug && i.debug("XHR.error", e), a["default"](function () {
                t.options.onEnd(e.error);
              });
            });
          }, e.prototype.configureXhr = function () {
            this.xhr.responseType = "text", this.xhr.overrideMimeType("text/plain; charset=x-user-defined");
          }, e.prototype.cancel = function () {
            this.options.debug && i.debug("XHR.abort"), this.xhr.abort();
          }, e;
        }();

        t.XHR = d;

        var c = function (e) {
          function t() {
            return null !== e && e.apply(this, arguments) || this;
          }

          return o(t, e), t.prototype.configureXhr = function () {
            this.options.debug && i.debug("MozXHR.configureXhr: setting responseType to 'moz-chunked-arraybuffer'"), this.xhr.responseType = "moz-chunked-arraybuffer";
          }, t.prototype.onProgressEvent = function () {
            var e = this,
                t = this.xhr.response;
            this.options.debug && i.debug("MozXHR.onProgressEvent: ", new Uint8Array(t)), a["default"](function () {
              e.options.onChunk(new Uint8Array(t));
            });
          }, t;
        }(d);

        function p(e, t) {
          var n = e.charCodeAt(t);

          if (n >= 55296 && n <= 56319) {
            var r = e.charCodeAt(t + 1);
            r >= 56320 && r <= 57343 && (n = 65536 + (n - 55296 << 10) + (r - 56320));
          }

          return n;
        }

        function f(e) {
          for (var t = new Uint8Array(e.length), n = 0, r = 0; r < e.length; r++) {
            var o = String.prototype.codePointAt ? e.codePointAt(r) : p(e, r);
            t[n++] = 255 & o;
          }

          return t;
        }

        t.MozChunkedArrayBufferXHR = c, t.stringToArrayBuffer = f;
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r,
            o = n(0),
            s = function s(e) {
          return 9 === e || 10 === e || 13 === e;
        };

        function i(e) {
          return s(e) || e >= 32 && e <= 126;
        }

        function a(e) {
          for (var t = 0; t !== e.length; ++t) {
            if (!i(e[t])) throw new Error("Metadata is not valid (printable) ASCII");
          }

          return String.fromCharCode.apply(String, Array.prototype.slice.call(e));
        }

        function u(e) {
          return 128 == (128 & e.getUint8(0));
        }

        function d(e) {
          return e.getUint32(1, !1);
        }

        function c(e, t, n) {
          return e.byteLength - t >= n;
        }

        function p(e, t, n) {
          if (e.slice) return e.slice(t, n);
          var r = e.length;
          void 0 !== n && (r = n);

          for (var o = new Uint8Array(r - t), s = 0, i = t; i < r; i++) {
            o[s++] = e[i];
          }

          return o;
        }

        t.decodeASCII = a, t.encodeASCII = function (e) {
          for (var t = new Uint8Array(e.length), n = 0; n !== e.length; ++n) {
            var r = e.charCodeAt(n);
            if (!i(r)) throw new Error("Metadata contains invalid ASCII");
            t[n] = r;
          }

          return t;
        }, function (e) {
          e[e.MESSAGE = 1] = "MESSAGE", e[e.TRAILERS = 2] = "TRAILERS";
        }(r = t.ChunkType || (t.ChunkType = {}));

        var f = function () {
          function e() {
            this.buffer = null, this.position = 0;
          }

          return e.prototype.parse = function (e, t) {
            if (0 === e.length && t) return [];
            var n,
                s = [];
            if (null == this.buffer) this.buffer = e, this.position = 0;else if (this.position === this.buffer.byteLength) this.buffer = e, this.position = 0;else {
              var i = this.buffer.byteLength - this.position,
                  f = new Uint8Array(i + e.byteLength),
                  h = p(this.buffer, this.position);
              f.set(h, 0);
              var l = new Uint8Array(e);
              f.set(l, i), this.buffer = f, this.position = 0;
            }

            for (;;) {
              if (!c(this.buffer, this.position, 5)) return s;
              var g = p(this.buffer, this.position, this.position + 5),
                  b = new DataView(g.buffer, g.byteOffset, g.byteLength),
                  y = d(b);
              if (!c(this.buffer, this.position, 5 + y)) return s;
              var v = p(this.buffer, this.position + 5, this.position + 5 + y);
              if (this.position += 5 + y, u(b)) return s.push({
                chunkType: r.TRAILERS,
                trailers: (n = v, new o.Metadata(a(n)))
              }), s;
              s.push({
                chunkType: r.MESSAGE,
                data: v
              });
            }
          }, e;
        }();

        t.ChunkParser = f;
      }, function (e, t, n) {

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), function (e) {
          e[e.OK = 0] = "OK", e[e.Canceled = 1] = "Canceled", e[e.Unknown = 2] = "Unknown", e[e.InvalidArgument = 3] = "InvalidArgument", e[e.DeadlineExceeded = 4] = "DeadlineExceeded", e[e.NotFound = 5] = "NotFound", e[e.AlreadyExists = 6] = "AlreadyExists", e[e.PermissionDenied = 7] = "PermissionDenied", e[e.ResourceExhausted = 8] = "ResourceExhausted", e[e.FailedPrecondition = 9] = "FailedPrecondition", e[e.Aborted = 10] = "Aborted", e[e.OutOfRange = 11] = "OutOfRange", e[e.Unimplemented = 12] = "Unimplemented", e[e.Internal = 13] = "Internal", e[e.Unavailable = 14] = "Unavailable", e[e.DataLoss = 15] = "DataLoss", e[e.Unauthenticated = 16] = "Unauthenticated";
        }(r = t.Code || (t.Code = {})), t.httpStatusToCode = function (e) {
          switch (e) {
            case 0:
              return r.Internal;

            case 200:
              return r.OK;

            case 400:
              return r.InvalidArgument;

            case 401:
              return r.Unauthenticated;

            case 403:
              return r.PermissionDenied;

            case 404:
              return r.NotFound;

            case 409:
              return r.Aborted;

            case 412:
              return r.FailedPrecondition;

            case 429:
              return r.ResourceExhausted;

            case 499:
              return r.Canceled;

            case 500:
              return r.Unknown;

            case 501:
              return r.Unimplemented;

            case 503:
              return r.Unavailable;

            case 504:
              return r.DeadlineExceeded;

            default:
              return r.Unknown;
          }
        };
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(4),
            o = n(5),
            s = n(7),
            i = n(13),
            a = n(8),
            u = n(6),
            d = n(10),
            c = n(14),
            p = n(16),
            f = n(3);
        !function (e) {
          e.setDefaultTransport = o.setDefaultTransportFactory, e.CrossBrowserHttpTransport = u.CrossBrowserHttpTransport, e.FetchReadableStreamTransport = s.FetchReadableStreamTransport, e.XhrTransport = a.XhrTransport, e.WebsocketTransport = i.WebsocketTransport, e.Code = d.Code, e.Metadata = r.BrowserHeaders, e.client = function (e, t) {
            return f.client(e, t);
          }, e.invoke = c.invoke, e.unary = p.unary;
        }(t.grpc || (t.grpc = {}));
      }, function (e, t, n) {

        var r;

        function o() {
          if (void 0 !== r) return r;

          if (XMLHttpRequest) {
            r = new XMLHttpRequest();

            try {
              r.open("GET", "https://localhost");
            } catch (e) {}
          }

          return r;
        }

        function s(e) {
          var t = o();
          if (!t) return !1;

          try {
            return t.responseType = e, t.responseType === e;
          } catch (e) {}

          return !1;
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.xhrSupportsResponseType = s, t.detectMozXHRSupport = function () {
          return "undefined" != typeof XMLHttpRequest && s("moz-chunked-arraybuffer");
        }, t.detectXHROverrideMimeTypeSupport = function () {
          return "undefined" != typeof XMLHttpRequest && XMLHttpRequest.prototype.hasOwnProperty("overrideMimeType");
        };
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r,
            o = n(1),
            s = n(2),
            i = n(9);
        !function (e) {
          e[e.FINISH_SEND = 1] = "FINISH_SEND";
        }(r || (r = {}));
        var a = new Uint8Array([1]);

        t.WebsocketTransport = function () {
          return function (e) {
            return function (e) {
              e.debug && o.debug("websocketRequest", e);

              var t,
                  n = function (e) {
                if ("https://" === e.substr(0, 8)) return "wss://" + e.substr(8);
                if ("http://" === e.substr(0, 7)) return "ws://" + e.substr(7);
                throw new Error("Websocket transport constructed with non-https:// or http:// host.");
              }(e.url),
                  u = [];

              function d(e) {
                if (e === r.FINISH_SEND) t.send(a);else {
                  var n = e,
                      o = new Int8Array(n.byteLength + 1);
                  o.set(new Uint8Array([0])), o.set(n, 1), t.send(o);
                }
              }

              return {
                sendMessage: function sendMessage(e) {
                  t && t.readyState !== t.CONNECTING ? d(e) : u.push(e);
                },
                finishSend: function finishSend() {
                  t && t.readyState !== t.CONNECTING ? d(r.FINISH_SEND) : u.push(r.FINISH_SEND);
                },
                start: function start(r) {
                  (t = new WebSocket(n, ["grpc-websockets"])).binaryType = "arraybuffer", t.onopen = function () {
                    var n;
                    e.debug && o.debug("websocketRequest.onopen"), t.send((n = "", r.forEach(function (e, t) {
                      n += e + ": " + t.join(", ") + "\r\n";
                    }), i.encodeASCII(n))), u.forEach(function (e) {
                      d(e);
                    });
                  }, t.onclose = function (t) {
                    e.debug && o.debug("websocketRequest.onclose", t), s["default"](function () {
                      e.onEnd();
                    });
                  }, t.onerror = function (t) {
                    e.debug && o.debug("websocketRequest.onerror", t);
                  }, t.onmessage = function (t) {
                    s["default"](function () {
                      e.onChunk(new Uint8Array(t.data));
                    });
                  };
                },
                cancel: function cancel() {
                  e.debug && o.debug("websocket.abort"), s["default"](function () {
                    t.close();
                  });
                }
              };
            }(e);
          };
        };
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(3);

        t.invoke = function (e, t) {
          if (e.requestStream) throw new Error(".invoke cannot be used with client-streaming methods. Use .client instead.");
          var n = r.client(e, {
            host: t.host,
            transport: t.transport,
            debug: t.debug
          });
          return t.onHeaders && n.onHeaders(t.onHeaders), t.onMessage && n.onMessage(t.onMessage), t.onEnd && n.onEnd(t.onEnd), n.start(t.metadata), n.send(t.request), n.finishSend(), {
            close: function close() {
              n.close();
            }
          };
        };
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.frameRequest = function (e) {
          var t = e.serializeBinary(),
              n = new ArrayBuffer(t.byteLength + 5);
          return new DataView(n, 1, 4).setUint32(0, t.length, !1), new Uint8Array(n, 5).set(t), new Uint8Array(n);
        };
      }, function (e, t, n) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(0),
            o = n(3);

        t.unary = function (e, t) {
          if (e.responseStream) throw new Error(".unary cannot be used with server-streaming methods. Use .invoke or .client instead.");
          if (e.requestStream) throw new Error(".unary cannot be used with client-streaming methods. Use .client instead.");
          var n = null,
              s = null,
              i = o.client(e, {
            host: t.host,
            transport: t.transport,
            debug: t.debug
          });
          return i.onHeaders(function (e) {
            n = e;
          }), i.onMessage(function (e) {
            s = e;
          }), i.onEnd(function (e, o, i) {
            t.onEnd({
              status: e,
              statusMessage: o,
              headers: n || new r.Metadata(),
              message: s,
              trailers: i
            });
          }), i.start(t.metadata), i.send(t.request), i.finishSend(), {
            close: function close() {
              i.close();
            }
          };
        };
      }]);
    });
  });
  unwrapExports(grpcWebClient_umd);
  var grpcWebClient_umd_1 = grpcWebClient_umd.grpc;

  // file: rpc.proto

  var grpc = grpcWebClient_umd.grpc;

  var AergoRPCService = function () {
    function AergoRPCService() {}

    AergoRPCService.serviceName = "types.AergoRPCService";
    return AergoRPCService;
  }();

  AergoRPCService.NodeState = {
    methodName: "NodeState",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.NodeReq,
    responseType: rpc_pb.SingleBytes
  };
  AergoRPCService.Metric = {
    methodName: "Metric",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: metric_pb.MetricsRequest,
    responseType: metric_pb.Metrics
  };
  AergoRPCService.Blockchain = {
    methodName: "Blockchain",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Empty,
    responseType: rpc_pb.BlockchainStatus
  };
  AergoRPCService.GetChainInfo = {
    methodName: "GetChainInfo",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Empty,
    responseType: rpc_pb.ChainInfo
  };
  AergoRPCService.ChainStat = {
    methodName: "ChainStat",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Empty,
    responseType: rpc_pb.ChainStats
  };
  AergoRPCService.ListBlockHeaders = {
    methodName: "ListBlockHeaders",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.ListParams,
    responseType: rpc_pb.BlockHeaderList
  };
  AergoRPCService.ListBlockMetadata = {
    methodName: "ListBlockMetadata",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.ListParams,
    responseType: rpc_pb.BlockMetadataList
  };
  AergoRPCService.ListBlockStream = {
    methodName: "ListBlockStream",
    service: AergoRPCService,
    requestStream: false,
    responseStream: true,
    requestType: rpc_pb.Empty,
    responseType: blockchain_pb.Block
  };
  AergoRPCService.ListBlockMetadataStream = {
    methodName: "ListBlockMetadataStream",
    service: AergoRPCService,
    requestStream: false,
    responseStream: true,
    requestType: rpc_pb.Empty,
    responseType: rpc_pb.BlockMetadata
  };
  AergoRPCService.GetBlock = {
    methodName: "GetBlock",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.SingleBytes,
    responseType: blockchain_pb.Block
  };
  AergoRPCService.GetBlockMetadata = {
    methodName: "GetBlockMetadata",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.SingleBytes,
    responseType: rpc_pb.BlockMetadata
  };
  AergoRPCService.GetBlockBody = {
    methodName: "GetBlockBody",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.BlockBodyParams,
    responseType: rpc_pb.BlockBodyPaged
  };
  AergoRPCService.GetTX = {
    methodName: "GetTX",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.SingleBytes,
    responseType: blockchain_pb.Tx
  };
  AergoRPCService.GetBlockTX = {
    methodName: "GetBlockTX",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.SingleBytes,
    responseType: blockchain_pb.TxInBlock
  };
  AergoRPCService.GetReceipt = {
    methodName: "GetReceipt",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.SingleBytes,
    responseType: blockchain_pb.Receipt
  };
  AergoRPCService.GetABI = {
    methodName: "GetABI",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.SingleBytes,
    responseType: blockchain_pb.ABI
  };
  AergoRPCService.SendTX = {
    methodName: "SendTX",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: blockchain_pb.Tx,
    responseType: rpc_pb.CommitResult
  };
  AergoRPCService.SignTX = {
    methodName: "SignTX",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: blockchain_pb.Tx,
    responseType: blockchain_pb.Tx
  };
  AergoRPCService.VerifyTX = {
    methodName: "VerifyTX",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: blockchain_pb.Tx,
    responseType: rpc_pb.VerifyResult
  };
  AergoRPCService.CommitTX = {
    methodName: "CommitTX",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: blockchain_pb.TxList,
    responseType: rpc_pb.CommitResultList
  };
  AergoRPCService.GetState = {
    methodName: "GetState",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.SingleBytes,
    responseType: blockchain_pb.State
  };
  AergoRPCService.GetStateAndProof = {
    methodName: "GetStateAndProof",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.AccountAndRoot,
    responseType: blockchain_pb.AccountProof
  };
  AergoRPCService.CreateAccount = {
    methodName: "CreateAccount",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Personal,
    responseType: account_pb.Account
  };
  AergoRPCService.GetAccounts = {
    methodName: "GetAccounts",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Empty,
    responseType: account_pb.AccountList
  };
  AergoRPCService.LockAccount = {
    methodName: "LockAccount",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Personal,
    responseType: account_pb.Account
  };
  AergoRPCService.UnlockAccount = {
    methodName: "UnlockAccount",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Personal,
    responseType: account_pb.Account
  };
  AergoRPCService.ImportAccount = {
    methodName: "ImportAccount",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.ImportFormat,
    responseType: account_pb.Account
  };
  AergoRPCService.ExportAccount = {
    methodName: "ExportAccount",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Personal,
    responseType: rpc_pb.SingleBytes
  };
  AergoRPCService.QueryContract = {
    methodName: "QueryContract",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: blockchain_pb.Query,
    responseType: rpc_pb.SingleBytes
  };
  AergoRPCService.QueryContractState = {
    methodName: "QueryContractState",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: blockchain_pb.StateQuery,
    responseType: blockchain_pb.StateQueryProof
  };
  AergoRPCService.GetPeers = {
    methodName: "GetPeers",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.PeersParams,
    responseType: rpc_pb.PeerList
  };
  AergoRPCService.GetVotes = {
    methodName: "GetVotes",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.VoteParams,
    responseType: rpc_pb.VoteList
  };
  AergoRPCService.GetAccountVotes = {
    methodName: "GetAccountVotes",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.AccountAddress,
    responseType: rpc_pb.AccountVoteInfo
  };
  AergoRPCService.GetStaking = {
    methodName: "GetStaking",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.AccountAddress,
    responseType: rpc_pb.Staking
  };
  AergoRPCService.GetNameInfo = {
    methodName: "GetNameInfo",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Name,
    responseType: rpc_pb.NameInfo
  };
  AergoRPCService.ListEventStream = {
    methodName: "ListEventStream",
    service: AergoRPCService,
    requestStream: false,
    responseStream: true,
    requestType: blockchain_pb.FilterInfo,
    responseType: blockchain_pb.Event
  };
  AergoRPCService.ListEvents = {
    methodName: "ListEvents",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: blockchain_pb.FilterInfo,
    responseType: rpc_pb.EventList
  };
  AergoRPCService.GetServerInfo = {
    methodName: "GetServerInfo",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.KeyParams,
    responseType: rpc_pb.ServerInfo
  };
  AergoRPCService.GetConsensusInfo = {
    methodName: "GetConsensusInfo",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.Empty,
    responseType: rpc_pb.ConsensusInfo
  };
  AergoRPCService.ChangeMembership = {
    methodName: "ChangeMembership",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: raft_pb.MembershipChange,
    responseType: raft_pb.MembershipChangeReply
  };
  AergoRPCService.GetEnterpriseConfig = {
    methodName: "GetEnterpriseConfig",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.EnterpriseConfigKey,
    responseType: rpc_pb.EnterpriseConfig
  };
  AergoRPCService.GetConfChangeProgress = {
    methodName: "GetConfChangeProgress",
    service: AergoRPCService,
    requestStream: false,
    responseStream: false,
    requestType: rpc_pb.SingleBytes,
    responseType: raft_pb.ConfChangeProgress
  };

  function AergoRPCServiceClient(serviceHost, options) {
    this.serviceHost = serviceHost;
    this.options = options || {};
  }

  AergoRPCServiceClient.prototype.nodeState = function nodeState(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.NodeState, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.metric = function metric(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.Metric, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.blockchain = function blockchain(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.Blockchain, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getChainInfo = function getChainInfo(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetChainInfo, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.chainStat = function chainStat(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.ChainStat, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.listBlockHeaders = function listBlockHeaders(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.ListBlockHeaders, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.listBlockMetadata = function listBlockMetadata(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.ListBlockMetadata, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.listBlockStream = function listBlockStream(requestMessage, metadata) {
    var listeners = {
      data: [],
      end: [],
      status: []
    };
    var client = grpc.invoke(AergoRPCService.ListBlockStream, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onMessage: function onMessage(responseMessage) {
        listeners.data.forEach(function (handler) {
          handler(responseMessage);
        });
      },
      onEnd: function onEnd(status, statusMessage, trailers) {
        listeners.status.forEach(function (handler) {
          handler({
            code: status,
            details: statusMessage,
            metadata: trailers
          });
        });
        listeners.end.forEach(function (handler) {
          handler({
            code: status,
            details: statusMessage,
            metadata: trailers
          });
        });
        listeners = null;
      }
    });
    return {
      on: function on(type, handler) {
        listeners[type].push(handler);
        return this;
      },
      cancel: function cancel() {
        listeners = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.listBlockMetadataStream = function listBlockMetadataStream(requestMessage, metadata) {
    var listeners = {
      data: [],
      end: [],
      status: []
    };
    var client = grpc.invoke(AergoRPCService.ListBlockMetadataStream, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onMessage: function onMessage(responseMessage) {
        listeners.data.forEach(function (handler) {
          handler(responseMessage);
        });
      },
      onEnd: function onEnd(status, statusMessage, trailers) {
        listeners.status.forEach(function (handler) {
          handler({
            code: status,
            details: statusMessage,
            metadata: trailers
          });
        });
        listeners.end.forEach(function (handler) {
          handler({
            code: status,
            details: statusMessage,
            metadata: trailers
          });
        });
        listeners = null;
      }
    });
    return {
      on: function on(type, handler) {
        listeners[type].push(handler);
        return this;
      },
      cancel: function cancel() {
        listeners = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getBlock = function getBlock(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetBlock, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getBlockMetadata = function getBlockMetadata(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetBlockMetadata, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getBlockBody = function getBlockBody(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetBlockBody, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getTX = function getTX(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetTX, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getBlockTX = function getBlockTX(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetBlockTX, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getReceipt = function getReceipt(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetReceipt, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getABI = function getABI(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetABI, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.sendTX = function sendTX(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.SendTX, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.signTX = function signTX(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.SignTX, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.verifyTX = function verifyTX(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.VerifyTX, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.commitTX = function commitTX(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.CommitTX, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getState = function getState(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetState, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getStateAndProof = function getStateAndProof(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetStateAndProof, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.createAccount = function createAccount(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.CreateAccount, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getAccounts = function getAccounts(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetAccounts, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.lockAccount = function lockAccount(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.LockAccount, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.unlockAccount = function unlockAccount(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.UnlockAccount, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.importAccount = function importAccount(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.ImportAccount, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.exportAccount = function exportAccount(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.ExportAccount, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.queryContract = function queryContract(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.QueryContract, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.queryContractState = function queryContractState(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.QueryContractState, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getPeers = function getPeers(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetPeers, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getVotes = function getVotes(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetVotes, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getAccountVotes = function getAccountVotes(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetAccountVotes, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getStaking = function getStaking(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetStaking, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getNameInfo = function getNameInfo(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetNameInfo, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.listEventStream = function listEventStream(requestMessage, metadata) {
    var listeners = {
      data: [],
      end: [],
      status: []
    };
    var client = grpc.invoke(AergoRPCService.ListEventStream, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onMessage: function onMessage(responseMessage) {
        listeners.data.forEach(function (handler) {
          handler(responseMessage);
        });
      },
      onEnd: function onEnd(status, statusMessage, trailers) {
        listeners.status.forEach(function (handler) {
          handler({
            code: status,
            details: statusMessage,
            metadata: trailers
          });
        });
        listeners.end.forEach(function (handler) {
          handler({
            code: status,
            details: statusMessage,
            metadata: trailers
          });
        });
        listeners = null;
      }
    });
    return {
      on: function on(type, handler) {
        listeners[type].push(handler);
        return this;
      },
      cancel: function cancel() {
        listeners = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.listEvents = function listEvents(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.ListEvents, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getServerInfo = function getServerInfo(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetServerInfo, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getConsensusInfo = function getConsensusInfo(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetConsensusInfo, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.changeMembership = function changeMembership(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.ChangeMembership, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getEnterpriseConfig = function getEnterpriseConfig(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetEnterpriseConfig, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  AergoRPCServiceClient.prototype.getConfChangeProgress = function getConfChangeProgress(requestMessage, metadata, callback) {
    if (arguments.length === 2) {
      callback = arguments[1];
    }

    var client = grpc.unary(AergoRPCService.GetConfChangeProgress, {
      request: requestMessage,
      host: this.serviceHost,
      metadata: metadata,
      transport: this.options.transport,
      debug: this.options.debug,
      onEnd: function onEnd(response) {
        if (callback) {
          if (response.status !== grpc.Code.OK) {
            var err = new Error(response.statusMessage);
            err.code = response.status;
            err.metadata = response.trailers;
            callback(err, null);
          } else {
            callback(null, response.message);
          }
        }
      }
    });
    return {
      cancel: function cancel() {
        callback = null;
        client.close();
      }
    };
  };

  var AergoRPCServiceClient_1 = AergoRPCServiceClient;

  /**
   * Provider for GRPC-WEB connections over HTTP.
   * This is compatible with Web browsers.
   * Note that the transport is considerably slower than over standard GRPC.
   */
  var GrpcWebProvider = /*#__PURE__*/function () {
    /**
     * .. code-block:: javascript
     * 
     *     import { GrpcWebProvider } from '@herajs/client';
     *     const provider = new GrpcWebProvider({url: 'http://localhost:7845'});
     * 
     * @param {GrpcWebProviderConfig} config
     */
    function GrpcWebProvider() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, GrpcWebProvider);

      _defineProperty(this, "client", void 0);

      _defineProperty(this, "config", void 0);

      this.config = _objectSpread2({}, this.defaultConfig, {}, config);
      var options = {
        transport: grpcWebClient_umd_1.WebsocketTransport()
      };
      this.client = new AergoRPCServiceClient_1(this.config.url, options);
    }

    _createClass(GrpcWebProvider, [{
      key: "defaultConfig",
      get: function get() {
        return {
          url: 'http://localhost:7845'
        };
      }
    }]);

    return GrpcWebProvider;
  }();

  AergoClient.platform = 'web';
  AergoClient.defaultProviderClass = GrpcWebProvider;

  exports.Address = Address;
  exports.AergoClient = AergoClient;
  exports.Amount = Amount;
  exports.Contract = Contract;
  exports.GrpcWebProvider = GrpcWebProvider;
  exports.Tx = Tx;
  exports.constants = constants;
  exports.default = AergoClient;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
